let PJQ = PJQ ? PJQ : {};

PJQ.helpers = {
    getMobileOS: function () {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return "android";
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "ios";
        }

        return null;
    },
    setViewport: function (content) {
        let existingViewport = document.getElementById('viewport');
        if (existingViewport != null) {
            existingViewport.remove();
        }

        let nameViewports = document.getElementsByName("viewport");
        if (nameViewports && nameViewports.length > 0) {
            for (let i = 0; i < nameViewports.length; i++) {
                if (typeof nameViewports[i].remove === 'function') {
                    nameViewports[i].remove();
                }
            }
        }

        if (content != null) {
            let viewPortTag = document.createElement('meta');
            viewPortTag.id = "viewport";
            viewPortTag.name = "viewport";
            viewPortTag.content = content;
            document.getElementsByTagName('head')[0].appendChild(viewPortTag);
        }
    },
    domReadyHelper: function () {
        if (typeof $ === 'function') {
            //Prevent main ASP.NET outer form from submitting
            //This fixes issues with refreshing when pressing enter on input fields
            $("#Form").submit(function (e) {
                e.preventDefault();
            });

            let $skinHeader = $('.skin-header'),
                $content = PJQ.app.$el;
            if (_.size($skinHeader) > 0) {
                $content.css({
                    top: $skinHeader.height(),
                    bottom: 0,
                    left: 0,
                    position: 'fixed',
                    'overflow-y': 'auto'
                });

                let $skinFooter = $('.skin-footer');
                if (_.size($skinFooter) > 0) {
                    $content.css('bottom', $skinFooter.height())
                }
            }

            window.getParameterByName = function (name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                    results = regex.exec(location.search);
                return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            };

            window.processUpload = function (uid, sid, folder) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'files'
                        },
                        {
                            endpoint: 'processupload',
                            value: uid
                        }
                    ], [
                        {
                            parameter: 'folderId',
                            value: folder
                        }
                    ]),
                    isApi2: true
                }).post().done(_.bind(function (response) {
                    jQuery('#dlg-uplc').click();
                    if (typeof FileUploadCallback === "function")
                        FileUploadCallback();
                }, this));
            };

            // create and populate a hidden form.
            $.extend({
                form: function (url, data, method) {
                    if (method == null)
                        method = 'POST';
                    if (data == null)
                        data = {};

                    let form = $('<form>').attr({
                        method: method,
                        action: url
                    }).css({
                        display: 'none'
                    });

                    let addData = function (name, data) {
                        if ($.isArray(data)) {
                            for (let i = 0; i < data.length; i++) {
                                let value = data[i];
                                addData(name + '[]', value);
                            }
                        } else if (typeof data === 'object') {
                            for (let key in data) {
                                if (data.hasOwnProperty(key)) {
                                    addData(name + '[' + key + ']', data[key]);
                                }
                            }
                        } else if (data != null) {
                            form.append($('<input>').attr({
                                type: 'hidden',
                                name: String(name),
                                value: String(data)
                            }));
                        }
                    };

                    for (let key in data) {
                        if (data.hasOwnProperty(key)) {
                            addData(key, data[key]);
                        }
                    }
                    return form.appendTo('body');
                }
            });

            if (typeof $.ui === 'object') {

                if (typeof $.ui.dialog === 'function') {
                    $.widget("ui.dialog", $.extend({}, $.ui.dialog.prototype, {
                        _title: function (title) {
                            if (!this.options.title) {
                                title.html("&#160;");
                            } else {
                                title.html(this.options.title);
                            }
                        }
                    }));
                }

                if (typeof $.views === 'object') {
                    $.views.helpers({
                        formatPhone: function (val) {
                            if (val.length == 10)
                                return val.substring(0, 3) + '-' + val.substring(3, 6) + '-' + val.substring(6);
                            else
                                return val;
                        },

                        formatNewsfeedName: function (val) {
                            var temp = val.substring(val.indexOf('{') + 1);
                            return temp.substring(0, temp.indexOf('|'));
                        },

                        formatNewsfeed: function (val) {
                            if (val.indexOf('}') != -1) {
                                var temp = val.substring(val.lastIndexOf('}') + 1);
                                return temp;
                            } else
                                return val;
                        },

                        formatDate: function (jsonDate) {
                            var date = new Date(parseInt(jsonDate.substr(6)));
                            return dateFormat(date, 'dddd, mmmm d, yyyy @ h:MM:ss TT Z');
                        },

                        parseDate: function (myDate) {
                            if (!myDate || myDate.toLowerCase() === 'n/a')
                                return 'N/A';

                            var date = new Date(myDate);
                            return dateFormat(date, 'mm/dd/yyyy');
                        },

                        isTooOld: function (jsonDate) {
                            if (!jsonDate)
                                return true;
                            var createdOn = new Date(parseInt(jsonDate.substr(6)));
                            return ((((new Date() - createdOn) % 86400000) % 3600000) / 60000 > 5);
                        },

                        parseDateDT: function (myDate) {
                            if (!myDate || myDate.trim().length == 0) {
                                return '';
                            }
                            if (myDate.indexOf(' ') != -1)
                                myDate = myDate.substring(0, myDate.indexOf(' '));

                            var date = new Date(myDate);
                            return PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE);
                        },
                        parseTimeDT: function (myDate) {
                            if (!myDate)
                                return '';
                            if (myDate.indexOf('AM') == -1 && myDate.indexOf('PM') == -1)
                                return '';
                            return myDate.substring(myDate.indexOf(' ') + 1);
                        },
                        isLast: function () {
                            return this.index == this.parent.data.length - 1;
                        },
                        notLast: function () {
                            return this.index !== this.parent.data.length - 1;
                        }
                    });
                }
            }

            if (typeof $.blueimp === 'object') {
                $.blueimp.fileupload.prototype._initProgressListener = function (options) {
                    var that = this,
                        xhr = options.xhr ? options.xhr() : jQuery.ajaxSettings.xhr();
                    if (xhr.upload) {
                        jQuery(xhr.upload).bind('progress', function (e) {
                            var oe = e.originalEvent;
                            // Make sure the progress event properties get copied over:
                            e.lengthComputable = oe.lengthComputable;
                            e.loaded = oe.loaded;
                            e.total = oe.total;
                            that._onProgress(e, options);
                        });
                        options.xhr = function () {
                            return xhr;
                        };
                    }
                };
            }
        }
    }
};

PJQ.helpers.dateHelpers = {
    dateFormats: {
        URL_DATE: 'MM-dd-yyyy',
        DATE_TIME: "MM/dd/yyyy hh:mm TT",
        TIME: "hh:mm TT",
        DATE: "MM/dd/yyyy",
        DATE_MONTH_DAY: "MM/dd",
        DATE_YMD: "yyyy-MM-dd",
        MONTH_YEAR: 'MMMM yyyy',
        MONTH_DAY_SHORT: 'MMM dd',
        datePicker: {
            DATE_TIME: "MM/DD/YYYY hh:mm A",
            DATE: "MM/DD/YYYY",
            ALT_DATE: "MM-DD-YYYY"
        }
    },
    getTimezoneByOffset: function (offset) {
        for (let timezone in this.timezones) {
            if (this.timezones[timezone].offset === offset) {
                return timezone;
            }
        }
        return null;
    },
    getFormattedTimezoneOffset: function (offset) {
        let tzo = offset * 60,
            dif = tzo >= 0 ? '+' : '-',
            pad = function (num) {
                return (num < 10 ? '0' : '') + num;
            };
        return dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    },
    timezones: {
        ACST: {name: "AUS Central Standard Time", abbr: "ACST", offset: 9.5},
        ADT: {name: "Azerbaijan Standard Time", abbr: "ADT", offset: 5},
        AEST: {name: "AUS Eastern Standard Time", abbr: "AEST", offset: 10},
        AKDT: {name: "Alaskan Standard Time", abbr: "AKDT", offset: -8},
        AST: {name: "Afghanistan Standard Time", abbr: "AST", offset: 4.5},
        BST: {name: "Bangladesh Standard Time", abbr: "BST", offset: 6},
        CAST: {name: "Cen. Australia Standard Time", abbr: "CAST", offset: 9.5},
        CBST: {name: "Central Brazilian Standard Time", abbr: "CBST", offset: -4},
        CST: {name: "Central Standard Time", abbr: "CST", offset: -6},
        CDT: {name: "Central Daylight Time", abbr: "CDT", offset: -5},
        CEDT: {name: "Central European Standard Time", abbr: "CEDT", offset: 2},
        CPST: {name: "Central Pacific Standard Time", abbr: "CPST", offset: 11},
        CVST: {name: "Cape Verde Standard Time", abbr: "CVST", offset: -1},
        DST: {name: "Dateline Standard Time", abbr: "DST", offset: -12},
        EAST: {name: "E. Australia Standard Time", abbr: "EAST", offset: 10},
        EDT: {name: "Eastern Daylight Time", abbr: "EST", offset: -4},
        EST: {name: "Eastern Standard Time", abbr: "EST", offset: -5},
        EEDT: {name: "E. Europe Standard Time", abbr: "EEDT", offset: 3},
        ESAST: {name: "E. South America Standard Time", abbr: "ESAST", offset: -3},
        FDT: {name: "FLE Standard Time", abbr: "FDT", offset: 3},
        FST: {name: "Fiji Standard Time", abbr: "FST", offset: 12},
        GDT: {name: "GTB Standard Time", abbr: "GDT", offset: 3},
        GET: {name: "Georgian Standard Time", abbr: "GET", offset: 4},
        GMT: {name: "GMT Standard Time", abbr: "GMT", offset: 0},
        GST: {name: "Greenwich Standard Time", abbr: "GST", offset: 0},
        HST: {name: "Hawaiian Standard Time", abbr: "HST", offset: -10},
        IDT: {name: "Iran Standard Time", abbr: "IDT", offset: 4.5},
        IST: {name: "India Standard Time", abbr: "IST", offset: 5.5},
        JDT: {name: "Israel Standard Time", abbr: "JDT", offset: 3},
        JST: {name: "Japan Standard Time", abbr: "JST", offset: 9},
        KDT: {name: "Kamchatka Standard Time", abbr: "KDT", offset: 13},
        KST: {name: "Korea Standard Time", abbr: "KST", offset: 9},
        LST: {name: "Libya Standard Time", abbr: "LST", offset: 2},
        MEDT: {name: "Middle East Standard Time", abbr: "MEDT", offset: 3},
        MPST: {name: "Singapore Standard Time", abbr: "MPST", offset: 8},
        MSK: {name: "Moscow Standard Time", abbr: "MSK", offset: 3},
        MDT: {name: "Mountain Daylight Time", abbr: "MDT", offset: -6},
        MST: {name: "Mountain Standard Time", abbr: "MST", offset: -7},
        NAEST: {name: "North Asia East Standard Time", abbr: "NAEST", offset: 8},
        NAST: {name: "North Asia Standard Time", abbr: "NAST", offset: 8},
        NCAST: {name: "N. Central Asia Standard Time", abbr: "NCAST", offset: 7},
        NDT: {name: "Newfoundland Standard Time", abbr: "NDT", offset: -2.5},
        NST: {name: "Nepal Standard Time", abbr: "NST", offset: 5.75},
        NZST: {name: "New Zealand Standard Time", abbr: "NZST", offset: 12},
        PDT: {name: "Pacific Daylight Time", abbr: "PDT", offset: -7},
        PKT: {name: "Pakistan Standard Time", abbr: "PKT", offset: 5},
        PSST: {name: "Pacific SA Standard Time", abbr: "PSST", offset: -4},
        PST: {name: "Pacific Standard Time", abbr: "PST", offset: -8},
        PYT: {name: "Paraguay Standard Time", abbr: "PYT", offset: -4},
        RDT: {name: "Romance Standard Time", abbr: "RDT", offset: 2},
        SAMT: {name: "Samara Time", abbr: "SAMT", offset: 4},
        SAST: {name: "SE Asia Standard Time", abbr: "SAST", offset: 7},
        SDT: {name: "Syria Standard Time", abbr: "SDT", offset: 3},
        SEST: {name: "SA Eastern Standard Time", abbr: "SEST", offset: -3},
        SLST: {name: "Sri Lanka Standard Time", abbr: "SLST", offset: 5.5},
        SPST: {name: "SA Pacific Standard Time", abbr: "SPST", offset: -5},
        SST: {name: "Samoa Standard Time", abbr: "SST", offset: 13},
        SWST: {name: "SA Western Standard Time", abbr: "SWST", offset: -4},
        TDT: {name: "Turkey Standard Time", abbr: "TDT", offset: 3},
        TST: {name: "Tonga Standard Time", abbr: "TST", offset: 13},
        UST: {name: "Ulaanbaatar Standard Time", abbr: "UST", offset: 8},
        UTC: {name: "UTC", abbr: "UTC", offset: 0},
        VST: {name: "Vladivostok Standard Time", abbr: "VST", offset: 11},
        WAST: {name: "W. Australia Standard Time", abbr: "WAST", offset: 8},
        WCAST: {name: "W. Central Africa Standard Time", abbr: "WCAST", offset: 1},
        WEDT: {name: "W. Europe Standard Time", abbr: "WEDT", offset: 2},
        WPST: {name: "West Pacific Standard Time", abbr: "WPST", offset: 10},
        YEKT: {name: "Yekaterinburg Time", abbr: "YEKT", offset: 5},
        YST: {name: "Yakutsk Standard Time", abbr: "YST", offset: 9},
    },
    parseDateString(input, isUTC = true) {
        return _.size(input) > 0 ? (new Date(isUTC || input.indexOf('Z') === -1 ? input : input.slice(0, -1))) : input;
    },
    GetDaysInMonth(m, y) {
        return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
    },
    tryParseDateString(string) {
        let result = new Date(string);
        if (Object.prototype.toString.call(result) === "[object Date]") {
            if (isNaN(result.getTime())) {
                return null;
            } else {
                return result;
            }
        } else {
            return null;
        }
    },
    getDayName: function (dayNumber) {
        // Pass number 0-6 to get the day name. 0 = Sunday, 6 = Saturday
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        if (dayNumber < 0 || dayNumber > 6) {
            return "Invalid day number";
        }

        return dayNames[dayNumber];
    },
    getWeekBounds: function (date) {
        // localDate is here because setUTCDate was changing the original date to the end date
        let localDate = new Date(date),
            startDiff = localDate.getUTCDate() - localDate.getUTCDay(),
            endDiff = localDate.getUTCDate() + (6 - localDate.getUTCDay());
        return {
            start: new Date(localDate.setUTCDate(startDiff)),
            end: new Date(localDate.setUTCDate(endDiff))
        };
    },
    getCurrentMonth: function () {
        return (new Date()).getMonth() + 1;
    },
    getCurrentYear: function () {
        return (new Date()).getFullYear();
    },
    getTimeStats: function (date1, date2) {
        let t = Date.parse(date1) - Date.parse(date2),
            totalSeconds = Math.floor((t / PJQ.constants.time.millis.ONE_MINUTE)),
            seconds = Math.floor(totalSeconds % 50),
            totalMinutes = Math.floor((t / 1000 / 60)),
            minutes = Math.floor(totalMinutes % 60),
            totalHours = Math.floor((t / (PJQ.constants.time.millis.ONE_HOUR))),
            hours = Math.floor(totalHours % 24),
            totalDays = Math.floor(t / (PJQ.constants.time.millis.ONE_DAY)),
            days = Math.floor(totalDays % 30),
            totalMonths = Math.floor(t / (PJQ.constants.time.millis.ONE_MONTH)),
            months = Math.floor(totalMonths % 12),
            years = Math.floor(t / (PJQ.constants.time.millis.ONE_YEAR));
        return {
            years: years,
            months: months,
            totalMonths: totalMonths,
            days: days,
            totalDays: totalDays,
            hours: hours,
            totalHours: totalHours,
            minutes: minutes,
            totalMinutes: totalMinutes,
            seconds: seconds,
            totalSeconds: totalSeconds,
            totalMillis: t
        };
    },
    getTimeString: function (date) {
        if (date == null) {
            return '';
        }

        let timeArray = date.toLocaleTimeString('en-US', {hour12: false}).split(':');

        // If timeArray[0] is 24 (12AM) we want to set it to 0
        timeArray[0] = timeArray[0] < 24 ? timeArray[0] : 0;

        // If timeArray[0] is single digit, we want to prepend a 0 to that.
        timeArray[0] = timeArray[0] < 10 ? '0' + timeArray[0] : timeArray[0];

        // Build time string from timeArray
        return `${timeArray[0]}:${timeArray[1]}:${timeArray[2]}`;
    },
    getMinutesFromHoursDecimal: function (hoursDecimal) {
        // This function expects hours to be in decimal form.
        // An example for this function would be: (Input : 11.08 => Output: 665)
        let wholeHours = Math.floor(hoursDecimal);
        let fractionalHours = hoursDecimal - wholeHours;
        let minutesFromFraction = fractionalHours * 60;

        return (wholeHours * 60) + Math.round(minutesFromFraction);
    },
    getCountdownString: function (date) {
        date = this.getTimeStats(date, new Date());
        let s = "";
        if (date.days > 0)
            s += (date.days + "d ");
        if (date.hours > 0 || date.days > 0)
            s += (date.hours + "h ");
        if (date.minutes > 0 || date.hours > 0 || date.days > 0)
            s += (date.minutes + "m ");

        s += (date.seconds + "s");
        return s;
    },
    checkDateIsBeforeToday: function (date) {
        if (!date) {
            return true;
        }

        let argDate = new Date(date);
        argDate.setHours(0, 0, 0, 0);
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        return argDate < today;
    },
    checkDateBetweenDays: function (date1, date2, checkDate = new Date()) {
        return (checkDate.getTime() <= date2.getTime() && checkDate.getTime() >= date1.getTime());
    },
    checkDateRangesOverlap: function (startA, endA, startB, endB) {
        startA = new Date(startA);
        endA = new Date(endA);
        startB = new Date(startB);
        endB = new Date(endB);
        if (startA <= startB && startB <= endA) return true; // b starts in a
        if (startA <= endB && endB <= endA) return true; // b ends in a
        if (startB < startA && endA < endB) return true; // a in b
        return false;
    },
    getFromNowString: function (date) {
        return moment(new Date(date)).fromNow();
    },
    getTimeElapsed: function (date) {
        return this.getTimeStats(new Date(), date);
    },
    getTimeRemaining: function (date) {
        return this.getTimeStats(date, new Date());
    },
    getNewDateAddMilliseconds: function (date, milliseconds) {
        if (!date)
            return date;
        else {
            date = new Date(date);
            return new Date(date.setTime(date.getTime() + milliseconds));
        }
    },
    getNewDateAddSeconds: function (date, seconds) {
        return this.getNewDateAddMilliseconds(date, seconds * 1000);
    },
    getNewDateAddHours: function (date, hours) {
        return this.getNewDateAddMilliseconds(date, hours * PJQ.constants.time.millis.ONE_HOUR);
    },
    getNewDateAddDays: function (date, days, weekdaysOnly = false, inclusive = false) {
        days -= (inclusive ? 1 : 0);
        if (weekdaysOnly) {
            let result = new Date(date);
            let day = result.getDay();
            result.setDate(
                result.getDate() + days +
                (day === 6 ? 2 : +!day) +
                (Math.floor((days - 1 + (day % 6 || 1)) / 5) * 2));
            return result;
        }
        return this.getNewDateAddMilliseconds(date, days * PJQ.constants.time.millis.ONE_DAY);
    },
    getDateMillisecondsDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'milliseconds');
    },
    getDateSecondsDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'seconds');
    },
    getDateMinutesDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'minutes');
    },
    getDateHoursDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'hours');
    },
    getDateDaysDiff: function (date1, date2, weekdaysOnly = false, inclusive = false) {
        if (weekdaysOnly) {
            let numWorkDays = 0,
                currentDate = new Date(date2);
            while (currentDate <= date1) {
                // Skips Sunday and Saturday
                if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
                    numWorkDays++;
                }
                currentDate = currentDate.addDays(1);
            }
            return numWorkDays;
        }

        return this.getDateDiff(date1, date2, 'days') + (inclusive ? 1 : 0);
    },
    getDateDiff: function (date1, date2, type) {
        date1 = date1 == null ? new Date() : date1;
        date2 = date2 == null ? new Date() : date2;
        let diff = parseInt(date1.getTime() - date2.getTime()),
            result = 0;
        switch (type) {
            case 'days':
                result = diff / PJQ.constants.time.millis.ONE_DAY;
                break;
            case 'hours':
                result = diff / PJQ.constants.time.millis.ONE_HOUR;
                break;
            case 'minutes':
                result = diff / PJQ.constants.time.millis.ONE_MINUTE;
                break;
            case 'seconds':
                result = diff / PJQ.constants.time.millis.ONE_SECOND;
                break;
            default:
                result = diff;
                break;
        }
        result = Math.floor(isNaN(result) ? 0 : result);
        return result;
    },
    checkTimesDifferent: function (date1, date2, isIncludeSeconds = false) {
        return date1.getHours() !== date2.getHours() ||
            date1.getMinutes() !== date2.getMinutes() ||
            (isIncludeSeconds && date1.getSeconds() !== date2.getSeconds());
    },
    getDateDiffString: function (compareDate) {
        let date = new Date(),
            totalMinutes = this.getDateMinutesDiff(compareDate ? compareDate : date, date),
            hours = Math.floor(totalMinutes / 60),
            minutes = totalMinutes % 60;
        if (hours > 0)
            return (hours + 'hrs ' + minutes + 'min');
        else
            return (minutes + 'min');
    },
    validateDate: function (dateString, type) {
        dateString = dateString.replace(/-/g, '/');

        // Parse the date parts to integers
        let parts = dateString.split("/"),
            day = 0,
            month = 0,
            year = 0;

        if (type == null || type == '' || type.toLowerCase() == 'mdy') {
            if (/^\d{1,2}?\/\d{1,2}?\/\d{4}?$/i.test(dateString) == false)
                return false;
            month = parseInt(parts[0], 10);
            day = parseInt(parts[1], 10);
            year = parseInt(parts[2], 10);
        } else if (type.toLowerCase() == 'dmy') {
            if (/^\d{1,2}?\/\d{1,2}?\/\d{4}?$/i.test(dateString) == false)
                return false;
            day = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10);
            year = parseInt(parts[2], 10);
        } else if (type.toLowerCase() == 'ymd') {
            if (/^\d{4}?\/\d{1,2}?\/\d{1,2}?$/i.test(dateString) == false)
                return false;

            year = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10);
            day = parseInt(parts[2], 10);
        }

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month == 0 || month > 12)
            return false;

        let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    },
    getDateString: function (date, Z, utc) {
        let format = Z;
        if (date == null || (PJQ.helpers.objectHelpers.refinedType(date) === 'date' && isNaN(date.getTime())))
            return;
        else if (typeof date === 'string') {
            if (date.trim().length === 0) {
                return;
            }
            date = new Date(date);
        }

        let MMMM = ["\x00", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            MMM = ["\x01", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dddd = ["\x02", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            ddd = ["\x03", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        function ii(i, len) {
            let s = i + "";
            len = len || 2;
            while (s.length < len) s = "0" + s;
            return s;
        }

        let y = utc ? date.getUTCFullYear() : date.getFullYear();
        format = format.replace(/(^|[^\\])yyyy+/g, "$1" + y);
        format = format.replace(/(^|[^\\])yy/g, "$1" + y.toString().substr(2, 2));
        format = format.replace(/(^|[^\\])y/g, "$1" + y);

        let M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
        format = format.replace(/(^|[^\\])MMMM+/g, "$1" + MMMM[0]);
        format = format.replace(/(^|[^\\])MMM/g, "$1" + MMM[0]);
        format = format.replace(/(^|[^\\])MM/g, "$1" + ii(M));
        format = format.replace(/(^|[^\\])M/g, "$1" + M);

        let d = utc ? date.getUTCDate() : date.getDate();
        format = format.replace(/(^|[^\\])dddd+/g, "$1" + dddd[0]);
        format = format.replace(/(^|[^\\])ddd/g, "$1" + ddd[0]);
        format = format.replace(/(^|[^\\])dd/g, "$1" + ii(d));
        format = format.replace(/(^|[^\\])d/g, "$1" + d);

        let H = utc ? date.getUTCHours() : date.getHours();
        format = format.replace(/(^|[^\\])HH+/g, "$1" + ii(H));
        format = format.replace(/(^|[^\\])H/g, "$1" + H);

        let h = H > 12 ? H - 12 : H == 0 ? 12 : H;
        format = format.replace(/(^|[^\\])hh+/g, "$1" + ii(h));
        format = format.replace(/(^|[^\\])h/g, "$1" + h);

        let m = utc ? date.getUTCMinutes() : date.getMinutes();
        format = format.replace(/(^|[^\\])mm+/g, "$1" + ii(m));
        format = format.replace(/(^|[^\\])m/g, "$1" + m);

        let s = utc ? date.getUTCSeconds() : date.getSeconds();
        format = format.replace(/(^|[^\\])ss+/g, "$1" + ii(s));
        format = format.replace(/(^|[^\\])s/g, "$1" + s);

        let f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
        format = format.replace(/(^|[^\\])fff+/g, "$1" + ii(f, 3));
        f = Math.round(f / 10);
        format = format.replace(/(^|[^\\])ff/g, "$1" + ii(f));
        f = Math.round(f / 10);
        format = format.replace(/(^|[^\\])f/g, "$1" + f);

        let T = H < 12 ? "AM" : "PM";
        format = format.replace(/(^|[^\\])TT+/g, "$1" + T);
        format = format.replace(/(^|[^\\])T/g, "$1" + T.charAt(0));

        let t = T.toLowerCase();
        format = format.replace(/(^|[^\\])tt+/g, "$1" + t);
        format = format.replace(/(^|[^\\])t/g, "$1" + t.charAt(0));

        let tz = -date.getTimezoneOffset(),
            K = utc || !tz ? "Z" : tz > 0 ? "+" : "-";
        if (!utc) {
            tz = Math.abs(tz);
            let tzHrs = Math.floor(tz / 60),
                tzMin = tz % 60;
            K += ii(tzHrs) + ":" + ii(tzMin);
        }
        format = format.replace(/(^|[^\\])K/g, "$1" + K);

        let day = (utc ? date.getUTCDay() : date.getDay()) + 1;
        format = format.replace(new RegExp(dddd[0], "g"), dddd[day]);
        format = format.replace(new RegExp(ddd[0], "g"), ddd[day]);

        format = format.replace(new RegExp(MMMM[0], "g"), MMMM[M]);
        format = format.replace(new RegExp(MMM[0], "g"), MMM[M]);

        format = format.replace(/\\(.)/g, "$1");

        return format;
    }
};

PJQ.helpers.timerHelpers = {
    createCountdownTimer: function ($el, date, finishCallback) {
        if ($el) {
            let t = PJQ.helpers.dateHelpers.getTimeRemaining(date);
            this.createTimerElement($el, date);
            if (t.totalMillis > 0) {
                let interval = setInterval(_.bind(function () {
                    t = PJQ.helpers.dateHelpers.getTimeRemaining(date);
                    if (t.totalMillis > 0) {
                        this.createTimerElement($el, date);
                    } else {
                        clearInterval(interval);
                        if (finishCallback)
                            finishCallback($el);
                    }
                }, this), 1000);
            }
        }
        return interval;
    },
    createElapsedTimer: function ($el, date) {
        if ($el) {
            let t = PJQ.helpers.dateHelpers.getTimeElapsed(date);
            this.createTimerElement($el, date);
            let interval = setInterval(_.bind(function () {
                t = PJQ.helpers.dateHelpers.getTimeElapsed(date);
                this.createTimerElement($el, date);
            }, this), 1000);
        }
        return interval;
    },
    createTimerElement: function ($el, date) {
        $el.html(PJQ.helpers.dateHelpers.getCountdownString(date));
    }
};

PJQ.helpers.validators = {
    validatePhone: function (value) {
        return ((value.replace(/-/g, '').replace('(', '').replace(')', '').replace(' ', '').length >= 10) || value.replace('/', '').toLowerCase() === 'na');
    },
    validateZip: function (value) {
        return (/(^\d{5}$)|(^\d{5}-\d{4}$)/).test(value) || (/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/).test(value);
    },
    validateEmail: function (emailAddress, isAllowMultiple = false) {
        let error = null,
            emailRegex = new RegExp("^[A-Z0-9._%'-]+\\+?[A-Z0-9]{0,20}@[A-Z0-9.-]+\\.[A-Z]{2,20}$", "i");
        if (isAllowMultiple) {
            if (emailAddress.indexOf(";") !== -1) {
                _.every(emailAddress.split(';'), function (emailIteration) {
                    emailIteration = emailIteration.replace(' ', '');
                    if (!emailIteration || !emailRegex.test(emailIteration)) {
                        error = "INVALID";
                        return false;
                    }
                    return true;
                });
            } else if (emailAddress.indexOf(",") !== -1) {
                _.every(emailAddress.split(','), function (emailIteration) {
                    emailIteration = emailIteration.replace(' ', '');
                    if (!emailIteration || !emailRegex.test(emailIteration)) {
                        error = "INVALID";
                        return false;
                    }
                    return true;
                });
            } else if (!emailRegex.test(emailAddress)) {
                error = "INVALID";
            }
        } else {
            if (emailAddress.indexOf(";") !== -1 || emailAddress.indexOf(",") !== -1) {
                error = "MULTIPLE";
            } else if (!emailRegex.test(emailAddress)) {
                error = "INVALID";
            }
        }
        return {
            success: error === null,
            error: error
        };
    }
};

PJQ.helpers.formatHelpers = {
    getOrdinalSuffix: function (value) {
        let j = value % 10,
            k = value % 100;
        if (j === 1 && k !== 11) {
            return value + "st";
        }
        if (j === 2 && k !== 12) {
            return value + "nd";
        }
        if (j === 3 && k !== 13) {
            return value + "rd";
        }
        return value + "th";
    },
    upperCaseFirstLetterEachWord: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },
    upperCaseFirstLetter: function (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    },
    lowerCaseFirstLetter: function (value) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    },
    depluralize: function (word) {
        if (typeof word !== 'string' || word.length === 0) return word;

        if (word.endsWith('ies')) {
            return word.slice(0, -3) + 'y';
        } else if (word.endsWith('es') && !word.endsWith('sses') && !word.endsWith('xes') && !word.endsWith('des') && !word.endsWith('oes')) {
            return word.slice(0, -2);
        } else if (word.endsWith('s') && word.length > 1 && word[word.length - 2] !== 's') {
            return word.slice(0, -1);
        }

        return word;
    },
    formatPhoneNumber: function (value, wrapURL) {
        let s2 = ("" + value).replace(/\D/g, ''),
            m = s2.match(/^(\d{3})(\d{3})(\d{4})$/),
            val = (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];

        if (wrapURL)
            val = '<a class="phone-link" href="tel:' + val + '">' + val + '</a>';

        return val;
    },
    numbersOnly: function (value, allowDecimals = false, allowNegative = false) {
        if (allowNegative)
            return value != null ? value.toString().replace(new RegExp('[^0-9\-]', 'g'), '') : "";
        else if (allowDecimals)
            return value != null ? value.toString().replace(new RegExp('[^0-9\.]', 'g'), '') : "";
        else
            return value != null ? value.toString().replace(new RegExp('[^0-9\]', 'g'), '') : "";
    },
    alphanumericOnly: function (value) {
        return value != null ? value.toString().replace(new RegExp('[^a-z0-9]', 'gi'), '') : "";
    },
    formatPercent: function (value) {
        let cleaned = '0';
        if (value != null) {
            cleaned = this.numbersOnly(value, true);
            if (isNaN(parseInt(cleaned))) {
                cleaned = '0'
            }
        }
        return cleaned + '%';
    },
    formatDecimal: function (number, decimals = 2) {
        if (number == null || isNaN(number))
            number = 0;
        return number.toFixed(decimals);
    },
    formatZip: function (value) {
        value = this.alphanumericOnly(value);
        if (_.size(value) === 6) {
            return value.substr(0, 3).toUpperCase() + '-' + value.substr(3, 6).toUpperCase();
        } else {
            return value;
        }
    },
    numberToWords: function (number) {
        // Works into the billions
        if (number === 0) return 'zero';

        const digits = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const tens = ['ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const scales = ['', 'thousand', 'million', 'billion'];

        let words = '';
        let scaleIndex = 0;

        while (number > 0) {
            const current = number % 1000;
            number = Math.floor(number / 1000);

            if (current === 0) {
                continue;
            }

            let currentWords = '';
            if (current >= 100) {
                currentWords += digits[Math.floor(current / 100) - 1] + ' hundred';
            }

            if (current % 100 < 10) {
                currentWords += (currentWords.length && current % 100 !== 0 ? ' ' : '') + digits[current % 100 - 1];
            } else if (current % 100 < 20) {
                currentWords += (currentWords.length ? ' ' : '') + teens[(current % 100) - 11];
            } else {
                currentWords += (currentWords.length ? ' ' : '') + tens[Math.floor((current % 100) / 10) - 1];
                if (current % 10 !== 0) {
                    currentWords += '-' + digits[current % 10 - 1];
                }
            }

            words = currentWords + (currentWords.length ? ' ' + scales[scaleIndex] + ' ' : '') + words;
            scaleIndex++;
        }

        return words.trim();
    },
    minutesToHHMM: function (minutes) {
        let hours = Math.floor(minutes / 60),
            mins = minutes % 60;
        return (hours < 10 ? '0' : '') + hours + ':' + (mins < 10 ? '0' : '') + mins;
    },
    minutesFromHHMM: function (timeStr) {
        if (timeStr == null || _.size(timeStr) === 0)
            return 0;

        let parts = timeStr.split(':');
        return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    },
    formatCurrency: function (money, decimals = 2, includeDollarSign = true) {
        if (money == null || isNaN(money))
            money = 0;
        return (includeDollarSign ? '$' : '') + (money / 100).toFixed(decimals).toString().replace(PJQ.constants.regex.CURRENCY_NO_SYMBOL, '$1,');
    },
    getCentsDisplay: function (money) {
        return money % 100 < 10 ? '0' + (money % 100).toString() : (money % 100).toString();
    },
    getDollarsDisplay: function (money) {
        return Math.floor(money / 100).toString()
    },
    getTotalCents: function (dollars, cents) {
        if (typeof dollars === 'string')
            dollars = parseInt(dollars);
        else if (typeof dollars != 'number')
            dollars = 0;
        dollars *= 100;

        if (typeof cents === 'string')
            cents = parseInt(cents);
        else if (typeof cents != 'number')
            cents = 0;

        return dollars + cents;
    }
};

PJQ.helpers.inputHelpers = {
    getMoneyInputValue: function ($container) {
        let inputDollarsFull = $container.find('.input-dollars-full');
        if (_.size(inputDollarsFull) === 0 && $container.hasClass('input-dollars-full')) {
            inputDollarsFull = $container;
        } else if ($container.hasClass('input-decimal')) {
            inputDollarsFull = $container;
        }

        let total = 0;
        if (_.size(inputDollarsFull) > 0) {
            let inputVal = inputDollarsFull.val(),
                inputSplit = inputVal.toString().split('.');
            if (inputSplit.length < 2) {
                inputSplit[1] = "00";
            } else if (inputSplit[1].trim().length === 1) {
                inputSplit[1] = inputSplit[1] + "0";
            } else if (inputSplit[1].trim().length === 0) {
                inputSplit[1] = "00";
            }
            total = parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputSplit[0] + inputSplit[1], true, true));
        } else {
            let dollarsInput = $container.find('.input-dollars'),
                centsInput = $container.find('.input-cents'),
                dollars = _.size(dollarsInput) > 0 ? dollarsInput.val() : "0",
                cents = "00";

            if (_.size(centsInput) > 0) {
                //If both inputs are blank, we return null so we set null instead of 0 in the database
                if (_.size(dollarsInput.val()) === 0 && _.size(centsInput.val()) === 0) {
                    return null;
                }

                cents = centsInput.val();
                if (_.size(cents) < 2)
                    cents = ((_.size(cents) === 1 ? '0' : '00') + cents.toString());
            } else if (_.size(dollarsInput.val()) === 0) {
                //If dollars is blank, we return null so we set null instead of 0 in the database
                return null;
            }
            total = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(dollars, false, true) + PJQ.helpers.formatHelpers.numbersOnly(cents));
        }
        return isNaN(total) ? 0 : total;
    },
    getNumberInputValue: function ($el) {
        let num = parseInt(PJQ.helpers.formatHelpers.numbersOnly($el.val(), false, true));
        return isNaN(num) ? null : num;
    },
    getPercentInputValue: function ($el, decimal = false) {
        let inputVal = $el.val().replace('%', '');
        if (inputVal === "") {
            return inputVal;
        }

        let inputSplit = inputVal.toString().split('.');
        if (inputSplit.length < 2) {
            inputSplit[1] = "00";
        } else if (inputSplit[1].trim().length === 1) {
            inputSplit[1] = inputSplit[1] + "0";
        } else if (inputSplit[1].trim().length === 0) {
            inputSplit[1] = "00";
        }

        if (decimal) {
            return parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputSplit[0] + inputSplit[1])) / 100;
        } else {
            return parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputSplit[0] + inputSplit[1]));
        }
    },
    getPhoneInputValue: function ($el) {
        return PJQ.helpers.formatHelpers.numbersOnly($el.val())
    },
    getElementNodeType: function (input) {
        return input.prop('nodeName').toLowerCase();
    },
    attachNumericInputMinMax: function ($el, min, max, callback) {
        $el.on('change', function () {
            let val = $el.val();
            if (min && min > val)
                val = min;
            else if (max && max < val)
                val = max;
            $el.val(val);

            if (typeof callback === 'function') {
                callback(val);
            }
        });
    },
    inputMaxLength: function (e, length) {
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
            // Allow: . if allowPeriods == true
            (e.keyCode == 190 && allowPeriods) ||
            // Allow: Ctrl/cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        if ($(e.currentTarget).val().length >= (isNaN(length) ? 1 : length))
            e.preventDefault();
    },
    numbersOnly: function (e, allowPeriods = false, allowNegative = false) {
        if (e.type === 'keyup') {
            let $target = $(e.target);
            $target.val(PJQ.helpers.formatHelpers.numbersOnly($target.val()));
        } else {
            // Allow: backspace, delete, tab, escape, and enter
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                // Allow: . if allowPeriods == true
                ((e.keyCode === 190 || e.keyCode === 110) && allowPeriods) ||
                //Allow - if allowNegative == true
                ((e.keyCode === 109 || e.keyCode === 189) && allowNegative) ||
                // Allow: Ctrl/cmd+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl/cmd+C
                (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl/cmd+X
                (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl/cmd+V
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // Key that was pressed is allowed
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        }
    },
    numbersAndSingleDecimalOnly: function (e) {
        return this.numbersOnly(e, true);
    },
    allowZip: function (e, country) {
        country = country != null && country.toLowerCase() === 'ca' ? 'ca' : 'us';
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
            // Allow: . if allowPeriods == true
            (e.keyCode == 190 && allowPeriods) ||
            // Allow: Ctrl/cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        if (country === 'us' && (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }

        if ($(e.currentTarget).val().replace('-', '').length >= (country === 'ca' ? 7 : 5))
            e.preventDefault();
    },
    setInputError: function (input, isValid = false, options = {}) {
        if (input == null || input.length <= 0)
            return;

        let elementType = this.getElementNodeType(input);
        if (elementType === 'input' || elementType === 'textarea') {
            if (isValid) {
                input.removeClass('p-field-error');
            } else {
                if (options.isHighlightInput != false) {
                    input.addClass('p-field-error');
                }
            }
        } else if (elementType === 'select') {
            let inputButton = input.siblings('.dropdown-toggle').eq(0);
            if (inputButton.length > 0) {
                if (isValid) {
                    inputButton.removeClass('p-field-error');
                } else {
                    inputButton.addClass('p-field-error');
                }
            }
        } else if (input.hasClass('bootstrap-select')) {
            let inputButton = input.find('.dropdown-toggle');
            if (inputButton.length > 0) {
                if (isValid) {
                    inputButton.removeClass('p-field-error');
                } else {
                    inputButton.addClass('p-field-error');
                }
            }
        }

        //Delete the existing error text if it exists
        let errId = input.data('errSrc');
        if (_.size(errId) > 0) {
            $('div[data-err="' + errId + '"]').remove();
            input.removeData('errSrc');
        }

        if (_.size(options.errorText) > 0) {
            let $errorEl;
            if (elementType === 'select') {
                $errorEl = input.closest('.btn-group');
            } else {
                $errorEl = input.closest('.input-group');
            }

            if (_.size($errorEl) === 0) {
                $errorEl = input.closest('.form-group').find('label');

                if (_.size($errorEl) > 0) {
                    $errorEl.append($('<span>', {
                        'class': 'fs-14 text-danger ml-1 wd-100 font-weight-light ml-2'
                    }).html(options.errorText));
                }
            } else {
                //Add the new error text
                errId = _.uniqueId();
                input.data('errSrc', errId);
                $errorEl.append($('<div>', {
                    'class': 'fs-14 text-danger ml-1 wd-100 font-weight-light',
                    'data-err': errId
                }).html(options.errorText));
            }


            if (_.size($errorEl) > 0) {

            }
        }
    },
    inputMaskPhone: function (input) {
        input.inputmask('(999) 999-9999', {
            placeholder: ''
        });
    },
    inputMaskZip: function (input, country = 'us') {
        let opts = {
            placeholder: '',
            mask: null,
            regex: null
        };
        if (country && country.toLowerCase() == 'ca') {
            opts.mask = 'A9A 9A9';
        } else if (country && country.toLowerCase() == 'us') {
            opts.mask = '99999';
        } else {
            opts.regex = '([a-zA-Z0-9_-]){0,12}';
        }
        input.inputmask(opts);
    },
    inputMaskCurrency: function (input, digits = 0, showSymbol = false) {
        input.inputmask({
            alias: "currency",
            prefix: showSymbol ? '$' : '',
            digits: digits,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false,
            allowMinus: true
        });
    },
    inputMaskHours: function (input) {
        input.inputmask('99:59', {
            mask: "99:59",
            placeholder: "00:00",
            definitions: {
                '9': {
                    validator: "[0-9]",
                    cardinality: 1
                },
                '5': {
                    validator: "[0-5]",
                    cardinality: 1
                }
            },
            insertMode: false,
            showMaskOnHover: false,
            positionCaretOnClick: 'select'
        }).off("focus.tei").on("focus.tei", function () {
            this.setSelectionRange(0, 1);
        }).on("input", function () {
            // The colon will always be at position 2, so we always want to skip over it.
            let caretPos = this.selectionStart;

            if (caretPos === 2) {
                this.setSelectionRange(3, 4);
            }
        });
    },
    inputMaskPercent: function (input, digits = 0, showSymbol = false) {
        input.inputmask({
            alias: "currency",
            suffix: showSymbol ? '%' : '',
            digits: digits,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false,
            allowMinus: true
        });
    },
    inputMaskCreditCard: function (input, digits = 0) {
        input.inputmask('9999 9999 9999 9999', {
            alias: "cc",
            digits: digits,
            placeholder: '',
            rightAlign: false
        });
    },
    inputMaskDecimal: function (input, digits = 0) {
        input.inputmask({
            alias: "currency",
            prefix: "",
            digits: digits,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false
        });
    },
    inputMaskInteger: function (input) {
        //we use currency so we get commas
        input.inputmask({
            alias: "currency",
            prefix: "",
            digits: 0,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false
        });
    }
};

PJQ.helpers.bidForms = {
    lineItemTypes: [
        {name: "Sum", abbreviation: "Sum"},
        {name: "Each", abbreviation: "Ea."},
        {name: "Square Feet", abbreviation: "Sq.Ft."},
        {name: "Linear Feet", abbreviation: "Ln.Ft."},
        {name: "Cubic Feet", abbreviation: "Cu.Ft."},
        {name: "Square Yards", abbreviation: "Sq.Yd."},
        {name: "Linear Yards", abbreviation: "Ln.Yd."},
        {name: "Cubic Yards", abbreviation: "Cu.Yd."},
        {name: "Acres", abbreviation: "Acres"},
        {name: "Hours", abbreviation: "Hrs"},
        {name: "Days", abbreviation: "Days"},
        {name: "Pounds", abbreviation: "Lbs."},
        {name: "Tons", abbreviation: "Tons"}
    ],
    lineItemQuestionTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Numeric",
        "Date",
        "Date/Time"
    ],
    alternateTypes: [
        {name: "Sum", abbreviation: "Sum"},
        {name: "Each", abbreviation: "Ea."},
        {name: "Square Feet", abbreviation: "Sq.Ft."},
        {name: "Linear Feet", abbreviation: "Ln.Ft."},
        {name: "Cubic Feet", abbreviation: "Cu.Ft."},
        {name: "Square Yards", abbreviation: "Sq.Yd."},
        {name: "Linear Yards", abbreviation: "Ln.Yd."},
        {name: "Cubic Yards", abbreviation: "Cu.Yd."},
        {name: "Acres", abbreviation: "Acres"},
        {name: "Hours", abbreviation: "Hrs"},
        {name: "Days", abbreviation: "Days"},
        {name: "Pounds", abbreviation: "Lbs."},
        {name: "Tons", abbreviation: "Tons"}
    ],
    alternateQuestionTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    acknowledgementTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    bondingTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    certificationTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    laborRateTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ]
};

PJQ.helpers.guid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

PJQ.helpers.stringHelpers = {
    format: function (format) {
        let args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined' ? args[number] : match;
        });
    },
    getLowercaseChars: function (string) {
        return string.match(/[a-z]/g);
    },
    getUppercaseChars: function (string) {
        return string.match(/[A-Z]/g);
    },
    getNumericChars: function (string) {
        return string.match(/[\d]/g);
    },
    getSpecialChars: function (string) {
        return string.match(/[^a-zA-Z\d]/g);
    },
    findMatches: function (regex, str, matches = []) {
        const res = regex.exec(str);
        res && matches.push({
            full: res[0],
            group: res[1]
        }) && this.findMatches(regex, str, matches);
        return matches;
    }
};

PJQ.helpers.objectHelpers = {
    checkNested: function (obj, level, ...rest) {
        if (typeof obj === 'undefined' || obj == null)
            return false;
        else if (_.size(rest) === 0 && obj.hasOwnProperty(level))
            return true;
        return this.checkNested(obj[level], ...rest);
    },
    getNestedValue: function (obj, attr) {
        if (attr == null || obj == null) {
            return null;
        }

        let attrs = attr.split('.');
        return attrs.reduce((acc, val) => acc && acc[val], obj);
    },
    convertObjectCamelcase: function (copyObject, destinationObject = {}) {
        if (typeof copyObject === "string") {
            return copyObject.substring(0, 1).toLowerCase() + copyObject.substring(1);
        } else if (copyObject instanceof Array) {
            return _.map(copyObject, function (value) {
                if (typeof value === "object") {
                    value = this.convertObjectCamelcase(value)
                }
                return value
            }, this);
        } else {
            _.each(copyObject, function (value, key) {
                if (copyObject.hasOwnProperty(key)) {
                    let valueType = this.refinedType(value),
                        lowerKey = key.substring(0, 1).toLowerCase() + key.substring(1);
                    if (valueType === 'object' || valueType === 'array') {
                        destinationObject[lowerKey] = this.convertObjectCamelcase(value);
                    } else {
                        destinationObject[lowerKey] = value;
                    }
                }
            }, this);
        }
        return destinationObject;
    },
    refinedType: function (object, isIncludeBackbone) {
        if (typeof object === 'object') {
            if (Object.prototype.toString.call(object) === '[object Array]') {
                return 'array';
            } else if (object instanceof Date) {
                return 'date';
            } else if (isIncludeBackbone) {
                if (this.isBackboneModel(object))
                    return 'backboneModel';
                else if (this.isBackboneCollection(object))
                    return 'backboneCollection';
            }
        }
        return typeof object;
    },
    isBackboneModel: function (object) {
        return object instanceof Backbone.Model;
    },
    isBackboneCollection: function (object) {
        return object instanceof Backbone.Collection;
    },
    findDistinct: function (arr, property) {
        let result = [],
            isBackboneCollection = this.isBackboneCollection(arr),
            isBackboneModels = isBackboneCollection || this.isBackboneModel(arr[0]);
        _.each(isBackboneCollection ? arr.models : arr, function (obj) {
            if (_.find(result, function (resultObj) {
                if (isBackboneModels)
                    return resultObj.get(property) === obj.get(property);
                else
                    return resultObj[property] === obj[property];
            }) == null) {
                result.push(obj);
            }
        });
        return result;
    }
};

PJQ.helpers.urlHelpers = {
    buildApiUrl: function (endpoint, options = {
        isPascal: false,
        includeSessionId: false,
        includeAccessKey: false,
        includeAccessToken: false,
        service: null
    }) {
        let url;
        switch (options.service) {
            case PJQ.constants.services.ORIGIN:
                url = window.location.origin;
                break;
            case PJQ.constants.services.FILES:
                url = PJQ.app.options.fileApiUrl;
                break;
            case PJQ.constants.services.APIv2:
                url = PJQ.app.options.apiV2Url;
                break;
            default:
                url = PJQ.app.options.apiUrl;
                break;
        }

        if (options.isPascal) {
            url += "/pascal";
        }

        url = url + (endpoint == null ? '' : endpoint);

        if (options.includeSessionId) {
            url = this.appendSessionId(url);
        }

        if (options.includeAccessToken) {
            url = this.appendAccessToken(url);
        }

        if (options.includeAccessKey && _.size(PJQ.app.session.get('accessKey')) > 0) {
            url = this.appendAccessKey(url);
        }

        return url;
    },
    // old/deprecated - still used in some places
    buildAPIURL: function (root, isPascal = false, includeSessionId = false, isFileAPI = false, includeAccessKey = false) {
        let url = (isFileAPI ? PJQ.app.options.fileApiUrl : PJQ.app.options.apiUrl) + (isPascal ? "/pascal" : "") + (root == null ? '' : root);
        if (includeSessionId) {
            url = this.appendSessionId(url);
        }

        if (PJQ.app.options.isDebug) {
            url = this.appendDebug(url);
        }

        if (includeAccessKey && _.size(PJQ.app.session.get('accessKey')) > 0) {
            url = this.appendAccessKey(url);
        }

        return url;
    },
    appendAccessKey: function (url) {
        return (url + (url.indexOf("?") === -1 ? "?" : "&") + "accessKey=" + PJQ.app.session.get('accessKey'));
    },
    appendDebug: function (url) {
        return (url + (url.indexOf("?") === -1 ? "?" : "&") + "debug=true");
    },
    appendSessionId: function (url) {
        return (url + (url.indexOf("?") === -1 ? "?" : "&") + "sessionId=" + PJQ.app.session.get('sessionId'));
    },
    appendAccessToken: function (url) {
        let accessToken = PJQ.app.TokenManager.getAccessToken()
        if (PJQ.app.TokenManager != null && _.size(accessToken) > 0) {
            return (url + (url.indexOf("?") === -1 ? "?" : "&") + "access_token=" + accessToken);
        }
        return url;
    },
    buildDomainURL: function (root, isPanteraDomain) {
        return isPanteraDomain ? PJQ.app.options.defaultPortalUrl : location.origin + (root == null ? '' : root);
    },
    generateEndpoint: function (endpointArr, parametersArr) {
        let result = '';
        _.each(endpointArr, function (endpointItem) {
            if (endpointItem.endpoint != null && endpointItem.endpoint.length > 0) {
                result += '/' + endpointItem.endpoint;

                result += endpointItem.value != null ? ('/' + endpointItem.value.toString()) : '';
            }
        });

        let isParamsStarted = false;
        _.each(parametersArr, function (parametersItem) {
            if (parametersItem.parameter != null && parametersItem.parameter.length > 0) {
                if (parametersItem.includeIfEmpty !== false || _.size(parametersItem.value) > 0 || typeof parametersItem.value === 'number' || typeof parametersItem.value === 'boolean') {
                    if (parametersItem.value != null) {
                        let refinedType = PJQ.helpers.objectHelpers.refinedType(parametersItem.value),
                            paramValue;
                        if (refinedType === 'array') {
                            paramValue = parametersItem.value.join(',');
                        } else if (refinedType === 'date') {
                            paramValue = parametersItem.value.toISOString();
                        } else {
                            paramValue = parametersItem.value.toString();
                        }
                        // only add the param to the result if it has a value
                        if (_.size(paramValue) > 0) {
                            result += (isParamsStarted ? "&" : "?") + parametersItem.parameter + '=' + encodeURIComponent(paramValue);
                            isParamsStarted = true;
                        }
                    }
                }
            }
        });
        return result
    },
    buildQueryParamRegex: function (name) {
        return '[?&]' + name + '=([^&#]*)';
    },
    getQueryParam: function (name, useHash = false) {
        let loc = useHash ? window.location.hash : window.location.search;
        if (_.size(name) > 0 && _.size(loc) > 0) {
            let q = loc.toLowerCase().match(new RegExp(this.buildQueryParamRegex(name.toLowerCase())));
            return q && q[1].replace(/\//g, '');
        }
        return null;
    },
    removeQueryParam: function (name, useHash = false) {
        let loc = useHash ? window.location.hash : window.location.search;
        if (_.size(name) > 0 && _.size(loc) > 0) {
            let regex = new RegExp(`[?&]${name}=([^&#]*)`, 'i');
            let newLoc = loc.replace(regex, '');

            if (useHash) {
                window.location.hash = newLoc;
            } else {
                let newUrl = window.location.pathname + newLoc + window.location.hash;
                history.replaceState(null, '', newUrl);
            }
        }
    },
    queryStringToObject: function (queryString) {
        let pairs = queryString.split('&');
        return pairs.reduce((acc, pair) => {
            const [key, value] = pair.split('=');
            acc[key] = isNaN(+value) ? value : +value;
            return acc;
        }, {});
    },
    pushState: function (options) {
        if (options != null && options.url != null) {
            if (typeof options.title === 'string') {
                document.title = options.pageTitle;
            }
            window.history.pushState({}, document.title, options.url);
        }
    },
    cleanRouteParams: function () {
        if (window.location.href.indexOf('#') != -1)
            window.history.replaceState(null, null, window.location.pathname + "#" + window.location.href.split('#')[1]);
    },
    isURL: function (input) {
        let givenURL;
        try {
            givenURL = new URL(input);
        } catch (error) {
            return false;
        }
        return givenURL.protocol === "http:" || givenURL.protocol === "https:";
    }
};

PJQ.helpers.apiHelpers = {
    isDebug: false,
    getHeaders: function (service) {
        let headers = {
            PortalId: PJQ.app.session.get('portalId'),
            Debug: PJQ.helpers.apiHelpers.isDebug
        };

        let accessToken = PJQ.app.TokenManager.getAccessToken();
        if (_.size(accessToken) > 0) {
            headers.Authorization = "Bearer " + accessToken;
        }

        switch (service) {
            case PJQ.constants.services.APIv2:
                break;
            default:
                let sessionId = PJQ.app.session.get('sessionId');
                if (sessionId != null) {
                    headers.SessionId = sessionId;
                }

                if (PJQ.app.session.contact && PJQ.app.session.contact.id > 0) {
                    headers.ContactId = PJQ.app.session.contact.id;
                }

                if (PJQ.app.session.project && PJQ.app.session.project.id > 0) {
                    headers.ProjectId = PJQ.app.session.project.id;
                }

                let accessKey = PJQ.app.session.get('accessKey');
                if (accessKey != null) {
                    headers.AccessKey = accessKey;
                }

                let projKey = PJQ.app.session.get('projectKey');
                if (projKey != null) {
                    headers.ProjectKey = projKey;
                }

                let contactGuid = PJQ.app.session.get('contactGuid');
                if (contactGuid != null) {
                    headers.ContactGuid = contactGuid;
                }

                if (PJQ.app.session.systemPermissions != null) {
                    headers.Perm = PJQ.app.session.systemPermissions.get('key');
                }

                if (PJQ.app.session.project != null && PJQ.app.session.project.permissions != null) {
                    headers.ProjectPerm = PJQ.app.session.project.permissions.get('key');
                }

                if (PJQ.app.session.get('masterUserId') > 0) {
                    headers.MasterUserId = PJQ.app.session.get('masterUserId');
                }
        }
        return headers;
    },
    addHeaders: function (xhr, service, extraHeaders = null) {
        let headers = PJQ.helpers.apiHelpers.getHeaders(service);
        if (extraHeaders != null) {
            for (let header in extraHeaders) {
                this.addHeader(xhr, header, headers[header]);
            }
        }
        for (let header in headers) {
            this.addHeader(xhr, header, headers[header]);
        }
    },
    addHeader: function (xhr, header, value) {
        if (value != null)
            xhr.setRequestHeader(header, value);
    }
};

PJQ.helpers.cookieHelpers = {
    getCookie: function (name) {
        let nameEQ = name + "=",
            ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    setCookie: function (name, value, days) {
        let expires = "";
        if (days >= 0) {
            let date = new Date();
            if (days > 0) {
                date.setTime(date.getTime() + (days * PJQ.constants.time.millis.ONE_DAY));
            } else {
                date.setTime(date.getTime() + (10 * 365 * PJQ.constants.time.millis.ONE_DAY));
            }
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    removeCookie: function (name) {
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    }
};

PJQ.helpers.googleMapsHelpers = {
    polyDefaults: {
        fillColor: '501400C8',
        isFill: true
    },
    generatePolyStyle: function (style) {
        style = _.defaults(style ? style : {}, this.polyDefaults);
        return '<Style><PolyStyle><color>' + (style.fillColor) + '</color><fill>' + (style.isFill ? '1' : '0') + '</fill></PolyStyle></Style>';
    }
};

PJQ.helpers.paymentHelpers = {
    validateCreditCard: function (value) {
        if (_.size(value) === 0)
            return false;

        value = value.replace(/\D/g, "");

        let nCheck = 0,
            bEven = false;
        for (let n = value.length - 1; n >= 0; n--) {
            let cDigit = value.charAt(n),
                nDigit = parseInt(cDigit, 10);

            if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
            }
            nCheck += nDigit;
            bEven = !bEven;
        }
        return (nCheck % 10) === 0;
    },
    getCardIssuer: function (value) {
        let issuer = "unknown";
        if (_.size(value) === 0) {
            return issuer;
        }

        //JCB
        let jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');

        // American Express
        let amex_regex = new RegExp('^3[47][0-9]{0,}$');

        // Diners Club
        let diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');

        // Visa
        let visa_regex = new RegExp('^4[0-9]{0,}$'); //4

        // MasterCard
        let mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');

        // Maestro
        let maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');

        //Discover
        let discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

        // get rid of anything but numbers
        value = value.replace(/\D/g, '');

        // checks per each, as their could be multiple hits
        //fix: ordering matter in detection, otherwise can give false results in rare cases
        if (value.match(jcb_regex)) {
            issuer = "jcb";
        } else if (value.match(amex_regex)) {
            issuer = "amex";
        } else if (value.match(diners_regex)) {
            issuer = "diners_club";
        } else if (value.match(visa_regex)) {
            issuer = "visa";
        } else if (value.match(mastercard_regex)) {
            issuer = "mastercard";
        } else if (value.match(discover_regex)) {
            issuer = "discover";
        } else if (value.match(maestro_regex)) {
            if (value[0] === '5') { //started 5 must be mastercard
                issuer = "mastercard";
            } else {
                issuer = "maestro"; //maestro is all 60-69 which is not something else, thats why this condition in the end
            }
        }
        return issuer;
    },
    getCardIssuerIconFAClass: function (issuer) {
        let icon;
        switch (issuer.toLowerCase()) {
            case "jcb":
                icon = 'fa-cc-jcb';
                break;
            case "amex":
                icon = 'fa-cc-amex';
                break;
            case "diners_club":
                icon = 'fa-cc-diners-club';
                break;
            case "visa":
                icon = 'fa-cc-visa';
                break;
            case "mastercard":
                icon = 'fa-cc-mastercard';
                break;
            case "maestro":
                icon = 'fa-cc-maestro';
                break;
            case "discover":
                icon = 'fa-cc-discover';
                break;
            default:
                return '';
        }
        return 'fab ' + icon;
    }
};

PJQ.helpers.colorHelpers = {
    getHexFromRGB: function (rgb) {
        if (rgb == null) {
            return null;
        } else if (rgb.indexOf('rgba') !== -1) {
            rgb = rgb.replace('rgba', 'rgb');
        }

        let rgbs = rgb.split(','),
            r = parseInt(rgbs[0].substring(4)),
            g = parseInt(rgbs[1]),
            b = parseInt(rgbs[2]);
        return "#" + PJQ.helpers.colorHelpers.componentToHex(r) + PJQ.helpers.colorHelpers.componentToHex(g) + PJQ.helpers.colorHelpers.componentToHex(b);
    },
    componentToHex: function (c) {
        let hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    },
    getRGBFromHex: function (hex) {
        if (_.indexOf(hex, '#') === -1) {
            hex = '#' + hex;
        }
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        let parsed = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return parsed ? {
            R: parseInt(parsed[1], 16),
            G: parseInt(parsed[2], 16),
            B: parseInt(parsed[3], 16)
        } : null;
    },
    idealLinkColorForBackground: function (color) {
        // if (bgColor == null) {
        // 	return '#FFF';
        // }
        // else if (bgColor.length < 5) {
        // 	bgColor += bgColor.slice(1);
        // }
        // return (bgColor.replace('#', '0x')) > (0xffffff / 2) ? '#333' : '#fff';

        let hexColor = color.replace("#", ""),
            r = parseInt(hexColor.substr(0, 2), 16),
            g = parseInt(hexColor.substr(2, 2), 16),
            b = parseInt(hexColor.substr(4, 2), 16),
            yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? '#333' : '#fff';
    }
};

PJQ.helpers.elementHelpers = {
    addInvisibleElement: function ($el) {
        let $b = $('body'),
            containerClass = '.invis-outer',
            $c = $b.find(containerClass);
        if (_.size($c) === 0) {
            $c = $('<div></div>', {
                class: containerClass,
                style: 'position:absolute;visibility:hidden;top:0;bottom:0;left:0;right:0;'
            });
            $b.append($c);
        }
        $c.append($el);
    },
    isElementInView: function ($el, docViewTop = null, docViewBottom = null) {
        if (docViewTop == null || docViewBottom == null) {
            docViewTop = $(window).scrollTop();
            docViewBottom = docViewTop + $(window).height();
        }
        let elementTop = $el.offset().top,
            elementBottom = elementTop + $el.height();
        return (elementBottom <= docViewBottom) && (elementTop >= docViewTop);
    }
};

PJQ.helpers.imageHelpers = {
    rotateByExif: function ($el, callback) {
        this.getExifOrientation($el, function (orientation) {
            $el.removeClass('transform-rotate-180 transform-rotate-90 transform-rotate-n-90');
            switch (orientation) {
                case 3:
                    $el.addClass('transform-rotate-180');
                    break;
                case 6:
                    $el.addClass('transform-rotate-90');
                    break;
                case 8:
                    $el.addClass('transform-rotate-n-90');
                    break;
            }
            callback();
        });
    },
    rotateElement: function ($el, degrees) {
        $el.removeClass('transform-rotate-180 transform-rotate-90 transform-rotate-n-90');
        switch (degrees) {
            case 90:
                $el.addClass('transform-rotate-90');
                break;
            case 180:
                $el.addClass('transform-rotate-180');
                break;
            case 270:
            case -90:
                $el.addClass('transform-rotate-n-90');
                break;
        }
    },
    getExifOrientation: function ($el, callback) {
        if (_.size($el) > 0) {
            let exifData = $el.data('exif');
            if (exifData != null) {
                callback(EXIF.getTag(exifData, "Orientation"));
            } else {
                EXIF.getData($el[0], function () {
                    exifData = this;
                    $el.data('exif', exifData);
                    callback(EXIF.getTag(exifData, "Orientation"));
                });
            }
        } else {
            callback(null);
        }
    }
};

PJQ.helpers.mathHelpers = {
    roundAwayFromZero(value) {
        let abs = Math.abs(value),
            rounded = (abs % 1 === 0.5) ? Math.ceil(abs) : Math.round(abs);
        return value < 0 ? -rounded : rounded;
    },
    getRandomNumber: function (max = 1) {
        return Math.floor(Math.random() * Math.floor(max));
    },
    clamp: function (num, a, b) {
        return Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b));
    }
};

PJQ.helpers.trigHelpers = {
    checkRectCollision: function (start, end, x, y) {
        return end.x >= x && start.x <= x && end.y >= y && start.y <= y;
    },
    distance: function (x1, y1, x2, y2) {
        let dx = x2 - x1,
            dy = y2 - y1;
        return Math.sqrt((dx * dx) + (dy * dy));
    }
};

PJQ.helpers.projectHelpers = {
    accessKeyNavigate: function (accessKey, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'accessKeys',
                    value: accessKey
                }
            ])
        }).get().done(_.bind(function (response) {
            if (response.url != null) {
                if (response.url.indexOf('Default.aspx') !== -1) {
                    window.location = response.url;
                } else if (response.url.indexOf('#') !== -1) {
                    PJQ.app.router.navigate(response.url.substring(1), {
                        trigger: true
                    });
                } else if (response.url.indexOf('/') !== -1) {
                    window.location = response.url.substring(1);
                }
            } else if (response.projectId > 0) {
                let host = window.location.origin;
                window.location = host + (host.indexOf('?') !== -1 ? '&' : '?') + 'accessKey=' + accessKey + '#projects/' + response.projectId.toString();
            } else {
                callback(response.message ? response.message : PJQ.Errors.auth.NOT_FOUND);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : PJQ.Errors.auth.NOT_FOUND);
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
                error: err,
                result: result
            });
        }, this));
    }
};

PJQ.helpers.sortHelpers = {
    regexAlpha: /[^a-zA-Z]/g,
    regexNum: /[^0-9]/g,
    sortAlphaNum: (a, b) => a.localeCompare(b, 'en', {numeric: true}),
    sortAlphaNumeric: function (a, b) {
        let aA = a.replace(PJQ.helpers.sortHelpers.regexAlpha, ""),
            bA = b.replace(PJQ.helpers.sortHelpers.regexAlpha, "");
        if (aA === bA) {
            let aN = parseInt(a.replace(PJQ.helpers.sortHelpers.regexNum, ""), 10),
                bN = parseInt(b.replace(PJQ.helpers.sortHelpers.regexNum, ""), 10);
            return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
            return aA > bA ? 1 : -1;
        }
    },
    commonOrder: [
        "g",
        "t",
        "d",
        "s",
        "a",
        "r",
        "m",
        "p",
        "e"
    ],
    sortCommonPageNumbers: function (a, b) {
        let regexLetters = /^[a-z]+$/i,
            aStartLetter = regexLetters.test(a[0]),
            bStartLetter = regexLetters.test(b[0]);
        if (aStartLetter && bStartLetter) {
            // if both a and b start with a letter, determine letters precedence
            // build a string for both with only the starting letters
            let aLetters = "";
            for (let i = 0; i < a.length; i++) {
                if (regexLetters.test(a[i])) {
                    aLetters += a[i].toLowerCase();
                } else {
                    break;
                }
            }

            let bLetters = "";
            for (let i = 0; i < b.length; i++) {
                if (regexLetters.test(b[i])) {
                    bLetters += b[i].toLowerCase();
                } else {
                    break;
                }
            }

            if (aLetters === bLetters) {
                // if the letters are the same, compare them alphanumeric
                return this.sortAlphaNumeric(a, b);
            }

            let aInd = -1,
                bInd = -1;
            for (let i = 0; i < this.commonOrder.length; i++) {
                if (aLetters === this.commonOrder[i]) {
                    aInd = i;
                }
                if (bLetters === this.commonOrder[i]) {
                    bInd = i;
                }
            }

            if (bInd !== -1 && aInd > bInd) {
                return 1;
            } else if (aInd !== -1 && bInd > aInd) {
                return -1;
            } else {
                // both were the same sort
                // if it got here, this means neither of them matched our commonOrder letters
                // sort alphanumeric
                return this.sortAlphaNumeric(a, b);
            }
        } else if (!aStartLetter && bStartLetter) {
            // if "b" starts with a letter and "a" does not, b is first
            return 1;
        } else if (aStartLetter && !bStartLetter) {
            // if "a" starts with a letter and "b" does not, a is first
            return -1;
        } else if (!aStartLetter && !bStartLetter) {
            // if neither "a" nor "b" start with a letter, return regular alphanumeric comparison
            return this.sortAlphaNumeric(a, b);
        }
    }
};

PJQ.helpers.browserHelpers = {
    getChromeVersion: function () {
        let raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        return raw ? parseInt(raw[2], 10) : null;
    }
};

PJQ.helpers.canvasHelpers = {
    loadFont: function (font, callback) {
        document.fonts.load(font).then((_) => {
            callback(font);
        });
    },
    drawRoundRect: function (ct, x, y, width, height, radius, fill, stroke) {
        if (typeof stroke === 'undefined') {
            stroke = true;
        }
        if (typeof radius === 'undefined') {
            radius = 5;
        }
        if (typeof radius === 'number') {
            radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
            let defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
            for (let side in defaultRadius) {
                radius[side] = radius[side] || defaultRadius[side];
            }
        }
        ct.beginPath();
        ct.moveTo(x + radius.tl, y);
        ct.lineTo(x + width - radius.tr, y);
        ct.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ct.lineTo(x + width, y + height - radius.br);
        ct.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ct.lineTo(x + radius.bl, y + height);
        ct.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ct.lineTo(x, y + radius.tl);
        ct.quadraticCurveTo(x, y, x + radius.tl, y);
        ct.closePath();
        if (fill) {
            ct.fill();
        }
        if (stroke) {
            ct.stroke();
        }
    }
};
PJQ.constants = {
    customerService: {
        getPhone: function () {
            return PJQ.helpers.formatHelpers.formatPhoneNumber('8772199777');
        },
        getEmail: function () {
            if (PJQ.app.options.isPanteraApp) {
                return 'customerservice@panteratools.com';
            }
            return 'contactus@jobplanner.com'
        }
    },
    services: {
        ORIGIN: "ORIGIN",
        API: "API",
        FILES: "FILES",
        APIv2: "APIv2"
    },
    panteraPortalId: 4,
    publicUserId: 39,
    publicLogoURL: "https://app.panteratools.com/images/pantera_app_logo.png",
    countries: ['us', 'ca'],
    internationalCountries: [{
        name: "Afghanistan",
        states: ["Badakhshan", "Badghis", "Baghlan", "Balkh", "Bamyan", "Daykundi", "Farah", "Faryab", "Ghazni", "Ghōr", "Helmand", "Herat", "Jowzjan", "Kabul", "Kandahar", "Kapisa", "Khost", "Kunar", "Kunduz Province", "Laghman", "Logar", "Nangarhar", "Nimruz", "Nuristan", "Paktia", "Paktika", "Panjshir", "Parwan", "Samangan", "Sar-e Pol", "Takhar", "Urozgan", "Zabul"]
    }, {
        name: "Aland Islands",
        states: ["Brändö", "Eckerö", "Finström", "Föglö", "Geta", "Hammarland", "Jomala", "Kökar", "Kumlinge", "Lemland", "Lumparland", "Mariehamn", "Saltvik", "Sottunga", "Sund", "Vårdö"]
    }, {
        name: "Albania",
        states: ["Berat County", "Berat District", "Bulqizë District", "Delvinë District", "Devoll District", "Dibër County", "Dibër District", "Durrës County", "Durrës District", "Elbasan County", "Fier County", "Fier District", "Gjirokastër County", "Gjirokastër District", "Gramsh District", "Has District", "Kavajë District", "Kolonjë District", "Korçë County", "Korçë District", "Krujë District", "Kuçovë District", "Kukës County", "Kukës District", "Kurbin District", "Lezhë County", "Lezhë District", "Librazhd District", "Lushnjë District", "Malësi e Madhe District", "Mallakastër District", "Mat District", "Mirditë District", "Peqin District", "Përmet District", "Pogradec District", "Pukë District", "Sarandë District", "Shkodër County", "Shkodër District", "Skrapar District", "Tepelenë District", "Tirana County", "Tirana District", "Tropojë District", "Vlorë County", "Vlorë District"]
    }, {
        name: "Algeria",
        states: ["Adrar", "Aïn Defla", "Aïn Témouchent", "Algiers", "Annaba", "Batna", "Béchar", "Béjaïa", "Béni Abbès", "Biskra", "Blida", "Bordj Baji Mokhtar", "Bordj Bou Arréridj", "Bouïra", "Boumerdès", "Chlef", "Constantine", "Djanet", "Djelfa", "El Bayadh", "El M'ghair", "El Menia", "El Oued", "El Tarf", "Ghardaïa", "Guelma", "Illizi", "In Guezzam", "In Salah", "Jijel", "Khenchela", "Laghouat", "M'Sila", "Mascara", "Médéa", "Mila", "Mostaganem", "Naama", "Oran", "Ouargla", "Ouled Djellal", "Oum El Bouaghi", "Relizane", "Saïda", "Sétif", "Sidi Bel Abbès", "Skikda", "Souk Ahras", "Tamanghasset", "Tébessa", "Tiaret", "Timimoun", "Tindouf", "Tipasa", "Tissemsilt", "Tizi Ouzou", "Tlemcen", "Touggourt"]
    }, {name: "American Samoa", states: []}, {
        name: "Andorra",
        states: ["Andorra la Vella", "Canillo", "Encamp", "Escaldes-Engordany", "La Massana", "Ordino", "Sant Julià de Lòria"]
    }, {
        name: "Angola",
        states: ["Bengo Province", "Benguela Province", "Bié Province", "Cabinda Province", "Cuando Cubango Province", "Cuanza Norte Province", "Cuanza Sul", "Cunene Province", "Huambo Province", "Huíla Province", "Luanda Province", "Lunda Norte Province", "Lunda Sul Province", "Malanje Province", "Moxico Province", "Uíge Province", "Zaire Province"]
    }, {
        name: "Anguilla",
        states: ["Blowing Point", "East End", "George Hill", "Island Harbour", "North Hill", "North Side", "Sandy Ground", "Sandy Hill", "South Hill", "Stoney Ground", "The Farrington", "The Quarter", "The Valley", "West End"]
    }, {name: "Antarctica", states: []}, {
        name: "Antigua and Barbuda",
        states: ["Barbuda", "Redonda", "Saint George Parish", "Saint John Parish", "Saint Mary Parish", "Saint Paul Parish", "Saint Peter Parish", "Saint Philip Parish"]
    }, {
        name: "Argentina",
        states: ["Buenos Aires", "Catamarca", "Chaco", "Chubut", "Ciudad Autónoma de Buenos Aires", "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero", "Tierra del Fuego", "Tucumán"]
    }, {
        name: "Armenia",
        states: ["Aragatsotn Region", "Ararat Province", "Armavir Region", "Gegharkunik Province", "Kotayk Region", "Lori Region", "Shirak Region", "Syunik Province", "Tavush Region", "Vayots Dzor Region", "Yerevan"]
    }, {
        name: "Aruba",
        states: ["Noord", "Oranjestad East", "Oranjestad West", "Paradera", "San Nicolaas Noord", "San Nicolaas Zuid", "Santa Cruz", "Savaneta"]
    }, {
        name: "Australia",
        states: ["Australian Capital Territory", "New South Wales", "Northern Territory", "Queensland", "South Australia", "Tasmania", "Victoria", "Western Australia"]
    }, {
        name: "Austria",
        states: ["Burgenland", "Carinthia", "Lower Austria", "Salzburg", "Styria", "Tyrol", "Upper Austria", "Vienna", "Vorarlberg"]
    }, {
        name: "Azerbaijan",
        states: ["Absheron District", "Agdam District", "Agdash District", "Aghjabadi District", "Agstafa District", "Agsu District", "Astara District", "Babek District", "Baku", "Balakan District", "Barda District", "Beylagan District", "Bilasuvar District", "Dashkasan District", "Fizuli District", "Ganja", "Gədəbəy", "Gobustan District", "Goranboy District", "Goychay", "Goygol District", "Hajigabul District", "Imishli District", "Ismailli District", "Jabrayil District", "Jalilabad District", "Julfa District", "Kalbajar District", "Kangarli District", "Khachmaz District", "Khizi District", "Khojali District", "Kurdamir District", "Lachin District", "Lankaran", "Lankaran District", "Lerik District", "Martuni", "Masally District", "Mingachevir", "Nakhchivan Autonomous Republic", "Neftchala District", "Oghuz District", "Ordubad District", "Qabala District", "Qakh District", "Qazakh District", "Quba District", "Qubadli District", "Qusar District", "Saatly District", "Sabirabad District", "Sadarak District", "Salyan District", "Samukh District", "Shabran District", "Shahbuz District", "Shaki", "Shaki District", "Shamakhi District", "Shamkir District", "Sharur District", "Shirvan", "Shusha District", "Siazan District", "Sumqayit", "Tartar District", "Tovuz District", "Ujar District", "Yardymli District", "Yevlakh", "Yevlakh District", "Zangilan District", "Zaqatala District", "Zardab District"]
    }, {name: "Bahrain", states: ["Capital", "Central", "Muharraq", "Northern", "Southern"]}, {
        name: "Bangladesh",
        states: ["Barisal ", "Chittagong ", "Dhaka ", "Khulna ", "Mymensingh ", "Rajshahi ", "Rangpur ", "Sylhet "]
    }, {
        name: "Barbados",
        states: ["Christ Church", "Saint Andrew", "Saint George", "Saint James", "Saint John", "Saint Joseph", "Saint Lucy", "Saint Michael", "Saint Peter", "Saint Philip", "Saint Thomas"]
    }, {
        name: "Belarus",
        states: ["Brest Region", "Gomel Region", "Grodno Region", "Minsk", "Minsk Region", "Mogilev Region", "Vitebsk Region"]
    }, {
        name: "Belgium",
        states: ["Antwerp", "Brussels-Capital Region", "East Flanders", "Flanders", "Flemish Brabant", "Hainaut", "Liège", "Limburg", "Luxembourg", "Namur", "Wallonia", "Walloon Brabant", "West Flanders"]
    }, {
        name: "Belize",
        states: ["Belize District", "Cayo District", "Corozal District", "Orange Walk District", "Stann Creek District", "Toledo District"]
    }, {
        name: "Benin",
        states: ["Alibori Department", "Atakora Department", "Atlantique Department", "Borgou Department", "Collines Department", "Donga Department", "Kouffo Department", "Littoral Department", "Mono Department", "Ouémé Department", "Plateau Department", "Zou Department"]
    }, {
        name: "Bermuda",
        states: ["Devonshire", "Hamilton", "Paget", "Pembroke", "Saint George's", "Sandys", "Smith's", "Southampton", "Warwick"]
    }, {
        name: "Bhutan",
        states: ["Bumthang ", "Chukha ", "Dagana ", "Gasa ", "Haa ", "Lhuntse ", "Mongar ", "Paro ", "Pemagatshel ", "Punakha ", "Samdrup Jongkhar ", "Samtse ", "Sarpang ", "Thimphu ", "Trashi Yangtse\t", "Trashigang ", "Trongsa ", "Tsirang ", "Wangdue Phodrang ", "Zhemgang "]
    }, {
        name: "Bolivia",
        states: ["Beni Department", "Chuquisaca Department", "Cochabamba Department", "La Paz Department", "Oruro Department", "Pando Department", "Potosí Department", "Santa Cruz Department", "Tarija Department"]
    }, {
        name: "Bonaire, Sint Eustatius and Saba",
        states: ["Bonaire", "Saba", "Sint Eustatius"]
    }, {
        name: "Bosnia and Herzegovina",
        states: ["Bosnian Podrinje Canton", "Brčko District", "Canton 10", "Central Bosnia Canton", "Federation of Bosnia and Herzegovina", "Herzegovina-Neretva Canton", "Posavina Canton", "Republika Srpska", "Sarajevo Canton", "Tuzla Canton", "Una-Sana Canton", "West Herzegovina Canton", "Zenica-Doboj Canton"]
    }, {
        name: "Botswana",
        states: ["Central District", "Ghanzi District", "Kgalagadi District", "Kgatleng District", "Kweneng District", "Ngamiland", "North-East District", "North-West District", "South-East District", "Southern District"]
    }, {name: "Bouvet Island", states: []}, {
        name: "Brazil",
        states: ["Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", "Espírito Santo", "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", "Paraná", "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", "Rondônia", "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"]
    }, {name: "British Indian Ocean Territory", states: []}, {
        name: "Brunei",
        states: ["Belait District", "Brunei-Muara District", "Temburong District", "Tutong District"]
    }, {
        name: "Bulgaria",
        states: ["Blagoevgrad Province", "Burgas Province", "Dobrich Province", "Gabrovo Province", "Haskovo Province", "Kardzhali Province", "Kyustendil Province", "Lovech Province", "Montana Province", "Pazardzhik Province", "Pernik Province", "Pleven Province", "Plovdiv Province", "Razgrad Province", "Ruse Province", "Shumen", "Silistra Province", "Sliven Province", "Smolyan Province", "Sofia City Province", "Sofia Province", "Stara Zagora Province", "Targovishte Province", "Varna Province", "Veliko Tarnovo Province", "Vidin Province", "Vratsa Province", "Yambol Province"]
    }, {
        name: "Burkina Faso",
        states: ["Balé Province", "Bam Province", "Banwa Province", "Bazèga Province", "Boucle du Mouhoun Region", "Bougouriba Province", "Boulgou", "Cascades Region", "Centre", "Centre-Est Region", "Centre-Nord Region", "Centre-Ouest Region", "Centre-Sud Region", "Comoé Province", "Est Region", "Ganzourgou Province", "Gnagna Province", "Gourma Province", "Hauts-Bassins Region", "Houet Province", "Ioba Province", "Kadiogo Province", "Kénédougou Province", "Komondjari Province", "Kompienga Province", "Kossi Province", "Koulpélogo Province", "Kouritenga Province", "Kourwéogo Province", "Léraba Province", "Loroum Province", "Mouhoun", "Nahouri Province", "Namentenga Province", "Nayala Province", "Nord Region, Burkina Faso", "Noumbiel Province", "Oubritenga Province", "Oudalan Province", "Passoré Province", "Plateau-Central Region", "Poni Province", "Sahel Region", "Sanguié Province", "Sanmatenga Province", "Séno Province", "Sissili Province", "Soum Province", "Sourou Province", "Sud-Ouest Region", "Tapoa Province", "Tuy Province", "Yagha Province", "Yatenga Province", "Ziro Province", "Zondoma Province", "Zoundwéogo Province"]
    }, {
        name: "Burundi",
        states: ["Bubanza Province", "Bujumbura Mairie Province", "Bujumbura Rural Province", "Bururi Province", "Cankuzo Province", "Cibitoke Province", "Gitega Province", "Karuzi Province", "Kayanza Province", "Kirundo Province", "Makamba Province", "Muramvya Province", "Muyinga Province", "Mwaro Province", "Ngozi Province", "Rumonge Province", "Rutana Province", "Ruyigi Province"]
    }, {
        name: "Cambodia",
        states: ["Banteay Meanchey", "Battambang", "Kampong Cham", "Kampong Chhnang", "Kampong Speu", "Kampong Thom", "Kampot", "Kandal", "Kep", "Koh Kong", "Kratie", "Mondulkiri", "Oddar Meanchey", "Pailin", "Phnom Penh", "Preah Vihear", "Prey Veng", "Pursat", "Ratanakiri", "Siem Reap", "Sihanoukville", "Stung Treng", "Svay Rieng", "Takeo"]
    }, {
        name: "Cameroon",
        states: ["Adamawa", "Centre", "East", "Far North", "Littoral", "North", "Northwest", "South", "Southwest", "West"]
    }, {
        name: "Cape Verde",
        states: ["Barlavento Islands", "Boa Vista", "Brava", "Maio Municipality", "Mosteiros", "Paul", "Porto Novo", "Praia", "Ribeira Brava Municipality", "Ribeira Grande", "Ribeira Grande de Santiago", "Sal", "Santa Catarina", "Santa Catarina do Fogo", "Santa Cruz", "São Domingos", "São Filipe", "São Lourenço dos Órgãos", "São Miguel", "São Vicente", "Sotavento Islands", "Tarrafal", "Tarrafal de São Nicolau"]
    }, {
        name: "Cayman Islands",
        states: ["Cayman Brac", "Grand Cayman", "Little Cayman"]
    }, {
        name: "Central African Republic",
        states: ["Bamingui-Bangoran Prefecture", "Bangui", "Basse-Kotto Prefecture", "Haut-Mbomou Prefecture", "Haute-Kotto Prefecture", "Kémo Prefecture", "Lobaye Prefecture", "Mambéré-Kadéï", "Mbomou Prefecture", "Nana-Grébizi Economic Prefecture", "Nana-Mambéré Prefecture", "Ombella-M'Poko Prefecture", "Ouaka Prefecture", "Ouham Prefecture", "Ouham-Pendé Prefecture", "Sangha-Mbaéré", "Vakaga Prefecture"]
    }, {
        name: "Chad",
        states: ["Bahr el Gazel", "Batha", "Borkou", "Chari-Baguirmi", "Ennedi-Est", "Ennedi-Ouest", "Guéra", "Hadjer-Lamis", "Kanem", "Lac", "Logone Occidental", "Logone Oriental", "Mandoul", "Mayo-Kebbi Est", "Mayo-Kebbi Ouest", "Moyen-Chari", "N'Djamena", "Ouaddaï", "Salamat", "Sila", "Tandjilé", "Tibesti", "Wadi Fira"]
    }, {
        name: "Chile",
        states: ["Aisén del General Carlos Ibañez del Campo", "Antofagasta", "Arica y Parinacota", "Atacama", "Biobío", "Coquimbo", "La Araucanía", "Libertador General Bernardo O'Higgins", "Los Lagos", "Los Ríos", "Magallanes y de la Antártica Chilena", "Maule", "Ñuble", "Región Metropolitana de Santiago", "Tarapacá", "Valparaíso"]
    }, {
        name: "China",
        states: ["Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong", "Guangxi Zhuang", "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan", "Hong Kong SAR", "Hubei", "Hunan", "Inner Mongolia", "Jiangsu", "Jiangxi", "Jilin", "Liaoning", "Macau SAR", "Ningxia Huizu", "Qinghai", "Shaanxi", "Shandong", "Shanghai", "Shanxi", "Sichuan", "Taiwan", "Tianjin", "Xinjiang", "Xizang", "Yunnan", "Zhejiang"]
    }, {name: "Christmas Island", states: []}, {name: "Cocos (Keeling) Islands", states: []}, {
        name: "Colombia",
        states: ["Amazonas", "Antioquia", "Arauca", "Archipiélago de San Andrés, Providencia y Santa Catalina", "Atlántico", "Bogotá D.C.", "Bolívar", "Boyacá", "Caldas", "Caquetá", "Casanare", "Cauca", "Cesar", "Chocó", "Córdoba", "Cundinamarca", "Guainía", "Guaviare", "Huila", "La Guajira", "Magdalena", "Meta", "Nariño", "Norte de Santander", "Putumayo", "Quindío", "Risaralda", "Santander", "Sucre", "Tolima", "Valle del Cauca", "Vaupés", "Vichada"]
    }, {name: "Comoros", states: ["Anjouan", "Grande Comore", "Mohéli"]}, {
        name: "Congo",
        states: ["Bouenza Department", "Brazzaville", "Cuvette Department", "Cuvette-Ouest Department", "Kouilou Department", "Lékoumou Department", "Likouala Department", "Niari Department", "Plateaux Department", "Pointe-Noire", "Pool Department", "Sangha Department"]
    }, {name: "Cook Islands", states: []}, {
        name: "Costa Rica",
        states: ["Alajuela Province", "Guanacaste Province", "Heredia Province", "Limón Province", "Provincia de Cartago", "Puntarenas Province", "San José Province"]
    }, {
        name: "Cote D'Ivoire (Ivory Coast)",
        states: ["Abidjan", "Agnéby", "Bafing Region", "Bas-Sassandra District", "Bas-Sassandra Region", "Comoé District", "Denguélé District", "Denguélé Region", "Dix-Huit Montagnes", "Fromager", "Gôh-Djiboua District", "Haut-Sassandra", "Lacs District", "Lacs Region", "Lagunes District", "Lagunes region", "Marahoué Region", "Montagnes District", "Moyen-Cavally", "Moyen-Comoé", "N'zi-Comoé", "Sassandra-Marahoué District", "Savanes Region", "Sud-Bandama", "Sud-Comoé", "Vallée du Bandama District", "Vallée du Bandama Region", "Woroba District", "Worodougou", "Yamoussoukro", "Zanzan Region"]
    }, {
        name: "Croatia",
        states: ["Bjelovar-Bilogora", "Brod-Posavina", "Dubrovnik-Neretva", "Istria", "Karlovac", "Koprivnica-Križevci", "Krapina-Zagorje", "Lika-Senj", "Međimurje", "Osijek-Baranja", "Požega-Slavonia", "Primorje-Gorski Kotar", "Šibenik-Knin", "Sisak-Moslavina", "Split-Dalmatia", "Varaždin", "Virovitica-Podravina", "Vukovar-Syrmia", "Zadar", "Zagreb", "Zagreb"]
    }, {
        name: "Cuba",
        states: ["Artemisa Province", "Camagüey Province", "Ciego de Ávila Province", "Cienfuegos Province", "Granma Province", "Guantánamo Province", "Havana Province", "Holguín Province", "Isla de la Juventud", "Las Tunas Province", "Matanzas Province", "Mayabeque Province", "Pinar del Río Province", "Sancti Spíritus Province", "Santiago de Cuba Province", "Villa Clara Province"]
    }, {name: "Curaçao", states: []}, {
        name: "Cyprus",
        states: ["Famagusta District (Mağusa)", "Kyrenia District (Keryneia)", "Larnaca District (Larnaka)", "Limassol District (Leymasun)", "Nicosia District (Lefkoşa)", "Paphos District (Pafos)"]
    }, {
        name: "Czech Republic",
        states: ["Benešov", "Beroun", "Blansko", "Břeclav", "Brno-město", "Brno-venkov", "Bruntál", "Česká Lípa", "České Budějovice", "Český Krumlov", "Cheb", "Chomutov", "Chrudim", "Děčín", "Domažlice", "Frýdek-Místek", "Havlíčkův Brod", "Hodonín", "Hradec Králové", "Jablonec nad Nisou", "Jeseník", "Jičín", "Jihlava", "Jihočeský kraj", "Jihomoravský kraj", "Jindřichův Hradec", "Karlovarský kraj", "Karlovy Vary", "Karviná", "Kladno", "Klatovy", "Kolín", "Kraj Vysočina", "Královéhradecký kraj", "Kroměříž", "Kutná Hora", "Liberec", "Liberecký kraj", "Litoměřice", "Louny", "Mělník", "Mladá Boleslav", "Moravskoslezský kraj", "Most", "Náchod", "Nový Jičín", "Nymburk", "Olomouc", "Olomoucký kraj", "Opava", "Ostrava-město", "Pardubice", "Pardubický kraj", "Pelhřimov", "Písek", "Plzeň-jih", "Plzeň-město", "Plzeň-sever", "Plzeňský kraj", "Prachatice", "Praha-východ", "Praha-západ", "Praha, Hlavní město", "Přerov", "Příbram", "Prostějov", "Rakovník", "Rokycany", "Rychnov nad Kněžnou", "Semily", "Sokolov", "Strakonice", "Středočeský kraj", "Šumperk", "Svitavy", "Tábor", "Tachov", "Teplice", "Třebíč", "Trutnov", "Uherské Hradiště", "Ústecký kraj", "Ústí nad Labem", "Ústí nad Orlicí", "Vsetín", "Vyškov", "Žďár nad Sázavou", "Zlín", "Zlínský kraj", "Znojmo"]
    }, {
        name: "Democratic Republic of the Congo",
        states: ["Bas-Uélé", "Équateur", "Haut-Katanga", "Haut-Lomami", "Haut-Uélé", "Ituri", "Kasaï", "Kasaï Central", "Kasaï Oriental", "Kinshasa", "Kongo Central", "Kwango", "Kwilu", "Lomami", "Lualaba", "Mai-Ndombe", "Maniema", "Mongala", "Nord-Kivu", "Nord-Ubangi", "Sankuru", "Sud-Kivu", "Sud-Ubangi", "Tanganyika", "Tshopo", "Tshuapa"]
    }, {
        name: "Denmark",
        states: ["Capital Region of Denmark", "Central Denmark Region", "North Denmark Region", "Region of Southern Denmark", "Region Zealand"]
    }, {
        name: "Djibouti",
        states: ["Ali Sabieh Region", "Arta Region", "Dikhil Region", "Djibouti", "Obock Region", "Tadjourah Region"]
    }, {
        name: "Dominica",
        states: ["Saint Andrew Parish", "Saint David Parish", "Saint George Parish", "Saint John Parish", "Saint Joseph Parish", "Saint Luke Parish", "Saint Mark Parish", "Saint Patrick Parish", "Saint Paul Parish", "Saint Peter Parish"]
    }, {
        name: "Dominican Republic",
        states: ["Azua Province", "Baoruco Province", "Barahona Province", "Dajabón Province", "Distrito Nacional", "Duarte Province", "El Seibo Province", "Espaillat Province", "Hato Mayor Province", "Hermanas Mirabal Province", "Independencia", "La Altagracia Province", "La Romana Province", "La Vega Province", "María Trinidad Sánchez Province", "Monseñor Nouel Province", "Monte Cristi Province", "Monte Plata Province", "Pedernales Province", "Peravia Province", "Puerto Plata Province", "Samaná Province", "San Cristóbal Province", "San José de Ocoa Province", "San Juan Province", "San Pedro de Macorís", "Sánchez Ramírez Province", "Santiago Province", "Santiago Rodríguez Province", "Santo Domingo Province", "Valverde Province"]
    }, {
        name: "Ecuador",
        states: ["Azuay", "Bolívar", "Cañar", "Carchi", "Chimborazo", "Cotopaxi", "El Oro", "Esmeraldas", "Galápagos", "Guayas", "Imbabura", "Loja", "Los Ríos", "Manabí", "Morona-Santiago", "Napo", "Orellana", "Pastaza", "Pichincha", "Santa Elena", "Santo Domingo de los Tsáchilas", "Sucumbíos", "Tungurahua", "Zamora Chinchipe"]
    }, {
        name: "Egypt",
        states: ["Alexandria", "Aswan", "Asyut", "Beheira", "Beni Suef", "Cairo", "Dakahlia", "Damietta", "Faiyum", "Gharbia", "Giza", "Ismailia", "Kafr el-Sheikh", "Luxor", "Matrouh", "Minya", "Monufia", "New Valley", "North Sinai", "Port Said", "Qalyubia", "Qena", "Red Sea", "Sharqia", "Sohag", "South Sinai", "Suez"]
    }, {
        name: "El Salvador",
        states: ["Ahuachapán Department", "Cabañas Department", "Chalatenango Department", "Cuscatlán Department", "La Libertad Department", "La Paz Department", "La Unión Department", "Morazán Department", "San Miguel Department", "San Salvador Department", "San Vicente Department", "Santa Ana Department", "Sonsonate Department", "Usulután Department"]
    }, {
        name: "Equatorial Guinea",
        states: ["Annobón Province", "Bioko Norte Province", "Bioko Sur Province", "Centro Sur Province", "Insular Region", "Kié-Ntem Province", "Litoral Province", "Río Muni", "Wele-Nzas Province"]
    }, {
        name: "Eritrea",
        states: ["Anseba Region", "Debub Region", "Gash-Barka Region", "Maekel Region", "Northern Red Sea Region", "Southern Red Sea Region"]
    }, {
        name: "Estonia",
        states: ["Harju County", "Hiiu County", "Ida-Viru County", "Järva County", "Jõgeva County", "Lääne County", "Lääne-Viru County", "Pärnu County", "Põlva County", "Rapla County", "Saare County", "Tartu County", "Valga County", "Viljandi County", "Võru County"]
    }, {
        name: "Eswatini",
        states: ["Hhohho District", "Lubombo District", "Manzini District", "Shiselweni District"]
    }, {
        name: "Ethiopia",
        states: ["Addis Ababa", "Afar Region", "Amhara Region", "Benishangul-Gumuz Region", "Dire Dawa", "Gambela Region", "Harari Region", "Oromia Region", "Somali Region", "Southern Nations, Nationalities, and Peoples' Region", "Tigray Region"]
    }, {name: "Falkland Islands", states: []}, {
        name: "Faroe Islands",
        states: ["Eysturoy", "Northern Isles", "Sandoy", "Streymoy", "Suðuroy", "Vágar"]
    }, {
        name: "Fiji Islands",
        states: ["Ba", "Bua", "Cakaudrove", "Central Division", "Eastern Division", "Kadavu", "Lau", "Lomaiviti", "Macuata", "Nadroga-Navosa", "Naitasiri", "Namosi", "Northern Division", "Ra", "Rewa", "Rotuma", "Serua", "Tailevu", "Western Division"]
    }, {
        name: "Finland",
        states: ["Åland Islands", "Central Finland", "Central Ostrobothnia", "Finland Proper", "Kainuu", "Kymenlaakso", "Lapland", "North Karelia", "Northern Ostrobothnia", "Northern Savonia", "Ostrobothnia", "Päijänne Tavastia", "Pirkanmaa", "Satakunta", "South Karelia", "Southern Ostrobothnia", "Southern Savonia", "Tavastia Proper", "Uusimaa"]
    }, {
        name: "France",
        states: ["Ain", "Aisne", "Allier", "Alpes-de-Haute-Provence", "Alpes-Maritimes", "Alsace", "Ardèche", "Ardennes", "Ariège", "Aube", "Aude", "Auvergne-Rhône-Alpes", "Aveyron", "Bas-Rhin", "Bouches-du-Rhône", "Bourgogne-Franche-Comté", "Bretagne", "Calvados", "Cantal", "Centre-Val de Loire", "Charente", "Charente-Maritime", "Cher", "Clipperton", "Corrèze", "Corse", "Corse-du-Sud", "Côte-d'Or", "Côtes-d'Armor", "Creuse", "Deux-Sèvres", "Dordogne", "Doubs", "Drôme", "Essonne", "Eure", "Eure-et-Loir", "Finistère", "French Guiana", "French Polynesia", "French Southern and Antarctic Lands", "Gard", "Gers", "Gironde", "Grand-Est", "Guadeloupe", "Haut-Rhin", "Haute-Corse", "Haute-Garonne", "Haute-Loire", "Haute-Marne", "Haute-Saône", "Haute-Savoie", "Haute-Vienne", "Hautes-Alpes", "Hautes-Pyrénées", "Hauts-de-France", "Hauts-de-Seine", "Hérault", "Île-de-France", "Ille-et-Vilaine", "Indre", "Indre-et-Loire", "Isère", "Jura", "La Réunion", "Landes", "Loir-et-Cher", "Loire", "Loire-Atlantique", "Loiret", "Lot", "Lot-et-Garonne", "Lozère", "Maine-et-Loire", "Manche", "Marne", "Martinique", "Mayenne", "Mayotte", "Métropole de Lyon", "Meurthe-et-Moselle", "Meuse", "Morbihan", "Moselle", "Nièvre", "Nord", "Normandie", "Nouvelle-Aquitaine", "Occitanie", "Oise", "Orne", "Paris", "Pas-de-Calais", "Pays-de-la-Loire", "Provence-Alpes-Côte-d’Azur", "Puy-de-Dôme", "Pyrénées-Atlantiques", "Pyrénées-Orientales", "Rhône", "Saint Pierre and Miquelon", "Saint-Barthélemy", "Saint-Martin", "Saône-et-Loire", "Sarthe", "Savoie", "Seine-et-Marne", "Seine-Maritime", "Seine-Saint-Denis", "Somme", "Tarn", "Tarn-et-Garonne", "Territoire de Belfort", "Val-d'Oise", "Val-de-Marne", "Var", "Vaucluse", "Vendée", "Vienne", "Vosges", "Wallis and Futuna", "Yonne", "Yvelines"]
    }, {name: "French Guiana", states: []}, {
        name: "French Polynesia",
        states: []
    }, {name: "French Southern Territories", states: []}, {
        name: "Gabon",
        states: ["Estuaire Province", "Haut-Ogooué Province", "Moyen-Ogooué Province", "Ngounié Province", "Nyanga Province", "Ogooué-Ivindo Province", "Ogooué-Lolo Province", "Ogooué-Maritime Province", "Woleu-Ntem Province"]
    }, {
        name: "Georgia",
        states: ["Abkhazia", "Adjara", "Guria", "Imereti", "Kakheti", "Khelvachauri Municipality", "Kvemo Kartli", "Mtskheta-Mtianeti", "Racha-Lechkhumi and Kvemo Svaneti", "Samegrelo-Zemo Svaneti", "Samtskhe-Javakheti", "Senaki Municipality", "Shida Kartli", "Tbilisi"]
    }, {
        name: "Germany",
        states: ["Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen", "Hamburg", "Hessen", "Lower Saxony", "Mecklenburg-Vorpommern", "North Rhine-Westphalia", "Rhineland-Palatinate", "Saarland", "Saxony", "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia"]
    }, {
        name: "Ghana",
        states: ["Ahafo", "Ashanti", "Bono", "Bono East", "Central", "Eastern", "Greater Accra", "North East", "Northern", "Oti", "Savannah", "Upper East", "Upper West", "Volta", "Western", "Western North"]
    }, {name: "Gibraltar", states: []}, {
        name: "Greece",
        states: ["Achaea Regional Unit", "Aetolia-Acarnania Regional Unit", "Arcadia Prefecture", "Argolis Regional Unit", "Attica Region", "Boeotia Regional Unit", "Central Greece Region", "Central Macedonia", "Chania Regional Unit", "Corfu Prefecture", "Corinthia Regional Unit", "Crete Region", "Drama Regional Unit", "East Attica Regional Unit", "East Macedonia and Thrace", "Epirus Region", "Euboea", "Grevena Prefecture", "Imathia Regional Unit", "Ioannina Regional Unit", "Ionian Islands Region", "Karditsa Regional Unit", "Kastoria Regional Unit", "Kefalonia Prefecture", "Kilkis Regional Unit", "Kozani Prefecture", "Laconia", "Larissa Prefecture", "Lefkada Regional Unit", "Pella Regional Unit", "Peloponnese Region", "Phthiotis Prefecture", "Preveza Prefecture", "Serres Prefecture", "South Aegean", "Thessaloniki Regional Unit", "West Greece Region", "West Macedonia Region"]
    }, {name: "Greenland", states: []}, {
        name: "Grenada",
        states: ["Carriacou and Petite Martinique", "Saint Andrew Parish", "Saint David Parish", "Saint George Parish", "Saint John Parish", "Saint Mark Parish", "Saint Patrick Parish"]
    }, {name: "Guadeloupe", states: []}, {
        name: "Guam",
        states: ["Agana Heights", "Asan-Maina", "Barrigada", "Chalan Pago-Ordot", "Dededo", "Hågat", "Hagåtña", "Inarajan (Inalåhan)", "Mangilao", "Merizo (Malesso)", "Mongmong-Toto-Maite", "Piti", "Santa Rita (Sånta Rita-Sumai)", "Sinajana", "Talofofo (Talo'fo'fo)", "Tamuning", "Umatac (Humåtak)", "Yigo", "Yona"]
    }, {
        name: "Guatemala",
        states: ["Alta Verapaz ", "Baja Verapaz ", "Chimaltenango ", "Chiquimula ", "El Progreso ", "Escuintla ", "Guatemala ", "Huehuetenango ", "Izabal ", "Jalapa ", "Jutiapa ", "Petén ", "Quetzaltenango ", "Quiché ", "Retalhuleu ", "Sacatepéquez ", "San Marcos ", "Santa Rosa ", "Sololá ", "Suchitepéquez ", "Totonicapán ", "Zacapa"]
    }, {name: "Guernsey and Alderney", states: []}, {
        name: "Guinea",
        states: ["Beyla Prefecture", "Boffa Prefecture", "Boké Prefecture", "Boké Region", "Conakry", "Coyah Prefecture", "Dabola Prefecture", "Dalaba Prefecture", "Dinguiraye Prefecture", "Dubréka Prefecture", "Faranah Prefecture", "Forécariah Prefecture", "Fria Prefecture", "Gaoual Prefecture", "Guéckédou Prefecture", "Kankan Prefecture", "Kankan Region", "Kérouané Prefecture", "Kindia Prefecture", "Kindia Region", "Kissidougou Prefecture", "Koubia Prefecture", "Koundara Prefecture", "Kouroussa Prefecture", "Labé Prefecture", "Labé Region", "Lélouma Prefecture", "Lola Prefecture", "Macenta Prefecture", "Mali Prefecture", "Mamou Prefecture", "Mamou Region", "Mandiana Prefecture", "Nzérékoré Prefecture", "Nzérékoré Region", "Pita Prefecture", "Siguiri Prefecture", "Télimélé Prefecture", "Tougué Prefecture", "Yomou Prefecture"]
    }, {
        name: "Guinea-Bissau",
        states: ["Bafatá", "Biombo Region", "Bolama Region", "Cacheu Region", "Gabú Region", "Leste Province", "Norte Province", "Oio Region", "Quinara Region", "Sul Province", "Tombali Region"]
    }, {
        name: "Guyana",
        states: ["Barima-Waini", "Cuyuni-Mazaruni", "Demerara-Mahaica", "East Berbice-Corentyne", "Essequibo Islands-West Demerara", "Mahaica-Berbice", "Pomeroon-Supenaam", "Potaro-Siparuni", "Upper Demerara-Berbice", "Upper Takutu-Upper Essequibo"]
    }, {
        name: "Haiti",
        states: ["Artibonite", "Centre", "Grand'Anse", "Nippes", "Nord", "Nord-Est", "Nord-Ouest", "Ouest", "Sud", "Sud-Est"]
    }, {name: "Heard Island and McDonald Islands", states: []}, {
        name: "Honduras",
        states: ["Atlántida Department", "Bay Islands Department", "Choluteca Department", "Colón Department", "Comayagua Department", "Copán Department", "Cortés Department", "El Paraíso Department", "Francisco Morazán Department", "Gracias a Dios Department", "Intibucá Department", "La Paz Department", "Lempira Department", "Ocotepeque Department", "Olancho Department", "Santa Bárbara Department", "Valle Department", "Yoro Department"]
    }, {
        name: "Hong Kong S.A.R.",
        states: ["Central and Western", "Eastern", "Islands", "Kowloon City", "Kwai Tsing", "Kwun Tong", "North", "Sai Kung", "Sha Tin", "Sham Shui Po", "Southern", "Tai Po", "Tsuen Wan", "Tuen Mun", "Wan Chai", "Wong Tai Sin", "Yau Tsim Mong", "Yuen Long"]
    }, {
        name: "Hungary",
        states: ["Bács-Kiskun", "Baranya", "Békés", "Békéscsaba", "Borsod-Abaúj-Zemplén", "Budapest", "Csongrád County", "Debrecen", "Dunaújváros", "Eger", "Érd", "Fejér County", "Győr", "Győr-Moson-Sopron County", "Hajdú-Bihar County", "Heves County", "Hódmezővásárhely", "Jász-Nagykun-Szolnok County", "Kaposvár", "Kecskemét", "Komárom-Esztergom", "Miskolc", "Nagykanizsa", "Nógrád County", "Nyíregyháza", "Pécs", "Pest County", "Salgótarján", "Somogy County", "Sopron", "Szabolcs-Szatmár-Bereg County", "Szeged", "Székesfehérvár", "Szekszárd", "Szolnok", "Szombathely", "Tatabánya", "Tolna County", "Vas County", "Veszprém", "Veszprém County", "Zala County", "Zalaegerszeg"]
    }, {
        name: "Iceland",
        states: ["Capital Region", "Eastern Region", "Northeastern Region", "Northwestern Region", "Southern Peninsula Region", "Southern Region", "Western Region", "Westfjords"]
    }, {
        name: "India",
        states: ["Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"]
    }, {
        name: "Indonesia",
        states: ["Aceh", "Bali", "Banten", "Bengkulu", "DI Yogyakarta", "DKI Jakarta", "Gorontalo", "Jambi", "Jawa Barat", "Jawa Tengah", "Jawa Timur", "Kalimantan Barat", "Kalimantan Selatan", "Kalimantan Tengah", "Kalimantan Timur", "Kalimantan Utara", "Kepulauan Bangka Belitung", "Kepulauan Riau", "Lampung", "Maluku", "Maluku Utara", "Nusa Tenggara Barat", "Nusa Tenggara Timur", "Papua", "Papua Barat", "Papua Barat Daya", "Papua Pegunungan", "Papua Selatan", "Papua Tengah", "Riau", "Sulawesi Barat", "Sulawesi Selatan", "Sulawesi Tengah", "Sulawesi Tenggara", "Sulawesi Utara", "Sumatera Barat", "Sumatera Selatan", "Sumatera Utara"]
    }, {
        name: "Iran",
        states: ["Alborz", "Ardabil", "Bushehr", "Chaharmahal and Bakhtiari", "East Azerbaijan", "Fars", "Gilan", "Golestan", "Hamadan", "Hormozgan", "Ilam", "Isfahan", "Kerman", "Kermanshah", "Khuzestan", "Kohgiluyeh and Boyer-Ahmad", "Kurdistan", "Lorestan", "Markazi", "Mazandaran", "North Khorasan", "Qazvin", "Qom", "Razavi Khorasan", "Semnan", "Sistan and Baluchestan", "South Khorasan", "Tehran", "West Azarbaijan", "Yazd", "Zanjan"]
    }, {
        name: "Iraq",
        states: ["Al Anbar", "Al Muthanna", "Al-Qādisiyyah", "Babylon", "Baghdad", "Basra", "Dhi Qar", "Diyala", "Dohuk", "Erbil", "Karbala", "Kirkuk", "Maysan", "Najaf", "Nineveh", "Saladin", "Sulaymaniyah", "Wasit"]
    }, {
        name: "Ireland",
        states: ["Carlow", "Cavan", "Clare", "Connacht", "Cork", "Donegal", "Dublin", "Galway", "Kerry", "Kildare", "Kilkenny", "Laois", "Leinster", "Limerick", "Longford", "Louth", "Mayo", "Meath", "Monaghan", "Munster", "Offaly", "Roscommon", "Sligo", "Tipperary", "Ulster", "Waterford", "Westmeath", "Wexford", "Wicklow"]
    }, {
        name: "Israel",
        states: ["Central District", "Haifa District", "Jerusalem District", "Northern District", "Southern District", "Tel Aviv District"]
    }, {
        name: "Italy",
        states: ["Abruzzo", "Agrigento", "Alessandria", "Ancona", "Aosta Valley", "Apulia", "Ascoli Piceno", "Asti", "Avellino", "Barletta-Andria-Trani", "Basilicata", "Belluno", "Benevento", "Bergamo", "Biella", "Brescia", "Brindisi", "Calabria", "Caltanissetta", "Campania", "Campobasso", "Caserta", "Catanzaro", "Chieti", "Como", "Cosenza", "Cremona", "Crotone", "Cuneo", "Emilia-Romagna", "Enna", "Fermo", "Ferrara", "Foggia", "Forlì-Cesena", "Friuli–Venezia Giulia", "Frosinone", "Gorizia", "Grosseto", "Imperia", "Isernia", "L'Aquila", "La Spezia", "Latina", "Lazio", "Lecce", "Lecco", "Liguria", "Livorno", "Lodi", "Lombardy", "Lucca", "Macerata", "Mantua", "Marche", "Massa and Carrara", "Matera", "Medio Campidano", "Modena", "Molise", "Monza and Brianza", "Novara", "Nuoro", "Oristano", "Padua", "Palermo", "Parma", "Pavia", "Perugia", "Pesaro and Urbino", "Pescara", "Piacenza", "Piedmont", "Pisa", "Pistoia", "Pordenone", "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Emilia", "Rieti", "Rimini", "Rovigo", "Salerno", "Sardinia", "Sassari", "Savona", "Sicily", "Siena", "Siracusa", "Sondrio", "South Sardinia", "Taranto", "Teramo", "Terni", "Trapani", "Trentino-South Tyrol", "Treviso", "Trieste", "Tuscany", "Udine", "Umbria", "Varese", "Veneto", "Verbano-Cusio-Ossola", "Vercelli", "Verona", "Vibo Valentia", "Vicenza", "Viterbo"]
    }, {
        name: "Jamaica",
        states: ["Clarendon Parish", "Hanover Parish", "Kingston Parish", "Manchester Parish", "Portland Parish", "Saint Andrew", "Saint Ann Parish", "Saint Catherine Parish", "Saint Elizabeth Parish", "Saint James Parish", "Saint Mary Parish", "Saint Thomas Parish", "Trelawny Parish", "Westmoreland Parish"]
    }, {
        name: "Japan",
        states: ["Aichi Prefecture", "Akita Prefecture", "Aomori Prefecture", "Chiba Prefecture", "Ehime Prefecture", "Fukui Prefecture", "Fukuoka Prefecture", "Fukushima Prefecture", "Gifu Prefecture", "Gunma Prefecture", "Hiroshima Prefecture", "Hokkaidō Prefecture", "Hyōgo Prefecture", "Ibaraki Prefecture", "Ishikawa Prefecture", "Iwate Prefecture", "Kagawa Prefecture", "Kagoshima Prefecture", "Kanagawa Prefecture", "Kōchi Prefecture", "Kumamoto Prefecture", "Kyōto Prefecture", "Mie Prefecture", "Miyagi Prefecture", "Miyazaki Prefecture", "Nagano Prefecture", "Nagasaki Prefecture", "Nara Prefecture", "Niigata Prefecture", "Ōita Prefecture", "Okayama Prefecture", "Okinawa Prefecture", "Ōsaka Prefecture", "Saga Prefecture", "Saitama Prefecture", "Shiga Prefecture", "Shimane Prefecture", "Shizuoka Prefecture", "Tochigi Prefecture", "Tokushima Prefecture", "Tokyo", "Tottori Prefecture", "Toyama Prefecture", "Wakayama Prefecture", "Yamagata Prefecture", "Yamaguchi Prefecture", "Yamanashi Prefecture"]
    }, {
        name: "Jersey",
        states: ["Grouville", "St Brelade", "St Clement", "St Helier", "St John", "St Lawrence", "St Martin", "St Mary", "St Ouen", "St Peter", "St Saviour", "Trinity"]
    }, {
        name: "Jordan",
        states: ["Ajloun", "Amman", "Aqaba", "Balqa", "Irbid", "Jerash", "Karak", "Ma'an", "Madaba", "Mafraq", "Tafilah", "Zarqa"]
    }, {
        name: "Kazakhstan",
        states: ["Akmola Region", "Aktobe Region", "Almaty", "Almaty Region", "Atyrau Region", "Baikonur", "East Kazakhstan Region", "Jambyl Region", "Karaganda Region", "Kostanay Region", "Kyzylorda Region", "Mangystau Region", "North Kazakhstan Region", "Nur-Sultan", "Pavlodar Region", "Turkestan Region", "West Kazakhstan Province"]
    }, {
        name: "Kenya",
        states: ["Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo-Marakwet", "Embu", "Garissa", "Homa Bay", "Isiolo", "Kajiado", "Kakamega", "Kericho", "Kiambu", "Kilifi", "Kirinyaga", "Kisii", "Kisumu", "Kitui", "Kwale", "Laikipia", "Lamu", "Machakos", "Makueni", "Mandera", "Marsabit", "Meru", "Migori", "Mombasa", "Murang'a", "Nairobi City", "Nakuru", "Nandi", "Narok", "Nyamira", "Nyandarua", "Nyeri", "Samburu", "Siaya", "Taita–Taveta", "Tana River", "Tharaka-Nithi", "Trans Nzoia", "Turkana", "Uasin Gishu", "Vihiga", "Wajir", "West Pokot"]
    }, {name: "Kiribati", states: ["Gilbert Islands", "Line Islands", "Phoenix Islands"]}, {
        name: "Kosovo",
        states: ["Đakovica District (Gjakove)", "Gjilan District", "Kosovska Mitrovica District", "Peć District", "Pristina (Priştine)", "Prizren District", "Uroševac District (Ferizaj)"]
    }, {
        name: "Kuwait",
        states: ["Al Ahmadi", "Al Farwaniyah", "Al Jahra", "Capital", "Hawalli", "Mubarak Al-Kabeer"]
    }, {
        name: "Kyrgyzstan",
        states: ["Batken Region", "Bishkek", "Chuy Region", "Issyk-Kul Region", "Jalal-Abad Region", "Naryn Region", "Osh", "Osh Region", "Talas Region"]
    }, {
        name: "Laos",
        states: ["Attapeu Province", "Bokeo Province", "Bolikhamsai Province", "Champasak Province", "Houaphanh Province", "Khammouane Province", "Luang Namtha Province", "Luang Prabang Province", "Oudomxay Province", "Phongsaly Province", "Sainyabuli Province", "Salavan Province", "Savannakhet Province", "Sekong Province", "Vientiane Prefecture", "Vientiane Province", "Xaisomboun", "Xaisomboun Province", "Xiangkhouang Province"]
    }, {
        name: "Latvia",
        states: ["Aglona Municipality", "Aizkraukle Municipality", "Aizpute Municipality", "Aknīste Municipality", "Aloja Municipality", "Alsunga Municipality", "Alūksne Municipality", "Amata Municipality", "Ape Municipality", "Auce Municipality", "Babīte Municipality", "Baldone Municipality", "Baltinava Municipality", "Balvi Municipality", "Bauska Municipality", "Beverīna Municipality", "Brocēni Municipality", "Burtnieki Municipality", "Carnikava Municipality", "Cēsis Municipality", "Cesvaine Municipality", "Cibla Municipality", "Dagda Municipality", "Daugavpils", "Daugavpils Municipality", "Dobele Municipality", "Dundaga Municipality", "Durbe Municipality", "Engure Municipality", "Ērgļi Municipality", "Garkalne Municipality", "Grobiņa Municipality", "Gulbene Municipality", "Iecava Municipality", "Ikšķile Municipality", "Ilūkste Municipality", "Inčukalns Municipality", "Jaunjelgava Municipality", "Jaunpiebalga Municipality", "Jaunpils Municipality", "Jēkabpils", "Jēkabpils Municipality", "Jelgava", "Jelgava Municipality", "Jūrmala", "Kandava Municipality", "Kārsava Municipality", "Ķegums Municipality", "Ķekava Municipality", "Kocēni Municipality", "Koknese Municipality", "Krāslava Municipality", "Krimulda Municipality", "Krustpils Municipality", "Kuldīga Municipality", "Lielvārde Municipality", "Liepāja", "Līgatne Municipality", "Limbaži Municipality", "Līvāni Municipality", "Lubāna Municipality", "Ludza Municipality", "Madona Municipality", "Mālpils Municipality", "Mārupe Municipality", "Mazsalaca Municipality", "Mērsrags Municipality", "Naukšēni Municipality", "Nereta Municipality", "Nīca Municipality", "Ogre Municipality", "Olaine Municipality", "Ozolnieki Municipality", "Pārgauja Municipality", "Pāvilosta Municipality", "Pļaviņas Municipality", "Preiļi Municipality", "Priekule Municipality", "Priekuļi Municipality", "Rauna Municipality", "Rēzekne", "Rēzekne Municipality", "Riebiņi Municipality", "Riga", "Roja Municipality", "Ropaži Municipality", "Rucava Municipality", "Rugāji Municipality", "Rūjiena Municipality", "Rundāle Municipality", "Sala Municipality", "Salacgrīva Municipality", "Salaspils Municipality", "Saldus Municipality", "Saulkrasti Municipality", "Sēja Municipality", "Sigulda Municipality", "Skrīveri Municipality", "Skrunda Municipality", "Smiltene Municipality", "Stopiņi Municipality", "Strenči Municipality", "Talsi Municipality", "Tērvete Municipality", "Tukums Municipality", "Vaiņode Municipality", "Valka Municipality", "Valmiera", "Varakļāni Municipality", "Vārkava Municipality", "Vecpiebalga Municipality", "Vecumnieki Municipality", "Ventspils", "Ventspils Municipality", "Viesīte Municipality", "Viļaka Municipality", "Viļāni Municipality", "Zilupe Municipality"]
    }, {
        name: "Lebanon",
        states: ["Akkar", "Baalbek-Hermel", "Beirut", "Beqaa", "Mount Lebanon", "Nabatieh", "North", "South"]
    }, {
        name: "Lesotho",
        states: ["Berea District", "Butha-Buthe District", "Leribe District", "Mafeteng District", "Maseru District", "Mohale's Hoek District", "Mokhotlong District", "Qacha's Nek District", "Quthing District", "Thaba-Tseka District"]
    }, {
        name: "Liberia",
        states: ["Bomi County", "Bong County", "Gbarpolu County", "Grand Bassa County", "Grand Cape Mount County", "Grand Gedeh County", "Grand Kru County", "Lofa County", "Margibi County", "Maryland County", "Montserrado County", "Nimba", "River Cess County", "River Gee County", "Sinoe County"]
    }, {
        name: "Libya",
        states: ["Al Wahat District", "Benghazi", "Derna District", "Ghat District", "Jabal al Akhdar", "Jabal al Gharbi District", "Jafara", "Jufra", "Kufra District", "Marj District", "Misrata District", "Murqub", "Murzuq District", "Nalut District", "Nuqat al Khams", "Sabha District", "Sirte District", "Tripoli District", "Wadi al Hayaa District", "Wadi al Shatii District", "Zawiya District"]
    }, {
        name: "Liechtenstein",
        states: ["Balzers", "Eschen", "Gamprin", "Mauren", "Planken", "Ruggell", "Schaan", "Schellenberg", "Triesen", "Triesenberg", "Vaduz"]
    }, {
        name: "Lithuania",
        states: ["Akmenė District Municipality", "Alytus City Municipality", "Alytus County", "Alytus District Municipality", "Birštonas Municipality", "Biržai District Municipality", "Druskininkai municipality", "Elektrėnai municipality", "Ignalina District Municipality", "Jonava District Municipality", "Joniškis District Municipality", "Jurbarkas District Municipality", "Kaišiadorys District Municipality", "Kalvarija municipality", "Kaunas City Municipality", "Kaunas County", "Kaunas District Municipality", "Kazlų Rūda municipality", "Kėdainiai District Municipality", "Kelmė District Municipality", "Klaipeda City Municipality", "Klaipėda County", "Klaipėda District Municipality", "Kretinga District Municipality", "Kupiškis District Municipality", "Lazdijai District Municipality", "Marijampolė County", "Marijampolė Municipality", "Mažeikiai District Municipality", "Molėtai District Municipality", "Neringa Municipality", "Pagėgiai municipality", "Pakruojis District Municipality", "Palanga City Municipality", "Panevėžys City Municipality", "Panevėžys County", "Panevėžys District Municipality", "Pasvalys District Municipality", "Plungė District Municipality", "Prienai District Municipality", "Radviliškis District Municipality", "Raseiniai District Municipality", "Rietavas municipality", "Rokiškis District Municipality", "Šakiai District Municipality", "Šalčininkai District Municipality", "Šiauliai City Municipality", "Šiauliai County", "Šiauliai District Municipality", "Šilalė District Municipality", "Šilutė District Municipality", "Širvintos District Municipality", "Skuodas District Municipality", "Švenčionys District Municipality", "Tauragė County", "Tauragė District Municipality", "Telšiai County", "Telšiai District Municipality", "Trakai District Municipality", "Ukmergė District Municipality", "Utena County", "Utena District Municipality", "Varėna District Municipality", "Vilkaviškis District Municipality", "Vilnius City Municipality", "Vilnius County", "Vilnius District Municipality", "Visaginas Municipality", "Zarasai District Municipality"]
    }, {
        name: "Luxembourg",
        states: ["Canton of Capellen", "Canton of Clervaux", "Canton of Diekirch", "Canton of Echternach", "Canton of Esch-sur-Alzette", "Canton of Grevenmacher", "Canton of Luxembourg", "Canton of Mersch", "Canton of Redange", "Canton of Remich", "Canton of Vianden", "Canton of Wiltz", "Diekirch District", "Grevenmacher District", "Luxembourg District"]
    }, {name: "Macau S.A.R.", states: []}, {
        name: "Madagascar",
        states: ["Antananarivo Province", "Antsiranana Province", "Fianarantsoa Province", "Mahajanga Province", "Toamasina Province", "Toliara Province"]
    }, {
        name: "Malawi",
        states: ["Balaka District", "Blantyre District", "Central Region", "Chikwawa District", "Chiradzulu District", "Chitipa district", "Dedza District", "Dowa District", "Karonga District", "Kasungu District", "Likoma District", "Lilongwe District", "Machinga District", "Mangochi District", "Mchinji District", "Mulanje District", "Mwanza District", "Mzimba District", "Nkhata Bay District", "Nkhotakota District", "Northern Region", "Nsanje District", "Ntcheu District", "Ntchisi District", "Phalombe District", "Rumphi District", "Salima District", "Southern Region", "Thyolo District", "Zomba District"]
    }, {
        name: "Malaysia",
        states: ["Johor", "Kedah", "Kelantan", "Kuala Lumpur", "Labuan", "Malacca", "Negeri Sembilan", "Pahang", "Penang", "Perak", "Perlis", "Putrajaya", "Sabah", "Sarawak", "Selangor", "Terengganu"]
    }, {
        name: "Maldives",
        states: ["Addu Atoll", "Alif Alif Atoll", "Alif Dhaal Atoll", "Central Province", "Dhaalu Atoll", "Faafu Atoll", "Gaafu Alif Atoll", "Gaafu Dhaalu Atoll", "Gnaviyani Atoll", "Haa Alif Atoll", "Haa Dhaalu Atoll", "Kaafu Atoll", "Laamu Atoll", "Lhaviyani Atoll", "Malé", "Meemu Atoll", "Noonu Atoll", "North Central Province", "North Province", "Raa Atoll", "Shaviyani Atoll", "South Central Province", "South Province", "Thaa Atoll", "Upper South Province", "Vaavu Atoll"]
    }, {
        name: "Mali",
        states: ["Bamako", "Gao Region", "Kayes Region", "Kidal Region", "Koulikoro Region", "Ménaka Region", "Mopti Region", "Ségou Region", "Sikasso Region", "Taoudénit Region", "Tombouctou Region"]
    }, {
        name: "Malta",
        states: ["Attard", "Balzan", "Birgu", "Birkirkara", "Birżebbuġa", "Cospicua", "Dingli", "Fgura", "Floriana", "Fontana", "Għajnsielem", "Għarb", "Għargħur", "Għasri", "Għaxaq", "Gudja", "Gżira", "Ħamrun", "Iklin", "Kalkara", "Kerċem", "Kirkop", "Lija", "Luqa", "Marsa", "Marsaskala", "Marsaxlokk", "Mdina", "Mellieħa", "Mġarr", "Mosta", "Mqabba", "Msida", "Mtarfa", "Munxar", "Nadur", "Naxxar", "Paola", "Pembroke", "Pietà", "Qala", "Qormi", "Qrendi", "Rabat", "San Ġwann", "San Lawrenz", "Sannat", "Santa Luċija", "Santa Venera", "Senglea", "Siġġiewi", "Sliema", "St. Julian's", "St. Paul's Bay", "Swieqi", "Ta' Xbiex", "Tarxien", "Valletta", "Victoria", "Xagħra", "Xewkija", "Xgħajra", "Żabbar", "Żebbuġ Gozo", "Żebbuġ Malta", "Żejtun", "Żurrieq"]
    }, {
        name: "Man (Isle of)",
        states: ["Ayre", "Garff", "Glenfaba", "Michael", "Middle", "Rushen"]
    }, {name: "Marshall Islands", states: ["Ralik Chain", "Ratak Chain"]}, {
        name: "Martinique",
        states: []
    }, {
        name: "Mauritania",
        states: ["Adrar", "Assaba", "Brakna", "Dakhlet Nouadhibou", "Gorgol", "Guidimaka", "Hodh Ech Chargui", "Hodh El Gharbi", "Inchiri", "Nouakchott-Nord", "Nouakchott-Ouest", "Nouakchott-Sud", "Tagant", "Tiris Zemmour", "Trarza"]
    }, {
        name: "Mauritius",
        states: ["Agalega Islands", "Black River", "Flacq", "Grand Port", "Moka", "Pamplemousses", "Plaines Wilhems", "Port Louis", "Rivière du Rempart", "Rodrigues Island", "Saint Brandon Islands", "Savanne"]
    }, {name: "Mayotte", states: []}, {
        name: "Mexico",
        states: ["Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "Ciudad de México", "Coahuila de Zaragoza", "Colima", "Durango", "Estado de México", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán de Ocampo", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz de Ignacio de la Llave", "Yucatán", "Zacatecas"]
    }, {name: "Micronesia", states: ["Chuuk State", "Kosrae State", "Pohnpei State", "Yap State"]}, {
        name: "Moldova",
        states: ["Anenii Noi District", "Bălți Municipality", "Basarabeasca District", "Bender Municipality", "Briceni District", "Cahul District", "Călărași District", "Cantemir District", "Căușeni District", "Chișinău Municipality", "Cimișlia District", "Criuleni District", "Dondușeni District", "Drochia District", "Dubăsari District", "Edineț District", "Fălești District", "Florești District", "Gagauzia", "Glodeni District", "Hîncești District", "Ialoveni District", "Nisporeni District", "Ocnița District", "Orhei District", "Rezina District", "Rîșcani District", "Sîngerei District", "Șoldănești District", "Soroca District", "Ștefan Vodă District", "Strășeni District", "Taraclia District", "Telenești District", "Transnistria autonomous territorial unit", "Ungheni District"]
    }, {name: "Monaco", states: ["La Colle", "La Condamine", "Moneghetti"]}, {
        name: "Mongolia",
        states: ["Arkhangai Province", "Bayan-Ölgii Province", "Bayankhongor Province", "Bulgan Province", "Darkhan-Uul Province", "Dornod Province", "Dornogovi Province", "Dundgovi Province", "Govi-Altai Province", "Govisümber Province", "Khentii Province", "Khovd Province", "Khövsgöl Province", "Ömnögovi Province", "Orkhon Province", "Övörkhangai Province", "Selenge Province", "Sükhbaatar Province", "Töv Province", "Uvs Province", "Zavkhan Province"]
    }, {
        name: "Montenegro",
        states: ["Andrijevica Municipality", "Bar Municipality", "Berane Municipality", "Bijelo Polje Municipality", "Budva Municipality", "Danilovgrad Municipality", "Gusinje Municipality", "Kolašin Municipality", "Kotor Municipality", "Mojkovac Municipality", "Nikšić Municipality", "Old Royal Capital Cetinje", "Petnjica Municipality", "Plav Municipality", "Pljevlja Municipality", "Plužine Municipality", "Podgorica Municipality", "Rožaje Municipality", "Šavnik Municipality", "Tivat Municipality", "Ulcinj Municipality", "Žabljak Municipality"]
    }, {name: "Montserrat", states: []}, {
        name: "Morocco",
        states: ["Agadir-Ida-Ou-Tanane", "Al Haouz", "Al Hoceïma", "Aousserd (EH)", "Assa-Zag (EH-partial)", "Azilal", "Béni Mellal", "Béni Mellal-Khénifra", "Benslimane", "Berkane", "Berrechid", "Boujdour (EH)", "Boulemane", "Casablanca", "Casablanca-Settat", "Chefchaouen", "Chichaoua", "Chtouka-Ait Baha", "Dakhla-Oued Ed-Dahab (EH)", "Drâa-Tafilalet", "Driouch", "El Hajeb", "El Jadida", "El Kelâa des Sraghna", "Errachidia", "Es-Semara (EH-partial)", "Essaouira", "Fahs-Anjra", "Fès", "Fès-Meknès", "Figuig", "Fquih Ben Salah", "Guelmim", "Guelmim-Oued Noun (EH-partial)", "Guercif", "Ifrane", "Inezgane-Ait Melloul", "Jerada", "Kénitra", "Khémisset", "Khénifra", "Khouribga", "L'Oriental", "Laâyoune (EH)", "Laâyoune-Sakia El Hamra (EH-partial)", "Larache", "M’diq-Fnideq", "Marrakech", "Marrakesh-Safi", "Médiouna", "Meknès", "Midelt", "Mohammadia", "Moulay Yacoub", "Nador", "Nouaceur", "Ouarzazate", "Oued Ed-Dahab (EH)", "Ouezzane", "Oujda-Angad", "Rabat", "Rabat-Salé-Kénitra", "Rehamna", "Safi", "Salé", "Sefrou", "Settat", "Sidi Bennour", "Sidi Ifni", "Sidi Kacem", "Sidi Slimane", "Skhirate-Témara", "Souss-Massa", "Tan-Tan (EH-partial)", "Tanger-Assilah", "Tanger-Tétouan-Al Hoceïma", "Taounate", "Taourirt", "Tarfaya (EH-partial)", "Taroudannt", "Tata", "Taza", "Tétouan", "Tinghir", "Tiznit", "Youssoufia", "Zagora"]
    }, {
        name: "Mozambique",
        states: ["Cabo Delgado Province", "Gaza Province", "Inhambane Province", "Manica Province", "Maputo", "Maputo Province", "Nampula Province", "Niassa Province", "Sofala Province", "Tete Province", "Zambezia Province"]
    }, {
        name: "Myanmar",
        states: ["Ayeyarwady Region", "Bago", "Chin State", "Kachin State", "Kayah State", "Kayin State", "Magway Region", "Mandalay Region", "Mon State", "Naypyidaw Union Territory", "Rakhine State", "Sagaing Region", "Shan State", "Tanintharyi Region", "Yangon Region"]
    }, {
        name: "Namibia",
        states: ["Erongo Region", "Hardap Region", "Karas Region", "Kavango East Region", "Kavango West Region", "Khomas Region", "Kunene Region", "Ohangwena Region", "Omaheke Region", "Omusati Region", "Oshana Region", "Oshikoto Region", "Otjozondjupa Region", "Zambezi Region"]
    }, {
        name: "Nauru",
        states: ["Aiwo District", "Anabar District", "Anetan District", "Anibare District", "Baiti District", "Boe District", "Buada District", "Denigomodu District", "Ewa District", "Ijuw District", "Meneng District", "Nibok District", "Uaboe District", "Yaren District"]
    }, {
        name: "Nepal",
        states: ["Bagmati", "Gandaki", "Karnali", "Koshi", "Lumbini", "Madhesh", "Sudurpashchim"]
    }, {
        name: "Netherlands",
        states: ["Bonaire", "Drenthe", "Flevoland", "Friesland", "Gelderland", "Groningen", "Limburg", "North Brabant", "North Holland", "Overijssel", "Saba", "Sint Eustatius", "South Holland", "Utrecht", "Zeeland"]
    }, {
        name: "New Caledonia",
        states: ["Loyalty Islands Province", "North Province", "South Province"]
    }, {
        name: "New Zealand",
        states: ["Auckland Region", "Bay of Plenty Region", "Canterbury Region", "Chatham Islands", "Gisborne District", "Hawke's Bay Region", "Manawatu-Wanganui Region", "Marlborough Region", "Nelson Region", "Northland Region", "Otago Region", "Southland Region", "Taranaki Region", "Tasman District", "Waikato Region", "Wellington Region", "West Coast Region"]
    }, {
        name: "Nicaragua",
        states: ["Boaco", "Carazo", "Chinandega", "Chontales", "Estelí", "Granada", "Jinotega", "León", "Madriz", "Managua", "Masaya", "Matagalpa", "North Caribbean Coast", "Nueva Segovia", "Río San Juan", "Rivas", "South Caribbean Coast"]
    }, {
        name: "Niger",
        states: ["Agadez Region", "Diffa Region", "Dosso Region", "Maradi Region", "Tahoua Region", "Tillabéri Region", "Zinder Region"]
    }, {
        name: "Nigeria",
        states: ["Abia", "Abuja Federal Capital Territory", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"]
    }, {name: "Niue", states: []}, {name: "Norfolk Island", states: []}, {
        name: "North Korea",
        states: ["Chagang Province", "Kangwon Province", "North Hamgyong Province", "North Hwanghae Province", "North Pyongan Province", "Pyongyang", "Rason", "Ryanggang Province", "South Hamgyong Province", "South Hwanghae Province", "South Pyongan Province"]
    }, {
        name: "North Macedonia",
        states: ["Aerodrom Municipality", "Aračinovo Municipality", "Berovo Municipality", "Bitola Municipality", "Bogdanci Municipality", "Bogovinje Municipality", "Bosilovo Municipality", "Brvenica Municipality", "Butel Municipality", "Čair Municipality", "Čaška Municipality", "Centar Municipality", "Centar Župa Municipality", "Češinovo-Obleševo Municipality", "Čučer-Sandevo Municipality", "Debarca Municipality", "Delčevo Municipality", "Demir Hisar Municipality", "Demir Kapija Municipality", "Dojran Municipality", "Dolneni Municipality", "Drugovo Municipality", "Gazi Baba Municipality", "Gevgelija Municipality", "Gjorče Petrov Municipality", "Gostivar Municipality", "Gradsko Municipality", "Greater Skopje", "Ilinden Municipality", "Jegunovce Municipality", "Karbinci", "Karpoš Municipality", "Kavadarci Municipality", "Kičevo Municipality", "Kisela Voda Municipality", "Kočani Municipality", "Konče Municipality", "Kratovo Municipality", "Kriva Palanka Municipality", "Krivogaštani Municipality", "Kruševo Municipality", "Kumanovo Municipality", "Lipkovo Municipality", "Lozovo Municipality", "Makedonska Kamenica Municipality", "Makedonski Brod Municipality", "Mavrovo and Rostuša Municipality", "Mogila Municipality", "Negotino Municipality", "Novaci Municipality", "Novo Selo Municipality", "Ohrid Municipality", "Oslomej Municipality", "Pehčevo Municipality", "Petrovec Municipality", "Plasnica Municipality", "Prilep Municipality", "Probištip Municipality", "Radoviš Municipality", "Rankovce Municipality", "Resen Municipality", "Rosoman Municipality", "Saraj Municipality", "Sopište Municipality", "Staro Nagoričane Municipality", "Štip Municipality", "Struga Municipality", "Strumica Municipality", "Studeničani Municipality", "Šuto Orizari Municipality", "Sveti Nikole Municipality", "Tearce Municipality", "Tetovo Municipality", "Valandovo Municipality", "Vasilevo Municipality", "Veles Municipality", "Vevčani Municipality", "Vinica Municipality", "Vraneštica Municipality", "Vrapčište Municipality", "Zajas Municipality", "Zelenikovo Municipality", "Želino Municipality", "Zrnovci Municipality"]
    }, {name: "Northern Mariana Islands", states: []}, {
        name: "Norway",
        states: ["Agder", "Innlandet", "Jan Mayen", "Møre og Romsdal", "Nordland", "Oslo", "Rogaland", "Svalbard", "Troms og Finnmark", "Trøndelag", "Vestfold og Telemark", "Vestland", "Viken"]
    }, {
        name: "Oman",
        states: ["Ad Dakhiliyah", "Ad Dhahirah", "Al Batinah North", "Al Batinah Region", "Al Batinah South", "Al Buraimi", "Al Wusta", "Ash Sharqiyah North", "Ash Sharqiyah Region", "Ash Sharqiyah South", "Dhofar", "Musandam", "Muscat"]
    }, {
        name: "Pakistan",
        states: ["Azad Kashmir", "Balochistan", "Federally Administered Tribal Areas", "Gilgit-Baltistan", "Islamabad Capital Territory", "Khyber Pakhtunkhwa", "Punjab", "Sindh"]
    }, {
        name: "Palau",
        states: ["Aimeliik", "Airai", "Angaur", "Hatohobei", "Kayangel", "Koror", "Melekeok", "Ngaraard", "Ngarchelong", "Ngardmau", "Ngatpang", "Ngchesar", "Ngeremlengui", "Ngiwal", "Peleliu", "Sonsorol"]
    }, {
        name: "Palestinian Territory Occupied",
        states: ["Bethlehem", "Deir El Balah", "Gaza", "Hebron", "Jenin", "Jericho ", "Jerusalem (Quds)", "Khan Yunis", "Nablus", "North Gaza", "Qalqilya", "Rafah", "Ramallah", "Salfit", "Tubas", "Tulkarm"]
    }, {
        name: "Panama",
        states: ["Bocas del Toro Province", "Chiriquí Province", "Coclé Province", "Colón Province", "Darién Province", "Emberá-Wounaan Comarca", "Guna Yala", "Herrera Province", "Los Santos Province", "Ngöbe-Buglé Comarca", "Panamá Oeste Province", "Panamá Province", "Veraguas Province"]
    }, {
        name: "Papua New Guinea",
        states: ["Bougainville", "Central Province", "Chimbu Province", "East New Britain", "East Sepik", "Eastern Highlands Province", "Enga Province", "Gulf", "Hela", "Jiwaka Province", "Madang Province", "Manus Province", "Milne Bay Province", "Morobe Province", "New Ireland Province", "Oro Province", "Port Moresby", "Sandaun Province", "Southern Highlands Province", "West New Britain Province", "Western Highlands Province", "Western Province"]
    }, {
        name: "Paraguay",
        states: ["Alto Paraguay Department", "Alto Paraná Department", "Amambay Department", "Asuncion", "Boquerón Department", "Caaguazú", "Caazapá", "Canindeyú", "Central Department", "Concepción Department", "Cordillera Department", "Guairá Department", "Itapúa", "Misiones Department", "Ñeembucú Department", "Paraguarí Department", "Presidente Hayes Department", "San Pedro Department"]
    }, {
        name: "Peru",
        states: ["Amazonas", "Áncash", "Apurímac", "Arequipa", "Ayacucho", "Cajamarca", "Callao", "Cusco", "Huancavelica", "Huanuco", "Ica", "Junín", "La Libertad", "Lambayeque", "Lima", "Loreto", "Madre de Dios", "Moquegua", "Pasco", "Piura", "Puno", "San Martín", "Tacna", "Tumbes", "Ucayali"]
    }, {
        name: "Philippines",
        states: ["Abra", "Agusan del Norte", "Agusan del Sur", "Aklan", "Albay", "Antique", "Apayao", "Aurora", "Autonomous Region in Muslim Mindanao", "Basilan", "Bataan", "Batanes", "Batangas", "Benguet", "Bicol", "Biliran", "Bohol", "Bukidnon", "Bulacan", "Cagayan", "Cagayan Valley", "Calabarzon", "Camarines Norte", "Camarines Sur", "Camiguin", "Capiz", "Caraga", "Catanduanes", "Cavite", "Cebu", "Central Luzon", "Central Visayas", "Compostela Valley", "Cordillera Administrative", "Cotabato", "Davao", "Davao del Norte", "Davao del Sur", "Davao Occidental", "Davao Oriental", "Dinagat Islands", "Eastern Samar", "Eastern Visayas", "Guimaras", "Ifugao", "Ilocos", "Ilocos Norte", "Ilocos Sur", "Iloilo", "Isabela", "Kalinga", "La Union", "Laguna", "Lanao del Norte", "Lanao del Sur", "Leyte", "Maguindanao", "Marinduque", "Masbate", "Metro Manila", "Mimaropa", "Misamis Occidental", "Misamis Oriental", "Mountain Province", "Negros Occidental", "Negros Oriental", "Northern Mindanao", "Northern Samar", "Nueva Ecija", "Nueva Vizcaya", "Occidental Mindoro", "Oriental Mindoro", "Palawan", "Pampanga", "Pangasinan", "Quezon", "Quirino", "Rizal", "Romblon", "Sarangani", "Siquijor", "Soccsksargen", "Sorsogon", "South Cotabato", "Southern Leyte", "Sultan Kudarat", "Sulu", "Surigao del Norte", "Surigao del Sur", "Tarlac", "Tawi-Tawi", "Western Samar", "Western Visayas", "Zambales", "Zamboanga del Norte", "Zamboanga del Sur", "Zamboanga Peninsula", "Zamboanga Sibugay"]
    }, {name: "Pitcairn Island", states: []}, {
        name: "Poland",
        states: ["Greater Poland", "Holy Cross", "Kuyavia-Pomerania", "Lesser Poland", "Lower Silesia", "Lublin", "Lubusz", "Łódź", "Mazovia", "Podlaskie", "Pomerania", "Silesia", "Subcarpathia", "Upper Silesia", "Warmia-Masuria", "West Pomerania"]
    }, {
        name: "Portugal",
        states: ["Açores", "Aveiro", "Beja", "Braga", "Bragança", "Castelo Branco", "Coimbra", "Évora", "Faro", "Guarda", "Leiria", "Lisbon", "Madeira", "Portalegre", "Porto", "Santarém", "Setúbal", "Viana do Castelo", "Vila Real", "Viseu"]
    }, {
        name: "Puerto Rico",
        states: ["Adjuntas", "Aguada", "Aguadilla", "Aguas Buenas", "Aibonito", "Añasco", "Arecibo", "Arecibo", "Arroyo", "Barceloneta", "Barranquitas", "Bayamon", "Bayamón", "Cabo Rojo", "Caguas", "Caguas", "Camuy", "Canóvanas", "Carolina", "Carolina", "Cataño", "Cayey", "Ceiba", "Ciales", "Cidra", "Coamo", "Comerío", "Corozal", "Culebra", "Dorado", "Fajardo", "Florida", "Guánica", "Guayama", "Guayanilla", "Guaynabo", "Guaynabo", "Gurabo", "Hatillo", "Hormigueros", "Humacao", "Isabela", "Jayuya", "Juana Díaz", "Juncos", "Lajas", "Lares", "Las Marías", "Las Piedras", "Loíza", "Luquillo", "Manatí", "Maricao", "Maunabo", "Mayagüez", "Mayagüez", "Moca", "Morovis", "Naguabo", "Naranjito", "Orocovis", "Patillas", "Peñuelas", "Ponce", "Ponce", "Quebradillas", "Rincón", "Río Grande", "Sabana Grande", "Salinas", "San Germán", "San Juan", "San Juan", "San Lorenzo", "San Sebastián", "Santa Isabel", "Toa Alta", "Toa Baja", "Toa Baja", "Trujillo Alto", "Trujillo Alto", "Utuado", "Vega Alta", "Vega Baja", "Vieques", "Villalba", "Yabucoa", "Yauco"]
    }, {
        name: "Qatar",
        states: ["Al Daayen", "Al Khor", "Al Rayyan Municipality", "Al Wakrah", "Al-Shahaniya", "Doha", "Madinat ash Shamal", "Umm Salal Municipality"]
    }, {name: "Reunion", states: []}, {
        name: "Romania",
        states: ["Alba", "Arad County", "Arges", "Bacău County", "Bihor County", "Bistrița-Năsăud County", "Botoșani County", "Braila", "Brașov County", "Bucharest", "Buzău County", "Călărași County", "Caraș-Severin County", "Cluj County", "Constanța County", "Covasna County", "Dâmbovița County", "Dolj County", "Galați County", "Giurgiu County", "Gorj County", "Harghita County", "Hunedoara County", "Ialomița County", "Iași County", "Ilfov County", "Maramureș County", "Mehedinți County", "Mureș County", "Neamț County", "Olt County", "Prahova County", "Sălaj County", "Satu Mare County", "Sibiu County", "Suceava County", "Teleorman County", "Timiș County", "Tulcea County", "Vâlcea County", "Vaslui County", "Vrancea County"]
    }, {
        name: "Russia",
        states: ["Altai Krai", "Altai Republic", "Amur Oblast", "Arkhangelsk", "Astrakhan Oblast", "Belgorod Oblast", "Bryansk Oblast", "Chechen Republic", "Chelyabinsk Oblast", "Chukotka Autonomous Okrug", "Chuvash Republic", "Irkutsk", "Ivanovo Oblast", "Jewish Autonomous Oblast", "Kabardino-Balkar Republic", "Kaliningrad", "Kaluga Oblast", "Kamchatka Krai", "Karachay-Cherkess Republic", "Kemerovo Oblast", "Khabarovsk Krai", "Khanty-Mansi Autonomous Okrug", "Kirov Oblast", "Komi Republic", "Kostroma Oblast", "Krasnodar Krai", "Krasnoyarsk Krai", "Kurgan Oblast", "Kursk Oblast", "Leningrad Oblast", "Lipetsk Oblast", "Magadan Oblast", "Mari El Republic", "Moscow", "Moscow Oblast", "Murmansk Oblast", "Nenets Autonomous Okrug", "Nizhny Novgorod Oblast", "Novgorod Oblast", "Novosibirsk", "Omsk Oblast", "Orenburg Oblast", "Oryol Oblast", "Penza Oblast", "Perm Krai", "Primorsky Krai", "Pskov Oblast", "Republic of Adygea", "Republic of Bashkortostan", "Republic of Buryatia", "Republic of Dagestan", "Republic of Ingushetia", "Republic of Kalmykia", "Republic of Karelia", "Republic of Khakassia", "Republic of Mordovia", "Republic of North Ossetia-Alania", "Republic of Tatarstan", "Rostov Oblast", "Ryazan Oblast", "Saint Petersburg", "Sakha Republic", "Sakhalin", "Samara Oblast", "Saratov Oblast", "Smolensk Oblast", "Stavropol Krai", "Sverdlovsk", "Tambov Oblast", "Tomsk Oblast", "Tula Oblast", "Tuva Republic", "Tver Oblast", "Tyumen Oblast", "Udmurt Republic", "Ulyanovsk Oblast", "Vladimir Oblast", "Volgograd Oblast", "Vologda Oblast", "Voronezh Oblast", "Yamalo-Nenets Autonomous Okrug", "Yaroslavl Oblast", "Zabaykalsky Krai"]
    }, {
        name: "Rwanda",
        states: ["Eastern Province", "Kigali district", "Northern Province", "Southern Province", "Western Province"]
    }, {name: "Saint Helena", states: []}, {
        name: "Saint Kitts and Nevis",
        states: ["Christ Church Nichola Town Parish", "Nevis", "Saint Anne Sandy Point Parish", "Saint George Gingerland Parish", "Saint James Windward Parish", "Saint John Capisterre Parish", "Saint John Figtree Parish", "Saint Kitts", "Saint Mary Cayon Parish", "Saint Paul Capisterre Parish", "Saint Paul Charlestown Parish", "Saint Peter Basseterre Parish", "Saint Thomas Lowland Parish", "Saint Thomas Middle Island Parish", "Trinity Palmetto Point Parish"]
    }, {
        name: "Saint Lucia",
        states: ["Anse la Raye Quarter", "Canaries", "Castries Quarter", "Choiseul Quarter", "Dauphin Quarter", "Dennery Quarter", "Gros Islet Quarter", "Laborie Quarter", "Micoud Quarter", "Praslin Quarter", "Soufrière Quarter", "Vieux Fort Quarter"]
    }, {name: "Saint Pierre and Miquelon", states: []}, {
        name: "Saint Vincent and the Grenadines",
        states: ["Charlotte Parish", "Grenadines Parish", "Saint Andrew Parish", "Saint David Parish", "Saint George Parish", "Saint Patrick Parish"]
    }, {name: "Saint-Barthelemy", states: []}, {name: "Saint-Martin (French part)", states: []}, {
        name: "Samoa",
        states: ["A'ana", "Aiga-i-le-Tai", "Atua", "Fa'asaleleaga", "Gaga'emauga", "Gaga'ifomauga", "Palauli", "Satupa'itea", "Tuamasaga", "Va'a-o-Fonoti", "Vaisigano"]
    }, {
        name: "San Marino",
        states: ["Acquaviva", "Borgo Maggiore", "Chiesanuova", "Domagnano", "Faetano", "Fiorentino", "Montegiardino", "San Marino", "Serravalle"]
    }, {name: "Sao Tome and Principe", states: ["Príncipe Province", "São Tomé Province"]}, {
        name: "Saudi Arabia",
        states: ["'Asir", "Al Bahah", "Al Jawf", "Al Madinah", "Al-Qassim", "Eastern Province", "Ha'il", "Jizan", "Makkah", "Najran", "Northern Borders", "Riyadh", "Tabuk"]
    }, {
        name: "Senegal",
        states: ["Dakar", "Diourbel Region", "Fatick", "Kaffrine", "Kaolack", "Kédougou", "Kolda", "Louga", "Matam", "Saint-Louis", "Sédhiou", "Tambacounda Region", "Thiès Region", "Ziguinchor"]
    }, {
        name: "Serbia",
        states: ["Belgrade", "Bor District", "Braničevo District", "Central Banat District", "Jablanica District", "Kolubara District", "Mačva District", "Moravica District", "Nišava District", "North Bačka District", "North Banat District", "Pčinja District", "Pirot District", "Podunavlje District", "Pomoravlje District", "Rasina District", "Raška District", "South Bačka District", "South Banat District", "Srem District", "Šumadija District", "Toplica District", "Vojvodina", "West Bačka District", "Zaječar District", "Zlatibor District"]
    }, {
        name: "Seychelles",
        states: ["Anse Boileau", "Anse Royale", "Anse-aux-Pins", "Au Cap", "Baie Lazare", "Baie Sainte Anne", "Beau Vallon", "Bel Air", "Bel Ombre", "Cascade", "Glacis", "Grand'Anse Mahé", "Grand'Anse Praslin", "La Digue", "La Rivière Anglaise", "Les Mamelles", "Mont Buxton", "Mont Fleuri", "Plaisance", "Pointe La Rue", "Port Glaud", "Roche Caiman", "Saint Louis", "Takamaka"]
    }, {
        name: "Sierra Leone",
        states: ["Eastern Province", "Northern Province", "Southern Province", "Western Area"]
    }, {
        name: "Singapore",
        states: ["Central Singapore", "North East", "North West", "South East", "South West"]
    }, {name: "Sint Maarten (Dutch part)", states: []}, {
        name: "Slovakia",
        states: ["Banská Bystrica Region", "Bratislava Region", "Košice Region", "Nitra Region", "Prešov Region", "Trenčín Region", "Trnava Region", "Žilina Region"]
    }, {
        name: "Slovenia",
        states: ["Ajdovščina Municipality", "Ankaran Municipality", "Beltinci Municipality", "Benedikt Municipality", "Bistrica ob Sotli Municipality", "Bled Municipality", "Bloke Municipality", "Bohinj Municipality", "Borovnica Municipality", "Bovec Municipality", "Braslovče Municipality", "Brda Municipality", "Brežice Municipality", "Brezovica Municipality", "Cankova Municipality", "Cerklje na Gorenjskem Municipality", "Cerknica Municipality", "Cerkno Municipality", "Cerkvenjak Municipality", "City Municipality of Celje", "City Municipality of Novo Mesto", "Črenšovci Municipality", "Črna na Koroškem Municipality", "Črnomelj Municipality", "Destrnik Municipality", "Divača Municipality", "Dobje Municipality", "Dobrepolje Municipality", "Dobrna Municipality", "Dobrova–Polhov Gradec Municipality", "Dobrovnik Municipality", "Dol pri Ljubljani Municipality", "Dolenjske Toplice Municipality", "Domžale Municipality", "Dornava Municipality", "Dravograd Municipality", "Duplek Municipality", "Gorenja Vas–Poljane Municipality", "Gorišnica Municipality", "Gorje Municipality", "Gornja Radgona Municipality", "Gornji Grad Municipality", "Gornji Petrovci Municipality", "Grad Municipality", "Grosuplje Municipality", "Hajdina Municipality", "Hoče–Slivnica Municipality", "Hodoš Municipality", "Horjul Municipality", "Hrastnik Municipality", "Hrpelje–Kozina Municipality", "Idrija Municipality", "Ig Municipality", "Ivančna Gorica Municipality", "Izola Municipality", "Jesenice Municipality", "Jezersko Municipality", "Juršinci Municipality", "Kamnik Municipality", "Kanal ob Soči Municipality", "Kidričevo Municipality", "Kobarid Municipality", "Kobilje Municipality", "Kočevje Municipality", "Komen Municipality", "Komenda Municipality", "Koper City Municipality", "Kostanjevica na Krki Municipality", "Kostel Municipality", "Kozje Municipality", "Kranj City Municipality", "Kranjska Gora Municipality", "Križevci Municipality", "Kungota", "Kuzma Municipality", "Laško Municipality", "Lenart Municipality", "Lendava Municipality", "Litija Municipality", "Ljubljana City Municipality", "Ljubno Municipality", "Ljutomer Municipality", "Log–Dragomer Municipality", "Logatec Municipality", "Loška Dolina Municipality", "Loški Potok Municipality", "Lovrenc na Pohorju Municipality", "Luče Municipality", "Lukovica Municipality", "Majšperk Municipality", "Makole Municipality", "Maribor City Municipality", "Markovci Municipality", "Medvode Municipality", "Mengeš Municipality", "Metlika Municipality", "Mežica Municipality", "Miklavž na Dravskem Polju Municipality", "Miren–Kostanjevica Municipality", "Mirna Municipality", "Mirna Peč Municipality", "Mislinja Municipality", "Mokronog–Trebelno Municipality", "Moravče Municipality", "Moravske Toplice Municipality", "Mozirje Municipality", "Municipality of Apače", "Municipality of Cirkulane", "Municipality of Ilirska Bistrica", "Municipality of Krško", "Municipality of Škofljica", "Murska Sobota City Municipality", "Muta Municipality", "Naklo Municipality", "Nazarje Municipality", "Nova Gorica City Municipality", "Odranci Municipality", "Oplotnica", "Ormož Municipality", "Osilnica Municipality", "Pesnica Municipality", "Piran Municipality", "Pivka Municipality", "Podčetrtek Municipality", "Podlehnik Municipality", "Podvelka Municipality", "Poljčane Municipality", "Polzela Municipality", "Postojna Municipality", "Prebold Municipality", "Preddvor Municipality", "Prevalje Municipality", "Ptuj City Municipality", "Puconci Municipality", "Rače–Fram Municipality", "Radeče Municipality", "Radenci Municipality", "Radlje ob Dravi Municipality", "Radovljica Municipality", "Ravne na Koroškem Municipality", "Razkrižje Municipality", "Rečica ob Savinji Municipality", "Renče–Vogrsko Municipality", "Ribnica Municipality", "Ribnica na Pohorju Municipality", "Rogaška Slatina Municipality", "Rogašovci Municipality", "Rogatec Municipality", "Ruše Municipality", "Šalovci Municipality", "Selnica ob Dravi Municipality", "Semič Municipality", "Šempeter–Vrtojba Municipality", "Šenčur Municipality", "Šentilj Municipality", "Šentjernej Municipality", "Šentjur Municipality", "Šentrupert Municipality", "Sevnica Municipality", "Sežana Municipality", "Škocjan Municipality", "Škofja Loka Municipality", "Slovenj Gradec City Municipality", "Slovenska Bistrica Municipality", "Slovenske Konjice Municipality", "Šmarje pri Jelšah Municipality", "Šmarješke Toplice Municipality", "Šmartno ob Paki Municipality", "Šmartno pri Litiji Municipality", "Sodražica Municipality", "Solčava Municipality", "Šoštanj Municipality", "Središče ob Dravi", "Starše Municipality", "Štore Municipality", "Straža Municipality", "Sveta Ana Municipality", "Sveta Trojica v Slovenskih Goricah Municipality", "Sveti Andraž v Slovenskih Goricah Municipality", "Sveti Jurij ob Ščavnici Municipality", "Sveti Jurij v Slovenskih Goricah Municipality", "Sveti Tomaž Municipality", "Tabor Municipality", "Tišina Municipality", "Tolmin Municipality", "Trbovlje Municipality", "Trebnje Municipality", "Trnovska Vas Municipality", "Tržič Municipality", "Trzin Municipality", "Turnišče Municipality", "Velika Polana Municipality", "Velike Lašče Municipality", "Veržej Municipality", "Videm Municipality", "Vipava Municipality", "Vitanje Municipality", "Vodice Municipality", "Vojnik Municipality", "Vransko Municipality", "Vrhnika Municipality", "Vuzenica Municipality", "Zagorje ob Savi Municipality", "Žalec Municipality", "Zavrč Municipality", "Železniki Municipality", "Žetale Municipality", "Žiri Municipality", "Žirovnica Municipality", "Zreče Municipality", "Žužemberk Municipality"]
    }, {
        name: "Solomon Islands",
        states: ["Central Province", "Choiseul Province", "Guadalcanal Province", "Honiara", "Isabel Province", "Makira-Ulawa Province", "Malaita Province", "Rennell and Bellona Province", "Temotu Province", "Western Province"]
    }, {
        name: "Somalia",
        states: ["Awdal Region", "Bakool", "Banaadir", "Bari", "Bay", "Galguduud", "Gedo", "Hiran", "Lower Juba", "Lower Shebelle", "Middle Juba", "Middle Shebelle", "Mudug", "Nugal", "Sanaag Region", "Togdheer Region"]
    }, {
        name: "South Africa",
        states: ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape"]
    }, {name: "South Georgia", states: []}, {
        name: "South Korea",
        states: ["Busan", "Daegu", "Daejeon", "Gangwon Province", "Gwangju", "Gyeonggi Province", "Incheon", "Jeju", "North Chungcheong Province", "North Gyeongsang Province", "North Jeolla Province", "Sejong City", "Seoul", "South Chungcheong Province", "South Gyeongsang Province", "South Jeolla Province", "Ulsan"]
    }, {
        name: "South Sudan",
        states: ["Central Equatoria", "Eastern Equatoria", "Jonglei State", "Lakes", "Northern Bahr el Ghazal", "Unity", "Upper Nile", "Warrap", "Western Bahr el Ghazal", "Western Equatoria"]
    }, {
        name: "Spain",
        states: ["A Coruña", "Albacete", "Alicante", "Almeria", "Araba", "Asturias", "Ávila", "Badajoz", "Barcelona", "Bizkaia", "Burgos", "Caceres", "Cádiz", "Canarias", "Cantabria", "Castellón", "Ceuta", "Ciudad Real", "Córdoba", "Cuenca", "Gipuzkoa", "Girona", "Granada", "Guadalajara", "Huelva", "Huesca", "Islas Baleares", "Jaén", "La Rioja", "Las Palmas", "León", "Lleida", "Lugo", "Madrid", "Málaga", "Melilla", "Murcia", "Navarra", "Ourense", "Palencia", "Pontevedra", "Salamanca", "Santa Cruz de Tenerife", "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "Zamora", "Zaragoza"]
    }, {
        name: "Sri Lanka",
        states: ["Ampara District", "Anuradhapura District", "Badulla District", "Batticaloa District", "Central Province", "Colombo District", "Eastern Province", "Galle District", "Gampaha District", "Hambantota District", "Jaffna District", "Kalutara District", "Kandy District", "Kegalle District", "Kilinochchi District", "Mannar District", "Matale District", "Matara District", "Monaragala District", "Mullaitivu District", "North Central Province", "North Western Province", "Northern Province", "Nuwara Eliya District", "Polonnaruwa District", "Puttalam District", "Ratnapura district", "Sabaragamuwa Province", "Southern Province", "Trincomalee District", "Uva Province", "Vavuniya District", "Western Province"]
    }, {
        name: "Sudan",
        states: ["Al Jazirah", "Al Qadarif", "Blue Nile", "Central Darfur", "East Darfur", "Kassala", "Khartoum", "North Darfur", "North Kordofan", "Northern", "Red Sea", "River Nile", "Sennar", "South Darfur", "South Kordofan", "West Darfur", "West Kordofan", "White Nile"]
    }, {
        name: "Suriname",
        states: ["Brokopondo District", "Commewijne District", "Coronie District", "Marowijne District", "Nickerie District", "Para District", "Paramaribo District", "Saramacca District", "Sipaliwini District", "Wanica District"]
    }, {name: "Svalbard and Jan Mayen Islands", states: []}, {
        name: "Sweden",
        states: ["Blekinge County", "Dalarna County", "Gävleborg County", "Gotland County", "Halland County", "Jämtland County", "Jönköping County", "Kalmar County", "Kronoberg County", "Norrbotten County", "Örebro County", "Östergötland County", "Skåne County", "Södermanland County", "Stockholm County", "Uppsala County", "Värmland County", "Västerbotten County", "Västernorrland County", "Västmanland County", "Västra Götaland County"]
    }, {
        name: "Switzerland",
        states: ["Aargau", "Appenzell Ausserrhoden", "Appenzell Innerrhoden", "Basel-Land", "Basel-Stadt", "Bern", "Fribourg", "Geneva", "Glarus", "Graubünden", "Jura", "Lucerne", "Neuchâtel", "Nidwalden", "Obwalden", "Schaffhausen", "Schwyz", "Solothurn", "St. Gallen", "Thurgau", "Ticino", "Uri", "Valais", "Vaud", "Zug", "Zürich"]
    }, {
        name: "Syria",
        states: ["Al-Hasakah", "Al-Raqqah", "Aleppo", "As-Suwayda", "Damascus", "Daraa", "Deir ez-Zor", "Hama", "Homs", "Idlib", "Latakia", "Quneitra", "Rif Dimashq", "Tartus"]
    }, {
        name: "Taiwan",
        states: ["Changhua", "Chiayi", "Chiayi", "Hsinchu", "Hsinchu", "Hualien", "Kaohsiung", "Keelung", "Kinmen", "Lienchiang", "Miaoli", "Nantou", "New Taipei", "Penghu", "Pingtung", "Taichung", "Tainan", "Taipei", "Taitung", "Taoyuan", "Yilan", "Yunlin"]
    }, {
        name: "Tajikistan",
        states: ["districts of Republican Subordination", "Gorno-Badakhshan Autonomous Province", "Khatlon Province", "Sughd Province"]
    }, {
        name: "Tanzania",
        states: ["Arusha", "Dar es Salaam", "Dodoma", "Geita", "Iringa", "Kagera", "Katavi", "Kigoma", "Kilimanjaro", "Lindi", "Manyara", "Mara", "Mbeya", "Morogoro", "Mtwara", "Mwanza", "Njombe", "Pemba North", "Pemba South", "Pwani", "Rukwa", "Ruvuma", "Shinyanga", "Simiyu", "Singida", "Songwe", "Tabora", "Tanga", "Zanzibar North", "Zanzibar South", "Zanzibar West"]
    }, {
        name: "Thailand",
        states: ["Amnat Charoen", "Ang Thong", "Bangkok", "Bueng Kan", "Buri Ram", "Chachoengsao", "Chai Nat", "Chaiyaphum", "Chanthaburi", "Chiang Mai", "Chiang Rai", "Chon Buri", "Chumphon", "Kalasin", "Kamphaeng Phet", "Kanchanaburi", "Khon Kaen", "Krabi", "Lampang", "Lamphun", "Loei", "Lop Buri", "Mae Hong Son", "Maha Sarakham", "Mukdahan", "Nakhon Nayok", "Nakhon Pathom", "Nakhon Phanom", "Nakhon Ratchasima", "Nakhon Sawan", "Nakhon Si Thammarat", "Nan", "Narathiwat", "Nong Bua Lam Phu", "Nong Khai", "Nonthaburi", "Pathum Thani", "Pattani", "Pattaya", "Phangnga", "Phatthalung", "Phayao", "Phetchabun", "Phetchaburi", "Phichit", "Phitsanulok", "Phra Nakhon Si Ayutthaya", "Phrae", "Phuket", "Prachin Buri", "Prachuap Khiri Khan", "Ranong", "Ratchaburi", "Rayong", "Roi Et", "Sa Kaeo", "Sakon Nakhon", "Samut Prakan", "Samut Sakhon", "Samut Songkhram", "Saraburi", "Satun", "Si Sa Ket", "Sing Buri", "Songkhla", "Sukhothai", "Suphan Buri", "Surat Thani", "Surin", "Tak", "Trang", "Trat", "Ubon Ratchathani", "Udon Thani", "Uthai Thani", "Uttaradit", "Yala", "Yasothon"]
    }, {
        name: "The Bahamas",
        states: ["Acklins", "Acklins and Crooked Islands", "Berry Islands", "Bimini", "Black Point", "Cat Island", "Central Abaco", "Central Andros", "Central Eleuthera", "Crooked Island", "East Grand Bahama", "Exuma", "Freeport", "Fresh Creek", "Governor's Harbour", "Grand Cay", "Green Turtle Cay", "Harbour Island", "High Rock", "Hope Town", "Inagua", "Kemps Bay", "Long Island", "Mangrove Cay", "Marsh Harbour", "Mayaguana District", "New Providence", "Nichollstown and Berry Islands", "North Abaco", "North Andros", "North Eleuthera", "Ragged Island", "Rock Sound", "Rum Cay District", "San Salvador and Rum Cay", "San Salvador Island", "Sandy Point", "South Abaco", "South Andros", "South Eleuthera", "Spanish Wells", "West Grand Bahama"]
    }, {
        name: "The Gambia ",
        states: ["Banjul", "Central River Division", "Lower River Division", "North Bank Division", "Upper River Division", "West Coast Division"]
    }, {
        name: "Timor-Leste",
        states: ["Aileu municipality", "Ainaro Municipality", "Baucau Municipality", "Bobonaro Municipality", "Cova Lima Municipality", "Dili municipality", "Ermera District", "Lautém Municipality", "Liquiçá Municipality", "Manatuto District", "Manufahi Municipality", "Viqueque Municipality"]
    }, {
        name: "Togo",
        states: ["Centrale Region", "Kara Region", "Maritime", "Plateaux Region", "Savanes Region"]
    }, {name: "Tokelau", states: []}, {
        name: "Tonga",
        states: ["Haʻapai", "ʻEua", "Niuas", "Tongatapu", "Vavaʻu"]
    }, {
        name: "Trinidad and Tobago",
        states: ["Arima", "Chaguanas", "Couva-Tabaquite-Talparo Regional Corporation", "Diego Martin Regional Corporation", "Eastern Tobago", "Penal-Debe Regional Corporation", "Point Fortin", "Port of Spain", "Princes Town Regional Corporation", "Rio Claro-Mayaro Regional Corporation", "San Fernando", "San Juan-Laventille Regional Corporation", "Sangre Grande Regional Corporation", "Siparia Regional Corporation", "Tunapuna-Piarco Regional Corporation", "Western Tobago"]
    }, {
        name: "Tunisia",
        states: ["Ariana", "Béja", "Ben Arous", "Bizerte", "Gabès", "Gafsa", "Jendouba", "Kairouan", "Kasserine", "Kebili", "Kef", "Mahdia", "Manouba", "Medenine", "Monastir", "Nabeul", "Sfax", "Sidi Bouzid", "Siliana", "Sousse", "Tataouine", "Tozeur", "Tunis", "Zaghouan"]
    }, {
        name: "Turkey",
        states: ["Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya", "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkâri", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kilis", "Kırıkkale", "Kırklareli", "Kırşehir", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Şanlıurfa", "Siirt", "Sinop", "Sivas", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"]
    }, {
        name: "Turkmenistan",
        states: ["Ahal Region", "Ashgabat", "Balkan Region", "Daşoguz Region", "Lebap Region", "Mary Region"]
    }, {name: "Turks and Caicos Islands", states: []}, {
        name: "Tuvalu",
        states: ["Funafuti", "Nanumanga", "Nanumea", "Niutao Island Council", "Nui", "Nukufetau", "Nukulaelae", "Vaitupu"]
    }, {
        name: "Uganda",
        states: ["Abim District", "Adjumani District", "Agago District", "Alebtong District", "Amolatar District", "Amudat District", "Amuria District", "Amuru District", "Apac District", "Arua District", "Budaka District", "Bududa District", "Bugiri District", "Buhweju District", "Buikwe District", "Bukedea District", "Bukomansimbi District", "Bukwo District", "Bulambuli District", "Buliisa District", "Bundibugyo District", "Bunyangabu District", "Bushenyi District", "Busia District", "Butaleja District", "Butambala District", "Butebo District", "Buvuma District", "Buyende District", "Central Region", "Dokolo District", "Eastern Region", "Gomba District", "Gulu District", "Ibanda District", "Iganga District", "Isingiro District", "Jinja District", "Kaabong District", "Kabale District", "Kabarole District", "Kaberamaido District", "Kagadi District", "Kakumiro District", "Kalangala District", "Kaliro District", "Kalungu District", "Kampala District", "Kamuli District", "Kamwenge District", "Kanungu District", "Kapchorwa District", "Kasese District", "Katakwi District", "Kayunga District", "Kibaale District", "Kiboga District", "Kibuku District", "Kiruhura District", "Kiryandongo District", "Kisoro District", "Kitgum District", "Koboko District", "Kole District", "Kotido District", "Kumi District", "Kween District", "Kyankwanzi District", "Kyegegwa District", "Kyenjojo District", "Kyotera District", "Lamwo District", "Lira District", "Luuka District", "Luwero District", "Lwengo District", "Lyantonde District", "Manafwa District", "Maracha District", "Masaka District", "Masindi District", "Mayuge District", "Mbale District", "Mbarara District", "Mitooma District", "Mityana District", "Moroto District", "Moyo District", "Mpigi District", "Mubende District", "Mukono District", "Nakapiripirit District", "Nakaseke District", "Nakasongola District", "Namayingo District", "Namisindwa District", "Namutumba District", "Napak District", "Nebbi District", "Ngora District", "Northern Region", "Ntoroko District", "Ntungamo District", "Nwoya District", "Omoro District", "Otuke District", "Oyam District", "Pader District", "Pakwach District", "Pallisa District", "Rakai District", "Rubanda District", "Rubirizi District", "Rukiga District", "Rukungiri District", "Sembabule District", "Serere District", "Sheema District", "Sironko District", "Soroti District", "Tororo District", "Wakiso District", "Western Region", "Yumbe District", "Zombo District"]
    }, {
        name: "Ukraine",
        states: ["Autonomous Republic of Crimea", "Cherkaska oblast", "Chernihivska oblast", "Chernivetska oblast", "Dnipropetrovska oblast", "Donetska oblast", "Ivano-Frankivska oblast", "Kharkivska oblast", "Khersonska oblast", "Khmelnytska oblast", "Kirovohradska oblast", "Kyiv", "Kyivska oblast", "Luhanska oblast", "Lvivska oblast", "Mykolaivska oblast", "Odeska oblast", "Poltavska oblast", "Rivnenska oblast", "Sevastopol", "Sumska oblast", "Ternopilska oblast", "Vinnytska oblast", "Volynska oblast", "Zakarpatska Oblast", "Zaporizka oblast", "Zhytomyrska oblast"]
    }, {
        name: "United Arab Emirates",
        states: ["Abu Dhabi Emirate", "Ajman Emirate", "Dubai", "Fujairah", "Ras al-Khaimah", "Sharjah Emirate", "Umm al-Quwain"]
    }, {
        name: "United Kingdom",
        states: ["Aberdeen", "Aberdeenshire", "Angus", "Antrim", "Antrim and Newtownabbey", "Ards", "Ards and North Down", "Argyll and Bute", "Armagh City and District Council", "Armagh, Banbridge and Craigavon", "Ascension Island", "Ballymena Borough", "Ballymoney", "Banbridge", "Barnsley", "Bath and North East Somerset", "Bedford", "Belfast district", "Birmingham", "Blackburn with Darwen", "Blackpool", "Blaenau Gwent County Borough", "Bolton", "Bournemouth", "Bracknell Forest", "Bradford", "Bridgend County Borough", "Brighton and Hove", "Buckinghamshire", "Bury", "Caerphilly County Borough", "Calderdale", "Cambridgeshire", "Carmarthenshire", "Carrickfergus Borough Council", "Castlereagh", "Causeway Coast and Glens", "Central Bedfordshire", "Ceredigion", "Cheshire East", "Cheshire West and Chester", "City and County of Cardiff", "City and County of Swansea", "City of Bristol", "City of Derby", "City of Kingston upon Hull", "City of Leicester", "City of London", "City of Nottingham", "City of Peterborough", "City of Plymouth", "City of Portsmouth", "City of Southampton", "City of Stoke-on-Trent", "City of Sunderland", "City of Westminster", "City of Wolverhampton", "City of York", "Clackmannanshire", "Coleraine Borough Council", "Conwy County Borough", "Cookstown District Council", "Cornwall", "County Durham", "Coventry", "Craigavon Borough Council", "Cumbria", "Darlington", "Denbighshire", "Derbyshire", "Derry City and Strabane", "Derry City Council", "Devon", "Doncaster", "Dorset", "Down District Council", "Dudley", "Dumfries and Galloway", "Dundee", "Dungannon and South Tyrone Borough Council", "East Ayrshire", "East Dunbartonshire", "East Lothian", "East Renfrewshire", "East Riding of Yorkshire", "East Sussex", "Edinburgh", "England", "Essex", "Falkirk", "Fermanagh and Omagh", "Fermanagh District Council", "Fife", "Flintshire", "Gateshead", "Glasgow", "Gloucestershire", "Gwynedd", "Halton", "Hampshire", "Hartlepool", "Herefordshire", "Hertfordshire", "Highland", "Inverclyde", "Isle of Wight", "Isles of Scilly", "Kent", "Kirklees", "Knowsley", "Lancashire", "Larne Borough Council", "Leeds", "Leicestershire", "Limavady Borough Council", "Lincolnshire", "Lisburn and Castlereagh", "Lisburn City Council", "Liverpool", "London Borough of Barking and Dagenham", "London Borough of Barnet", "London Borough of Bexley", "London Borough of Brent", "London Borough of Bromley", "London Borough of Camden", "London Borough of Croydon", "London Borough of Ealing", "London Borough of Enfield", "London Borough of Hackney", "London Borough of Hammersmith and Fulham", "London Borough of Haringey", "London Borough of Harrow", "London Borough of Havering", "London Borough of Hillingdon", "London Borough of Hounslow", "London Borough of Islington", "London Borough of Lambeth", "London Borough of Lewisham", "London Borough of Merton", "London Borough of Newham", "London Borough of Redbridge", "London Borough of Richmond upon Thames", "London Borough of Southwark", "London Borough of Sutton", "London Borough of Tower Hamlets", "London Borough of Waltham Forest", "London Borough of Wandsworth", "Magherafelt District Council", "Manchester", "Medway", "Merthyr Tydfil County Borough", "Metropolitan Borough of Wigan", "Mid and East Antrim", "Mid Ulster", "Middlesbrough", "Midlothian", "Milton Keynes", "Monmouthshire", "Moray", "Moyle District Council", "Neath Port Talbot County Borough", "Newcastle upon Tyne", "Newport", "Newry and Mourne District Council", "Newry, Mourne and Down", "Newtownabbey Borough Council", "Norfolk", "North Ayrshire", "North Down Borough Council", "North East Lincolnshire", "North Lanarkshire", "North Lincolnshire", "North Somerset", "North Tyneside", "North Yorkshire", "Northamptonshire", "Northern Ireland", "Northumberland", "Nottinghamshire", "Oldham", "Omagh District Council", "Orkney Islands", "Outer Hebrides", "Oxfordshire", "Pembrokeshire", "Perth and Kinross", "Poole", "Powys", "Reading", "Redcar and Cleveland", "Renfrewshire", "Rhondda Cynon Taf", "Rochdale", "Rotherham", "Royal Borough of Greenwich", "Royal Borough of Kensington and Chelsea", "Royal Borough of Kingston upon Thames", "Rutland", "Saint Helena", "Salford", "Sandwell", "Scotland", "Scottish Borders", "Sefton", "Sheffield", "Shetland Islands", "Shropshire", "Slough", "Solihull", "Somerset", "South Ayrshire", "South Gloucestershire", "South Lanarkshire", "South Tyneside", "Southend-on-Sea", "St Helens", "Staffordshire", "Stirling", "Stockport", "Stockton-on-Tees", "Strabane District Council", "Suffolk", "Surrey", "Swindon", "Tameside", "Telford and Wrekin", "Thurrock", "Torbay", "Torfaen", "Trafford", "United Kingdom", "Vale of Glamorgan", "Wakefield", "Wales", "Walsall", "Warrington", "Warwickshire", "West Berkshire", "West Dunbartonshire", "West Lothian", "West Sussex", "Wiltshire", "Windsor and Maidenhead", "Wirral", "Wokingham", "Worcestershire", "Wrexham County Borough"]
    }, {
        name: "United States Minor Outlying Islands",
        states: ["Baker Island", "Howland Island", "Jarvis Island", "Johnston Atoll", "Kingman Reef", "Midway Islands", "Navassa Island", "Palmyra Atoll", "Wake Island"]
    }, {
        name: "Uruguay",
        states: ["Artigas", "Canelones", "Cerro Largo", "Colonia", "Durazno", "Flores", "Florida", "Lavalleja", "Maldonado", "Montevideo", "Paysandú", "Río Negro", "Rivera", "Rocha", "Salto", "San José", "Soriano", "Tacuarembó", "Treinta y Tres"]
    }, {
        name: "Uzbekistan",
        states: ["Andijan Region", "Bukhara Region", "Fergana Region", "Jizzakh Region", "Karakalpakstan", "Namangan Region", "Navoiy Region", "Qashqadaryo Region", "Samarqand Region", "Sirdaryo Region", "Surxondaryo Region", "Tashkent", "Tashkent Region", "Xorazm Region"]
    }, {
        name: "Vanuatu",
        states: ["Malampa", "Penama", "Sanma", "Shefa", "Tafea", "Torba"]
    }, {name: "Vatican City State (Holy See)", states: []}, {
        name: "Venezuela",
        states: ["Amazonas", "Anzoátegui", "Apure", "Aragua", "Barinas", "Bolívar", "Carabobo", "Cojedes", "Delta Amacuro", "Distrito Capital", "Falcón", "Federal Dependencies of Venezuela", "Guárico", "La Guaira", "Lara", "Mérida", "Miranda", "Monagas", "Nueva Esparta", "Portuguesa", "Sucre", "Táchira", "Trujillo", "Yaracuy", "Zulia"]
    }, {
        name: "Vietnam",
        states: ["An Giang", "Bà Rịa-Vũng Tàu", "Bắc Giang", "Bắc Kạn", "Bạc Liêu", "Bắc Ninh", "Bến Tre", "Bình Dương", "Bình Định", "Bình Phước", "Bình Thuận", "Cà Mau", "Cần Thơ", "Cao Bằng", "Đà Nẵng", "Đắk Lắk", "Đắk Nông", "Điện Biên", "Đồng Nai", "Đồng Tháp", "Gia Lai", "Hà Giang", "Hà Nam", "Hà Nội", "Hà Tĩnh", "Hải Dương", "Hải Phòng", "Hậu Giang", "Hồ Chí Minh", "Hòa Bình", "Hưng Yên", "Khánh Hòa", "Kiên Giang", "Kon Tum", "Lai Châu", "Lâm Đồng", "Lạng Sơn", "Lào Cai", "Long An", "Nam Định", "Nghệ An", "Ninh Bình", "Ninh Thuận", "Phú Thọ", "Phú Yên", "Quảng Bình", "Quảng Nam", "Quảng Ngãi", "Quảng Ninh", "Quảng Trị", "Sóc Trăng", "Sơn La", "Tây Ninh", "Thái Bình", "Thái Nguyên", "Thanh Hóa", "Thừa Thiên-Huế", "Tiền Giang", "Trà Vinh", "Tuyên Quang", "Vĩnh Long", "Vĩnh Phúc", "Yên Bái"]
    }, {name: "Virgin Islands (British)", states: []}, {
        name: "Virgin Islands (US)",
        states: ["Saint Croix", "Saint John", "Saint Thomas"]
    }, {name: "Wallis and Futuna Islands", states: []}, {name: "Western Sahara", states: []}, {
        name: "Yemen",
        states: ["'Adan", "'Amran", "Abyan", "Al Bayda'", "Al Hudaydah", "Al Jawf", "Al Mahrah", "Al Mahwit", "Amanat Al Asimah", "Dhamar", "Hadhramaut", "Hajjah", "Ibb", "Lahij", "Ma'rib", "Raymah", "Saada", "Sana'a", "Shabwah", "Socotra", "Ta'izz"]
    }, {
        name: "Zambia",
        states: ["Central Province", "Copperbelt Province", "Eastern Province", "Luapula Province", "Lusaka Province", "Muchinga Province", "Northern Province", "Northwestern Province", "Southern Province", "Western Province"]
    }, {
        name: "Zimbabwe",
        states: ["Bulawayo Province", "Harare Province", "Manicaland", "Mashonaland Central Province", "Mashonaland East Province", "Mashonaland West Province", "Masvingo Province", "Matabeleland North Province", "Matabeleland South Province", "Midlands Province"]
    }],
    states: {
        us: [
            {
                name: "Alabama",
                abbreviation: "AL"
            },
            {
                name: "Alaska",
                abbreviation: "AK"
            },
            {
                name: "Arkansas",
                abbreviation: "AR"
            },
            {
                name: "American Samoa",
                abbreviation: "AS"
            },
            {
                name: "Arizona",
                abbreviation: "AZ"
            },

            {
                name: "California",
                abbreviation: "CA"
            },
            {
                name: "Colorado",
                abbreviation: "CO"
            },
            {
                name: "Connecticut",
                abbreviation: "CT"
            },
            {
                name: "District Of Columbia",
                abbreviation: "DC"
            },
            {
                name: "Delaware",
                abbreviation: "DE"
            },
            {
                name: "Florida",
                abbreviation: "FL"
            },
            {
                name: "Federated States Of Micronesia",
                abbreviation: "FM"
            },
            {
                name: "Georgia",
                abbreviation: "GA"
            },
            {
                name: "Guam",
                abbreviation: "GU"
            },
            {
                name: "Hawaii",
                abbreviation: "HI"
            },
            {
                name: "Iowa",
                abbreviation: "IA"
            },
            {
                name: "Idaho",
                abbreviation: "ID"
            },
            {
                name: "Illinois",
                abbreviation: "IL"
            },
            {
                name: "Indiana",
                abbreviation: "IN"
            },
            {
                name: "Kansas",
                abbreviation: "KS"
            },
            {
                name: "Kentucky",
                abbreviation: "KY"
            },
            {
                name: "Louisiana",
                abbreviation: "LA"
            },
            {
                name: "Massachusetts",
                abbreviation: "MA"
            },
            {
                name: "Maryland",
                abbreviation: "MD"
            },
            {
                name: "Maine",
                abbreviation: "ME"
            },
            {
                name: "Marshall Islands",
                abbreviation: "MH"
            },
            {
                name: "Michigan",
                abbreviation: "MI"
            },
            {
                name: "Minnesota",
                abbreviation: "MN"
            },
            {
                name: "Missouri",
                abbreviation: "MO"
            },
            {
                name: "Mississippi",
                abbreviation: "MS"
            },
            {
                name: "Montana",
                abbreviation: "MT"
            },
            {
                name: "North Carolina",
                abbreviation: "NC"
            },
            {
                name: "North Dakota",
                abbreviation: "ND"
            },
            {
                name: "Nebraska",
                abbreviation: "NE"
            },
            {
                name: "New Hampshire",
                abbreviation: "NH"
            },
            {
                name: "New Jersey",
                abbreviation: "NJ"
            },
            {
                name: "New Mexico",
                abbreviation: "NM"
            },
            {
                name: "Nevada",
                abbreviation: "NV"
            },
            {
                name: "New York",
                abbreviation: "NY"
            },
            {
                name: "Northern Mariana Islands",
                abbreviation: "MP"
            },
            {
                name: "Ohio",
                abbreviation: "OH"
            },
            {
                name: "Oklahoma",
                abbreviation: "OK"
            },
            {
                name: "Oregon",
                abbreviation: "OR"
            },
            {
                name: "Pennsylvania",
                abbreviation: "PA"
            },
            {
                name: "Puerto Rico",
                abbreviation: "PR"
            },
            {
                name: "Palau",
                abbreviation: "PW"
            },
            {
                name: "Rhode Island",
                abbreviation: "RI"
            },
            {
                name: "South Carolina",
                abbreviation: "SC"
            },
            {
                name: "South Dakota",
                abbreviation: "SD"
            },
            {
                name: "Tennessee",
                abbreviation: "TN"
            },
            {
                name: "Texas",
                abbreviation: "TX"
            },
            {
                name: "Utah",
                abbreviation: "UT"
            },
            {
                name: "Virginia",
                abbreviation: "VA"
            },
            {
                name: "Virgin Islands",
                abbreviation: "VI"
            },
            {
                name: "Vermont",
                abbreviation: "VT"
            },
            {
                name: "Washington",
                abbreviation: "WA"
            },
            {
                name: "Wisconsin",
                abbreviation: "WI"
            },
            {
                name: "West Virginia",
                abbreviation: "WV"
            },
            {
                name: "Wyoming",
                abbreviation: "WY"
            }
        ],
        ca: [{
            name: 'Alberta',
            abbreviation: 'AB'
        }, {
            name: 'British Columbia',
            abbreviation: 'BC'
        }, {
            name: 'Manitoba',
            abbreviation: 'MB'
        }, {
            name: 'New Brunswick',
            abbreviation: 'NB'
        }, {
            name: 'Newfoundland and Labrador',
            abbreviation: 'NL'
        }, {
            name: 'Northwest Territories',
            abbreviation: 'NT'
        }, {
            name: 'Nova Scotia',
            abbreviation: 'NS'
        }, {
            name: 'Nunavut',
            abbreviation: 'NU'
        }, {
            name: 'Ontario',
            abbreviation: 'ON'
        }, {
            name: 'Prince Edward Island',
            abbreviation: 'PE'
        }, {
            name: 'Quebec',
            abbreviation: 'QC'
        }, {
            name: 'Saskatchewan',
            abbreviation: 'SK'
        }, {
            name: 'Yukon Territory',
            abbreviation: 'YT'
        }]
    },
    statusCodes: {
        GONE: 410
    }
};

PJQ.constants.colors = {
    BLUE: '#007bff',
    INDIGO: '#6610f2',
    PURPLE: '#6f42c1',
    PINK: '#e83e8c',
    RED: '#dc3545',
    ORANGE: '#fd7e14',
    YELLOW: '#ffc107',
    GREEN: '#4CAF50',
    TEAL: '#20c997',
    CYAN: '#17a2b8',
    WHITE: '#fff',
    GRAY: '#6c757d',
    DARK: '#343a40',
    BLACK: "#000000"
};

PJQ.constants.navigation = {
    categories: {
        FIELD_TOOLS: 1,
        BIDDING: 2,
        JOB_COSTING: 3
    },
    categoryNames: {
        1: 'Field Tools',
        2: 'Bidding',
        3: 'Job Costing'
    }
}

PJQ.constants.bidFormHelpers = {
    lineItemTypes: [
        {name: "Sum", abbreviation: "Sum"},
        {name: "Each", abbreviation: "Ea."},
        {name: "Square Feet", abbreviation: "Sq.Ft."},
        {name: "Linear Feet", abbreviation: "Ln.Ft."},
        {name: "Cubic Feet", abbreviation: "Cu.Ft."},
        {name: "Square Yards", abbreviation: "Sq.Yd."},
        {name: "Linear Yards", abbreviation: "Ln.Yd."},
        {name: "Cubic Yards", abbreviation: "Cu.Yd."},
        {name: "Acres", abbreviation: "Acres"},
        {name: "Hours", abbreviation: "Hrs"},
        {name: "Days", abbreviation: "Days"},
        {name: "Pounds", abbreviation: "Lbs."},
        {name: "Tons", abbreviation: "Tons"}
    ],
    acknowledgementTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    bondingTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    certificationTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    laborRateTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ]
};

PJQ.constants.primeContracts = {
    primeContractStatus: {
        DRAFT: 1,
        OUT_FOR_BID: 2,
        OUT_FOR_SIGNATURE: 3,
        APPROVED: 4,
        COMPLETE: 5,
        TERMINATED: 6
    },
    primeContractStatusNames: {
        1: 'Draft',
        2: 'Out for Bid',
        3: 'Out for Signature',
        4: 'Approved',
        5: 'Complete',
        6: 'Terminated'
    },
    changeOrderStatus: {
        DRAFT: 0,
        NO_CHARGE: 1,
        IN_REVIEW: 2,
        NOT_PRICING: 3,
        PRICING: 4,
        NOT_PROCEEDING: 5,
        PROCEEDING: 6,
        REVISED: 7,
        APPROVED: 8,
        REJECTED: 9,
        VOID: 10
    },
    primeContractStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 3]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 3, 4, 5]
        },
        APPROVED: {
            name: "Approved",
            statuses: [4, 5]
        }
    },
    changeOrderStatusNames: {
        0: 'Draft',
        1: 'No Charge',
        2: 'In Review',
        3: 'Not Pricing',
        4: 'Pricing',
        5: 'Not Proceeding',
        6: 'Proceeding',
        7: 'Revised',
        8: 'Approved',
        9: 'Rejected',
        10: 'Void'
    },
    changeOrderStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 4, 6, 7]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 4, 6, 7, 8]
        },
        APPROVED: {
            name: "Approved",
            statuses: [8]
        }
    },
    view: {
        PRIME_CONTRACTS: "primecontracts",
        CHANGE_ORDERS: "changeorders"
    },
    filterType: {
        PRIME_CONTRACT_STATUS_FILTER: "primeContractStatusFilter"
    },
    changeOrderFilterType: {
        STATUS_FILTER: "statusFilter"
    }
}

PJQ.constants.financeCoreFields = {
    primeContacts: {
        primeContract: [
            {
                name: "Number",
                fieldName: "number",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Work Retainage",
                fieldName: "defaultWorkRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Material Retainage",
                fieldName: "defaultMaterialRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Terms",
                fieldName: "termsId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Description",
                fieldName: "description",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Start Date",
                fieldName: "startOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Estimated Completion Date",
                fieldName: "estimatedCompleteOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Substantial Completion Date",
                fieldName: "substantialCompleteOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Actual Completion Date",
                fieldName: "actualCompleteOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Contract Date",
                fieldName: "contractOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Contract Received Date",
                fieldName: "signedContractOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Letter of Intent Date",
                fieldName: "letterOfIntentOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Approval Letter Date",
                fieldName: "approvalLetterOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Issued On Date",
                fieldName: "issuedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Execution Date",
                fieldName: "executedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Returned Date",
                fieldName: "returnedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Contract Termination Date",
                fieldName: "contractTerminatedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Inclusions",
                fieldName: "inclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Exclusions",
                fieldName: "exclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Documents",
                fieldName: "signedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Executed Documents",
                fieldName: "executedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Attachments",
                fieldName: "attachments",
                isVisible: true,
                isRequired: false
            }
        ],
        changeOrder: [
            {
                name: "Reviewer",
                fieldName: "reviewer"
            },
            {
                name: "Received From",
                fieldName: "receivedFromId"
            },
            {
                name: "Number",
                fieldName: "number"
            },
            {
                name: "Executed",
                fieldName: "executed"
            },
            {
                name: "Field Change",
                fieldName: "fieldChange"
            },
            {
                name: "Paid In Full",
                fieldName: "paidInFull"
            },
            {
                name: "Change Reason",
                fieldName: "changeReason"
            },
            {
                name: "Invoiced Date",
                fieldName: "invoicedDate"
            },
            {
                name: "Due Date",
                fieldName: "dueDate"
            },
            {
                name: "Description",
                fieldName: "description"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    },
    commitments: {
        commitment: [
            {
                name: "Invoice Contact",
                fieldName: "invoiceContactId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Number",
                fieldName: "number",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Title",
                fieldName: "title",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Work Retainage",
                fieldName: "defaultWorkRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Material Retainage",
                fieldName: "defaultMaterialRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Ship To",
                fieldName: "shipToId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Bill To",
                fieldName: "billToId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Terms",
                fieldName: "termsId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Description",
                fieldName: "description",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Start Date",
                fieldName: "startDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Estimated Completion Date",
                fieldName: "estimatedCompletionDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Actual Completion Date",
                fieldName: "actualCompletionDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Contract Date",
                fieldName: "contractDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Contract Received Date",
                fieldName: "signedContractReceivedDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Letter of Intent Date",
                fieldName: "letterOfIntentDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Approval Letter Date",
                fieldName: "approvalLetterDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Issued On Date",
                fieldName: "issuedOnDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Execution Date",
                fieldName: "executionDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Returned Date",
                fieldName: "returnedDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Inclusions",
                fieldName: "inclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Exclusions",
                fieldName: "exclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Certificate of Insurance",
                fieldName: "coiAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Delivery Date",
                fieldName: "deliveryDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Payment Terms",
                fieldName: "paymentTerms",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Shipping Terms",
                fieldName: "shipVia",
                isVisible: true,
                isRequired: false
            },
            {
                name: "W9",
                fieldName: "w9Attachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Lien Waivers",
                fieldName: "lienWaiverAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Documents",
                fieldName: "signedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Affidavits",
                fieldName: "affidavitAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Executed Documents",
                fieldName: "executedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Attachments",
                fieldName: "attachments",
                isVisible: true,
                isRequired: false
            }
        ],
        changeOrder: [
            {
                name: "Reviewer",
                fieldName: "reviewer"
            },
            {
                name: "Received From",
                fieldName: "receivedFromId"
            },
            {
                name: "Number",
                fieldName: "number"
            },
            {
                name: "Executed",
                fieldName: "executed"
            },
            {
                name: "Field Change",
                fieldName: "fieldChange"
            },
            {
                name: "Paid In Full",
                fieldName: "paidInFull"
            },
            {
                name: "Change Reason",
                fieldName: "changeReason"
            },
            {
                name: "Invoiced Date",
                fieldName: "invoicedDate"
            },
            {
                name: "Due Date",
                fieldName: "dueDate"
            },
            {
                name: "Description",
                fieldName: "description"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    },
    invoices: {
        payableInvoice: [
            {
                name: "Invoice #",
                fieldName: "number"
            },
            {
                name: "Paid",
                fieldName: "paid"
            },
            {
                name: "Notes",
                fieldName: "notes"
            },
            {
                name: "Certificate of Insurance",
                fieldName: "coiAttachments"
            },
            {
                name: "W9",
                fieldName: "w9Attachments"
            },
            {
                name: "Lien Waivers",
                fieldName: "lienWaiverAttachments"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ],
        receivableInvoice: [
            {
                name: "Invoice #",
                fieldName: "number"
            },
            {
                name: "Paid",
                fieldName: "paid"
            },
            {
                name: "Notes",
                fieldName: "notes"
            },

            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    },
    directCosts: {
        directCost: [
            {
                name: "Vendor",
                fieldName: "vendor"
            },
            {
                name: "Reported By",
                fieldName: "reportedBy"
            },
            {
                name: "Type",
                fieldName: "type"
            },
            {
                name: "Applied On",
                fieldName: "appliedOn"
            },
            {
                name: "Received On",
                fieldName: "receivedOn"
            },
            {
                name: "Paid On",
                fieldName: "paidOn"
            },
            {
                name: "Terms",
                fieldName: "terms"
            },
            {
                name: "Description",
                fieldName: "description"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    }
};

PJQ.constants.primeContractChangeOrders = {
    status: {
        DRAFT: 1,
        NO_CHARGE: 2,
        IN_REVIEW: 3,
        NOT_PRICING: 4,
        PRICING: 5,
        NOT_PROCEEDING: 6,
        PROCEEDING: 7,
        REVISED: 8,
        APPROVED: 9,
        REJECTED: 10,
        VOID: 11
    },
    statusNames: {
        1: 'Draft',
        2: 'No Charge',
        3: 'In Review',
        4: 'Not Pricing',
        5: 'Pricing',
        6: 'Not Proceeding',
        7: 'Proceeding',
        8: 'Revised',
        9: 'Approved',
        10: 'Rejected',
        11: 'Void'
    }
};

PJQ.constants.invoicing = {
    payableInvoiceStatus: {
        DRAFT: 0,
        REVIEWING: 1,
        REVISE: 2,
        APPROVED: 3,
        COMPLETE: 4,
        VOID: 5
    },
    payableInvoiceStatusNames: {
        0: 'Draft',
        1: 'Under Review',
        2: 'Revise',
        3: 'Approved',
        4: 'Complete',
        5: 'Void'
    },
    inviteStatus: {
        'DECLINED': 0,
        'ACCEPTED': 1
    },
    receivableInvoiceStatus: {
        DRAFT: 0,
        REVIEWING: 1,
        REVISE: 2,
        APPROVED: 3,
        COMPLETE: 4
    },
    receivableInvoiceStatusNames: {
        0: 'Draft',
        1: 'Under Review',
        2: 'Revise',
        3: 'Approved',
        4: 'Complete'
    },
    filterType: {
        STATUS_FILTER: 'statusFilter'
    },
    view: {
        PAYABLE_INVOICES: "payableinvoices",
        RECEIVABLE_INVOICES: "receivableinvoices"
    },
    paymentMethods: [
        'Credit Card',
        'Check',
        'Electronic'
    ]
};

PJQ.constants.directcosts = {
    directCostType: {
        EXPENSE: 1,
        INVOICE: 2,
        PAYROLL: 3
    },
    directCostTypeNames: {
        1: 'Expense',
        2: 'Invoice',
        3: 'Payroll'
    },
    directCostStatus: {
        DRAFT: 1,
        PENDING: 2,
        REVISE: 3,
        APPROVED: 4
    },
    directCostStatusNames: {
        1: 'Draft',
        2: 'Pending',
        3: 'Revise',
        4: 'Approved'
    },
    filterType: {
        DIRECT_COST_TYPE_FILTER: 'directCostTypeFilter',
        DIRECT_COST_STATUS_FILTER: 'directCostStatusFilter'
    },
    view: {
        DIRECT_COSTS: "directcosts"
    }
};

PJQ.constants.projectContacts = {
    bidStatus: {
        PENDING: 'PENDING',
        DECLINE: 'DECLINE',
        ACCEPT: 'ACCEPT',
        BID_RECEIVED: 'BID RECEIVED',
        AWARDED: 'AWARDED'
    }
};

PJQ.constants.markup = {
    requiredAst: '<span class="text-danger">*</span>'
};

PJQ.constants.cookies = {
    ACTION_ITEM_ORDER_COOKIE: "11236b4e-6da4-4576-98f5-981e8a30b385",
    CLOSE_PREQUAL_HELP_ALERT: "4343fee1-dcf7-487d-bf4d-7ab33976eef8",
    NOTIFY_CONTACT_GROUPS_REPORTED: "2f1c6d7f-1f6a-4a8e-9bee-aaa4153e1116",
    NOTIFY_DAILY_REPORTS_PROJECT_START_END: "0a71555e-3244-4e9d-b94c-cbf4234d56d6",
    PROJECT_INVITES_FAVORITE_FILTER: "PROJECT_INVITES_FAVORITE_FILTER",
    PROJECT_INVITES_CURRENT_BIDDING_FILTER: "PROJECT_INVITES_CURRENT_BIDDING_FILTER",
    PROJECT_INVITES_ORDER_COOKIE: "091ca838-72c2-4f0c-a219-90a65159c75e",
    SCHEDULE_TEMPLATE_DATES_ORIGIN: "f100ed94-6a16-40c9-8ace-7718a2c0ee4b",
    RFI_PAGE_LENGTH: "3F156499-1584-4152-9BE7-216A933B03A5",
    SCHEDULE_TASK_LIST_GROUP_BY: "3F156499-1584-4152-9BE7-216A933B03A5",
    SUBSCRIPTION_FREE_TRIAL: "97ebfdec-ba47-4c21-84a7-1009f4a4cb32",
    SUBSCRIPTION_EXPIRES_ALERT: "c649a742-859f-4096-b6cf-f9aa57951b43",
    SUBMITTAL_ORDER_COOKIE: "f78a796d-cfda-4ba1-acf3-1ae2f8c15446",
    PUNCHLIST_ORDER_COOKIE: "f3e968f2-bcaf-49a1-9cc1-cceae3824ca8",
    CHANGE_REQUEST_ORDER_COOKIE: "ca299ec1-9ab0-4df5-ace7-997761c1907d",
    INSPECTIONS_ORDER_COOKIE: "dbf2eec6-e4da-442b-9795-118d0ff99966",
    INSPECTIONS_GROUP_BY_KEY: "inspections_group_by",
    PRODUCTION_QUANTITIES_ORDER_COOKIE: "b2f32e3a-c94f-4bd3-b771-e96905bcca6b",
    NOTIFY_PREQUAL_VIEW_REQUESTED: "cf6adedb-ca86-4477-86bb-4728679b2041",
    NOTIFY_DRAWING_SHARE_PREVENT_EXPIRE: "65524272-cb10-40ab-a22f-952ce70c451f",
    ALERT_DRAWING_SHARE_PREVENT_EXPIRE: "65524272-cb10-40ab-a22f-952ce70c451f",
    ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS: "ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS",
    SCHEDULE_GANTT_SORT_COLUMN: "40a8d697-9043-4fbb-ab82-2c74e80a3378",
    SCHEDULE_GANTT_SORT_DIRECTION: "6c4475a4-8dbc-475d-8517-d8573e5024c0",
    SCHEDULE_TASK_LIST_ORDER: "b834b7c5-8ddb-49bd-a972-6f57bb4e32e0",
    PROJECT_CONTACT_LIST_ORDER: "c8b0b215-d05e-4e0b-b967-05844374dc87",
    PROJECT_CONTACT_LIST_PAGE_LENGTH: "4f97ff02-e73d-437a-abec-d8bef4d4a7dc",
    COMMITMENT_LIST_COLUMNS_WIDTH: "998db2bb-00e1-4516-859f-47b06c540046",
    MY_PROJECTS_LIST_COLUMNS_WIDTH: "8efccf80-0aa4-46a0-89cf-2eadca8ca897",
    PROJECT_INVITES_LIST_COLUMNS_WIDTH: "06b506e3-5006-43a3-a5bd-0bf6e7cb9077",
    PRODUCTION_QUANTITIES_COLUMNS_WIDTH: "7bd78c30-b8d7-4810-a3f0-c98dea1e52dd"
};

PJQ.constants.changeRequests = {
    changeRequestStatus: {
        DRAFT: 0,
        NO_CHARGE: 1,
        IN_REVIEW: 2,
        NOT_PRICING: 3,
        PRICING: 4,
        NOT_PROCEEDING: 5,
        PROCEEDING: 6,
        REVISED: 7,
        APPROVED: 8,
        REJECTED: 9,
        VOID: 10
    },
    changeRequestStatusNames: {
        0: 'Draft',
        1: 'No Charge',
        2: 'In Review',
        3: 'Not Pricing',
        4: 'Pricing',
        5: 'Not Proceeding',
        6: 'Proceeding',
        7: 'Revised',
        8: 'Approved',
        9: 'Rejected',
        10: 'Void'
    },
    scope: {
        OWNER_CHANGE: 0,
        INTERNAL: 1
    },
    scopeNames: {
        0: 'Owner Change',
        1: 'Internal'
    },
    revenueSource: {
        COST: 0,
        MANUAL: 1
    },
    revenueSourceNames: {
        0: 'Revenue',
        1: 'Manual'
    },
    filterType: {
        STATUS_FILTER: 'statusFilter',
        OTHER_FILTER: 'other'
    },
    view: {
        CHANGE_REQUESTS: "changerequests"
    },
    changeRequestStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 4, 6, 7]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 4, 6, 7, 8]
        },
        APPROVED: {
            name: "Approved",
            statuses: [8]
        }
    },
};

PJQ.constants.rfq = {
    filterType: {
        STATUS_FILTER: 'statusFilter'
    }, rfqStatus: {
        DRAFT: 0,
        PRICING: 1,
        REVIEWING: 2,
        REVISE: 3,
        APPROVED: 4,
        CLOSED: 5
    },
    rfqStatusNames: {
        0: 'Draft',
        1: 'Pricing',
        2: 'Reviewing',
        3: 'Revise',
        4: 'Approved',
        5: 'Closed'
    },
    view: {
        RFQ: "rfq"
    }
}

PJQ.constants.commitments = {
    commitmentType: {
        PURCHASE_ORDER: 1,
        SUBCONTRACT: 2
    },
    commitmentTypeNames: {
        1: 'Purchase Order',
        2: 'Subcontract'
    },
    commitmentStatus: {
        DRAFT: 0,
        PURCHASE_ORDER_PROCESSING: 1,
        SUBCONTRACT_OUT_FOR_BID: 2,
        OUT_FOR_SIGNATURE: 3,
        SUBMITTED: 4,
        PURCHASE_ORDER_PARTIALLY_RECEIVED: 5,
        PURCHASE_ORDER_RECEIVED: 6,
        APPROVED: 7,
        SUBCONTRACT_COMPLETE: 8,
        SUBCONTRACT_TERMINATED: 9,
        SUBCONTRACT_VOID: 10,
        PURCHASE_ORDER_CLOSED: 11
    },
    commitmentStatusNames: {
        0: 'Draft',
        1: 'Processing',
        2: 'Out for Bid',
        3: 'Out for Signature',
        4: 'Submitted',
        5: 'Partially Received',
        6: 'Received',
        7: 'Approved',
        8: 'Complete',
        9: 'Terminated',
        10: 'Void',
        11: 'Closed'
    },
    commitmentStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [1, 2, 3, 4, 5, 6]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [1, 2, 3, 4, 5, 6, 7, 8, 11]
        },
        COMMITTED: {
            name: "Committed",
            statuses: [7, 8, 11]
        }
    },
    changeOrderStatus: {
        DRAFT: 0,
        NO_CHARGE: 1,
        IN_REVIEW: 2,
        NOT_PRICING: 3,
        PRICING: 4,
        NOT_PROCEEDING: 5,
        PROCEEDING: 6,
        REVISED: 7,
        APPROVED: 8,
        REJECTED: 9,
        VOID: 10
    },
    changeOrderStatusNames: {
        0: 'Draft',
        1: 'No Charge',
        2: 'In Review',
        3: 'Not Pricing',
        4: 'Pricing',
        5: 'Not Proceeding',
        6: 'Proceeding',
        7: 'Revised',
        8: 'Approved',
        9: 'Rejected',
        10: 'Void'
    },
    changeOrderStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 4, 6, 7]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 4, 6, 7, 8]
        },
        COMMITTED: {
            name: "Committed",
            statuses: [8]
        }
    },
    filterType: {
        TYPE_FILTER: 'typeFilter',
        STATUS_FILTER: 'statusFilter'
    },
    changeOrderFilterType: {
        STATUS_FILTER: 'statusFilter'
    },
    view: {
        COMMITMENTS: "commitments",
        CHANGE_ORDERS: "changeorders"
    },
    commitmentNumberTokenDateFormat: {
        MMDDYYYY: 0,
        MM: 1,
        DD: 2,
        YY: 3,
        YYYY: 4
    },
    commitmentNumberTokenDateFormatNames: [
        'Full Date',
        'Month',
        'Day',
        'Year 2-Digit',
        'Year'
    ],
    // TODO: this needs to be moved to the new customField
    customFieldType: {
        BOOLEAN: 1,
        CHOICE: 2,
        DATE: 3,
        DATETIME: 4,
        FILE: 5,
        INTEGER: 6,
        MONEY: 7,
        PERCENT: 8,
        TEXT: 9,
        TEXTAREA: 10
    }
};

PJQ.constants.regex = {
    CURRENCY_NO_SYMBOL: /(\d)(?=(\d\d\d)+(?!\d))/g
};

PJQ.constants.modules = {
    APP: 'APP',
    GLOBAL: 'GLOBAL',
    PROFILE_OLD: 'PJQPROFILE',
    PROFILE: 'PROFILE',
    ACTIONITEMS: 'ACTIONITEMS',
    BIDFORMS: 'BIDFORMS',
    PJQADDRESSBOOK: 'PJQADDRESSBOOK',
    ADDRESSBOOK: 'ADDRESSBOOK',
    PUBLICPROJECTS: 'PJQPUBLICPROJECTS',
    PROJECTWALL: 'PROJECTWALL',
    PROJECTWALLADMIN: 'PJQPROJECTWALLADMIN',
    PROJECTWALLSUB: 'PJQPROJECTWALLSUB',
    PROJECTLIST: 'PROJECTLIST',
    REPORTS: 'REPORTS',
    RFI: 'RFI',
    RESOURCES: 'RESOURCES',
    SUBMITTALS: 'SUBMITTALS',
    FIELDREPORTS: 'FIELDREPORTS',
    MARKUPTOOL: 'MARKUPTOOL',
    PUNCHLISTS: 'PUNCHLISTS',
    DAILYREPORTS: 'DAILYREPORTS',
    LOGIN: 'PJQLOGIN',
    ACCESS_KEY_LOGIN: 'PJQACCESSKEYLOGIN',
    PJQSETTINGS: 'PJQSETTINGS',
    SETTINGS: 'SETTINGS',
    SUBMITTALS: 'SUBMITTALS',
    PANTERASCHEDULE: 'PANTERASCHEDULE',
    DRAWINGS: 'DRAWINGS',
    BIDFILER: 'PJQBIDFILER',
    PRINTONDEMAND: 'PJQPRINTONDEMAND',
    PJQREGISTRATION: 'PJQREGISTRATION',
    FILES: 'FILES',
    SCHEDULE: 'SCHEDULE',
    TIMECARDS: 'TIMECARDS',
    INVOICES: 'INVOICES',
    BUDGET: 'BUDGET',
    COMMITMENTS: 'COMMITMENTS',
    PRIMECONTRACTS: 'PRIMECONTRACTS',
    DIRECTCOSTS: 'DIRECTCOSTS',
    INVOICING: 'INVOICING',
    MEETINGS: 'MEETINGS',
    INSPECTIONS: 'INSPECTIONS'
};

PJQ.constants.errorCodes = {
    DELETED_CONTACT: 100
};

PJQ.constants.auth = {
    minUsernameLength: 5,
    minPasswordLength: 5,
    login: {
        errorText: {
            INVALID_PASSWORD: 'The username or password you entered was incorrect.',
            USER_NOT_FOUND: 'The username you entered doesn\'t exist.'
        }
    }
};

PJQ.constants.screenings = {
    statuses: {
        WAITING: 1,
        UNUSED: 2,
        IN_PROCESS: 3,
        INCOMPLETE: 4,
        FEEDBACK_REQUIRED: 5,
        EXPIRED: 6,
        COMPLETE: 7,
        NOT_APPLICABLE: 8
    }
};
PJQ.constants.contacts = {
    contexts: {
        PARTICIPANTS: "PARTICIPANTS",
        CONTACTS: "CONTACTS",
        PROJECTCONTACTS: "PROJECTCONTACTS",
        USERS: "USERS",
        COMPANIES: "COMPANIES"
    }
};

PJQ.constants.customFields = {
    fieldTypes: {
        INT: 'INT',
        PERCENT: 'PERCENT',
        MONEY: 'MONEY',
        CALC: 'CALC',
        PHONE: 'PHONE',
        TEXT: 'TEXT',
        TEXTAREA: 'TEXTAREA',
        BOOL: 'BOOL',
        CHOICE: 'CHOICE',
        GRID: 'GRID',
        GROUPSELECT: 'GROUPSELECT',
        REGIONSELECT: 'REGIONSELECT',
        DOWNLOAD: 'DOWNLOAD',
        UPLOAD: 'FILE',
        DATE: 'DATE',
        DATETIME: 'DATETIME',
        CUSTOMGRID: 'CUSTOMGRID',
        UPLOADV2: 'UPLOADV2'
    },

};


PJQ.constants.projects = {
    customFields: {
        fieldTypes: [
            PJQ.constants.customFields.fieldTypes.INT,
            PJQ.constants.customFields.fieldTypes.PERCENT,
            PJQ.constants.customFields.fieldTypes.MONEY,
            PJQ.constants.customFields.fieldTypes.TEXT,
            PJQ.constants.customFields.fieldTypes.TEXTAREA,
            PJQ.constants.customFields.fieldTypes.BOOL,
            PJQ.constants.customFields.fieldTypes.CHOICE,
            PJQ.constants.customFields.fieldTypes.DATE,
            PJQ.constants.customFields.fieldTypes.DATETIME
        ]
    }
};

PJQ.constants.ordering = {
    paperSize: {
        FULL: 'FULL SIZE',
        HALF: 'HALF SIZE'
    },
    paper: {
        WHITE: 'WHITE BOND',
        BLUE: 'BLUE BOND',
        GREEN: 'GREEN BOND',
        YELLOW: 'YELLOW BOND',
        PINK: 'PINK BOND'
    },
    largeBinding: {
        STAPLED: 'STAPLED',
        LOOSE: 'LOOSE',
        EDGE: 'BINDING EDGE',
        PUNCHBIND: 'PUNCH AND BIND'
    },
    smallBinding: {
        STAPLED: 'STAPLED',
        LOOSE: 'LOOSE',
        CHICAGO: 'CHICAGO SCREW',
        GBC: 'GBC PLASTIC COMB'
    },
    deliveryOptions: {
        NEXTMORNING: 'Next Day (Morning)',
        NEXTDAY: 'Next Day (Standard)',
        TWODAY: 'Two Day',
        THREEDAY: 'Three Day'
    }
};

PJQ.constants.general = {
    defaultView: {
        COMPANY: 'View by Company',
        MESSAGE: 'View by Message',
        RESPONSE: 'View by Response',
        GROUPS: 'View by Groups',
        SCOPE: 'View by Scope'
    },
    defaultTimeZone: {
        ALASKAN: 'Alaskan',
        ATLANTIC: 'Atlantic',
        CENTRAL: 'Central',
        EASTERN: 'Eastern',
        HAWAIIAN: 'Hawaiian',
        MOUNTAIN: 'Mountain',
        PACIFIC: 'Pacific'
    }
};

PJQ.constants.time = {
    millis: {
        ONE_SECOND: 1000,
        ONE_MINUTE: 60000,
        ONE_HOUR: 3600000,
        ONE_DAY: 86400000,
        ONE_MONTH: 2592000000,
        ONE_YEAR: 31556952000
    }
};

PJQ.constants.files = {
    modes: {
        PRINT: 'print',
        ALT_PRINT: 'altprint',
        DOWNLOAD: 'download'
    },
    zipStatus: {
        NEW: 0,
        QUEUED: 1,
        IN_PROGRESS: 2,
        CANCELLED: 3,
        FAILED: 4,
        COMPLETE: 5,
        COMPLETE_ASYNC: 6
    },
    downloadFrameId: 'pjqDownload',
    imageExtensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif']
};

PJQ.constants.actionItems = {
    notificationTypeNames: {
        NEW_ITEM: 'Item Created',
        STATUS_CHANGE: 'Status Changed',
        ASSIGNED: 'Assigned',
        NEWCOMMENT: 'Comment Added',
        DISTRIBUTE: 'Distribution'
    },
    statuses: {
        NEW: 0,
        ASSIGNED: 4,
        WORK_COMPLETED: 2,
        NOT_RESOLVED: 1,
        RESOLVED: 3
    },
    statusNames: {
        0: 'New',
        1: 'Not Resolved',
        2: 'Work Completed',
        3: 'Resolved',
        4: 'Assigned'
    },
    statusColors: {
        0: PJQ.constants.colors.GRAY,
        1: PJQ.constants.colors.RED,
        2: PJQ.constants.colors.BLUE,
        3: PJQ.constants.colors.GREEN,
        4: PJQ.constants.colors.PURPLE
    },
    priorities: {
        LOW: 0,
        MEDIUM: 1,
        HIGH: 2,
        CRITICAL: 3
    },
    priorityNames: {
        0: 'Low',
        1: 'Medium',
        2: 'High',
        3: 'Critical',
    },
    priorityColors: {
        0: PJQ.constants.colors.GREEN,
        1: PJQ.constants.colors.YELLOW,
        2: PJQ.constants.colors.ORANGE,
        3: PJQ.constants.colors.RED
    },
    view: {
        ACTIONITEMS: "actionitems"
    }
};

PJQ.constants.dailyReports = {
    statuses: {
        NOT_SUBMITTED: 0,
        SUBMITTED: 1,
        DAY_OFF: 2,
        MISSED: 3
    },
    statusNames: {
        0: 'Not Submitted',
        1: 'Submitted',
        2: 'Day Off',
        3: 'Missed'
    },
    notificationModes: {
        DEFAULT: 1,
        PER_USER_DAY: 2,
        DISABLED: 3
    },
    communicationLogs: {
        types: {
            PHONE: 0,
            TEXT: 1,
            EMAIL: 2,
            IN_PERSON: 3,
            CONFERENCE_CALL: 4,
            WEB_CONFERENCE: 5
        },
        typeNames: {
            0: "Phone Call",
            1: "Text Message",
            2: "Email",
            3: "In Person",
            4: "Conference Call",
            5: "Web Conference"
        }
    },
    inspectionLogs: {
        statuses: {
            REJECTED: 0,
            APPROVED: 1
        },
        statusNames: {
            0: "Rejected",
            1: "Approved"
        }
    }
};

PJQ.constants.meetings = {
    meetingStatus: {
        DRAFT: 1,
        SCHEDULED: 2,
        IN_PROGRESS: 3,
        CONCLUDED: 4,
        CANCELLED: 5
    },
    meetingStatusNames: {
        1: 'Draft',
        2: 'Scheduled',
        3: 'In Progress',
        4: 'Concluded',
        5: 'Cancelled'
    },
    meetingAgendaStatus: {
        OPEN: 1,
        CLOSED: 2,
        HALTED: 3
    },
    meetingAgendaStatusNames: {
        1: 'Open',
        2: 'Closed',
        3: 'Halted'
    },
    meetingAgendaStatusColors: {
        1: PJQ.constants.colors.GREEN,
        2: PJQ.constants.colors.RED,
        3: PJQ.constants.colors.DARK
    },
    meetingAgendaPriority: {
        LOW: 1,
        MEDIUM: 2,
        HIGH: 3,
        URGENT: 4
    },
    meetingAgendaPriorityNames: {
        1: 'Low',
        2: 'Medium',
        3: 'High',
        4: 'Urgent'
    },
    meetingAgendaPriorityColors: {
        1: PJQ.constants.colors.GREEN,
        2: PJQ.constants.colors.YELLOW,
        3: PJQ.constants.colors.RED,
        4: PJQ.constants.colors.DARK
    }
}

PJQ.constants.punchlists = {
    notificationTypeNames: {
        NEW_ITEM: 'Item Created',
        STATUS_CHANGE: 'Status Changed',
        ASSIGNED: 'Assigned',
        NEWCOMMENT: 'Comment Added',
        DISTRIBUTE: 'Distribution'
    },
    statuses: {
        NEW: 0,
        NOT_RESOLVED: 1,
        WORK_COMPLETED: 2,
        RESOLVED: 3,
        ASSIGNED: 4
    },
    statusNames: {
        0: 'New',
        1: 'Not Resolved',
        2: 'Work Completed',
        3: 'Resolved',
        4: 'Assigned'
    },
    statusColors: {
        0: PJQ.constants.colors.GRAY,
        1: PJQ.constants.colors.RED,
        2: PJQ.constants.colors.BLUE,
        3: PJQ.constants.colors.GREEN,
        4: PJQ.constants.colors.PURPLE
    },
    priorities: {
        LOW: 0,
        MEDIUM: 1,
        HIGH: 2,
        CRITICAL: 3
    },
    priorityNames: {
        0: 'Low',
        1: 'Medium',
        2: 'High',
        3: 'Critical',
    },
    priorityColors: {
        0: PJQ.constants.colors.GREEN,
        1: PJQ.constants.colors.YELLOW,
        2: PJQ.constants.colors.ORANGE,
        3: PJQ.constants.colors.RED
    },
    view: {
        PUNCHLISTS: "punchlists"
    }
};

PJQ.constants.rfi = {
    notificationTypeNames: {
        NEW_ITEM: 'Item Opened',
        RFIOpen: 'Item Opened',
        RFIUpdateDueDate: 'Due Date Updated',
        RFIAddDocument: 'Document Added',
        RFIAddAssignee: 'Assignee Added',
        RFIAddDistribution: 'Dist. Contact Added',
        RFIAddResponse: 'Response Added',
        RFIClose: 'Item Closed',
        Overdue: 'Overdue'
    },
    statuses: {
        DRAFT: 0,
        OPEN: 1,
        CLOSED: 2,
        DISTRIBUTED: 3
    },
    statusNames: {
        0: 'Draft',
        1: 'Open',
        2: 'Closed',
        3: 'Distributed'
    },
    statusColors: {
        0: PJQ.constants.colors.BLUE,
        1: PJQ.constants.colors.GREEN,
        2: PJQ.constants.colors.GRAY,
        3: PJQ.constants.colors.PURPLE
    },
    view: {
        RFIS: "rfis"
    }
};

PJQ.constants.submittals = {
    notificationTypeNames: {
        Created: 'Created',
        Attachment: 'Attachment',
        Comment: 'Comment',
        BallInCourt: 'Ball In Court',
        'Ball In Court': 'Ball In Court',
        Approved: 'Approved',
        'File(s) Uploaded': 'File(s) Uploaded',
        Rejected: 'Rejected',
        Submitted: 'Submitted',
        Assigned: 'Assigned',
        Overdue: 'Overdue',
        Distribute: 'Distribution'
    },
    errors: {
        STATUS_NOT_EXISTS: 'STATUS_NOT_EXISTS'
    },
    approvalModes: {
        UNORDERED: 1,
        SEQUENTIAL: 2
    },
    statusTypeColors: {
        0: PJQ.constants.colors.GRAY,
        1: PJQ.constants.colors.BLUE,
        2: PJQ.constants.colors.GREEN,
        3: PJQ.constants.colors.RED,
        4: PJQ.constants.colors.DARK
    },
    statusTypes: {
        NEW: 0,
        SUBMITTED: 1,
        APPROVED: 2,
        REJECTED: 3,
        VOID: 4
    },
    statusTypeNames: {
        0: 'New',
        1: 'Submitted',
        2: 'Approved',
        3: 'Rejected',
        4: 'Void'
    },
    view: {
        SUBMITTALS: 'submittals'
    }
};

PJQ.constants.schedule = {
    notificationTypeNames: {
        ASSIGNED: 'Assigned',
        SCHEDULE_CHANGE: 'Schedule Changed',
        REMINDER: 'Reminder',
        COMMENT_ADDED: 'Comment Added',
        ATTACHMENT_ADDED: 'Attachment Added',
        TASK_COMPLETE: 'Task Complete',
        SCHEDULE_UPDATE: 'Schedule Update'
    },
    dependencyTypes: {
        START_START: 'SS',
        FINISH_START: 'FS'
    },
    linkTypes: {
        0: 'FS',
        1: 'SS',
        2: 'FF',
        3: 'SF'
    },
    views: {
        TIMELINE: 'TIMELINE',
        CALENDAR: 'CALENDAR',
        TASK_LIST: 'TASK_LIST'
    },
    taskList: {
        groupBy: {
            DEFAULT: 'DEFAULT',
            MONTH: 'MONTH',
            WEEK: 'WEEK',
            DAY: 'DAY',
            ASSIGNEE: 'ASSIGNEE',
            GROUP: 'GROUP'
        }
    }
};

PJQ.constants.proQual = {
    screeningStatuses: {
        Pending: 1,
        Declined: 2,
        InProcess: 3,
        Incomplete: 4,
        FeedbackRequired: 5,
        Expired: 6,
        Complete: 7,
        NotApplicable: 8
    }
};
PJQ.modules = {};

$(function () {
	PJQ.app.beforeReady();
});
PJQ.templating = {
	templates: {}
};

PJQ.templating.Template = class {
	constructor(module, file, options = {}) {
		// Files with updated UI
		let v2Files = {
			"app-sign-in" : "app-sign-in-v2",
			"app-sign-up" : "app-sign-up-v2",
			"app-reset-password": "app-reset-password-v2",
			"app-sign-in-access-key" : "app-sign-in-access-key-v2",
			"app-navigator-commands" : "app-navigator-commands-v2",
			"app-navigator" : "app-navigator-v2",
			"nav-project-header": "nav-project-header-v2"
		},
			v2File = v2Files[file.toLowerCase()];
		file = v2File != null && PJQ.app.options.isV2UI ? v2File : file;

		this.module = module;
		this.file = file;
		this.options = _.defaults(options, {
			isOldModule: false
		});
	}

	getPath() {
		let path;
		if (PJQ.app.options.isCombinedAssets) {
			path = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'assets'
				},
				{
					endpoint: 'layout',
					value: this.module
				},
				{
					endpoint: this.file + '.tmpl.html' + '?v=' + (this.options.isOldModule ? PJQ.app.version : PJQ.app.version)
				}
			]);
		}
		else {
			path = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'assets'
				},
				{
					endpoint: this.options.isOldModule ? 'modules' : 'modules2'
				},
				{
					endpoint: this.module
				},
				{
					endpoint: 'layout'
				},
				{
					endpoint: this.file + '.tmpl.html' + '?v=' + (this.options.isOldModule ? PJQ.app.version : PJQ.app.version)
				}
			]);
		}

		if (PJQ.app.options.isK8) {
			path = path.toLowerCase();
		}

		return _.size(PJQ.app.options.cdnUrl) > 0 ? (PJQ.app.options.cdnUrl + path) : PJQ.helpers.urlHelpers.buildDomainURL(path, false);
	}

	fetch(callback) {
		let url = this.getPath();
		if (PJQ.templating.TemplateRenderer.templates[url]) {
			let cachedTemplate = PJQ.templating.TemplateRenderer.templates[url];
			this.parse(cachedTemplate);
			if (typeof callback === 'function')
				callback(cachedTemplate);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return cachedTemplate;
		}
		else {
			$.ajax({
				url: url,
				method: 'GET',
				dataType: 'html',
				success: _.bind(function (html) {
					// html = '<div>' + html + '</div>';
					let template = {
						template: _.template(html),
						markup: html,
						jsRenderTemplate: typeof $.templates === 'function' ? $.templates(html) : null
					};
					this.parse(template);
					PJQ.templating.TemplateRenderer.templates[url] = template;
					if (typeof callback === 'function')
						callback(template);
				}, this)
			});
		}
	}

	parse(template) {
		this.template = template.template;
		this.markup = template.markup;
		this.jsRenderTemplate = template.jsRenderTemplate;
	}

	render(data, callback) {
		this.fetch(_.bind(function (template) {
			if (typeof callback === 'function') {
				if (this.options.isJsRender) {
					callback($(template.jsRenderTemplate.render(data)));
				}
				else {
					callback($(template.template(data ? data : {})));
				}
			}
		}, this));
	}
};

PJQ.templating.TemplateRenderer = {
	templates: {},
	renderTemplate: function (isAppend, tmpl, $el, data, callback, options = {}) {
		this.parseTemplate(tmpl, data, _.bind(function (template) {
			this.render(isAppend, template, $el, callback, options);
		}, this));
	},
	parseTemplate: function (tmpl, data, callback, options) {
		let template = $();
		if (tmpl instanceof $) {
			template = $(_.template(tmpl.html())(data ? data : {}));
			if (typeof callback === 'function')
				callback(template);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return template;
		}
		else if (tmpl instanceof PJQ.templating.Template) {
			if (this.templates[tmpl.getPath()]) {
				tmpl.render(data, callback);
				//todo: phase out this return - this is only here to support methods that call this synchronously
				return $(tmpl.fetch().template(data ? data : {}));
			}
			else {
				tmpl.render(data, callback);
			}
		}
		else if (typeof tmpl === 'string') {
			if (!this.templates[tmpl]) {
				let html = '<div>' + $('#' + tmpl).html() + '</div>';
				this.templates[tmpl] = {
					template: _.template(html),
					markup: html
				};
			}
			template = $(this.templates[tmpl].template(data ? data : {}));
			if (typeof callback === 'function')
				callback(template);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return template;
		}
		else {
			if (typeof callback === 'function')
				callback(template);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return template;
		}
	},
	fetchTemplates: function (templates, callback) {
		let templateCount = _.size(_.filter(templates, function (template) {
			return template instanceof PJQ.templating.Template;
		}));
		if (templateCount === 0) {
			callback();
		}
		else {
			let resultCount = 0,
				resultCallback = function () {
					resultCount++;
					if (resultCount === templateCount)
						callback();
				};
			_.each(templates, function (template) {
				if (template instanceof PJQ.templating.Template)
					template.fetch(resultCallback);
			});
		}
	},
	parseMarkup: function (markup, data) {
		return $(_.template('<div>' + markup + '</div>')(data ? data : {})).html();
	},
	render: function (isAppend, content, $el, callback, options) {
		if(options && options.prepend)
			$el.prepend(content);
		else if(options && options.replace)
			$el.replaceWith(content);
		else if (isAppend)
			$el.append(content);
		else
			$el.html(content);
		if (typeof callback === 'function')
			callback(content);
	}
};
//MODELS
PJQ.models = {};

PJQ.models.BaseModel = Backbone.Model.extend({
    idAttribute: "id",
    baseOptions: {},
    defaults: {},
    options: {},
    urlRoot: "/",
    subItems: {},
    hasEndpoint: function () {
        return this.endpoint() !== '/';
    },
    endpoint: function (action) {
        return '/';
    },
    isNew: function () {
        return this.id == null || this.id === 0 || Backbone.Model.prototype.isNew.call(this);
    },
    restore: function () {
        this.set(this.parse(_.defaults(this.initAttributes, this.attributes)));
        this.dirtyAttributes = {};
        this.isDirty = false;
    },
    hasChanged: function (attribute) {
        if (attribute != null) {
            return Backbone.Model.prototype.hasChanged.call(this, attribute);
        }

        return this.isDirty || _.size(this.dirtyAttributes) > 0 || _.find(this.subItems, function (itemClass, key) {
            let subItem = this[key];
            return subItem != null && typeof subItem.hasChanged === 'function' && subItem.hasChanged();
        }, this) != null;
    },
    hasNewAttachments() {
        return this.attachments != null && _.find(this.attachments.models, function (attachment) {
            return attachment.isNew()
        }) != null;
    },
    url: function (options, method) {
        return PJQ.helpers.urlHelpers.buildApiUrl(typeof this.endpoint === 'function' ? this.endpoint(options, method) : this.endpoint, {
            service: this.getService(options)
        });
    },
    getService: function (options) {
        let service;
        if (this.options.isAPIv2 || (options != null && options.isAPIv2)) {
            service = PJQ.constants.services.APIv2
        } else if (this.hasNewAttachments() || this.options.isFileAPI || (options != null && options.isFileAPI)) {
            service = PJQ.constants.services.FILES;
        } else if (this.options.isOrigin || (options != null && options.isOrigin)) {
            service = PJQ.constants.services.ORIGIN;
        } else if (_.size(this.options.service) > 0) {
            service = this.options.service;
        } else {
            return PJQ.constants.services.API;
        }
        return service;
    },
    beforeConstruct: function (attributes, options) {
    },
    constructor: function (attributes, options) {
        if (this.beforeConstruct(attributes, options) !== false) {
            attributes = this.parse(attributes, options);
            this.initAttributes = attributes;
            return Backbone.Model.prototype.constructor.call(this, attributes, options);
        }
    },
    beforeInit: function (options) {
    },
    initialize: function (model, options) {
        if (this.beforeInit(options) !== false) {
            this.fetchedAttributes = {};
            this.dirtyAttributes = {};
            this.isDirty = false;
            this.options = _.defaults(options ? options : {}, _.defaults(this.defaults ? this.defaults : {}, this.baseOptions));
            this.afterInit();
        }
    },
    afterInit: function () {
    },
    getChanged: function (attribute) {
        let result = this.dirtyAttributes[attribute];
        return result ? result : null;
    },
    reset: function (model) {
        this.clear();
        this.initAttributes = model;
        if (model) {
            this.set(this.parse(model));
        }
        this.isDirty = false;
        this.dirtyAttributes = {};
    },
    set: function (attribute, val, options) {
        let attrs = {};
        if (typeof attribute === 'string') {
            attrs[attribute] = val;
        } else {
            attrs = attribute;
            options = val;
        }
        if (options == null || (!options.silent && (!options.isPatch || options.attrs != null))) {
            this.isDirty = true;
            this.dirtyAttributes = _.extend(this.dirtyAttributes ? this.dirtyAttributes : {}, attrs);
        }
        return Backbone.Model.prototype.set.call(this, attrs, options);
    },
    sync: function (method, model, options) {
        let optsClone = _.clone(options);

        options.url = this.url(options.urlOptions, method);
        options.beforeSend = _.bind(function (xhr) {
            xhr.url = this.url(options.urlOptions, method);
            if (options.timeout) {
                xhr.timeout = options.timeout;
            }
            PJQ.helpers.apiHelpers.addHeaders(xhr, this.getService(options));
        }, this);

        // unless no error notification specified, always notify error
        let self = this,
            error = options.error,
            success = options.success;
        options.error = function (xhr) {
            let args = arguments,
                fnErr = function () {
                    if (options.notify !== false) {
                        new PJQ.ErrorHandler(options.errorHandlerOpts).handle(xhr, self.toJSON());
                    }
                    if (typeof error === 'function') {
                        return error.call(this, ...args);
                    }
                }
            if (xhr.status === 401 && options.canRetry !== false && self.getService(options) === PJQ.constants.services.APIv2) {
                PJQ.app.TokenManager.refreshAccessToken(_.bind(function (token) {
                    if (_.size(token) > 0) {// retry after refreshing the token
                        self.sync(method, model, _.defaults({
                            canRetry: false
                        }, optsClone));
                    } else {
                        fnErr();
                    }
                }, this));
            } else if (xhr.status === 401 && self.getService(options) === PJQ.constants.services.API && xhr.responseText === 'INVALID_SESSION') {
                PJQ.app.signOutNavigate();
            } else {
                fnErr();
            }
        };

        // only notify success if notify option is true
        if (options.notify === true && (method === 'update' || method === 'create') && _.size(self.notifyName) > 0) {
            options.success = function (request) {
                PJQ.notifications.notify.successNotify({
                    message: PJQ.helpers.stringHelpers.format('{0} {1} successfully', self.notifyName, method === 'update' ? 'saved' : 'created')
                });

                if (typeof success === 'function')
                    return success.call(this, ...arguments);
            };
        }

        return Backbone.Model.prototype.sync.call(this, method, model, options);
    },
    fetch: function (options) {
        let paramSuccess = options ? options.success : null,
            opts = _.defaults({
                success: _.bind(function (model, response) {
                    this.initAttributes = response;
                    this.dirtyAttributes = {};
                    this.isDirty = false;
                    this.isFetched = true;
                    this.trigger('fetch');
                    if (typeof paramSuccess === 'function')
                        paramSuccess(model, response);
                }, this)
            }, options ? options : {});
        return Backbone.Model.prototype.fetch.call(this, opts);
    },
    patch: function (attrs, options) {
        attrs = _.defaults(attrs ? attrs : {}, this.dirtyAttributes);
        this.dirtyAttributes = {};
        return this.save(attrs, _.defaults({type: 'PATCH', patch: true}, options));
    },
    put: function (attrs, options) {
        attrs = _.defaults(attrs ? attrs : {}, this.dirtyAttributes);
        this.dirtyAttributes = {};
        return this.save(attrs, _.defaults({type: 'PUT'}, options));
    },
    queuePatch: function (data, options = {}, timeout = 800) {
        this.queueSave(data, _.defaults(options ? options : {}, {isPatch: true}), timeout);
    },
    queueSave: function (data, options = {}, timeout = 800) {
        options = options ? options : {};
        //Set a timeout for saving
        //This can be used when save will be called a lot, and you don't want to send to the API constantly
        if (data) {
            this.set(data);

            if (options.isPatch) {
                this.queueData = _.defaults(this.queueData ? this.queueData : {}, data);
            }
        }

        clearTimeout(this.saveTimeout);
        this.saveTimeout = setTimeout(_.bind(function () {
            if (options.isPatch) {
                this.patch(this.queueData, options);
            } else {
                this.save(this.queueData, options);
            }
            this.queueData = null;
        }, this), timeout);
    },
    beforeSave: function () {
    },
    save: function (attributes, options) {
        this.beforeSave();
        let saveObject = this.getSaveObject(),
            saveOptions = this.getSaveOptions(),
            successCallback = options && options.success ? _.bind(options.success, this) : undefined;

        options = _.defaults({
            success: _.bind(function (model, response, opts) {
                this.dirtyAttributes = {};
                this.isDirty = false;
                this.afterSave(model, response, opts);
                if (successCallback) {
                    successCallback(model, response, opts);
                }
            }, this)
        }, options);

        if (saveObject) {
            if (attributes != null)
                _.defaults(attributes, saveObject);
            else
                attributes = saveObject;
        }
        if (saveOptions) {
            if (options != null)
                _.defaults(options, saveOptions);
            else
                options = saveOptions;
        }
        if (this.saveTimeout != null) {
            clearTimeout(this.saveTimeout);
        }
        return Backbone.Model.prototype.save.call(this, attributes, options);
    },
    afterSave: function () {

    },
    getSaveObject: function () {
        return null;
    },
    getSaveOptions: function () {
        return null;
    },
    formatString: function (str) {
        _.each(PJQ.helpers.stringHelpers.findMatches(/\[(.*?)]/gm, str), function (match) {
            if (match.group.toLowerCase().indexOf('fieldlabel') !== -1) {
                let fieldNumber = parseInt(match.group.toLowerCase().replace('fieldlabel', ''));
                if (fieldNumber > 0) {
                    let matchValue = this.getCustomFieldLabel(fieldNumber);
                    str = str.replace(match.full, matchValue != null ? matchValue : '');
                }
            } else if (match.group.toLowerCase().indexOf('fieldvalue') !== -1) {
                let fieldNumber = parseInt(match.group.toLowerCase().replace('fieldvalue', ''));
                if (fieldNumber > 0) {
                    let matchValue = this.getCustomFieldValue(fieldNumber);
                    str = str.replace(match.full, matchValue != null ? matchValue : '');
                }
            }
        }, this);
        return str;
    },
    getCustomFieldLabel: function (id) {
        if (this.customFields) {
            let match = this.customFields.get(id);
            if (match == null) {
                match = this.customFields.findWhere({fieldNumber: id});
            }
            return match ? match.get('fieldName') : null;
        }
        return _.find(this.get('customFields'), function (cf) {
            return (cf.id === id);
        });
    },
    getCustomFieldValue: function (id) {
        let customFields = this.get('customFields') ? this.get('customFields') : this.get('customFieldValues')
        let match = _.find(customFields, function (cf) {
            return (cf.id === id);
        });
        if (match == null) {
            match = _.find(customFields, function (cf) {
                return (cf.fieldNumber === id);
            });
        }
        return match ? match.value : null;
    },
    externalId: function () {
        let exObj = this.get('externalObject');
        return exObj != null && typeof exObj.externalId === 'string' ? exObj.externalId : null;
    },
    erpSyncStatus: function () {
        let exObj = this.get('externalObject');
        return exObj != null && typeof exObj.status === 'number' ? exObj.status : PJQ.constants.integrations.erp.syncStatuses.PENDING;
    },
    isERPSynced: function () {
        return _.size(this.externalId()) > 0;
    },
    makeERPUrl: function(integration){
        return null;
    }
});


//COLLECTIONS
PJQ.collections = {};

PJQ.collections.BaseCollection = Backbone.Collection.extend({
    baseOptions: {},
    defaults: {},
    options: {},
    urlRoot: "/",
    isFetched: false,
    url: function (options, method) {
        return PJQ.helpers.urlHelpers.buildApiUrl(typeof this.endpoint === 'function' ? this.endpoint(options, method) : this.endpoint, {
            service: this.getService(options)
        });
    },
    getService: function (options) {
        let service;
        if (this.options.isOrigin || (options != null && options.isOrigin)) {
            service = PJQ.constants.services.ORIGIN;
        } else if (this.options.isAPIv2 || (options != null && options.isAPIv2)) {
            service = PJQ.constants.services.APIv2
        } else if (this.options.isFileAPI || (options != null && options.isFileAPI)) {
            service = this.options.service;
        } else if (_.size(this.options.service) > 0) {
            service = this.options.service;
        } else {
            return PJQ.constants.services.API;
        }
        return service;
    },
    beforeConstruct: function (models, options) {
    },
    constructor: function (models, options) {
        if (this.beforeConstruct(models, options) !== false) {
            models = this.parse(models, options);
            return Backbone.Collection.prototype.constructor.call(this, models, options);
        }
    },
    beforeInit: function (options) {
    },
    initialize: function (models, options) {
        if (this.beforeInit(options) !== false) {
            this.options = _.defaults(options ? options : {}, _.defaults(this.defaults ? this.defaults : {}, this.baseOptions));
            if (models && models.length > 0)
                this.add(models, this.options);
            this.afterInit();
        }
    },
    afterInit: function () {
    },
    fetchFirst: function (options) {
        if (!this.isFetched)
            return this.fetch(options);
    },
    get: function (id) {
        if (PJQ.helpers.objectHelpers.refinedType(id) === 'array') {
            let result = [];
            _.each(id, _.bind(function (modelId) {
                let model = Backbone.Collection.prototype.get.call(this, modelId);
                if (model) {
                    result.push(model);
                }
            }, this));
            return result;
        }
        return Backbone.Collection.prototype.get.call(this, id);
    },
    fetch: function (options) {
        let paramSuccess = options ? options.success : null,
            opts = _.defaults({
                success: _.bind(function (models, response) {
                    this.isFetched = true;
                    this.trigger('fetch');
                    if (typeof paramSuccess === 'function')
                        paramSuccess(models, response);
                }, this)
            }, options ? options : {});
        return Backbone.Collection.prototype.fetch.call(this, opts);
    },
    fetchReset: function (options) {
        this.fetch(_.defaults(options ? options : {}, {reset: true}));
    },
    sync: function (method, model, options) {
        let optsClone = _.clone(options);

        options.url = this.url(options.urlOptions, method);
        options.beforeSend = _.bind(function (xhr) {
            xhr.url = this.url(options.urlOptions, method);
            if (options.timeout) {
                xhr.timeout = options.timeout;
            }
            PJQ.helpers.apiHelpers.addHeaders(xhr, this.getService(options));
        }, this);

        // unless no error notification specified, always notify error
        let self = this,
            error = options.error,
            success = options.success;
        options.error = function (xhr) {
            let args = arguments,
                fnErr = function () {
                    if (options.notify !== false) {
                        new PJQ.ErrorHandler(options.errorHandlerOpts).handle(xhr, self.toJSON());
                    }
                    if (typeof error === 'function') {
                        return error.call(this, ...args);
                    }
                }
            if (xhr.status === 401 && options.canRetry !== false && self.getService(options) === PJQ.constants.services.APIv2) {
                PJQ.app.TokenManager.refreshAccessToken(_.bind(function (token) {
                    if (_.size(token) > 0) {// retry after refreshing the token
                        self.sync(method, model, _.defaults({
                            canRetry: false
                        }, optsClone));
                    } else {
                        fnErr();
                    }
                }, this));
            } else if (xhr.status === 401 && self.getService(options) === PJQ.constants.services.API && xhr.responseText === 'INVALID_SESSION') {
                PJQ.app.signOutNavigate();
            } else {
                fnErr();
            }
        };

        // only notify success if notify option is true
        if (options.notify === true && (method === 'update' || method === 'create') && _.size(self.notifyName) > 0) {
            options.success = function (request) {
                PJQ.notifications.notify.successNotify({
                    message: PJQ.helpers.stringHelpers.format('{0} {1} successfully', self.notifyName, method === 'update' ? 'saved' : 'created')
                });

                if (typeof success === 'function')
                    return success.call(this, ...arguments);
            };
        }

        return Backbone.Collection.prototype.sync.call(this, method, model, options);
    },
    save: function (options) {
        return this.sync(options && options.put ? "update" : "create", this, options);
    },
    getChangedModels: function () {
        let changedModels = [];
        _.each(this.models, function (model) {
            if (model.hasChanged() || model.isNew())
                changedModels.push(model);
        });
        return changedModels;
    }
});


//VIEWS
PJQ.views = {};

PJQ.views.BaseView = Backbone.View.extend({
    opts: {
        isAppend: false,
        template: null,
        firstRenderAnimation: null,
        subTemplates: {},
        hasTooltips: false,
        shouldRenderTemplate: true
    },
    baseOptions: {},
    defaults: {},
    options: {},
    defaultEvents: {},
    events: {},
    beforeInit: function (options) {
    },
    initialize: function (options) {
        if (this.beforeInit(options) !== false) {
            let newOpts = _.defaults(this.baseOptions ? this.baseOptions : {}, this.opts);
            newOpts = _.defaults(this.defaults ? this.defaults : {}, newOpts);
            this.options = _.defaults(options ? options : {}, newOpts);
            if (this.defaultEvents != null) {
                this.undelegateEvents();
                this.events = _.defaults(this.events ? this.events : {}, this.defaultEvents);
                this.delegateEvents(this.events);
            }
            this.getTemplates(_.bind(function () {
                if (this.beforeFirstRender() !== false) {
                    this.render();
                }
            }, this));
        }
    },
    getTemplates: function (callback) {
        let templates = this.options.subTemplates ? this.options.subTemplates : {};
        templates.view_base = this.options.template;
        PJQ.templating.TemplateRenderer.fetchTemplates(templates, callback);
    },
    beforeFirstRender: function () {
    },
    renderData: function () {
        return this.options;
    },
    beforeRender: function () {

    },
    render: function (onlyIfRendered = false) {
        if (onlyIfRendered && !this.isFirstRenderDone) {
            return;
        }

        if (this.beforeRender() !== false) {
            if (this.options.template != null && (_.size(this.$el) > 0 && this.options.shouldRenderTemplate !== false)) {
                let data;
                if (typeof this.renderData === 'function') {
                    data = this.renderData();
                } else if (typeof this.renderData !== 'undefined') {
                    data = this.renderData;
                } else {
                    data = {};
                }
                PJQ.templating.TemplateRenderer.renderTemplate(this.options.isAppend, this.options.template, this.$el, data, _.bind(function () {
                    _.bind(this.rightAfterRender, this);
                    if (this.options.hasTooltips) {
                        let toolTips = this.$('[data-toggle="tooltip"]');
                        if (_.size(toolTips) > 0) {
                            toolTips.tooltip()
                        }
                    }
                    if (!this.isFirstRenderDone && this.options.firstRenderAnimation != null) {
                        this.$el.animateCSS(this.options.firstRenderAnimation, function () {
                            this.rightAfterRender();
                        }, this);
                    } else {
                        this.rightAfterRender();
                    }
                }, this));
            } else {
                this.rightAfterRender();
            }
            this.isFirstRenderDone = true;
        }
        return this;
    },
    rightAfterRender: function () {
        if (typeof this.options.afterRender === 'function')
            this.options.afterRender();

        this.afterRender()
    },
    afterRender: function () {

    },
    renderSubTemplate: function (isAppend, template, el, renderData, options) {
        let cb;
        if (typeof options === 'function') {
            cb = options;
        } else if (options && typeof options.callback === 'function') {
            cb = options.callback;
        }
        PJQ.templating.TemplateRenderer.renderTemplate(isAppend, template, el, renderData ? renderData : {}, cb, options);
    },
    addElements: function (element) {
        if (this.$addEl == null) {
            this.$addEl = [];
        }
        this.$addEl.push(element);
    },
    //YOU MUST CALLBACK WHEN OVERRIDING THIS FUNCTION IN AN EXTENDED CLASS
    beforeRemove: function (callback) {
        if (typeof callback === 'function')
            callback();
    },
    remove: function (callback) {
        this.beforeRemove(_.bind(function (result) {
            if (result !== false) {
                this.stopListening();
                this.undelegateEvents();
                this.$el.empty();
                if (_.size(this.$addEl) > 0) {
                    _.each(this.$addEl, function ($el) {
                        $el.empty();
                    });
                }

                if (typeof callback === 'function')
                    callback();
            }
        }, this));
    },
    stopPropagation: function (e) {
        if (e) {
            e.stopPropagation();
            e.cancelBubble = true;
        }
    }
});


//MODALS
PJQ.views.BaseModal = PJQ.views.BaseView.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Default'),
        header: "",
        body: "",
        isVerticalCenter: false,
        isWrapForm: false,
        wrapFormName: null,
        isShowOkButton: true,
        okButtonText: "Ok",
        okButtonColorClass: 'primary',
        isShowCancelButton: false,
        cancelButtonText: "Cancel",
        cancelButtonColorClass: 'secondary',
        isShowSecondaryButton: false,
        secondaryButtonText: "",
        secondaryButtonColorClass: 'light',
        onSecondary: _.noop,
        onClose: _.noop,
        onOk: _.noop,
        width: null,
        minWidth: null,
        maxWidth: null,
        height: null,
        minHeight: null,
        maxHeight: null,
        fitHeight: false,
        isShowCloseButton: false,
    },
    defaults: {},
    options: {},
    defaultEvents: {
        'hidden.bs.modal': 'removeModal',
        'click .modal-ok': 'onOk',
        'click .modal-secondary': 'onSecondary',
        'click .modal-close': 'close'
    },
    events: {},
    beforeFirstRender: function () {
        this.options = _.defaults(this.options, {
            uuid: "modal-" + _.uniqueId()
        });
        //force element to null in case one was passed in
        //this view uses modals only so it creates its own container to insert into in the <body>
        this.setElement(null);
        if (this.beforeModalCreated() !== false) {
            this.createModal();
            this.afterModalCreated();
        }
    },
    beforeModalCreated: function () {
    },
    afterModalCreated: function () {
    },
    createModal: function () {
        this.container = $('#modalsContainer');
        if (_.size(this.container) === 0) {
            this.container = jQuery('<div id="modalsContainer" />');
            $('body').append(this.container);
        }
        this.modal = $('<div class="modal" role="dialog">');
        if (this.options.isVerticalCenter) {
            let verticalBox = $('<div class="modal-vertical-center">');
            this.modal.append(verticalBox);
            this.setElement(verticalBox);
        } else if (this.options.isWrapForm) {
            let form = $('<form name="' + this.options.wrapFormName + '"/>');
            this.modal.append(form);
            this.setElement(this.modal);
        } else {
            this.setElement(this.modal);
        }
        this.container.append(this.modal);
        this.modal.modal({
            backdrop: _.size($('.modal-backdrop.show')) === 0 ? 'static' : false,
            keyboard: false,
            show: true
        });

        this.$('.modal-dialog').attr('id', this.options.uuid);

        this.setZIndex();
    },
    getWidth: function () {
        return {
            minWidth: this.options.minWidth,
            maxWidth: this.options.maxWidth,
            width: this.options.width
        };
    },
    setWidth: function (widths) {
        this.modal.find('.modal-dialog').css({
            "min-width": widths.minWidth,
            "max-width": widths.maxWidth,
            "width": widths.width
        });
    },
    rightAfterRender: function () {
        if (this.modal != null) {
            this.setWidth(this.getWidth());

            // to use this there must be a modal body in the template
            // this will set the modal body to overflow auto which will make it scroll
            // if there is a different class you would like to scroll, it can be defined with modal-overflow
            // this functionality scales the body taking into account the footer/header heights
            // it also scales taking into account the height of elements in modal-body if modal-overflow is present
            if (this.options.fitHeight) {
                // get the top margin and multiply it by 2 so we get a uniform top/bottom margin
                let offset = parseInt(this.modal.find('.modal-dialog').css('margin-top').replace('px', '')) * 2,
                    $header = this.modal.find('.modal-header'),
                    $footer = this.modal.find('.modal-footer'),
                    $overflow = this.modal.find('.modal-overflow'),
                    $scrollContent = this.modal.find('.modal-body');

                if (_.size($overflow) > 0) {
                    // calculate the height of the siblings of the overflow element
                    offset += ($scrollContent.outerHeight() - $overflow.outerHeight());

                    // make the overflow element the content that will be set as scrollable with a max height
                    $scrollContent = $overflow;
                }

                // if there is a header, factor that into the offset for height calculation
                if (_.size($header) > 0) {
                    offset += $header.outerHeight();
                }

                // if there is a footer, factor that into the offset for height calculation
                if (_.size($footer) > 0) {
                    offset += $footer.outerHeight();
                }

                $scrollContent.css({
                    "min-height": (window.innerHeight - offset) + 'px',
                    "max-height": (window.innerHeight - offset) + 'px',
                    "overflow": "auto"
                });
            } else {
                this.modal.find('.modal-dialog').css({
                    "min-height": this.options.minHeight,
                    "max-height": this.options.maxHeight,
                    "height": this.options.height
                });
            }

            if (this.options.isShowCloseButton) {
                let button = $('<button>', {
                    class: 'btn btn-transparent-dark fs-22 btn-sm p-absolute modal-close',
                    style: 'top:-30px;right:-30px;'
                });
                button.append('<i class="fal fa-times"></i>');
                this.$('.modal-content').append(button);
            }

            PJQ.views.BaseView.prototype.rightAfterRender.call(this);
        }
    },
    setZIndex: function () {
        let isRemoved = (this.modal == null),
            ivIndex = parseInt($('.iv-image-view').css('z-index')),
            zIndex = 99999;
        if (!isNaN(ivIndex)) {
            zIndex = ivIndex;
        }
        $('#modalsContainer').find('.modal').each(function () {
            if ($(this).css('display') !== 'none' && $(this).css('zIndex').toString() !== 'auto' && parseInt($(this).css('zIndex').toString()) > zIndex)
                zIndex = parseInt($(this).css('zIndex').toString());
        });
        if (isRemoved) {
            $('.modal-backdrop').css("z-index", zIndex - 25);
        } else {
            $('.modal-backdrop').css("z-index", zIndex + 25);
            this.modal.css("z-index", zIndex + 50);
        }
    },
    removeModal: function () {
        if (this.modal != null) {
            this.modal.modal('hide');
            if (this.modal) {
                this.modal.remove();
                this.modal = null;
            }
            this.remove();
            if (_.size($('.modal:visible')) === 0) {
                $('.modal-backdrop').remove();
            } else {
                this.setZIndex();
                $(document.body).addClass('modal-open');
            }
            this.onRemove();
            this.undelegateEvents();
        }
    },
    close: function () {
        this.removeModal();
        this.onClose();
    },
    onRemove: function () {
        if (this.options.onRemove)
            arguments ? this.options.onRemove(...arguments) : this.options.onRemove(this.model);
    },
    onClose: function () {
        if (this.options.onClose)
            arguments ? this.options.onClose(...arguments) : this.options.onClose(this.model);
    },
    onSecondary: function () {
        if (this.options.onSecondary)
            arguments ? this.options.onSecondary(...arguments) : this.options.onSecondary(this.model);
    },
    onOk: function () {
        if (this.options.onOk)
            arguments ? this.options.onOk(...arguments) : this.options.onOk(this.model);
    }
});

//Router
PJQ.routers = {};

PJQ.routers.BaseRouter = Backbone.Router.extend({
	routes: {
		"": "empty"
	},
	initialize: function () {
		//Add all assigned routes
		_.each(PJQ.app.routes, function (route) {
			this.route(route.route, route.name, route.callback);
		}, this);
	},
	empty: function () {
		if (PJQ.app.module === PJQ.constants.modules.APP) {
			if (PJQ.app.session != null && !PJQ.app.session.isLoggedIn()) {
				//If the user isn't logged in, force nav to sign in
				this.signInNavigate();
			}
			else {
				//try to match routes with a parameter
				let matchedRoute = false;
				_.each(_.filter(PJQ.app.routes, function (paramRoute) {
					return _.size(paramRoute.route) > 0;
				}), function (paramRoute) {
					if (!matchedRoute && _.indexOf(paramRoute.route, '?') !== -1 && typeof paramRoute.callback === 'function') {
						let paramValues = [],
							hasAllParams = true;
						_.each(paramRoute.route.replace('?', '').split('&'), function (param) {
							if (hasAllParams) {
								let paramVal = PJQ.helpers.urlHelpers.getQueryParam(param.split('=:')[0]);
								if (paramVal && _.size(paramVal) > 0) {
									paramValues.push(paramVal);
								}
								else {
									hasAllParams = false;
								}
							}
						});
						if (hasAllParams) {
							paramRoute.callback(...paramValues);
							matchedRoute = true;
						}
					}
				});

				if (!matchedRoute) {
					if (PJQ.app.session.hasFeature('projects')) {
						this.navigate('projects', {
							trigger: true,
							replace: true
						});
					}
					else if(PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId || (PJQ.app.session.user != null && PJQ.app.session.user.get('companyType') === "SUB")) {
						this.navigate('projectinvites', {
							trigger: true,
							replace: true
						});
					}
					else{
						this.navigate('settings', {
							trigger: true,
							replace: true
						});
					}
				}
			}
		}
		else {
			let matchedRoute = false;
			if (typeof PJQ.app.oldRoutes === 'object') {
				_.each(_.filter(PJQ.app.oldRoutes, function (oldRoute) {
					return _.size(oldRoute.route) > 0;
				}), function (oldRoute) {
					_.find(oldRoute.route.split(' '), function (param) {
						let paramVal = PJQ.helpers.urlHelpers.getQueryParam(param.replace('?', ''));
						if (paramVal && _.size(paramVal) > 0 && typeof oldRoute.callback === 'function') {
							oldRoute.callback(paramVal);
							matchedRoute = true;
						}
					});
				});
			}
			if (!matchedRoute) {
				let defaultRoute = _.find(PJQ.app.oldRoutes, function (oldRoute) {
					return oldRoute.name === 'default';
				});
				if (defaultRoute && typeof defaultRoute.callback === 'function') {
					//If there is a default route overriding this from old modules, route to that
					defaultRoute.callback();
				}
				else if (_.size(PJQ.app.readyEvents) > 0) {
					//This function calls all bound functions to ready (added by attachReadyEvent)
					//These are only added by old modules
					//All new modules should use routes
					//This uses an array so multiple ready events can be attached (for different modules)
					//There should ideally only ever be one function in the array
					// However we don't want a situation where one module overrides another so we do it this way
					_.each(PJQ.app.readyEvents, function (func) {
						if (typeof func === 'function')
							func();
					});
				}
			}
		}
	}
	,
	noAuthRoutes: [
		'invoiceguestlink',
		'signin',
		'signup',
		'signuptrial',
		'sharephotos',
		'sharedrawings',
		'sharefiles',
		'scheduleshare',
		'resetpassword',
		'prequal',
		'register',
		'optout',
		'deleteaccount'
	],
	signInNavigate: function (options = {}) {
		if (options != null) {
			if (options.cacheRoute) {
				PJQ.app.router.signInCache = '#' + this.getCurrentRoute();
			}
		}

		$('.skin-header').hide();
		PJQ.app.$el.css('top', 0);
		if (PJQ.app.portal != null && _.size(PJQ.app.portal.pages) > 0) {
			let portalSignInRoute = _.findWhere(PJQ.app.portal.pages, {route: 'signin'});
			if (portalSignInRoute != null) {
				this.navigate('p/' + portalSignInRoute.route, {
					trigger: true,
					replace: true
				});
				return;
			}
		}

		this.navigate('signin', {
			trigger: true,
			replace: true
		});
	},
	routeToRoot: function () {
		PJQ.app.router.navigate('/', {
			trigger: true
		});
	},
	execute: function (callback, args, name) {
		if (typeof ga === 'function') {
			ga('send', 'pageview', {
				'page': location.pathname + location.search + location.hash
			});
		}

		if (!PJQ.app.view) {
			PJQ.app.view = new PJQ.views.AppView(PJQ.app.$el);
		}

		if (PJQ.app.view.photoViewer) {
			let triggerRoute = PJQ.app.view.photoViewer.options.triggerRoute;
			PJQ.app.view.photoViewer.hide();
			if (triggerRoute) {
				Backbone.Router.prototype.execute.call(this, callback, args, name);
				return;
			}
		}
		let accessKey = PJQ.helpers.urlHelpers.getQueryParam('accessKey');
		if (_.size(accessKey) > 0) {
			PJQ.app.session.set('accessKey', accessKey);
			if (_.size(window.location.hash) > 0 && window.location.hash.indexOf('?') > -1) {
				let hashArr = window.location.hash.split('?'),
					posStatus = hashArr[_.size(hashArr) - 1].toUpperCase(),
					resQuery = 'RESPONSE=';
				if (posStatus.indexOf(resQuery) > -1) {
					PJQ.app.session.set('bidStatus', posStatus.replace(resQuery, ''));
				}
			}
		}

		let $menuItems = $('.pt-menu-item');
		if (_.size($menuItems) > 0) {
			let utId;
			if (PJQ.app.session.get('ownsPortal') && PJQ.app.session.user != null) {
				utId = PJQ.app.session.user.get('userTypeId');
			}
			else if (PJQ.app.session.contact != null) {
				utId = PJQ.app.session.contact.get('userTypeId');
			}
			else {
				utId = null;
			}
			$menuItems.each(function () {
				let $menuitem = $(this);
				let allowedUtString = $menuitem.data('userTypes');
				if (_.size(allowedUtString) > 0) {
					if (_.find(allowedUtString.split(','), function (allowedUt) {
						return parseInt(allowedUt) === utId;
					})) {
						$(this).removeClass('hidden');
					}
					else {
						$(this).addClass('hidden');
					}
				}
			});
		}

		let contactGuid = PJQ.helpers.urlHelpers.getQueryParam('cg');
		if (_.size(contactGuid) > 0) {
			PJQ.app.session.set('contactGuid', contactGuid);
		}

		if (_.size(window.staticRoute) > 0 && name !== window.staticRoute) {
			this.navigate(window.staticRoute, {
				trigger: true,
				replace: true
			});
			return;
		}

		//If this is the single page module and the user isn't signed in
		//We force navigation to the sign in route
		let isPortalRoute = name.indexOf('portal_') !== -1,
			$header = $('.skin-header'),
			$appMain = PJQ.app.$el;
		if (isPortalRoute && PJQ.app.session.isLoggedIn()) {
			this.navigate('', {
				trigger: true,
				replace: true
			});
			return;
		}
		else if (!isPortalRoute && PJQ.app.module === PJQ.constants.modules.APP && !PJQ.app.session.isLoggedIn() && this.noAuthRoutes.indexOf(name.toLowerCase()) === -1) {
			// if this is the root route and there is a portal root route, navigate to it
			if (name === 'empty' && PJQ.app.portal != null && _.size(PJQ.app.portal.pages) > 0) {
				let rootRoute = _.findWhere(PJQ.app.portal.pages, {isRoot: true});
				if (rootRoute != null) {
					this.navigate('/p/' + rootRoute.route, {
						trigger: true,
						replace: true
					});
					return;
				}
			}

			// if (PJQ.app.session.isPanteraPortal() && (_.size(accessKey) > 0 || _.size(contactGuid) > 0)
			// 	&& (PJQ.app.session.contact == null || !(PJQ.app.session.contact.get('userId') > 0))) {
			// 	$appMain.css('top', 0);
			// 	this.navigate('signup', {
			// 		trigger: true,
			// 		replace: true
			// 	});
			// 	return;
			// }

			if (_.size(accessKey) === 0 && _.size(contactGuid) === 0) {
				this.signInNavigate({
					cacheRoute: true
				});
				return;
			}
			else {
				$header.show();
			}
		}
		else if (isPortalRoute || name === 'signin' || name === 'signup') {
			$appMain.css('top', 0);
			$header.hide();
			$appMain.scrollTop(0);

			//this is a sign in or sign up route, make sure the session is fetched
			if (!PJQ.app.session.isFetched) {
				PJQ.app.session.fetch();
			}
		}
		else {
			$header.show();
			$appMain.css('top', $header.height());

			//this is an app route, make sure the session is fetched
			if (!PJQ.app.session.isFetched) {
				PJQ.app.session.fetch();
			}
		}

		let foundRoute = _.findWhere(PJQ.app.routes, {name: name});
		if (foundRoute != null) {
			if (typeof foundRoute.title === 'function') {
				document.title = foundRoute.title();
			}
			else if (_.size(foundRoute.title)) {
				document.title = foundRoute.title;
			}
		}

		Backbone.Router.prototype.execute.call(this, callback, args, name);
	},
	getCurrentRoute: function () {
		return window.location.hash.replace('#', '');
	}
});
// $.fn.dataTable.ext.errMode = 'none';

PJQ.views.dataTables = {};

PJQ.views.dataTables.DataTable = PJQ.views.BaseView.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Base'),
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Base')
        },
        deferRender: true,
        isStriped: false,
        isNoPadding: true,
        isOverflowAuto: false,
        isHideSearch: false,
        dom: "<'row no-gutters'<'table-outer col-sm-12'tr>>" + "<'row no-gutters'<'col-sm-5 mt-1'l><'col-sm-7 mt-2'p>>",
        headerData: {},
        getPageCallback: null,
        onRowClick: null,
        onRowDoubleClick: null,
        onRowRemoved: null,
        onTableDraw: null,
        minHeightPx: null,
        paging: true,
        pageLength: 10,
        rowId: "cid",
        groupBy: null,
        groupByKey: null,
        disableGroupToggle: null,
        getGroupHeader: null,
        collapsedGroups: [],
        scrollRows: false,
        emptyDataGroup: "N/A",
        onPageSizeChange: null,
        orderCookie: null,
        columnWidthCookie: null,
        pageLengthCookie: null,
        showPageSelector: false,
        enableColumnResize: true,
        hasFooter: false,
        extraClasses: null,
        toggleRowClass: '.toggle-row',
        hideColumnHeaders: false,
        allowEmptySort: false
    },
    defaultEvents: {
        'click .group-start': 'toggleGroup',
        'keyup .datatable-search': 'search',
        'click .clear-filters': 'clearFilters'
    },
    onColumnResizeStart: function (column, columns) {

    },
    onColumnResize: function (column) {

    },
    onColumnResizeEnd: function (column, columns) {

    },
    beforeFirstRender: function () {
        this.options = _.extend(this.options, {
            uuid: _.uniqueId(),
            dom: this.options.paging ? this.options.dom : "<'row no-gutters'<'table-outer col-sm-12'tr>>",
            language: _.defaults({
                lengthMenu: "Show _MENU_",
                processing: "Loading...",
                paginate: {
                    previous: "Prev",
                    next: "Next"
                }
            }, this.options.language ? this.options.language : {})
        });

        if (this.options.clearServerCache)
            this.clearServerCache = true;
    },
    beforeRender: function () {
        if (_.size(this.options.groupByKey) > 0) {
            if (this.options.groupBy != null) {
                window.localStorage.removeItem(this.options.groupByKey);
                if (_.size(this.options.groupBy) > 0) {
                    window.localStorage.setItem(this.options.groupByKey, this.options.groupBy);
                }
            } else {
                let groupBy = window.localStorage.getItem(this.options.groupByKey);
                if (_.size(groupBy) > 0) {
                    this.options.groupBy = groupBy;
                }
            }
        }

        let grg = this.options.getRowGroup || this.getRowGroup,
            groupBy = this.getGroupBy();
        if (groupBy != null) {
            this.options.rowGroup = {
                startRender: _.bind(this.startGroupRender, this),
                emptyDataGroup: this.options.emptyDataGroup ? this.options.emptyDataGroup : "N/A",
                dataSrc: (row) => {
                    if (typeof grg === 'function') {
                        return grg(row, groupBy);
                    }

                    let groupByCol = this.getGroupByColumn();
                    if (groupByCol == null) {
                        return null;
                    }

                    let dataVal = PJQ.helpers.objectHelpers.getNestedValue(row, groupByCol.column.data ?? groupByCol.column.columnData ?? groupByCol.column.attribute);
                    if (typeof groupByCol.column.group === 'function') {
                        return groupByCol.column.group(row, groupBy);
                    } else if (typeof groupByCol.column.render === 'function') {
                        return groupByCol.column.render(dataVal, "display", row);
                    }

                    return dataVal ?? '';
                }
            };
        } else {
            this.options.rowGroup = null;
        }
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    getContextMenuOptions: function () {
        return this.options.contextMenuOptions != null ? this.options.contextMenuOptions : null;
    },
    getSortableOptions: function () {
        return this.options.sortableOptions != null ? this.options.sortableOptions : null;
    },
    afterRender: function () {
        this.renderHeader();

        let self = this,
            doneMoving = true;
        self.$el.off('dblclick');
        self.$el.on('touchmove', 'tbody tr[id]', function () {
            doneMoving = false;
        });

        self.$el.on('click', 'tbody tr[id]', function (e) {
            let row = self.getRow($(this));
            if (row) {
                if (doneMoving) {
                    self.onRowClick(row);
                }
            }
        });
        self.$el.on('dblclick touchend', 'tbody tr[id]', function (e) {
            let isChildRow = $(this).hasClass('child-row'),
                row = isChildRow ? self.getChildRowObject($(this)) : self.getRow($(this)),
                $target = $(e.target);

            if (_.size(self.options.toggleRowClass) > 0 && $target.is(self.options.toggleRowClass)) {
                return;
            }

            if (row) {
                e.stopPropagation();
                if (doneMoving) {
                    self.onRowDoubleClick(row, $(this));
                }
            }
        });

        // self.$el.on( 'error.dt', function ( e, settings, techNote, message ) {
        //     if(console){
        //         console.log( 'DataTable ' + this.options.uuid  + ' error: ', message );
        //     }
        // } ) .DataTable();

        this.renderDataTable();

        let sortOpts = this.getSortableOptions();
        if (_.size(sortOpts) > 0) {
            this.makeSortable(sortOpts);
        }

        let ctxOpts = this.getContextMenuOptions();
        if (ctxOpts != null && _.size(ctxOpts.actions) > 0) {
            this.addContextMenu(ctxOpts);
        }
    },
    onTableDraw: function () {
        if (this.options.hideColumnHeaders) {
            this.$el.find('thead').attr('style', 'visibility: collapse;');
        }
        if (typeof this.options.onTableDraw === 'function') {
            this.options.onTableDraw(this.dataTable);
        }

        this.initializeToggledRows();
        this.updateScrollbar();
        this.forceScrollXWidths();
    },
    onRowClick: function (row) {
        if (typeof this.options.onRowClick === 'function') {
            this.options.onRowClick(row);
        }
    },
    onRowDoubleClick: function (row, $el) {
        if (typeof this.options.onRowDoubleClick === 'function') {
            this.options.onRowDoubleClick(row, $el);
        }
    },
    afterHeaderRender: function () {
        if (typeof this.options.afterHeaderRender === 'function') {
            this.options.afterHeaderRender(this, this.$('.dt-header'));
        }
    },
    beforeDataTableRender: function () {

    },
    headerData: function () {
        return typeof this.options.headerData === 'function' ? this.options.headerData() : this.options.headerData;
    },
    renderHeader: function () {
        if (!this.options.isHideSearch) {
            this.renderSubTemplate(false, this.options.subTemplates.header, this.$('.dt-header'), this.headerData(), _.bind(function () {
                this.delegateEvents();
                this.afterHeaderRender();
            }, this));
        }
    },
    renderPage: function () {
        if (this.dataTable != null) {
            let page = this.dataTable.page();
            this.options.displayStart = page != null ? page * this.options.pageLength : null;
        }
        if (this.options.addressBookView && this.options.addressBookView.currentView === 'company') {
            if (this.options.addressBookView.dataTable) {
                let page = this.options.addressBookView.dataTable.dataTable.page();
                this.options.addressBookView.dataTable.options.displayStart = page != null ? page * this.options.addressBookView.dataTable.options.pageLength : null;
                this.options.addressBookView.dataTable.options.addressBookView.dataTable.render()
            }
        } else {
            this.render();
        }
    },
    disableColumnReorder: function () {
        if (this.dataTable != null && this.dataTable.colReorder != null && typeof this.dataTable.colReorder.disable === 'function') {
            this.dataTable.colReorder.disable();
        }
    },
    enableColumnReorder: function () {
        if (this.dataTable != null && this.dataTable.colReorder != null && typeof this.dataTable.colReorder.enable === 'function') {
            this.dataTable.colReorder.enable();
        }
    },
    renderDataTable: function () {
        this.options.childDataTables = [];

        this.beforeDataTableRender();

        if (this.dataTable)
            this.dataTable.destroy();

        if (this.options.scrollY) {
            this.options.autoWidth = false;
        }

        if (this.options.getPageCallback != null) {
            this.options = _.extend(this.options, {
                ajax: _.bind(this.getPage, this),
                processing: true,
                serverSide: true
            });
        }

        if (this.options.columns == null && typeof this.getColumns === 'function') {
            this.options.columns = this.getColumns();
        }

        this.colNameMap = {};
        _.each(this.options.columns, function (column, index) {
            if (_.size(column.title) > 0) {
                this.colNameMap[column.title.toLowerCase()] = index;
            }

            if (column.resizable === false) {
                let prevColumn = this.options.columns[index - 1];
                column.className = column.className ? column.className + ' no-resize' : 'no-resize';

                if (prevColumn != null && !prevColumn.className?.includes('no-resize')) {
                    prevColumn.className = prevColumn.className ? prevColumn.className + ' no-resize' : 'no-resize';
                }
            }

            if (this.options.allowEmptySort !== true && column.orderSequence == null) {
                column.orderSequence = ['asc', 'desc'];
            }
        }, this);

        let rowIdAttr = this.options.rowId;
        this.$dataTable = this.$('#dt_' + this.options.uuid);

        if (this.options.pageLength === 0) {
            this.options.paging = false;
        }

        let self = this,
            filterData = this.getFilterData(),
            groupByCol = this.getGroupByColumn();
        if (groupByCol == null) {
            this.options.orderFixed = this.options.initOrderFixed;
        } else {
            this.options.initOrderFixed = this.options.initOrderFixed ?? this.options.orderFixed;
            this.options.orderFixed = [[groupByCol.index, 'asc']];

            // if the group by column data is array data
            // we need to clone each object for each item in the array so items can be in multiple groups
            if (groupByCol.column != null && groupByCol.column.isArrayGroup && _.size(filterData) > 0) {
                let attr;
                if (groupByCol.column.attribute) {
                    attr = groupByCol.column.attribute
                } else if (typeof groupByCol.column.columnData) {
                    attr = groupByCol.column.columnData;
                } else {
                    attr = null;
                }
                if (_.size(attr) > 0) {
                    let newData = [];
                    _.each(filterData, function (item) {
                        let colData = typeof groupByCol.column.columnData === 'function' ? groupByCol.column.columnData(item) : item[attr];
                        if (_.size(colData) > 1) {
                            _.each(colData, function (colItem) {
                                if (typeof item.clone === 'function') {
                                    let newItem = item.clone();
                                    newItem.set(attr, [colItem]);
                                    newData.push(newItem);
                                } else {
                                    let newItem = _.clone(colItem);
                                    newItem[attr] = [colItem];
                                    newData.push(newItem);
                                }
                            });
                        } else {
                            newData.push(item);
                        }
                    });
                    filterData = newData;
                }
            }
        }

        if (_.size(this.options.language?.zeroRecords) > 0 && _.size(this.options.language?.emptyTable) === 0) {
            this.options.language.emptyTable = this.options.language?.zeroRecords;
        }

        this.dataTable = this.$dataTable.DataTable(_.defaults(
            {
                data: filterData,
                fixedHeader: {
                    header: this.options.scrollRows && this.options.parentDataTable == null,
                    footer: this.options.scrollRows && this.options.hasFooter
                },
                footerCallback: function (row, data, start, end, display) {
                    let api = this.api();
                    let footer = $(api.table().footer());

                    if (self.options.hasFooter) {
                        footer.empty();

                        if (typeof self.options.footer === 'function') {
                            footer.append(self.options.footer(self));
                        } else {
                            let colMarkup = '';
                            _.each(typeof self.options.columns === 'function' ? self.options.columns() : self.options.columns, (column) => {
                                if (column.visible !== false) {
                                    let col = '';
                                    if (typeof column.renderFooter === 'function') {
                                        col = column.renderFooter(self.options.data);
                                    }
                                    colMarkup += '<th>' + (col ?? '') + '</th>';
                                }
                            });

                            footer.append('<tr>' + colMarkup + '</tr>');
                        }
                    } else {
                        footer.remove();
                    }
                },
                initComplete: function (settings, json) {
                    // Add a table wrapper
                    if (self.options.scrollY == null) {
                        this.wrap("<div class='table-wrapper'></div>");
                    }

                    // Remove the duplicated footer from the scrollBody if scrollY is enabled and table has a footer
                    // if (self.options.scrollY && self.options.hasFooter) {
                    //     self.$('.dt-scroll-body tfoot:last').remove();
                    //     self.$('.dt-scroll-footInner').width('100%');
                    // }

                    if (typeof self.options.initComplete === 'function') {
                        self.options.initComplete.call(this, settings, json);
                    }
                },
                createdRow: _.bind(this.createdRow, this),
                rowId: function (a) {
                    let id = a[rowIdAttr];
                    return typeof id === 'number' ? id.toString() : id;
                }
            }, this.options));

        this.applyColumnWidths();

        if (this.options.enableColumnResize) {
            this.makeColumnsResizable();
        }

        // this.dataTable.off('draw.dt');
        this.dataTable.on('draw.dt', () => {
            this.onTableDraw();
        });

        if (_.size(this.options.toggleRowClass) > 0) {
            this.$el.off('click', this.options.toggleRowClass);
            this.$el.on('click', this.options.toggleRowClass, _.bind(this.childRowToggle, this));

            this.$el.off('click', '.toggle-all-rows');
            this.$el.on('click', '.toggle-all-rows', (e) => {
                this.toggleAllChildRows();
            });
        }

        // this.dataTable.off('length.dt');
        if (_.size(this.options.pageLengthCookie) > 0) {
            let self = this;
            let cookieVal = PJQ.helpers.cookieHelpers.getCookie(self.options.pageLengthCookie);
            if (_.size(cookieVal) > 0) {
                self.options.pageLength = parseInt(cookieVal);
            }

            this.dataTable.on('length.dt', _.bind(function (e, settings, details) {
                PJQ.helpers.cookieHelpers.setCookie(self.options.pageLengthCookie, details);
            }, this));
        }

        // this.dataTable.off('order.dt');
        if (_.size(this.options.orderCookie) > 0) {
            let self = this;
            let cookieVal = PJQ.helpers.cookieHelpers.getCookie(self.options.orderCookie);
            if (_.size(cookieVal) > 0) {
                self.options.order = JSON.parse(cookieVal);

                if (self.options.order.length > 1) {
                    let firstVal = self.options.order[0];
                    if (!_.isArray(firstVal)) {
                        self.options.order = [self.options.order];
                    }
                }
            }

            this.dataTable.on('order.dt', (e, settings, details) => {
                let orderArr = [];
                _.each(details, function (order) {
                    orderArr.push([order.col, order.dir]);
                });
                PJQ.helpers.cookieHelpers.setCookie(self.options.orderCookie, JSON.stringify(orderArr));
            });
        }

        this.$dataTable.on('mouseup', function () {
            self.options.isResizing = false;
        });

        if (this.options.getPageCallback != null) {
            this.dataTable.on('length.dt order.dt', () => {
                this.clearServerCache = true;
            });
        }

        let pageSizeContainer = this.$('.dt-length');
        if (_.size(pageSizeContainer) > 0) {
            pageSizeContainer.addClass('fs-14 text-dark');
            let pageSizeInput = pageSizeContainer.find('select');
            pageSizeInput.addClass('wd-80p mr-2 ml-2');
            new PJQ.inputs.Selectpicker({
                el: pageSizeInput,
                isIntChoices: true,
                defaultValue: this.options.pageLength,
                onChange: (value) => {
                    if (typeof this.options.onPageSizeChange === 'function') {
                        this.options.onPageSizeChange(value);
                    }
                }
            });
        }

        this.$wrapper = this.$('#dt_' + this.options.uuid + '_wrapper');
        this.afterSearch();

        if (this.options.isOverflowAuto) {
            this.$wrapper.find('.row>.col-sm-12').first().addClass('of-x-auto')
        }

        if (_.size(this.options.orderFixed) > 0) {
            _.each(this.options.orderFixed, function (arr) {
                this.$dataTable.find('thead > tr > th[data-column-index="' + arr[0].toString() + '"]').addClass('hidden-before hidden-after');
            }, this)
        }

        let hasSettingsModel = this.options.settings != null,
            isBackboneSettings = this.options.settings instanceof Backbone.Model;
        this.dataTable.on('order.dt', (e, settings, details) => {
            if (this.$dataTable.attr('id') !== $(e.target).attr('id')) {
                return;
            } else if (!(details?.length > 0)) {
                return;
            }

            e.stopPropagation();
            if (hasSettingsModel) {
                let oldOrderBy,
                    oldOrderAscending,
                    oldOrder = 0, columns = this.options.columns;
                if (isBackboneSettings) {
                    oldOrderBy = this.options.settings.get('orderBy');
                    oldOrderAscending = this.options.settings.get('orderAscending');
                } else {
                    oldOrderBy = this.options.settings.orderBy;
                    oldOrderAscending = this.options.settings.orderAscending;
                }

                _.each(columns, _.bind(function (column, index) {
                    if (column.columnData === oldOrderBy)
                        oldOrder = index;
                }, this));

                let orderBy, orderAscending;
                if (details?.length > 0) {
                    let detailCol = isBackboneSettings ? details[details.length - 1] : details[0],
                        orderByCol = columns[detailCol.src];

                    orderBy = orderByCol.columnData != null ? orderByCol.columnData : orderByCol.data;
                    orderAscending = (detailCol.dir === 'asc');
                } else {
                    orderBy = null;
                    orderAscending = null;
                }
                if (oldOrderBy !== orderBy || oldOrderAscending !== orderAscending) {
                    if (isBackboneSettings) {
                        this.options.settings.set('orderBy', orderBy);
                        this.options.settings.set('orderAscending', orderAscending);
                        if (this.options.settings.hasEndpoint()) {
                            this.options.settings.save();
                        }
                    } else {
                        this.options.settings.orderBy = orderBy;
                        this.options.settings.orderAscending = orderAscending;
                    }
                    this.orderByChanged();
                }
            } else {
                this.orderByChanged(details);
            }
        });

        if (this.options.colReorder != null) {
            // this.dataTable.off('column-reorder.dt');
            this.dataTable.on('column-reorder.dt', _.bind(function (e, settings, details) {
                e.stopPropagation();

                // if (!details.drop && this.options.colReorder.realtime === false) {
                //     return;
                // }

                let columns = this.options.columns,
                    fixedLeft,
                    fixedRight;
                if (typeof this.options.colReorder === 'object') {
                    fixedLeft = this.options.colReorder.fixedColumnsLeft > 0 ? this.options.colReorder.fixedColumnsLeft : 0;
                    fixedRight = this.options.colReorder.fixedColumnsRight > 0 ? this.options.colReorder.fixedColumnsRight : 0;
                } else {
                    fixedLeft = 0;
                    fixedRight = 0;
                }
                _.each(columns, function (col, index) {
                    let curSort = col.sort != null ? col.sort : index;
                    col.sort = details.mapping[curSort];
                });

                let newColumns = _.map(_.sortBy(_.filter(columns, function (column) {
                    let colNum = column.sort + 1;
                    return (colNum > fixedLeft && colNum <= _.size(columns) - fixedRight);
                }), function (column) {
                    return column.sort;
                }), function (column) {
                    return column.columnData ?? column.data;
                });

                if (this.options.settings != null) {
                    if (isBackboneSettings) {
                        this.options.settings.set('columns', newColumns);
                        this.options.settings.save();
                    } else {
                        this.options.settings.columns = newColumns;
                    }
                    this.columnOrderChanged(newColumns);
                } else if (_.size(this.options.identifier) > 0) {
                    for (let i = 0; i < fixedLeft; i++) {
                        let column = columns[i];
                        if (column) {
                            newColumns.unshift(column.columnData ?? column.data);
                        }
                    }

                    for (let i = fixedRight; i > 0; i--) {
                        let column = columns[columns.length - i];
                        if (column) {
                            newColumns.push(column.columnData ?? column.data);
                        }
                    }

                    PJQ.helpers.cookieHelpers.setCookie(this.options.identifier + '_col_order', JSON.stringify(newColumns));
                }

                this.columnOrderChanged(_.sortBy(columns, function (column) {
                    return column.sort;
                }));
            }, this));
        }

        // Resize observer to update scrollbar when the table width changes. Calls updateScrollbar() when the table width changes
        let resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.contentRect.width) {
                    self.updateScrollbar();
                }
            }
            if (!self.options.isResizing) {
                self.forceScrollXWidths();
            }
        });

        // Have resizeObserver observe the datatable element
        if (this.$wrapper[0]) {
            resizeObserver.observe(this.$wrapper[0]);
        }

        this.initializeToggledRows();
        this.afterDataTableRender();
    },
    makeColumnsResizable: function () {
        let self = this,
            minColumnWidth = 80,
            $dtHeader = this.options.scrollY ? this.$('.dt-scroll-head') : self.$dataTable,
            $dtBody = this.options.scrollY ? this.$('.dt-scroll-body') : self.$dataTable,
            $dtFooter = this.options.scrollY ? this.$('.dt-scroll-foot') : self.$dataTable,
            $fTh = $dtHeader.find('thead').first().find('th:not(.no-resize)');

        if (this.options.scrollY) {
            $dtHeader.find('table').css('table-layout', 'fixed');
            $dtBody.find('table').css('table-layout', 'fixed');
            $dtFooter.find('table').css('table-layout', 'fixed');
        }

        function getColSpannedIndex($th) {
            let index = 0;
            $th.prevAll().each(function () {
                index += $(this).attr('colspan') ? parseInt($(this).attr('colspan')) : 1;
            });
            return index;
        }

        if (this.options.colReorder != null && this.options.enableColumnResize) {
            let settings = self.dataTable.settings()[0];
            if (settings == null) {
                return;
            }

            let internalColReorder = settings._colReorder,
                colReorderMouseDown = $.fn.dataTable.ColReorder.prototype._mouseDown;
            $fTh.off('mousedown.colReorder touchstart.colReorder');
            $fTh.on('mousedown.colReorder touchstart.colReorder', function (e) {
                const offsetX = e.pageX - $(this).offset().left;
                if (offsetX > $(this).outerWidth() - 5) {
                    self.options.isResizing = true;
                } else {
                    self.options.isResizing = false;
                    colReorderMouseDown.call(internalColReorder, e, this);
                }
            });
        }

        $fTh.resizable({
            handles: "e",
            helper: 'th-helper',
            start: function () {
                self.options.isResizing = true;

                $dtHeader.find('th').each(function () {
                    this.addEventListener("click", self.preventBubble, {capture: true});
                });
                $dtHeader.on('mouseup.preventBubble', self.preventBubble);
            },
            resize: function (event, ui) {
                const $th = $(this),
                    thIndex = getColSpannedIndex($th),
                    $col = $dtHeader.find('col').eq(thIndex),
                    $nextCol = $dtHeader.find('col').eq(thIndex + 1);

                if (!$col.length || !$nextCol.length) {
                    return;
                }

                let newWidth = ui.helper.get(0).getBoundingClientRect().width,
                    totalAvailableWidth = ui.element.get(0).getBoundingClientRect().width + $nextCol.get(0).getBoundingClientRect().width,
                    remainingWidth = totalAvailableWidth - newWidth;

                if (newWidth > minColumnWidth && remainingWidth > minColumnWidth) {
                    $col.css('min-width', '');
                    $col.css('width', `${newWidth}px`);
                    $nextCol.css('min-width', '');
                    $nextCol.css('width', `${remainingWidth}px`);

                    $dtBody.find('colgroup').each(function () {
                        const $cols = $(this).find('col');
                        $cols.eq(thIndex).css('min-width', '');
                        $cols.eq(thIndex).css('width', `${newWidth}px`);
                        $cols.eq(thIndex + 1).css('min-width', '');
                        $cols.eq(thIndex + 1).css('width', `${remainingWidth}px`);
                    });

                    $dtFooter.find('colgroup').each(function () {
                        const $cols = $(this).find('col');
                        $cols.eq(thIndex).css('min-width', '');
                        $cols.eq(thIndex).css('width', `${newWidth}px`);
                        $cols.eq(thIndex + 1).css('min-width', '');
                        $cols.eq(thIndex + 1).css('width', `${remainingWidth}px`);
                    });
                }
            },
            stop: function () {
                self.saveColumnWidths();

                $dtHeader.find('th').each(function () {
                    this.removeEventListener("click", self.preventBubble, {capture: true});
                });
                $dtHeader.off('mouseup.preventBubble');

                self.options.isResizing = false;
            }
        });
    },
    updateScrollbar: function (context) {
        if (!this.options.scrollY) {
            return;
        }

        let $wrapper = this.$wrapper,
            $table = this.$dataTable;
        if (!$wrapper || !$table)
            return;

        let isNestedTable = $wrapper.closest('table').length > 0;
        if ($table.outerWidth() > $wrapper.width() && !isNestedTable) {
            $wrapper.css('overflow-x', 'auto');
        } else {
            $wrapper.css('overflow-x', 'visible');
        }

        if (this.options.scrollY === 'auto') {
            let windowHeight = window.innerHeight,
                tableOffset = this.$el.offset()?.top || 0,
                headerHeight = this.$('.dt-header').outerHeight() || 0,
                scrollHeaderHeight = this.$('.dt-scroll-head').outerHeight() || 0,
                scrollFooterHeight = this.$('.dt-scroll-foot').outerHeight() || 0,
                availableHeight = windowHeight - tableOffset - headerHeight - scrollHeaderHeight - scrollFooterHeight;

            this.$('.dt-scroll-body').css('max-height', availableHeight + 'px');
        }
    },
    forceScrollXWidths: function () {
        let $wrapper = this.$wrapper,
            $table = this.$dataTable;

        if (!$wrapper || !$table || (!this.options.scrollX && !this.options.scrollY)) {
            return;
        }

        let $scrollHead = this.$wrapper.find('.dt-scroll-head'),
            $scrollFoot = this.$wrapper.find('.dt-scroll-foot'),
            tableWidth = this.$dataTable.width();
        $scrollHead.find('table').each((index, table) => {
            table.style.setProperty('table-layout', 'fixed');
            table.style.setProperty('width', `${tableWidth}px`, 'important');
        });
        $scrollFoot.find('table').each((index, table) => {
            table.style.setProperty('table-layout', 'fixed');
            table.style.setProperty('width', `${tableWidth}px`, 'important');
        });

        // if (this.options.enableColumnResize) {
        //     let $scrollBodyHeaderColumns = this.$dataTable.find('thead tr').last().find('th'),
        //         $scrollHeadRow = $scrollHead.find('thead tr').last(),
        //         $scrollFooterRow = $scrollHead.find('tfoot tr').last(),
        //         $scrollHeadColumns = $scrollHeadRow.find('th'),
        //         $scrollFootColumns = $scrollFooterRow.find('th');
        //     $scrollBodyHeaderColumns.each((index, bodyTh) => {
        //         let width = bodyTh.getBoundingClientRect().width,
        //             headTh = $scrollHeadColumns[index];
        //
        //         $(headTh).css({
        //             'width': `${width}px`,
        //             'box-sizing': 'border-box'
        //         });
        //
        //         bodyTh.style.setProperty('padding', `0`, 'important');
        //     });
        // } else {
        //
        // }

        this.dataTable?.columns.adjust();
    },
    onResize: function () {
        if (typeof this.options.onResize === 'function') {
            this.options.onResize();
        }
    },
    preventBubble: function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
    },
    saveColumnWidths: function () {
        let columnWidths = [],
            self = this;

        let $dtHeader = this.options.scrollY ? this.$('.dt-scroll-head').find('colgroup').first() : this.$dataTable.find('colgroup').first();
        $dtHeader.find('col').each(function () {
            let widthPercent = $(this).width() / self.$dataTable.width() * 100;
            columnWidths.push(parseFloat(widthPercent.toFixed(2)));
        });

        PJQ.helpers.cookieHelpers.setCookie(this.options.columnWidthCookie, JSON.stringify(columnWidths));
    },
    applyColumnWidths: function () {
        if (this.options.columnWidthCookie == null) {
            return;
        }

        let cookieVal = PJQ.helpers.cookieHelpers.getCookie(this.options.columnWidthCookie);

        if (!cookieVal) {
            return;
        }

        cookieVal = JSON.parse(cookieVal);

        let $dtHeader = this.options.scrollY ? this.$('.dt-scroll-head') : this.$dataTable,
            $dtBody = this.options.scrollY ? this.$('.dt-scroll-body') : this.$dataTable,
            $dtFooter = this.options.scrollY ? this.$('.dt-scroll-foot') : this.$dataTable;

        if (cookieVal && cookieVal.length === $dtHeader.find('col').length) {
            $dtHeader.find('col').each(function (i) {
                $(this).css('width', cookieVal[i] + '%');
            });

            if (this.options.scrollY) {
                $dtBody.find('col').each(function () {
                    $(this).find('td').each(function (i) {
                        $(this).css('width', cookieVal[i] + '%');
                    });
                });
                $dtFooter.find('col').each(function (i) {
                    $(this).css('width', cookieVal[i] + '%');
                });
            }
        }
    },
    beforeRemove: function () {
        $(window).off('resize.' + this.options.uuid);
    },
    pageCache: [],
    getPage: function (data, callback) {
        let pageNumber = 1,
            pageSize = data.length;
        if (data.start != null) {
            pageNumber = (data.start / pageSize) + 1;
        } else if (this.dataTable != null) {
            let pageInfo = this.dataTable.page.info();
            pageNumber = pageInfo.page + 1;
        }
        if (this.clearServerCache) {
            this.clearServerCache = false;
            this.pageCache = [];
        }

        if (this.pageCache[pageNumber - 1] == null) {
            let orderArr = [];
            _.each(data.order, function (order) {
                let columnOrderName = data.columns[order.column].data;
                if (_.size(columnOrderName) > 0 && columnOrderName.indexOf('attributes.') !== -1) {
                    columnOrderName = columnOrderName = columnOrderName.substr(columnOrderName.indexOf('.') + 1);
                }
                orderArr.push({
                    name: columnOrderName,
                    direction: order.dir
                });
            });
            let cache = this.pageCache;
            this.options.getPageCallback(pageNumber, pageSize, orderArr, _.bind(function (rows, rowCount) {
                //Its the first page, lets set the total count from the callback result
                if (pageNumber === 1) {
                    this.totalRows = rowCount;
                }
                cache[pageNumber - 1] = {
                    recordsTotal: this.totalRows,
                    recordsFiltered: this.totalRows,
                    data: rows
                };
                callback(cache[pageNumber - 1]);
            }), this);
        } else {
            callback(this.pageCache[pageNumber - 1]);
        }
    },
    afterDataTableRender: function () {
        if (typeof this.options.afterDataTableRender === 'function') {
            this.options.afterDataTableRender(this.dataTable);
        }
    },
    getColumns: function () {
        if (_.size(this.options.columnDefinitions) > 0 && _.size(this.options.identifier) > 0) {
            let colOrderStr = PJQ.helpers.cookieHelpers.getCookie(this.options.identifier + '_col_order'),
                colOrder = null;
            if (_.size(colOrderStr) > 0) {
                colOrder = JSON.parse(colOrderStr);
            }

            if (_.size(colOrder) === 0 && this.options.defaultColOrder != null) {
                colOrder = this.options.defaultColOrder;
            }

            if (_.size(colOrder) === 0) {
                colOrder = _.map(this.options.columnDefinitions, function (column) {
                    return column.columnData ?? column.data;
                });
            }

            if (_.size(colOrder) > 0) {
                let result = [];
                _.each(colOrder, (col) => {
                    let colDef = _.find(this.options.columnDefinitions, function (column) {
                        return column.columnData === col;
                    });

                    if (colDef == null) {
                        colDef = _.find(this.options.columnDefinitions, function (column) {
                            return column.data === col;
                        });
                    }

                    if (colDef != null) {
                        result.push(colDef);
                    }
                });
                return result;
            }
        }

        return this.options.columns;
    },
    orderByChanged: function () {
        if (typeof this.options.orderByChanged === 'function') {
            this.options.orderByChanged(...arguments);
        }
    },
    columnOrderChanged: function () {
        if (typeof this.options.columnOrderChanged === 'function') {
            this.options.columnOrderChanged(...arguments);
        }
    },
    createdRow: function (row, data) {
        if (typeof this.options.createdRow === 'function') {
            this.options.createdRow(row, data);
        }
    },
    getRow: function (obj) {
        if (this.dataTable) {
            if (typeof obj === 'object' && obj[0]) {
                let t = $(obj);
                if (t.length > 0) {
                    obj = t;
                }
            }

            if (obj instanceof $) {
                if (!obj.is('tr')) {
                    obj = obj.closest('tr');
                }
                obj = '#' + obj.attr('id');
            } else if (typeof obj === 'number' || typeof obj === 'string')
                obj = ('#' + obj.toString());
            return this.dataTable.row(obj);
        }
        return null;
    },
    addRow: function (obj) {
        if (this.dataTable != null) {
            if (PJQ.helpers.objectHelpers.refinedType(obj) === 'array') {
                this.dataTable.rows.add(obj).draw(false);
            } else {
                this.dataTable.row.add(obj).draw(false);
            }
        }
    },
    refreshRow: function (row) {
        if (typeof row.remove !== 'function') {
            row = this.getRow(row);
        }

        this.dataTable.row(row).invalidate().draw();
    },
    resetData: function (data) {
        this.options.data = data;
        this.dataTable.clear();
        this.dataTable.rows.add(this.getFilterData());
        this.search();
    },
    removeRow: function (row, isRefresh = true) {
        if (typeof row.remove !== 'function') {
            row = this.getRow(row);
        }

        row.remove().draw();
        if (isRefresh) {
            this.refresh();
        }

        if (typeof this.options.onRowRemoved === 'function') {
            this.options.onRowRemoved(row);
        }
    },
    removeAllRows: function () {
        if (this.dataTable != null) {
            this.dataTable.clear().draw();
        }
    },
    getFilterData: function () {
        return typeof this.options.getFilterData === 'function' ? this.options.getFilterData(this, this.options.data) : this.options.data;
    },
    getFilter: function (attr) {
        if (this.filters == null) {
            return null;
        }
        let find = this.filters[attr];
        return find ? find : null;
    },
    setFilter: function (attr, value) {
        if (this.filters == null) {
            this.filters = {};
        }
        this.filters[attr] = value;
        this.filter();
    },
    filter: function () {
        if (this.dataTable != null) {
            if (this.options.getPageCallback != null) {
                this.clearServerCache = true;
                this.dataTable.draw();
            } else {
                let columns = this.getRowChildColumns({level: 1});

                this.removeAllChildRows();
                this.filteredData = this.getFilterData();

                if (columns == null) {
                    this.dataTable.clear();
                    this.dataTable.rows.add(this.filteredData);
                }

                this.search();
            }
        }
    },
    clearFilters: function () {
        this.filters = null;
        this.renderHeader();
        this.filter();
    },
    getFilteredRowData: function () {
        let filteredRows = this.dataTable.rows({filter: 'applied'}).data(),
            result = [];
        _.each(filteredRows, function (filteredRow) {
            result.push(filteredRow);
        })
        return result;
    },
    toggleGroup: function (e) {
        let name = $(e.currentTarget).data('name');
        this.options.collapsedGroups[name] = !this.options.collapsedGroups[name];
        this.dataTable.draw();
    },
    getGroupByColumnIndex: function (id) {
        let result = _.findIndex(this.options.columns, function (col) {
            return col.attribute === id || col.columnData === id;
        })
        return result === -1 ? null : result;
    },
    getGroupByColumn: function () {
        let colInd = this.getGroupByColumnIndex(this.getGroupBy());
        col = colInd != null ? this.options.columns[colInd] : null;
        return col ? {
            column: col,
            index: colInd
        } : null;
    },
    getGroupBy: function () {
        return typeof this.options.groupBy !== 'undefined' ? this.options.groupBy : null;
    },
    setGroupBy: function (groupBy) {
        this.options.groupBy = _.size(groupBy?.trim() ?? '') > 0 ? groupBy : null;

        if (_.size(this.options.groupByKey) > 0) {
            window.localStorage.removeItem(this.options.groupByKey);
            if (_.size(groupBy) > 0) {
                window.localStorage.setItem(this.options.groupByKey, groupBy);
            }
        } else {
            window.localStorage.removeItem(this.options.groupByKey);
        }

        this.render();
    },
    startGroupRender: function (rows, group) {
        if (group == null) {
            return;
        }

        let safeGroup = this.stripHtml(group);

        let collapsed = !!this.options.collapsedGroups[safeGroup];

        rows.nodes().each(function (r) {
            r.style.display = collapsed ? 'none' : '';
        });

        let toggle = '';
        if (this.options.disableGroupToggle !== true) {
            let toggleClass = collapsed ? 'fa-plus-square' : 'fa-minus-square';
            toggle = `<span data-name="${this.stripHtml(group)}" class="fal ml-2 mr-2 fa-lg fa-fw group-start toggler ${toggleClass}" style="width:auto;"></span>`;
        }

        return $('<tr/>')
            .append(`<td colspan="${rows.columns()[0].length}">
                    <div class="d-flex wd-100 align-items-center">
                        ${toggle}
                        <div class="wd-100" style="display:inherit;">${this.getGroupHeader(group, rows)}</div>
                    </div>
                </td>`)
            .attr('data-name', safeGroup)
            .toggleClass('collapsed', collapsed);
    },
    stripHtml: function (html) {
        let div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    },
    getGroupHeader: function (group, rows) {
        if (typeof this.options.getGroupHeader === 'function') {
            return this.options.getGroupHeader(group, rows);
        }

        return '<span class="fs-15 font-weight-bold text-dark p-1">' + group + ' (' + rows.count() + ')</span>';
    },
    refresh: function (type = false) {
        if (this.dataTable != null) {
            this.dataTable.rows().invalidate(type);
            this.adjust(type);
            this.onTableDraw();
        }
    },
    adjust: function (type = false) {
        this.dataTable.columns.adjust().draw(type);
    },
    getSearchText: function () {
        let $search = this.$('.datatable-search');
        return $search.length > 0 ? $search.val() : '';
    },
    search: function (searchText) {
        searchText = this.getSearchText();
        //Hack to make the zeroRecords language be used instead of emptyTable
        //This is only needed when there are records filtered before the search
        //If the remaining records are filtered by search, the datatable will handle the language correctly
        if (this.options.getPageCallback != null) {
            if (this.lastSearchText !== searchText) {
                if (this.searchTimeout != null) {
                    clearTimeout(this.searchTimeout);
                }
                this.searchTimeout = setTimeout(_.bind(function () {
                    this.clearServerCache = true;
                    this.dataTable.search(searchText).draw();
                    this.afterSearch();
                }, this), 500);
            }
        } else {
            let colSearch = false,
                self = this;

            if (searchText.indexOf(":") !== -1) {
                let searchArr = searchText.split(':');
                if (_.size(searchArr) > 1) {
                    let colName = searchArr[0],
                        colSearchText = searchArr[1],
                        colIndex = this.colNameMap[colName.toLowerCase()];
                    if (colIndex != null) {
                        colSearch = true;
                        this.dataTable.search('').column(colIndex).search(colSearchText).draw();
                    }
                }
            }
            if (!colSearch) {
                let childColumns = this.getRowChildColumns(1);

                if (childColumns != null) {
                    if (this.searchTimeout != null) {
                        clearTimeout(this.searchTimeout);
                    }

                    this.searchTimeout = setTimeout(() => {
                        this.initializeToggledRows(true);
                        this.$("tbody tr").css('visibility', 'collapse');
                        let filteredIds = this.filteredData ? _.map(this.filteredData, (data) => {
                            return data[this.options.rowId]
                        }) : null;
                        let shownRowsCount = 0;

                        this.$dataTable.find("tbody tr:not(.child-row)").each(function () {
                            let $parentRow = $(this),
                                parentId = $parentRow?.attr("id"),
                                isParentMatch = self.rowMatchesSearch($parentRow, searchText) && (filteredIds == null || _.contains(filteredIds, parentId)),
                                filteredChildren = self.filterChildRows(parentId, searchText, filteredIds, isParentMatch),
                                isDtEmptyRow = $parentRow.find("td.dt-empty").length > 0;

                            if ((isParentMatch || filteredChildren.length > 0) && !isDtEmptyRow) {
                                shownRowsCount += 1;
                                $parentRow.css('visibility', 'visible');
                            }
                        });

                        let $dtEmpty = this.$dataTable.find('td.dt-empty');

                        if ($dtEmpty.length > 0) {
                            $dtEmpty.closest('tr').remove();
                        }

                        if (shownRowsCount === 0) {
                            let colCount = this.$dataTable.find('colgroup col').length;

                            let $tr = $('<tr>').append($('<td>').addClass('dt-empty').attr('colspan', colCount).text(this.$dataTable.find("tbody tr:not(.child-row)").length > 0 ? this.options.language.zeroRecords : this.options.language.emptyTable));
                            this.$dataTable.find('tbody').append($tr);
                        }
                    }, 500);
                } else {
                    this.dataTable.columns().search('');
                    this.dataTable.search(searchText).draw();

                    //If there is a filter prior to the search, we have to override the emptyTable language with zeroRecords
                    //zeroRecords is only displayed automatically using DataTables built in search
                    if (_.size(searchText) === 0 && _.size(this.filteredData) === 0 && _.size(this.options.data) > 0) {
                        this.$(".dt-empty").html(this.options.language.zeroRecords);
                    }
                }
            }

            this.afterSearch();
        }
        this.lastSearchText = searchText;
    },
    filterChildRows: function (parentId, searchText, filteredIds, forceShow = false) {
        let self = this,
            matchingRows = [];

        this.$(`tr.child-row[data-parent-id='${parentId}']`).each(function () {
            let $childRow = $(this),
                childId = $childRow.attr('id'),
                isChildMatch = self.rowMatchesSearch($childRow, searchText) && (filteredIds == null || _.contains(filteredIds, childId)),
                filteredGrandChildren = self.filterChildRows(childId, searchText, filteredIds, isChildMatch);

            if (isChildMatch || filteredGrandChildren.length > 0 || forceShow) {
                $childRow.css('visibility', 'visible');
                matchingRows.push($childRow);
            }
        });

        return matchingRows;
    },
    rowMatchesSearch: function ($row, searchText) {
        let rawText = $row.clone().children().map(function () {
            return $(this).text().trim();
        }).get().join(' ');

        return rawText.toLowerCase().includes(searchText.toLowerCase());
    },
    afterSearch: function () {

    },
    addContextMenu: function (newOptions) {
        this.options.contextMenuOptions = newOptions;
        this.contextMenu = new PJQ.menus.ContextMenu(_.defaults(this.options.contextMenuOptions, {
            el: this.$wrapper,
            selector: 'tr[id]',
            isHideNoActions: true,
            isWrapInFixedContainer: true,
            fetchElementData: _.bind(function (element) {
                let isChild = element.hasClass('child-row');

                return isChild ? this.getChildRowObject(element) : this.getRow(element);
            }, this),
            onOpen: _.bind(function (row) {
                $(row.node()).addClass('context-row');
            }, this),
            onClose: _.bind(function () {
                this.$('.context-row').removeClass('context-row');
            }, this)
        }));
    },
    makeSortable: function (options) {
        let data = this.dataTable.data();
        if (_.size(data) === 0) {
            return;
        }

        let self = this;
        this.options.sortableOptions = options;

        if (this.options.sortableOptions.isNestedTable) {
            new PJQ.Sortable(self.$el, _.defaults(options, {
                data: data[0].collection,
                dataAttribute: 'sortOrder',
                items: 'tbody tr:not(.child-row-footer)',
                connectWith: 'tbody tr:not(.child-row-footer)',
                start: function (event, ui) {
                    $(this).sortable("refreshPositions");
                },
                change: function (event, ui) {
                    let placeholder = ui.placeholder,
                        prevItem = placeholder.prev(),
                        nextItem = placeholder.next(),
                        draggedItem = ui.helper;

                    if (draggedItem.hasClass('child-row')) {
                        let level = draggedItem.data('level');
                        if (!((nextItem.hasClass('child-row') || nextItem.hasClass('child-row-footer')) && nextItem.data('level') === level)) {
                            placeholder.hide();
                            return;
                        }
                    } else {
                        if (!(prevItem.data('parentId') == null || prevItem.length === 0)) {
                            placeholder.hide();
                            return;
                        }
                    }

                    placeholder.show();
                },
                stop: function (event, ui) {
                    let draggedItem = ui.item,
                        level = draggedItem.data('level'),
                        parentId,
                        prevItem = draggedItem.prev();

                    if (level != null) {
                        // If the next item is not a child-row or child-row-footer, and it's level is not the same as the dragged item, then cancel the drop
                        let nextItem = draggedItem.next();
                        if (!((nextItem.hasClass('child-row') || nextItem.hasClass('child-row-footer')) && nextItem.data('level') === level)) {
                            $(this).sortable('cancel');
                            return;
                        }

                        // If the dragged elements level is 1, then we need to find the first element above it that doesn't have a level
                        // If the dragged elements level is greater than 1, then we need to find the first element above it that has a level 1 less than the dragged element
                        // The parentId will be the id of the element found that meets the above criteria
                        if (level === 1 || level == null) {
                            while (prevItem.length) {
                                if (!prevItem.data('level')) {
                                    parentId = prevItem.attr('id');
                                    break;
                                }
                                prevItem = prevItem.prev();
                            }
                        } else {
                            while (prevItem.length) {
                                if (prevItem.data('level') === level - 1) {
                                    parentId = prevItem.attr('id');
                                    break;
                                }
                                prevItem = prevItem.prev();
                            }
                        }

                        if (!parentId) {
                            $(this).sortable('cancel');
                            return;
                        }

                        draggedItem.attr('data-parent-id', parentId).data('parent-id', parentId);
                        let siblings = self.$dataTable.find('tbody tr').filter(function () {
                            return $(this).data('parent-id') === parentId && !$(this).hasClass('child-row-footer');
                        });
                        let position = siblings.index(draggedItem) + 1;

                        let item,
                            parent;

                        _.each(options.data, function (data) {
                            if (data[self.options.rowId] === draggedItem.attr('id')) {
                                item = data;
                            }

                            if (data.cid === parentId) {
                                parent = data;
                            }
                        });

                        if (item == null || parent == null || position <= 0) {
                            $(this).sortable('cancel');
                            return;
                        }

                        self.onNestedRowSorted(item, position, parent);
                    } else {
                        if (!(prevItem.data('parentId') == null || prevItem.length === 0)) {
                            $(this).sortable('cancel');
                            return;
                        }

                        let siblings = self.$dataTable.find('tbody tr').filter(function () {
                            return !$(this).data('parent-id');
                        });

                        let position = siblings.index(draggedItem) + 1,
                            item = _.find(options.data, (data) => data[this.options.rowId] === draggedItem.attr('id'));

                        if (item == null || position <= 0) {
                            $(this).sortable('cancel');
                            return;
                        }

                        self.onNestedRowSorted(item, position, null);
                    }
                }
            }));
        } else {
            let $tbl = self.$('table');
            new PJQ.Sortable($tbl, _.defaults(options, {
                containment: "document",
                data: data[0].collection,
                dataAttribute: 'sortOrder',
                items: ">tbody>tr",
                connectWith: ">tbody>tr",
                // Start is necessary to keep row CSS from squishing together
                // Selects the table header row and copies the width of the td to the current dragged object
                start: (a, b) => {
                    let headerRow = $tbl.find('thead')[0].firstChild;
                    _.each(b.item[0].children, function (td, index) {
                        let headerCol = $(headerRow.children[index]);
                        if (headerCol.length > 0) {
                            td.width = headerCol.outerWidth()
                        }
                    })
                },
                update: (a, b) => {
                    let sortedRow = b.item[0].id,
                        rowData = options.data.get(sortedRow),
                        pageInfo = self.dataTable.page.info();
                    $tbl.find('tbody>tr').each(function (index, html) {
                        let sortNumber = (pageInfo.page * pageInfo.length) + (index + 1),
                            row = $(html)[0].id;
                        if (row === sortedRow) {
                            self.onRowSorted(rowData, sortNumber);
                        }
                    });
                }
            }));
        }
    },
    onNestedRowSorted: function (item, newSort, newParent) {
        if (typeof this.options.onNestedRowSorted === 'function') {
            this.options.onNestedRowSorted(item, newSort, newParent);
        }
    },
    onRowSorted: function (data, sortOrder) {
        if (data == null || _.size(this.options.sortableOptions.dataAttribute) === 0) {
            return;
        }

        data.set(this.options.sortableOptions.dataAttribute, sortOrder);

        if (this.options.sortableOptions.shouldSave === true) {
            data.save(null, {
                success: _.bind(function () {
                    if (this.collection != null) {
                        this.collection.fetch({
                            success: _.bind(function () {
                                this.render();
                            }, this)
                        });
                    }
                }, this)
            });
        }
    },
    toggleAllChildRows: function (e) {
        let self = this,
            expand = _.size(this.options.expandedRowIds) === 0;
        this.dataTable.rows().every(function () {
            self.toggleChildRow(this, expand, true, expand);
        });

        if (!expand) {
            this.options.expandedRowIds = [];
        }

        this.renderToggleAllIcon();
    },
    renderToggleAllIcon: function () {
        let $icon = $('.toggle-all-rows');
        if ($icon.length === 0) {
            return;
        }

        let hasExpanded = _.size(this.options.expandedRowIds) > 0;
        if (hasExpanded) {
            $icon.removeClass('fa-plus-circle').addClass('fa-minus-circle');
        } else {
            $icon.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        }
    },
    getChildRowObject: function ($tr) {
        return {
            node: () => {
                return $tr
            },
            data: () => {
                return this.getChildRowData($tr.data('parentId'), $tr.data('row-id'), $tr.data('level'))
            }
        }
    },
    childRowToggle: function (sender, rowOverride) {
        let $target = rowOverride ? $(rowOverride.selector.rows).find(this.options.toggleRowClass) : $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);

        if ($(tr).hasClass('child-row')) {
            row = this.getChildRowObject($(tr));
        }
        this.toggleChildRow(row);
    },
    toggleChildRow: function (row, show = null, preventOnToggleEvent = false, expandAll = false) {
        if (this.options.expandedRowIds == null) {
            this.options.expandedRowIds = [];
        }

        let tr = $(row.node()),
            item = row.data(),
            id = item[this.options.rowId],
            $icon = tr.find(this.options.toggleRowClass),
            level = tr.data('level');
        if ($icon.length === 0) {
            return;
        }

        if (show !== true && (row.child?.isShown() || tr.hasClass('shown') || this.options.expandedRowIds.includes(id))) {
            if (this.options.childDataTables != null) {
                this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                    return childDt.options.parentId !== id;
                }, this));
            }

            if (row.child) {
                row.child.hide();
            }

            tr.removeClass('shown');
            this.options.expandedRowIds = this.options.expandedRowIds.filter(expandedId => expandedId !== id);
            $icon.removeClass('fa-minus-circle').addClass('fa-plus-circle');

            let parentId = item[this.options.rowId];
            if (_.size(parentId) > 0) {
                this.removeChildRows(parentId);
            }
        } else if (show !== false) {
            $icon.removeClass('fa-plus-circle').addClass('fa-minus-circle');

            this.renderChildRows(row, id, level ? level + 1 : 1, expandAll);
            tr.addClass('shown');

            if (!_.contains(this.options.expandedRowIds, id)) {
                this.options.expandedRowIds.push(id);
            }
        }

        if (!preventOnToggleEvent) {
            this.onChildRowToggle(row);
        }
        this.renderToggleAllIcon();
    },
    removeChildRows: function (parentId) {
        let childRows = $('tr.child-row[data-parent-id="' + parentId + '"], tr.child-row-footer[data-parent-id="' + parentId + '"]'),
            self = this;

        if (_.size(childRows) > 0) {
            childRows.each(function () {
                let newParentId = $(this).data('row-id');
                self.removeChildRows(newParentId);
            });
            childRows.remove();
        }
    },
    removeAllChildRows: function () {
        let self = this;

        this.dataTable.rows().every(function () {
            let parentId = $(this.node()).data('row-id');
            if (parentId !== undefined) {
                self.removeChildRows(parentId);
            }
        });
    },
    getChildRowData: function (parentId, id, level) {
        if (typeof this.options.getChildRowData === 'function') {
            return this.options.getChildRowData(parentId, id, level);
        }
        return {};
    },
    onChildRowToggle: function (row) {
        if (typeof this.options.onChildRowToggle === 'function') {
            this.options.onChildRowToggle(row);
        }
    },
    initializeToggledRows: function (forceExpandAll = false) {
        let expandAll = (this.options.expandedRowIds == null && this.options.expandAll) || forceExpandAll;
        if (_.size(this.options.expandedRowIds) === 0 && !expandAll)
            return;

        if (this.options.expandedRowIds == null || forceExpandAll) {
            this.options.expandedRowIds = [];
        }

        let self = this;
        this.dataTable.rows().every(function () {
            let row = this,
                data = row.data(),
                id = data[self.options.rowId];

            if ((expandAll || _.contains(self.options.expandedRowIds, id)) && self.options.isChildTables !== true) {
                self.toggleChildRow(row, true, true, expandAll);
            }
        });
    },
    getChildHeader: function (opts) {
        if (typeof this.options.getChildHeader === 'function') {
            return this.options.getChildHeader(opts);
        }
        return '';
    },
    getChildFooter: function (opts) {
        if (typeof this.options.getChildFooter === 'function') {
            return this.options.getChildFooter(opts);
        }
        return '';
    },
    renderChildRows: function (row, parentId, level = 1, expandAll) {
        if (this.childRows == null) {
            this.childRows = {};
        }

        if (!this.childRows[level]) {
            this.childRows[level] = {};
        }
        // Prevent duplicates
        this.removeChildRows(parentId);

        let childData = this.getRowChildData(row, level),
            self = this;
        if (childData != null) {
            let fnRender = () => {
                let childCols = this.getRowChildColumns({
                    level: level
                });

                if (childCols != null) {
                    let childHeader = this.getChildHeader(row),
                        childRows = '';
                    if (_.size(childHeader) > 0) {
                        let displayedColumnsCount = this.dataTable.columns(':visible').count();
                        childRows += `<tr><td style="border-top: none;" colspan="${displayedColumnsCount}"><table class="wd-100 table dataTable no-footer"><tr class="child-row-header" data-level="${level}" data-parent-id="${parentId}">${childHeader}</tr>`;
                    } else {
                        let currentSort = this.dataTable.order();
                        currentSort = Array.isArray(currentSort[0]) ? currentSort[0] : currentSort;

                        let sortColumnIndex = currentSort[0],
                            sortDirection = currentSort[1],
                            column = childCols[sortColumnIndex];
                        childData = _.sortBy(childData, (item) => {
                            let val;

                            if (column.data && typeof column.data === 'string' && column.data !== '') {
                                val = column.data.split('.').reduce((obj, key) => obj && obj[key], item);
                            }

                            if (typeof column.data?._ === 'function') {
                                val = column.data._(item);
                            }

                            if (val === null || val === undefined) return Number.MAX_VALUE;
                            if (typeof val === 'boolean') return val ? 1 : 0;
                            if (!isNaN(val) && val !== '' && typeof val !== 'object') return parseFloat(val);
                            if (Object.prototype.toString.call(val) === "[object Date]" || Date.parse(val)) return new Date(val).getTime();
                            if (typeof val === 'object') return JSON.stringify(val);

                            return val.toString().toLowerCase();
                        });

                        if (sortDirection === "desc") {
                            childData.reverse();
                        }
                    }

                    childData.forEach((item) => {
                        childRows += this.renderChildRow(parentId, item, level, childCols);
                    });

                    let footer = this.getChildFooter(row);
                    if (_.size(footer) > 0) {
                        childRows += `<tr class="child-row-footer" data-level="${level}" data-parent-id="${parentId}">${footer}</tr>`;
                    }

                    if (_.size(childHeader) > 0) {
                        childRows += '</table></td></tr>';
                    }

                    $(row.node()).after(childRows);

                    let $rows = this.$(`tr.child-row[data-parent-id="${parentId}"]`);
                    $rows.each(function () {
                        let row = self.getChildRowObject($(this)),
                            rowId = row.node().attr("data-row-id"),
                            $icon = row.node().find(self.options.toggleRowClass);
                        if (rowId && $icon.length > 0 && (_.contains(self.options.expandedRowIds, rowId) || expandAll)) {
                            self.toggleChildRow(row, true, true, expandAll);
                        }
                    });

                    if ($rows.length > 0 && level > 0) {
                        $rows.last().addClass('last-child-row');
                    }
                    return;
                }

                let childClass = 'subgrid-' + parentId.toString(),
                    $childTable = $('<div data-id="' + parentId + '" />', {
                        class: childClass + ' p-2'
                    });
                row.child($childTable).show();
                let childTable = this.getRowChildTable({
                    el: $childTable,
                    data: PJQ.helpers.objectHelpers.isBackboneCollection(childData) ? childData.models : childData,
                    isHideSearch: true,
                    parentId: parentId,
                    parentData: row.data()
                });
                this.options.childDataTables = _.filter(this.options.childDataTables, (childDt) => {
                    return childDt.options.parentId !== parentId;
                });
                this.options.childDataTables.push(childTable);
            };

            if (PJQ.helpers.objectHelpers.isBackboneModel(childData)) {
                childData.fetch({
                    success: () => {
                        fnRender();
                    }
                });
            } else {
                fnRender();
            }
        }
    },
    renderChildRow: function (parentId, item, level, cols = null, replace = false) {
        if (cols == null) {
            cols = this.getRowChildColumns({
                level: level
            });
        }

        let childRowClasses = this.getChildRowClasses(item, level) ?? "",
            childRowStyles = this.getChildRowStyles(item, level) ?? "",
            row = `<tr data-parent-id="${parentId}" data-level="${level}" data-row-id="${item[this.options.rowId]}" id="${item[this.options.rowId]}" class="child-row ${childRowClasses}" style="${childRowStyles}">`;
        cols.forEach((column, index) => {
            let content = typeof column.render === 'function' ? column.render(null, null, item) : typeof column.data.display === 'function' ? column.data.display(item) : '';
            row += `<td class="${column.className ?? ""}" style="width:${column.width || 'auto'}">${content}</td>`;
        });
        row += '</tr>';

        if (replace) {
            let $row = this.$('tr.child-row[data-row-id="' + item[this.options.rowId] + '"]');
            if ($row.length > 0) {
                $row.replaceWith(row);
            } else {

            }
        }

        return row;
    },
    renderChildColumn: function (colIndex, item, level) {
        let cols = this.getRowChildColumns({
                level: level
            }),
            column = cols[colIndex];
        if (column == null) {
            return;
        }

        let content = typeof column.render === 'function' ? column.render(null, null, item) : '',
            $row = this.$('tr.child-row[data-row-id="' + item[this.options.rowId] + '"]');
        if ($row.length === 0) {
            return;
        }

        let $replace = $row.find('td:nth-child(' + (colIndex + 1).toString() + ')');
        if ($replace.length === 0) {
            return;
        }
        $replace.replaceWith(`<td style="width:${column.width || 'auto'}">${content}</td>`);
    },
    getRowChildColumns: function (opts) {
        if (typeof this.options.getRowChildColumns === 'function') {
            return this.options.getRowChildColumns(opts);
        }
        return null;
    },
    getRowChildTable: function (opts) {
        if (typeof this.options.getRowChildTable === 'function') {
            return this.options.getRowChildTable(opts);
        }
        return null;
    },
    getRowChildData: function (row, level) {
        if (typeof this.options.getRowChildData === 'function') {
            return this.options.getRowChildData(row, level);
        }
        return {};
    },
    getChildRowClasses: function (item, level) {
        if (typeof this.options.getChildRowClasses === 'function') {
            return this.options.getChildRowClasses(item, level);
        }
        return '';
    },
    getChildRowStyles: function (item, level) {
        if (typeof this.options.getChildRowStyles === 'function') {
            return this.options.getChildRowStyles(item, level);
        }
        return '';
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    }
});

PJQ.models.customFields = {};
PJQ.collections.customFields = {};
PJQ.views.customFields = {};

PJQ.helpers.customFieldHelpers = {
    getDisplayValue: function (type, value, choices = null, isMultipleChoice = false) {
        // currently only supports choices being a backbone collection
        if (type == null || value == null || (type === 'CHOICE' && _.size(choices) === 0)) {
            return '';
        }
        let typeUpper = type.toUpperCase(),
            valueType = PJQ.helpers.objectHelpers.refinedType(value),
            result = '';
        switch (typeUpper) {
            case PJQ.constants.customFields.fieldTypes.TEXT:
                if (valueType === 'string') {
                    result = value;
                } else if (valueType === 'number') {
                    result = valueType.toString();
                }
                break;
            case PJQ.constants.customFields.fieldTypes.CHOICE:
                let fnGetChoiceName = function (choiceId) {
                    if (choiceId == null) {
                        return '';
                    }
                    let chId;
                    if (typeof choiceId === 'number') {
                        chId = choiceId;
                    } else if (typeof choiceId === 'string') {
                        if (_.size(choiceId) === 0) {
                            return '';
                        }
                        chId = parseInt(choiceId);
                        if (isNaN(chId)) {
                            return '';
                        }
                    }
                    let choice = choices.get(chId);
                    if (choice != null) {
                        if (_.size(choice.get('value')) > 0) {
                            return choice.get('value');
                        } else if (_.size(choice.get('name')) > 0) {
                            return choice.get('name');
                        }
                    }
                    return '';
                }
                if (isMultipleChoice) {
                    let arrValue;
                    if (valueType === 'array') {
                        arrValue = value;
                    } else if (valueType === 'string') {
                        arrValue = value.split('|');
                    } else {
                        arrValue = [];
                    }

                    let choiceNames = [];
                    _.each(arrValue, function (choiceId) {
                        let choiceName = fnGetChoiceName(choiceId);
                        if (_.size(choiceName) > 0) {
                            choiceNames.push(choiceName);
                        }
                    })
                    result = choiceNames.join(', ');
                } else {
                    let choiceId;
                    if (valueType === 'number') {
                        choiceId = value;
                    } else if (valueType === 'string') {
                        choiceId = parseInt(value);
                    } else {
                        choiceId = null;
                    }
                    result = choiceId == null ? '' : fnGetChoiceName(choiceId);
                }
                break;
            case PJQ.constants.customFields.fieldTypes.BOOL:
                let boolValue;
                if (valueType === 'boolean') {
                    boolValue = value;
                } else if (valueType === 'string') {
                    if (_.size(value) === 0) {
                        return '';
                    }
                    let lowerValue = value.toLowerCase();
                    boolValue = lowerValue === 'true' || lowerValue === 'yes';
                } else if (valueType === 'number') {
                    boolValue = value === 1;
                } else {
                    boolValue = null;
                }
                if (boolValue == null) {
                    result = '';
                } else {
                    result = boolValue ? 'Yes' : 'No';
                }
                break;
            case PJQ.constants.customFields.fieldTypes.INT:
            case PJQ.constants.customFields.fieldTypes.MONEY:
            case PJQ.constants.customFields.fieldTypes.PERCENT:
                let intValue;
                if (valueType === 'number') {
                    intValue = value;
                } else if (valueType === 'string') {
                    intValue = parseInt(value);
                } else {
                    intValue = null;
                }

                if (intValue == null || isNaN(intValue)) {
                    result = '';
                } else if (typeUpper === PJQ.constants.customFields.fieldTypes.INT) {
                    result = intValue.toString();
                } else if (typeUpper === PJQ.constants.customFields.fieldTypes.MONEY) {
                    result = PJQ.helpers.formatHelpers.formatCurrency(intValue)
                } else if (typeUpper === PJQ.constants.customFields.fieldTypes.PERCENT) {
                    result = intValue.toString() + '%';
                }
                break;
            case PJQ.constants.customFields.fieldTypes.DATE:
            case PJQ.constants.customFields.fieldTypes.DATETIME:
                let dateValue;
                if (valueType === 'date') {
                    dateValue = value;
                } else if (valueType === 'string') {
                    dateValue = new Date(value);
                } else {
                    dateValue = null;
                }

                let isDateTime = typeUpper === PJQ.constants.customFields.fieldTypes.DATETIME,
                    format;
                if (isDateTime) {
                    format = PJQ.helpers.dateHelpers.dateFormats.DATE_TIME;
                } else {
                    format = PJQ.helpers.dateHelpers.dateFormats.DATE;
                }
                result = dateValue == null ? '' : PJQ.helpers.dateHelpers.getDateString(dateValue, format, !isDateTime);
                break;
            default:
                result = value;
        }
        return result;
    }
}


//Models
PJQ.models.customFields.CustomField = PJQ.models.BaseModel.extend({
    idAttribute: "id",
    collectionClass: function () {
        return PJQ.collections.customFields.CustomFieldChoices;
    },
    newChoiceCollection: function (choices) {
        return new (this.collectionClass())(choices);
    },
    parse: function (model) {
        if (model != null) {
            if (model.choices != null) {
                if (this.choices != null) {
                    this.choices.reset(model.choices);
                } else {
                    this.choices = this.newChoiceCollection(model.choices);
                    this.choices.on('update', _.bind(function () {
                        this.isDirty = true;
                    }, this));
                }
            } else {
                this.choices = this.newChoiceCollection();
                this.choices.on('update', _.bind(function () {
                    this.isDirty = true;
                }, this));
            }
        } else {
            this.choices = this.newChoiceCollection();
            this.choices.on('update', _.bind(function () {
                this.isDirty = true;
            }, this));
        }

        return model;
    },
    beforeSave: function () {
        this.set('choices', this.choices.getChangedModels());
    }
});

PJQ.models.customFields.CustomFieldChoice = PJQ.models.BaseModel.extend({
    idAttribute: "id"
});


//Collections
PJQ.collections.customFields.CustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.customFields.CustomField
});

PJQ.collections.customFields.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.customFields.CustomFieldChoice
});


//Views
PJQ.views.customFields.CustomFieldsForm = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form'),
        subTemplates: {
            field: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form-Field'),
            fieldInput: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form-Field-Input')
        },
        isEdit: null, // null by default, will be used to seet canEdit if not null
        canEdit: true
    },
    beforeFirstRender: function () {
        if (this.options.isEdit != null) {
            this.options.canEdit = this.options.isEdit;
        }

        this.changedValues = [];
        if (this.options.fieldValues == null) {
            this.options.fieldValues = [];
        }

        if(this.options.applyDefaults !== false){
            _.each(this.collection.models, (field, index) => {
                let value = field.get('defaultValue') ?? '';
                if (field.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE || field.get('fieldType') === PJQ.constants.customFields.fieldTypes.INT) {
                    value = parseInt(value);

                    if (isNaN(value)) {
                        value = null;
                    }
                }

                let existingFieldValue = _.find(this.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === field.get('id');
                });
                value = value != null ? value : null;
                if (value == null) {
                    return;
                }

                if (existingFieldValue == null) {
                    this.options.fieldValues.push({
                        fieldNumber: field.get('fieldNumber'),
                        fieldTypeId: field.get('fieldTypeId'),
                        fieldType: field.get('fieldType'),
                        isMultiple: field.get('isMultiple'),
                        value: value,
                        id: field.get('id')
                    })
                } else if (existingFieldValue.value == null) {
                    existingFieldValue.value = value;
                }
            });
        }
    },
    afterRender: function () {
        _.each(_.sortBy(this.collection.models, function (model) {
            return model.get('sortOrder') != null ? model.get('sortOrder') : model.id
        }), function (field) {
            // Don't render anything for Upload V2 fields
            if (field.get('fieldTypeId') === 13) {
                return;
            }

            if ((field instanceof PJQ.models.contacts.ContactCustomField || field instanceof PJQ.models.contacts.CompanyCustomField) && field.get('isVisibleInRSVP') === false && !this.options.isAdmin) {
                return false;
            }

            let $cf = this.$('.custom-field-outer-' + field.id.toString()),
                $field = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.field, {
                    model: field,
                    fieldValues: this.options.fieldValues,
                    subTemplates: this.options.subTemplates,
                    canEdit: this.options.canEdit,
                    isAdmin: this.options.isAdmin
                });
            if (_.size($cf) > 0) {
                let colClasses = $cf.data('classes');
                $cf.replaceWith($field);
                if (_.size(colClasses) > 0) {
                    $field.removeClass('col-sm-12 col-md-6 col-6 col-12').addClass(colClasses);
                }
            } else {
                this.$('.custom-fields').append($field);
            }
        }, this);
        this.attachFormEvents();
    },
    attachFormEvents: function () {
        let self = this;
        this.customFieldControls = [];

        this.$('.custom-field.input-text[data-p-bind],.custom-field.input-dollars-full[data-p-bind],.custom-field.input-numeric[data-p-bind],.custom-field.input-percent[data-p-bind],.custom-field.input-phone[data-p-bind],.custom-field.input-textarea[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                mask = input.data('mask');
            if (_.size(mask) > 0) {
                input.inputmask(mask, {
                    placeholder: ''
                });
            } else if (input.hasClass('input-dollars-full')) {
                PJQ.helpers.inputHelpers.inputMaskCurrency(input, 2);
            } else if (input.hasClass('input-numeric')) {
                PJQ.helpers.inputHelpers.inputMaskInteger(input);
            } else if (input.hasClass('input-percent')) {
                PJQ.helpers.inputHelpers.inputMaskPercent(input, 2, true);
            } else if (input.hasClass('input-phone')) {
                PJQ.helpers.inputHelpers.inputMaskPhone(input);
            }

            self.customFieldControls.push({
                id: customFieldId,
                input: input
            });
        });

        this.$('.custom-field.input-select[data-p-bind],.custom-field.input-bool[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                control = new PJQ.inputs.Selectpicker({
                    el: input,
                    isIntChoices: !input.hasClass('input-bool') && !input.hasClass('input-state'),
                    onChange: function (value) {
                        if (input.hasClass('input-bool'))
                            value = value.toLowerCase() === 'true';
                        self.fieldChanged(customFieldId, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control
            });
        });

        this.$('.custom-field.input-date[data-p-bind],.custom-field.input-date-time').each(function () {
            let input = $(this),
                customFieldId = input.data('fieldId'),
                isDateTime = input.hasClass('input-date-time'),
                control = new PJQ.inputs.Datepicker({
                    el: input,
                    isUTC: false,
                    datepickerOptions: {
                        format: !isDateTime ? PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase() : undefined
                    },
                    onChange: function (value) {
                        if (!isDateTime)
                            value = PJQ.helpers.dateHelpers.getDateString(value, PJQ.helpers.dateHelpers.dateFormats.DATE);

                        self.fieldChanged(customFieldId, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control
            });
        });

        this.$('.custom-field.input-contact[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });

            let value = fieldValue.value,
                isMultipleChoice = input.data('multipleChoice');
            if (isMultipleChoice) {
                value = new PJQ.collections.contacts.Contacts(value).models;
            } else if (value != null) {
                value = new PJQ.models.contacts.Contact(value);
            }

            let control = new PJQ.views.contacts.ContactsSelectInput({
                el: input,
                context: PJQ.constants.contacts.contexts.CONTACTS,
                selectedContact: value,
                isSingleChoice: !isMultipleChoice,
                isReadOnly: !self.options.canEdit,
                emptyNotice: "No Contact Selected",
                onChange: function (selectedContacts) {
                    self.fieldChanged(customFieldId, selectedContacts);
                }
            });

            self.customFieldControls.push({
                id: customFieldId,
                input: control
            });
        });

        this.$('.custom-field.input-html[data-p-bind]').each(function () {
            let $htmlInput = $(this);
            let customFieldId = $htmlInput.data('pBind'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });
            new PJQ.inputs.HTMLEditor({
                el: $htmlInput,
                editorHeight: 600,
                defaultValue: _.size(fieldValue.value) > 0 ? fieldValue.value.replace(/(?:\r\n|\r|\n)/g, '<br>') : fieldValue.value,
                onChange: function (contents) {
                    if (contents !== fieldValue.value) {
                        self.fieldChanged(customFieldId, contents);
                    }
                }
            });
        });

        this.$('.custom-field.file-upload-field').each(function () {

            let endpoint,
                fnInput = function ($input, attachments, endpoint) {
                    let sortSettings;
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SORT_USER_ATTACHMENTS))
                        sortSettings = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SORT_USER_ATTACHMENTS);

                    let uploader = new PJQ.views.files.FileUploaderGrid({
                        el: $input,
                        canUpload: self.options.canEdit,
                        canDelete: self.options.canEdit,
                        collection: attachments,
                        endpoint: endpoint,
                        sortBy: sortSettings ? sortSettings.sortBy : null,
                        sortDirection: sortSettings ? (sortSettings.sortBy ? 'asc' : 'desc') : null,
                        onSuccess: function (file) {
                            let guids = [file.guid];
                            if (attachments != null) {
                                _.each(attachments.models, function (attachment) {
                                    if (_.size(attachment.get('guid')) > 0) {
                                        guids.push(attachment.get('guid'));
                                    }
                                });
                            }
                            self.fieldChanged($input.data('pBind'), guids.join('|'));
                        },
                        onDelete: function (file, callback) {
                            let guids = [],
                                delAttachments = [];
                            if (attachments != null) {
                                _.each(attachments.models, function (attachment) {
                                    if (_.size(attachment.get('guid')) > 0 && file.get('guid') !== attachment.get('guid')) {
                                        guids.push(attachment.get('guid'));
                                    } else {
                                        delAttachments.push(attachment);
                                    }
                                });
                                attachments.remove(delAttachments);
                            }
                            self.fieldChanged($input.data('pBind'), guids.join('|'));
                            callback();
                        }
                    });

                    self.customFieldControls.push({
                        id: customFieldId,
                        input: uploader
                    });

                }

            if (self.options.model instanceof PJQ.models.users.User) {
                endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users'
                    },
                    {
                        endpoint: 'attachments'
                    }
                ]);
            }

            let $input = $(this);
            let customFieldId = $input.data('pBind'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });

            if (fieldValue && _.size(fieldValue.value) > 0) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'files'
                        },
                        {
                            endpoint: 'details'
                        }
                    ]),
                    data: {
                        guids: fieldValue.value ? ((typeof fieldValue.value === 'string') ? fieldValue.value.split('|') : fieldValue.value) : null
                    }
                }).post().done(_.bind(function (result) {
                    let attachments = new PJQ.collections.files.Files(result);
                    fnInput($input, attachments, endpoint);
                }, this));
            } else {
                fnInput($input, new PJQ.collections.files.Files(), endpoint);
            }
        });

        //Init the binder but override the change event
        new PJQ.Binder(this.$el, null, {
            watchElements: [
                'input.custom-field',
                'textarea.custom-field'
            ],
            onChange: _.bind(function (changeEl, attribute, value) {
                if (changeEl.hasClass('input-date-time') || changeEl.hasClass('input-date'))
                    return;

                this.fieldChanged(parseInt(attribute), value);
            }, this)
        });
    },
    renderField: function (field) {
        // right now we only re-render if its a readonly alert
        let $alert = this.$('.alert[data-field-id="' + field.id.toString() + '"]');
        if (_.size($alert) > 0) {
            let $inputOuter = $alert.closest('.input-outer'),
                fieldValue = _.findWhere(this.options.fieldValues, {id: field.id});
            $inputOuter.children(':not(label)').remove();
            this.renderSubTemplate(true, this.options.subTemplates.fieldInput, $inputOuter, {
                model: field,
                fieldValue: fieldValue != null ? fieldValue.value : null,
                canEdit: typeof field.get('isChangeableInRSVP') === 'undefined' ? this.options.canEdit : ((this.options.canEdit && field.get('isChangeableInRSVP')) || (this.options.canEdit && this.options.isAdmin))
            });
        }
    },
    setValue: function (fieldId, value) {
        this.fieldChanged(fieldId, value, false);

        let field = this.collection.get(fieldId),
            control = _.find(this.customFieldControls, function (control) {
                return control.id === fieldId;
            });

        if (control != null) {
            let fieldType = field.get('fieldType').toLowerCase();
            switch (fieldType) {
                case 'choice':
                    control.input.setValue(value);
                    break;
                case 'money':
                    control.input.val(value / 100);
                    break;
                case 'text':
                case 'int':
                case 'percent':
                case 'phone':
                case 'textarea':
                    control.input.val(value);
                    break;
                case 'date':
                case 'datetime':
                    let val;
                    if (PJQ.helpers.objectHelpers.refinedType(value) === 'date') {
                        val = value;
                    } else if (_.size(value) > 0) {
                        val = new Date(value);
                    } else {
                        val = null;
                    }
                    control.input.setValue(val);
                    break;
            }
        } else {
            this.renderField(field);
        }
    },
    fieldChanged: function (fieldId, value, triggerEvent = true) {
        let fieldValueObj = _.findWhere(this.options.fieldValues, {id: fieldId}),
            field = this.collection.get(fieldId);
        if (field.get('fieldType') === 'CHOICE' && !field.get('isMultipleChoice')) {
            value = parseInt(value);
        }
        if (fieldValueObj == null) {
            fieldValueObj = {
                id: fieldId,
                fieldNumber: field.get('fieldNumber'),
                value: value
            };
            this.options.fieldValues.push(fieldValueObj);
        } else {
            fieldValueObj.value = value;
        }

        let changedObj = _.findWhere(this.changedValues, {id: fieldId});
        if (changedObj != null) {
            changedObj.value = value;
        } else {
            this.changedValues.push(fieldValueObj);
        }
        if (typeof this.options.onChange === 'function' && triggerEvent) {
            this.options.onChange(fieldId, value);
        }
    },
    getValues: function () {
        return this.options.fieldValues;
    },
    getChanged: function () {
        return this.changedValues;
    },
    validate: function () {
        let isValid = true;
        _.each(this.collection.models, _.bind(function (field) {
            if ((!this.options.isAdmin && !field.get('isRequired')) || (this.options.isAdmin && field.get('isRequiredAdmin') != null && !field.get('isRequiredAdmin')) || (this.options.isAdmin && !field.get('isRequired') && field.get('isRequiredAdmin') == null))
                return;
            else if (!this.options.isAdmin && field.get('isAdminEdit')) {
                return;
            }

            _.each(this.customFieldControls, _.bind(function (control) {
                let customFieldId = control.id,
                    input = control.input;
                if (customFieldId === field.id) {
                    switch (field.get('fieldType').toLowerCase()) {
                        case 'text':
                        case 'int':
                        case 'percent':
                        case 'phone':
                        case 'textarea':
                            PJQ.helpers.inputHelpers.setInputError(input, true);
                            if (input.val().trim().length === 0) {
                                PJQ.helpers.inputHelpers.setInputError(input, false);
                                isValid = false;
                            }
                            break;
                        case 'money':
                            PJQ.helpers.inputHelpers.setInputError(input, true);
                            if (input.val().trim().length === 0 || parseInt(input.val().trim()) === 0) {
                                PJQ.helpers.inputHelpers.setInputError(input, false);
                                isValid = false;
                            }
                            break;
                        case 'bool':
                            input.hideError();
                            if (_.size(input.getValue()) === 0) {
                                input.showError();
                                isValid = false;
                            }
                            break;
                        case 'date':
                        case 'datetime':
                            input.hideError();
                            if (input.getValue() === undefined || input.getValue() == null) {
                                input.showError();
                                isValid = false;
                            }
                            break;
                        case 'choice':
                            input.hideError();
                            if (input.options.isMultiple ? (_.size(input.getValue()) === 0) : (!input.getValue() || input.getValue().length === 0)) {
                                input.showError();
                                isValid = false;
                            }
                            break;
                        case 'contact':
                            if (!input.validate())
                                isValid = false;
                            break;
                        case 'upload':
                            input.clearError();
                            if (!input.options.collection || input.options.collection.length == 0) {
                                input.showError("File Upload Required");
                                isValid = false;
                            }
                            break;
                    }
                }
            }, this));
        }, this));

        return isValid;
    }
});

PJQ.views.customFields.CustomFieldsSearchForm = PJQ.views.customFields.CustomFieldsForm.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form'),
        subTemplates: {
            field: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Search-Form-Field'),
            fieldInput: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Search-Form-Field-Input')
        },
        applyDefaults: false
    },
    afterRender: function () {
        _.each(this.collection.models, function (field) {
            let $field = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.field, {
                model: field,
                fieldValues: this.options.fieldValues,
                subTemplates: this.options.subTemplates
            });
            this.$('.custom-fields').append($field);
        }, this);
        this.attachFormEvents();
    },
    attachFormEvents: function () {
        let self = this;
        this.customFieldControls = [];

        this.$('.custom-field.input-text[data-p-bind],.custom-field.input-dollars-full[data-p-bind],.custom-field.input-numeric[data-p-bind],.custom-field.input-phone[data-p-bind],.custom-field.input-textarea[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                mask = input.data('mask');
            if (_.size(mask) > 0) {
                input.inputmask(mask, {
                    placeholder: ''
                });
            } else if (input.hasClass('input-dollars-full')) {
                PJQ.helpers.inputHelpers.inputMaskCurrency(input, 2);
            } else if (input.hasClass('input-numeric')) {
                PJQ.helpers.inputHelpers.inputMaskInteger(input);
            } else if (input.hasClass('input-phone')) {
                PJQ.helpers.inputHelpers.inputMaskPhone(input);
            }

            self.customFieldControls.push({
                id: customFieldId,
                input: input,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-percent[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex');

            self.customFieldControls.push({
                id: customFieldId,
                input: input,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-select[data-p-bind],.custom-field.input-bool[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                control = new PJQ.inputs.Selectpicker({
                    el: input,
                    isIntChoices: !input.hasClass('input-bool') && !input.hasClass('input-state'),
                    onChange: function (value) {
                        if (input.hasClass('input-bool'))
                            value = value.toLowerCase() === 'true';

                        self.fieldChanged(customFieldId, valueIndex, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-date[data-p-bind],.custom-field.input-date-time[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                isDateTime = input.hasClass('input-date-time'),
                control = new PJQ.inputs.Datepicker({
                    el: input,
                    isUTC: false,
                    datepickerOptions: {
                        format: !isDateTime ? PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase() : undefined
                    },
                    onChange: function (value) {
                        if (!isDateTime)
                            value = value ? PJQ.helpers.dateHelpers.getDateString(value, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                        else
                            value = value ? value.toISOString() : null;
                        self.fieldChanged(customFieldId, valueIndex, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-contact[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });

            let value = fieldValue.value,
                isMultipleChoice = input.data('multipleChoice');
            if (isMultipleChoice) {
                value = new PJQ.collections.contacts.Contacts(value).models;
            } else if (value != null) {
                value = new PJQ.models.contacts.Contact(value);
            }

            let control = new PJQ.views.contacts.ContactsSelectInput({
                el: input,
                context: PJQ.constants.contacts.contexts.CONTACTS,
                selectedContact: value,
                isSingleChoice: !isMultipleChoice,
                canEdit: self.options.canEdit,
                emptyNotice: "No Contact Selected",
                onChange: function (selectedContacts) {
                    self.fieldChanged(customFieldId, valueIndex, selectedContacts);
                }
            });

            self.customFieldControls.push([customFieldId, valueIndex, control]);
            self.customFieldControls.push({
                id: customFieldId,
                input: control,
                index: valueIndex
            });
        });

        //Init the binder but override the change event
        new PJQ.Binder(this.$el, null, {
            watchElements: [
                'input.custom-field',
                'textarea.custom-field'
            ],
            onChange: _.bind(function (changeEl, attribute, value) {
                if (changeEl.hasClass('input-percent') || changeEl.hasClass('input-date-time') || changeEl.hasClass('input-date'))
                    return;

                let valueIndex = parseInt($(changeEl).data('valueIndex'));
                this.fieldChanged(parseInt(attribute), valueIndex, value);
            }, this)
        });
    },
    fieldChanged: function (fieldId, valueIndex, value) {
        let fieldValueObj = _.findWhere(this.options.fieldValues, {id: fieldId});
        if (fieldValueObj == null) {
            let field = this.collection.get(fieldId);

            fieldValueObj = {
                id: fieldId,
                fieldNumber: field.get('fieldNumber'),
                value: valueIndex === 1 ? value : null,
                value2: valueIndex === 2 ? value : null
            };
            this.options.fieldValues.push(fieldValueObj);
        } else {
            if (valueIndex === 1)
                fieldValueObj.value = value;
            else
                fieldValueObj.value2 = value;
        }

        let changedObj = _.findWhere(this.changedValues, {id: fieldId});
        if (changedObj != null) {
            changedObj.value = valueIndex === 1 ? value : changedObj.value;
            changedObj.value2 = valueIndex === 2 ? value : changedObj.value2;
        } else {
            this.changedValues.push(fieldValueObj);
        }

        if (!fieldValueObj.value && !fieldValueObj.value2) {
            this.options.fieldValues = _.filter(this.options.fieldValues, function (fieldValue) {
                return fieldValue.id !== fieldId
            });
            this.changedValues = _.filter(this.changedValues, function (fieldValue) {
                return fieldValue.id !== fieldId
            });
        }

        if (typeof this.options.onChange === 'function') {
            this.options.onChange(fieldId, value);
        }
    },
    clearFieldValues: function () {
        this.options.fieldValues = [];
        this.changedValues = [];
        this.render();
    },
    setValues: function (fieldValues) {
        this.options.fieldValues = fieldValues;
        this.changedValues = [];
        this.render();
    },
    validateSearch: function () {
        let isValid = true;
        _.each(this.collection.models, _.bind(function (field) {
            _.each(this.customFieldControls, _.bind(function (control) {
                let customFieldId = control.id,
                    valueIndex = control.index,
                    input = control.input,
                    input2 = null;

                if (valueIndex === 1) {

                    if (customFieldId === field.id) {
                        switch (field.get('fieldType').toLowerCase()) {
                            case 'bool':
                            case 'choice':
                            case 'contact':
                            case 'percent':
                            case 'phone':
                            case 'text':
                            case 'textarea':
                                // no validation needed
                                break;
                            case 'int':
                            case 'money':
                                // get 2nd control
                                input2 = _.filter(this.customFieldControls, function (control2) {
                                    return (control2.id === field.id && control2.index === 2);
                                })[0].input;

                                // clear error state for both
                                PJQ.helpers.inputHelpers.setInputError(input, true);
                                PJQ.helpers.inputHelpers.setInputError(input2, true);

                                // if value empty, set error on it
                                if (_.size(input.val()) === 0 && _.size(input2.val()) > 0) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input, false);
                                }

                                // if value2 empty, set error on it
                                if (_.size(input2.val()) === 0 && _.size(input.val()) > 0) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input2, false);
                                }

                                // if value > value2 set error on both
                                if (_.size(input.val()) > 0 && _.size(input2.val()) > 0 && parseInt(input.val()) > parseInt(input2.val())) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input, false);
                                    PJQ.helpers.inputHelpers.setInputError(input2, false);
                                }
                                break;
                            case 'date':
                            case 'datetime':
                                // get 2nd control
                                input2 = _.filter(this.customFieldControls, function (control2) {
                                    return (control2.id === field.id && control2.index === 2);
                                })[0].input;

                                // clear error state for both
                                PJQ.helpers.inputHelpers.setInputError(input.$el, true);
                                PJQ.helpers.inputHelpers.setInputError(input2.$el, true);

                                // if value empty, set error on it
                                if (!input.getValue() && input2.getValue()) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input.$el, false);
                                }

                                // if value2 empty, set error on it
                                if (!input2.getValue() && input.getValue()) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input2.$el, false);
                                }

                                // if value > value2 set error on both
                                if (input.getValue() && input2.getValue() && input.getValue() > input2.getValue()) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input.$el, false);
                                    PJQ.helpers.inputHelpers.setInputError(input2.$el, false);
                                }
                                break;
                        }
                    }
                }
            }, this));
        }, this));

        return isValid;
    }
});

PJQ.views.customFields.CustomFieldChoicesEditor = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Custom-Field-Choices-Editor'),
        choices: [],
        onCancel: _.noop,
        onSave: _.noop
    },
    events: {
        "click .add-custom-field-choice-button": "addChoice",
        "click .delete-custom-field-choice-button": "deleteChoice",
        "change .custom-field-choice-value": "choiceChanged",
        "click .custom-field-choices-cancel": "cancel",
        "click .custom-field-choices-save": "save"
    },
    beforeRender: function () {
        _.each(this.collection.models, function (model) {
            model.oldAttributes = _.clone(model.attributes);
        });

        this.renderData = {
            models: _.filter(this.collection.models, function (model) {
                return !model.get("isDeleted")
            })
        };
    },
    afterRender: function () {
        this.$('.custom-field-choices-table').DataTable({
            "ordering": false
        });
        this.$('.custom-field-choices-table').sortable({
            items: 'tr',
            connectWith: 'tr',
            update: _.bind(this.setSortOrder, this)
        });
    },
    setSortOrder: function () {
        let self = this;
        this.$('.custom-field-choices-table').find('tbody>tr[data-cid]').each(function (index) {
            let cid = $(this).data('cid'),
                choice = self.collection.get({cid: cid});
            choice.set('sortOrder', index + 1);
        });
    },
    addChoice: function () {
        this.collection.add(new PJQ.models.customFields.CustomFieldChoice({
            value: '',
            sortOrder: this.collection.models.length + 1
        }));
        this.render();
    },
    choiceChanged: function (e) {
        let cid = $(e.currentTarget).closest('tr').data('cid'),
            choice = this.collection.get({cid: cid});
        choice.set('value', $(e.currentTarget).val());
    },
    deleteChoice: function (e) {
        let cid = $(e.currentTarget).closest('tr').data('cid'),
            choice = this.collection.get({cid: cid});
        if (choice.isNew())
            this.collection.remove(choice);
        else
            choice.set('isDeleted', true);
        this.render();
    },
    cancel: function () {
        _.each(this.collection.models, function (model) {
            model.attributes = _.clone(model.oldAttributes);
            model.oldAttributes = null;
        });
        this.options.onCancel(this.collection);
    },
    save: function () {
        this.options.onSave(this.collection);
    }
});

PJQ.views.templates = {};
PJQ.views.templates.TemplateManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Template-Management'),
		templateType: null
	},
	events: {
		'click .btn-add-template': 'addTemplate',
		'click .btn-edit-template': 'editClicked',
		'click .btn-delete-template': 'deleteClicked'
	},
	beforeFirstRender: function () {
		if(!this.options.collection) {
			this.collection = new PJQ.collections.schedule.Templates();
		}
		else{
			this.collection = this.options.collection
		}
		this.listenTo(this.collection, 'fetch', this.render);
		this.collection.fetch();
	},
	renderData: function () {
		return {
			collection: this.collection,
			templateType: this.options.templateType
		};
	},
	afterRender: function () {
		if (this.collection == null || !this.collection.isFetched) {
			return;
		}
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.templates-table'),
			isHideSearch: true,
			data: this.collection.models,
			rowId: "cid",
			order: [0, 'asc'],
			pageLength: 20,
			language: {
				zeroRecords: 'Click "Add" to create a new Template'
			},
			onRowDoubleClick: _.bind(function (row) {
				this.editTemplate(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editTemplate(row.data());
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteTemplate(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attributes.name",
					"title": "Name"
				}, {
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"resizable": false,
					"render": _.bind(function () {
						return '<div class="text-align-right show-on-row-hover" style="max-width:80px; width: 80px;"><button type="button" class="btn btn-info btn-edit-template mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-template"><i class="fal fa-trash-alt"></i></button></button></div>'
					}, this),
					"width": "100px"
				}
			]
		});
	},
	addTemplate: function () {
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			template = row.data();

		this.editTemplate(template);
	},
	editTemplate: function (template) {
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteTemplate(row);
	},
	deleteTemplate: function (row) {
		let template = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this template?",
			onDelete: _.bind(function () {
				this.collection.remove(template);
				template.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.templates.NewTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-New-Template'),
		minWidth: '500px',
		onSave: _.noop,
		isSubmittal: false
	},
	events: {
		'keyup .input-template-name': 'templateNameChanged',
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		if(!this.options.model){
			this.model = new PJQ.models.schedule.Template();
		}
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		this.$('.input-template-name').focus();
	},
	templateNameChanged: function (e) {
		let isValid = _.size(this.$('.input-template-name').val()) > 0;
		this.$('.btn-save').prop('disabled', !isValid);
		if (isValid && e.keyCode === 13) {
			this.save();
		}
	},
	save: function () {
		let templateName = this.$('.input-template-name').val();
		if (_.size(templateName) === 0) {
			return;
		}

		new PJQ.Loader(this.$('.modal-content'));
		this.model.save({
			name: templateName
		}, {
			success: _.bind(function () {
				this.removeModal();
				if (typeof this.options.onSave === 'function') {
					this.options.onSave(this.model);
				}
			}, this)
		});
	}
});

PJQ.ajax = {};

PJQ.ajax.Request = class {
	constructor(options = {}) {
		this.setOptions(options);
	}

	setOptions(options = {}) {
		this.options = _.defaults(options, {
			method: 'GET',
			dataType: 'json',
			contentType: 'application/json',
			service: PJQ.constants.services.API,
			beforeSend: _.bind(function (xhr) {
				PJQ.helpers.apiHelpers.addHeaders(xhr, this.getService(), options.headers);
			}, this),
			isPascal: false,
			isApi2: false,
			isAPIv2: false,
			isOrigin: false,
			canAuthRetry: true
		});
	}

	getService() {
		let service;
		if (this.options.isOrigin) {
			service = PJQ.constants.services.ORIGIN;
		}
		else if (this.options.isAPIv2) {
			service = PJQ.constants.services.APIv2
		}
		else {
			service = this.options.service;
		}
		return service;
	}

	exec(method) {
		if (method)
			this.options.method = method.toUpperCase();

		let service = this.getService();
		if (this.options.endpoint) {
			this.options.url = PJQ.helpers.urlHelpers.buildApiUrl(this.options.endpoint, {
				isPascal: this.options.isPascal,
				service: service
			});
		}

		if((this.options.method === "PUT" || this.options.method === "POST" || this.options.method === "PATCH") && this.options.data == null) {
			this.options.data = {};
		}

		if (this.options.data)
			this.options.data = JSON.stringify(this.options.data);

		let result = {
			_success: null,
			success: function (callback) {
				this._success = callback;
				return this;
			},
			_done: null,
			done: function (callback) {
				this._done = callback;
				return this;
			},
			_fail: null,
			fail: function (callback) {
				this._fail = callback;
				return this;
			}
		}
		$.ajax(this.options).done(function () {
			if (typeof result._done === 'function') {
				result._done(...arguments);
			} else if (typeof result._success === 'function') {
				result._success(...arguments);
			}
		}).fail(_.bind(function (xhr) {
			if (service === PJQ.constants.services.APIv2 && xhr.status === 401 && this.options.canAuthRetry) {
				// we had a 401 error on the new api
				// we should try to get a refresh token if we haven't already tried
				PJQ.app.TokenManager.refreshAccessToken(_.bind(function (token) {
					// retry after refreshing the token
					if (_.size(token) > 0) {
						$.ajax(this.options).done(function () {
							if (typeof result._done === 'function') {
								result._done(...arguments);
							}
						}).fail(_.bind(function (xhr) {
							if (typeof result._fail === 'function') {
								result._fail(...arguments);
							}
						}, this));
					}
					else if (typeof result._fail === 'function') {
						result._fail(...arguments);
					}
				}, this));
			}
			else if (typeof result._fail === 'function') {
				result._fail(...arguments);
			}
		}, this));
		return result;
	}

	get() {
		return this.exec('get');
	}

	post() {
		return this.exec('post');
	}

	patch() {
		return this.exec('patch');
	}

	put() {
		return this.exec('put');
	}

	delete() {
		return this.exec('delete')
	}
};
PJQ.Alert = class {
	constructor($el, options = {}) {
		this.options = _.defaults(options, {
			type: 'primary',
			extraClasses: [],
			text: '',
			isPrepend: false,
			isAppend: false,
			isBefore: false,
			isShowClose: false,
			cookie: null,
			cookieExpirationDays: null,
			style: null,
			animation: null,
			timeout: null
		});
		if (this.options.cookie == null || !PJQ.helpers.cookieHelpers.getCookie(this.options.cookie)){}
			this.createElement($el);
	}

	createElement($el) {
		this.options.isShowClose = this.options.isShowClose || this.options.cookie != null;
		this.$outer = $el;

		this.$el = $('<div>', {
			class: this.options.extraClasses.join(' ') + ' d-flex alert alert-' + this.options.type + (this.options.animation != null ? ' hidden' : ''),
			style: this.options.style != null ? this.options.style : ''
		}).html('<div class="flex-fill">' + this.options.text + '</div>');
		if (this.options.isShowClose) {
			this.$el.append($('<button type="button" class="close alert-item-close text-dark p-1 fs-24" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'));
			this.$el.find('.alert-item-close').on('click', _.bind(this.alertClosed, this))
		}
		if (this.options.isAppend)
			this.$outer.append(this.$el);
		else if (this.options.isPrepend)
			this.$outer.prepend(this.$el);
		else if (this.options.isBefore)
			this.$outer.before(this.$el);
		else
			this.$outer.html(this.$el);

		if(this.options.animation != null && _.size(this.options.animation.in) > 0){
			this.$el.animateCSS(this.options.animation.in, function(){
				if(this.options.timeout > 0){
					this.startDestroyTimeout();
				}
			}, this);
		}
		else{
			if(this.options.timeout > 0){
				this.startDestroyTimeout();
			}
		}
	}

	startDestroyTimeout() {
		setTimeout(_.bind(function(){
			this.destroy();
		}, this), this.options.timeout)
	}

	destroy() {
		this.remove();
	}

	remove() {
		if(this.options.animation != null && _.size(this.options.animation.out) > 0){
			this.$el.animateCSS(this.options.animation.out, function(){
				this.$el.remove();
			}, this);
		}
		else{
			this.$el.remove();
		}
	}

	alertClosed() {
		if (this.options.cookie != null) {
			PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true, this.options.cookieExpirationDays);
		}
	}
};
$.fn.extend({
	animateCSS: function (options, callback, context) {
		let animation = options;
		if (typeof options === 'object') {
			animation = options.animation;
		}

		if (typeof callback !== 'function') {
			callback = _.noop;
		}
		callback = _.bind(callback, context ? context : this);

		if (options.css !== undefined) {
			if (options.css.height != null && options.css.height.toLowerCase() === 'auto') {
				//If auto height animation was passed in, we need to get the autoheight and then animate to it
				//Then we set the height back to auto after the animation is done
				let curHeight = this.outerHeight();
				options.css.height = this.css('height', 'auto').outerHeight();
				this.height(curHeight).animate(options.css, {
					complete: _.bind(function () {
						this.css('height', 'auto');
						callback();
					}, this)
				});
			}
			else {
				this.animate(options.css, options.duration ? options.duration : 400, callback);
			}
		}
		else {
			let animationLowered = animation.toLowerCase();
			if (animationLowered === 'slideup' || animationLowered === 'slidedown' || animationLowered === 'fadein' || animationLowered === 'fadeout') {
				if (this.hasClass('hidden')) {
					this.css({
						display: 'none'
					}).removeClass('hidden');
				}
				if (this.hasClass('invisible')) {
					this.css({
						opacity: 0
					}).removeClass('invisible');
				}
				switch (animationLowered) {
					case 'slideup':
						this.slideUp(options.duration ? options.duration : 400, callback);
						break;
					case 'slidedown':
						this.slideDown(options.duration ? options.duration : 400, callback);
						break;
					case 'fadein':
						this.fadeTo(options.duration ? options.duration : 400, 1, callback);
						break;
					case 'fadeout':
						this.fadeTo(options.duration ? options.duration : 400, 0, callback);
						break;
				}
			}
			else {
				let animationEnd = (function (el) {
					let animations = {
						animation: 'animationend',
						OAnimation: 'oAnimationEnd',
						MozAnimation: 'mozAnimationEnd',
						WebkitAnimation: 'webkitAnimationEnd',
					};

					for (let t in animations) {
						if (el.style[t] !== undefined) {
							return animations[t];
						}
					}
				})(document.createElement('div'));

				let wasInvisible = false;
				if (animation.toLowerCase().indexOf('in') !== -1 && this.hasClass('hidden')) {
					this.removeClass('hidden');
				}
				else if (animation.toLowerCase().indexOf('in') !== -1 && this.hasClass('invisible')) {
					this.css('opacity', 0);
					this.removeClass('invisible');
				}
				this.addClass('animated ' + animation).on(animationEnd, function (e) {
					if (e.target === this) {
						$(this).off(animationEnd);
						if (animation.toLowerCase().indexOf('out') !== -1) {
							if (wasInvisible) {
								$(this).addClass('invisible');
							}
							else {
								$(this).addClass('hidden');
							}
						}
						$(this).removeClass('animated ' + animation);
						callback();
					}
				});
			}
		}
		return this;
	},
});
PJQ.app = {
    version: typeof bbVersion !== 'undefined' ? bbVersion : _.uniqueId(),
    module: typeof bbModule !== 'undefined' ? bbModule : 'APP',
    options: {
        cdnUrl: typeof cdnUrl !== 'undefined' ? cdnUrl : null,
        apiUrl: typeof bbApiUrl !== 'undefined' ? bbApiUrl : 'https://api.jobplanner.com',
        apiV2Url: typeof bbApiV2Url !== 'undefined' ? bbApiV2Url : 'https://api-v2.jobplanner.com',
        fileApiUrl: typeof bbFileApiUrl !== 'undefined' ? bbFileApiUrl : 'https://api.jobplanner.com',
        defaultPortalUrl: typeof bbPanteraUrl !== 'undefined' ? bbPanteraUrl : 'https://app.jobplanner.com',
        isCombinedAssets: typeof bbCombinedAssets !== 'undefined' ? bbCombinedAssets : false,
        isK8: typeof isK8 !== 'undefined' ? isK8 : null,
        isV2Zips: false,
        isV2UI: true,
        isPanteraApp: false,
        useBlobStorage: typeof useBlobStorage !== 'undefined' ? useBlobStorage : null,
        isJobPlanner: window.location.host.toLowerCase().indexOf('jobplanner') !== -1
    },
    portal: null,
    groups: [],
    readyEvents: [],
    oldRoutes: [],
    routes: [
        {
            title: 'Sign In',
            route: 'signin',
            name: 'signin',
            callback: function () {
                if (!PJQ.app.session.isLoggedIn()) {
                    new PJQ.views.auth.AppSignIn({
                        el: PJQ.app.$el
                    });
                } else {
                    PJQ.app.router.navigate("", {
                        trigger: true
                    });
                }
            }
        },
        {
            title: 'Sign Up',
            route: 'signup',
            name: 'signup',
            callback: function () {
                if (!PJQ.app.session.isLoggedIn()) {
                    new PJQ.views.auth.AppSignUp({
                        el: PJQ.app.$el
                    });
                } else {
                    let accessKey = PJQ.app.session.get('accessKey');
                    if (_.size(accessKey) > 0) {
                        PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
                            if (err != null) {
                                PJQ.app.router.navigate("", {
                                    trigger: true
                                });
                            }
                        }, this));
                    } else {
                        PJQ.app.router.navigate("", {
                            trigger: true
                        });
                    }
                }
            }
        },
        {
            title: 'Sign Up - Free Trial',
            route: 'signup/trial/:subscription',
            name: 'signuptrial',
            callback: function (subscription) {
                let affiliateId = PJQ.helpers.urlHelpers.getQueryParam('affiliateId'),
                    subscriptionId;
                if (_.size(subscription) > 0) {
                    subscriptionId = PJQ.constants.subscriptions.types[subscription.toUpperCase()]
                } else {
                    subscriptionId = null;
                }
                if (!PJQ.app.session.isLoggedIn()) {
                    new PJQ.views.auth.AppSignUp({
                        el: PJQ.app.$el,
                        subscriptionId: subscriptionId,
                        affiliateId: affiliateId
                    });
                } else {
                    // update the trial for the context user automatically if they arent on the free subscription
                    // also don't do this if they are "onAccount"
                    if (!PJQ.app.session.get('onAccount') && subscriptionId > PJQ.constants.subscriptions.types.FREE && PJQ.app.session.subscription.id <= PJQ.constants.subscriptions.types.FREE) {
                        PJQ.app.session.updateTrial(subscriptionId, _.bind(function (data) {
                            if (data == null || data.subscription == null) {
                                PJQ.notifications.notify.errorNotify({
                                    message: 'Encountered an error starting your free trial.  Please contact customer service.'
                                });
                            } else {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Free trial started'
                                });
                            }
                        }, this), _.bind(function () {
                            PJQ.notifications.notify.errorNotify({
                                message: 'Encountered an error starting your free trial.  Please contact customer service.'
                            });
                        }, this));
                    }
                    PJQ.app.router.navigate("", {
                        trigger: true
                    });
                }
            }
        },
        {
            title: 'Documents',
            route: 'documents',
            name: 'documents',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "documents"
                });
            }
        },
        {
            title: 'Email Opt Out',
            route: 'optout',
            name: 'optout',
            callback: function () {
                new PJQ.views.auth.EmailOptOut({
                    el: PJQ.app.$el
                });
            }
        },
        {
            title: 'Request Account Deletion',
            route: 'deleteaccount',
            name: 'deleteaccount',
            callback: function () {
                new PJQ.views.auth.RequestAccountDeletion({
                    el: PJQ.app.$el
                });
            }
        }
    ],
    scrollTo: function (x, y) {
        PJQ.app.$el.find('.nav-content').animate({
            scrollTop: y,
            scrollLeft: x
        }, 1);
    },
    signOutNavigate: function () {
        if (PJQ.app.options.isK8) {
            window.location.href = "/signout";
        } else {
            window.location.href = "/Signout.aspx";
        }
    },
    renderPortalPage: function (page) {
        $('.skin-header').hide();
        PJQ.app.$el.css('top', 0);
        let pageUrl;
        if (PJQ.app.options.isK8) {
            pageUrl = '/static/' + page + '.html'
        } else {
            pageUrl = '/portals/' + PJQ.app.session.get('portalId').toString() + '/' + page + '.html'
        }
        $.ajax({
            url: pageUrl + "?" + PJQ.app.version,
            method: 'GET',
            dataType: 'html',
            success: _.bind(function (html) {
                PJQ.templating.TemplateRenderer.renderTemplate(false, $(html), PJQ.app.$el, null, function (el) {
                    if (_.size(PJQ.app.portal.menuItems) > 0) {
                        PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Portal-Menu'), $('.portal-menu'), {
                            menuItems: PJQ.app.portal.menuItems
                        });
                    }

                    $(el).find('div.module').each(function () {
                        let type = $(this).data('type'),
                            typeSplit = type.split('.'),
                            view = PJQ.views;
                        _.each(typeSplit, function (obj) {
                            view = view[obj];
                        });
                        if (typeof view === 'function') {
                            new view({
                                el: $(this),
                                masterUserId: $(this).data('masterUserId')
                            });
                        }
                    });
                });
            }, this)
        });
    },
    addOldRoutes: function (addRoutes) {
        this.oldRoutes = _.union(addRoutes, this.oldRoutes);
    },
    addRoutes: function (addRoutes) {
        if (PJQ.helpers.objectHelpers.refinedType(addRoutes) !== 'array') {
            addRoutes = [addRoutes];
        }
        this.routes = _.union(addRoutes, this.routes);
    },
    configureSentry: function () {
        //temporarily disable until we have time to actually manage the results
        // if (typeof Sentry === 'object') {
        // 	Sentry.init(
        // 		{
        // 			dsn: 'https://1fd906b1b3524d3ab3b466651b2dda6b@sentry.io/1459517',
        // 			release: PJQ.app.version,
        // 			blacklistUrls: [
        // 				'/DesktopModules/PanteraModuleGlobal/dhtmlx',
        // 				/maps\.google\.com/i
        // 			]
        // 		}
        // 	);
        // }
    },
    configureTokenManager: function () {
        this.TokenManager = new PJQ.TokenManager({
            accessToken: window.accessToken,
            refreshToken: window.refreshToken,
            expiresOn: _.size(window.accessTokenExpiresOn) > 0 ? new Date(window.accessTokenExpiresOn) : null,
            enabled: true
        });
    },
    beforeReady: function () {
        this.configureSentry();

        this.configureTokenManager();

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.userLogin && typeof window.webkit.messageHandlers.userLogin.postMessage === 'function') {
            window.webkit.messageHandlers.userLogin.postMessage({
                sessionId: typeof bbSessionId !== 'undefined' ? bbSessionId : null
            });
        } else if (window.Android && typeof window.Android.userLogin === 'function') {
            window.Android.userLogin(bbSessionId);
        }

        let $hd = $('head');
        $hd.append('<link href="https://fonts.cdnfonts.com/css/nevis" rel="stylesheet">');
        $hd.append('<script src="https://export.dhtmlx.com/gantt/api.js"></script>');
        $hd.append('<script src="https://app.agaveapi.com/init.js"></script>');
        // $hd.append('<script type="text/javascript" src="https://secure.smart-enterprise-7.com/js/262471.js" ></script><noscript><img alt="" src="https://secure.smart-enterprise-7.com/262471.png" style="display:none;" /></noscript>');

        if (PJQ.app.options.isK8) {
            this.$el = $('.app-container');
        } else {
            this.$el = $('#pjq-main');
        }

        PJQ.helpers.domReadyHelper();

        if (PJQ.app.portal != null && _.size(PJQ.app.portal.pages) > 0) {
            _.each(PJQ.app.portal.pages, _.bind(function (page) {
                // add the portal page route
                PJQ.app.routes.push({
                    title: page.title,
                    route: 'p/' + page.route,
                    name: 'portal_' + page.name,
                    callback: _.bind(function () {
                        this.renderPortalPage(page.name);
                    }, this)
                });
            }, this));

            // check if the current route is not for the app
            // if so, don't bother fetching the session yet
            let isPortalRoute = false,
                hash = window.location.hash.replace('#', '');
            if (_.size(hash) === 0) {
                isPortalRoute = _.findWhere(PJQ.app.portal.pages, {isRoot: true}) != null;
            } else if (hash.indexOf('p/') !== -1) {
                isPortalRoute = _.findWhere(PJQ.app.portal.pages, {route: hash.replace('p/', '')}) != null;
            }
            this.getSession(!isPortalRoute);
        } else {
            this.getSession();
        }

        window.captureOutboundLink = function (category, url) {
            ga('send', 'event', _.size(category) > 0 ? category : 'outbound', 'click', url, {
                'transport': 'beacon',
                'hitCallback': function () {
                }
            });
        }

        this.attachEvents();
    },
    attachEvents: function () {
        let $body = $('body');
        $body.on('click', '.watch-contact-edit', function (e) {
            if (PJQ.app.session.hasPermission('contacts.canView')) {
                let $target = $(e.currentTarget),
                    $badge = $target.closest('.select-contact-container'),
                    id = $target.data('contactId'),
                    ec;
                if (PJQ.app.session.project != null) {
                    ec = new PJQ.models.projectContacts.ProjectContact({
                        id: id,
                        projectId: PJQ.app.session.project.id
                    });
                } else {
                    ec = new PJQ.models.contacts.Contact({
                        id: id
                    });
                }
                new PJQ.views.contacts.BaseEditContactModal({
                    model: ec,
                    project: PJQ.app.session.project,
                    onSave: function () {
                        $badge.find('.company-name').text(ec.get('companyName'));
                        $badge.find('.contact-name').text(ec.get('contactName'));
                    }
                });
            }
        });

        $body.on('click', '.clipboard-input', _.bind(function (e) {
            let $btn = $(e.currentTarget),
                $input = $btn.prev('input');
            if ($input.length === 0) {
                $input = $btn.next('input');
            }
            if ($input.length > 0) {
                navigator.clipboard.writeText($input.val());
                $input[0].select();
                PJQ.notifications.notify.successNotify({
                    message: 'Text copied to clipboard'
                });
            }
        }, this));

        $body.on('click', '.btn-change-sub', _.bind(function (e) {
            new PJQ.views.subscriptions.EditSubscriptionModal({
                preventTrial: $(e.currentTarget).hasClass('no-trial'),
                onSave: _.bind(function (type) {
                    if (!PJQ.app.session.get('onAccount')) {
                        PJQ.helpers.tours.initTour();
                    }
                }, this)
            });
        }, this));

        $body.on('click', '.dropdown-menu a.dropdown-toggle', function (e) {
            if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
            }

            let $subMenu = $(this).next('.dropdown-menu');
            $subMenu.toggleClass('show');

            $(this).closest('.dropdown-menu.show').add($(this).closest('.btn-group.show')).on('hidden.bs.dropdown', function (e) {
                $(this).find('.dropdown-submenu .dropdown-menu').removeClass('show');
            });

            return false;
        });
    },
    lazyLoad: function () {
        if (this.LazyLoad == null && typeof LazyLoad == 'function') {
            this.LazyLoad = new LazyLoad();
        }
        return this.LazyLoad;
    },
    getSession: function (isFetch = true, retryCount = 0) {
        let urlAccessKey = PJQ.helpers.urlHelpers.getQueryParam('accessKey'),
            urlContactGuid = PJQ.helpers.urlHelpers.getQueryParam('cg'),
            windowAccessKey = typeof bbAccessKey !== 'undefined' ? bbAccessKey : null;
        this.session = new PJQ.models.sessions.Session({
            sessionId: typeof bbSessionId !== 'undefined' ? bbSessionId : null,
            masterUserId: typeof bbMasterUserId !== 'undefined' ? bbMasterUserId : null,
            userId: typeof bbUserId !== 'undefined' ? bbUserId : null,
            portalId: typeof bbPortalId !== 'undefined' ? bbPortalId : null,
            contactGuid: _.size(urlContactGuid) > 0 ? urlContactGuid : null,
            accessKey: _.size(urlAccessKey) > 0 ? urlAccessKey : windowAccessKey
        });

        if (isFetch || this.session.get('userId') > 0) {
            this.session.fetch({
                cache: false,
                success: _.bind(_.bind(function () {
                    if ((PJQ.app.options.isK8 || this.session.get('masterUserId') === -1) && this.session.user != null) {
                        this.session.set('masterUserId', this.session.user.get('masterUserId'));
                        this.session.set('userId', this.session.user.get('userId'));
                    }


                    if (this.session.isLoggedIn()) {
                        if (_.size(PJQ.helpers.urlHelpers.getQueryParam('paysimple')) > 0) {
                            let companyId = this.session.user.get('companyId');
                            if (companyId > 0) {
                                new PJQ.views.paysimple.SignUpOpenedModal();
                                window.open('https://payments.paysimple.com/SignUp/Start?rid=459&externalId=' + companyId.toString(), '_blank');
                                return;
                            }
                        }

                        if (this.session.get('ownsPortal')) {
                            this.session.fetchERPIntegration(_.bind(function (erp) {
                                this.ready();
                            }, this));
                            return;
                        }
                    }

                    this.ready();
                }, this), this),
                error: _.bind(function (model, result) {
                    //Log the error but still continue to ready in case the app doesn't require the session (not likely but still try)
                    //If the status is 0, this means the browser is failing to communicate with the API
                    //Retry 3 times before logging the error if this is the case
                    if (result != null && result.status === 0) {
                        if (retryCount < 3) {
                            retryCount++;
                            this.getSession(true, retryCount);
                        }
                    } else {
                        this.ready();
                    }
                }, this)
            });
        } else {
            this.ready();
        }
    },
    initNavigator: function (options) {
        if (PJQ.app.session.project != null) {
            PJQ.app.session.project.fetchProjectCustomFields(_.bind(function (customFields) {
                if (PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
                    PJQ.app.session.project.customFields = new PJQ.collections.projects.ProjectCustomFields(_.filter(customFields.models, function (customField) {
                        if (customField.get('isVisibleInRSVP'))
                            return customField;
                    }));
                    PJQ.app.session.project.customFields.isFetched = true;
                }

                if (PJQ.app.navigator != null) {
                    PJQ.app.navigator.remove();
                }
                $('a.nav-item').off();
                PJQ.app.navigator = new PJQ.views.nav.AppNavigator(_.defaults(options ? options : {}, {
                    el: PJQ.app.$el
                }));
            }, this));
        } else {
            if (PJQ.app.navigator != null) {
                PJQ.app.navigator.remove();
            }
            PJQ.app.navigator = new PJQ.views.nav.AppNavigator(_.defaults(options ? options : {}, {
                el: PJQ.app.$el
            }));
        }
    },
    attachReadyEvent: function (func) {
        this.readyEvents.push(func);
    },
    ready: function () {
        if (PJQ.modules.pjqProjectWall != null && !this.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_PROJECT_WALL)) {
            if (PJQ.app.module === PJQ.constants.modules.PROJECTWALLADMIN) {
                PJQ.app.addOldRoutes(PJQ.modules.pjqProjectWall.oldRoutes);
            }
            PJQ.app.addRoutes(PJQ.modules.pjqProjectWall.routes);
        }

        this.router = new PJQ.routers.BaseRouter();
        if (!Backbone.history.start()) {
            this.router.empty();
        }
    }
};

PJQ.views.AppView = class {
    constructor($el) {
        this.$el = $el;
    }

    renderView(view, options) {
        this.removeActiveView();

        let $elInner = $('<div>');
        this.$el.append($elInner);
        this.$el = $elInner;
        $elInner.addClass('p-3 ht-100');

        this.view = new view(_.defaults(options ? options : {}, {
            el: this.$el
        }));

        return this.view;
    }

    //Profile outer view
    renderProfile(key, tab) {
        if (this.view && this.view instanceof PJQ.views.profile.CompanyProfile && this.view.model.id === key) {
            this.view.activateTab(tab);
        } else {
            if (!(this.view instanceof PJQ.views.profile.CompanyProfile)) {
                this.removeActiveView();
            }
            let self = this,
                profile = new PJQ.models.profile.CompanyProfile({
                    profileKey: key
                });
            profile.fetch({
                success: function () {
                    //We still want to make sure that the key doesn't match what is in the view already just in case this is a user looking at their own profile
                    if (this.view && this.view instanceof PJQ.views.profile.CompanyProfile && this.view.model.id === profile.id) {
                        this.view.activateTab(tab);
                    } else {
                        self.removeActiveView();
                        self.renderView(PJQ.views.profile.CompanyProfile, {
                            el: self.$el,
                            model: profile,
                            activateTab: tab
                        });
                    }
                }
            });
        }
    }

    //Screenings outer view
    renderScreeningDashboard() {
        if (this.view && this.view instanceof PJQ.views.screenings.ScreeningDashboard) {

        } else {
            this.removeActiveView();
            let self = this,
                clients = new PJQ.collections.screenings.ScreeningClients(null, {
                    contact: PJQ.app.session.contact,
                    masterUserId: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId')
                });
            clients.fetch({
                success: function () {
                    self.renderView(PJQ.views.screenings.ScreeningDashboard, {
                        collection: clients
                    });
                },
                error: function (model, result) {
                    new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
                        model: model,
                        result: result
                    });
                }
            });
        }
    }

    renderPhotoViewer(options) {
        this.photoViewer = new PJQ.views.photos.PhotoViewer(_.extend(options, {
            onClose: _.bind(function () {
                if (this.photoViewer) {
                    this.photoViewer = null;
                }
            }, this)
        }));
    }

    removeActiveView() {
        if (this.view) {
            this.view.remove();
            this.view = null;
        }
    }
};

//Models
PJQ.models.auth = {};

//Collections
PJQ.collections.auth = {};

//Views
PJQ.views.auth = {};

PJQ.views.auth.SignIn = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Sign-In')
    },
    events: {
        'keydown .input-username,.input-password': 'loginChanged',
        'click .btn-sign-in': 'signInClicked',
        'click .btn-forgot-password': 'forgotPassword'
    },
    renderData: function () {
        return {
            username: this.username,
            options: this.options
        };
    },
    loginChanged: function (e) {
        if (e.which === 13) {
            e.preventDefault();
            if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
                this.signInToken();
            } else {
                this.signIn();
            }
            return false;
        }
    },
    signInClicked: function () {
        if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
            this.signInToken();
        } else {
            this.signIn();
        }
    },
    signInToken: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }

        let $btnSignIn = this.$('.btn-sign-in');
        $btnSignIn.prop('disabled', true);


        if (this.$('.input-username').length > 0 && !this.isUsernameSSO) {
            this.username = this.$('.input-username').val();
        }

        if (this.options.isSSO && this.isUsernameSSO !== false) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'saml'
                    }
                ], [
                    {
                        parameter: 'username',
                        value: this.username
                    }
                ])
            }).get().done(_.bind(function (data) {
                if (data.enabled) {
                    window.location.href = data.signOnUrl;
                } else {
                    this.isUsernameSSO = false;
                    this.render();
                }
            }, this)).fail(_.bind(function () {
                this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
            }, this));
        } else {
            let password = this.$('.input-password').val();
            if (_.size(this.username) === 0 || _.size(password) === 0)
                return;

            PJQ.app.TokenManager.getTokensForUser(this.username, password, _.bind(function (success, error) {
                if (success) {
                    let accessKey = PJQ.app.session.get('accessKey');
                    if (_.size(accessKey) > 0) {
                        PJQ.app.session.fetch({
                            success: function () {
                                PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
                                    if (err != null) {
                                        this.renderError(err);
                                    }
                                }, this));
                            }
                        });
                    } else {
                        let loc = '/';
                        if (PJQ.app.module === PJQ.constants.modules.APP) {
                            if (_.size(PJQ.app.router.signInCache) > 0) {
                                loc += PJQ.app.router.signInCache;
                                PJQ.app.router.signInCache = null;

                                let cGuid = PJQ.app.session.get('contactGuid');
                                if(_.size(cGuid) > 0) {
                                    loc = "?cg=" + cGuid + loc;
                                }

                                window.location.href = loc;
                                window.location.reload();
                                return;
                            }
                            window.location.reload();
                        } else {
                            window.location = loc;
                        }
                    }
                } else {
                    $btnSignIn.prop('disabled', false);
                    if (error === 'EXPIRED' || error === 'EXPIRED_PASSWORD') {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'users'
                                },
                                {
                                    endpoint: 'resetpassword',
                                    value: data.passwordResetGuid
                                },
                            ])
                        }).get().done(function (request) {
                            new PJQ.views.auth.ResetPasswordModal({
                                request: request,
                                isExpired: true,
                                isContinueToSignIn: false
                            });
                        }).fail(_.bind(function () {
                            this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
                        }, this));
                    } else {
                        let errorText;
                        if (_.size(error) > 0 && (error.toUpperCase() === "LOCKED" || error.toUpperCase() === "LOCKED_USER")) {
                            if (error.lockoutMinutes > 0) {
                                errorText = "Your account has been locked for " + error.lockoutMinutes.toString() + " minutes due to too many failed attempts";
                            } else if (_.size(error) > 0) {
                                errorText = PJQ.Errors.auth[error.toUpperCase()];
                            } else {
                                errorText = PJQ.Errors.auth["CUSTOMER_SERVICE"];
                            }
                        } else if (_.size(error) > 0) {
                            errorText = PJQ.Errors.auth[error.toUpperCase()];
                        } else {
                            errorText = PJQ.Errors.auth["CUSTOMER_SERVICE"];
                        }
                        if (this.options.isSSO) {
                            this.username = null;
                            this.isUsernameSSO = null;
                            this.initError = errorText;
                            this.render();
                        } else {
                            this.renderError(errorText);
                        }
                    }
                }
            }, this));
        }
    },
    signIn: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }

        let $btnSignIn = this.$('.btn-sign-in');
        $btnSignIn.prop('disabled', true);

        if (_.size(this.username) === 0) {
            this.username = this.$('.input-username').val();
        }

        if (this.options.isSSO && this.isUsernameSSO !== false) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'saml'
                    }
                ], [
                    {
                        parameter: 'username',
                        value: this.username
                    }
                ])
            }).get().done(_.bind(function (data) {
                if (data.enabled) {
                    window.location.href = data.signOnUrl;
                } else {
                    this.isUsernameSSO = false;
                    this.render();
                }
            }, this)).fail(_.bind(function () {
                this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
            }, this));
        } else {
            let password = this.$('.input-password').val();
            if (_.size(this.username) === 0 || _.size(password) === 0)
                return;

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'signin'
                    }
                ]),
                data: {
                    username: this.username,
                    password: password
                }
            }).post().done(_.bind(function (data) {
                if (data.success) {
                    let remember = this.$('.input-remember').prop('checked');
                    PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie, remember ? 0 : null);
                    PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);

                    let fnRedirect = _.bind(function () {
                        let accessKey = PJQ.app.session.get('accessKey');
                        if (_.size(accessKey) > 0) {
                            PJQ.app.session.fetch({
                                success: function () {
                                    PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
                                        if (err != null) {
                                            this.renderError(err);
                                        }
                                    }, this));
                                }
                            });
                        } else {
                            let loc = '/';
                            if (PJQ.app.module === PJQ.constants.modules.APP) {
                                if (_.size(PJQ.app.router.signInCache) > 0) {
                                    loc = PJQ.app.router.signInCache;
                                    PJQ.app.router.signInCache = null;

                                    let cGuid = PJQ.app.session.get('contactGuid');
                                    if(_.size(cGuid) > 0) {
                                        loc = "?cg=" + cGuid + loc;
                                    }

                                    window.location.href = loc;
                                    window.location.reload();
                                    return;
                                }
                                window.location.reload();
                            } else {
                                window.location = loc;
                            }
                        }
                    }, this);

                    if (1 === 2) {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'token'
                                }
                            ], [
                                {
                                    parameter: 'username',
                                    value: this.username
                                },
                                {
                                    parameter: 'password',
                                    value: password
                                }
                            ]),
                            isAPIv2: true
                        }).get().done(_.bind(function (data) {
                            // new PJQ.ajax.Request({
                            // 	endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            // 		{
                            // 			endpoint: 'Token.aspx'
                            // 		}
                            // 	], [
                            // 		{
                            // 			parameter: 'r',
                            // 			value: data.refresh_token
                            // 		}
                            // 	]),
                            // 	isOrigin: true
                            // }).get().done(_.bind(function () {
                            // 	fnRedirect();
                            // }));
                            fnRedirect();
                        }));
                    } else {
                        fnRedirect();
                    }
                } else {
                    $btnSignIn.prop('disabled', false);
                    if (data.error === 'EXPIRED') {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'users'
                                },
                                {
                                    endpoint: 'resetpassword',
                                    value: data.passwordResetGuid
                                },
                            ])
                        }).get().done(function (request) {
                            new PJQ.views.auth.ResetPasswordModal({
                                request: request,
                                isExpired: true,
                                isContinueToSignIn: false
                            });
                        }).fail(_.bind(function () {
                            this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
                        }, this));
                    } else {
                        let errorText;
                        if (data.error === "LOCKED") {
                            if (data.lockoutMinutes === -1) {
                                errorText = "Your account has been locked due to too many failed attempts";
                            } else if (data.lockoutMinutes > 0) {
                                errorText = "Your account has been locked for " + data.lockoutMinutes.toString() + " minutes due to too many failed attempts";
                            } else {
                                errorText = PJQ.Errors.auth[data.error];
                            }
                        } else {
                            errorText = PJQ.Errors.auth[data.error];
                        }
                        if (this.options.isSSO) {
                            this.username = null;
                            this.isUsernameSSO = null;
                            this.initError = errorText;
                            this.render();
                        } else {
                            this.username = null;
                            this.renderError(errorText);
                        }
                    }
                }
            }, this)).fail(_.bind(function (xhr, err, result) {
                this.username = null;
                this.renderError(PJQ.Errors.auth.UNHANDLED);
                new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
                    error: err,
                    result: result
                });
            }, this));
        }
    },
    forgotPassword: function () {
        new PJQ.views.auth.RequestResetPasswordModal();
    },
    renderError: function (error) {
        this.$('.btn-sign-in').prop('disabled', false);
        this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
            type: 'danger',
            text: error
        });
    }
});

PJQ.views.auth.AccessKeySignIn = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Sign-In-Access-Key')
    },
    events: {
        'keydown .input-access-key': 'accessKeyChanged',
        'paste .input-access-key': 'accessKeyPasted',
        'click .btn-access-key-sign-in': 'signIn'
    },
    accessKeyPasted: function (e) {
        if (typeof navigator !== 'undefined' && e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) {
            navigator.permissions.query({
                name: 'clipboard-read'
            }).then(permissionStatus => {
                if (permissionStatus.state === 'granted') {
                    e.preventDefault();
                    let pastedText = e.originalEvent.clipboardData.getData('text/plain');

                    setTimeout(_.bind(function () {
                        this.$('.input-access-key').val(pastedText.replace(/\s|\t/g, ''));
                    }, this), 100);
                } else {
                    setTimeout(_.bind(function () {
                        this.$('.input-access-key').val(this.$('.input-access-key').val().replace(/\s|\t/g, ''));
                    }, this), 100);
                }
            });
        } else if (window.clipboardData && window.clipboardData.getData) {
            e.preventDefault();

            //IE browser OnPaste Event Handler
            let pastedText = window.clipboardData.getData('Text');
            setTimeout(_.bind(function () {
                this.$('.input-access-key').val(pastedText.replace(/\s|\t/g, ''));
            }, this), 100);
        }
    },
    accessKeyChanged: function (e) {
        if (e.which === 13) {
            if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
                this.signInToken();
            } else {
                this.signIn();
            }
            e.preventDefault();
            return false;
        }
    },
    signIn: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }

        let accessKey = this.$('.input-access-key').val();
        if (_.size(accessKey) !== 10) {
            this.renderError(PJQ.Errors.auth.KEY_LENGTH);
            return;
        }

        this.$('.btn-sign-in').prop('disabled', true);

        if (PJQ.app.module === PJQ.constants.modules.APP) {
            PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
                if (err != null) {
                    this.renderError(err);
                }
                this.$('.btn-sign-in').prop('disabled', false);
            }, this));
        } else {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'v1'
                    },
                    {
                        endpoint: 'accessKeys',
                        value: accessKey
                    }
                ])
            }).get().done(_.bind(function (response) {
                if (response.indexOf('Default.aspx') !== -1) {
                    window.location = response;
                } else if (response.indexOf('/') !== -1) {
                    window.location = response.substring(1);
                } else {
                    this.renderError(PJQ.Errors.auth.NOT_FOUND);
                }
            }, this)).fail(_.bind(function (xhr, err, result) {
                this.renderError(PJQ.Errors.auth.UNHANDLED);
                this.$('.btn-sign-in').prop('disabled', false);
                new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
                    error: err,
                    result: result
                });
            }, this));
        }
    },
    renderError: function (error) {
        this.$('.btn-sign-in').prop('disabled', false);
        this.errorAlert = new PJQ.Alert(this.$('.error-container-access-key'), {
            type: 'danger',
            text: error
        });
    }
});

PJQ.views.auth.AuthModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-auth'),
        isVerticalCenter: true
    },
    events: {},
    afterRender: function () {
        new PJQ.views.auth.Auth(_.defaults(_.omit(this.options, 'template'), {
            el: this.$('.modal-body'),
            model: this.model
        }));
    }
});

PJQ.views.auth.Auth = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'auth'),
        defaultSignUpUsername: '',
        routeToRoot: false
    },
    modes: {
        SIGN_IN: 'SIGN_IN',
        SIGN_UP: 'SIGN_UP',
        RESET_PASSWORD: 'RESET_PASSWORD',
        RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS'
    },
    events: {
        'click .auth-nav-sign-in': 'renderSignIn',
        'keyup .auth-sign-in-username': 'signInUsernameChanged',
        'keyup .auth-sign-in-password': 'signInPasswordChanged',
        'click .auth-sign-in': 'signIn',
        'click .auth-nav-sign-up': 'renderSignUp',
        'keyup .input-sign-up-username': 'signUpUsernameChanged',
        'keyup .input-sign-up-password': 'signUpPasswordChanged',
        'click .btn-sign-up': 'signUp',
        'click .auth-nav-reset-password': 'renderResetPassword',
        'keyup .auth-reset-password-username': 'resetUsernameChanged',
        'click .auth-reset-password': 'resetPassword'
    },
    beforeFirstRender: function () {
        let errorParam = PJQ.helpers.urlHelpers.getQueryParam("err", true);
        if (_.size(errorParam) > 0) {
            this.initError = PJQ.Errors.auth[errorParam.toUpperCase()];
        }

        this.model = new PJQ.models.users.User();

        let sessionContact = PJQ.app.session.contact;
        if (sessionContact != null) {
            this.model.set({
                companyName: sessionContact.get('companyName'),
                contactName: sessionContact.get('contactName'),
                email: sessionContact.get('email')
            });
        }
    },
    beforeRender: function () {
        if (this.options.mode == null) {
            this.options.mode = this.modes.SIGN_IN
        }
    },
    renderData: function () {
        return {
            model: this.model,
            options: this.options,
            modes: this.modes
        };
    },
    afterRender: function () {
        if (this.initError != null) {
            this.renderSignInError(this.initError);
            this.initError = null;
        }

        new PJQ.Binder(this.$('.auth-sign-up'), this.model, {
            watchElements: [
                'input'
            ]
        });
    },
    renderSignIn: function () {
        this.options.mode = this.modes.SIGN_IN;
        this.render();
    },
    signInUsernameChanged: function (e) {
        if (e.keyCode === 13) {
            this.$('.auth-sign-in-password').focus();
        }
    },
    signInPasswordChanged: function (e) {
        if (e.keyCode === 13) {
            if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
                this.signInToken();
            } else {
                this.signIn();
            }
        }
    },
    renderSignInError: function (error) {
        this.signInAlert = new PJQ.Alert(this.$('.sign-in-error-container'), {
            type: 'danger',
            text: error
        });
        this.$('.auth-sign-in').prop('disabled', false).text('Sign In');
    },
    signIn: function () {
        let username = this.$('.auth-sign-in-username').val(),
            password = this.$('.auth-sign-in-password').val();

        if (_.size(username) === 0 || _.size(password) === 0)
            return;

        this.$('.auth-sign-in').prop('disabled', true).text('Signing In...');

        if (this.signInAlert) {
            this.signInAlert.destroy();
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'signin'
                }
            ]),
            data: {
                username: username,
                password: password
            }
        }).post().done(_.bind(function (data) {
            if (data.success) {
                PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie);
                PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);
                if (this.options.routeToRoot) {
                    window.location.href = '/';
                } else {
                    location.reload();
                }
            } else {
                this.renderSignInError(PJQ.Errors.auth[data.error]);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.renderSignInError(PJQ.Errors.auth.UNHANDLED);
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
                error: err,
                result: result
            });
        }, this));
    },
    renderSignUp: function () {
        this.options.mode = this.modes.SIGN_UP;
        this.render();
    },
    signUpUsernameChanged: function (e) {
        this.validateSignUpInfo();
        if (e.keyCode === 13) {
            this.$('.input-sign-up-password').focus();
        }
    },
    signUpPasswordChanged: function (e) {
        this.validateSignUpInfo();
        if (e.keyCode === 13) {
            this.signUp();
        }
    },
    validateSignUpInfo: function () {
        let usernameLength = _.size(this.$('.input-sign-up-username').val()),
            passwordLength = _.size(this.$('.input-sign-up-password').val());
        this.$('.btn-sign-up').prop('disabled', usernameLength === 0 || passwordLength === 0);
    },
    signUp: function () {
        let username = this.$('.input-sign-up-username').val(),
            password = this.$('.input-sign-up-password').val();

        if (_.size(username) === 0 || _.size(password) === 0)
            return;

        this.$('.btn-sign-up').prop('disabled', true).text('Signing Up...');

        if (this.signUpAlert) {
            this.signUpAlert.destroy();
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'signup'
                }
            ]),
            data: {
                companyName: this.model.get('companyName'),
                contactName: this.model.get('contactName'),
                email: this.model.get('email'),
                username: username,
                password: password
            }
        }).post().done(_.bind(function (data) {
            if (data.success) {
                PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie);
                PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);
                PJQ.app.TokenManager.getTokensForUser(username, password, _.bind(function (success, error) {
                    if (PJQ.app.module === PJQ.constants.modules.APP) {
                        let accessKey = PJQ.app.session.get('accessKey');
                        if (_.size(accessKey) > 0) {
                            PJQ.app.session.fetch({
                                success: function () {
                                    PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
                                        if (err != null) {
                                            this.renderError(err);
                                        }
                                    }, this));
                                }
                            });
                        } else {
                            window.location.reload();
                        }
                    } else {
                        window.location = '/';
                    }
                }, this));
            } else {
                this.renderSignUpError(PJQ.Errors.auth[data.error]);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.renderSignUpError(PJQ.Errors.auth.CUSTOMER_SERVICE);
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_UP, {
                error: err,
                result: result
            });
        }, this));
    },
    renderSignUpError: function (error) {
        this.signUpAlert = new PJQ.Alert(this.$('.sign-up-error-container'), {
            type: 'danger',
            text: error
        });
        this.$('.btn-sign-up').prop('disabled', false).text('Sign Up');
    },
    renderResetPassword: function () {
        this.options.mode = this.modes.RESET_PASSWORD;
        this.render();
    },
    resetUsernameChanged: function (e) {
        this.validateResetPasswordInfo();
        if (e.keyCode === 13) {
            this.resetPassword();
        }
    },
    validateResetPasswordInfo: function () {
        let usernameLength = _.size(this.$('.auth-reset-password-username').val());
        this.$('.auth-reset-password').prop('disabled', usernameLength === 0);
    },
    resetPassword: function () {
        let username = this.$('.auth-reset-password-username').val();

        if (_.size(username) === 0)
            return;

        this.$('.auth-reset-password').prop('disabled', true).text('Trying...');

        if (this.resetPasswordAlert) {
            this.resetPasswordAlert.destroy();
        }

        PJQ.helpers.users.sendPasswordReset(username, _.bind(function (result) {
            if (result.success) {
                this.renderResetPasswordSuccess();
            } else {
                this.renderResetPasswordError(result.error);
            }
        }, this));
    },
    renderResetPasswordSuccess: function () {
        this.options.mode = this.modes.RESET_PASSWORD_SUCCESS;
        this.render();
    },
    renderResetPasswordError: function (error) {
        this.resetPasswordAlert = new PJQ.Alert(this.$('.reset-password-error-container'), {
            type: 'danger',
            text: error
        });
        this.$('.auth-reset-password').prop('disabled', false).text('Reset Password');
    }
});

PJQ.views.auth.ResetPasswordModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Reset-Password'),
        isVerticalCenter: true,
        isExpired: false,
        isContinueToSignIn: true
    },
    events: {
        'click .auth-nav-sign-in': 'navSignIn'
    },
    beforeRender: function () {
        this.options.isShowCloseButton = this.options.isExpired;
        this.renderData = {
            options: this.options,
            error: this.options.error ? (PJQ.Errors.auth[this.options.error] ? PJQ.Errors.auth[this.options.error] : PJQ.Errors.auth.CUSTOMER_SERVICE) : null
        };
    },
    afterRender: function () {
        if (this.options.request != null) {
            new PJQ.views.auth.ResetPassword({
                el: this.$('.reset-password-view'),
                request: this.options.request,
                onReset: _.bind(function () {
                    this.options.request = null;
                    this.options.success = true;
                    this.render();
                }, this)
            });
        }
    },
    navSignIn: function () {
        this.removeModal();
        PJQ.app.router.signInNavigate();

    }
});

PJQ.views.auth.ResetPassword = PJQ.views.BaseView.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Reset-Password'),
        subTemplates: {
            passwordRequirements: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Password-Requirements')
        },
        isRequirementsGrid: true
    },
    events: {
        'keyup .input-reset-password': 'passwordChanged',
        'click .btn-reset-password': 'resetPassword'
    },
    beforeRender: function () {
        this.renderData = {
            options: this.options,
            passwordRequirements: this.options.request ? this.options.request.passwordRequirements : null,
            error: this.options.error ? (PJQ.Errors.auth[this.options.error] ? PJQ.Errors.auth[this.options.error] : PJQ.Errors.auth.CUSTOMER_SERVICE) : null
        };
    },
    afterRender: function () {
        this.renderPasswordRequirements();

        this.$('.input-reset-password')[0].focus();
        if (this.options.request != null) {
            this.checkPasswordRequirements();
        }
    },
    renderPasswordRequirements: function () {
        this.renderSubTemplate(false, this.options.subTemplates.passwordRequirements, this.$('.password-requirements'), {
            isGrid: this.options.isRequirementsGrid,
            passwordRequirements: this.options.request ? this.options.request.passwordRequirements : null,
        });
    },
    checkPasswordRequirements: function () {
        let req = this.options.request.passwordRequirements,
            newPassword = this.$('.input-reset-password').val(),
            validCheck = true;
        if (!req.allowRepeatChars) {
            let $noRepeat = this.$('.password-req-no-repeat'),
                arr = newPassword.split('');
            if (_.size(arr) === 0 || arr.some(function (v, i, a) {
                return a.lastIndexOf(v) !== i;
            })) {
                validCheck = false;
                $noRepeat.addClass('op-6');
            } else {
                $noRepeat.removeClass('op-6');
            }
        }

        if (req.minLength > 0) {
            let $length = this.$('.password-req-length');
            if (_.size(newPassword) < req.minLength) {
                validCheck = false;
                $length.addClass('op-6');
            } else {
                $length.removeClass('op-6');
            }
        }

        if (req.lowercaseCount > 0) {
            let $lowercase = this.$('.password-req-lowercase');
            if (_.size(PJQ.helpers.stringHelpers.getLowercaseChars(newPassword)) < req.lowercaseCount) {
                validCheck = false;
                $lowercase.addClass('op-6');
            } else {
                $lowercase.removeClass('op-6');
            }
        }

        if (req.uppercaseCount > 0) {
            let $uppercase = this.$('.password-req-uppercase');
            if (_.size(PJQ.helpers.stringHelpers.getUppercaseChars(newPassword)) < req.uppercaseCount) {
                validCheck = false;
                $uppercase.addClass('op-6');
            } else {
                $uppercase.removeClass('op-6');
            }
        }

        if (req.numericCount > 0) {
            let $numeric = this.$('.password-req-numeric');
            if (_.size(PJQ.helpers.stringHelpers.getNumericChars(newPassword)) < req.numericCount) {
                validCheck = false;
                $numeric.addClass('op-6');
            } else {
                $numeric.removeClass('op-6');
            }
        }

        if (req.specialCharCount > 0) {
            let $special = this.$('.password-req-special-char');
            if (_.size(PJQ.helpers.stringHelpers.getSpecialChars(newPassword)) < req.specialCharCount) {
                validCheck = false;
                $special.addClass('op-6');
            } else {
                $special.removeClass('op-6');
            }
        }
        this.isValid = validCheck;
    },
    passwordChanged: function (e) {
        this.checkPasswordRequirements();
        this.$('.btn-reset-password').prop('disabled', !this.isValid);
        if (e.keyCode === 13 && this.isValid) {
            this.resetPassword();
        }
    },
    resetPassword: function () {
        if (this.errorAlert != null) {
            this.errorAlert.destroy();
        }

        if (!this.isValid)
            return;

        this.$('.btn-reset-password').prop('disabled', true).text('Trying...');

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'users'
                },
                {
                    endpoint: 'resetpassword',
                    value: this.options.request.guid
                },
            ]),
            data: {
                password: this.$('.input-reset-password').val()
            }
        }).post().success(_.bind(function (data) {
            if (data.success) {
                this.options.success = true;
                this.options.request = null;
                this.onReset();
            } else {
                this.$('.btn-reset-password').prop('disabled', false).text('Change Password');
                if (data.error === 'ALREADY_USED') {
                    this.renderError("You cannot use your last " + this.options.request.passwordRequirements.historyPreventCount.toString() + " passwords.");
                } else {
                    this.renderError(PJQ.Errors.auth[data.error]);
                }
            }
        }, this)).fail(_.bind(function () {
            this.options.success = false;
            this.render();
        }, this));
    },
    onReset: function () {
        if (typeof this.options.onReset === 'function') {
            this.options.onReset();
        } else {
            this.render();
        }
    },
    renderError: function (error) {
        this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
            type: 'danger',
            text: error
        });
    }
});

PJQ.views.auth.RequestResetPasswordModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Request-Reset-Password'),
        isVerticalCenter: true,
        isShowCloseButton: true
    },
    events: {
        'keyup .input-reset-password-username': 'usernameChanged',
        'click .btn-reset-password': 'resetPassword'
    },
    beforeRender: function () {
        this.renderData = {
            success: this.success
        };
    },
    afterRender: function () {
        let $username = this.$('.input-reset-password-username');
        if (_.size($username) > 0) {
            $username[0].focus();
        }
    },
    usernameChanged: function (e) {
        this.$('.btn-reset-password').prop('disabled', _.size(this.$('.input-reset-password-username').val()) === 0);
        if (e.keyCode === 13) {
            this.resetPassword();
        }
    },
    resetPassword: function () {
        let username = this.$('.input-reset-password-username').val();

        if (_.size(username) === 0)
            return;

        this.$('.btn-reset-password').prop('disabled', true).text('Trying...');

        if (this.resetPasswordAlert) {
            this.resetPasswordAlert.destroy();
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'users'
                },
                {
                    endpoint: 'requestpasswordreset'
                }
            ], [
                {
                    parameter: 'masterUserId',
                    value: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId')
                },
                {
                    parameter: 'username',
                    value: username
                }
            ])
        }).post().done(_.bind(function (data) {
            if (data.success) {
                this.success = true;
                this.render();
            } else {
                this.renderError(PJQ.Errors.auth[data.error]);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.renderError(PJQ.Errors.auth.CUSTOMER_SERVICE);
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_RESET_PASSWORD, {
                error: err,
                result: result
            });
        }, this));
    },
    renderError: function (error) {
        this.resetPasswordAlert = new PJQ.Alert(this.$('.reset-password-error-container'), {
            type: 'danger',
            text: error
        });
        this.$('.btn-reset-password').prop('disabled', false).text('Reset Password');
    }
});

PJQ.views.auth.AppSignIn = PJQ.views.auth.SignIn.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In')
    },
    events: {
        'keydown .input-username,.input-password': 'loginChanged',
        'click .btn-sign-in': 'signInClicked',
        'click .btn-sign-up-nav': 'signUpNavigate',
        'click .btn-forgot-password': 'forgotPassword'
    },
    beforeFirstRender: function () {
        let errorParam = PJQ.helpers.urlHelpers.getQueryParam("err", true);
        if (_.size(errorParam) > 0) {
            this.initError = PJQ.Errors.auth[errorParam.toUpperCase()];
        }

        PJQ.helpers.setViewport("width=device-width, initial-scale=1, minimum-scale=1");
        this.options.isSSO = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_SSO_ENABLED);
    },
    afterRender: function () {
        if (this.initError != null) {
            this.renderError(this.initError);
            this.initError = null;
        }

        if (this.options.isSSO && _.size(this.username) > 0) {
            this.$('.input-password')[0].focus();
        } else {
            this.$('.input-username')[0].focus();
        }

        this.accessKeySignIn = new PJQ.views.auth.AccessKeySignIn({
            el: this.$('.access-key-sign-in'),
            template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Access-Key')
        });

        if (PJQ.app.session.isPanteraPortal()) {
            this.initFeatureAds();
        }
    },
    signUpNavigate: function () {
        PJQ.app.router.navigate('signup', {
            trigger: true
        });
    },
    initFeatureAds: function () {
        let features = PJQ.helpers.auth.features();
        if (_.size(features) > 0) {
            let feature = features[Math.floor(Math.random() * _.size(features))];
            this.renderSubTemplate(false, feature, this.$('.app-sign-in-features'), {}, _.bind(function () {
                if (feature.file === 'app-sign-in-carousel') {
                    this.$('.carousel').carousel({
                        interval: 4300,
                        ride: 'carousel'
                    })
                }
            }, this));
        }
    }
});

PJQ.views.auth.AppSignUp = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-Up'),
        subscriptionId: null,
        affiliateId: null
    },
    events: {
        'click .btn-sign-up': 'signUp',
        'click .btn-sign-in-nav': 'signInNavigate',
        'keydown .input-password-signup': 'checkReady',
        'keydown .input-username-signup': 'checkReady'
    },
    beforeFirstRender: function () {
        PJQ.helpers.setViewport("width=device-width, initial-scale=1, minimum-scale=1");

        this.model = new PJQ.models.users.User();
        let sessionContact = PJQ.app.session.contact;
        if (sessionContact != null) {
            this.model.set({
                companyName: sessionContact.get('companyName'),
                contactName: sessionContact.get('contactName'),
                zip: sessionContact.get('zip'),
                email: sessionContact.get('email'),
                phone: sessionContact.get('phone')
            });
        }
        if (_.size(PJQ.helpers.urlHelpers.getQueryParam('bb')) > 0) {
            this.model.set('isBlueBook', true);
        }

        let portalOwner = PJQ.app.session.preferences.getPref('portalOwner');
        PJQ.app.session.fetchUserGroups(portalOwner ? portalOwner : 39, _.bind(function (groups) {
            this.groups = groups;
            this.render();
        }, this));
        return false;
    },
    renderData: function () {
        return {
            model: this.model,
            groups: this.groups,
            subscriptionId: this.options.subscriptionId > 1 ? this.options.subscriptionId : null
        };
    },
    afterRender: function () {
        if (this.options.affiliateId == null) {
            this.options.affiliateId = PJQ.helpers.urlHelpers.getQueryParam('affiliateId');
        }
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function ($field, attr, val) {
                // this.validateField($field, attr, val);
            }, this)
        });

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));

        if (PJQ.app.session.get('portalId') === 4) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-company-type'),
                noneSelectedText: 'Select Type',
                mobile: PJQ.helpers.mobile.getDevice() != null,
                onChange: _.bind(function (value) {
                    this.model.set('companyType', value);
                    if (value === 'SUB') {
                        this.$('.groups-outer').removeClass('hidden');
                    } else {
                        this.$('.groups-outer').addClass('hidden');
                    }
                }, this)
            });
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-groups'),
            noneSelectedText: 'Select Trades',
            liveSearch: true,
            isIntChoices: true,
            isMultiple: true,
            header: '<div class="text-align-right"><button type="button" class="btn close position-relative text-dark op-10 fs-17 pt-2 mt-1 mb-1 mr-1">Done</button></div>',
            mobile: PJQ.helpers.mobile.getDevice() != null,
            onChange: _.bind(function (value) {
                this.model.set('groups', value);
            }, this),
            defaultValue: _.map(this.model.get('groups'), function (group) {
                return group.groupId;
            })
        });

        this.statePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-country'),
            noneSelectedText: 'Select Value',
            defaultValue: 'us',
            onChange: _.bind(function (value) {
                this.model.set('country', value.toUpperCase());
                this.model.set('zip', '');
                this.countryChanged();
            }, this)
        });
        this.countryChanged();

        if (PJQ.app.session.isPanteraPortal()) {
            this.initFeatureAds();
        }
    },
    initFeatureAds: function () {
        let features = PJQ.helpers.auth.features();
        if (_.size(features) > 0) {
            let feature = features[Math.floor(Math.random() * _.size(features))];
            this.renderSubTemplate(false, feature, this.$('.app-sign-in-features'), {});
        }
    },
    validateField: function () {
        let isValid = true,
            isCompanyNameValid = _.size(this.model.get('companyName')) !== 0,
            isContactNameValid = _.size(this.model.get('contactName')) !== 0,
            isUsernameValid = _.size(this.model.get('username')) !== 0,
            isPasswordValid = _.size(this.model.get('password')) !== 0,
            isZipValid = _.size(this.model.get('zip')) >= 5,
            isPhoneValid = _.size(this.model.get('phone')) >= 10,
            isEmailValid = _.size(this.model.get('email')) !== 0,
            isCompanyTypeValid = _.size(this.model.get('companyType')) !== 0,
            isGroupsValid = _.size(this.model.get('groups')) !== 0

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-company-name'), isCompanyNameValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-contact-name'), isContactNameValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-phone'), isPhoneValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-email'), isEmailValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-zip'), isZipValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-username-signup'), isUsernameValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-password-signup'), isPasswordValid);

        if (!isCompanyNameValid || !isContactNameValid || !isUsernameValid || !isPasswordValid || !isPhoneValid || !isEmailValid || !isZipValid) {
            this.renderError("Required fields missing data or incorrectly formatted.");
            isValid = false;
        }

        if (PJQ.app.session.get('portalId') === 4) {
            if (!isCompanyTypeValid) {
                this.renderError("Required fields missing data");
                isValid = false;
            }
            PJQ.helpers.inputHelpers.setInputError(this.$('.select-company-type'), isCompanyTypeValid);

            if (this.model.get('companyType') === 'SUB') {
                if (!isGroupsValid) {
                    this.renderError('Required fields missing data');
                    isValid = false;
                }
                PJQ.helpers.inputHelpers.setInputError(this.$('.select-groups'), isGroupsValid);
            }
        }

        return isValid;
    },
    countryChanged: function () {
        if (!this.model.get('country')) {
            this.model.set('country', 'US');
        }
        let country = _.size(this.statePicker.getValue()) > 0 ? this.statePicker.getValue().toLowerCase() : 'us',
            options = '<option value="">Select Value</option>';

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.input-zip'), country);
    },
    signInNavigate: function () {
        PJQ.app.router.signInNavigate();
    },
    checkReady: function (e) {
        if (e.keyCode === 13) {
            this.signUp()
        }
    },
    renderError: function (error) {
        this.$('.btn-sign-up').prop('disabled', false);
        this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
            type: 'danger',
            text: error
        });
    },
    signUp: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }

        if (!this.validateField()) {
            return;
        }

        this.$('.btn-sign-up').prop('disabled', true);

        let params = [];
        if (this.options.subscriptionId != null) {
            params.push({
                parameter: 'subscriptionId',
                value: this.options.subscriptionId
            });
        }
        if (this.options.affiliateId != null) {
            params.push({
                parameter: 'affiliateId',
                value: this.options.affiliateId
            });
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'signup'
                }
            ], params),
            data: this.model
        }).post().done(_.bind(function (data) {
            if (data.success) {
                PJQ.app.session.set('sessionId', data.sessionId);
                PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie);
                PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);
                PJQ.app.TokenManager.getTokensForUser(this.model.get('username'), this.model.get('password'), _.bind(function (success, error) {
                    if (PJQ.app.module === PJQ.constants.modules.APP) {
                        let accessKey = PJQ.app.session.get('accessKey');
                        if (_.size(accessKey) > 0) {
                            PJQ.app.session.fetch({
                                success: function () {
                                    PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
                                        if (err != null) {
                                            this.renderError(err);
                                        }
                                    }, this));
                                }
                            });
                        } else if (_.size(this.options.affiliateId) > 0) {
                            window.location = '/#settings/billing';
                        } else {
                            if (_.size(PJQ.app.router.signInCache) > 0) {
                                let loc = PJQ.app.router.signInCache;
                                PJQ.app.router.signInCache = null;

                                let cGuid = PJQ.app.session.get('contactGuid');
                                if(_.size(cGuid) > 0) {
                                    loc = "?cg=" + cGuid + loc;
                                }

                                window.location.href = loc;
                                window.location.reload();
                                return;
                            }
                            window.location.reload();
                        }
                    } else {
                        window.location = '/';
                    }
                }, this));
            } else {
                this.renderError(PJQ.Errors.auth[data.error]);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.renderError(PJQ.Errors.auth.UNHANDLED);
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_UP, {
                error: err,
                result: result
            });
        }, this));
    }
});

PJQ.views.auth.AppResetPassword = PJQ.views.auth.ResetPassword.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Reset-Password'),
        isRequirementsGrid: false
    }
});

PJQ.helpers.auth = {
    features: function () {
        return [
            // Commented out older screens in case we want to use them again.
            // new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Proqual'),
            // new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Plan-Express'),
            // new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Doc-Clerk'),
            // new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Cloud-Storage'),
            // new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Scheduling'),
            // new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Mobile'),
            // new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Free-Trial'),
            new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'app-sign-in-carousel')

        ];
    },
    validateSessionContact: function () {
        if (PJQ.app.session.contact != null && PJQ.app.session.contact.get('isDeleted')) {
            //Hide main app element, which is the outer element on all PJQ modules
            PJQ.app.$el.addClass('hidden');
            //Show dialog to tell user this link is no longer active
            new PJQ.views.modals.ErrorModal({
                header: 'Inactive Link',
                body: "This link is no longer active.",
                errorCode: PJQ.constants.errorCodes.DELETED_CONTACT
            });
            return true;
        }
    }
};

PJQ.views.auth.EmailOptOut = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'email-opt-out')
    },
    events: {
        'click .btn-opt-out': 'submit'
    },
    beforeFirstRender: function () {
        this.isOptOut = false;
    },
    renderData: function () {
        return {
            isOptOut: this.isOptOut,
            email: this.email
        };
    },
    submit: function () {
        let email = this.$('.input-email').val(),
            data = {
                emailAddress: email
            };

        if (PJQ.helpers.validators.validateEmail(email).success) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'emails'
                    },
                    {
                        endpoint: 'optout'
                    }
                ]),
                isAPIv2: true,
                data: data
            }).post().done(_.bind(function (data) {
                this.email = email;
                this.isOptOut = true;
                this.render();
            }, this)).fail(_.bind(function (data) {
                PJQ.notifications.notify.errorNotify({
                    message: 'Something went wrong.'
                });
            }, this))
        } else {
            new PJQ.Alert(this.$('.error-container'), {
                type: 'danger',
                text: "The email that was entered is not valid."
            });
        }
    }
});

PJQ.views.auth.RequestAccountDeletion = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'request-account-deletion')
    },
    events: {
        'click .btn-send-request': 'sendRequest'
    },
    beforeFirstRender: function () {
        this.requestSent = false;
    },
    renderData: function () {
        return {
            requestSent: this.requestSent,
            username: this.username
        };
    },
    sendRequest: function () {
        let username = this.$('.input-username').val(),
            data = {
                username: username
            };

        if (_.size(username.trim()) > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'account'
                    },
                    {
                        endpoint: 'requestdeletion'
                    }
                ]),
                isAPIv2: true,
                data: data
            }).post().done(_.bind(function (data) {
                this.username = username;
                this.requestSent = true;
                this.render();
            }, this)).fail(_.bind(function (data) {
                PJQ.notifications.notify.errorNotify({
                    message: 'Something went wrong.'
                });
            }, this))
        } else {
            new PJQ.Alert(this.$('.error-container'), {
                type: 'danger',
                text: "No username was entered."
            });
        }
    }
});
PJQ.models.bidPackages = {};
PJQ.models.bidPackages.Template = PJQ.models.BaseModel.extend({
	idAttribute: 'templateId',
	notifyName: 'Template',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidpackages'
			},
			{
				endpoint: 'templates',
				value: this.id
			}
		], this.get('projectId') > 0 ? [
			{
				parameter: 'projectId',
				value: this.get('projectId')
			}
		] : null);
	},
	parse: function (model) {
		if (!model)
			return model;

		if (model.bidPackages != null) {
			this.bidPackages = new PJQ.collections.bidPackages.BidPackages(model.bidPackages);
		}
		else {
			this.bidPackages = null;
		}

		return model;
	}
});

PJQ.models.bidPackages.BidPackage = PJQ.models.BaseModel.extend({
	idAttribute: 'bidPackageId',
	notifyName: 'Bid Package',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidpackages',
				value: this.get('bidPackageId')
			}
		]);
	},
	parse: function (model) {
		if (!model)
			return model;

		this.groups = new PJQ.collections.groups.Groups(model.groups);
		this.attachments = new PJQ.collections.bidPackages.Attachments(model.attachments);

		return model;
	},
	isNew: function () {
		return this.id <= 0;
	},
	addAttachments: function (entryIds, drawingIds, tags, callback) {
		this.attachments.reset();
		if (entryIds != null) {
			_.each(_.uniq(entryIds), function (entryId) {
				this.attachments.add({
					entryId: entryId
				});
			}, this);
		}

		if (drawingIds != null) {
			_.each(_.uniq(drawingIds), function (drawingId) {
				this.attachments.add({
					drawingId: drawingId
				});
			}, this);
		}

		if (tags != null) {
			_.each(_.uniq(tags), function (tag) {
				this.attachments.add({
					drawingTagName: tag
				});
			}, this);
		}

		this.patch({
			attachments: this.attachments.toJSON()
		}, {
			success: _.bind(function () {
				if (typeof callback === 'function') {
					callback(this.attachments)
				}
			}, this),
			error: _.bind(function () {
				if (typeof callback === 'function') {
					callback(null)
				}
			}, this)
		});
	},
	beforeSave: function () {
		this.set('groups', this.groups.toJSON());
		this.set('attachments', this.attachments.toJSON());
	}
});

PJQ.models.bidPackages.Attachment = PJQ.models.BaseModel.extend({});

PJQ.collections.bidPackages = {};
PJQ.collections.bidPackages.BidPackages = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidPackages.BidPackage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.projectId > 0 ? this.options.projectId : null
			},
			{
				endpoint: 'bidpackages'
			}
		]);
	}
});

PJQ.collections.bidPackages.Attachments = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidPackages.Attachment
})

PJQ.collections.bidPackages.Templates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidPackages.Template,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidpackages'
			},
			{
				endpoint: 'templates'
			}
		]);
	}
});

PJQ.views.bidPackages = {};
PJQ.views.bidPackages.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
	beforeFirstRender: function () {
		this.collection = new PJQ.collections.bidPackages.Templates();
		this.listenTo(this.collection, 'fetch', this.render);
		this.collection.fetch();
	},
	addTemplate: function () {
		new PJQ.views.templates.NewTemplateModal({
			model: new PJQ.models.bidPackages.Template(),
			onSave: _.bind(function (template) {
				this.collection.add(template);
				this.dataTable.refresh();
				this.editTemplate(template);
			}, this)
		});
	},
	editTemplate: function (template) {
		new PJQ.views.bidPackages.EditTemplateModal({
			model: template,
			onClose: _.bind(function () {
				this.dataTable.refresh();
			}, this),
			onDelete: _.bind(function (template) {
				if (template.id > 0) {
					let row = this.dataTable.getRow(template.cid);
					this.collection.remove(template);
					template.destroy();
					this.dataTable.removeRow(row);
				}
			}, this)
		});
	}
});

PJQ.views.bidPackages.EditTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Edit-Bid-Package-Template'),
		maxWidth: '60%',
		fitHeight: true,
		onClose: null
	},
	events: {
		'change .cb-is-default': 'defaultChanged',
		'click .btn-close': 'close',
		'click .btn-delete': 'deleteTemplate'
	},
	defaultChanged: function () {
		this.model.patch({
			isDefault: this.$('.cb-is-default').prop('checked')
		});
	},
	beforeModalCreated: function () {
		if (!this.model) {
			this.model = new PJQ.models.bidPackages.Template({
				templateId: this.options.templateId
			})
		}

		this.listenTo(this.model, 'fetch', this.render);
		this.model.fetch();

	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model.isFetched) {
			new PJQ.inputs.TextEditorInput({
				el: this.$('.edit-template-name'),
				label: 'Name',
				value: this.model.get('name'),
				onSave: _.bind(function (value) {
					this.model.patch({
						name: value
					});
				}, this)
			});
		}

		new PJQ.views.bidPackages.BidPackagesView({
			el: this.$('.manage-template'),
			model: this.model,
			collection: this.model.bidPackages,
			templateId: this.model.get('templateId')
		});
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose(this.model);
		}
	},
	deleteTemplate: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this template?",
			onDelete: _.bind(function () {
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});

PJQ.views.bidPackages.ManageBidPackagesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Manage-Bid-Packages'),
		maxWidth: '60%',
		fitHeight: true,
		onClose: null
	},
	events: {
		'click .btn-close': 'close'
	},
	renderData: function () {
		return {
			projectName: this.options.project ? this.options.project.get('projectName') : ''
		};
	},
	afterRender: function () {
		new PJQ.views.bidPackages.BidPackagesView({
			el: this.$('.manage-bid-packages'),
			projectId: this.options.project ? this.options.project.get('projectId') : null,
			project: this.options.project ? this.options.project : null
		});
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose({
				changed: true
			});
		}
	}
});

PJQ.views.bidPackages.BidPackagesView = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Bid-Packages')
	},
	events: {
		'click .add-bid-package': 'addBidPackageClicked',
		'click .btn-import-template': 'importTemplate',
		'click .btn-save-a-template': 'saveAsTemplate',
		'click .btn-delete-bid-package': 'deleteBidPackageClicked',
		'click .btn-edit-bid-package': 'editBidPackageClicked'
	},
	beforeFirstRender: function () {
		if (this.collection) {
			this.listenTo(this.collection, 'fetch', this.render);
			this.render();
		}
		else if (this.options.projectId) {
			this.collection = new PJQ.collections.bidPackages.BidPackages(null, {
				projectId: this.options.projectId
			})
			this.collection.fetch({
				success: _.bind(function () {
					this.render();
					this.listenTo(this.collection, 'fetch', this.render);
				}, this)
			});
		}
		else {
			this.collection = new PJQ.collections.bidPackages.BidPackages();
		}
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".bid-package-table"),
			data: _.sortBy(this.collection.models, function (model) {
				return model.get('sortOrder');
			}),
			rowId: "cid",
			order: [0, 'asc'],
			sortableOptions: {
				data: this.collection,
				containment: ".bid-package-table",
			},
			bSort: false,
			scrollRows: true,
			paging: false,
			onRowDoubleClick: _.bind(function (row) {
				this.editBidPackage(row.data());
			}, this),
			language: {
				zeroRecords: 'Click "Add New Bid Package" to create a new Bid Package'
			},
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editBidPackage(row.data());
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteBidPackage(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attributes.sortOrder",
					"title": "",
					"searchable": false,
					"orderable": false,
					"visible": false,
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (data != null) {
							content = '<div><i class="fas fa-sort"></i></div>'
						}

						return content
					}, this)
				},
				{
					"title": "Name",
					"data": "attributes.name"
				},
				{
					"title": "Groups",
					"data": "attributes.groups",
					"render": function (data, type, row) {
						if (row.groups && _.size(row.groups.models) > 0) {
							let groupNames = [];
							_.each(row.groups.models, function (group) {
								groupNames.push(group.get('groupName'));
							});
							return groupNames.join(", ");
						}
						return '';
					}
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"render": _.bind(function () {
						return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-bid-package wd-30p mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-bid-package wd-30p"><i class="fal fa-trash-alt"></i></button></button></div>'
					}, this),
					"width": "80px"
				}
			]
		});
	},
	addBidPackageClicked: function () {
		let newBidPackage = new PJQ.models.bidPackages.BidPackage({
			bidPackageId: null,
			name: "",
			groups: null,
			projectId: this.options.projectId,
			templateId: this.options.templateId
		});
		this.editBidPackage(newBidPackage);
	},
	importTemplate: function () {
		new PJQ.views.bidPackages.ImportTemplateModal({
			project: this.options.project,
			onImport: _.bind(function (submittals) {
				this.collection = submittals;
				this.render();
			}, this)
		});
	},
	saveAsTemplate: function () {
		new PJQ.views.bidPackages.BidPackageTemplateCreatorModal({
			collection: this.collection,
			project: this.options.project
		});
	},
	editBidPackage: function (bidPackage) {
		new PJQ.views.bidPackages.EditBidPackageModal({
			model: bidPackage,
			onSave: _.bind(function (pkg, isNew) {
				if (isNew) {
					this.collection.add(pkg);
					this.dataTable.addRow(pkg);
				}
				this.dataTable.refresh();
			}, this),
			onClose: _.bind(function (pkg) {
				if (pkg.hasChanged()) {
					pkg.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (pkg) {
				let row = this.dataTable.getRow(pkg.cid);
				this.deleteBidPackage(row);
			}, this)
		});
	},
	editBidPackageClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			pkg = row.data();

		this.editBidPackage(pkg);
	},
	deleteBidPackageClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteBidPackage(row);
	},
	deleteBidPackage: function (row) {
		let pkg = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this Bid Package?",
			onDelete: _.bind(function () {
				this.collection.remove(pkg);
				pkg.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.bidPackages.EditBidPackageModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Edit-Bid-Package'),
		maxWidth: '50%',
		onClose: null
	},
	events: {
		'click .btn-close': 'close',
		'click .btn-delete': 'deleteBidPackage',
		'click .btn-save': 'save'
	},
	// beforeModalCreated: function () {
	//     // this.listenTo(this.model, 'fetch', this.render);
	//     // this.model.fetch();
	// },
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		new PJQ.Binder(this.$el, this.model, {
			watchElements: [
				'input',
				'textarea'
			]
		});
		let groupUserId = PJQ.app.session.get('masterUserId'),
			groupLevels = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
		if (this.model.groups == null) {
			this.model.groups = new PJQ.collections.groups.Groups([], {
				groupLevels: groupLevels
			});
		}
		new PJQ.views.groups.GroupsSelectInput({
			el: this.$('.bid-package-groups'),
			isShowAddButton: false,
			groupLevels: groupLevels,
			groupUserId: groupUserId,
			isReadOnly: false,
			addButton: this.$('.btn-edit-groups'),
			selectedGroups: this.model.groups.models,
			onAfterSave: _.bind(function (selectedGroups) {
				this.model.groups.reset(selectedGroups);
				this.model.isDirty = true;
			}, this)
		});
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose(this.model);
		}
		this.removeModal();
	},
	save: function () {
		if (this.model.hasChanged() || this.model.isNew()) {
			let isNew = false;
			if (this.model.isNew()) {
				isNew = true;
			}
			this.model.save(null, {
				notify: true,
				success: _.bind(function () {
					if (this.options.onSave) {
						this.options.onSave(this.model, isNew);
					}
					this.removeModal();
				}, this)
			});
		}
		else {
			this.removeModal();
		}
	},
	deleteBidPackage: function () {
		if (typeof this.options.onDelete === 'function') {
			this.options.onDelete(this.model);
		}
		this.removeModal();
	}
});

PJQ.views.bidPackages.ImportTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-import-bid-package-template'),
		maxWidth: 500,
		onImport: null
	},
	events: {
		'click .btn-import': 'save'
	},
	beforeModalCreated: function () {
		PJQ.app.session.fetchBidPackageTemplates(_.bind(function (tmp) {
			this.templates = tmp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			templates: this.templates
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			this.templatePicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-template'),
				onChange: _.bind(function (value) {
					this.selectedTemplate = this.templates.get(value);
				}, this),
				isIntChoices: true,
				noneSelectedText: 'Select Template'
			});

		}
	},
	save: function () {
		let isValid = true;
		if (this.selectedTemplate == null) {
			this.templatePicker.showError();
			isValid = false;
		}
		else {
			this.templatePicker.hideError();
		}


		if (!isValid) {
			return;
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'bidpackages'
				},
				{
					endpoint: 'import',
					value: this.selectedTemplate.id
				}
			])
		}).put().done(_.bind(function (response) {
			if (typeof this.options.onImport === 'function') {
				let result = new PJQ.collections.bidPackages.BidPackages(response);
				result.isFetched = true;
				this.options.onImport(result);
			}
			this.removeModal();
			PJQ.notifications.notify.successNotify({
				message: 'Bid Package Template Imported'
			});
		}, this));
	}
});

PJQ.views.bidPackages.BidPackageTemplateCreatorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-create-bid-package-template'),
		width: '30%'
	},
	events: {
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		this.model = new PJQ.models.bidPackages.Template({
			projectId: this.options.project.id
		});

		PJQ.app.session.fetchBidPackageTemplates(_.bind(function (tmp) {
			this.templates = tmp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			templates: this.templates,
			bidPackages: this.collection
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-bid-package'),
				isMultiple: true,
				noneSelectedText: 'Select Bid Package',
				onChange: _.bind(function (value) {

				}, this)
			});

			new PJQ.inputs.AutocompleteInput({
				el: this.$('.input-template-name'),
				source: _.map(this.templates.models, function (template) {
					return template.get('name')
				})
			});
		}
	},
	save: function () {
		let $name = this.$('.input-template-name'),
			name = $name.val();
		if (_.size(name.trim()) === 0) {
			PJQ.helpers.inputHelpers.setInputError($name);
			return;
		}
		else {
			PJQ.helpers.inputHelpers.setInputError($name, true);
		}

		let existingTemplate = this.templates.findWhere({name: name}),
			fnSave = _.bind(function () {
				this.model.set({
					name: name
				});
				this.model.save(null, {
					success: _.bind(function () {
						this.removeModal();
						PJQ.notifications.notify.successNotify({
							message: 'Bid Package Template Created'
						});
					}, this)
				});
			}, this);
		if (existingTemplate != null) {
			new PJQ.views.modals.YesNo({
				header: "Overwrite Template",
				body: "A template already exists with this name.  Would you like to overwrite it?",
				onYes: _.bind(function () {
					this.model.set('templateId', existingTemplate.id);
					fnSave();
				}, this)
			});
		}
		else {
			fnSave();
		}
	}
});

PJQ.views.bidPackages.SelectBidPackagesModal = PJQ.views.BaseModal.extend({
	defaults: {
		isSingleChoice: false,
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Bid-Packages-Select'),
		alertText: null,
		onSave: null
	},
	events: {
		"click .bid-packages-select-save": "onSave"
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.bidPackageSelector = new PJQ.views.bidPackages.BidPackageSelector({
			el: this.$('.bid-packages-selector'),
			isEnableSelectedFilter: false,
			onBidPackageSelected: _.bind(this.checkBidPackagesSelected, this),
			project: this.options.project
		});
	},
	checkBidPackagesSelected: function (bidPackagesData) {
		this.$('.bid-packages-select-save').prop('disabled', _.size(bidPackagesData.new) === 0 && _.size(_.difference(_.map(bidPackagesData.original, function (bidPackage) {
			return bidPackage.id;
		}), _.map(bidPackagesData.selected, function (bidPackage) {
			return bidPackage.id
		}))) === 0);
		this.onSave()
	},
	onSave: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.bidPackageSelector.getData());
		}
		this.removeModal();
	},
});

PJQ.views.bidPackages.BidPackageSelector = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Bid-Package-Selector-Container'),
		subTemplates: {
			selector: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Bid-Package-Selector')
		},
		bidPackages: null,
		includeBidPackageIds: null,
		selectedBidPackageIds: null,
		disabledBidPackageIds: null,
		selectedBidPackages: null,
		onBidPackagesLoaded: null,
		onBidPackageSelected: null,
		isAdmin: false,
		isEnableSelectAll: false,
		isDisableSelected: false,
		isHideDisabled: false,
		isExpandSelected: true,
		canEdit: true,
		onSelect: _.noop,
		isSingleChoice: false,
		headerButtons: null,
		isIncludeGroups: false,
		onSelected: _.noop
	},
	events: {
		"keyup .bid-package-search": "renderBidPackages",
		"click .btn-header-action": "headerAction",
		"click .bid-package-all-select": "selectAll",
		"click .bid-package-expand": "expandParentClick",
		"click .bid-package-select": "selectBidPackage",
		"click .group-select": "selectGroup"
	},
	afterRender: function () {
		this.selectedGroupIds = [];
		this.selectedBidPackageIds = [];
		if (this.options.bidPackages == null) {
			this.getBidPackages();
		}
		else {
			this.afterSync();
		}
	},
	getBidPackages: function () {
		if (this.collection != null) {
			this.collection.fetch({
				success: _.bind(function () {
					this.afterSync();
				}, this)
			});
		}
		else if (this.options.project) {
			this.collection = new PJQ.collections.bidPackages.BidPackages(null, {
				projectId: this.options.project.id
			})
			this.collection.fetch({
				success: _.bind(function () {
					this.afterSync();
				}, this)
			});
		}
		else {
			this.collection = new PJQ.collections.bidPackages.BidPackages();
			this.afterSync()
		}
	},
	afterSync: function () {
		this.options.isBidPackagesLoaded = true;
		this.loadBidPackages();
	},
	loadBidPackages: function () {
		if (this.removed) {
			return;
		}

		this.renderBidPackages();

		if (typeof this.options.onBidPackagesLoaded === 'function') {
			this.options.onBidPackagesLoaded();
		}
	},
	renderBidPackages: function () {
		let searchFilter = this.$('.bid-package-search').val().toLowerCase(),
			bidPackages = [];

		if (_.size(searchFilter) > 0) {
			_.each(this.collection.models, _.bind(function (model) {
				if (model.get('name').toLowerCase().indexOf(searchFilter) > -1)
					bidPackages.push(model);
			}, this));
		}
		else {
			this.$('.bid-package-clear-filters').prop('disabled', true);
			bidPackages = this.collection.models;
		}

		let data = {
			models: bidPackages,
			options: this.options,
		};
		this.renderSubTemplate(false, this.options.subTemplates.selector, this.$('.bid-packages-container'), data, _.bind(function () {
			if (this.options.isHideDisabled) {
				this.$('.bid-package-select:disabled').closest('.bid-package-select-container').hide();
			}
			this.isRendered = true;
		}, this));
	},
	showError: function (errorText) {
		this.hideError();
		this.errorAlert = new PJQ.Alert(this.$el, {
			type: 'danger',
			extraClasses: ['mt-1, mb-1'],
			text: errorText,
			isPrepend: true
		});
	},
	hideError: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
	},
	reload: function (userId) {
		this.getBidPackages();
	},
	getParentChildContainer: function (parent) {
		return parent.closest('.pretty').siblings('.group-child-container');
	},
	expandParentClick: function (e) {
		this.expandParent($(e.currentTarget).siblings('.group-child-container'));
	},
	expandParent: function (container) {
		let icon = container.siblings('i.bid-package-expand');
		if (container.hasClass('hidden')) {
			container.removeClass('hidden');
			icon.removeClass('fa-chevron-down text-primary');
			icon.addClass('fa-chevron-up text-muted');
		}
		else {
			container.addClass('hidden');
			icon.removeClass('fa-chevron-up text-muted');
			icon.addClass('fa-chevron-down text-primary');
		}
	},
	getData: function () {
		let groupIds = [],
			bidPackageIds = [];
		_.each(this.collection.models, function (bidPackage) {
			if (bidPackage.get('isSelected')) {
				bidPackageIds.push(bidPackage.get('bidPackageId'))
			}
			_.each(bidPackage.groups.models, function (group) {
				if (group.get('isSelected')) {
					groupIds.push(group.get('groupId'));
				}
			}, this)
		}, this);

		if (typeof this.options.onSelected === 'function') {
			this.options.onSelected(groupIds, bidPackageIds);
		}
		return {groupIds, bidPackageIds};
	},
	selectBidPackage: function (e) {
		let childContainer = this.getParentChildContainer($(e.currentTarget)),
			isChecked = $(e.currentTarget).is(':checked'),
			bidPackageId = $(e.currentTarget).data('bid-package-id'),
			bidPackage = this.collection.get(bidPackageId);

		let groupSelects = [];
		groupSelects = childContainer.find('.bid-package-select')
		childContainer.find('.group-select').prop('checked', isChecked);

		bidPackage.set('isSelected', isChecked);
		_.each(bidPackage.groups.models, function (group) {
			group.set('isSelected', isChecked);
		}, this)

		if (isChecked) {
			//If its checked, expand the parents/sub-parents to show the groups that were selected
			if (childContainer.hasClass('hidden')) {
				this.expandParent(childContainer);
			}
		}

		this.$('.bid-package-all-select').prop('checked', !(this.$('.group-select:not(:checked)').length > 0));

		this.getData();
	},
	selectAll: function () {
		let groupSelects = this.$('.group-select'),
			bidPackageSelects = this.$('.bid-package-select')
		if (this.$('.bid-package-all-select').prop('checked')) {
			_.each(this.collection.models, function (model) {
				model.set('isSelected', true);
				_.each(model.groups.models, function (group) {
					group.set('isSelected', true);
				}, this)
			}, this)
			groupSelects.prop('checked', true);
			bidPackageSelects.prop('checked', true);
		}
		else {
			_.each(this.collection.models, function (model) {
				model.set('isSelected', false);
				_.each(model.groups.models, function (group) {
					group.set('isSelected', false);
				}, this)
			}, this)
			groupSelects.prop('checked', false);
			bidPackageSelects.prop('checked', false);
		}
		this.getData();
	},
	selectGroup: function (e) {
		let $target = $(e.currentTarget),
			groupId = $target.data('group-id'),
			bidPackageId = $target.data('bid-package'),
			bidPackage = this.collection.get(bidPackageId),
			removeBidPackage = true,
			group = _.find(bidPackage.groups.models, function (group) {
				return group.get('groupId') === groupId;
			}),
			isChecked = $(e.currentTarget).is(':checked'),
			bidPackageSwitch = this.$('.bid-packages-container').find('[data-bid-package-id="' + bidPackageId + '"]')

		group.set('isSelected', isChecked);
		if (isChecked && !bidPackage.get('isSelected')) {
			bidPackage.set('isSelected', true);
			bidPackageSwitch.prop('checked', isChecked);
		}

		if (!isChecked) {
			_.each(bidPackage.groups.models, function (group) {
				if (group.get('isSelected')) {
					removeBidPackage = false;
				}
			})

			if (removeBidPackage) {
				bidPackageSwitch.prop('checked', isChecked);
				bidPackage.set('isSelected', false);
			}
		}
		this.$('.bid-package-all-select').prop('checked', !(this.$('.group-select:not(:checked)').length > 0));
		this.getData();
	}
});

PJQ.views.bidPackages.BidPackageRadiusModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Bid-Package-Radius'),
		alertText: null,
		onSave: null,
		maxWidth: "400px",
		defaultRadius: 50
	},
	events: {
		"click .add-participants": "addParticipants",
		'keyup .add-participants-radius': 'radiusChanged'
	},
	beforeModalCreated: function () {
		let prefs;
		if (this.options.project != null) {
			prefs = this.options.project.preferences;
		}
		else {
			prefs = PJQ.app.session.preferences;
		}

		let radiusPref = prefs.getPref(PJQ.constants.preferenceTypes.ADD_PARTICIPANTS_BID_PACKAGE_RADIUS);
		if (radiusPref != null && radiusPref > 0) {
			this.options.defaultRadius = radiusPref;
		}
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.directoryFilterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.directory-filter'),
			isIntChoices: true,
			isMultiple: true,
			mustSelectValue: true,
			defaultValue: [1,2]
		});

		this.radiusSlider = new PJQ.Slider(this.$('.add-participants-radius-slider'), {
			ticks: [1, 50, 100, 150, 200, 250, 300],
			ticks_labels: [1, 50, 100, 150, 200, 250, 300],
			value: this.options.defaultRadius,
			onChange: _.bind(function (obj) {
				this.setRadius(obj.newValue);
			}, this)
		});
	},
	radiusChanged: function () {
		this.setRadius(parseInt(this.$('.add-participants-radius').val()));
	},
	setRadius: function (radius) {
		if (isNaN(radius) || radius < 1)
			radius = 1;
		else if (radius > 300)
			radius = 300;
		this.radiusSlider.setValue(radius);
		//don't set the radius input yet if the length of the value is 0 in case the user is trying to clear the input to enter a new value
		if (this.$('.add-participants-radius').val().length > 0)
			this.$('.add-participants-radius').val(radius);
	},
	addParticipants: function () {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'participants',
					value: 'bidPackages'
				}
			], [
				{
					parameter: 'radius',
					value: this.radiusSlider.getValue()
				},
				{
					parameter: 'directoryFilter',
					value: _.size(this.directoryFilterSelectPicker.getValue()) === 2 ? 0 : this.directoryFilterSelectPicker.getValue()[0]
				}
			])
		}).post().done(_.bind(function (data) {
			if (typeof this.options.onSave === 'function') {
				this.options.onSave(data)
			}
			if (_.size(data) > 0) {
				PJQ.notifications.notify.successNotify({
					message: 'Participants successfully added'
				});
			}
			else {
				PJQ.notifications.notify.successNotify({
					message: 'No participants were added'
				});
			}
			this.removeModal();
		}, this)).fail(_.bind(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Encountered an error adding participants.  Please contact customer service.'
			});
		}, this));
	}
});


//Models
PJQ.models.billing = {};

PJQ.models.billing.BillingInfo = PJQ.models.BaseModel.extend({
	endpoint: '/billing',
	getCardholderName: function () {
		let name = this.get('firstName');
		if (_.size(this.get('lastName')) > 0) {
			name = ' ' + this.get('lastName');
		}
		return name;
	},
	save: function (mod, opts = {}) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'billing'
				}
			]),
			data: this.toJSON()
		}).put().done(_.bind(function (data) {
			if (data == null || data.subscription == null) {
				//empty the card number in case of error after this point
				this.set({
					cardNumber: null,
					cardExpirationMonth: null,
					cardExpirationYear: null
				});

				if (typeof opts.error === 'function') {
					opts.error(data);
				}
			}

			if (data.billingInfo != null) {
				this.parse(data.billingInfo);
			}

			PJQ.app.session.subscriptionChanged(data.subscription);

			if (typeof opts.success === 'function') {
				opts.success(data);
			}
		}, this)).fail(_.bind(function (data) {
			//empty the card number in case of error after this point
			this.set({
				cardNumber: null,
				cardExpirationMonth: null,
				cardExpirationYear: null
			});

			if (typeof opts.error === 'function') {
				opts.error(data);
			}
		}, this));
	},
	parse(model) {
		if (!model)
			return model;

		this.attributes = model;
	}
});

PJQ.Binder = class {
    constructor($el, obj, options = {}) {
        this.options = _.defaults(options, {
            attribute: 'data-p-bind',
            watchElements: [
                'input',
                'textarea'
            ],
            setDefaultValues: false,
            events: 'keyup change dp.change',
            delegate: false,
            onChange: null,
            afterChange: null,
            useDecimalPercentFields: false,
            canEdit: null,
            //below needed to support events for collections w/ data tables
            dataTable: null,
            idAttribute: 'cid',
            modelSelectorAttribute: 'cid',
            modelSelector: 'tr',
            validators: {}
        });

        this.$outer = $el;

        let objectType = PJQ.helpers.objectHelpers.refinedType(obj, true);
        if (objectType === 'backboneCollection') {
            this.isArray = true;
            this.obj = obj.models;
        } else if (objectType === 'array') {
            this.isArray = true;
            this.obj = obj;

        } else if (objectType === 'backboneModel' || objectType === 'object') {
            this.isBackboneObj = (objectType === 'backboneModel');
            this.obj = obj;
        }

        this.bindElements();
    }

    remove() {
        if (this.options.delegate === true) {
            this.$outer.off(this.options.events);
        } else {
            let self = this;
            _.each(this.options.watchElements, (element) => {
                this.$outer.find(element + '[' + this.options.attribute + ']').each(function () {
                    $(this).off(self.options.events);
                });
            });
        }
    }

    bindElements() {
        this.requiredAttributes = [];

        this.renderInputs();

        if (this.options.delegate === true) {
            this.$outer.on(this.options.events, this.options.watchElements.join(', '), (e) => {
                this.handleChange($(e.target));
            });
        } else {
            let self = this;
            _.each(this.options.watchElements, (element) => {
                this.$outer.find(element + '[' + this.options.attribute + ']').each(function () {
                    if (self.options.canEdit != null) {
                        $(this).prop('disabled', !self.options.canEdit);
                    }

                    self.bindElement($(this));
                    if (self.options.setDefaultValues && self.obj != null && !self.isArray) {
                        self.setElementValue($(this))
                    }
                });
            });
        }
    }

    bindElement($el) {
        let attribute = this.getElementAttribute($el);
        if (attribute != null && attribute.length > 0) {
            if ($el.prop('required') && !_.contains(this.requiredAttributes, attribute)) {
                this.requiredAttributes.push(attribute);
            }

            let self = this;
            switch (this.getElementType($el)) {
                case 'text':
                    $el.on(this.options.events, function () {
                        self.onChange($el, attribute, $el.val());
                    });
                    break;
                case 'decimal':
                    $el.on(this.options.events, function () {
                        let value = parseFloat($el.val());
                        value = typeof value === 'number' ? value * 100 : 0;
                        self.onChange($el, attribute, value);
                    });
                    break;
                case 'number':
                    $el.on(this.options.events, function () {
                        self.onChange($el, attribute, PJQ.helpers.inputHelpers.getNumberInputValue($el));
                    });
                    break;
                case 'percent':
                    $el.on(this.options.events, function () {
                        self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPercentInputValue($el, self.options.useDecimalPercentFields === true));
                    });
                    break;
                case 'phone':
                    $el.on(this.options.events, function () {
                        self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPhoneInputValue($el));
                    });
                    break;
                case 'money':
                    $el.on(this.options.events, function () {
                        self.onChange($el, attribute, PJQ.helpers.inputHelpers.getMoneyInputValue($el.parent()));
                    });
                    break;
                case 'date':
                    //todo: Support date input (dates use another prototype - attempt to attach this prototype to the element somehow
                    break;
                case 'select':
                    $el.on(this.options.events, function () {
                        let picker = $el.data('selectpickerview'),
                            value = picker != null ? picker.getValue() : $el.val();
                        self.onChange($el, attribute, value);
                    });
                    break;
                case 'bool':
                    $el.on(this.options.events, function () {
                        let opposite = $el.data('pBindOpposite') === true,
                            val = $el.prop('checked');
                        self.onChange($el, attribute, opposite ? !val : val);
                    });
                    break;
            }
        }
    }

    renderInputs() {
        this.inputs = {
            selectPickers: {},
            datePickers: {},
            buttonGroups: {},
            groupPickers: {},
            locationPickers: {},
            contactSelectors: {},
            fileUploaders: {},
            all: {}
        }
        this.attributeListeners = {};

        if (this.options.inputs == null) {
            return;
        }

        _.each(this.options.inputs, (inputOpts, attribute) => {
            if (typeof inputOpts.onChange === 'function' || typeof inputOpts.afterChange === 'function') {
                this.attributeListeners[attribute] = {
                    onChange: inputOpts.onChange,
                    afterChange: inputOpts.afterChange
                };
            }

            let $el = this.getAttributeElement(attribute);
            if ($el.length === 0) {
                return false;
            }

            let fnRender = ($input) => {
                if (inputOpts.selectPicker != null) {
                    this.renderSelectPicker($input, attribute, inputOpts.selectPicker);
                } else if (inputOpts.datePicker != null) {
                    this.renderDatePicker($input, attribute, inputOpts.datePicker);
                } else if (inputOpts.groupPicker != null) {
                    this.renderGroupPicker($input, attribute, inputOpts.groupPicker);
                } else if (inputOpts.locationPicker != null) {
                    this.renderLocationPicker($input, attribute, inputOpts.locationPicker);
                } else if (inputOpts.contactSelector != null) {
                    this.renderContactSelector($input, attribute, inputOpts.contactSelector);
                } else if (inputOpts.fileUploader != null) {
                    this.renderFileUploader($input, attribute, inputOpts.fileUploader);
                } else if (inputOpts.buttonGroup != null) {
                    this.renderButtonGroup($input, attribute, inputOpts.buttonGroup);
                }
            }
            if ($el.length > 1) {
                $el.each(function () {
                    fnRender($(this));
                });
                return;
            } else {
                fnRender($el);
            }

            if ((inputOpts.required || $el.prop('required')) && !_.contains(this.requiredAttributes, attribute)) {
                this.requiredAttributes.push(attribute);
            }
        });
    }

    getInputObj(attribute, modelId = null) {
        let attr = attribute;
        if (modelId != null) {
            attr = attribute + "_" + modelId;
        }
        return this.inputs.all[attr];
    }

    getInput(attribute, modelId = null) {
        return this.getInputObj(attribute, modelId)?.input ?? null;
    }

    renderGroupPicker($el, attribute, pickerOpts) {
        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        let value = null;
        if (typeof obj.get === 'function') {
            value = obj.get(attribute);
        } else {
            value = obj[attribute];
        }

        let optChange = pickerOpts?.onChange;
        this.inputs.all[attribute] = this.inputs.groupPickers[attribute] = {
            input: new PJQ.inputs.GroupPicker(_.defaults({
                el: $el,
                project: this.options.project,
                canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
                defaultValue: pickerOpts.defaultValue ?? value,
                onChange: (value) => {
                    this.onChange($el, attribute, value);

                    if (typeof optChange === 'function') {
                        optChange(value);
                    }
                }
            }, pickerOpts))
        };
    }

    renderLocationPicker($el, attribute, pickerOpts) {
        if (this.options.project == null && pickerOpts.project == null) {
            return;
        }

        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        let value = null;
        if (typeof obj.get === 'function') {
            value = obj.get(attribute);
        } else {
            value = obj[attribute];
        }

        let optChange = pickerOpts?.onChange;
        this.inputs.all[attribute] = this.inputs.locationPickers[attribute] = {
            input: new PJQ.inputs.ProjectLocationPicker(_.defaults({
                el: $el,
                project: this.options.project,
                canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
                defaultValue: pickerOpts.defaultValue ?? value,
                onChange: (value) => {
                    this.onChange($el, attribute, value);

                    if (typeof optChange === 'function') {
                        optChange(value);
                    }
                }
            }, pickerOpts))
        };
    }

    renderContactSelector($el, attribute, pickerOpts) {
        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        // first try to get a collection object inside the model (not the attributes)
        let value = obj[attribute],
            objectType = PJQ.helpers.objectHelpers.refinedType(value, true),
            collection = null;
        if (value == null) {
            if (typeof obj.get === 'function') {
                value = obj.get(attribute);
            } else {
                value = obj[attribute];
            }
        } else if (objectType === 'backboneCollection') {
            collection = value;
        }

        let optChange = pickerOpts?.onChange;
        this.inputs.all[attribute] = this.inputs.contactSelectors[attribute] = {
            input: new PJQ.views.contacts.ContactsSelectInput(_.defaults({
                el: $el,
                project: this.options.project,
                canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
                selectedContact: pickerOpts.selectedContact ?? collection?.models ?? value,
                onChange: (value) => {
                    if (this.isBackboneObj) {
                        obj.set('isDirty', true);
                    }

                    this.onChange($el, attribute, value);

                    if (typeof optChange === 'function') {
                        optChange(value);
                    }
                }
            }, pickerOpts)),
            setValue: pickerOpts.setValue ? pickerOpts.setValue(value) : (value) => {
                if (collection != null) {
                    collection.reset(value);
                } else {
                    obj[attribute] = value;
                }

                if (this.isBackboneObj) {
                    obj.isDirty = true;
                }
            }
        };
    }

    renderSelectPicker($el, attribute, pickerOpts) {
        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        let value = null;
        if (typeof obj.get === 'function') {
            value = obj.get(attribute);
        } else {
            value = obj[attribute];
        }

        let optChange = pickerOpts?.onChange;
        this.inputs.all[attribute] = this.inputs.selectPickers[attribute] = {
            input: new PJQ.inputs.Selectpicker(_.defaults({
                el: $el,
                canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
                defaultValue: pickerOpts.defaultValue ?? value,
                onChange: (value) => {
                    this.onChange($el, attribute, value);

                    if (typeof optChange === 'function') {
                        optChange(...arguments);
                    }
                }
            }, pickerOpts))
        };
    }

    renderDatePicker($el, attribute, pickerOpts) {
        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        let value = null;
        if (typeof obj.get === 'function') {
            value = obj.get(attribute);
        } else {
            value = obj[attribute];
        }

        let optChange = pickerOpts?.onChange;
        pickerOpts = _.defaults({
            el: $el,
            canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
            onChange: (value) => {
                this.onChange($el, attribute, value);

                if (typeof optChange === 'function') {
                    optChange(value);
                }
            }
        }, pickerOpts);

        if (pickerOpts.datepickerOptions == null) {
            pickerOpts.datepickerOptions = {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
            }
        }

        let defVal = pickerOpts.datepickerOptions.defaultValue ?? value;
        pickerOpts.datepickerOptions.defaultDate = typeof defVal === 'function' ? defVal(obj) : defVal;

        // todo: support datepicker collections
        this.inputs.all[attribute] = this.inputs.datePickers[attribute] = {
            input: new PJQ.inputs.Datepicker(pickerOpts)
        };
    }

    renderButtonGroup($el, attribute, opts) {
        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        let value = null;
        if (typeof obj.get === 'function') {
            value = obj.get(attribute);
        } else {
            value = obj[attribute];
        }

        let optChange = opts?.onChange;
        this.inputs.all[attribute] = this.inputs.buttonGroups[attribute] = {
            input: new PJQ.inputs.ButtonGroup(_.defaults({
                el: $el,
                defaultValue: opts.defaultValue ?? value,
                buttons: typeof opts.buttons === 'function' ? opts.buttons(obj) : opts.buttons,
                canEdit: opts.canEdit != null ? opts.canEdit : (this.options.canEdit ?? true),
                onChange: (value) => {
                    this.onChange($el, attribute, value);

                    if (typeof optChange === 'function') {
                        optChange(value);
                    }
                }
            }, opts))
        };
    }

    renderFileUploader($el, attribute, opts) {
        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        // first try to get a collection object inside the model (not the attributes)
        let value = obj[attribute],
            objectType = PJQ.helpers.objectHelpers.refinedType(value, true),
            collection = null;
        if (value == null) {
            if (typeof obj.get === 'function') {
                value = obj.get(attribute);
            } else {
                value = obj[attribute];
            }
        } else if (objectType === 'backboneCollection') {
            collection = value;
        }

        let optSuccess = opts.onSuccess,
            optDelete = opts.onDelete;
        this.inputs.all[attribute] = this.inputs.fileUploaders[attribute] = {
            input: new PJQ.views.files.FileUploaderGrid(_.defaults({
                el: $el,
                collection: collection,
                canUpload: opts.canUpload != null ? opts.canUpload : (this.options.canEdit ?? true),
                canDelete: opts.canDelete != null ? opts.canDelete : (this.options.canEdit ?? true),
                onSuccess: this.isBackboneObj ? () => {
                    obj.isDirty = true;

                    if (typeof optSuccess === 'function') {
                        optSuccess(value);
                    }
                } : null,
                onDelete: (attachment, callback) => {
                    if (attachment.id > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    obj.isDirty = true;

                    if (typeof optDelete === 'function') {
                        optDelete(value);
                    }

                    callback();
                }
            }, opts))
        };
    }

    getAttributeElement(attr) {
        return this.$outer.find('[' + this.options.attribute + '="' + attr + '"]');
    }

    getArrayObjectForElement($el) {
        let id = $el.closest(_.size(this.options.modelSelector) > 0 ? this.options.modelSelector : 'tr').attr(this.options.modelSelectorAttribute);
        if (_.size(id) <= 0) {
            return null;
        }
        return _.find(this.obj, function (obj) {
            return obj[this.options.idAttribute] === id;
        }, this);
    }

    setValue(attribute, value, changedObj, $el = null, updateElement = true) {
        if (_.size(attribute) === 0) {
            return;
        }

        // if there is a contact selector associated with this
        // then we need to update the contacts collection/model at the root of the object
        let input = this.getInputObj(attribute);
        if (this.isArray) {
            if (!changedObj) {
                if (_.size($el) === 0) {
                    return;
                }
                changedObj = this.getArrayObjectForElement($el);
            }

            if (changedObj == null) {
                return;
            }

            if (typeof changedObj.set === 'function') {
                changedObj.set(attribute, value);
            } else {
                changedObj[attribute] = value;
            }
        } else if (input != null && typeof input.setValue === 'function') {
            input.setValue(value);
        } else if (this.isBackboneObj) {
            this.obj.set(attribute, value);
        } else {
            this.obj[attribute] = value;
        }

        if (updateElement) {
            if (_.size($el) === 0) {
                $el = this.getAttributeElement(attribute);
            }

            if (input != null) {
                // todo: update input if not null
            } else if (_.size($el) > 0) {
                this.setElementValue($el);
            }
        }
    }

    setElementValue($el) {
        let obj = this.obj;
        if (this.isArray) {
            obj = this.getArrayObjectForElement($el);
        }

        if (obj == null)
            return;

        let value = null,
            attribute = this.getElementAttribute($el);
        if (typeof obj.get === 'function') {
            value = obj.get(attribute);
        } else {
            value = obj[attribute];
        }

        let elType = this.getElementType($el);
        if (elType === 'bool') {
            let opposite = $el.data('pBindOpposite') === true;
            value = opposite ? value === false : value;
        }

        if (value != null) {
            switch (this.getElementType($el)) {
                case 'text':
                case 'number':
                    $el.val(value);
                    break;
                case 'percent':
                    $el.val(PJQ.helpers.formatHelpers.formatPercent(this.options.useDecimalPercentFields === true ? value : value / 100));
                    break;
                case 'bool':
                    $el.prop('checked', value);
                    break;
                case 'phone':
                    $el.val(PJQ.helpers.formatHelpers.formatPhoneNumber(value));
                    break;
                case 'decimal':

                    break;
                case 'select':
                    // this is handled in the selectpicker when it is initialized
                    break;
                case 'date':
                case 'datetime':
                case 'time':
                    // this is handled in the datetimepicker when it is initialized
                    break;
                case 'money':
                    $el.val(PJQ.helpers.formatHelpers.formatCurrency(value, 2));
                    break;
            }
        }
    }

    handleChange($el) {
        let attribute = this.getElementAttribute($el),
            self = this;
        if (_.size(attribute) > 0) {
            switch (this.getElementType($el)) {
                case 'text':
                    self.onChange($el, attribute, $el.val());
                    break;
                case 'decimal':
                    self.onChange($el, attribute, PJQ.helpers.inputHelpers.getMoneyInputValue($el) / 100);
                    break;
                case 'number':
                    self.onChange($el, attribute, PJQ.helpers.inputHelpers.getNumberInputValue($el));
                    break;
                case 'percent':
                    self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPercentInputValue($el, self.options.useDecimalPercentFields === true));
                    break;
                case 'phone':
                    self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPhoneInputValue($el));
                    break;
                case 'money':
                    self.onChange($el, attribute, PJQ.helpers.inputHelpers.getMoneyInputValue($el.parent()));
                    break;
                case 'hours':
                    break;
                case 'time':
                    //todo: Support date input (dates use another prototype - attempt to attach this prototype to the element somehow
                    break;
                case 'date':
                case 'datetime':
                    // date/datetime is handled by the datepicker
                    // this should never be hit
                    break;
                case 'select':
                    // select is ideally handled by defining an input so the binder initializes the selectpicker
                    // if select is provided in the watchElements, then we can handle it here
                    let picker = $el.data('selectpicker'),
                        value = picker != null ? picker.getValue() : $el.val();
                    self.onChange($el, attribute, value);
                    break;
                case 'bool':
                    let opposite = $el.data('pBindOpposite') === true,
                        val = $el.prop('checked');
                    self.onChange($el, attribute, opposite ? !val : val);
                    break;
            }
        }
    }

    getElementAttribute($el) {
        return $el.attr(this.options.attribute);
    }

    getElementType($el) {
        if ($el.is('input')) {
            if ($el.hasClass('input-dollars-full') || $el.hasClass('input-dollars') || $el.hasClass('input-cents')) {
                return 'money';
            } else if ($el.hasClass('input-phone')) {
                return 'phone';
            } else if ($el.hasClass('input-percent')) {
                return 'percent';
            } else if ($el.hasClass('input-numeric')) {
                return 'number';
            } else if ($el.hasClass('input-decimal')) {
                return 'decimal';
            } else if ($el.hasClass('input-time')) {
                return 'time';
            } else if ($el.hasClass('input-hours')) {
                return 'hours';
            } else if ($el.attr('type') === 'checkbox') {
                return 'bool';
            } else if ($el.data('DateTimePicker') != null || $el.hasClass('input-date')) {
                return 'date';
            } else {
                return 'text';
            }
        } else if ($el.is('textarea')) {
            return 'text';
        } else if ($el.is('select')) {
            return 'select';
        }
    }

    onChange($el, attribute, value) {
        if (attribute.length > 0) {
            let attrListener = this.attributeListeners[attribute],
                changedObj = this.obj;
            if (this.isArray) {
                changedObj = this.getArrayObjectForElement($el);
            }

            if (typeof attrListener?.onChange === 'function') {
                attrListener.onChange($el, attribute, value, changedObj);
            } else if (typeof this.options.onChange === 'function') {
                this.options.onChange($el, attribute, value, changedObj);
            } else {
                this.setValue(attribute, value, changedObj, $el, false);
            }

            if (typeof this.options.afterChange === 'function') {
                this.options.afterChange($el, attribute, value, changedObj);
            }
            if (typeof attrListener?.afterChange === 'function') {
                attrListener.afterChange($el, value, changedObj);
            }
        }
    }

    getValidator(attribute) {
        let inputOpts = this.options.inputs != null ? this.options.inputs[attribute] : null,
            validator = null;
        if (inputOpts != null) {
            validator = inputOpts.validator;

            if (validator == null) {
                validator = {
                    func: inputOpts.validate ?? null
                };
            }
        } else if (this.options.validators != null) {
            validator = this.options.validators[attribute];
        }

        return validator ?? null;
    }

    validate(options = {showInputErrors: true}) {
        let self = this,
            result = {
                isValid: true,
                validAttributes: [],
                invalidAttributes: [],
                errors: []
            };
        if (this.isArray) {
            // add if needed
        } else {
            _.each(this.requiredAttributes, (attr) => {
                let validator = this.getValidator(attr),
                    value = this.isBackboneObj ? this.obj.get(attr) : self.obj[attr],
                    isValid = true,
                    $el = null;
                if (typeof validator?.func === 'function') {
                    let validatorRes = validator.func(value, this.obj);
                    if (typeof validatorRes === 'boolean') {
                        isValid = validatorRes;
                    } else {
                        isValid = validatorRes?.isValid ?? false;
                    }

                    if (_.size(validatorRes?.errors) > 0) {
                        result.errors.push(...validatorRes.errors);
                    }
                } else {
                    $el = self.getAttributeElement(attr);

                    // todo: allow rules to be passed in rather than always needing a function validator
                    let rules = validator?.rules ?? [],
                        elType = self.getElementType($el);
                    switch (elType) {
                        case 'text':
                        case 'phone':
                            isValid = _.size(value) > 0;
                            break;
                        case 'select':
                            let picker = $el.data('selectpickerview');
                            if (picker && value != null) {
                                // it is valid if we find at least 1 matching choice
                                let isArr = _.isArray(value);
                                isValid = null != _.find(picker.options.choices, (choice) => {
                                    return isArr ? _.contains(value, choice.id) : choice.id === value;
                                });
                            } else {
                                isValid = typeof value === 'number' || _.size(value) > 0;
                            }
                            break;
                        default:
                            isValid = value != null;
                            break;
                    }
                }

                if (isValid) {
                    result.validAttributes.push(attr);
                } else {
                    result.invalidAttributes.push(attr);
                }

                if (options.showInputErrors !== false) {
                    if ($el == null) {
                        $el = self.getAttributeElement(attr);
                    }
                    PJQ.helpers.inputHelpers.setInputError($el, isValid);
                }
            });
        }

        result.isValid = _.size(result.invalidAttributes) === 0;
        return result;
    }
}
if (PJQ.app.module === PJQ.constants.modules.APP) {
	PJQ.modules.calendar = {
		routes: [
			{
				route: 'calendar',
				name: 'calendar',
				callback: function () {
					PJQ.app.initNavigator({
						activeItem: "calendar"
					});
				}
			}
		]
	};
	PJQ.app.addRoutes(PJQ.modules.calendar.routes);
}

PJQ.views.calendars = {};

PJQ.views.calendars.MiniCalendar = PJQ.views.BaseView.extend({
	defaults: {
		datepickerOptions: {
			inline: true,
			defaultDate: new Date(),
			format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
			isDaysOnly: true,
			icons: {
				time: 'fal fa-clock',
				date: 'fal fa-calendar-alt',
				up: 'fal fa-chevron-up',
				down: 'fal fa-chevron-down',
				previous: 'fal fa-chevron-left',
				next: 'fal fa-chevron-right',
				today: 'fal fa-crosshairs',
				clear: 'fal fa-trash',
				close: 'fal fa-times'
			}
		},
		onChange: _.noop,
		dateRangeChanged: _.noop
	},
	events: {
		"dp.change": "onChange",
		"dp.update": "onUpdate"
	},
	beforeInit: function (options) {
		this.$el.addClass('mini-calendar');

		if (options.datepickerOptions != null) {
			this.options.datepickerOptions = _.defaults(options.datepickerOptions ? options.datepickerOptions : {}, this.defaults.datepickerOptions);
		}
	},
	afterRender: function () {
		if (PJQ.helpers.objectHelpers.refinedType(this.options.datepickerOptions.defaultDate) === 'date') {
			this.lastSelectedDate = this.options.datepickerOptions.defaultDate;
		}
		this.$el.datetimepicker(this.options.datepickerOptions);
		this.onUpdate();
	},
	onChange: function (e) {
		this.onUpdate();
		if (this.lastSelectedDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(e.date._d, this.lastSelectedDate) !== 0) {
			e.date._d.setHours(0, 0, 0, 0);
			this.lastSelectedDate = e.date._d;
			this.options.onChange(typeof e.date._d === 'undefined' ? null : e.date._d);
			this.renderStatusMarkers();
		}
	},
	updateStatusMarker: function (newStatusDate) {
		if (this.statusDates != null) {
			this.statusDates = _.filter(this.statusDates, function (statusDate) {
				return PJQ.helpers.dateHelpers.getDateDaysDiff(newStatusDate.date, statusDate.date) !== 0;
			});
		}
		else {
			this.statusDates = [];
		}
		this.statusDates.push(newStatusDate);
		this.renderStatusMarker(newStatusDate);
	},
	renderStatusMarkers: function (dates) {
		if (dates != null) {
			this.statusDates = dates;
		}
		//this.$('.status-marker').remove();
		_.each(this.statusDates, function (dayObj) {
			this.renderStatusMarker(dayObj)
		}, this);
	},
	renderStatusMarker: function (statusDate) {
		let dateString = PJQ.helpers.dateHelpers.getDateString(statusDate.date, 'MM/dd/yyyy'),
			$dayContainer = this.$('.day[data-day="' + dateString + '"]');
		if ($dayContainer.hasClass('active')) {
			$dayContainer.css('background-color', statusDate.color);
		}
		if(statusDate.textColor != null) {
			$dayContainer.css('color', statusDate.textColor);
		}
		let $existingMarker = $dayContainer.find('.status-marker');
		if (_.size($existingMarker) > 0) {
			$existingMarker.remove();
		}
		if (statusDate.color != null) {
			let textColor = ''
			if(statusDate.textColor != null) {
				textColor = 'color: ' + statusDate.textColor + ';';
			}
			let $newMarker = $('<span>', {
				class: 'status-marker',
				style: 'background-color: ' + statusDate.color + ';' + textColor
			});
			$newMarker.on('click', function (e) {
				e.stopPropagation();
				$(e.currentTarget).closest('td').trigger('click');
			});
			$dayContainer.append($newMarker);
		}
	},
	onUpdate: function () {
		let currentDateRange = this.getCurrentDateRange(),
			toString = function (date) {
				return PJQ.helpers.dateHelpers.getDateString(date, 'MM/dd/yyyy');
			};
		if (currentDateRange != null && (this.lastDateRange == null || (toString(currentDateRange.start) !== toString(this.lastDateRange.start) || toString(currentDateRange.end) !== toString(this.lastDateRange.end)))) {
			this.lastDateRange = currentDateRange;
			this.options.dateRangeChanged(currentDateRange);
		}
	},
	getCurrentDateRange: function () {
		let $startDayEl = this.$('.datepicker-days').find('td.day').first(),
			$endDayEl = this.$('.datepicker-days').find('td.day').last();
		if (_.size($startDayEl) === 0 || _.size($endDayEl) === 0) {
			return null;
		}
		return {
			start: new Date($startDayEl.data('day')),
			end: new Date($endDayEl.data('day'))
		};
	},
	setDate: function (date) {
		this.lastSelectedDate = date;
		this.$el.data("DateTimePicker").date(date);
		this.renderStatusMarkers();
		this.onUpdate();
	}
});

PJQ.views.calendars.FullCalendar = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Calendar-Base'),
		subTemplates: {
			taskTooltip: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Task-Tooltip')
		},
		canEdit: true,
		canDelete: true,
		onTaskEdit: null,
		onTaskDelete: null,
		fetchTasks: null
	},
	events: {
		'click .btn-edit-task': 'editTaskClicked',
		'click .btn-delete-task': 'deleteTaskClicked',
		'click .btn-close-tooltip': 'closeEventTooltip',
		'contextmenu .fc-day-grid-event': 'eventRightClicked'
	},
	afterRender: function () {
		this.initCalendar();
	},
	initCalendar: function () {
		let fnParseTasks = function (tasks) {
			return _.map(tasks, function (task) {
				return _.defaults({
					extendedProps: {
						model: task.model ? task.model : task,
						progress: task.get('progress') != null ? task.get('progress') : task
					},
					title: task.get('isMilestone') ? ('<span class="far fa-flag mr-1"></span>' + task.get('title')) : task.get('title'),
				}, task.attributes);
			});
		};

		this.calendar = new FullCalendar.Calendar(this.$('.calendar-outer')[0], _.defaults(this.options, {
			height: 'parent',
			plugins: ['dayGrid', 'bootstrap'],
			themeSystem: 'bootstrap',
			defaultView: 'dayGridMonth',
			timezone: 'local',
			header: {
				left: '',
				center: 'title',
				right: 'today prev,next'
			},
			events: typeof this.options.fetchTasks === 'function' ? _.bind(function (filter, callback) {
				this.options.fetchTasks(filter, _.bind(function (res) {
					this.collection = res;
					callback(fnParseTasks(this.collection.models));
				}, this));
			}, this) : fnParseTasks(this.collection.models),
			eventRender: _.bind(this.eventRender, this)
		}));
		this.calendar.render();
	},
	eventRightClicked: function (e) {
		$(e.currentTarget).trigger('click');
		e.preventDefault();
	},
	eventRender: function (info) {
		this.addEventTooltip(info);

		let $ev = $(info.el);
		$ev.addClass('schedule-event');
		if (info.event.id != null) {
			$ev.attr('data-id', info.event.id);
			$ev.attr('title', info.event.title);

			if (typeof this.options.onTaskEdit === 'function') {
				$ev.bind('dblclick', _.bind(function () {
					this.options.onTaskEdit(this.getTask(info.event.id));
				}, this));
			}
		}
	},
	addEventTooltip: function (info) {
		this.tooltip = new PJQ.Tooltip($(info.el), {
			template: this.options.subTemplates.taskTooltip,
			container: this.$el,
			trigger: 'click',
			renderData: _.bind(function () {
				return {
					model: info.event.extendedProps.model,
					schedule: this.options.schedule,
				};
			}, this)
		});
	},
	getTask: function (taskId) {
		let calTask = this.collection.get(taskId);
		return calTask.model ? calTask.model : calTask;
	},
	editTaskClicked: function (e) {
		let taskId = $(e.currentTarget).closest('.task-popup').data('taskId');
		this.editTask(this.getTask(taskId));
	},
	editTask: function (task) {
		if (typeof this.options.onTaskEdit === 'function') {
			this.options.onTaskEdit(task);
		}
	},
	deleteTaskClicked: function (e) {
		let taskId = $(e.currentTarget).closest('.task-popup').data('taskId');
		this.deleteTask(this.getTask(taskId));
	},
	deleteTask: function (task) {
		if (typeof this.options.onTaskDelete === 'function') {
			this.options.onTaskDelete(task);
		}
	},
	closeEventTooltip: function () {
		if (this.tooltip != null) {
			this.tooltip.remove();
			this.tooltip = null;
		}
	}
});

PJQ.views.calendars.SystemCalendar = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'System-Calendar')
	},
	events: {
		'click .btn-add-task': 'addTaskClicked',
		'click .btn-add-milestone': 'addMilestoneClicked',
		'click .btn-export': 'exportCalendar',
		'click .btn-calendar-settings': 'editSettings'
	},
	beforeFirstRender: function () {
		PJQ.app.session.fetchProjectCustomFields(null, _.bind(function (customFields) {
			this.projectCustomFields = customFields;
			PJQ.app.session.fetchScheduleStatuses(_.bind(function (statuses) {
				this.taskStatuses = statuses;
				PJQ.app.session.fetchCalendarSettings(_.bind(function (stResult) {
					this.settings = stResult;
					this.render();
				}, this));
			}, this));
		}, this));
	},
	renderData: function () {
		return {
			settings: this.settings
		};
	},
	afterRender: function () {
		if (this.settings != null) {
			this.calendar = new PJQ.views.calendars.FullCalendar({
				el: this.$('.system-calendar'),
				fetchTasks: _.bind(this.fetchTasks, this),
				onTaskEdit: _.bind(function (task) {
					this.editTask(task);
				}, this),
				onTaskDelete: _.bind(function (task) {
					this.deleteTaskClicked(task);
				}, this),
				canDelete: false
			});
		}
	},
	fetchTasks: function (filter, callback) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'calendar'
			}
		], [
			{
				parameter: 'start',
				value: PJQ.helpers.dateHelpers.getDateString(new Date(filter.start), 'yyyy-MM-dd')
			},
			{
				parameter: 'finish',
				value: PJQ.helpers.dateHelpers.getDateString(new Date(filter.end), 'yyyy-MM-dd')
			},
			{
				parameter: 'bidsDue',
				value: this.settings.get('bidsDueFilter')
			},
			{
				parameter: 'startFinish',
				value: this.settings.get('startFinishFilter')
			},
			{
				parameter: 'tasks',
				value: this.settings.get('scheduleTasksFilter')
			},
			{
				parameter: 'cfProjects',
				value: this.settings.get('customFieldProjectsFilter')
			},
			{
				parameter: 'cfFilter',
				value: this.settings.get('customFieldIdsFilter')
			},
			{
				parameter: 'cfDisplay',
				value: this.settings.get('customFieldIdsDisplay')
			},
			{
				parameter: 'statusFilter',
				value: this.settings.get('projectStatusFilter')
			}
		]);

		new PJQ.ajax.Request({
			endpoint: endpoint
		}).get().done(_.bind(function (response) {
			this.collection = new PJQ.collections.calendars.CalendarTasks();

			let sysTasks = new PJQ.collections.schedule.Tasks(response.tasks);
			_.each(sysTasks.models, function (sysTask) {
				let status = this.taskStatuses.get(sysTask.get('statusId'));
				if (status == null) {
					status = this.taskStatuses.getDefault();
				}
				sysTask.status = status;

				let calTask = sysTask.getCalendarTask(),
					taskName = sysTask.get('userId') > 0 ? sysTask.get('name') : sysTask.get('name') + ' - ' + sysTask.get('projectName');
				calTask.set('title', taskName);
				this.collection.add(calTask);
			}, this);

			_.each(response.events, function (task) {
				let taskName = task.name + ' - ' + task.projectName;
				if (_.size(this.settings.get('customFieldIdsDisplay')) > 0) {
					_.each(this.settings.get('customFieldIdsDisplay'), function (cfId) {
						let cfValueMatch = _.find(task.customFields, function (cf) {
							return cf.id === cfId;
						});
						if (cfValueMatch != null) {
							let cfMatch = this.projectCustomFields.get(cfId);
							if (cfMatch != null) {
								let cfValue = '';
								if (cfMatch.get('fieldType') === 'DATE') {
									if (_.size(cfValueMatch.value) > 0) {
										cfValue = PJQ.helpers.dateHelpers.getDateString(new Date(cfValueMatch.value), 'MM-dd-yyyy', true);
									}
									else {
										cfValue = 'Not set';
									}

									taskName += '<br /><strong>' + cfMatch.get('fieldName') + "</strong>: " + cfValue;
								}
								else if (cfMatch.get('fieldType') === 'DATETIME') {
									if (_.size(cfValueMatch.value) > 0) {
										cfValue = PJQ.helpers.dateHelpers.getDateString(new Date(cfValueMatch.value), 'MM-dd-yyyy hh:mm:ss');
									}
									else {
										cfValue = 'Not set';
									}

									taskName += '<br /><strong>' + cfMatch.get('fieldName') + "</strong>: " + cfValue;
								}
								else {
									if (_.size(cfValueMatch.value) > 0) {
										cfValue = cfValueMatch.value;
									}
									taskName += '<br /><strong>' + cfMatch.get('fieldName') + "</strong>: " + cfValue;
								}
							}
						}
					}, this);
				}

				let finish = PJQ.helpers.dateHelpers.parseDateString(task.finish ? task.finish : task.start, !task.isAllDay),
					event = new PJQ.models.calendars.CalendarTask({
						id: -_.uniqueId(),
						name: task.name,
						projectId: task.projectId,
						projectName: task.projectName,
						title: taskName,
						start: PJQ.helpers.dateHelpers.parseDateString(task.start, !task.isAllDay),
						finish: task.finish ? finish : null,
						end: finish,
						allDay: task.isAllDay,
						isAllDay: task.isAllDay,
						backgroundColor: task.color != null ? task.color + ' !important' : '#5E35B1 !important',
						borderColor: task.color != null ? task.color + ' !important' : '#5E35B1 !important'
					});
				this.collection.add(event);
			}, this);
			callback(this.collection);
		}, this));
	},
	addTaskClicked: function () {
		let newTask = new PJQ.models.schedule.Task({
			name: "",
			duration: 1,
			start: null,
			finish: null,
			weekendWork: false,
			isAllDay: true,
			isMilestone: false,
			percentComplete: 0,
			notes: "",
			status: this.taskStatuses.getDefault()
		});
		this.editTask(newTask);
	},
	addMilestoneClicked: function () {
		let newTask = new PJQ.models.schedule.Task({
			name: "",
			duration: 1,
			start: null,
			finish: null,
			weekendWork: false,
			isAllDay: true,
			isMilestone: true,
			percentComplete: 0,
			notes: "",
			status: this.taskStatuses.getDefault()
		});
		this.editTask(newTask);
	},
	editTask: function (task) {
		if (task.id > 0 || task.isNew()) {
			// if this is a new task, global calendar task, or project task in the context of a project schedule then we can edit it here
			if (this.model != null || task.isNew() || task.get('projectId') == null) {
				if (!task.isNew()) {
					task.fetch({
						success: _.bind(function () {
							new PJQ.views.schedule.EditTaskModal({
								schedule: this.model,
								model: task,
								statuses: this.taskStatuses,
								onSave: _.bind(function () {
									this.render()
								}, this),
								onDelete: _.bind(function () {
									this.deleteTask(task);
								}, this)
							});
						}, this)
					})
				}
				else {
					new PJQ.views.schedule.EditTaskModal({
						schedule: this.model,
						model: task,
						statuses: this.taskStatuses,
						onSave: _.bind(function (task) {
							this.render();
						}, this),
						onDelete: _.bind(function () {
							this.deleteTask(task);
						}, this)
					});
				}
			}
			else {
				PJQ.app.router.navigate('projects/' + task.get('projectId').toString() + '/schedule/' + task.id.toString(), {
					trigger: true
				});
			}
		}
		else {
			PJQ.app.router.navigate('projects/' + task.get('projectId').toString(), {
				trigger: true
			});
		}
	},
	deleteTaskClicked: function (task) {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this task?",
			onDelete: _.bind(function () {
				this.deleteTask(task);
			}, this)
		});
	},
	deleteTask: function (task) {
		this.collection.remove(task);
		task.destroy({
			success: _.bind(function () {
				this.render()
			}, this)
		});
	},
	exportCalendar: function () {
		let loader = new PJQ.Loader(this.$('.btn-export'), {
			type: 'button',
			loadingText: 'Exporting'
		});
		new PJQ.models.reporting.Report({
			name: 'system-calendar',
			fileName: 'Calendar'
		}).generate({
			html: this.calendar.$el.find('.calendar-outer').outerHTML()
		}, function () {
			loader.remove();
		});
	},
	editSettings: function () {
		new PJQ.views.calendars.CalendarSettingsModal({
			model: this.settings,
			onSave: _.bind(function () {
				this.render();
			}, this)
		});
	}
});

PJQ.views.calendars.CalendarSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Calendar-Settings'),
		onSave: null
	},
	events: {
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		let fnFetch = _.bind(function () {
			PJQ.app.session.fetchProjectCustomFields(null, _.bind(function (cfs) {
				this.customFields = cfs
				PJQ.app.session.fetchProjectStatuses(_.bind(function (statuses) {
					this.projectStatuses = statuses;
					this.render();
				}, this));
			}, this));
		}, this);
		if (this.model == null) {
			PJQ.app.session.fetchCalendarSettings(_.bind(function (settings) {
				this.model = settings;
				fnFetch();
			}, this));
		}
		else {
			fnFetch();
		}
	},
	renderData: function () {
		return {
			projectStatuses: this.projectStatuses,
			customFields: _.filter(this.customFields.models, function (cf) {
				let fieldType = cf.get('fieldType').toUpperCase();
				return fieldType === 'TEXT' || fieldType === 'INT';
			}),
			dateCustomFields: _.filter(this.customFields.models, function (cf) {
				let fieldType = cf.get('fieldType').toUpperCase();
				return fieldType === 'DATE' || fieldType === 'DATETIME';
			})
		}
	},
	afterRender: function () {
		if (typeof this.customFields !== 'undefined') {
			new PJQ.inputs.Selectpicker({
				el: this.$('.bids-due-filter'),
				defaultValue: this.model.get('bidsDueFilter'),
				onChange: _.bind(function (value) {
					this.model.set('bidsDueFilter', value);
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.start-finish-filter'),
				defaultValue: this.model.get('startFinishFilter'),
				onChange: _.bind(function (value) {
					this.model.set('startFinishFilter', value);
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.project-tasks-filter'),
				isMultiple: true,
				defaultValue: this.model.get('scheduleTasksFilter'),
				onChange: _.bind(function (value) {
					this.model.set('scheduleTasksFilter', value);
				}, this)
			});

			if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_STATUS_ID)) {
				new PJQ.inputs.Selectpicker({
					el: this.$('.project-status-filter'),
					defaultValue: this.model.get('projectStatusFilter'),
					isMultiple: true,
					onChange: _.bind(function (value) {
						this.model.set('projectStatusFilter', value);
					}, this)
				});
			}

			let defaultVal = {
				projects: this.model.get('customFieldProjectsFilter'),
				fields: this.model.get('customFieldIdsFilter')
			};
			new PJQ.inputs.Selectpicker({
				el: this.$('.custom-fields-filter'),
				defaultValue: defaultVal,
				isGrouped: true,
				onChange: _.bind(function (value) {
					this.model.set('customFieldIdsFilter', value.fields ? value.fields : null);
					this.model.set('customFieldProjectsFilter', value.projects ? value.projects : 'NONE');
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.custom-fields-display'),
				defaultValue: this.model.get('customFieldIdsDisplay'),
				isMultiple: true,
				onChange: _.bind(function (value) {
					this.model.set('customFieldIdsDisplay', value);
				}, this)
			});
		}
	},
	save: function () {
		if (this.model.hasChanged()) {
			this.model.save(null, {
				success: _.bind(function () {
					PJQ.notifications.notify.successNotify({
						message: 'Calendar settings saved'
					});
					if (typeof this.options.onSave === 'function') {
						this.options.onSave(this.model);
					}
					this.removeModal();
				}, this)
			});
		}
		else {
			this.removeModal();
		}
	}
});


PJQ.models.calendars = {};
PJQ.models.calendars.CalendarSettings = PJQ.models.BaseModel.extend({
	idAttribute: 'userId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'calendar'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

PJQ.models.calendars.CalendarTask = PJQ.models.BaseModel.extend({
	parse: function (model) {
		if (model.model != null) {
			this.model = model.model;
		}

		return model;
	}
});

PJQ.collections.calendars = {};
PJQ.collections.calendars.CalendarTasks = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.calendars.CalendarTask
});

PJQ.charts = {
    colors: {
        RED_80: 'rgba(255, 99, 132, 0.8)',
        BLUE_80: 'rgba(54, 162, 235, 0.8)',
        YELLOW_80: 'rgba(255, 206, 86, 0.8)',
        GREEN_80: 'rgba(75, 192, 192, 0.8)'
    }
};

PJQ.charts.Chart = class {
    constructor($el, options = {}) {
        this.$outer = $el;
        this.$outer.addClass('chart-outer');
        this.options = _.defaults(options, {
            width: null,
            height: null,
            showTotal: false,
            onClick: _.noop
        });
        this.renderChart();
    }

    renderChart() {
        if (_.size(this.$el) > 0) {
            this.$el.remove();
        }
        if (this.options.width && this.options.height) {
            this.options.options = _.defaults({
                maintainAspectRatio: false
            }, this.options.options ? this.options.options : {});
        }
        this.$el = $('<canvas>', {
            height: this.options.height,
            width: this.options.width,
            style: 'z-index:100 !important;',
        });
        this.$outer.append(this.$el);

        if (this.options.type.toLowerCase() === 'doughnut' && this.options.showTotal) {
            let total = this.options.total;
            if (isNaN(total)) {
                total = _.reduce(this.options.data.datasets[0].data, function (memo, num) {
                    return num + memo;
                }, 0)
            }
            this.$outer.append($('<span />', {
                class: 'chart-total text-align-center fs-40 wd-50 font-weight-light p-absolute left-25',
                style: 'z-index:1 !important;top:' + (this.options.height / 3).toString() + 'px;',
                text: total
            }));
        }

        this.chart = new Chart(this.$el, this.options);

        if (this.options.onClick != null) {
            this.$el.on('click', _.bind(function (e) {
                this.options.onClick(this.chart.getElementsAtEvent(e));
            }, this));
        }
    }
};

PJQ.views.charts = {};
PJQ.views.charts.dhtmlxGantt = PJQ.views.BaseView.extend({
    defaults: {
        enableSorting: false,
        sortField: "sortOrder",
        sortAsc: false,
        onSort: null,
        isShowCriticalPath: false
    },
    events: {
        'click .grid-toggle': 'toggleGrid'
    },
    beforeFirstRender: function () {
        this.collection = this.options.schedule.tasks;
        // Order by id by default
        this.currentSort = {
            field: this.options.sortField != null ? this.options.sortField : 'sortOrder',
            asc: this.options.sortAsc != null ? this.options.sortAsc : false
        };
    },
    afterRender: function () {
        this.initChart();
        this.renderContextMenu();
    },
    getDataObject: function () {
        let result = {
                tasks: [],
                links: [],
                minStartDate: null,
                maxStartDate: null,
                maxEndDate: null,
                hasTaskNearToday: false
            },
            rangeStart = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
            rangeEnd = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), 7);
        _.each(this.collection.models, function (task) {
            let start = null;
            if (task.get('start') != null) {
                start = new Date(task.get('start'));
                if (result.minStartDate == null || start < result.minStartDate) {
                    result.minStartDate = start;
                }
                if (result.maxStartDate == null || start > result.maxStartDate) {
                    result.maxStartDate = start;
                }
            }

            let end = null;
            if (task.get('finish') != null) {
                end = new Date(task.get('finish'));
                if (result.maxEndDate == null || end > result.maxEndDate) {
                    result.maxEndDate = end;
                }
            }

            result.hasTaskNearToday = result.hasTaskNearToday
                || (start != null && end != null && PJQ.helpers.dateHelpers.checkDateRangesOverlap(rangeStart, rangeEnd, start, end))
                || (start != null && PJQ.helpers.dateHelpers.checkDateBetweenDays(rangeStart, rangeEnd, start))
                || (end != null && PJQ.helpers.dateHelpers.checkDateBetweenDays(rangeStart, rangeEnd, end));

            if (task instanceof PJQ.models.schedule.Task) {
                let color = task.get('isMilestone') ? '#43A047' : task.status ? task.status.get('color') : '#0b7bc1'
                let taskObj = {
                    text: task.get('name'),
                    start_date: task.get('start') ? task.get('start') : result.maxStartDate,
                    duration: task.get('isMilestone') ? 1 : task.get('duration'),
                    id: task.get('taskId'),
                    type: task.get('isMilestone') ? 'milestone' : (task.get('isSummaryTask') ? 'project' : 'task'),
                    progress: (task.get('percentComplete') / 100),
                    parent: task.get('summaryTaskId') && task.get('summaryTaskId') !== task.get('taskId') ? task.get('summaryTaskId') : task.get('parentTaskId'),
                    calendar_id: task.get('weekendWork') ? "weekend_work" : null,
                    details: task.get('notes'),
                    bar_height: task.get('isSummaryTask') ? 18 : null,
                    unscheduled: task.get('start') == null && !task.get('isSummaryTask'),
                    color: color,
                    textColor: PJQ.helpers.colorHelpers.idealLinkColorForBackground(color),
                    listTextColor: color,
                    sortOrder: task.get('sortOrder')
                }
                result.tasks.push(taskObj);
            }
        }, this);

        _.each(this.options.schedule.dependencies.models, function (dependency) {
            if (!dependency.get('isDeleted')) {
                let linkObj = {
                    id: dependency.get('dependencyId'),
                    target: dependency.get('taskId'),
                    source: dependency.get('dependTaskId'),
                    type: Object.keys(PJQ.constants.schedule.linkTypes).find(key => PJQ.constants.schedule.linkTypes[key] === dependency.get('type')),
                    lag: dependency.get('offset')
                }

                result.links.push(linkObj);
            }
        }, this);

        return result;
    },
    startInlineEdit: function (taskId, column = 'text') {
        if (!(taskId > 0)) {
            return;
        }

        this.gantt.ext.inlineEditors.startEdit(taskId, column ?? 'text');
    },
    initChart: function () {
        if (this.gantt) {
            this.gantt.destructor();
        }

        let gantt = Gantt.getGanttInstance();
        this.gantt = gantt;

        // Clear all tasks to prevent persistence between projects
        gantt.clearAll();

        gantt.templates.scale_cell_class = (date) => {


            if (date.getDay() === 0 || date.getDay() === 6) {
                return "weekend-highlight";
            }
        };
        gantt.templates.timeline_cell_class = (task, date) => {
            // let taskModel = this.collection.get(task.id);
            // if (taskModel != null && taskModel.get('weekendWork')) {
            //     return;
            // }

            if (date.getDay() === 0 || date.getDay() === 6) {
                return "weekend-highlight";
            }
        };

        // Expand chart date range when task is changed
        gantt.config.fit_tasks = true;

        // Make skin broadway. Default is set to terrace
        gantt.skin = "broadway";

        // Make Gantt change tasks that fall on weekend
        gantt.config.work_time = true;
        gantt.config.correct_work_time = true;

        // Add calendar to Make Gantt respect weekendWork
        gantt.addCalendar({
            id: "weekend_work",
            worktime: {
                days: [1, 1, 1, 1, 1, 1, 1]
            }
        });

        // Define custom editors
        // Date Editor
        let self = this;
        gantt.config.editor_types.dateEditor = {
            show: function (id, column, config, placeholder) {
                placeholder.innerHTML = '<div class="input-group"><input type="text" class="form-control input-date date-editor-input fs-13"></div>';
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);
                self.showDate(taskModel.get('start'));

                this.datePicker = new PJQ.inputs.Datepicker({
                    el: self.$('.date-editor-input'),
                    canEdit: true,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.ALT_DATE,
                        defaultDate: taskModel.get('start') ? taskModel.get('start') : new Date(),
                        minDate: column.name === 'end_date' ? taskModel.get('start') : taskModel.getMinStart(),
                        widgetPositioning: {
                            horizontal: column.name === 'start_date' ? 'left' : 'right'
                        }
                    },
                    onChange: function (value) {
                        if (column.name === 'start_date') {
                            self.gantt.ext.inlineEditors.startEdit(taskModel.get('taskId'), 'end_date');
                        }
                    }
                });
            },
            hide: function (a) {
                this.datePicker.remove();
            },
            set_value: function (value, id, column, node) {
                let taskModel = self.collection.get(value.id);
                let date = new Date(taskModel && taskModel.get('start') ? taskModel.get('start') : value.start_date);
                if (column.name === 'end_date') {
                    date = new Date(taskModel && taskModel.get('finish') ? taskModel.get('finish') : value.end_date - 1);
                }
                date.setHours(0, 0, 0, 0);

                this.datePicker.setValue(date);
            },
            get_value: function (id, column, node) {
                return this.datePicker.getValue();
            },
            is_changed: function (value, id, column, node) {
                let d1 = new Date(column.name === 'start_date' ? value.start_date : value.end_date - 1),
                    d2 = new Date(this.datePicker.getValue());

                d1.setHours(0, 0, 0, 0);
                d2.setHours(0, 0, 0, 0);

                return d1.getTime() !== d2.getTime() || (value.unscheduled && this.datePicker.getValue() != null);
            },
            is_valid: function (value, id, column, node) {
                return value !== null
            },
            save: function (id, column, node) {
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);

                if (column.name === 'start_date') {
                    task.start_date = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(this.datePicker.getValue()), 1, !taskModel.get('weekendWork'), true);
                    task.end_date = PJQ.helpers.dateHelpers.getNewDateAddDays(task.start_date, task.duration > 0 ? task.duration : 1, !taskModel.get('weekendWork'), true);
                } else {
                    let duration = PJQ.helpers.dateHelpers.getDateDaysDiff(this.datePicker.getValue(), task.start_date, !taskModel.get('weekendWork'), true);
                    task.end_date = PJQ.helpers.dateHelpers.getNewDateAddDays(task.start_date, duration > 0 ? duration : 1, !taskModel.get('weekendWork'), true);
                }

                if (typeof self.options.onTaskMoved === 'function') {
                    self.options.onTaskMoved(taskModel, task, column.name, true);
                }
                if (self.currentSort) {
                    self.sort();
                }
            },
            focus: function (node) {
                let input = self.getInput(node);

                if (!input) {
                    return;
                }
                if (input.focus) {
                    input.focus();
                }

                if (input.select) {
                    input.select();
                }
            }
        }

        //Duration Editor
        gantt.config.editor_types.durationEditor = {
            show: function (id, column, config, placeholder) {
                let task = self.getTask(id);
                self.showDate(task.start_date);

                placeholder.innerHTML = '<input type="number" class="form-control number-editor-input fs-13">';
            },
            set_value: function (value, id, column, node) {
                let input = self.getInput(node)
                if (input) {
                    input.value = value.duration;
                }
            },
            get_value: function (id, column, node) {
                let input = self.getInput(node)
                if (input) {
                    return input.value || 0;
                }
            },
            is_changed: function (value, id, column, node) {
                let currentValue = this.get_value(id, column, node);
                return Number(value.duration) !== Number(currentValue);
            },
            is_valid: function (value, id, column, node) {
                return !isNaN(parseInt(value)) && value > 0;
            },
            save: function (id, column, node) {
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);

                task.duration = parseInt(this.get_value(id, column, node));
                task.end_date = PJQ.helpers.dateHelpers.getNewDateAddDays(task.start_date, task.duration, !taskModel.get('weekendWork'), true);

                if (typeof self.options.onTaskMoved === 'function') {
                    self.options.onTaskMoved(taskModel, task, column.name, true);
                }
                if (self.currentSort) {
                    self.sort();
                }
            },
            focus: function (node) {
                let input = self.getInput(node);

                if (!input) {
                    return;
                }
                if (input.focus) {
                    input.focus();
                }

                if (input.select) {
                    input.select();
                }
            }
        }

        //Name Editor
        gantt.config.editor_types.nameEditor = {
            show: function (id, column, config, placeholder) {
                let task = self.getTask(id);
                self.showDate(task.start_date);
                placeholder.innerHTML = '<input type="text" class="form-control name-editor-input fs-13">';
            },
            hide: function () {
            },
            set_value: function (value, id, column, node) {
                self.getInput(node).value = value.text;
            },
            get_value: function (id, column, node) {
                return self.getInput(node).value || '';
            },
            is_changed: function (value, id, column, node) {
                let currentValue = this.get_value(id, column, node);
                return value.text !== currentValue;
            },
            is_valid: function (value, id, column, node) {
                return value != null;
            },
            save: function (id, column, node) {
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);

                task.text = this.get_value(id, column, node);

                if (typeof self.options.onTaskMoved === 'function') {
                    self.options.onTaskMoved(taskModel, task, column.name);
                }
                if (self.currentSort) {
                    self.sort();
                }
            },
            focus: function (node) {
                let input = self.getInput(node);

                if (!input) {
                    return;
                }
                if (input.focus) {
                    input.focus();
                }

                if (input.select) {
                    input.select();
                }
            }
        }

        let formatter = gantt.ext.formatters.durationFormatter({
            enter: "day",
            store: "day",
            format: "auto"
        });
        let linksFormatter = gantt.ext.formatters.linkFormatter({durationFormatter: formatter});

        let dateEditor = {
                type: "dateEditor",
                map_to: "auto"
            },
            durationEditor = {
                type: "durationEditor",
                map_to: "auto"
            },
            nameEditor = {
                type: "nameEditor",
                map_to: "auto"
            },
            predecessorEditor = {type: "predecessor", map_to: "auto", formatter: linksFormatter}

        // Change task list display
        gantt.config.columns = [
            {name: "wbs", label: "#", width: 40, template: gantt.getWBSCode, resize: true},
            {name: "text", label: "Name", tree: true, width: 200, resize: true, editor: nameEditor},
            {name: "start_date", label: "Start", width: 85, align: "center", resize: true, editor: dateEditor},
            {name: "end_date", label: "Finish", width: 85, align: "center", resize: true, editor: dateEditor},
            {
                name: "duration",
                label: "Duration",
                width: 75,
                align: "center",
                resize: true,
                editor: durationEditor,
                sort: false
            },
            {
                name: "predecessors", label: "WBS", width: 80, align: "left",
                editor: predecessorEditor, resize: true, template: function (task) {
                    let links = task.$target;
                    let labels = [];
                    for (let i = 0; i < links.length; i++) {
                        let link = gantt.getLink(links[i]);
                        labels.push(linksFormatter.format(link));
                    }
                    return labels.join(", ")
                }
            },
            {name: "add"}
        ];

        // Display text on task if it fits in the task, otherwise display to the right of the task
        gantt.templates.task_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task)) return " "
            else return task.text
        }, this);

        gantt.templates.rightside_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task) || task.type === 'milestone')
                return task.text;
        }, this);

        //Change open/closed folder icons for gantt tree
        gantt.templates.grid_folder = _.bind(function (item) {
            if (item.$open) {
                return '<div class="text-align-center"><i class="fad fa-folder-open ml-1 mr-1" style="margin-top: 50%;"></i></div>'
            } else {
                return '<div class="text-align-center"><i class="fad fa-folder-closed ml-1 mr-1" style="margin-top: 50%;"></i></div>'
            }
        }, this)

        gantt.templates.grid_row_class = _.bind(function (start, end, task) {
            if (task.type !== 'project') {
                return "normal_task"
            }
            return "";
        }, this);

        // Change icons for non-parent tasks on gantt tree - Changed to no icon
        gantt.templates.grid_file = _.bind(function (item) {
            if (item.unscheduled) {
                return '<div class="text-align-center"><i class="fad fa-exclamation-circle text-danger ml-1 mr-1 p-1" title="Unscheduled Task" style="margin-top: 25%;"></i></div>'
            } else if (item.type === 'milestone') {
                return '<div class="text-align-center"><i class="fad fa-flag text-success ml-1 mr-1 p-1" title="Milestone" style="margin-top: 25%;"></i></div>'
            }
            return '<div class="text-align-center"><i class="fad fa-check ml-1 mr-1 p-1" style="margin-top: 25%;"></i></div>'
        }, this)

        // define class for summary tasks
        gantt.templates.task_class = (start, end, task) => {
            if (task.type === 'project') {
                return "summary-task-bar";
            }
        };

        // Resize Scales
        gantt.config.scale_height = 75;

        //Enable row drag and drop
        if (!this.options.enableSorting) {
            gantt.config.order_branch = true;
        }
        // gantt.config.order_branch_free = false;

        // The gantt will display 1 duration day as the next date, where we interpret it as the same date, e.g, 1 duration date to the gantt will display
        // Sept. 19, 2022 - Sept. 20, 2022. We interpret 1 duration day as Sept. 19, 2022 - Sept. 19, 2022
        gantt.templates.task_end_date = function (date, a) {
            return gantt.templates.task_date(new Date(date.valueOf() - 1));
        };

        // Expand all nested tasks initially
        gantt.config.open_tree_initially = true;

        //Set gantt to read only
        gantt.config.readonly = !this.options.canEdit || this.options.settings.get('lockSchedule');

        // addTaskLayer functions added to onGanttReady, so they are added every time the gantt is initialized
        gantt.attachEvent("onGanttReady", _.bind(function (field, direction, parent) {
            let sizeEl = document.querySelectorAll(".gantt_grid")[0],
                ganttContainer = document.querySelectorAll(".schedule-dashboard-view")[0],
                sizeElRect = sizeEl.getBoundingClientRect();

            this.gridCollapse = document.createElement("div");
            ganttContainer.append(this.gridCollapse);
            this.gridCollapse.innerHTML = '<i class="fas fa-caret-left" style="margin-top: 60%; margin-left: 35%"></i>'

            this.gridCollapse.classList.add('grid-toggle');
            this.gridCollapse.style.top = (sizeElRect.height / 2) + 'px';
            this.gridCollapse.style.left = sizeElRect.width + 'px';

            //Display Percent Complete on task bar
            gantt.addTaskLayer(function (task) {
                if (gantt.getState().drag_id == task.id && task.type !== 'milestone') {
                    let sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
                        el = document.createElement('div'),
                        progressAmount = Math.round(task.progress * 100)
                    el.className = 'progress_value';
                    el.innerHTML = progressAmount + "%";
                    el.style.left = sizes.left + (sizes.width / 3) + 'px';
                    el.style.top = sizes.top + 40 + 'px';
                    if (progressAmount === 100) {
                        el.style.backgroundColor = '#28a745'
                    } else if (progressAmount >= 60) {
                        el.style.backgroundColor = '#ffc107'
                    } else {
                        el.style.backgroundColor = '#dc3545'
                    }
                    return el;
                }
                return false;
            });

            // Summary Task left triangle
            gantt.addTaskLayer(function (task) {
                if (task.type === 'project') {
                    let sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
                        el = document.createElement('div')
                    el.className = 'summary-task-left';
                    el.style.left = sizes.left + 'px';
                    el.style.top = sizes.top + 22 + 'px';

                    return el;
                }
            });

            // Summary Task right triangle
            gantt.addTaskLayer(function (task) {
                if (task.type === 'project') {
                    let sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
                        el = document.createElement('div')
                    el.className = 'summary-task-right';
                    el.style.left = (sizes.left + sizes.width - 20) + 'px';
                    el.style.top = sizes.top + 22 + 'px';

                    return el;
                }
            });
        }, this));

        // Define date format
        let gridDateToStr = gantt.date.date_to_str("%m-%d-%Y");

        // Modify grid date format to fix display
        gantt.templates.date_grid = function (date, task, column) {
            if (task.unscheduled) {
                task.duration = 0;
                return '';
            } else if (column === "end_date" && task.type !== 'milestone') {
                return gridDateToStr(new Date(date.valueOf() - 1));
            } else {
                return gridDateToStr(date);
            }
        };

        // Enable critical path
        gantt.plugins({
            critical_path: true,
            marker: true
        });

        // Declare zoom scales
        let zoomConfig = {
            levels: [
                {
                    name: "day",
                    scale_height: 40,
                    min_column_width: 25,
                    scales: [
                        {
                            unit: "week",
                            format: function (date) {
                                let dateToStr = gantt.date.date_to_str("%d %M");
                                return dateToStr(date);
                            }
                        },
                        {
                            unit: "day",
                            step: 1,
                            format: function (date) {
                                let dateToStr = gantt.date.date_to_str("%D"),
                                    day = dateToStr(date),
                                    dayNum = date.getDay();
                                return (dayNum === 0 || dayNum === 4) ? day.substring(0, 2) : day[0];
                            },
                            css: function (date) {
                                if (date.getDay() === 0 || date.getDay() === 6) {
                                    return "weekend-highlight";
                                }
                                return "";
                            }
                        }
                    ]
                },
                {
                    name: "week",
                    scale_height: 35,
                    min_column_width: 100,
                    scales: [
                        {unit: "month", format: "%F %Y"},
                        {
                            unit: "week", step: 1, format: function (date) {
                                let dateToStr = gantt.date.date_to_str("%d"),
                                    endDate = gantt.date.add(date, 6, "day");
                                return dateToStr(date) + "-" + dateToStr(endDate);
                            }
                        }
                    ]
                },
                {
                    name: "month",
                    scale_height: 35,
                    min_column_width: 80,
                    scales: [
                        {unit: "year", format: "%Y"},
                        {unit: "month", format: "%M"}
                    ]
                },
                {
                    name: "quarter",
                    scale_height: 35,
                    min_column_width: 90,
                    scales: [
                        {unit: "year", format: "%Y"},
                        {
                            unit: "quarter", step: 1, format: function (date) {
                                return "Quarter " + (Math.floor((date.getMonth() / 3)) + 1)
                            }
                        }
                    ]
                },
                {
                    name: "year",
                    scale_height: 35,
                    min_column_width: 30,
                    scales: [
                        {unit: "year", step: 1, format: "%Y"}
                    ]
                }
            ],
            activeLevelIndex: 0
        };

        // initialize zoom
        gantt.ext.zoom.init(zoomConfig);

        // Allows sorting tasks on task bar
        gantt.config.sort = this.options.enableSorting;

        // Initialize Chart
        gantt.init(this.options.el[0]);

        // Parse tasks into gantt from existing data
        let ganttData = this.getDataObject();
        gantt.parse(ganttData);

        if (ganttData.hasTaskNearToday) {
            let pos = gantt.posFromDate(new Date());
            gantt.scrollTo(pos);
        } else if (ganttData.minStartDate != null) {
            let pos = gantt.posFromDate(ganttData.minStartDate);
            gantt.scrollTo(pos);
        }

        // Set default sort to start date
        if (this.currentSort) {
            this.sort();
        }

        this.attachEvents();
        this.renderTodayMarker();

        if (this.options.isShowCriticalPath) {
            this.toggleCriticalPath(this.options.isShowCriticalPath);
        }
    },
    renderTodayMarker: function () {
        if (this.isExporting) {
            if (this.todayMarkerId == null) {
                return;
            }

            this.gantt.deleteMarker(this.todayMarkerId);
            this.todayMarkerId = null;
        } else {
            if (this.todayMarkerId != null) {
                this.gantt.deleteMarker(this.todayMarkerId);
                this.todayMarkerId = null;
            }

            // Add today marker
            let dateToStr = this.gantt.date.date_to_str(gantt.config.task_date);
            this.todayMarkerId = this.gantt.addMarker({
                start_date: new Date(), //a Date object that sets the marker's date
                css: "today-marker", //a CSS class applied to the marker
                text: "Today",
                title: dateToStr(new Date())
            });
        }
    },
    checkTaskOverflow: function (task, dateText) {
        let task_width = this.gantt.getTaskPosition(task, task.start_date, task.end_date);

        let element = document.createElement('canvas'),
            context = element.getContext("2d"),
            task_element = document.getElementsByClassName("gantt_task_content")[0];
        if (task_element) {
            let task_font_family = getComputedStyle(task_element)['font-family'],
                task_font_size = getComputedStyle(task_element)['font-size'];
            context.font = task_font_size + ' ' + task_font_family;
        }
        let date_text_width = 0
        let task_text_width = context.measureText(task.text).width;
        if (dateText) {
            date_text_width = context.measureText(dateText).width;
        }
        if ((task_text_width + 60) > task_width.width || (date_text_width + 60) > task_width.width)
            return true;
    },
    renderForExport: function () {
        this.isExporting = true;

        this.gantt.templates.task_text = _.bind(function (start, end, task) {
            let dateString = PJQ.helpers.dateHelpers.getDateString(task.start_date, PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            if (task.type !== 'milestone') {
                dateString += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(task.end_date - 1), PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            }
            if (this.checkTaskOverflow(task, dateString)) return " "
            else return '<div style="position: absolute; top: -4px"><div style="height: 12px; line-height: 75%; margin-top: 7px">' + task.text + '</div> <div class="mb-1" style="height: 12px; line-height: 100%;">' + dateString + '</div></div>';
        }, this);

        this.gantt.templates.rightside_text = _.bind(function (start, end, task) {
            let dateString = PJQ.helpers.dateHelpers.getDateString(task.start_date, PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            if (task.type !== 'milestone') {
                dateString += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(task.end_date - 1), PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            }
            if (this.checkTaskOverflow(task, dateString) || task.type === 'milestone')
                return '<div><div style="height: 10px; line-height: 75%; margin-top: 7px">' + task.text + '</div> <div class="mb-1" style="height: 12px; line-height: 100%;">' + dateString + '</div></div>';
        }, this);

        this.renderTodayMarker();

        this.gantt.render();
    },
    renderForViewing: function () {
        this.isExporting = false;

        this.gantt.templates.task_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task)) return " "
            else return task.text
        }, this);

        this.gantt.templates.rightside_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task) || task.type === 'milestone')
                return task.text;
        }, this);

        this.renderTodayMarker();

        this.gantt.render();
    },
    toggleGrid: function () {
        this.gantt.config.show_grid = !this.gantt.config.show_grid;
        this.gantt.render();

        if (this.gantt.config.show_grid) {
            let sizeEl = document.querySelectorAll(".gantt_grid")[0],
                sizeElRect = sizeEl.getBoundingClientRect();
            this.gridCollapse.style.top = (sizeElRect.height / 2) + 'px';
            this.gridCollapse.style.left = sizeElRect.width + 'px';
            this.gridCollapse.innerHTML = '<i class="fas fa-caret-left" style="margin-top: 60%; margin-left: 35%"></i>'
        } else {
            let sizeEl = document.querySelectorAll(".gantt_container")[0],
                sizeElRect = sizeEl.getBoundingClientRect();
            this.gridCollapse.style.top = (sizeElRect.height / 2) + 'px';
            this.gridCollapse.style.left = 0 + 'px';
            this.gridCollapse.innerHTML = '<i class="fas fa-caret-right" style="margin-top: 60%; margin-left: 35%"></i>'
        }
    },
    attachEvents: function () {
        // Reopen the datePicker if scales are adjusted when editing the start_date
        this.gantt.attachEvent("onScaleAdjusted", _.bind(function () {
            let editorState = this.gantt.ext.inlineEditors.getState();
            if (editorState.columnName === 'end_date') {
                editorState.editor.datePicker.show();
            }
        }, this));

        this.gantt.attachEvent("onBeforeGanttRender", () => {
            let range = this.gantt.getSubtaskDates();
            if (range.start_date == null || range.end_date == null) {
                return;
            }

            if (this.isExporting) {
                this.gantt.config.start_date = this.gantt.calculateEndDate(range.start_date, -3, 'day');
                this.gantt.config.end_date = this.gantt.calculateEndDate(range.end_date, 5, 'day');
            } else {
                this.gantt.config.start_date = this.gantt.calculateEndDate(range.start_date, -30, 'day');
                this.gantt.config.end_date = this.gantt.calculateEndDate(range.end_date, 30, 'day');
            }
        });

        // Override the default dhtmlx modal for updating task
        this.gantt.attachEvent("onBeforeLightBox", _.bind(function (id) {
            id = parseInt(id);
            if (id != null && typeof this.options.onTaskEdit === 'function') {
                let taskModel = this.collection.get(id),
                    ganttTask = this.getTask(id);
                if (taskModel != null) {
                    // gantt.ext.quickInfo.hide();
                    this.options.onTaskEdit(taskModel);
                } else {
                    if (typeof this.options.onTaskAdd === 'function') {
                        let callback = _.bind(function (taskModel) {
                            this.gantt.ext.inlineEditors.startEdit(taskModel.get('taskId'), 'text');
                        }, this);
                        this.options.onTaskAdd(ganttTask, callback);
                    }
                }
            } else
                return true;
        }, this));

        // Change position of gridCollapse button when grid is resized
        this.gantt.attachEvent("onGridResizeEnd", _.bind(function (old_width, new_width) {
            this.gridCollapse.style.left = new_width + 'px';
            return true;
        }, this));

        // Disable editing on certain inline editors in certain cases
        this.gantt.ext.inlineEditors.attachEvent("onBeforeEditStart", _.bind(function (state) {
            let task = this.getTask(state.id);
            if (task && state.columnName === 'duration' && (task.unscheduled || task.type === 'project')) {
                return false;
            } else if (task && (state.columnName === 'start_date' || state.columnName === 'end_date') && task.type === 'project') {
                return false;
            } else if (task && state.columnName === 'start_date' && _.size(task.$target) > 0) {
                if ((PJQ.app.session.project && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)) ||
                    (PJQ.app.session.project == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED))) {
                    return false;
                }
            }
            return true;
        }, this));

        // Store the sort if it is changed
        this.gantt.attachEvent("onAfterSort", _.bind(function (field, direction, parent) {
            this.gantt.config.order_branch = false;
            if (field === 'wbs') {
                field = 'sortOrder';
                this.gantt.config.order_branch = true;
                this.gantt.clearAll();
                this.gantt.parse(this.getDataObject());
            }
            this.currentSort = {
                field: field,
                asc: direction
            };
            if (typeof this.options.onSort === 'function') {
                this.options.onSort(this.currentSort);
            }
            this.gantt.render();
        }, this));

        // Override dhtmlx gantt error with our own
        this.gantt.attachEvent("onError", _.bind(function (errorMessage) {
            PJQ.notifications.notify.errorNotify({
                message: errorMessage
            });
            return false;
        }, this));

        // Override dhtmlx gantt error with our own
        this.gantt.attachEvent("onTaskCreated", _.bind(function (task) {
            let callback = _.bind(function (taskModel) {
                this.gantt.showTask(taskModel.get('taskId'));
                this.gantt.ext.inlineEditors.startEdit(taskModel.get('taskId'), 'text');
            }, this);
            this.options.onTaskAdd(task, callback);
        }, this));

        // Handle task deletion through gantt
        this.gantt.attachEvent("onAfterTaskDelete", _.bind(function (id, item) {
            let taskModel = this.collection.get(id);
            if (typeof this.options.onTaskDelete === 'function') {
                this.options.onTaskDelete(taskModel);
            }
        }, this));

        // Handle on task dragging
        this.gantt.attachEvent("onTaskDrag", _.bind(function (id, mode, task, original, e) {
            let taskModel = this.collection.get(id);
            if (!taskModel) {
                return;
            }
            // Prevent dragging before the minimum start date
            if (task.start_date < taskModel.getMinStart()) {
                task.start_date = original.start_date;
                task.end_date = original.end_date;
            }

            //Prevent dragging on tasks with a predecessor && ASAP Constraints enabled
            if (mode === 'move' && _.size(task.$target) > 0 &&
                ((PJQ.app.session.project && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)) ||
                    (PJQ.app.session.project == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)))) {
                task.start_date = original.start_date;
                task.end_date = original.end_date;
            }
        }, this));

        this.gantt.attachEvent("onRowDragEnd", _.bind(function (id, target) {
            let task = this.getTask(id);
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'schedule'
                    },
                    {
                        endpoint: 'tasks',
                        value: task.id
                    },
                    {
                        endpoint: 'sort',
                        value: task.$local_index + 1
                    }
                ])
            }).put().done(_.bind(function () {
                let newSort = task.$local_index + 1,
                    oldSort = task.sortOrder;
                if (this.collection) {
                    let taskModel = this.collection.get(id),
                     summaryTaskId = taskModel.get('summaryTaskId'),
                        sorted = _.sortBy(_.filter(this.collection.models, (mod) => {
                            return (!(summaryTaskId > 0) && mod.get('summaryTaskId') == null) || mod.get('summaryTaskId') === summaryTaskId;
                        }), (mod) => {
                            let mSort = mod.get('sortOrder');
                            if (mod.id.toString() === id) {
                                return newSort;
                            } else if (oldSort > newSort && mSort >= newSort) {
                                return mSort + 1;
                            } else if (oldSort < newSort && mSort === newSort) {
                                return mSort - 1
                            } else if (oldSort < newSort && mSort > newSort) {
                                return mSort + 1;
                            }
                            return mSort;
                        });
                    _.each(sorted, (mod, i) => {
                        mod.set('sortOrder', i + 1);
                    });
                }
                task.sortOrder = newSort;
            }, this));
        }, this));

        // Disable dragging between summary tasks
        this.gantt.attachEvent("onBeforeRowDragEnd", _.bind(function (id, parent) {
            let task = this.getTask(id);
            return task.parent === parent;
        }, this));

        // Handle after task dragging
        this.gantt.attachEvent("onAfterTaskDrag", _.bind(function (id, mode, e) {
            let task = this.getTask(id),
                taskModel = this.collection.get(id);
            if (typeof this.options.onTaskMoved === 'function') {
                this.options.onTaskMoved(taskModel, task);
            }
            if (this.currentSort) {
                this.sort();
            }
        }, this));

        // Handle Dependency adding
        this.gantt.attachEvent("onAfterLinkAdd", _.bind(function (id, item) {
            let taskModel = this.collection.get(parseInt(item.target));
            if (typeof this.options.onDependencyAdd === 'function') {
                this.options.onDependencyAdd(taskModel, item);
            }
        }, this));

        // Handle Dependency deletion
        this.gantt.attachEvent("onAfterLinkDelete", _.bind(function (id, item) {
            let taskModel = this.collection.get(parseInt(item.target));
            if (typeof this.options.onDependencyAdd === 'function') {
                this.options.onDependencyDelete(taskModel, item);
            }
        }, this));
    },
    sort: function (override) {
        this.gantt.sort(override != null ? override : this.currentSort.field, this.currentSort.asc);
    },
    getTask: function (id) {
        return this.gantt.getTask(id);
    },
    getZoom: function () {
        return this.gantt.ext.zoom.getCurrentLevel();
    },
    zoomIn: function () {
        this.gantt.ext.zoom.zoomIn();
    },
    zoomOut: function () {
        this.gantt.ext.zoom.zoomOut();
    },
    getInput: function (node) {
        return node.querySelector("input");
    },
    showTask: function (id) {
        this.gantt.showTask(id);
    },
    showDate: function (date) {
        this.gantt.showDate(date);
    },
    updateLink: function (id) {
        this.gantt.updateLink(id);
    },
    renderContextMenu: function () {
        this.options.contextMenuOptions = {
            actions: [
                {
                    name: 'View Details',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.editTask(task);
                    }, this)
                },
                {
                    name: 'Add Sub-Task',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.addSubTaskClicked(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        return !this.options.settings.get('lockSchedule');
                    }, this)
                },
                {
                    name: 'Add to Summary Task',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.addToSummaryTaskClicked(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        return !this.options.settings.get('lockSchedule');
                    }, this)
                },
                {
                    name: 'Remove from Summary Task',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.removeSummaryTask(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        return task.get('summaryTaskId') > 0 && !this.options.settings.get('lockSchedule');
                    }, this)
                },
                {
                    name: 'Delete',
                    isDanger: true,
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.deleteTask(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        return !this.options.settings.get('lockSchedule');
                    }, this)
                }
            ]
        }
        this.contextMenu = new PJQ.menus.ContextMenu(_.defaults(this.options.contextMenuOptions, {
            el: this.$('.gantt_container'),
            selector: '.gantt_bar_task, .gantt_row_task, .gantt_bar_project, .gantt_row_project, .gantt_row_milestone, .gantt_bar_milestone',
            fetchElementData: _.bind(function (element) {
                return element
            }, this),
            onOpen: _.bind(function (row) {
            }, this),
            onClose: _.bind(function () {
                this.$('.context-row').removeClass('context-row');
            }, this)
        }));
    },
    editTask: function (task) {
        if (typeof this.options.onTaskEdit === 'function') {
            this.options.onTaskEdit(task);
        }
    },
    removeSummaryTask: function (task) {
        if (typeof this.options.onTaskUpdateSummary === 'function') {
            this.options.onTaskUpdateSummary(task, 0);
        }
    },
    addToSummaryTaskClicked: function (task) {
        new PJQ.views.charts.SummaryTaskModal({
            tasks: this.collection,
            task: task,
            project: this.options.project,
            schedule: this.options.schedule,
            onSave: _.bind(function (task, summaryTaskId, isNewTask = false) {
                if (typeof this.options.onTaskUpdateSummary === 'function') {
                    this.options.onTaskUpdateSummary(task, summaryTaskId, isNewTask);
                }
            }, this)
        });
    },
    addSubTaskClicked: function (task) {
        if (typeof this.options.onAddSubTask === 'function') {
            this.options.onAddSubTask(task);
        }
    },
    deleteTaskClicked: function (e) {
        let taskId = $(e.currentTarget).closest('.task-popup').data('taskId'),
            task = this.collection.get(taskId);
        this.deleteTask(task);
    },
    deleteTask: function (task) {
        if (typeof this.options.onTaskDelete === 'function') {
            this.options.onTaskDelete(task);
        }
    },
    addTask: function (taskModel, parentId) {
        let taskObj = {
            text: taskModel.get('name'),
            start_date: taskModel.get('start'),
            duration: taskModel.get('duration'),
            id: taskModel.get('taskId'),
            type: taskModel.get('isMilestone') ? 'milestone' : taskModel.get('isSummaryTask') ? 'project' : 'task',
            progress: (taskModel.get('percentComplete') / 100),
            parent: taskModel.get('summaryTaskId') ? taskModel.get('summaryTaskId') : taskModel.get('parentTaskId'),
            calendar_id: taskModel.get('weekendWork') ? "weekend_work" : null
        };

        this.gantt.addTask(taskObj);

        // Handle dependencies for new task
        _.each(taskModel.dependencies.models, function (dependency) {
            if (dependency.get('taskId') === taskModel.get('taskId')) {
                let linkObj = {
                    id: dependency.get('dependencyId'),
                    target: dependency.get('taskId'),
                    source: dependency.get('dependTaskId'),
                    type: dependency.get('type') === 'FS' ? "0" : "1",
                    lag: dependency.get('offset')
                }

                this.addLink(linkObj);
            }
        }, this);
    },
    addLink: function (linkObj) {
        this.gantt.addLink(linkObj);
    },
    toggleCriticalPath: function (bool) {
        this.gantt.config.highlight_critical_path = bool;
        this.gantt.render();
    },
    refreshTasks: function () {
        let scroll = this.gantt.getScrollState();
        this.gantt.clearAll();
        this.gantt.parse(this.getDataObject());
        if (this.currentSort) {
            this.sort();
        }
        this.gantt.scrollTo(scroll.x, scroll.y);
        this.renderTodayMarker();
    },
    updateTask: function (taskModel) {
        let task = this.gantt.getTask(taskModel.get('taskId')),
            // If start date is null we want to use the latest task start date. If there are no other tasks we just want to use today's date.
            hasTaskWithStartDate = _.find(this.collection.models, function (model) {
                return model.get('start') != null;
            }),
            maxStartDate = hasTaskWithStartDate ? new Date(Math.max(...this.collection.models.map(model => new Date(model.get('start'))))) : new Date();
        // Since we subtracted a day for the API, we have to add it back for the gantt to be correct.
        let endDate = new Date(taskModel.get('finish'));
        endDate = endDate.addDays(1);
        endDate.setHours(0, 0, 0, 0);
        task.start_date = taskModel.get('start') != null ? taskModel.get('start') : maxStartDate;
        task.end_date = endDate;
        task.duration = taskModel.get('duration');
        task.unscheduled = taskModel.get('start') == null || taskModel.get('finish') == null;

        this.gantt.updateTask(task.id);
    },
    exportToPDF: function (callback) {
        if (!this.gantt) {
            return;
        }

        let endpointString = "/schedule/export";

        if(!PJQ.app.session.project && this.options.shareKey){
            endpointString += "?shareKey=" + this.options.shareKey;
        }

        this.getCompanyLogoUrl(_.bind(function (logoURL) {
            this.renderForExport();
            setTimeout(() => {
                this.gantt.exportToPDF({
                    name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.pdf",
                    header: PJQ.app.session.project ? "<style>.weekend-highlight{background-color: #eee !important;}.chart-outer{position:relative}.gantt-container{height:100%!important;flex:1;display:flex;position:relative}.task-list-header{height:39px;width:600px;background-color:#fff;z-index:9999999}.task-list-task{height:50px;width:600px;text-align:left;align-content:start;font-size:16px;border-bottom:1px solid #eaeaea;transition:border-right-width 0.2s linear;&:hover{color:#156cb1!important;background:#f8f9fa!important;border-right-width:10px!important}}.task-list-div{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff;position:absolute;left:0;top:0}.task-list-fill{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff}.task-list-input{padding:.39rem .3rem!important;margin-top:0.6rem!important}.gantt{display:flex;.lower-text{font-size:15px!important;font-weight:300!important}.upper-text{font-size:16px!important;font-weight:500!important}.bar-label{font-size:14px!important;font-weight:500!important;&.big{font-weight:700!important;color:#343a40!important}}.today-highlight{fill:rgba(0,109,255,.35)!important;opacity:inherit!important}.weekend-highlight{fill:rgba(94,53,177,.1)!important;opacity:inherit!important}.row-line{stroke:#b6b6b6!important;stroke-width:.4!important}.tick{stroke:transparent!important;stroke-width:.4!important}}.gantt_qi_big_icon.icon_delete{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#dc3545;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #dc3545;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:10px;&:hover{color:#fff;background-color:#c82333;border-color:#bd2130;text-decoration:none}}.gantt_qi_big_icon.icon_edit{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#17a2b8;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #17a2b8;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:12px;min-width:50px;&:hover{color:#fff;background-color:#138496;border-color:#117a8b;text-decoration:none}}.icon_edit{background-image:none!important;width:0!important}.icon_delete{background-image:none!important;width:0!important}.progress_value{position:absolute;border-radius:5px;margin-top:-7px;height:20px;width:40px;color:#fff;z-index:99999;text-align:center}.summary-task-bar{background-color:#000!important;border:1px solid #000!important}.summary-task-bar .gantt_task_progress_wrapper .gantt_task_progress{border:1px solid #4f4f4f!important;background:#5a5a5a!important;box-shadow:none!important}.summary-task-left{position:absolute;border-top:20px solid #000;border-right:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.summary-task-right{position:absolute;border-top:20px solid #000;border-left:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.milestone-icon{position:absolute;z-index:99999;padding:3px;margin-left:-10px;margin-top:8px;pointer-events:none}.gantt_task_line.gantt_milestone{border-radius:50%}.gantt_critical_task{background-color:#e63030!important;border-color:#9d3a3a!important}.gantt_container{font-family:Roboto,sans-serif;font-weight:400}.gantt_row.odd,.gantt_task_row.odd,.gantt_row,.gantt_task_row{background:white!important;border-bottom:1px solid #e8e8e8!important}.gantt_grid_data{background:white!important}.gantt_task .gantt_task_scale .gantt_scale_cell{background-color:#FFFFFF!important}.gantt_grid_scale .gantt_grid_head_cell{border-left:none!important;border-right:none!important;background-color:#FFFFFF!important;color:#212529;font-size:12px!important}.gantt_task_scale{border-bottom:none!important}.gantt_scale_line{border-bottom:none;border-top:none!important}.gantt_scale_cell{font-size:12px!important;border-bottom:1px solid #b3b3b3}.today-marker{background-color:rgb(0 0 0 / 60%)}.normal_task .gantt_add{display:none} </style>" + (PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) != null ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) : "<div style='display: flex; font-size: 24px; background: #022c52; color: #FFFFFF; padding: 20px; font-family: sans-serif;'> <img src='" + logoURL + "' alt='Company Logo' style='margin-bottom: auto; max-width: 200px; margin-right:20px;'/> <div style='align-self: flex-end; margin-left:20px;'> <div style='font-weight: bold;'>" + PJQ.app.session.project.get('projectName') + "</div><div>" + PJQ.app.session.project.get('address1') + "</div><div>" + PJQ.app.session.project.get('city') + ", " + PJQ.app.session.project.get('state') + " " + PJQ.app.session.project.get('zip') + " </div></div></div>") : '',
                    raw: true,
                    server: PJQ.helpers.urlHelpers.buildApiUrl(endpointString, {
                        service: PJQ.constants.services.APIv2
                    })
                });

                this.renderForViewing();
                if (typeof callback === 'function') {
                    callback();
                }
            }, 1);
        }, this));
    },
    exportToExcel: function (callback) {
        if (!this.gantt) {
            return;
        }

        let endpointString = "/schedule/export";

        if(!PJQ.app.session.project && this.options.shareKey){
            endpointString += "?shareKey=" + this.options.shareKey;
        }

        this.getCompanyLogoUrl(_.bind(function (logoURL) {
            this.gantt.exportToExcel({
                name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.xlsx",
                visual: "base-colors",
                cellColors: true,
                date_format: "mmmm d, yyyy",
                project: PJQ.app.session.project,
                logoURL: logoURL ? logoURL : '',
                server: PJQ.helpers.urlHelpers.buildApiUrl(endpointString, {
                    service: PJQ.constants.services.APIv2
                })
            });
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    },
    exportToPNG: function (callback) {
        if (!this.gantt) {
            return;
        }
        let endpointString = "/schedule/export";

        if(!PJQ.app.session.project && this.options.shareKey){
            endpointString += "?shareKey=" + this.options.shareKey;
        }

        this.getCompanyLogoUrl(_.bind(function (logoURL) {
            this.renderForExport();
            this.gantt.exportToPNG({
                name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.png",
                header: PJQ.app.session.project ? "<style>.gantt_container{margin: 20px;}.chart-outer{position:relative}.gantt-container{height:100%!important;flex:1;display:flex;position:relative}.task-list-header{height:39px;width:600px;background-color:#fff;z-index:9999999}.task-list-task{height:50px;width:600px;text-align:left;align-content:start;font-size:16px;border-bottom:1px solid #eaeaea;transition:border-right-width 0.2s linear;&:hover{color:#156cb1!important;background:#f8f9fa!important;border-right-width:10px!important}}.task-list-div{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff;position:absolute;left:0;top:0}.task-list-fill{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff}.task-list-input{padding:.39rem .3rem!important;margin-top:0.6rem!important}.gantt{display:flex;.lower-text{font-size:15px!important;font-weight:300!important}.upper-text{font-size:16px!important;font-weight:500!important}.bar-label{font-size:14px!important;font-weight:500!important;&.big{font-weight:700!important;color:#343a40!important}}.today-highlight{fill:rgba(0,109,255,.35)!important;opacity:inherit!important}.weekend-highlight{fill:rgba(94,53,177,.1)!important;opacity:inherit!important}.row-line{stroke:#b6b6b6!important;stroke-width:.4!important}.tick{stroke:transparent!important;stroke-width:.4!important}}.gantt_qi_big_icon.icon_delete{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#dc3545;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #dc3545;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:10px;&:hover{color:#fff;background-color:#c82333;border-color:#bd2130;text-decoration:none}}.gantt_qi_big_icon.icon_edit{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#17a2b8;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #17a2b8;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:12px;min-width:50px;&:hover{color:#fff;background-color:#138496;border-color:#117a8b;text-decoration:none}}.icon_edit{background-image:none!important;width:0!important}.icon_delete{background-image:none!important;width:0!important}.progress_value{position:absolute;border-radius:5px;margin-top:-7px;height:20px;width:40px;color:#fff;z-index:99999;text-align:center}.summary-task-bar{background-color:#000!important;border:1px solid #000!important}.summary-task-bar .gantt_task_progress_wrapper .gantt_task_progress{border:1px solid #4f4f4f!important;background:#5a5a5a!important;box-shadow:none!important}.summary-task-left{position:absolute;border-top:20px solid #000;border-right:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.summary-task-right{position:absolute;border-top:20px solid #000;border-left:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.milestone-icon{position:absolute;z-index:99999;padding:3px;margin-left:-10px;margin-top:8px;pointer-events:none}.gantt_task_line.gantt_milestone{border-radius:50%}.gantt_critical_task{background-color:#e63030!important;border-color:#9d3a3a!important}.gantt_container{font-family:Roboto,sans-serif;font-weight:400}.gantt_row.odd,.gantt_task_row.odd,.gantt_row,.gantt_task_row{background:white!important;border-bottom:1px solid #e8e8e8!important}.gantt_grid_data{background:white!important}.gantt_task .gantt_task_scale .gantt_scale_cell{background-color:#FFFFFF!important}.gantt_grid_scale .gantt_grid_head_cell{border-left:none!important;border-right:none!important;background-color:#FFFFFF!important;color:#212529;font-size:12px!important}.gantt_task_scale{border-bottom:none!important}.gantt_scale_line{border-bottom:none;border-top:none!important}.gantt_scale_cell{font-size:12px!important;border-bottom:1px solid #b3b3b3}.today-marker{background-color:rgb(0 0 0 / 60%)}.normal_task .gantt_add{display:none}</style>" + (PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) != null ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) : "<div style='display: flex; font-size: 24px; background: #022c52; color: #FFFFFF; padding: 20px; font-family: sans-serif;'> <img src='" + logoURL + "' alt='Company Logo' style='margin-bottom: auto; margin-right:20px; max-width: 200px;'/> <div style='align-self: flex-end; margin-left:20px;'> <div style='font-weight: bold;'>" + PJQ.app.session.project.get('projectName') + "</div><div>" + PJQ.app.session.project.get('address1') + "</div><div>" + PJQ.app.session.project.get('city') + ", " + PJQ.app.session.project.get('state') + " " + PJQ.app.session.project.get('zip') + " </div></div></div>") : '',
                skin: 'broadway',
                raw: true,
                server: PJQ.helpers.urlHelpers.buildApiUrl(endpointString, {
                    service: PJQ.constants.services.APIv2
                })
            });
            this.renderForViewing();
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    },
    getCompanyLogoUrl: function (callback) {
        if (this.logoURL != null) {
            callback(this.logoURL);
            return;
        }

        if (PJQ.app.session.project?.get('masterUserId') > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users',
                        value: PJQ.app.session.project.get('masterUserId')
                    },
                    {
                        endpoint: 'logo'
                    }
                ])
            }).get().done(_.bind(function (response) {
                this.logoURL = response.url;
                callback(response.url);
            }, this));
        } else {
            callback(null);
        }
    },
    exportToPrimavera: function (callback) {
        this.gantt.exportToPrimaveraP6({
            name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.xer",
        });
        if (typeof callback === 'function') {
            callback();
        }
    },
    exportToMSProject: function (callback) {
        if (!this.gantt) {
            return;
        }

        let endpointString = "/schedule/export";

        if(!PJQ.app.session.project && this.options.shareKey){
            endpointString += "?shareKey=" + this.options.shareKey;
        }

        let customData = {
            "data": this.gantt.serialize().data,
            "links": this.gantt.getLinks()
        }

        this.gantt.exportToMSProject({
            name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.mpp",
            server: PJQ.helpers.urlHelpers.buildApiUrl(endpointString, {
                service: PJQ.constants.services.APIv2
            }),
            data: customData
        });
        if (typeof callback === 'function') {
            callback();
        }
    }
});

PJQ.views.charts.SummaryTaskModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'summary-task-modal'),
        width: '30%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-new-summary-task': 'newSummaryTaskClicked'
    },
    beforeRender: function () {
        this.existingTasks = _.filter(this.options.tasks.models, function (task) {
            let taskModel = task.get('model') ? task.get('model') : task;
            return taskModel.get('isSummaryTask')
        }, this);

        this.targetTask = this.options.task;
        this.renderData = {
            tasks: this.options.tasks.models,
            targetTask: this.targetTask
        };
    },
    afterRender: function () {
        let invalidTasks = this.getAllDescendantTaskIds();

        this.existingTaskPicker = new PJQ.inputs.Selectpicker({
            el: $('.select-existing-summary-task'),
            isLiveSearch: true,
            noneSelectedText: 'Select Existing Task',
            choices: _.map(_.filter(this.options.tasks.models, function (task) {
                return !_.contains(invalidTasks, task.get('taskId')) && task.get('taskId') !== this.targetTask.get('taskId') && task.get('taskId') !== this.targetTask.get('summaryTaskId');
            }, this), function (task) {
                return {
                    id: task.get('taskId'),
                    name: task.get('name')
                }
            }),
            onChange: _.bind(function (value) {
                let existingSummary = _.find(this.existingTasks, function (model) {
                    return model.id === parseInt(value);
                })
                if (this.warningAlert) {
                    this.warningAlert.destroy();
                }

                if (existingSummary == null) {
                    this.warningAlert = new PJQ.Alert(this.$('.summary-warning'), {
                        type: 'danger',
                        text: 'Selected task is not currently a summary task. Saving will cause selected task to convert into a summary task.'
                    });
                }
                this.summaryTaskId = value;
                this.$('.btn-save').prop('disabled', false);
            }, this)
        });
    },
    getAllDescendantTaskIds: function () {
        let descendants = [],
            findDescendants = _.bind(function (currentTaskId) {
                _.each(this.options.tasks.models, function (task) {
                    task = task.model ? task.model : task;
                    if (task.get('summaryTaskId') === currentTaskId) {
                        descendants.push(task.get('taskId'));
                        findDescendants(task.get('taskId'));
                    }
                });
            }, this);

        findDescendants(this.targetTask.get('taskId'));
        return descendants;
    },
    newSummaryTaskClicked: function () {
        let newTask = new PJQ.models.schedule.Task({
            projectId: this.targetTask ? this.targetTask.get('projectId') : null,
            templateId: this.targetTask ? this.targetTask.get('templateId') : null
        });
        this.newSummaryTask(newTask)
    },
    newSummaryTask: function (task) {
        new PJQ.views.schedule.EditTaskModal({
            project: this.options.project,
            schedule: this.options.schedule,
            isSummaryTask: true,
            model: task,
            onSave: _.bind(function () {
                task.save(null, {
                    success: _.bind(function (model) {
                        this.summaryTaskId = model.get('taskId');
                        this.options.onSave(model, null, true);
                        this.save()
                    }, this)
                })
            }, this),
            onClose: _.bind(function () {
                this.removeModal();
            }, this)
        });
    },
    save: function () {
        if (this.summaryTaskId != null) {
            this.options.onSave(this.targetTask, this.summaryTaskId)
            this.removeModal();
        }
    }
});

PJQ.views.charts.AssigneeListModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'assignee-list-modal'),
        subTemplates: {
            assignees: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'assignee-list'),
        },
        width: '30%',
        maxWidth: 700
    },
    events: {
        'click .btn-edit-assignee': 'editAssignee'
    },
    afterRender: function () {
        this.renderAssignees()
    },
    renderAssignees: function () {
        this.renderSubTemplate(false, this.options.subTemplates.assignees, this.$('.assignee-outer'), {
            assignees: this.options.assignees.models
        });
    },
    editAssignee: function (e) {
        let target = $(e.currentTarget).closest('.assignee-card'),
            cid = target.data('cid'),
            assignee = this.options.assignees.get(cid),
            model = new PJQ.models.contacts.Contact(assignee);

        new PJQ.views.contacts.BaseEditContactModal({
            model: model
        })
    }
});

PJQ.models.charts = {};
PJQ.models.charts.GanttTask = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (model.model != null) {
            this.model = model.model;
        }
        return model;
    }
});

PJQ.collections.charts = {};
PJQ.collections.charts.GanttTasks = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.charts.GanttTask
});

PJQ.views.collapse = {};
PJQ.views.collapse.BaseCollapse = PJQ.views.BaseView.extend({
	defaults: {
		onShown: null
	},
	events: {
		"shown.bs.collapse": "onShown",
		"hidden.bs.collapse": "renderChevrons",
		"show.bs.collapse": "renderChevrons",
		"hide.bs.collapse": "renderChevrons"
	},
	afterRender: function () {
		this.$el.collapse();
		this.renderChevrons();
	},
	onShown: function (e) {
		if (typeof this.options.onShown === 'function') {
			let id = e ? $(e.target).attr('id') : null;
			this.options.onShown(id);
		}
		this.renderChevrons();
	},
	renderChevrons: function () {
		this.$('.card-header[data-target]').each(function () {
			let chevron,
				header = $(this),
				target = header.data('target'),
				collapseContainer = $(target);
			header.css('position', 'relative');
			if (_.size(header.find('.chevron')) === 0) {
				chevron = $('<span />', {
					class: 'chevron fal fa-chevron-down position-absolute right-10p top-35 fs-20 text-dark'
				});
				header.append(chevron);
			}
			else {
				chevron = header.find('.chevron');
			}
			chevron.removeClass(collapseContainer.hasClass('show') ? 'fa-chevron-down' : 'fa-chevron-up');
			chevron.addClass(collapseContainer.hasClass('show') ? 'fa-chevron-up' : 'fa-chevron-down');
		});
	}
});

PJQ.colors = {};

PJQ.colors.ColorPicker = class {
	constructor($el, options = {}) {
		this.$el = $el;
		this.options = _.defaults(options, {
			format: 'auto'
		});
		this.initPicker();
	}

	initPicker() {
		this.$el.colorpicker(this.options).on('change', _.bind(function (e) {
			if (typeof this.options.onChange === 'function') {
				this.options.onChange(e.value);
			}
		}, this));
	}

	getColor() {
		return this.$el.colorpicker('getValue')
	}

	setColor(color) {
		return this.$el.colorpicker('setValue', color)
	}
};

PJQ.colors.SimpleColorPicker = class {
	constructor($el, options = {}) {
		this.colors = [
			{
				hex: PJQ.constants.colors.BLUE,
				name: 'Blue'
			},
			{
				hex: PJQ.constants.colors.PURPLE,
				name: 'Purple'
			},
			{
				hex: PJQ.constants.colors.PINK,
				name: 'Pink'
			},
			{
				hex: PJQ.constants.colors.RED,
				name: 'Red'
			},
			{
				hex: PJQ.constants.colors.ORANGE,
				name: 'Orange'
			},
			{
				hex: PJQ.constants.colors.YELLOW,
				name: 'Yellow'
			},
			{
				hex: PJQ.constants.colors.GREEN,
				name: 'Green'
			},
			{
				hex: PJQ.constants.colors.CYAN,
				name: 'Cyan'
			},
			{
				hex: PJQ.constants.colors.GRAY,
				name: 'Gray'
			},
			{
				hex: PJQ.constants.colors.BLACK,
				name: 'Black'
			}
		];

		this.$el = $el;
		this.$picker = null;
		this.color = options.color ? options.color : this.colors[0].hex;
		this.options = options;
		this.render();
	}

	setColor(color){
		this.color = color;
		this.render();
	}

	render() {
		let template = new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'color-picker');
		PJQ.templating.TemplateRenderer.renderTemplate(true, template, this.$el, {
			colors: this.colors,
			color: this.color
		}, _.bind(function ($el) {
			this.$picker = $el;
			$el.find('.color-item').on('click', _.bind(this.colorPicked, this));
		}, this));
	}

	toggle() {
		if (this.$picker) {
			if (this.$picker.hasClass('hidden')) {
				this.$picker.removeClass('hidden');
			}
			else {
				this.$picker.addClass('hidden');
			}
		}
	}

	show() {
		if (this.$picker) {
			this.$picker.removeClass('hidden');
		}
	}

	hide() {
		if (this.$picker) {
			this.$picker.addClass('hidden');
		}
	}

	colorPicked(e) {
		e.stopPropagation();
		this.color = $(e.currentTarget).data('color');
		if (typeof this.options.onColorPicked === 'function') {
			this.options.onColorPicked(this.color);
		}
		this.hide();
	}

	remove(e) {
		if (this.$picker && this.$picker.length > 0) {
			this.$picker.remove();
		}
	}
}
PJQ.views.comments = {};

PJQ.views.comments.CommentsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-add-comment'),
		onAddComment: null,
		onCancel: null
	},
	events: {
		'keyup .textarea-comment': 'commentChanged',
		'click .btn-add-comment': 'addComment'
	},
	commentChanged: function () {
		this.$('.btn-add-comment').prop('disabled', _.size(this.$('.textarea-comment').val()) === 0);
	},
	addComment: function () {
		if (typeof this.options.onAddComment === 'function') {
			this.options.onAddComment(this.$('.textarea-comment').val());
		}
		this.removeModal();
	}
});
PJQ.models.companies = {};

PJQ.models.companies.UserLimits = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'userlimits'
            }
        ]);
    }
});
PJQ.compression = {
	encode: {
		delta(values) {
			values = values.sort(function (a, b) {
				return a - b;
			});

			return values.reduce(function (state, value) {
				let diff = value - state.lastValue;
				state.encoded.push(isNaN(diff) ? value : diff);
				state.lastValue = value;
				return state;
			}, {
				encoded: []
			}).encoded;
		},
		runLength(values) {
			let len = _.size(values);
			return values.reduce(function (state, value, index) {
				//if this is the last value in array, we need to do things a bit differently
				if (index === len - 1) {
					if (state.lastValue !== value) {
						// if the last value doesn't match this one, add it to the result
						if (!isNaN(state.lastValue)) {
							state.encoded.push(state.multiple > 1 ? state.multiple.toString() + '_' + state.lastValue.toString() : state.lastValue.toString());
							state.multiple = 1;
						}
						state.encoded.push(value.toString());
					}
					else {
						state.multiple++;
						state.encoded.push(state.multiple.toString() + '_' + value.toString());
					}
				}
				else {
					if (state.lastValue === value) {
						// if the last value matches this one, just increment the counter
						state.multiple++;
					}
					else if (!isNaN(state.lastValue)) {
						// if the last value doesn't match this one AND this isn't the first iteration
						// add the multiple+lastValue or lastValue (if multiple === 1)
						state.encoded.push(state.multiple > 1 ? state.multiple.toString() + '_' + state.lastValue.toString() : state.lastValue.toString());
						state.multiple = 1;
					}
				}
				state.lastValue = value;
				return state;
			}, {
				encoded: [],
				multiple: 1
			}).encoded;
		}
	},
	decode: {}
};
PJQ.models.contacts = {};
PJQ.collections.contacts = {};
PJQ.views.contacts = {};

PJQ.helpers.contacts = {
    getContactAnchor: function (options = {}) {
        if (options.contact != null) {
            if (PJQ.helpers.objectHelpers.refinedType(options.contact, true) === 'backboneModel') {
                options.id = options.contact.get('id') != null ? options.contact.get('id') : options.contact.id;
                if (options.useCompanyName && options.contact.get('companyName') != null)
                    options.name = options.contact.get('companyName');
                else
                    options.name = options.contact.get('contactName');
            } else {
                options.id = options.contact.id;
                if (options.useCompanyName && options.contact.companyName != null)
                    options.name = options.contact.companyName;
                else
                    options.name = options.contact.contactName;
            }
        }

        if (_.size(options.name) == 0) {
            // options.name = '&lt;No Contact Name&gt;';
            options.name = '(No Contact Name)';
        }

        let canViewContacts = PJQ.app.session.hasPermission('contacts.canView');
        if (canViewContacts && PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
            canViewContacts = false;
        }

        if (options.id != null && options.id !== 0
            && ((PJQ.app.session.user != null && -options.id === PJQ.app.session.user.id)
                || canViewContacts
            )) {
            return `<a href="javascript:void(0)" class="font-weight-normal watch-contact-edit contact-name text-primary" data-contact-id="${options.id.toString()}">${options.name}</a>`;
        }

        return '<span>' + options.name + '</span>';
    }
};

//Models
PJQ.models.contacts.Company = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'companies',
                value: this.id
            }
        ])
    },
    beforeConstruct: function (attributes) {
        if (attributes && attributes.groups != null) {
            this.parseContactData(attributes);
        }
    },
    beforeInit: function () {
        this.on('change:userTypeId', function () {
            if (PJQ.app.session != null) {
                let userTypeId = this.get('userTypeId');
                if (userTypeId != null) {
                    this.userType = PJQ.app.session.userTypes.get(userTypeId);
                    if (this.userType === null) {
                        this.userType = PJQ.app.session.userTypes.getDefault(this.id < 0);
                    }
                } else {
                    this.userType = PJQ.app.session.userTypes.getDefault(this.id < 0);
                }
            }
        });
    },
    parse: function (model) {
        this.parseContactData(model);
        this.parseAttachmentData(model);
        return model;
    },
    parseContactData: function (model) {
        this.contacts = new PJQ.collections.contacts.Contacts(model ? model.contacts : null);
    },
    parseAttachmentData: function (model) {
        this.attachments = new PJQ.collections.files.Files(model ? model.attachments : null);
    },
    getGroups: function () {
        let result = [],
            ids = [];
        _.each(this.contacts.models, function (contact) {
            _.each(contact.groups.models, function (group) {
                if (ids.indexOf(group.id) === -1) {
                    ids.push(group.id);
                    result.push(group);
                }
            });
        });
        return result;
    },
    checkHasGroup: function (filter) {
        let result = false;
        _.each(this.contacts.models, function (contact) {
            result = result || contact.checkHasGroup(filter);
        });
        return result;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.getChangedModels()
        })
    },
    fetchERPObject: function (callback) {
        if (this.get('externalObject') == null && !this.externalObjectFetched) {
            this.externalObjectFetched = true;
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'contacts',
                        value: this.id
                    },
                    {
                        endpoint: 'erpobject'
                    }
                ]),
                isAPIv2: true
            }).get().done((data) => {
                if (data != null) {
                    this.set({
                        externalObject: data
                    }, {
                        silent: true
                    });
                }
                if (typeof callback === 'function') {
                    callback(this.get('externalObject'));
                }
            }).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            callback(this.get('externalObject'));
        }
    },
    erpSyncStatus: function (forCompany = false) {
        let exObj = this.get('externalObject');
        if (exObj != null) {
            let minModified = this.get('modifiedOn'),
                status = typeof exObj.status === 'number' ? exObj.status : 0;

            if (this.contacts != null) {
                minModified = _.min(_.union([minModified], _.map(this.contacts.models, function (contact) {
                    let mod = contact.get('modifiedOn');
                    return mod ? new Date(mod) : null;
                })))
            }

            if (status !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                && status !== PJQ.constants.integrations.erp.syncStatuses.APPROVED
                && minModified > new Date(exObj.lastSync)) {
                return PJQ.constants.integrations.erp.syncStatuses.STALE;
            }
            return status;
        }
        return 0;
    },
    unlinkERP: function (callback) {
        if (!this.id || this.id === 0) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: `/erp/vendors/${this.id}/unlink`,
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    }
});

PJQ.models.contacts.Contact = PJQ.models.contacts.Company.extend({
    defaults: {
        type: 'contact'
    },
    endpoint: function (options) {
        let params = [];
        if (options) {
            if (options.approve) {
                params.push({
                    parameter: 'approve',
                    value: true
                });
            }
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.id
            }
        ], params)
    },
    sendPasswordReset: function (callback) {
        PJQ.helpers.users.sendPasswordReset(this.get('username'), function (result) {
            if (typeof callback === 'function') {
                callback(result);
            }
        });
    },
    parseContactData: function (model) {
        if (model != null) {
            let isCompanyUser = (this instanceof PJQ.models.users.User || this.id < 0);
            if (PJQ.app.session != null) {
                if (model.userTypeId != null) {
                    this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
                }

                if (this.userType == null) {
                    if (isCompanyUser || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE)) {
                        this.userType = PJQ.app.session.userTypes.getDefault(isCompanyUser);

                        if (this.userType != null)
                            model.userTypeId = this.userType.id;

                    }
                }
            }

            if (model.user != null) {
                this.user = new PJQ.models.users.User(model.user);
            }

            if (this.approvals == null) {
                this.approvalUpdates = new PJQ.collections.contacts.ApprovalUpdates(model.approvalUpdates)
            }

            if (this.groups == null) {
                this.groups = new PJQ.collections.groups.Groups(model.groups, {
                    groupLevels: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
                });
            } else {
                //Override for groups being returned in a nested object
                //This is some old api stuff that will soon be deprecated
                //We will remove this when that happens
                if (model.groups != null) {
                    model.groups = model.groups;
                }
                this.groups.reset(_.size(model.groups) > 0 ? model.groups : null);
                this.groups.options.groupLevels = PJQ.app.session ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS) : 1;
            }

            if (this.workAreas) {
                this.workAreas.reset(model.workAreas);
            } else {
                this.workAreas = new PJQ.collections.workAreas.ContactWorkAreas(model.workAreas, {
                    contactId: model.id
                });
            }
        } else {
            let isCompanyUser = (this instanceof PJQ.models.users.User || this.id < 0);

            if (isCompanyUser || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE)) {
                this.userType = PJQ.app.session != null ? PJQ.app.session.userTypes.getDefault(isCompanyUser) : null;

            }

            this.groups = new PJQ.collections.groups.Groups();
            this.workAreas = new PJQ.collections.workAreas.ContactWorkAreas();
        }
    },
    fetchEditHistory: function (callback) {
        if (this.editHistory == null) {
            this.editHistory = new PJQ.collections.contacts.EditHistory(null, {
                contact: this
            })
        }

        this.editHistory.fetch({
            success: _.bind(function () {
                callback(this.editHistory);
            }, this)
        });
    },
    fetchCompanyERPObject: function (callback) {
        if (this.get('companyExternalObject') == null && !this.companyErpObjectFetched) {
            this.companyErpObjectFetched = true;
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'contacts',
                        value: this.get('contactCompanyId')
                    },
                    {
                        endpoint: 'erpobject'
                    }
                ]),
                isAPIv2: true
            }).get().done(_.bind(function (data) {
                if (data != null) {
                    this.set({
                        companyExternalObject: data
                    }, {
                        silent: true
                    });
                }
                if (typeof callback === 'function') {
                    callback(this.get('companyExternalObject'));
                }
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            callback(this.get('companyExternalObject'));
        }
    },
    externalId: function (forCompany = false) {
        let exObj;
        if (forCompany) {
            exObj = this.get('companyExternalObject');
        } else {
            exObj = this.get('externalObject');
        }
        return exObj != null && typeof exObj.externalId === 'string' ? exObj.externalId : null;
    },
    erpSyncStatus: function (forCompany = false) {
        let exObj;
        if (forCompany) {
            exObj = this.get('companyExternalObject');
        } else {
            exObj = this.get('externalObject');
        }
        if (exObj != null) {
            let status = typeof exObj.status === 'number' ? exObj.status : 0;
            if (status !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                && status !== PJQ.constants.integrations.erp.syncStatuses.APPROVED
                && new Date(this.get('modifiedOn')) > new Date(exObj.lastSync)) {
                return PJQ.constants.integrations.erp.syncStatuses.STALE;
            }
            return status;
        }
        return 0;
    },
    isERPSynced: function (forCompany = false) {
        return _.size(this.externalId(forCompany)) > 0;
    },
    fetchSystemPermissions: function (callback) {
        let perm;
        if (!this.isNew()) {
            perm = new PJQ.models.permissions.SystemPermissions({
                id: this.get('id')
            });
        } else {
            perm = new PJQ.models.permissions.SystemPermissions({
                userTypeId: this.userType != null ? this.userType.id : null
            });
        }
        perm.fetch({
            success: _.bind(function () {
                callback(perm);
            }, this)
        });
    },
    fetchProjectPermissions: function (projectId = null, callback) {
        let perm;
        if (!this.isNew()) {
            perm = new PJQ.models.permissions.ProjectPermissions({
                id: this.get('id'),
                projectId: projectId
            });
        } else {
            perm = new PJQ.models.permissions.ProjectPermissions({
                userTypeId: this.userType != null ? this.userType.id : null
            });
        }
        perm.fetch({
            success: _.bind(function () {
                callback(perm);
            }, this)
        });
    },
    fetchSystemNotificationSettings: function (callback) {
        let notificationSettings = null;
        if (!this.isNew()) {
            notificationSettings = new PJQ.models.notificationSettings.SystemNotificationSettings({
                id: this.get('id')
            });
        } else {
            notificationSettings = new PJQ.models.notificationSettings.SystemNotificationSettings({
                userTypeId: this.get('userTypeId')
            });
        }

        notificationSettings.fetch({
            success: _.bind(function () {
                callback(notificationSettings);
            }, this)
        });
    },
    fetchProjectNotificationSettings: function (projectId, callback) {
        let notificationSettings = null;
        if (!this.isNew()) {
            notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
                id: this.get('id'),
                projectId: projectId
            });
        } else {
            notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
                userTypeId: this.get('userTypeId'),
                projectId: projectId
            });
        }

        notificationSettings.fetch({
            success: _.bind(function () {
                callback(notificationSettings);
            }, this)
        });
    },
    unlinkUser: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.id
                },
                {
                    endpoint: 'user'
                }
            ])
        }).delete().done(_.bind(function () {
            this.userid = null;
            this.username = null;
            this.user = null;
            if (typeof callback === 'function') {
                callback();
            }
        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    },
    copyContact: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.id
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (model) {
            if (typeof callback === 'function') {
                callback(model);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    },
    getVcard: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.id
            },
            {
                endpoint: 'vcard'
            }
        ]));
    },
    showProjectHistory: function () {
        new PJQ.views.projects.ProjectParticipantHistoryModal({
            contactId: this.get('contactId')
        });
    },
    sendUpdater: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('contactId')
                },
                {
                    endpoint: 'updater'
                }
            ])
        }).post().done(_.bind(function () {
            callback();
        }, this)).fail(function (xhr, err, result) {
        });
    },
    exportExcel: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.id
            },
            {
                endpoint: 'export'
            }
        ]));
    },
    getContactProjects: function () {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'contacts',
                        value: this.id
                    },
                    {
                        endpoint: 'projects'
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                resolve(res);
            }).fail((err) => {
                reject(new Error("Failed to fetch contact projects"));
            });
        });
    },
    addToProjects: function (projectIds) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'contacts',
                        value: this.id
                    },
                    {
                        endpoint: 'projects'
                    }
                ]),
                data: projectIds,
                isAPIv2: true
            }).post().done((res) => {
                resolve(res);
            }).fail((err) => {
                reject(new Error("Failed to add contact to projects"));
            });
        });
    },
    beforeSave: function () {
        let flatCustomFields = this.get('contactCustomFieldValuesFlat');
        if (_.size(flatCustomFields) > 0) {
            let parsed = [];
            _.each(flatCustomFields, function (number, value) {
                parsed.push({
                    fieldNumber: number,
                    value: value
                });
            });
            this.set({
                contactCustomFieldValues: parsed,
                contactCustomFieldValuesFlat: null
            })
        }

        let flatCompanyCustomFields = this.get('companyCustomFieldValuesFlat');
        if (_.size(flatCompanyCustomFields) > 0) {
            let parsed = [];
            _.each(flatCompanyCustomFields, function (value, id) {
                parsed.push({
                    id: id,
                    value: value
                });
            });
            this.set({
                companyCustomFieldValues: parsed,
                contactCustomFieldValuesFlat: null
            })
        }

        if (this.groups) {
            this.set({
                groups: _.map(this.groups.models, function (group) {
                    return {
                        groupId: group.id,
                        isDeleted: group.get('isDeleted')
                    }
                })
            });
        }

        if (this.workAreas) {
            this.set({
                workAreas: _.map(this.workAreas.models, function (workArea) {
                    return {
                        contactWorkAreaId: workArea.id,
                        workAreaId: workArea.get('workAreaId'),
                        isDeleted: workArea.get('isDeleted')
                    }
                })
            });
        }

        if (this.userType != null) {
            this.set('userTypeId', this.userType.id);
        }
    },
    approve: function (callback) {
        this.set('approvalUpdates', this.approvalUpdates ? this.approvalUpdates.toJSON() : null);
        this.save(null, {
            urlOptions: {
                approve: true
            },
            success: _.bind(function () {
                this.set('isApprovalRequired', false);
                callback();
            }, this),
            error: _.bind(callback, this)
        });
    },
    addCompanyCustomFieldValue: function (value) {
        this.attributes.companyCustomFieldValues = _.filter(this.attributes.companyCustomFieldValues, function (exValue) {
            return value.id !== exValue.id;
        });
        this.attributes.companyCustomFieldValues.push(value);
    },
    addContactCustomFieldValue: function () {
        this.attributes.contactCustomFieldValues = _.filter(this.attributes.contactCustomFieldValues, function (exValue) {
            return value.id !== exValue.id;
        });
        this.attributes.contactCustomFieldValues.push(value);
    },
    mergeCustomFields: function () {

    }
});

PJQ.models.contacts.EditHistoryItem = PJQ.models.BaseModel.extend({
    idAttribute: 'auditId'
});

PJQ.models.contacts.ApprovalUpdates = PJQ.models.BaseModel.extend({
    idAttribute: 'id'
});

PJQ.models.contacts.ContactCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'contactcustomfields',
                value: this.id
            }
        ])
    }
});

PJQ.models.contacts.CompanyCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'companycustomfields',
                value: this.id
            }
        ]);
    },
});

PJQ.models.contacts.CompanyPhoto = PJQ.models.BaseModel.extend({
    idAttribute: 'companyPhotoId',
    endpoint: function () {
        if (_.size(this.get('profileKey')) > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'profiles',
                    value: this.get('profileKey')
                },
                {
                    endpoint: 'companyphotos',
                    value: this.id
                }
            ])
        } else if (this.get('contactCompanyId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('contactCompanyId')
                },
                {
                    endpoint: 'photos',
                    value: this.id
                }
            ])
        }
    }
});

PJQ.models.contacts.ContactFieldSetting = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'fields'
            }
        ]);
    }
});

PJQ.models.contacts.ContactGroup = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'groupId'
});

//Collections
PJQ.collections.contacts.ContactFieldSettings = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactFieldSetting,
    endpoint: function () {
        let params;
        if (this.options.masterUserId > 0) {
            params = [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId
                }
            ];
        } else {
            params = null;
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'fields'
            }
        ], params)
    }
});

PJQ.collections.contacts.Contacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.Contact,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            }
        ]);
    },
    filteredByGroups: function (filter) {
        let groupContacts = PJQ.collections.contacts.Contacts();
        _.each(this.models, function (model) {
            if (model.checkHasGroup(filter))
                groupContacts.add(model);
        });
        return groupContacts;
    }
});

PJQ.collections.contacts.ContactInfoList = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.Contact,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'list'
            }
        ], [
            {
                parameter: 'contactIds',
                value: this.options.contactIds
            }
        ]);
    }
});

PJQ.collections.contacts.EditHistory = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.EditHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.options.contact.id
            },
            {
                endpoint: 'edithistory'
            }
        ]);
    }
});

PJQ.collections.contacts.CompanyPhotos = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.CompanyPhoto,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactCompanyId')
            },
            {
                endpoint: 'photos'
            }
        ]);
    }
});

PJQ.collections.contacts.ContactCustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'contactcustomfields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

PJQ.collections.contacts.CompanyCustomFields = PJQ.collections.customFields.CustomFields.extend({
    model: PJQ.models.contacts.CompanyCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
            },
            {
                endpoint: 'companycustomfields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

PJQ.collections.contacts.ApprovalUpdates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ApprovalUpdates
})

PJQ.collections.contacts.ContactGroups = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.contacts.ContactGroup,
    endpoint: function () {
        let params = [];
        if (this.options.projectId)
            params.push({
                parameter: 'projectId',
                value: this.options.projectId
            });
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.options.contactId
            },
            {
                endpoint: 'groups'
            }
        ], params);
    }
});
//Views
PJQ.views.contacts.BaseEditContactView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'contact-edit-base'),
        subTemplates: {
            sso: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'user-edit-sso'),
        },
        canEdit: true,
        alert: null,
        onSave: null,
        onCancel: null,
        onDelete: null
    },
    events: {
        "click .btn-edit-permissions": "editPermissions",
        "click .btn-edit-notifications": "editNotifications",
        "change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
        "keydown .contact-edit-phone-ext": "numbersOnly",
        "keyup .contact-edit-phone-ext": "numbersOnly",
        "click .btn-unlock-user": "unlockUser",
        'click .btn-unlink-user': 'unlinkContactUser',
        'click .btn-send-user-reg': 'sendSignUp',
        "click .btn-send-password-reset": "sendPasswordReset",
        "click .btn-screening-request-contact": "newScreeningRequest",
        "click .contact-edit-add": "addNew",
        "click .contact-edit-cancel": "cancel",
        "click .contact-edit-save": "save",
        "click .contact-edit-save-and-add-project": "saveAndAddToProject",
        "click .contact-edit-delete": "delete",
        "change .cb-sso-enabled": "userSSOChanged"
    },
    beforeFirstRender: function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        let prefs = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences,
            isUser = this.model && (this.model.get('id') < 0 || this.model instanceof PJQ.models.users.User);

        if (!this.options.fieldSettingsEnabled) {
            if (isUser) {
                this.options.fieldSettingsEnabled = prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_USER_FIELD_SETTINGS);
            } else {
                this.options.fieldSettingsEnabled = prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
            }
        }

        if (!(this.options.masterUserId > 0)) {
            if (this.options.project != null) {
                this.options.masterUserId = this.options.project.get('masterUserId');
            }
        }

        let fetchContact = (callback) => {
                if (this.model == null) {
                    this.model = new PJQ.models.contacts.Contact({
                        id: this.options.contactId,
                        country: "US"
                    });
                } else if (_.size(this.model.get('country')) === 0) {
                    this.model.set('country', 'US');
                }

                if (!this.model.isNew() && !this.model.isFetched) {
                    this.model.fetch({
                        success: _.bind(function () {
                            this.listenTo(this.model, 'sync', this.render);
                            callback();
                        }, this)
                    });
                } else {
                    this.listenTo(this.model, 'sync', this.render);
                    callback();
                }
            },
            fetchERP = (callback) => {
                PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
                    this.erpIntegration = erp;
                    if (this.erpIntegration != null) {
                        this.model.fetchCompanyERPObject(_.bind(function () {
                            callback();
                        }, this));
                    } else {
                        callback();
                    }
                }, this));
            },
            fnRender = () => {
                if (isUser) {
                    PJQ.app.session.fetchUserCustomFields(this.options.masterUserId, _.bind(function (userCustomFields) {
                        this.userCustomFields = userCustomFields;
                        PJQ.app.session.fetchSSOProviders(_.bind(function (providers) {
                            this.ssoProviders = providers;
                            this.render();
                        }, this));
                    }, this));
                } else {
                    this.render();
                    PJQ.app.session.fetchCompanyCustomFields(this.options.masterUserId, _.bind(function (customFields) {
                        this.companyCustomFields = customFields;
                        if (this.isRendered) {
                            this.renderCompanyCustomFields();
                        }
                    }, this));
                    PJQ.app.session.fetchContactCustomFields(this.options.masterUserId, _.bind(function (customFields) {
                        this.contactCustomFields = customFields;
                        if (this.isRendered) {
                            this.renderContactCustomFields();
                        }
                    }, this));
                }
            };

        fetchContact(() => {
            fetchERP(() => {
                if (this.options.fieldSettingsEnabled) {
                    if (isUser) {
                        PJQ.app.session.fetchUserFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                            this.coreFieldSettings = settings;
                            fnRender();
                        }, this));
                    } else {
                        PJQ.app.session.fetchContactFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                            this.coreFieldSettings = settings;
                            fnRender();
                        }, this));
                    }
                } else {
                    fnRender();
                }
            });
        })
    },
    beforeRender: function () {
        let mod = this.company != null ? this.company : this.model;
        if (mod == null || (this.options.fieldSettingsEnabled && this.coreFieldSettings == null)) {
            return false;
        }

        this.initPermissionOptions();
        this.initViewOptions();

        this.listenTo(mod, 'change:isActive', function () {
            this.render();
        });

        this.listenTo(mod, 'change:itbUser change:pmUser', function () {
            this.featuresDidChange = true;
        });
        this.featuresDidChange = false;

        this.options.showScreenings = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS);
    },
    renderERP: function () {
        let company;
        if (this.company != null) {
            company = this.company;
        } else {
            company = this.model;
        }

        let isUser = ((company instanceof PJQ.models.users.User) || (company instanceof PJQ.models.projectContacts.ProjectContact && this.model.id < 0));
        if (this.erpIntegration == null || isUser) {
            return;
        }

        let $modal = this.$el.closest('.modal-content');
        $modal.find('.erp-badge').html(PJQ.helpers.erp.getERPBadge(company.erpSyncStatus(), company.get('externalObject')));
        PJQ.helpers.erp.renderERPButtons($modal.find('.erp-sync'), {
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_VENDORS),
            status: company.erpSyncStatus(true),
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_VENDOR),
        });
        $modal.find('.btn-push-erp').off().on('click', () => this.pushERP());
        $modal.find('.btn-undo-push-erp').off().on('click', () => this.undoPushERP());
        $modal.find('.btn-unlink-erp').off().on('click', () => this.unlinkERP());
    },
    pushERP: async function () {
        if (this.erpIntegration == null || !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_VENDORS)) {
            return;
        }

        let mod = this.company != null ? this.company : this.model,
            fnPush = () => {
                this.erpIntegration.pushVendor(mod, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Company pushed to ERP'
                    });
                    this.render();
                });
            };

        if (mod.isNew()) {
            this.save(() => {
                fnPush();
            });
        } else {
            fnPush();
        }
    },
    undoPushERP: function () {
        let mod = this.company != null ? this.company : this.model;
        if (this.erpIntegration == null || mod.erpSyncStatus() !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            return;
        }

        this.erpIntegration.undoPush(mod, () => {
            PJQ.notifications.notify.successNotify({
                message: 'Company removed from ERP approval'
            });
            this.render();
        });
    },
    unlinkERP: function () {
        if (this.erpIntegration == null) {
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Company from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content')),
                    mod = this.company != null ? this.company : this.model;
                this.erpIntegration.unlinkVendor(mod, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Company unlinked from ERP'
                        });
                        this.render();
                    }
                });
            }
        });
    },
    initViewOptions: function () {
        let mod = this.company != null ? this.company : this.model;
        this.options.groupLevels = null;
        this.options.maxGroups = null;
        if (PJQ.app.session.project != null) {
            // in a project/contact context, all contacts must have a Contact Name and a Phone, to match with old system logic per Bart.
            if (mod.id > 0) {
                this.options.allowMultipleEmails = !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.SUB_RESTRICT_SINGLE_EMAIL);
            }

            // if this is a contact editing their own contact record
            if (!this.options.isAdmin) {
                if (mod.id > 0 && this.options.isSelfEdit) {
                    this.options.allowMultipleEmails = !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.SUB_RESTRICT_SINGLE_EMAIL);
                }
            }

            this.options.prevailingWageLabel = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PREVAILING_WAGE_LABEL);

            this.options.groupLevels = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS);
            this.options.maxGroups = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT);
        } else {
            this.options.prevailingWageLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PREVAILING_WAGE_LABEL);
            this.options.groupLevels = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS);
            this.options.maxGroups = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT);
        }

        if (this.options.isAdmin && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP)) {
            this.options.maxGroups = null;
        }
    },
    initPermissionOptions: function () {
        this.options.enablePermissions = true;

        let mod = this.company != null ? this.company : this.model;
        this.options.isSelfEdit = false;
        this.options.canModifyAttachments = false;
        if (!mod.isNew()) {
            let sessionUserId = PJQ.app.session.user != null ? PJQ.app.session.user.id : null,
                sessionContactId = PJQ.app.session.contact != null ? PJQ.app.session.contact.id : null;
            if (((sessionUserId != null && mod.get('userId') === sessionUserId)) ||
                (sessionContactId != null && mod.get('contactId') === sessionContactId)) {
                this.options.isSelfEdit = true;
            }

            if (mod.id > 0)
                this.options.canModifyAttachments = PJQ.app.session.hasPermission('contacts.canViewAttachments');
        }

        this.options.isAdmin = false;
        this.options.isPrequalVisible = false;
        this.options.canEdit = false;
        this.options.canModifyNotifications = false;
        this.options.canViewCustomFields = true;
        this.options.canEditCustomFields = false;
        let isUser = ((mod instanceof PJQ.models.users.User) || (mod instanceof PJQ.models.projectContacts.ProjectContact && mod.id < 0));
        if (mod.isNew()) {
            this.options.canEdit = true;
            this.options.canEditCustomFields = true;
            this.options.isAdmin = PJQ.app.session.get('masterUserId') > 0;
            this.options.canModifyNotifications = this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
            this.options.canModifyAttachments = !isUser && PJQ.app.session.hasPermission('contacts.canViewAttachments');
        } else if (this.options.isSelfEdit) {
            this.options.canEdit = true;
            this.options.canEditCustomFields = true;
            this.options.isAdmin = PJQ.app.session.hasPermission('settings.canManageUsers') && (PJQ.app.session.user != null && mod.get('masterUserId') === PJQ.app.session.user.get('masterUserId'));
            this.options.canModifyNotifications = this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
        } else if ((((isUser || mod.id < 0) && PJQ.app.session.hasPermission('settings.canManageUsers'))
                || (mod.id > 0 && PJQ.app.session.hasPermission('contacts.isAdmin')) || (mod.id > 0 && PJQ.app.session.hasPermission('contacts.canEditContact')))
            && mod.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
            this.options.canEdit = true;
            this.options.canViewCustomFields = mod.get('masterUserId') === PJQ.app.session.get('masterUserId');
            this.options.canEditCustomFields = true;
            this.options.isAdmin = (this.options.project == null || this.options.project.hasPermission('projectContacts.isAdmin')) && mod.get('masterUserId') === PJQ.app.session.get('masterUserId');
            this.options.isPrequalVisible = !isUser && mod.get('masterUserId') === PJQ.app.session.get('masterUserId') && PJQ.app.session.hasPermission('prequal.canView');
            this.options.canModifyNotifications = this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
        } else if (mod.get('masterUserId') === 39) {
            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY_EDIT)) {
                this.options.canEdit = true;
            }
            this.options.canEditCustomFields = true;
        }
        this.options.isPrequalVisible = !mod.isNew() && !this.options.isSelfEdit && !isUser && mod.get('masterUserId') === PJQ.app.session.get('masterUserId') && PJQ.app.session.hasPermission('prequal.canView');

        this.options.isCompanyUser = mod instanceof PJQ.models.users.User || mod.id < 0;
    },
    renderData: function () {
        return {
            isContact: this.model.get('id') > 0 || (this.model.isNew() && !(this.model instanceof PJQ.models.users.User)),
            isUser: this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User)),
            model: this.model,
            userTypes: PJQ.app.session.userTypes.getByIsCompany(this.options.isCompanyUser),
            isUserTypeRequired: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE) && this.options.isCompanyUser,
            prevailingWageLabel: this.options.prevailingWageLabel,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            maxGroups: this.options.maxGroups ? this.options.maxGroups : 0,
            isSelfEdit: this.options.isSelfEdit,
            alert: this.options.alert,
            enablePermissions: this.options.enablePermissions,
            canEdit: this.options.canEdit,
            canViewCustomFields: this.options.canViewCustomFields,
            canEditCustomFields: this.options.canEditCustomFields,
            ssoProviders: this.ssoProviders,
            isAdmin: this.options.isAdmin,
            isPrequalVisible: this.options.isPrequalVisible,
            canModifyNotifications: this.options.canModifyNotifications,
            canModifyAttachments: this.options.canModifyAttachments,
            userCustomFields: this.userCustomFields,
            showScreenings: this.options.showScreenings
        };
    },
    afterRender: function () {
        if (this.model == null || (!this.model.isFetched && !this.model.isNew())) {
            new PJQ.Loader(this.$('.modal-body'));
        } else {
            if (this.options.masterUserId == null) {
                this.options.masterUserId = this.model.get('masterUserId');
            }
            this.renderERP();
            this.renderContact();
        }
    },
    checkFieldRequired: function (fieldName) {
        if (!this.checkFieldVisible(fieldName) || !this.options.canEdit) {
            return false;
        }

        if (!this.options.isSelfEdit && fieldName === 'userType')
            return true;

        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            switch (fieldName) {
                case 'contactName':
                case 'email':
                    return true;
                case 'address1':
                case 'address2':
                case 'city':
                case 'state':
                    return false;
                case 'country':
                    return (!this.options.isAdmin && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ADDRESS_REQUIRED)) ||
                        (this.options.isAdmin && (prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE) || ((prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP) && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ADDRESS_REQUIRED)))));
                case 'zip':
                    return (!this.options.isAdmin && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ZIP_REQUIRED)) ||
                        (this.options.isAdmin && (prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE) || ((prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP) && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ZIP_REQUIRED)))));
                case 'phone':
                    return !this.options.isAdmin ||
                        prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE) ||
                        (prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP) && prefs.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_CONTACT_UPDATE_REQ));
                case 'laborStatus':
                    return this.checkFieldVisible(fieldName) && !prefs.hasPref(PJQ.constants.preferenceTypes.NO_REQUIRE_UNION_SUB) &&
                        (!this.options.isAdmin || prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP));
                case 'groups':
                    let isUser = (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User)));
                    if (isUser) {
                        return false;
                    }
                    return prefs.hasPref(PJQ.constants.preferenceTypes.ALLOW_SUB_GROUP_EDIT_REQUIRED) &&
                        (this.options.isSelfEdit || prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP));
            }
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return !this.options.isAdmin ? fieldSettings.get('isRequiredContact') : fieldSettings.get('isRequiredAdmin');
            }
        }
        return false;
    },
    checkFieldVisible: function (fieldName) {
        // special fields
        if (fieldName === 'title' && (this.model == null ? false : (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User))))) {
            return false;
        } else if (this.options.isSelfEdit && (fieldName === 'userType' || fieldName === 'companyNotes' || fieldName === 'contactNotes' || fieldName === 'active')) {
            return false;
        } else if (!this.options.isSelfEdit && fieldName === 'userType') {
            return true;
        }

        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let result;
            switch (fieldName) {
                case 'sector':
                    result = !prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_SECTOR);
                    break;
                case 'laborStatus':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
                    if (!this.options.isAdmin) {
                        if (result && prefs.hasPref(PJQ.constants.preferenceTypes.CAN_EDIT_UNION_STATUS_SUB)) {
                            result = prefs.getPref(PJQ.constants.preferenceTypes.CAN_EDIT_UNION_STATUS_SUB);
                        }
                    }
                    break;
                case 'classifications':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_MINORITY_STATUS) === false &&
                        (this.options.isAdmin || prefs.getPref(PJQ.constants.preferenceTypes.CAN_EDIT_MINORITY_CLASS_SUB));
                    break;
                case 'groups':
                    result = !(this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User)));
                    break;
                default:
                    result = true;
            }
            return result;
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return this.options.isSelfEdit ? fieldSettings.get('isVisibleContact') : fieldSettings.get('isVisibleAdmin');
            }
        }
        return true;
    },
    renderContact: function () {
        if (this.checkFieldVisible('userType') !== false) {
            let isCompanyUser = (this.model instanceof PJQ.models.users.User || this.model.id < 0),
                defaultUserType = (!isCompanyUser && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE)) ? null : (this.model.get('userTypeId') != null ? this.model.get('userTypeId') : null);
            this.userTypePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-user-type'),
                noneSelectedText: 'Select Value',
                isIntChoices: true,
                defaultValue: this.model.userType ? this.model.userType.id : defaultUserType,
                onChange: _.bind(function (value) {
                    this.model.set('userTypeId', value);
                    this.model.userType = PJQ.app.session.userTypes.getById(value);
                }, this)
            });
        }

        let statePicker = new PJQ.inputs.StatePicker({
            el: this.$('.contact-edit-state'),
            country: this.model.get('country') ?? null,
            defaultValue: this.model.get('state') ?? null,
            size: 20,
            onChange: (value) => {
                this.model.set('state', value);
            }
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('.contact-edit-country'),
            defaultValue: this.model.get('country') ?? null,
            statePicker: statePicker,
            zipInput: this.$('.contact-edit-zip'),
            enableInternational: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
            size: 20,
            onChange: (value) => {
                this.model.set('country', value);
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.contact-edit-selection-status'),
            noneSelectedText: 'Select Value',
            defaultValue: this.model.get('isAutoSelectDisabled'),
            onChange: _.bind(function (value) {
                this.model.set('isAutoSelectDisabled', value === "true");
            }, this)
        });

        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model);
        }

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-phone'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-fax'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-cell'));

        this.renderLaborStatus(this.model);
        this.renderSector(this.model);
        this.renderMinority(this.model);

        if (this.$('#contactInfoCollapseContainer').length > 0) {
            new PJQ.views.collapse.BaseCollapse({
                el: this.$('#contactInfoCollapseContainer'),
                onShown: _.bind(function (id) {
                    switch (id) {
                        case 'prequalCollapse':
                            this.renderPrequal();
                            break;
                        case 'screeningCollapse':
                            this.renderScreenings();
                            break;
                        case 'contactEditWorkAreasCollapse':
                            if (this.workAreaMap == null || this.workAreaMap.options.contactId !== this.model.id) {
                                if (this.model.workAreas != null) {
                                    this.renderWorkAreas();
                                }
                            } else {
                                this.workAreaMap.refresh();
                            }
                            break;
                        case 'companyAttachmentsCollapse':
                            this.renderCompanyAttachments();
                            break;
                    }
                }, this)
            });
        } else {
            this.renderWorkAreas();
        }

        if (!(this.model instanceof PJQ.models.users.User) && (this.model.id > 0 || this.model.isNew())) {
            if (this.model.groups != null) {
                this.renderGroupSelector();
            }

            if (this.options.canViewCustomFields) {
                this.renderCompanyCustomFields();
                this.renderContactCustomFields();
            }
        }


        if (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User))) {

            if (this.model.groups != null && this.checkFieldVisible('groups'))
                this.renderGroupSelector();

            if (this.options.canViewCustomFields) {
                this.renderUserCustomFields();
            }
            if (this.options.isAdmin) {
                this.renderSSO();
            }
        }

        this.isRendered = true;
    },
    renderPrequal: function () {
        if (!PJQ.app.session.hasPermission('prequal.canView') || !PJQ.app.session.subscription.hasFeature('projectmessaging')) {
            // this element shouldn't even be rendered if the user doesn't meet this criteria
            // but we remove it just for good measure
            this.$('.prequal-section').remove();
            return;
        }

        if (this.prequalEditor != null) {
            return;
        }

        let contact;
        if (!this.model.isNew()) {
            contact = this.model.clone();
        } else {
            contact = _.find(this.company.contacts.models, function (compContact) {
                return compContact.id > 0;
            });
        }
        if (contact != null) {
            let self = this,
                mod = this.company != null ? this.company : this.model;
            let fnRender = function () {
                PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Dashboard'), self.$('.company-prequal-data'), {
                    prequal: mod.prequal,
                    isAdmin: self.options.isAdmin,
                    isPrequalVisible: self.options.isPrequalVisible
                }, function ($outer) {
                    self.$('.company-prequal-data .prequal-export-pdf').click(function () {
                        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: contact.get('contactId')
                            },
                            {
                                endpoint: 'prequal'
                            },
                            {
                                endpoint: 'export'
                            }
                        ], [
                            {
                                parameter: 'masterUserId',
                                value: mod.prequal.get('masterUserId') > 0 ? mod.prequal.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                            },
                            {
                                parameter: 'isExcel',
                                value: false
                            }
                        ]));
                    });

                    self.$('.company-prequal-data .prequal-export-excel').click(function () {
                        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: contact.get('contactId')
                            },
                            {
                                endpoint: 'prequal'
                            },
                            {
                                endpoint: 'export'
                            }
                        ], [
                            {
                                parameter: 'masterUserId',
                                value: mod.prequal.get('masterUserId') > 0 ? mod.prequal.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                            },
                            {
                                parameter: 'isExcel',
                                value: true
                            }
                        ]));
                    });

                    self.prequalEditor = new PJQ.views.prequal.PrequalEditor({
                        el: $outer.find('.screening-dashboard-body'),
                        isAdmin: self.model.get('masterUserId') === PJQ.app.session.user.get('masterUserId'),
                        canEdit: PJQ.app.session.hasPermission('prequal.canEdit'),
                        clients: new PJQ.collections.screenings.ScreeningClients(),
                        navContainer: $outer.find('.screening-dashboard-nav-extend'),
                        preferences: PJQ.app.session.preferences,
                        model: mod.prequal,
                        contact: contact,
                        onContactChange: function (contact, ch) {
                            if (contact.id === self.model.id) {
                                self.model.groups = contact.groups;
                                self.model.workAreas = contact.workAreas;
                                self.model.set(ch.prop, ch.value);
                                mod.set(ch.prop, ch.value);
                                self.renderContact();
                            }
                        },
                        onCompanyCustomFieldChange: function (ch) {
                            if (self.companyCustomFieldsForm != null && ch != null && ch.id > 0) {
                                _.each(self.model.attributes.companyCustomFieldValues, function (cfv) {
                                    if (cfv.id === ch.id) {
                                        cfv.value = ch.value;
                                    }
                                });

                                self.companyCustomFieldsForm.setValue(ch.id, ch.value);
                            }
                        },
                        onContactCustomFieldChange: function (ch) {
                            if (self.contactCustomFieldsForm != null && ch != null && ch.id > 0) {
                                _.each(self.model.attributes.contactCustomFieldValues, function (cfv) {
                                    if (cfv.id === ch.id) {
                                        cfv.value = ch.value;
                                    }
                                });

                                self.contactCustomFieldsForm.setValue(ch.id, ch.value);
                            }
                        }
                    });
                });
            };
            if (mod.prequal == null || !mod.prequal.isFetched) {
                mod.prequal = new PJQ.models.prequal.Prequal({
                    contact: contact
                });
                mod.prequal.fetch({
                    success: function () {
                        fnRender();
                    }
                });
            } else {
                mod.prequal.contact = contact;
                fnRender();
            }
        }
    },
    renderScreenings: function () {
        if (!this.options.isAdmin) {
            // this element shouldn't even be rendered if the user isnt an admin
            // but we remove it just for good measure
            this.$('.screening-section').remove();
            return;
        }

        let contactId = null;
        if (!this.model.isNew()) {
            contactId = this.model.id;
        } else if (this.company != null) {
            let contact = _.find(this.company.contacts.models, function (compContact) {
                return compContact.id > 0;
            });
            if (contact != null) {
                contactId = contact.id;
            }
        }

        if (this.screenings == null && contactId != null) {
            let self = this;
            this.screenings = new PJQ.models.screenings.ScreeningClient({
                masterUserId: PJQ.app.session.get('masterUserId'),
                contactId: contactId
            });
            this.screenings.fetch({
                success: _.bind(function () {
                    let $screenings = this.$('.contact-screenings');
                    if (_.size(this.screenings.categories) > 0) {
                        this.screeningEditor = new PJQ.views.screenings.ScreeningClientEditor({
                            el: $screenings,
                            canManage: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_CUSTOMER),
                            isAdmin: self.options.isAdmin,
                            model: this.screenings
                        });
                    } else {
                        $screenings.empty();
                        new PJQ.Alert($screenings, {
                            text: 'This contact has not been requested to complete any screening items'
                        });
                    }
                }, this)
            })
        }
    },
    newScreeningRequest: function () {
        new PJQ.views.addressbook.ProqualRequestModal({
            contactId: this.model.id,
            onSend: _.bind(function () {
                this.screenings = null;
                this.renderScreenings();
            }, this)
        });
    },
    renderCompanyAttachments: function () {
        if (!PJQ.app.session.hasPermission('contacts.canViewAttachments')) {
            return;
        }
        if (this.companyAttachmentFileUploader == null) {

            let sortSettings;
            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SORT_COMPANY_ATTACHMENTS))
                sortSettings = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SORT_COMPANY_ATTACHMENTS);

            this.companyAttachmentFileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.company-documents'),
                collection: this.model.attachments,
                sortBy: sortSettings ? sortSettings.sortBy : null,
                sortDirection: sortSettings ? (sortSettings.sortBy ? 'asc' : 'desc') : null,
                // canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                canUpload: PJQ.app.session.hasPermission('contacts.canEditContact'),
                canDownloadAll: true,
                onSuccess: _.bind(function () {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    renderLaborStatus: function (mod) {
        if (this.checkFieldVisible('laborStatus') && mod != null) {
            let laborStatus = [];
            if (mod.get('isUnion')) {
                laborStatus.push('union');
            }
            if (mod.get('isNonUnion')) {
                laborStatus.push('nonUnion');
            }
            if (mod.get('isPrevailingWage')) {
                laborStatus.push('prevWage');
            }

            new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-labor-status'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isDisabled: !this.options.canEdit,
                defaultValue: laborStatus,
                onChange: _.bind(function (value) {
                    mod.set({
                        isUnion: (value?.indexOf("union") ?? -1) !== -1,
                        isNonUnion: (value?.indexOf("nonUnion") ?? -1) !== -1,
                        isPrevailingWage: (value?.indexOf("prevWage") ?? -1) !== -1
                    });

                    //temporary fix for api call on contact overriding the company in the address book
                    // we set this.company to the same as mod (if it exists)
                    if (this.company != null) {
                        this.company.set({
                            isUnion: (value?.indexOf("union") ?? -1) !== -1,
                            isNonUnion: (value?.indexOf("nonUnion") ?? -1) !== -1,
                            isPrevailingWage: (value?.indexOf("prevWage") ?? -1) !== -1
                        });
                    }
                }, this)
            });
        }
    },
    renderSector: function (mod) {
        if (this.checkFieldVisible('sector') && mod != null) {
            let sectors = [];
            if (mod.get('isPrivateSector')) {
                sectors.push('privateSector');
            }
            if (mod.get('isPublicSector')) {
                sectors.push('publicSector');
            }

            new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-sector'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isDisabled: !this.options.canEdit,
                defaultValue: sectors,
                onChange: _.bind(function (value) {
                    mod.set({
                        isPrivateSector: value.indexOf("privateSector") !== -1,
                        isPublicSector: value.indexOf("publicSector") !== -1,
                    });

                    //temporary fix for api call on contact overriding the company in the address book
                    // we set this.company to the same as mod (if it exists)
                    if (this.company != null) {
                        this.company.set({
                            isPrivateSector: value.indexOf("privateSector") !== -1,
                            isPublicSector: value.indexOf("publicSector") !== -1,
                        });
                    }
                }, this)
            });
        }
    },
    renderMinority: function (mod) {
        if (this.checkFieldVisible('classifications') && mod != null) {
            let minorityClass = [];
            if (mod.get('isDBE')) {
                minorityClass.push('isDBE');
            }
            if (mod.get('isDVBE')) {
                minorityClass.push('isDVBE');
            }
            if (mod.get('isMBE')) {
                minorityClass.push('isMBE');
            }
            if (mod.get('isSBE')) {
                minorityClass.push('isSBE');
            }
            if (mod.get('isSDVBE')) {
                minorityClass.push('isSDVBE');
            }
            if (mod.get('isWBE')) {
                minorityClass.push('isWBE');
            }

            if (minorityClass.length === 0)
                minorityClass.push('NA');

            new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-minority-class'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isDisabled: !this.options.canEdit,
                defaultValue: minorityClass,
                exclusiveChoices: "NA",
                onChange: _.bind(function (value) {
                    mod.set({
                        isDBE: value.indexOf("isDBE") !== -1,
                        isDVBE: value.indexOf("isDVBE") !== -1,
                        isMBE: value.indexOf("isMBE") !== -1,
                        isSBE: value.indexOf("isSBE") !== -1,
                        isSDVBE: value.indexOf("isSDVBE") !== -1,
                        isUDBE: value.indexOf("isUDBE") !== -1,
                        isVSBE: value.indexOf("isVSBE") !== -1,
                        isWBE: value.indexOf("isWBE") !== -1
                    });

                    //temporary fix for api call on contact overriding the company in the address book
                    // we set this.company to the same as mod (if it exists)
                    if (this.company != null) {
                        this.company.set({
                            isDBE: value.indexOf("isDBE") !== -1,
                            isDVBE: value.indexOf("isDVBE") !== -1,
                            isMBE: value.indexOf("isMBE") !== -1,
                            isSBE: value.indexOf("isSBE") !== -1,
                            isSDVBE: value.indexOf("isSDVBE") !== -1,
                            isUDBE: value.indexOf("isUDBE") !== -1,
                            isVSBE: value.indexOf("isVSBE") !== -1,
                            isWBE: value.indexOf("isWBE") !== -1
                        });
                    }
                }, this)
            });
        }
    },
    renderGroupSelector: function () {
        let $groups = this.$('.contact-edit-groups');
        if (_.size($groups) > 0) {
            if (this.groupSelector != null) {
                this.groupSelector.remove();
            }

            this.groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.contact-edit-groups'),
                contactId: this.model != null ? this.model.id : null,
                groupLevels: this.options.groupLevels,
                groupUserId: this.options.masterUserId,
                selectedGroups: this.model.groups,
                maxGroups: this.options.maxGroups,
                detectGroupLevels: this.options.detectGroupLevels,
                isAdmin: this.options.canEdit && !this.options.isSelfEdit && !(PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK) || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY_EDIT)),
                canEdit: this.options.canEdit,
                onGroupSelected: _.bind(this.groupsChanged, this)
            });
        }
    },
    groupsChanged: function (data) {
        this.model.isDirty = true;
    },
    sendPasswordReset: function () {
        this.model.sendPasswordReset(_.bind(function () {
            let $container = this.$('.btn-send-password-reset').closest('div');
            $container.html('<div class="fs-16 text-success"><i class="fal fa-check mr-1"></i>Password Reset Sent</div>');
        }, this));
    },
    unlinkContactUser: function () {
        if (this.model.user != null) {
            this.model.unlinkUser(_.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'User successfully unlinked from contact'
                });
                this.render();
            }, this));
        }
    },
    sendSignUp: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.model.id
                },
                {
                    endpoint: 'requestsignup'
                },
            ])
        }).post().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Sign up link sent'
            });
            this.$('button.btn-send-user-reg').remove();
            this.$('.sign-up-alert').replaceWith('<div class="fs-16 text-success"><i class="fal fa-check mr-1"></i>Sign-Up Link Sent</div>');
        }, this)).fail(function (xhr, err, result) {

        });
    },
    userSSOChanged: function () {
        this.model.set('isSSOEnabled', this.$('.cb-sso-enabled').prop('checked'));
        this.renderSSO();
    },
    renderSSO: function () {
        if (this.model.get('isSSOEnabled')) {
            this.$('.btn-send-password-reset').addClass('hidden');
        } else {
            this.$('.btn-send-password-reset').removeClass('hidden');
        }
        this.renderSubTemplate(false, this.options.subTemplates.sso, this.$('.user-sso'), {
            model: this.model,
            ssoProviders: this.ssoProviders
        }, _.bind(function () {
            this.tagSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-sso-provider'),
                defaultValue: this.model.get('samlId'),
                noneSelectedText: 'Default Provider',
                isIntChoices: true,
                onChange: _.bind(function (value) {
                    this.model.set('samlId', value);
                }, this)
            });
        }, this));
    },
    renderUserCustomFields: function () {
        let $cf = this.$('.user-custom-fields');
        if (this.userCustomFields != null) {
            if (_.size(this.userCustomFields.models) > 0) {
                this.$('.user-custom-fields-outer').removeClass('hidden');

                let reqField = _.find(this.userCustomFields.models, function (customField) {
                    return customField.get('isRequired');
                }, this);
                if (reqField != null) {
                    this.$('.user-custom-fields-header').html('Additional User Details ' + PJQ.constants.markup.requiredAst);
                }

                let cfArray = [];
                _.each(this.userCustomFields.models, function (field) {
                    let fieldValue = _.find(this.model.get('userCustomFieldValues'), function (cfv) {
                        return cfv && cfv.id === field.get('id');
                    }, this);
                    if (_.size(field.get('defaultValue')) > 0 && (fieldValue == null || fieldValue.value == null || (typeof fieldValue.value !== 'number' && typeof fieldValue.value !== 'boolean' && _.size(fieldValue.value) === 0))) {
                        let defaultValue;
                        switch (field.get('fieldType')) {
                            case 'CHOICE':
                                defaultValue = parseInt(field.get('defaultValue'));
                                break;
                            case 'CHOICEMULTIPLE':
                                defaultValue = parseInt(field.get('defaultValue'));
                                break;
                            case 'BOOL':
                                defaultValue = field.get('defaultValue') === 'true';
                                break;
                            default:
                                defaultValue = field.get('defaultValue');
                                break;
                        }

                        if (fieldValue != null) {
                            fieldValue.value = defaultValue;
                        } else {
                            fieldValue = {
                                id: field.get('id'),
                                fieldNumber: field.get('fieldNumber'),
                                value: defaultValue
                            }
                        }
                    }
                    if (fieldValue != null) {
                        cfArray.push(fieldValue);
                    }
                }, this);
                this.model.set({
                    'userCustomFieldValues': cfArray
                }, {
                    silent: true
                });

                this.userCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                    el: $cf,
                    isAdmin: true,
                    isEdit: this.options.canEdit,
                    collection: this.userCustomFields,
                    fieldValues: this.model.get('userCustomFieldValues'),
                    onChange: _.bind(function () {
                        this.model.isDirty = true;
                    }, this)
                });
            }
        }
    },
    renderCompanyCustomFields: function () {
        let $cf = this.$('.company-custom-fields');
        if (this.companyCustomFields != null && (this.model.id > 0 || this.model.isNew()) && $cf.length > 0) {
            if (_.size(_.filter(this.companyCustomFields.models, _.bind(function (field) {
                return (!this.options.isSelfEdit || field.get('isVisibleInRSVP'));
            }, this))) > 0) {
                this.$('.company-custom-fields-outer').removeClass('hidden');

                let reqField = _.find(this.companyCustomFields.models, function (customField) {
                    return (!this.options.isAdmin && customField.get('isRequired')) || customField.get('isRequiredAdmin');
                }, this);
                if (reqField != null) {
                    this.$('.company-custom-fields-header').html('Additional Company Details ' + PJQ.constants.markup.requiredAst);
                }

                let cfAdmin = PJQ.app.session.user != null && (this.model.get('masterUserId') === PJQ.app.session.user.get('masterUserId') || this.model.isNew());
                if (this.companyCustomFields != null) {
                    let cfArray = [];
                    _.each(this.companyCustomFields.models, function (field) {
                        let fieldValue = _.find(this.model.get('companyCustomFieldValues'), function (cfv) {
                            return cfv && cfv.id === field.get('id');
                        }, this);
                        if (_.size(field.get('defaultValue')) > 0 && (fieldValue == null || fieldValue.value == null || (typeof fieldValue.value !== 'number' && typeof fieldValue.value !== 'boolean' && _.size(fieldValue.value) === 0))) {
                            let defaultValue;
                            switch (field.get('fieldType')) {
                                case 'CHOICE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'CHOICEMULTIPLE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'BOOL':
                                    defaultValue = field.get('defaultValue') === 'true';
                                    break;
                                default:
                                    defaultValue = field.get('defaultValue');
                                    break;
                            }

                            if (fieldValue != null) {
                                fieldValue.value = defaultValue;
                            } else {
                                fieldValue = {
                                    id: field.get('id'),
                                    fieldNumber: field.get('fieldNumber'),
                                    value: defaultValue
                                }
                            }
                        }
                        if (fieldValue != null) {
                            cfArray.push(fieldValue);
                        }
                    }, this);
                    this.model.set({
                        'companyCustomFieldValues': cfArray
                    }, {
                        silent: true
                    });
                }

                this.companyCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                    el: $cf,
                    isAdmin: cfAdmin,
                    isEdit: this.options.canEditCustomFields,
                    collection: this.companyCustomFields,
                    fieldValues: this.model.get('companyCustomFieldValues'),
                    onChange: _.bind(function () {
                        this.model.isDirty = true;
                    }, this)
                });
            }
        }
    },
    renderContactCustomFields: function () {
        let $cf = this.$('.contact-custom-fields');
        if (this.contactCustomFields != null && $cf.length > 0) {
            if (_.size(_.filter(this.contactCustomFields.models, _.bind(function (field) {
                return (!this.options.isSelfEdit || field.get('isVisibleInRSVP'));
            }, this))) > 0) {
                this.$('.contact-custom-fields-outer').removeClass('hidden');

                let reqField = _.find(this.contactCustomFields.models, function (customField) {
                    return (!this.options.isAdmin && customField.get('isRequired')) || customField.get('isRequiredAdmin');
                }, this);
                if (reqField != null) {
                    this.$('.contact-custom-fields-header').html('Additional Contact Details ' + PJQ.constants.markup.requiredAst);
                }

                let cfAdmin = PJQ.app.session.user != null && (this.model.get('masterUserId') === PJQ.app.session.user.get('masterUserId') || this.model.isNew());
                if (this.contactCustomFields != null) {
                    let cfArray = [];
                    _.each(this.contactCustomFields.models, function (field) {
                        let fieldValue = _.find(this.model.get('contactCustomFieldValues'), function (cfv) {
                            return cfv && cfv.id === field.get('id');
                        }, this);
                        if (_.size(field.get('defaultValue')) > 0 && (fieldValue == null || fieldValue.value == null || (typeof fieldValue.value !== 'number' && typeof fieldValue.value !== 'boolean' && _.size(fieldValue.value) === 0))) {
                            let defaultValue;
                            switch (field.get('fieldType')) {
                                case 'CHOICE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'CHOICEMULTIPLE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'BOOL':
                                    defaultValue = field.get('defaultValue') === 'true';
                                    break;
                                default:
                                    defaultValue = field.get('defaultValue');
                                    break;
                            }

                            if (fieldValue != null) {
                                fieldValue.value = defaultValue;
                            } else {
                                fieldValue = {
                                    id: field.get('id'),
                                    fieldNumber: field.get('fieldNumber'),
                                    value: defaultValue
                                }
                            }
                        }
                        if (fieldValue != null) {
                            cfArray.push(fieldValue);
                        }
                    }, this);
                    this.model.set({
                        'contactCustomFieldValues': cfArray
                    }, {
                        silent: true
                    });
                }

                this.contactCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                    el: $cf,
                    isAdmin: cfAdmin,
                    isEdit: this.options.canEditCustomFields,
                    collection: this.contactCustomFields,
                    fieldValues: this.model.get('contactCustomFieldValues'),
                    onChange: _.bind(function () {
                        this.model.isDirty = true;
                    }, this)
                });
            }
        }
    },
    renderWorkAreas: function () {
        let $workAreas = this.$('.contact-edit-work-areas');
        if (_.size($workAreas) > 0) {
            this.workAreaMap = new PJQ.views.workAreas.WorkAreaMap({
                el: $workAreas,
                collection: this.model.workAreas,
                isInline: false,
                isEdit: this.options.canEdit,
                isSync: false,
                contactId: this.model.id,
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }
    },
    countryChanged: function () {
        let country = this.model.get('country') && this.model.get('country').length > 0 ? this.model.get('country').toLowerCase() : 'us',
            options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[country], function (state) {
            options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
        });
        this.statePicker.$el.html(options);
        this.statePicker.refresh();
        if (this.model.get('state'))
            this.statePicker.setValue(this.model.get('state').toLowerCase());

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.contact-edit-zip'), country);
    },
    formatPhone: function (e) {
        let target = $(e.currentTarget);
        target.val(PJQ.helpers.formatHelpers.formatPhoneNumber(target.val()));
    },
    numbersOnly: function (e) {
        if (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) {
            return true;
        } else {
            return PJQ.helpers.inputHelpers.numbersOnly(e);
        }
    },
    editPermissions: function () {
        new PJQ.views.permissions.PermissionsEditorModal({
            model: this.model,
            project: this.options.project
        });
    },
    editNotifications: function () {
        new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
            model: this.model,
            project: this.options.project
        });
    },
    validateCoreFields: function () {
        let hasError = false,
            $scrollTo = null;
        if (this.checkFieldRequired('companyName')) {
            let $company = this.$('.contact-edit-company');
            if ($company.length > 0) {
                PJQ.helpers.inputHelpers.setInputError($company, true);
                if (_.size(this.model.get('companyName')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($company, false);
                    hasError = true;
                }
            }
        }

        if (this.checkFieldRequired('contactName')) {
            let $contactName = this.$('.contact-edit-name');
            PJQ.helpers.inputHelpers.setInputError($contactName, true);
            if (_.size(this.$('.contact-edit-name').val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($contactName, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('title')) {
            let $title = this.$('.contact-edit-title');
            PJQ.helpers.inputHelpers.setInputError($title, true);
            if (_.size(this.model.get('title')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($title, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('phone')) {
            let $phone = this.$('.contact-edit-phone');
            PJQ.helpers.inputHelpers.setInputError($phone, true);
            if (_.size(this.model.get('phone')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($phone, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('cell')) {
            let $cell = this.$('.contact-edit-cell');
            PJQ.helpers.inputHelpers.setInputError($cell, true);
            if (_.size(this.model.get('cell')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($cell, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('fax')) {
            let $fax = this.$('.contact-edit-fax');
            PJQ.helpers.inputHelpers.setInputError($fax, true);
            if (_.size(this.model.get('fax')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($fax, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('email')) {
            let $email = this.$('.contact-edit-email');
            PJQ.helpers.inputHelpers.setInputError($email, true);
            if (_.size(this.model.get('email')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($email, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('address1')) {
            let $add1 = this.$('.contact-edit-address-1');
            PJQ.helpers.inputHelpers.setInputError($add1, true);
            if (_.size(this.model.get('address1')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($add1, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('address2')) {
            let $add2 = this.$('.contact-edit-address-2');
            PJQ.helpers.inputHelpers.setInputError($add2, true);
            if (_.size(this.model.get('address2')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($add2, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('city')) {
            let $city = this.$('.contact-edit-city');
            PJQ.helpers.inputHelpers.setInputError($city, true);
            if (_.size(this.model.get('city')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($city, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('state')) {
            let $state = this.$('.contact-edit-state');
            PJQ.helpers.inputHelpers.setInputError($state, true);
            if (_.size(this.model.get('state')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($state, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('zip')) {
            let $zip = this.$('.contact-edit-zip');
            PJQ.helpers.inputHelpers.setInputError($zip, true);
            if (_.size(this.model.get('zip')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($zip, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('country')) {
            let $country = this.$('.contact-edit-country');
            PJQ.helpers.inputHelpers.setInputError($country, true);
            if (_.size(this.model.get('country')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($country, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('laborStatus') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $union = this.$('.contact-edit-labor-status,.company-edit-labor-status');
            PJQ.helpers.inputHelpers.setInputError($union, true);
            if (!this.model.get('isUnion') && !this.model.get('isNonUnion') && !this.model.get('isPrevailingWage')) {
                PJQ.helpers.inputHelpers.setInputError($union, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('classifications') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $certifications = this.$('.contact-edit-minority-class,.contact-edit-minority-class');
            PJQ.helpers.inputHelpers.setInputError($certifications, true);
            if (!this.model.get('isDBE') && !this.model.get('isDVBE') && !this.model.get('isMBE') && !this.model.get('isSBE') && !this.model.get('isSDVBE') && !this.model.get('isWBE')) {
                PJQ.helpers.inputHelpers.setInputError($certifications, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('sector') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $sector = this.$('.contact-edit-sector,.company-edit-sector');
            PJQ.helpers.inputHelpers.setInputError($sector, true);
            if (!this.model.get('isPublicSector') && !this.model.get('isPrivateSector')) {
                PJQ.helpers.inputHelpers.setInputError($sector, false);
                hasError = true;
            }
        }

        if (this.checkFieldVisible('userType') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $usertype = this.$('.contact-edit-user-type');
            PJQ.helpers.inputHelpers.setInputError($usertype, true);
            if (!this.model.get('userTypeId')) {
                PJQ.helpers.inputHelpers.setInputError($usertype, false);
                hasError = true;
            }
        }

        if (hasError) {
            $scrollTo = this.$('.validation-error')
        }

        if (this.groupSelector != null) {
            this.groupSelector.hideError();
            if (this.checkFieldRequired('groups') && _.size(this.groupSelector.getGroupsData().selected) === 0) {
                this.groupSelector.showError('Please select at least one value');
                hasError = true;

                let $gac = this.$('#contactEditGroupsCollapse');
                if ($gac.length > 0) {
                    if (!$gac.hasClass('show'))
                        $gac.siblings('.card-header').click();

                    if ($scrollTo == null) {
                        $scrollTo = $gac;
                    }
                } else if ($scrollTo == null) {
                    $scrollTo = this.$('.contact-edit-groups');
                }
            }
        }

        if (this.workAreaMap != null) {
            this.workAreaMap.hideError();
            if (this.checkFieldRequired('workAreas') && _.size(_.filter(this.model.workAreas.models, function (workArea) {
                return !workArea.get('isDeleted')
            })) === 0) {
                hasError = true;

                let $wac = this.$('#contactEditWorkAreasCollapse');
                if ($wac.length > 0) {
                    if (!$wac.hasClass('show'))
                        $wac.siblings('.card-header').click();

                    if ($scrollTo == null) {
                        $scrollTo = $wac;
                    }
                } else if ($scrollTo == null) {
                    $scrollTo = this.$('.contact-edit-work-areas');
                }

                this.workAreaMap.showError('Please select at least one work area');
            }
        }

        return {
            valid: !hasError,
            $scrollTo: $scrollTo
        };
    },
    unlockUser: function () {
        this.model.unlock(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'User unlocked'
            });
            this.render();
        }, this));
    },
    saveAndAddToProject: function () {
        this.save(null, false, true);
    },
    save: function (e, isAddNew, isAddToProject, callback) {
        let hasError = false,
            $scrollTo = null;
        //only validate core contact information if they can actually edit it
        //they may only be able to edit the custom fields

        let errorText = 'Required fields are empty or have an incorrect value';
        if (this.options.canEdit) {
            let validate = this.validateCoreFields();
            if (!validate.valid) {
                hasError = true;
                $scrollTo = validate.$scrollTo;
            }

            if (this.model instanceof PJQ.models.users.User) {
                if (this.model.isNew()) {
                    let $username = this.$('.input-username');
                    PJQ.helpers.inputHelpers.setInputError($username, true);
                    if (_.size(this.model.get('username')) === 0) {
                        PJQ.helpers.inputHelpers.setInputError($username, false);
                        hasError = true;
                        if ($scrollTo == null) {
                            $scrollTo = $username;
                        }
                    }

                    let $password = this.$('.input-password');
                    PJQ.helpers.inputHelpers.setInputError($password, true);
                    if (_.size(this.model.get('password')) === 0) {
                        PJQ.helpers.inputHelpers.setInputError($password, false);
                        hasError = true;
                        if ($scrollTo == null) {
                            $scrollTo = $password;
                        }
                    }
                }

                let $itbUser = this.$('.cb-itb-user'),
                    $pmUser = this.$('.cb-pm-user');
                PJQ.helpers.inputHelpers.setInputError($itbUser, true);
                PJQ.helpers.inputHelpers.setInputError($pmUser, true);
                if (!this.model.get('itbUser') && !this.model.get('pmUser')) {
                    PJQ.helpers.inputHelpers.setInputError($itbUser, false);
                    PJQ.helpers.inputHelpers.setInputError($pmUser, false);
                    hasError = true;
                    $scrollTo = this.$('.cb-itb-user');

                    errorText = 'User must be enabled for either ITB or PM features';
                }
            }
        }

        if (this.options.canEditCustomFields) {
            if (this.contactCustomFieldsForm) {
                if (!this.contactCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditContactCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = this.contactCustomFieldsForm.$el;
                    }
                }
            }
            if (this.companyCustomFieldsForm) {
                if (!this.companyCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditCompanyCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = this.companyCustomFieldsForm.$el;
                    }
                }
            }

            if (this.userCustomFieldsForm) {
                if (!this.userCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditUserCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = this.userCustomFieldsForm.$el;
                    }
                }
            }
        }

        if (hasError) {
            new PJQ.Alert(this.$('.validation-error'), {
                type: 'danger',
                text: errorText
            });

            if ($scrollTo != null) {
                this.scrollTo($scrollTo.offset().top);
            }
            return;
        } else {
            this.$('.validation-error').empty();

            if (this.options.isSelfEdit && !this.model.isDirty) {
                // this is a self edit context and the contact wasn't changed
                // don't save to the api to avoid getting added to the approval queue
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                return;
            }
        }

        let currentGroups = this.model.groups,
            currentCompanyCustomFieldValues = this.model.get('companyCustomFieldValues'),
            currentContactCustomFieldValues = this.model.get('contactCustomFieldValues'),
            currentUserCustomFieldValues = this.model.get('userCustomFieldValues');
        if (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User))) {
            if (this.groupSelector != null) {
                this.model.groups.reset(this.groupSelector.getGroupsData().all);
            }

            this.model.set('userCustomFieldValues', this.userCustomFieldsForm != null ? this.userCustomFieldsForm.getChanged() : null);
        } else if (!(this.model.id < 0)) {
            if (this.groupSelector != null) {
                this.model.groups.reset(this.groupSelector.getGroupsData().all);
            }
            this.model.set('companyCustomFieldValues', this.companyCustomFieldsForm != null ? this.companyCustomFieldsForm.getChanged() : null);
            this.model.set('contactCustomFieldValues', this.contactCustomFieldsForm != null ? this.contactCustomFieldsForm.getChanged() : null);
        }

        let loader = new PJQ.Loader(this.$('.modal-content')),
            isNew = this.model.isNew();
        if (isNew && this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
            this.model.set({
                isPreventAddToProject: !isAddToProject,
                isForceSaveExistingEmail: false
            });
        }

        let currentWorkAreas = new PJQ.collections.workAreas.ContactWorkAreas();
        if (isAddNew) {
            _.each(this.model.workAreas.models, _.bind(function (workArea) {
                if (!workArea.get('isDeleted')) {
                    currentWorkAreas.add(new PJQ.models.workAreas.ContactWorkArea({
                        country: workArea.get('country'),
                        state: workArea.get('state'),
                        county: workArea.get('county'),
                        isDeleted: false,
                        workAreaId: workArea.get('workAreaId')
                    }));
                }
            }, this));
        }

        this.model.save(null, {
            notify: false,
            success: _.bind(function (model, data) {
                if (isAddNew) {
                    this.model = new PJQ.models.projectParticipants.ProjectParticipant({
                        projectId: PJQ.app.session.project.id,
                        contactId: 0,
                        contactCompanyId: this.model.get('contactCompanyId'),
                        companyName: this.model.get('companyName'),
                        masterUserId: PJQ.app.session.user.get('masterUserId'),
                        address1: this.model.get('address1'),
                        address2: this.model.get('address2'),
                        city: this.model.get('city'),
                        state: this.model.get('state'),
                        country: this.model.get('country'),
                        zip: this.model.get('zip'),
                        phone: this.model.get('phone'),
                        fax: this.model.get('fax'),
                        groups: currentGroups,
                        companyCustomFieldValues: currentCompanyCustomFieldValues,
                        contactCustomFieldValues: currentContactCustomFieldValues,
                        userCustomFieldValues: currentUserCustomFieldValues
                    });
                    this.model.groups = currentGroups;
                    this.model.workAreas = currentWorkAreas;

                    if (typeof this.options.onAddNew === 'function') {
                        this.options.onAddNew(this.model);
                    } else {
                        this.render();
                    }
                    return;
                }

                let message = 'Successfully saved contact';
                if (this.options.isSelfEdit) {
                    message = 'Successfully saved your info'

                    if (this.featuresDidChange) {
                        PJQ.app.session.fetchSystemPermissions(function () {
                            PJQ.app.navigator.refreshCommands();
                        });
                    }
                } else {
                    if (this.model instanceof PJQ.models.projectContacts.ProjectContact) {
                        if (isNew) {
                            PJQ.app.session.project.projectContacts.add(this.model);
                            message = 'Successfully added project contact';
                        } else {
                            message = 'Successfully saved project contact';
                        }
                    } else if (this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
                        if (isNew) {
                            PJQ.app.session.project.participants.add(this.model);
                            message = isAddToProject ? 'Successfully added bid participant' : 'Successfully saved contact';
                        } else {
                            message = 'Successfully saved contact';
                        }
                    } else if (this.model instanceof PJQ.models.users.User) {
                        if (isNew) {
                            PJQ.app.session.users.add(this.model);
                            message = 'Successfully added user';
                        } else {
                            message = 'Successfully saved user';
                        }
                    }
                }
                PJQ.notifications.notify.successNotify({
                    message: message
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model, isNew);
                }

                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this),
            error: _.bind(function (model, response) {
                if (typeof callback === 'function') {
                    callback(true);
                }

                loader.remove();
                if (response.responseJSON && response.responseJSON.message) {
                    if (response.responseJSON.message === 'ACTIVE_USERS_EXCEEDS_SEATS') {
                        PJQ.app.session.subscription.getCostsPerUser(_.bind(function (changeCosts) {
                            let subscription = PJQ.app.session.subscription,
                                cost;
                            switch (subscription.id) {
                                case PJQ.constants.subscriptions.types.BASIC:
                                    cost = changeCosts.basic;
                                    break;
                                case PJQ.constants.subscriptions.types.PRO:
                                    cost = changeCosts.pro;
                                    break;
                                case PJQ.constants.subscriptions.types.ENTERPRISE:
                                    cost = changeCosts.enterprise;
                                    break;
                                default:
                                    cost = 0;
                                    break;
                            }
                            let userSeatModal = new PJQ.views.modals.YesNo({
                                header: "Not Enough User Seats",
                                body: "You don't have enough user seats to activate this user.  Would you like to add one?  " + PJQ.helpers.formatHelpers.formatCurrency(cost, 2, true) + " will be charged to your credit card on file.",
                                onYes: _.bind(function () {
                                    PJQ.app.session.changeUserSeats(PJQ.app.session.subscription.get('userSeats') + 1, _.bind(function () {
                                        userSeatModal.removeModal();
                                        this.save();
                                    }, this), _.bind(function () {
                                        PJQ.notifications.notify.errorNotify({
                                            message: 'Encountered an error adding user seats.  Please contact customer service.'
                                        });
                                        this.removeModal();
                                    }, this));
                                }, this)
                            });
                        }, this));
                        return;
                    } else if (response.responseJSON.message === 'EmailExists') {
                        new PJQ.views.modals.YesNo({
                            header: "Email Exists",
                            body: "Another contact in your Address Book has this email address already.   Do you still want to save this record?",
                            onYes: _.bind(function () {
                                this.model.set('isForceSaveExistingEmail', true);
                                loader = new PJQ.Loader(this.$('.modal-content'));
                                this.model.save(null, {
                                    success: _.bind(function () {
                                        let message = 'Successfully saved contact';
                                        if (isNew) {
                                            PJQ.app.session.project.participants.add(this.model);
                                            message = isAddToProject ? 'Successfully added bid participant' : 'Successfully saved contact';
                                        }
                                        PJQ.notifications.notify.successNotify({
                                            message: message
                                        });
                                        if (typeof this.options.onSave === 'function') {
                                            this.options.onSave(this.model, isNew);
                                        }

                                        if (typeof callback === 'function') {
                                            callback(true);
                                        }
                                    }, this),
                                    error: function () {
                                        loader.remove();
                                        PJQ.notifications.notify.errorNotify({
                                            message: 'Failed to save'
                                        });
                                    }
                                }, this);
                            }, this)
                        });
                        return;
                    } else if (response.responseJSON.message === 'USERNAME_EXISTS') {
                        new PJQ.Alert(this.$('.validation-error'), {
                            type: 'danger',
                            text: 'The entered username is already taken'
                        });
                        PJQ.helpers.inputHelpers.setInputError(this.$('.input-username'), false);
                        return;
                    }
                }
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to save'
                });
            }, this)
        });
    },
    scrollTo: function (y) {
        if (typeof this.options.scrollTo === 'function') {
            this.options.scrollTo(y);
        } else {
            this.$el.animate({
                scrollTop: y
            }, 500);
        }
    },
    cancel: function () {
        if (this.model.isDirty && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                }, this)
            });
        } else if (typeof this.options.onCancel === 'function') {
            this.options.onCancel(this.model);
        }
    },
    delete: function () {
        let message = "Are you sure you want to delete this contact?";
        if (this.model instanceof PJQ.models.users.User) {
            message = "Are you sure you want to delete this user?";
        } else if (this.model instanceof PJQ.models.projectContacts.ProjectContact) {
            message = "Are you sure you want to remove this contact from the project?";
        } else if (this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
            message = "Are you sure you want to remove this bid participant from the project?";
        }
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: message,
            onDelete: _.bind(function () {
                this.model.destroy();
                if (this.model instanceof PJQ.models.projectContacts.ProjectContact && PJQ.app.session.project.projectContacts != null) {
                    PJQ.app.session.project.projectContacts.remove(this.model.id);
                    message = "Are you sure you want to remove this contact from the project?";
                } else if (this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
                    PJQ.app.session.project.participants.remove(this.model.id);
                    message = "Are you sure you want to remove this bid participant from the project?";
                }
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
            }, this)
        });
    }
});

PJQ.views.contacts.BaseEditContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-contact-edit-base'),
        canEdit: true,
        minWidth: 600,
        maxWidth: 1200,
        isShowAddContact: false,
        alert: null,
        onDelete: _.noop,
        onCancel: _.noop,
        onSave: _.noop
    },
    events: {
        "click .btn-edit-permissions": "editPermissions",
        "click .btn-edit-notifications": "editNotifications",
        "change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
        "keydown .contact-edit-phone-ext": "numbersOnly",
        "click .btn-send-password-reset": "sendPasswordReset",
        "click .contact-edit-add": "addNew",
        "click .contact-edit-cancel": "cancel",
        "click .contact-edit-save": "save",
        "click .contact-edit-save-without-approval": "saveWithoutApproval",
        "click .contact-edit-save-and-add-project": "saveAndAddToProject",
        "click .contact-edit-delete": "delete"
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.contacts.Contact({
                id: this.options.contactId
            });
        }
        this.listenTo(this.model, 'sync', this.render);
        if (!this.model.isNew() && !this.model.isFetched) {
            this.model.fetch();
        } else if (!this.isRendered) {
            this.render();
        }
    },
    beforeRender: function () {
        PJQ.views.contacts.BaseEditContactView.prototype.initPermissionOptions.call(this);
    },
    renderData: function () {
        return {
            model: this.model,
            isSelfEdit: this.options.isSelfEdit,
            isShowAddContact: this.options.isShowAddContact,
            deleteLabel: this.options.deleteLabel ? this.options.deleteLabel : 'Delete',
            canEdit: this.options.canEdit,
            canEditCustomFields: this.options.canEditCustomFields,
            enablePermissions: this.options.enablePermissions,
            isAdmin: this.options.isAdmin,
            canModifyNotifications: this.options.canModifyNotifications
        };
    },
    shouldRenderInnerView: function () {
        return this.model != null && (this.model.isNew() || this.model.isFetched);
    },
    getContactElement: function () {
        return this.$('.modal-body');
    },
    afterRender: function () {
        if (this.shouldRenderInnerView()) {
            let $cel = this.getContactElement(),
                opts = _.extend(this.getInnerViewOptions(), {
                    el: $cel,
                    len: $cel.length,
                    scrollTo: _.bind(function (y) {
                        $('div.modal').animate({
                            scrollTop: y
                        }, 500);
                    }, this),
                    onAddNew: _.bind(function (model) {
                        this.model = model;
                        this.render();
                    }, this),
                    onSave: _.bind(function (model, isNew, options = {contextClosed: true}) {
                        if (options.contextClosed !== false) {
                            this.removeModal();
                        }
                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(model, isNew);
                        }
                    }, this),
                    onCancel: _.bind(function (model, options = {contextClosed: true}) {
                        if (options.contextClosed !== false) {
                            this.removeModal();
                        }
                        if (typeof this.options.onCancel === 'function') {
                            this.options.onCancel(model);
                        }
                    }, this),
                    onDelete: _.bind(function (model, options = {contextClosed: true}) {
                        if (options.contextClosed !== false) {
                            this.removeModal();
                        }
                        if (typeof this.options.onDelete === 'function') {
                            this.options.onDelete(model);
                        }
                    }, this)
                });
            this.editView = new (this.getInnerViewType())(opts);
        }
    },
    getInnerViewType: function () {
        return PJQ.views.contacts.BaseEditContactView;
    },
    getInnerViewOptions: function () {
        return {
            model: this.model,
            modal: this
        };
    },
    editPermissions: function () {
        this.editView.editPermissions();
    },
    editNotifications: function () {
        this.editView.editNotifications();
    },
    addNew: function () {
        this.editView.save(null, true);
    },
    saveAndAddToProject: function () {
        this.editView.saveAndAddToProject(...arguments);
    },
    save: function () {
        this.editView.save(...arguments);
    },
    cancel: function () {
        this.editView.cancel(...arguments);
    },
    delete: function () {
        this.editView.delete(...arguments);
    }
});

PJQ.views.contacts.SelectContactsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-contacts-select'),
        onCancel: _.noop,
        onSave: _.noop,
        hideContacts: null,
        hideEmails: null,
        disableBadEmail: false,
        disableBlacklisted: false,
        disableContacts: null,
        isSingleChoice: true,
        contacts: null,
        showAddress: false,
        context: PJQ.constants.contacts.contexts.CONTACTS,
        minWidth: '500px',
        width: '100%',
        maxWidth: '1000px',
        userTypeFilter: null,
        isUserTypeFilterDisabled: false,
        titleOverride: null,
        canSwitchContext: false,
        hideUsers: false,
        shouldHideContacts: false,
        enableSelectAll: false,
        saveButtonText: 'Save'
    },
    events: {
        "change .select-contact": "selectContact",
        "click .contacts-select-cancel": "cancel",
        "click .contacts-select-save": "save",
        'click .switch-context': 'switchContext',
        'click .project-contacts-new-contact': 'newContactClicked',
        'click .project-contacts-add-from-bid-participants': 'addFromBidParticipants',
        'click .project-contacts-add-from-address-book': 'addFromAddressBook',
        'click .project-contacts-quick-search': 'quickSearch',
        'click .project-contacts-add-from-project': 'addFromProject',
        'click .project-contacts-add-from-company': 'addFromCompany',
        'click .select-all-contacts': 'selectAllContacts',
    },
    beforeModalCreated: function () {
        this.options.project = PJQ.app.session.project ? PJQ.app.session.project : null;
        this.options.isAdmin = this.options.project ? this.options.project.hasPermission('projectContacts.isAdmin') : false;
        this.selectedContact = this.options.isSingleChoice ? null : [];

        let context = this.options.context;
        if (context === PJQ.constants.contacts.contexts.USERS) {
            if (this.users == null) {
                this.users = new PJQ.collections.users.Users();
                this.listenTo(this.users, 'sync', this.render);
                this.users.fetch();
            } else {
                this.listenTo(this.users, 'sync', this.render);
            }
        } else {
            if (this.options.contacts) {
                this.contacts = this.options.contacts;
            }
            if (this.contacts == null) {
                let contactsRef = [];
                let fnGet = _.bind(function (ctx) {
                    switch (ctx) {
                        case PJQ.constants.contacts.contexts.PARTICIPANTS:
                            return PJQ.app.session.project.participants;
                        case PJQ.constants.contacts.contexts.PROJECTCONTACTS:
                            return PJQ.app.session.project.projectContacts;
                        case PJQ.constants.contacts.contexts.CONTACTS:
                        default:
                            return new PJQ.collections.contacts.Contacts();
                    }
                }, this);
                this.forParticipants = false;
                if (PJQ.helpers.objectHelpers.refinedType(this.options.context) === 'array') {
                    _.each(this.options.context, function (ctx) {
                        contactsRef.push(fnGet(ctx));

                        if (ctx === PJQ.constants.contacts.contexts.PARTICIPANTS) {
                            this.forParticipants = true;
                        }
                    }, this);
                } else {
                    this.contacts = fnGet(this.options.context);

                    if (this.options.context === PJQ.constants.contacts.contexts.PARTICIPANTS) {
                        this.forParticipants = true;
                    }
                }

                let fnContinue = _.bind(function () {
                    if (_.size(contactsRef) > 0) {
                        this.contacts = new PJQ.collections.contacts.Contacts();
                        let fnFetch = (index) => {
                            if (_.size(contactsRef) > index) {
                                contactsRef[index].fetch({
                                    success: _.bind(function (ctn) {
                                        this.contacts.add(ctn.models);
                                        fnFetch(index + 1);
                                    }, this)
                                });
                            } else {
                                this.render();
                            }
                        };
                        fnFetch(0);
                    } else if (this.options.context !== PJQ.constants.contacts.contexts.CONTACTS && !this.contacts.isFetched) {
                        this.contacts.fetch();
                        this.listenTo(this.contacts, 'reset update', _.bind(function () {
                            this.render();
                        }, this));

                        this.listenTo(this.contacts, 'sync', _.bind(function () {
                            this.dataTable.refresh('page');
                        }, this));
                    }
                }, this)

                if (this.forParticipants) {
                    this.options.project.getProjectStatuses(_.bind(function (statuses) {
                        this.projectStatuses = statuses;
                        fnContinue();
                    }, this));
                } else {
                    fnContinue();
                }
            } else {
                this.listenTo(this.contacts, 'reset update', _.bind(function () {
                    this.render();
                }, this));

                this.listenTo(this.contacts, 'sync', _.bind(function () {
                    this.dataTable.refresh('page');
                }, this));
            }
        }
    },
    beforeRender: function () {
        if (this.options.titleOverride) {
            this.options.title = this.options.titleOverride;
        } else {
            if (this.options.context === PJQ.constants.contacts.contexts.USERS) {
                this.options.title = "Select User";
            } else if (this.options.context === PJQ.constants.contacts.contexts.PROJECTCONTACTS) {
                this.options.title = "Select Project Contact";
            } else if (this.options.context === PJQ.constants.contacts.contexts.PARTICIPANTS) {
                this.options.title = "Select Bid Participant";
            } else if (this.options.context === PJQ.constants.contacts.contexts.COMPANIES) {
                this.options.title = "Select Company"
            } else {
                this.options.title = "Select Contact";
            }
        }

        if (!this.options.isSingleChoice) {
            this.options.title += 's';
        }
        this.renderData = {
            options: this.options
        };
    },
    afterRender: function () {
        let columns = [],
            isUsersOnly = this.options.context === PJQ.constants.contacts.contexts.USERS;
        if (isUsersOnly) {
            columns = [
                {
                    "data": "attributes.id",
                    "title": !this.options.enableSelectAll ? "" : '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                    "orderable": false,
                    "searchable": false,
                    "resizable": false,
                    "width": "40px",
                    "render": _.bind(function (data, type, row) {
                        let isSelected = false;
                        if (this.selectedContact != null) {
                            if (this.options.isSingleChoice && this.selectedContact != null) {
                                isSelected = this.selectedContact.id === data;
                            } else {
                                isSelected = _.find(this.selectedContact, function (contact) {
                                    return data === contact.id;
                                }) != null;
                            }
                        }
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (isSelected ? ' checked ' : '') + ' class="select-contact" ' + (row.get('isBlacklisted') ? 'disabled' : '') + '/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this)
                },
                {
                    'title': "Active",
                    "data": "attributes.isActive",
                    'width': '40px',
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (data === true) {
                            content = '<i class="fas fa-circle" style="color: #5cb85c"><div hidden>true</div></i>'
                        } else {
                            content = '<i class="fas fa-circle" style="color: #d9534f"><div hidden>false</div></i>'
                        }
                        return content
                    })
                },
                {
                    "title": "Type",
                    "width": "120px",
                    "orderable": true,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let userType;
                        if (row.userType != null) {
                            userType = row.userType;
                        } else {
                            userType = PJQ.app.session.userTypes.getDefault(row.get('id') < 0);
                        }
                        if (type === 'sort') {
                            return userType.get('sortOrder');
                        }
                        return '<span style="color:' + userType.get('color') + ';">' + userType.get('name') + '</span>';
                    }, this)
                },
                {"data": "attributes.contactName", "title": "Contact Name"},
                {"data": "attributes.email", "title": "Email"}
            ];
        } else {
            columns = [
                {
                    "data": "attributes.id",
                    "title": !this.options.enableSelectAll ? "" : '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                    "orderable": false,
                    "searchable": false,
                    "resizable": false,
                    "width": "40px",
                    "render": _.bind(function (data, type, row) {
                        let isSelected = false, isDisabled = false;

                        if (this.selectedContact != null) {
                            if (this.options.isSingleChoice) {
                                isSelected = this.selectedContact.id === data;
                            } else {
                                isSelected = _.find(this.selectedContact, function (contact) {
                                    return data === contact.id;
                                }) != null;
                            }
                        }

                        if (row.get('isBlacklisted')) {
                            isDisabled = true
                        } else if (this.options.disableContacts) {
                            if (this.options.isSingleChoice) {
                                if (this.options.disableContacts.id === data) {
                                    isDisabled = true;
                                }
                            } else {
                                if (_.find(this.options.disableContacts, function (disableContact) {
                                    return disableContact.id === data;
                                }) !== undefined) {
                                    isSelected = true;
                                    isDisabled = true;
                                }
                            }
                        }

                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (isSelected ? 'checked' : '') + (isDisabled ? ' disabled' : '') + ' class="select-contact"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this)
                },
                {
                    "data": "userType",
                    "title": "Type",
                    "width": "120px",
                    "orderable": true,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let userType;
                        if (row.userType != null) {
                            userType = row.userType;
                        } else {
                            userType = PJQ.app.session.userTypes.getDefault(row.get('id') < 0);
                        }
                        if (type === 'sort') {
                            return userType.get('sortOrder');
                        }
                        return '<span style="color:' + userType.get('color') + ';">' + userType.get('name') + '</span>';
                    }, this)
                },
                {"data": "attributes.companyName", "title": "Company Name"},
                {"data": "attributes.contactName", "title": "Contact Name"},
                {"data": "attributes.email", "title": "Email"}
            ];

            if (this.projectStatuses != null) {
                columns.push({
                    "data": "attributes.status",
                    "title": 'Status',
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let status = _.size(data) > 0 ? data.toUpperCase() : 'PENDING';
                        return '<span style="color:' + this.getStatusColor(status) + '">' + status + '</span>';
                    }, this)
                });
            }
        }

        if (this.options.showAddress) {
            columns.push({"data": "attributes.address1", "title": "Address"});
            columns.push({"data": "attributes.city", "title": "City"});
            columns.push({"data": "attributes.state", "title": "State"});
        }

        let getPageCallback = null,
            data;
        if (this.options.context === PJQ.constants.contacts.contexts.CONTACTS) {
            getPageCallback = _.bind(function (pageNumber, pageSize, orderArr, callback) {
                let order = orderArr[0];
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'contacts'
                        }], [
                        {
                            parameter: 'search',
                            value: this.$('.datatable-search').val(),
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'page',
                            value: pageNumber
                        },
                        {
                            parameter: 'pageSize',
                            value: pageSize
                        },
                        {
                            parameter: 'orderBy',
                            value: order.name,
                        },
                        {
                            parameter: 'orderDirection',
                            value: order.direction
                        },
                        {
                            parameter: 'userTypes',
                            value: this.dataTable ? this.dataTable.userTypeFilter : null,
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'projectId',
                            value: this.options.project ? this.options.project.id : null,
                            includeIfEmpty: false
                        }
                    ])
                }).get().success(_.bind(function (data) {
                    let newContacts = new PJQ.collections.contacts.Contacts(data.contacts);
                    callback(newContacts.models, data.totalRows);
                }, this)).fail(_.bind(function (xhr) {
                    callback();
                }, this));
            }, this);
        } else if (this.options.context === PJQ.constants.contacts.contexts.COMPANIES) {
            getPageCallback = _.bind(function (pageNumber, pageSize, orderArr, callback) {
                let order = orderArr[0];
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'companiessimple'
                        }], [
                        {
                            parameter: 'search',
                            value: this.$('.datatable-search').val(),
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'page',
                            value: pageNumber
                        },
                        {
                            parameter: 'pageSize',
                            value: pageSize
                        },
                        {
                            parameter: 'orderBy',
                            value: order.name,
                        },
                        {
                            parameter: 'orderDirection',
                            value: order.direction
                        },
                        {
                            parameter: 'userTypes',
                            value: this.dataTable ? this.dataTable.userTypeFilter : null,
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'projectId',
                            value: this.options.project ? this.options.project.id : null,
                            includeIfEmpty: false
                        }
                    ])
                }).get().success(_.bind(function (data) {
                    let newContacts = new PJQ.collections.contacts.Contacts(data.companies);
                    callback(newContacts.models, data.totalRows);
                }, this)).fail(_.bind(function (xhr) {
                    callback();
                }, this));
            }, this);
        } else {
            data = this.getContactsList();
        }

        if (_.size(data) > 0 && this.options.hideUsers) {
            data = _.filter(data, function (model) {
                return model.get('contactId') > 0;
            }, this)
        }

        if (_.size(data) > 0 && this.options.shouldHideContacts) {
            data = _.filter(data, function (model) {
                return model.get('contactId') == null;
            }, this)
        }

        let userTypes,
            zeroRecordsLabel,
            emptyTableLabel;

        if ((this.options.context === PJQ.constants.contacts.contexts.USERS)) {
            userTypes = PJQ.app.session.userTypes.getByIsCompany(true);
            zeroRecordsLabel = "No users match the search criteria";
            if (_.size(data) === 0 && _.size(this.users.models) > 0) {
                emptyTableLabel = "All users have already been added";
            } else {
                emptyTableLabel = "You don't have any other users in your company";
            }
        } else if (this.options.context === PJQ.constants.contacts.contexts.PARTICIPANTS) {
            userTypes = PJQ.app.session.userTypes.getByIsCompany(false);
            zeroRecordsLabel = "No bid participants match the search criteria";
            if (_.size(data) === 0 && _.size(this.contacts.models) > 0) {
                emptyTableLabel = "All bid participants have already been added";
            } else {
                emptyTableLabel = "No bid participants have been added to this project";
            }
        } else if (this.options.context === PJQ.constants.contacts.contexts.PROJECTCONTACTS) {
            userTypes = PJQ.app.session.userTypes.getByIsCompany();
            zeroRecordsLabel = "No project contacts match the search criteria";
            if (_.size(data) === 0 && (this.contacts == null || _.size(this.contacts.models) > 0)) {
                emptyTableLabel = "All project contacts have already been added";
            } else {
                emptyTableLabel = "No project contacts have been added to this project";
            }
        } else {
            if (this.options.context === PJQ.constants.contacts.contexts.CONTACTS) {
                userTypes = PJQ.app.session.userTypes.getByIsCompany(false);
            } else {
                userTypes = _.union(PJQ.app.session.userTypes.getByIsCompany(), PJQ.app.session.userTypes.getByIsCompany(false));
            }
            zeroRecordsLabel = "No contacts match the search criteria";
            if (_.size(data) === 0 && (this.contacts == null || _.size(this.contacts.models) > 0)) {
                emptyTableLabel = "All contacts have already been added";
            } else {
                emptyTableLabel = "No contacts match the search criteria";
            }
        }

        this.dataTable = new PJQ.views.contacts.ContactSelectDataTable({
            el: this.$('.contacts-data-table'),
            data: data,
            deferRender: true,
            order: this.options.context === PJQ.constants.contacts.contexts.USERS ? [2, 'asc'] : [1, 'asc'],
            columns: columns,
            userTypeFilter: this.options.userTypeFilter,
            isUserTypeFilterDisabled: this.options.isUserTypeFilterDisabled,
            headerData: {
                userTypes: userTypes,
                projectStatuses: this.projectStatuses,
                filterGroups: this.forParticipants,
                context: this.options.context,
                isAdmin: this.options.isAdmin
            },
            language: {
                emptyTable: emptyTableLabel,
                zeroRecords: zeroRecordsLabel
            },
            getPageCallback: getPageCallback,
            createdRow: _.bind(this.createdRow, this)
        });
    },
    getStatusColor: function (name) {
        let status = _.find(this.projectStatuses, function (status) {
            return status.name.toUpperCase() === name.toUpperCase();
        });

        return status != null ? status.backgroundColor : "#eee";
    },
    switchContext: function () {
        this.options.context = this.options.context === PJQ.constants.contacts.contexts.CONTACTS ? PJQ.constants.contacts.contexts.USERS : PJQ.constants.contacts.contexts.CONTACTS
        this.render();
    },
    getContactsList: function () {
        let contacts = [];
        if (this.users != null && this.users.length > 0)
            contacts = _.union(contacts, this.users.models);
        if (this.contacts != null && this.contacts.length > 0)
            contacts = _.union(contacts, this.contacts.models);

        if (this.options.hideContacts) {
            if (this.options.isSingleChoice) {
                contacts = _.filter(contacts, _.bind(function (contact) {
                    return (contact.id !== this.options.hideContacts.id);
                }, this));
            } else {
                contacts = _.filter(contacts, _.bind(function (contact) {
                    return _.find(this.options.hideContacts, (hideContact) => {
                        return hideContact.id === contact.id || (this.options.context === PJQ.constants.contacts.contexts.USERS && hideContact.id < 0 && -hideContact.id === contact.id);
                    }) == null;
                }, this));
            }
        }

        if (this.options.hideEmails && Array.isArray(this.options.hideEmails) && _.size(this.options.hideEmails) > 0) {
            let hideEmailsLower = this.options.hideEmails.map(email => email.toLowerCase());
            contacts = _.filter(contacts, (contact) => {
                let contactEmail = contact.get('email')?.toLowerCase();
                return !hideEmailsLower.includes(contactEmail);
            });
        }

        return contacts;
    },
    createdRow: function (row, data, dataIndex) {
        if (data.attributes.isBlacklisted)
            $(row).css({cssText: 'text-decoration: line-through !important;'});
    },
    selectAllContacts: function (e) {
        let $target = $(e.currentTarget),
            isChecked = $target.prop('checked');

        if (!isChecked) {
            this.selectedContact = (this.options.isSingleContact ? null : []);
        } else {
            this.selectedContact = this.getContactsList();
        }

        this.$('.select-contact').prop('checked', isChecked);
        this.$('.contacts-select-save').prop('disabled', this.selectedContact == null || _.size(this.selectedContact) === 0);
    },
    selectContact: function (e) {
        let target = $(e.currentTarget),
            isSelected = target.prop('checked');
        if (this.options.isSingleChoice)
            this.$('.select-contact').not(target).prop('checked', false);

        let data = this.dataTable.dataTable.row(target.parents('tr')).data();
        if (isSelected) {
            if (this.options.isSingleChoice)
                this.selectedContact = data;
            else
                this.selectedContact.push(data);
        } else {
            if (this.options.isSingleChoice)
                this.selectedContact = null;
            else
                this.selectedContact = _(this.selectedContact).filter(function (item) {
                    return item.attributes.id !== data.attributes.id
                });
        }
        this.$('.contacts-select-save').prop('disabled', this.selectedContact == null || _.size(this.selectedContact) === 0);
    },
    addFromBidParticipants: function () {
        this.options.project.fetchParticipants(_.bind(function (participants) {
            new PJQ.views.contacts.SelectContactsModal({
                contacts: participants,
                hideContacts: this.contacts.models,
                context: PJQ.constants.contacts.contexts.PARTICIPANTS,
                isSingleChoice: false,
                subtitle: "Add Project Contacts from Bid Participants",
                onSave: _.bind(function (selectedContacts) {
                    this.contacts.addContactsToProject(_.map(selectedContacts, function (contact) {
                        return contact.id;
                    }), () => {
                        this.render();
                    });
                }, this)
            });
        }, this));
    },
    addFromAddressBook: function () {
        $('form[name="modal-add-participants"]').remove();
        let options = {
            onSave: (selectedContactsAll, data) => {
                this.contacts.addContactsToProject(selectedContactsAll, () => {
                    this.render();
                });
            },
            disableContacts: _.map(this.contacts.models, function (contact) {
                return contact.id;
            })
        };

        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
            options.isWrapForm = false;
            options.wrapFormName = null;
            options.isUseNewAddressBook = true;
            options.isMultipleProjects = true;
        }

        new PJQ.views.projects.AddParticipantsDetailedModal(options);
    },
    quickSearch: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.CONTACTS,
            isSingleChoice: false,
            project: this.options.project,
            subtitle: "Add Project Contacts From Address Book",
            onSave: _.bind(function (selectedContacts) {
                this.contacts.addContactsToProject(_.map(selectedContacts, function (contact) {
                    return contact.id;
                }), () => {
                    this.render();
                });
            }, this)
        });
    },
    addFromProject: function () {

    },
    addFromCompany: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.USERS,
            isSingleChoice: false,
            hideContacts: this.contacts.models,
            subtitle: "Add Project Contacts from My Company Users",
            onSave: _.bind(function (selectedContacts) {
                this.contacts.addContactsToProject(_.map(selectedContacts, function (contact) {
                    return -contact.id;
                }), () => {
                    this.render();
                });
            }, this)
        });
    },
    newContactClicked: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                projectId: this.options.project.id,
                country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US'
            })
        });
    },
    newUserClicked: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                projectId: this.options.project.id
            })
        });
    },
    save: function () {
        let callback = _.bind(function () {
            this.options.onSave(this.selectedContact);
            this.removeModal();
        }, this);

        if (this.options.disableBadEmail) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'checkpcg'
                    }]),
                data: {
                    contactIds: this.options.isSingleChoice ? [this.selectedContact] : _.map(this.selectedContact, function (selectedContact) {
                        return selectedContact.get('contactId');
                    }),
                    contactCompanyIds: [],
                    contactGroupIds: []
                }
            }).post().done(_.bind(function (data) {
                if (data.results.length > 0) {
                    new PJQ.views.projects.AddParticipantsErrorModal({
                        data: data.results,
                        onContinue: _.bind(function () {
                            // remove bad items from this.selectedContact
                            _.each(data.results, _.bind(function (contact) {
                                if (this.options.isSingleChoice && contact.contactId === this.selectedContact.get('contactId'))
                                    this.selectedContact = null;
                                else if (!this.options.isSingleChoice) {
                                    this.selectedContact = _.filter(this.selectedContact, _.bind(function (selectedContact) {
                                        return selectedContact.get('contactId') !== contact.contactId;
                                    }, this));
                                }
                            }, this));

                            callback();
                        }, this)
                    });
                } else
                    callback();

            }, this)).fail(function () {
            });
        } else {
            callback();
        }
    },
    cancel: function () {
        this.options.onCancel();
    }
});

PJQ.views.contacts.ContactSelectDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Contact-Select')
        },
        userTypeFilter: null,
        isUserTypeFilterDisabled: false
    },
    events: {
        'keyup .datatable-search': 'search',
        "click .btn-filter-groups": "filterGroups",
        'click .contact-select-clear-filters': 'clearFilters'
    },
    beforeDataTableRender: function () {
        if (this.options.userTypeFilter)
            this.userTypeFilter = this.options.userTypeFilter;

        this.filterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contacts-filter'),
            onChange: _.bind(function (value) {
                let companyUserTypes = value["companyUserType"],
                    contactUserTypes = value["contactUserType"];

                this.userTypeFilter = [];
                if (_.size(companyUserTypes) > 0) {
                    this.userTypeFilter.push(...companyUserTypes);
                }
                if (_.size(contactUserTypes) > 0) {
                    this.userTypeFilter.push(...contactUserTypes);
                }

                this.projectStatusFilter = value["projectStatus"];

                this.filter();
            }, this),
            isGrouped: true,
            isMultiple: true,
            isDisabled: this.options.isUserTypeFilterDisabled,
            defaultValue: this.userTypeFilter,
            noneSelectedText: 'No Filters'
        });
    },
    getFilterData: function () {
        if (_.size(this.userTypeFilter) === 0 && _.size(this.projectStatusFilter) === 0 && _.size(this.groupsFilter) === 0) {
            return this.options.data;
        }

        let results = this.options.data;
        if (_.size(this.userTypeFilter) > 0) {
            results = _.filter(results, function (row) {
                return _.contains(this.userTypeFilter, row.userType.id.toString());
            }, this);
        }

        if (_.size(this.groupsFilter) > 0) {
            results = _.filter(results, function (row) {
                let noGroups = _.contains(this.groupsFilter, 0);
                return (noGroups && _.size(row.groups.models) === 0) || _.find(row.groups.models, _.bind(function (group) {
                    return _.contains(this.groupsFilter, group.id);
                }, this)) != null;
            }, this);
        }

        if (_.size(this.projectStatusFilter) > 0) {
            return _.filter(results, function (row) {
                let st = row.get('status');
                if (_.size(st) === 0) {
                    st = "PENDING";
                }
                return _.size(st) > 0 && _.contains(this.projectStatusFilter, st.toUpperCase());
            }, this);
        } else {
            return results;
        }
    },
    filterGroups: function () {
        new PJQ.views.addressbook.FilterTradesModal({
            selectedGroups: this.groupsFilter,
            onFilter: _.bind(function (groups) {
                this.updateGroupsFilter(groups);
                this.filter();
            }, this)
        });
    },
    updateGroupsFilter: function (groups) {
        this.groupsFilter = groups;

        let groupLen = _.size(groups)
        this.$('.filter-groups-text').text((groupLen > 0 ? groupLen.toString() : 'All') + ' Trades');
    },
    afterSearch: function () {
        this.$('.contact-select-clear-filters').prop('disabled', _.size(this.$('input.datatable-search').val()) === 0 && _.size(this.userTypeFilter) === 0 && _.size(this.projectStatusFilter) === 0 && _.size(this.groupsFilter) === 0);
    },
    clearFilters: function () {
        this.userTypeFilter = null;
        this.projectStatusFilter = null;
        this.updateGroupsFilter(null);
        this.filterPicker.deselectAll();
        this.$('input.datatable-search').val('');
        this.filter();
    }
});

PJQ.views.contacts.ContactsSelectInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input'),
        subTemplates: {
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts')
        },
        contacts: null,
        selectedContact: null,
        disableContacts: null,
        isSingleChoice: true,
        isShowAddButtonByLabel: true,
        addButton: null,
        onAdd: _.noop,
        onChange: _.noop,
        onDelete: _.noop,
        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
        emptyNotice: "No Contacts Selected",
        isRequired: false,
        isReadOnly: null, // this value is null by default, if its not null it will be used to set canEdit
        showSelectorAddress: false,
        contactsRenderData: null,
        isSortable: false,
        onStop: _.noop,
        canSwitchContext: false,
        canViewContacts: null,
        canEdit: true,
        hideUsers: false,
        shouldHideContacts: false,
        saveButtonText: null
    },
    events: {
        "click .btn-approve-behalf": "approveBehalf",
        "click .contact-select-input-add": "edit",
        "click .contact-select-input-delete": "deleteContact"
    },
    beforeRender() {
        this.selectedContact = this.options.selectedContact ? this.options.selectedContact : (this.options.isSingleChoice ? null : []);

        if (!this.options.isSingleChoice && this.selectedContact != null && PJQ.helpers.objectHelpers.refinedType(this.selectedContact) !== 'array') {
            this.selectedContact = [this.selectedContact];
        }

        if (this.options.isReadOnly != null) {
            this.options.canEdit = !this.options.isReadOnly;
        }
    },
    afterRender() {
        if (this.options.addButton != null && this.options.canEdit) {
            this.options.addButton.off().on('click', _.bind(this.edit, this));
        } else if (this.options.canEdit) {
            let addButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm contact-select-input-add ml-1"><i class="fal fa-pencil"></i></button>');
            if (this.options.isShowAddButtonByLabel) {
                this.$el.closest('.form-group').find('label').append(addButton);
                addButton.on('click', _.bind(this.edit, this));
            } else {
                this.find('.contact-select-input-buttons').append(addButton);
            }
        }

        if (this.options.isSortable) {
            let self = this;
            self.approversSortable = new PJQ.Sortable(self.$('.contact-select-list'), {
                containment: "document",
                items: '.select-contact-container',
                connectWith: '.select-contact-container',
                onStop: _.bind(function () {
                    // self.options.onStop();
                    let dataArray = []
                    self.$('.select-contact-container').each(function (a, b) {
                        let data = $(b).data('contactId');
                        dataArray.push(data);
                    });
                    self.options.onStop(dataArray);
                }, this)
            });
        }

        this.renderSelectedContact();
    },
    approveBehalf: function (e) {
        let id = $(e.target).closest('.select-contact-container').data('contactId'),
            contact = _.find(this.selectedContact, function (contact) {
                return contact.id === id
            });
        if (typeof this.options.onApproveBehalf === 'function') {
            this.options.onApproveBehalf(contact);
        }
    },
    deleteContact: function (e) {
        let cid = $(e.target).closest('.select-contact-container').data('cid');
        if (this.options.isSingleChoice) {
            this.options.onDelete(this.selectedContact, null);
            this.options.onChange(null);
            this.selectedContact = null;
        } else {
            let deletedContact = _.find(this.selectedContact, function (contact) {
                return contact.cid === cid;
            });
            if (deletedContact != null) {
                this.selectedContact = _.filter(this.selectedContact, function (contact) {
                    return contact.cid !== cid;
                });
                this.options.onDelete(deletedContact, this.selectedContact);
                this.options.onChange(this.selectedContact);
            }
        }
        this.renderSelectedContact();
    },
    edit: function () {
        this.selector = new PJQ.views.contacts.SelectContactsModal({
            contacts: this.options.contacts,
            hideUsers: this.options.hideUsers,
            shouldHideContacts: this.options.shouldHideContacts,
            hideContacts: this.options.allowDuplicate ? null : this.selectedContact,
            disableContacts: this.options.disableContacts,
            context: this.options.context,
            canSwitchContext: this.options.canSwitchContext,
            showAddress: this.options.showSelectorAddress,
            isSingleChoice: this.options.isSingleChoice,
            saveButtonText: this.options.saveButtonText,
            onSave: (newContacts) => {
                if (this.options.allowDuplicate && !this.options.isSingleChoice) {
                    this.selectedContact.push(...newContacts);
                } else {
                    this.selectedContact = this.options.isSingleChoice ? newContacts : _.union(this.selectedContact, newContacts);
                }
                this.renderSelectedContact();
                this.options.onAdd(newContacts, this.selectedContact);
                this.options.onChange(this.selectedContact);
            }
        });
    },
    renderSelectedContact: function () {
        let data = this.selectedContact;
        if (this.selectedContact && this.options.isSingleChoice)
            data = [this.selectedContact];

        if (_.size(data) === 0) {
            this.$('.contact-select-list').html('<div class="text-muted font-weight-light mt-1 fs-16">' + this.options.emptyNotice + '</div>');
        } else {
            let crd;
            if (typeof this.options.contactsRenderData === 'function') {
                crd = this.options.contactsRenderData(data);
            } else {
                crd = this.options.contactsRenderData ? this.options.contactsRenderData : {};
            }

            this.renderSubTemplate(false, this.options.subTemplates.contactBadge, this.$('.contact-select-list'),
                {
                    models: data,
                    contactsRenderData: crd,
                    isSingleChoice: this.options.isSingleChoice,
                    displayContactsBlock: this.options.displayContactsBlock,
                    canView: this.options.canViewContacts ?? this.options.canEdit,
                    canEdit: this.options.canEdit
                });
        }
    },
    validate: function () {
        if (_.size(this.selectedContact) > 0) {
            return true;
        } else {
            this.$('.contact-select-list').html('<div class="text-danger mt-1">This field is required.</div>');
            return false;
        }
    }
});

PJQ.views.contacts.ReportContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Report-Contact'),
        minWidth: '400px',
        reason: "",
        onReport: null,
        showRemoveFromProject: false
    },
    events: {
        'keyup .input-other-reason': 'otherReasonChanged',
        'click .btn-report': 'reportParticipant'
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            noneSelectedText: 'Select Reason',
            el: this.$('.select-reason'),
            onChange: _.bind(function (value) {
                if (value && value.toLowerCase() === 'other') {
                    this.$('.other-reason').removeClass('hidden');
                } else {
                    this.$('.other-reason').addClass('hidden');
                }
                this.setReason(value);
            }, this)
        });

        if (this.options.showRemoveFromProject)
            this.$('.remove-from-project').removeClass('hidden');
    },
    otherReasonChanged: function (e) {
        this.setReason($(e.currentTarget).val());
    },
    setReason: function (reason) {
        this.options.reason = reason;
        this.$('.btn-report').prop('disabled', _.size(this.options.reason) === 0);
    },
    reportParticipant: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.options.contactId
                },
                {
                    endpoint: 'report'
                }
            ]),
            data: {
                projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null,
                reason: this.options.reason,
                removeFromProject: this.$('.input-remove-from-project').prop('checked')
            }
        }).post().done(_.bind(function (data) {
            if (typeof this.options.onReport === 'function') {
                this.options.onReport(this.$('.input-remove-from-project').prop('checked'));
            }

            this.removeModal();

            PJQ.notifications.notify.successNotify({
                message: 'Contact successfully reported'
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.removeModal();

            PJQ.notifications.notify.errorNotify({
                message: 'Failed to report contact'
            });

            new PJQ.logging.Debug(PJQ.logging.LoggingActions.REPORT_CONTACT, {
                error: err,
                result: result
            });
        }, this));
    }
});

PJQ.models.contacts.ContactImportUpload = PJQ.models.BaseModel.extend({
    defaults: {
        isFileAPI: true
    },
    idAttribute: 'contactImportUploadId',
    endpoint: function (urlOptions) {
        let params = [];
        if (urlOptions != null) {
            if (urlOptions.overwrite) {
                params.push({
                    parameter: 'overwrite',
                    value: true
                });
            } else if (urlOptions.skip) {
                params.push({
                    parameter: 'skip',
                    value: true
                });
            }

            if (urlOptions.createGroups) {
                params.push({
                    parameter: 'createGroups',
                    value: true
                });
            }
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'imports',
                value: this.id
            }
        ], params);
    },
    parse: function (model) {
        this.columns = new PJQ.collections.contacts.ContactImportUploadColumns(model ? model.columns : null);
        return model;
    }
});

PJQ.collections.contacts.ContactImportUploads = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactImportUpload,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'imports'
            }
        ]);
    }
});

PJQ.models.contacts.ContactImportUploadColumn = PJQ.models.BaseModel.extend({
    idAttribute: 'index',
    parse: function (model) {
        if (model && model.customField != null) {
            this.customField = new PJQ.models.customFields.CustomField(model.customField);
        }
        return model;
    }
});

PJQ.collections.contacts.ContactImportUploadColumns = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactImportUploadColumn
});

PJQ.views.contacts.ContactsImportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Contacts-Import'),
        minWidth: '70%',
        maxWidth: '90%',
        contextUpload: null
    },
    events: {
        'click .btn-export-template': 'exportTemplate',
        'click .btn-import': 'import',
        'click .btn-cancel': 'cancel'
    },
    renderData: function () {
        return {
            contextUpload: this.options.contextUpload
        };
    },
    afterRender: function () {
        if (this.collection == null) {
            this.collection = new PJQ.collections.contacts.ContactImportUploads();
            this.collection.fetch({
                success: _.bind(function () {
                    this.renderUI();
                }, this)
            });
        } else {
            this.renderUI();
        }
    },
    renderUI: function () {
        if (this.options.contextUpload != null) {
            this.renderUploadEdit();
        } else {
            this.renderImportUploadPicker();
        }
    },
    renderImportUploadPicker: function () {
        let $container = this.$('.contacts-import-container');
        new PJQ.views.contacts.ContactsImportUploadsSelect({
            el: $container,
            collection: this.collection,
            viewImportUploadCallback: _.bind(function (upload) {
                upload.fetch({
                    success: _.bind(function () {
                        $container.empty();
                        new PJQ.Loader($container);
                        this.options.contextUpload = upload;
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    renderUploadEdit: function () {
        let $container = this.$('.contacts-import-container');
        this.editor = new PJQ.views.contacts.ContactsImportUploadEdit({
            el: $container,
            model: this.options.contextUpload,
            onDone: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        this.options.contextUpload = null;
                        this.render();
                    }, this)
                });
            }, this),
            onCancel: _.bind(function () {
                this.renderImportUploadPicker();
            }, this)
        });
    },
    exportTemplate: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'imports'
            },
            {
                endpoint: 'template'
            }
        ]));
    },
    import: function () {
        this.editor.import();
    },
    cancel: function () {
        this.options.contextUpload = null;
        this.render();
    }
});

PJQ.views.contacts.ContactsImportUploadsSelect = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Import-Uploads-Select')
    },
    events: {
        'click .view-contact-import-upload': 'viewImportUpload',
        'click .delete-contact-import-upload': 'deleteImportUpload'
    },
    beforeRender: function () {
        this.renderData = {
            collection: this.collection
        };
    },
    afterRender: function () {
        this.renderUploads();
        this.renderFileUploader();
    },
    renderUploads: function () {
        _.each(this.collection.models, function (model) {
            model.set('displayUploadedOn', PJQ.helpers.dateHelpers.getDateString(new Date(model.get('uploadedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME))
        });

        this.uploadsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.contacts-import-upload-data-table'),
            data: this.collection.models,
            language: {
                zeroRecords: "You haven't uploaded any contact imports yet"
            },
            isHideSearch: true,
            columns: [
                {"data": "attributes.fileName", "title": "File Name"},
                {"data": "attributes.uploadedBy", "title": "Uploaded By"},
                {"data": "attributes.displayUploadedOn", "title": "Uploaded On"},
                {
                    "title": "",
                    "width": "80px",
                    "orderable": false,
                    "searchable": false,
                    "render": function (data, type, row) {
                        let status = row.get('status');
                        if (status === 1) {
                            return '<span class="text-info fs-16 font-weight-light">Processing...</span>';
                        } else if (status === 2) {
                            return '<span class="text-success fs-16 font-weight-light">Imported</span>';
                        } else {
                            return '<div class="text-align-center"><button type="button" class="btn btn-info view-contact-import-upload mr-1"><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-contact-import-upload"><i class="fal fa-trash"></i></button></div>';
                        }
                    }
                }
            ],
            onRowDoubleClick: _.bind(function (row) {
                let im = row.data();
                if (im.get('status') === 0) {
                    this.options.viewImportUploadCallback(im);
                }
            }, this)
        });
    },
    renderFileUploader: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.contacts-import-file-upload'),
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'imports'
                }
            ]),
            isRemoveOnComplete: true,
            allowedExtensions: ['xls', 'xlsx'],
            onSuccess: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        this.renderUploads();
                    }, this)
                })
            }, this)
        });
    },
    viewImportUpload: function (e) {
        let row = this.uploadsDataTable.getRow($(e.currentTarget).parents('tr'));
        this.options.viewImportUploadCallback(row.data());
    },
    deleteImportUpload: function (e) {
        let row = this.uploadsDataTable.getRow($(e.currentTarget).parents('tr')),
            upload = row.data();

        upload.destroy();
        this.collection.remove(upload);
        row.remove();
        this.uploadsDataTable.refresh();
    }
});

PJQ.views.contacts.ContactsImportUploadEdit = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Import-Uploads-Edit')
    },
    events: {
        'click .btn-map-groups': 'mapGroups',
        'click .delete-contact-import-upload-row': 'deleteRow',
        'click .btn-edit-groups': 'editGroups',
        'click .btn-edit-work-areas': 'editWorkAreas',
        'keyup .input-text': 'textValueChanged',
        'keydown .input-int': 'numbersOnly',
        'keyup .input-int': 'intValueChanged',
        'change select.input-state': 'stateValueChanged',
        'change select.input-country': 'countryValueChanged',
        'keyup .input-phone': 'phoneValueChanged',
        'change select.input-bool': 'boolValueChanged',
        'change select.input-choice': 'singleChoiceValueChanged'
    },
    afterRender: function () {
        PJQ.app.session.fetchUserGroups(null, _.bind(function (groups) {
            this.groups = groups;
            this.renderImportUploadData();
        }, this));

        this.$el.closest('.modal').find('.cb-overwrite').on('change', _.bind(this.overwriteOptionChanged, this));
    },
    deleteRow: function (e) {
        let $target = $(e.currentTarget),
            row = this.dataTable.getRow($target.closest('tr'));
        this.dataTable.removeRow(row);
        this.model.set('rows', _.filter(this.model.get('rows'), function (exRow) {
            return exRow.index !== row.data().index;
        }));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    },
    textValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val();
    },
    intValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr')),
            parsedVal = parseInt($target.val());
        row.data().columnData[attr] = isNaN(parsedVal) ? 0 : parsedVal;
    },
    stateValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val();
    },
    countryValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            country = $target.val();

        if (country !== row.data().columnData[attr]) {
            let $state = $row.find('.input-state'),
                $options = this.getStateOptions(country, $state.val());
            $state.empty();
            $state.append($options);

            PJQ.helpers.inputHelpers.inputMaskZip($row.find('.input-zip'), country);
        }

        row.data().columnData[attr] = country;
    },
    getStateOptions: function (country, selectedState) {
        let options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[_.size(country) === 0 ? "us" : country.toLowerCase()], function (state) {
            let lowerAbbr = state.abbreviation.toLowerCase();
            options += '<option ' + (selectedState === lowerAbbr || selectedState === state.name.toLowerCase() ? 'selected' : '') + ' value="' + lowerAbbr + '">' + state.abbreviation.toUpperCase() + '</option>';
        });
        return options;
    },
    phoneValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = PJQ.helpers.formatHelpers.numbersOnly($target.val());
    },
    boolValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val() === 'true';
    },
    singleChoiceValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val();
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        };
    },
    getColumnWidth: function (column) {
        let width = null;
        switch (column.get('attribute').toLowerCase()) {
            case 'companyname':
            case 'contactname':
                width = '150px';
                break;
            case 'title':
                width = '100px';
                break;
            case 'email':
                width = '200px';
                break;
            case 'address1':
            case 'address2':
                width = '120px';
                break;
            case 'notes':
                width = '200px';
                break;
            case 'groups':
                width = '100px';
                break;
        }

        if (width == null) {
            switch (column.get('type').toLowerCase()) {
                case 'choice':
                    width = '80px';
                    break;
                case 'int':
                    width = '60px';
                    break;
                case 'bool':
                    width = '50px';
                    break;
                case 'phone':
                    width = '100px';
                    break;
                case 'text':
                    width = '100px';
                    break;
                case 'regions':
                case 'groups':
                case 'workareas':
                    width = '80px';
                    break;
                case 'state':
                case 'country':
                case 'zip':
                    width = '50px';
                    break;
            }
        }
        return width;
    },
    renderImportUploadData: function () {
        this.unmatchedGroups = [];
        let columns = [],
            noEmailOrFax = false;
        _.each(this.model.columns.models, function (column) {
            let attrCamel = PJQ.helpers.objectHelpers.convertObjectCamelcase(column.get('attribute'));
            columns.push({
                data: "columnData." + attrCamel,
                title: column.get('name'),
                width: this.getColumnWidth(column),
                render: _.bind(function (data, type, row) {
                    if (type === 'sort' || type === 'type')
                        return data;

                    let input,
                        isValid = true;
                    switch (column.get('type').toLowerCase()) {
                        case 'choice':
                            if (column.customField != null) {
                                let options = '<option value="">No Value</option>';
                                _.each(column.customField.choices.models, function (choice) {
                                    let selected;
                                    if (PJQ.helpers.objectHelpers.refinedType(data) === 'array') {
                                        selected = data && data.indexOf(choice.id) !== -1;
                                    } else {
                                        selected = data === choice.id;
                                    }
                                    options += '<option ' + (selected ? 'selected' : '') + ' value="' + choice.id + '">' + choice.get('choiceName') + '</option>';
                                });

                                input = '<div class="d-flex align-items-center ht-100 wd-100"><select data-p-bind="' + attrCamel + '" class="form-control max-wd-150p input-choice ' + (column.customField.get('isMultipleChoice') ? 'input-multiple-choice' : '') + '">';
                                input += options;
                                input += '</select>';
                                input += '</div>';
                            }
                            break;
                        case 'bool':
                            input = '<select class="form-control input-bool" data-p-bind="' + attrCamel + '">';
                            input += '<option value="">Select Value</option>';
                            input += '<option value="true" ' + (data === true ? 'selected' : '') + '>Yes</option>';
                            input += '<option value="false" ' + (data === false ? 'selected' : '') + ' >No</option>';
                            input += '</select>';
                            break;
                        case 'state':
                            let selectedState = data != null ? data.toLowerCase() : '';
                            input = '<select class="form-control max-wd-150p input-state">';
                            input += this.getStateOptions(row.columnData.country, selectedState);
                            input += '</select>';
                            break;
                        case 'zip':
                            isValid = !(_.size(data) > 0 && !PJQ.helpers.validators.validateZip(data));
                            input = '<input title="original: ' + data + '" type="text" data-p-bind="' + attrCamel + '" class="form-control input-text input-zip' + (!isValid ? ' bg-danger-transparent' : '') + '" value="' + (data != null ? data : "") + '">';
                            break;
                        case 'country':
                            let country = data != null ? data.toLowerCase() : '';
                            input = '<select title="original: ' + data + '" class="form-control input-country" data-p-bind="' + attrCamel + '"><option value="US" ' + (country === 'us' ? 'selected' : '') + '>US</option><option value="CA" ' + (country === 'ca' ? 'selected' : '') + ' >CA</option></select>';
                            break;
                        case 'int':
                            input = '<input title="original: ' + data + '" type="number" data-p-bind="' + attrCamel + '" class="form-control input-int" value="' + (data != null ? data : "") + '">';
                            break;
                        case 'phone':
                            isValid = true;
                            if (column.get('attribute').toLowerCase() === "fax" || column.get('attribute').toLowerCase() === "email") {
                                isValid = _.size(row.columnData.email) > 0 || _.size(row.columnData.fax) > 0;
                                noEmailOrFax = noEmailOrFax || !isValid;
                            }
                            input = '<input type="text" title="original: ' + data + '"  data-p-bind="' + attrCamel + '" class="form-control input-phone' + (!isValid ? ' bg-danger-transparent' : '') + '" value="' + (data != null ? data : "") + '">';
                            break;
                        case 'groups':
                            let matchResult = this.getColumnGroupNames(data),
                                pf = _.size(matchResult.unmatched) > 0;
                            this.unmatchedGroups = _.union(this.unmatchedGroups, matchResult.unmatched)
                            input = '<div class="d-flex align-items-center wd-100 ht-100 ' + (pf ? 'bg-primary-transparent' : '') + '"><button type="button" title="original: ' + data + '" class="btn btn-link btn-edit-groups">' + _.size(matchResult.matched).toString() + ' selected</button>';
                            if (pf) {
                                input += '<i class="fad fa-history ml-1" title="original: ' + data + '"></i>';
                            }
                            input += '</div>';
                            break;
                        case 'regions':
                            let regions = data != null ? data.split(',') : [];
                            input = '<button type="button" title="original: ' + data + '" class="btn btn-link btn-edit-regions">' + _.size(regions).toString() + ' selected</button>';
                            break;
                        case 'workareas':
                            input = '<button type="button" class="btn btn-link btn-edit-work-areas">' + _.size(data).toString() + ' selected</button>';
                            break;
                        case 'text':
                        default:
                            let rowVal = data;
                            isValid = true;
                            if (column.get('attribute').toLowerCase() === "fax" || column.get('attribute').toLowerCase() === "email") {
                                if (column.get('attribute').toLowerCase() === "email" && rowVal != null && rowVal.indexOf('<') !== -1 && rowVal.indexOf('>') !== -1) {
                                    let regexp = /<(.*?)>/g;
                                    rowVal = regexp.exec(rowVal)[1];
                                }

                                isValid = _.size(rowVal) > 0 || _.size(row.columnData.fax) > 0;
                                noEmailOrFax = noEmailOrFax || !isValid;
                            }
                            input = '<input type="text" title="original: ' + data + '"  data-p-bind="' + attrCamel + '" class="form-control input-text' + (!isValid ? ' bg-danger-transparent' : '') + '" value="' + (rowVal != null ? rowVal : "") + '">';
                            break;
                    }
                    return input;
                }, this)
            });
        }, this);
        columns.push({
            title: "",
            defaultContent: '<button type="button" class="btn btn-danger delete-contact-import-upload-row"><i class="fal fa-trash"></i></button>',
            orderable: false,
            searchable: false
        });

        _.each(this.model.get('rows'), function (row) {
            if (row.columnData.groups != null && row.columnData.groups.indexOf(',') === -1 && row.columnData.groups.indexOf('|') === -1) {
                row.columnData.groups = row.columnData.groups + ',';
            }
        });

        let $table = this.$('.contact-import-upload-data-table'),
            self = this;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: $table,
            rowId: "index",
            autoWidth: false,
            isHideSearch: true,
            data: this.model.get('rows'),
            columns: columns,
            isOverflowAuto: true,
            onTableDraw: function () {
                PJQ.helpers.inputHelpers.inputMaskPhone($table.find('.input-phone'));
                $table.find('.input-multiple-choice').each(function () {
                    let attr = $(this).data('p-bind');
                    new PJQ.inputs.Selectpicker({
                        el: $(this),
                        isMultiple: true,
                        onChange: _.bind(function (value) {
                            let row = self.dataTable.getRow($(this).parents('tr'));
                            row.data().columnData[attr] = value;
                        }, this)
                    });
                });

                $table.find('th').each(function (index) {
                    let column = self.model.columns.models[index];
                    if (column != null) {
                        $(this).css('min-width', self.getColumnWidth(column));
                    }
                });

                let umGroups = _.size(self.unmatchedGroups) > 0;
                if ((umGroups || noEmailOrFax) && self.importAlert == null) {
                    let message = '';
                    if (noEmailOrFax) {
                        message += "Some of the imported contacts do not have an email or fax number, these are highlighted in red.";
                    }
                    if (umGroups) {
                        if (_.size(message) > 0) {
                            message += '<br/>'
                        }
                        let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL);
                        message += 'Some of the imported contacts have groups that do not exist in the system.  If you do not map them by clicking <strong><a href="javascript:void(0)" class="btn-map-groups">Map ' + (groupLabel ? groupLabel : 'Groups') + '</a></strong>, these groups will be created automatically.';
                    }

                    self.importAlert = new PJQ.Alert(self.$el, {
                        type: 'primary',
                        text: message,
                        isPrepend: true
                    })
                }
            }
        });

        let $footer = this.$el.closest('.modal-content').find('.modal-footer');
        $footer.find('.btn-map-groups').remove();
        if (_.size(this.unmatchedGroups) > 0) {
            let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL),
                $btn = $('<button />', {
                    type: 'button',
                    class: 'btn btn-info btn-map-groups',
                    text: 'Map ' + (groupLabel ? groupLabel : 'Groups')
                });
            $footer.prepend($btn);
            $btn.on('click', _.bind(this.mapGroups, this))
        }
    },
    editWorkAreas: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            data = row.data(),
            collection = new PJQ.collections.workAreas.ContactWorkAreas();

        _.each(this.model.get('workAreas'), function (workArea) {
            if (data.columnData.workAreas.indexOf(workArea.workAreaId) !== -1) {
                collection.add(new collection.model(workArea));
            }
        });

        new PJQ.views.workAreas.WorkAreaMapModal({
            collection: collection,
            onSave: _.bind(function (workAreaCol) {
                data.columnData.workAreas = _.map(workAreaCol.models, function (workArea) {
                    return workArea.get('workAreaId');
                });
                this.dataTable.refresh();
            }, this)
        });
    },
    getColumnGroupNames: function (data) {
        let groupNames,
            result = {
                matched: [],
                unmatched: []
            };
        if (_.size(data) === 0) {
            groupNames = [];
        } else if (data.indexOf('|') !== -1) {
            groupNames = data.split('|');
        } else if (data.indexOf(',') !== -1) {
            groupNames = data.split(',');
        } else {
            groupNames = [data];
        }
        _.each(groupNames, function (groupName) {
            if (groupName == null || _.size(groupName.trim()) === 0) {
                return;
            }

            let loweredName = groupName.toLowerCase().trim();
            if (_.find(this.groups.models, function (group) {
                return group.get('groupName').toLowerCase() === loweredName;
            }) != null) {
                result.matched.push(groupName);
            } else {
                let mappedGroup = _.find(this.groupMap, function (map) {
                    return map.group != null && map.groupName === groupName;
                });
                if (mappedGroup != null) {
                    result.matched.push(mappedGroup.group.get('groupName'));
                } else if (result.unmatched.indexOf(groupName) === -1) {
                    result.unmatched.push(groupName);
                }
            }
        }, this);
        return result;
    },
    editGroups: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            data = row.data(),
            selectedGroupIds = [],
            matchResult = this.getColumnGroupNames(data.columnData.groups);
        _.each(matchResult.matched, function (groupName) {
            let group = _.find(this.groups.models, function (group) {
                return group.get('groupName').toLowerCase() === groupName.trim().toLowerCase();
            });
            if (group != null) {
                selectedGroupIds.push(group.id);
            }
        }, this);
        new PJQ.views.groups.SelectGroupsModal({
            selectorOptions: {
                selectedGroupIds: selectedGroupIds
            },
            onSave: _.bind(function (groups) {
                data.columnData.groups = _.map(groups.selected, function (group) {
                    return group.get('groupName');
                }).join(',');
                this.dataTable.refresh();
            }, this)
        });
    },
    mapGroups: function () {
        new PJQ.views.contacts.MapGroupsModal({
            groupMap: this.groupMap,
            groupNames: this.unmatchedGroups,
            onSave: _.bind(function (map) {
                this.groupMap = map;
                this.render();
            }, this)
        });
    },
    editRegions: function () {

    },
    getIsOverwrite: function () {
        return this.$el.closest('.modal').find('.cb-overwrite').prop('checked') === true;
    },
    overwriteOptionChanged: function () {
        let $mdOuter = this.$el.closest('.modal').find('.cb-merge-data-outer');
        if (this.getIsOverwrite()) {
            $mdOuter.removeClass('hidden');
        } else {
            $mdOuter.addClass('hidden');
        }
    },
    import: function (importOptions) {
        let save = _.bind(function () {
            let $btn = this.$el.closest('.modal').find('.btn-import,.btn-cancel'),
                importLoader = new PJQ.Loader(this.dataTable.$el);
            $btn.prop('disabled', true);

            if (this.groupMap != null) {
                _.each(this.model.get('rows'), function (row) {
                    let matchResult = this.getColumnGroupNames(row.columnData.groups),
                        newNames = [];
                    _.each(matchResult.matched, function (gName) {
                        if (newNames.indexOf(gName) === -1) {
                            newNames.push(gName);
                        }
                    });

                    _.each(matchResult.unmatched, function (gName) {
                        if (newNames.indexOf(gName) === -1) {
                            newNames.push(gName);
                        }
                    });
                    if (_.size(newNames) > 0) {
                        row.columnData.groups = newNames.join('|');
                    }
                }, this)
            }

            let overwrite = this.getIsOverwrite();
            this.model.save({
                overwrite: overwrite,
                mergeData: overwrite && this.$el.closest('.modal').find('.cb-merge-data').prop('checked'),
                rows: this.model.get('rows')
            }, {
                timeout: 600000,
                urlOptions: _.extend(importOptions, {
                    createGroups: this.$('.cb-create-groups').prop('checked')
                }),
                notify: false,
                success: _.bind(function (model, data) {
                    PJQ.notifications.notify.successNotify({
                        message: "Your contacts have been queued for import"
                    });
                    if (typeof this.options.onDone === 'function') {
                        this.options.onDone();
                    }
                }, this)
            });
        }, this);
        if (importOptions == null || !importOptions.overwrite) {
            let noEmailFaxCount = 0;
            _.each(this.model.get('rows'), function (contact) {
                if (_.size(contact.columnData.email) === 0 && _.size(contact.columnData.fax) === 0) {
                    noEmailFaxCount++;
                }
            });
            if (noEmailFaxCount > 0) {
                new PJQ.views.modals.YesNo({
                    header: "Import Data Missing",
                    body: "Some of the contacts you are importing do not have an email or fax.  Do you still want to continue?",
                    onYes: _.bind(function () {
                        save();
                    }, this)
                });
            } else {
                save();
            }
        } else {
            save();
        }
    }
});

PJQ.views.contacts.DuplicateEmailModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Contacts-Import-Duplicate-Email'),
        onSkip: null,
        onOverwrite: null
    },
    events: {
        'click .btn-overwrite': 'overwrite',
        'click .btn-skip': 'skip',
        'click .btn-cancel': 'cancel'
    },
    overwrite: function () {
        if (typeof this.options.onOverwrite === 'function') {
            this.options.onOverwrite();
            this.removeModal();
        }
    },
    skip: function () {
        if (typeof this.options.onSkip === 'function') {
            this.options.onSkip();
            this.removeModal();
        }
    },
    cancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
            this.removeModal();
        }
    }
});

PJQ.views.contacts.MapGroupsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-contacts-import-map-groups')
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        if (this.options.groupMap == null) {
            this.options.groupMap = [];
            _.each(this.options.groupNames, function (groupName) {
                this.options.groupMap.push({
                    id: _.uniqueId(),
                    groupName: groupName,
                    group: null
                });
            }, this);
        }

        PJQ.app.session.fetchUserGroups(null, _.bind(function (groups) {
            this.groups = groups;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            groupMap: this.options.groupMap,
            groups: this.groups
        };
    },
    afterRender: function () {
        let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL);
        _.each(this.options.groupMap, function (map) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-group[data-tid="' + map.id.toString() + '"]'),
                defaultValue: map.group?.id,
                noneSelectedText: 'Select Group',
                isLiveSearch: true,
                onChange: _.bind(function (groupId) {
                    map.group = this.groups.get(groupId);
                }, this)
            });
        }, this);
    },
    save: function () {
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.options.groupMap);
            this.removeModal();
        }
    }
});
PJQ.models.contactus = {};

PJQ.models.contactus.ContactUs = PJQ.models.BaseModel.extend({
	idAttribute: "contactUsId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contactus'
			}
		])
	}
});

PJQ.views.ContactUs = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contact-Us')
	},
	events: {
		'click .contactus-submit': 'onSubmit'
	},
	beforeFirstRender: function () {
	},
	beforeRender: function () {
		this.renderData = {};
	},
	afterRender: function () {
		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contactus-phone'));
	},
	onSubmit: function () {
		let errors = 0;

		PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-company'), true);
		if (this.$('.contactus-company').val().trim().length == 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-company'), false);
			errors++;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-contact'), true);
		if (this.$('.contactus-contact').val().trim().length == 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-contact'), false);
			errors++;
		}

		let emailValid = PJQ.helpers.validators.validateEmail(this.$('.contactus-email').val());
		PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-email'), emailValid.success);
		if (!emailValid.success)
			errors++;

		let phone = PJQ.helpers.formatHelpers.numbersOnly(this.$('.contactus-phone').val());

		if (errors == 0) {

			let model = new PJQ.models.contactus.ContactUs();
			let context = "Sub LP - General";
			if (this.getParameterByName('contactcontext'))
				context = this.getParameterByName('contactcontext');

			model.set('context', context);
			model.set('companyName', this.$('.contactus-company').val());
			model.set('contactName', this.$('.contactus-contact').val());
			model.set('phone', phone);
			model.set('email', this.$('.contactus-email').val());
			model.set('message', this.$('.contactus-message').val());

			model.save(null, {
				success: function () {
					window.location.href = 'http://app.panteratools.com/Default.aspx?tabid=21997';
				}
			});

			this.$('.contactus-company').val('');
			this.$('.contactus-contact').val('');
			this.$('.contactus-phone').val('');
			this.$('.contactus-email').val('');
			this.$('.contactus-message').val('');
		}
	},
	getParameterByName: function (name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		let regexS = "[\\?&]" + name + "=([^&#]*)";
		let regex = new RegExp(regexS);
		let results = regex.exec(window.location.search);
		if (results == null)
			return "";
		else
			return decodeURIComponent(results[1].replace(/\+/g, " "));
	}
});
//Date Prototype functions
Date.daysBetween = function (date1, date2) {
	let one_day = 1000 * 60 * 60 * 24,
		date1_ms = date1.getTime(),
		date2_ms = date2.getTime(),
		difference_ms = date2_ms - date1_ms;
	return Math.round(difference_ms / one_day);
};

Date.prototype.addDays = function(days) {
	let date = new Date(this.valueOf());
	date.setDate(date.getDate() + days);
	return date;
};
PJQ.Draggable = class {
	constructor($el, options = {}) {
		let self = this;
		self.$el = $el;
		self.options = _.defaults(options, {
			addClasses: "selected",
			stop: function () {
				self.onStop();
			}
		});
		if (_.size(self.$el) > 0) {
			self.$el.draggable(self.options);
		}
	}

	onStop() {
		if (typeof this.options.onStop === 'function') {
			this.options.onStop();
		}
	}
};

PJQ.Droppable = class {
	constructor($el, options = {}) {
		let self = this;
		self.$el = $el;
		self.options = _.defaults(options, {
			addClasses: "selected",
			stop: function () {
				self.onStop();
			}
		});
		if (_.size(self.$el) > 0) {
			self.$el.droppable(self.options);
		}
	}

	onStop() {
		if (typeof this.options.onStop === 'function') {
			this.options.onStop();
		}
	}
};
PJQ.views.email = {};

PJQ.views.email.ComposeEmailModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-compose-email'),
        subTemplates: {
            emailBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Email-Badge')
        },
        header: "Send Email",
        enableCC: true,
        subject: '',
        onSave: null,
        onSaveWait: null,
        onCancel: null,
        maxWidth: '1200px'
    },
    events: {
        'keyup .input-share-search': 'searchChanged',
        'focus .input-share-search': 'focusSearch',
        'click .share-email-delete': 'deleteEmail',
        'click .modal-share-send': 'send',
        'click .modal-share-cancel': 'cancel',
        'mousedown .modal-dialog': 'checkIsFocused',
        'click .btn-add-project-contact': 'addProjectContact'
    },
    beforeModalCreated: function () {
        this.selectedEmailsTo = [];
        this.selectedEmailsCC = [];
        this.focusType = null;

        if (_.size(this.options.subjectTemplate) > 0) {
            this.options.subject = this.replaceTokens(this.options.subjectTemplate, this.options.tokens ?? {});
        }
    },
    replaceTokens: function (text, tokens) {
        return text.replace(/\[([^\]]+)]/g, (match, token) => {
            let tokenVal = PJQ.helpers.objectHelpers.getNestedValue(tokens, token);
            return tokenVal ?? '';
        });
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    afterRender: function () {
        this.bodyEditor = new PJQ.inputs.HTMLEditor({
            el: this.$('.email-body'),
            editorHeight: 300,
            isHideTokens: true,
            onChange: _.bind(function (contents) {

            }, this)
        });
    },
    focusSearch: function (e) {
        this.focusType = $(e.currentTarget).data('email-line');
        if (this.contactEmailSelector != null)
            this.contactEmailSelector.remove();

        this.contactEmailSelector = new PJQ.views.email.ContactSearchSelect({
            el: this.focusType === "to" ? this.$('.contact-emails-to') : this.$('.contact-emails-cc'),
            selectedEmails: this.focusType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC,
            search: this.getFocusSearchText(),
            project: this.options.project,
            onAdd: _.bind(function (email) {
                this.addEmail(email);
            }, this)
        });
    },
    checkIsFocused: function (e) {
        if (this.$(e.target).closest('.share-contact').length > 0) {
            return;
        }

        // Removes contact email selector if not selecting a contact, or entering an email
        let target = $(e.target),
            targetParent = $(e.target.parentElement);

        if (this.focusType != null
            && !target.hasClass('share-contact')
            && !targetParent.hasClass('share-contact')
            && !target.hasClass('input-share-search')
            && !target.hasClass('share-contact-email')
            && !target.hasClass('share-email-entry')
            && !target.hasClass('share-contact-name')) {
            this.contactEmailSelector.remove();
            this.focusType = null;
        }
    },
    getFocusSearchText: function () {
        return this.focusType != null ? this.$('.input-share-search[data-email-line="' + this.focusType + '"]').val().toLowerCase() : this.$('.input-share-search').val().toLowerCase();
    },
    searchChanged: function () {
        this.contactEmailSelector.searchChanged(this.getFocusSearchText());
    },
    renderRecipientCount: function () {
        let emailCount = _.size(this.selectedEmailsTo) + _.size(this.selectedEmailsCC);
        this.$('.recipient-count').html(emailCount.toString() + (emailCount === 1 ? ' recipient' : ' recipients'));
    },
    addProjectContact: function (e) {
        let $target = $(e.currentTarget),
            emailLine = $target.data('email-line');

        new PJQ.views.contacts.SelectContactsModal({
            hideEmails: emailLine === 'to' ? this.selectedEmailsTo : this.selectedEmailsCC,
            subtitle: `Add Project Contacts to the ${emailLine === 'to' ? 'To' : 'CC'} line`,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            canSwitchContext: false,
            showAddress: false,
            isSingleChoice: false,
            saveButtonText: "Add",
            onSave: (newContacts) => {
                this.focusType = emailLine;
                _.each(newContacts, (contact) => {
                    let email = contact.get('email').toLowerCase();
                    if (_.size(email) === 0) {
                        return;
                    }

                    if (emailLine === 'to') {
                        this.selectedEmailsTo.push(email);
                    } else {
                        this.selectedEmailsCC.push(email);
                    }
                    this.addEmail(email, true);
                });
                this.focusType = null;
            }
        });
    },
    addEmail: function (email, shouldNotFocus) {
        this.renderSubTemplate(true, this.options.subTemplates.emailBadge, this.$('.share-selected-emails[data-email-line="' + (this.focusType) + '"]'), {
            email: email
        });
        this.$('.input-share-search').val('');
        this.$('.modal-share-send').prop('disabled', false);
        this.renderRecipientCount();

        if (!shouldNotFocus) {
            this.$('.input-share-search[data-email-line="' + this.focusType + '"]').focus();
        }
    },
    deleteEmail: function (e) {
        let emailContainer = $(e.currentTarget).closest('.share-email'),
            emailLineType = $(e.currentTarget).closest('.share-selected-emails').data('email-line'),
            emailArray = emailLineType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC;
        emailArray = _.without(emailArray, emailContainer.data('email').toLowerCase());

        if (emailLineType === "to")
            this.selectedEmailsTo = emailArray
        else
            this.selectedEmailsCC = emailArray

        emailContainer.remove();
        this.searchChanged();
        this.$('.modal-share-send').prop('disabled', _.size(emailArray) === 0);
        this.renderRecipientCount();
    },
    validate: function () {
        return true;
    },
    send: function () {
        let $subject = this.$('.input-share-subject'),
            data = {
                toEmails: this.selectedEmailsTo,
                ccEmails: this.selectedEmailsCC,
                subject: $subject.val(),
                body: this.bodyEditor.getValue()
            };

        let isSubjectValid = _.size(data.subject) > 0;
        PJQ.helpers.inputHelpers.setInputError($subject, isSubjectValid);
        if (!isSubjectValid) {
            return;
        }

        if (typeof this.options.onSave === 'function') {
            this.options.onSave(data);
            this.removeModal();
        } else if (typeof this.options.onSaveWait === 'function') {
            new PJQ.Loader(this.$('.modal-content'));
            this.options.onSaveWait(data, () => {
                this.removeModal();
            });
        } else {
            this.removeModal();
        }
    },
    cancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
        }
    },
});

PJQ.views.email.ContactSearchSelect = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'contact-email-search-select'),
        subTemplates: {
            contact: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Contact')
        },
        search: ''
    },
    events: {
        'click .share-contact': 'addEmail',
    },
    beforeFirstRender: function () {
        this.selectedEmails = this.options.selectedEmails;
        this.render();
    },
    afterRender: function () {
        if (this.options.project != null) {
            let contactsLoader = new PJQ.Loader(this.$('.share-contacts-outer'));
            this.options.project.fetchProjectContacts(_.bind(function (projectContacts) {
                this.contacts = projectContacts;
                contactsLoader.remove();
                this.searchChanged(this.options.search);
            }, this));
        } else {
            this.contacts = new PJQ.collections.contacts.Contacts();
            this.searchChanged(this.options.search);
        }
    },
    searchChanged: function (searchVal) {
        let searchText = searchVal != null ? searchVal : "",
            filteredContacts;
        if (_.size(searchText) > 0) {
            filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
                let email = contact.get('email').toLowerCase();
                if (_.size(email) === 0 || _.indexOf(this.selectedEmails, email) !== -1) {
                    return false;
                }

                return contact.get('contactName').toLowerCase().indexOf(searchText) !== -1 || email.indexOf(searchText) !== -1;
            }, this));
        } else {
            filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
                let email = contact.get('email').toLowerCase();
                return _.size(email) > 0 && _.indexOf(this.selectedEmails, email) === -1;
            }, this))
        }

        let $addEmail = this.$('.share-add-email'),
            isValidEmail = PJQ.helpers.validators.validateEmail(searchText).success;
        if (isValidEmail && _.size(filteredContacts) === 0) {
            this.$('.share-suggested-contacts').append($('<div>', {
                text: searchText
            }));
            this.$('.share-add-email .share-contact').data('email', searchText);
            this.$('.share-email-entry-letter').html(searchText[0].toUpperCase());
            this.$('.share-email-entry').text(searchText);
            $addEmail.removeClass('hidden');
        } else {
            $addEmail.addClass('hidden');
        }

        let $searchResults = this.$('.share-search-results'),
            $searchResultsOuter = this.$('.share-search-results-outer');
        $searchResults.empty();
        if (_.size(filteredContacts) > 0) {
            _.each(_.sortBy(filteredContacts, function (contact) {
                return contact.get('contactName')
            }), _.bind(function (contact) {
                this.renderSubTemplate(true, this.options.subTemplates.contact, $searchResults, {
                    model: contact
                });
            }, this));

            $searchResultsOuter.removeClass('hidden');
        } else {
            $searchResultsOuter.addClass('hidden');
        }

        let $noResults = this.$('.share-search-no-results');
        if (isValidEmail || _.size(filteredContacts) > 0) {
            $noResults.addClass('hidden');
        } else {
            $noResults.removeClass('hidden');
        }
    },
    addEmail: function (e) {
        let email = $(e.currentTarget).closest('.share-contact').data('email');
        this.selectedEmails.push(email.toLowerCase());
        this.searchChanged();
        if (typeof this.options.onAdd === 'function') {
            this.options.onAdd(email)
        }
    },
})
//Models
PJQ.models.emailTemplates = {};
PJQ.models.emailTemplates.EmailTemplate = PJQ.models.BaseModel.extend({
    idAttribute: 'emailTemplateId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'emailTemplates',
                value: this.id
            }
        ])
    }
});

//Collections
PJQ.collections.emailTemplates = {};
PJQ.collections.emailTemplates.EmailTemplates = PJQ.collections.BaseCollection.extend({
    options: {
        projectMessage: false
    },
    model: PJQ.models.emailTemplates.EmailTemplate,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'emailTemplates'
            }
        ], [
            {
                parameter: 'projectMessage',
                value: this.options.projectMessage
            },
        ])
    }
});

PJQ.Errors = {
	auth: {
		INACTIVE: 'Your account is currently inactive, contact an administrator to activate it',
		INACTIVE_USER: 'Your account is currently inactive, contact an administrator to activate it',
		KEY_LENGTH: 'Access key must be 10 characters',
		NOT_FOUND: 'Access key not found',
		USER_NOT_FOUND: 'Unable to find an account with that username',
		LOCKED: 'Your account has been locked due to too many failed attempts',
		LOCKED_USER: 'Your account is currently locked',
		INCORRECT_PASSWORD: 'Incorrect password',
		INVALID_GRANT: 'Username does not exist or has been deleted',
		UNHANDLED: 'An error occurred, please contact customer service or try again later',
		USERNAME_EXISTS: 'Username already taken',
		CUSTOMER_SERVICE: 'An error occurred, please contact customer service or try again later',
		CURRENT_PASSWORD: 'You cannot use your current password',
		SSO_DISABLED: 'SSO is not enabled for this user',
		INVALID_SAML: 'Unable to validate SAML certificate, please contact your system administrator'
	}
};

PJQ.ErrorHandler = class {
	constructor(options = {}) {
		options = options != null ? options : {};
		options.handlers = _.defaults(options.handlers ? options.handlers : {}, {
			0: {
				notification: {
					type: 'error',
					message: 'Unable to connect.  Please verify you are still connected to the internet.',
					showContact: true
				}
			},
			400: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			401: {
				notification: {
					type: 'error',
					message: 'You do not have permission to view this {0}'
				}
			},
			404: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			405: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			500: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			502: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			503: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			504: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			default: {
				enableTracking: true,
			}
		});

		this.options = _.defaults(options ? options : {}, {});
	}

	handle(request, data) {
		let handler = this.options.handlers[request.status];
		if (handler != null) {
			if (handler.enableTracking && typeof Sentry === 'object') {
				Sentry.configureScope((scope) => {
					let sentryUserId = 0;
					if (PJQ.app.session.contact != null) {
						sentryUserId = PJQ.app.session.contact.id;
					}
					else if (PJQ.app.session.user != null) {
						sentryUserId = -PJQ.app.session.user.id;
					}
					scope.setUser({id: sentryUserId});
					scope.setLevel(handler.level ? handler.level : 'warning');
					scope.setExtra('statusCode', request.status);
					scope.setExtra('responseText', request.responseText);
					scope.setExtra('data', data);
					Sentry.captureMessage(request.status.toString() + ": " + request.url);
				});
			}

			if (handler.notification != null) {
				let itemName = handler.itemName != null ? handler.itemName : 'item';
				handler.notification.message = PJQ.helpers.stringHelpers.format(handler.notification.message, itemName);
				if (handler.level === 'warning' || handler.notification.type === 'warning') {
					PJQ.notifications.notify.warningNotify(handler.notification);
				}
				else {
					PJQ.notifications.notify.errorNotify(handler.notification);
				}
			}
		}
	}
};
// Models

PJQ.models.featureSettings = {};

PJQ.models.featureSettings.FeatureSetting = PJQ.models.BaseModel.extend({
    endpoint: function () {
        if(this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'featuresettings'
                }
            ])
        }
        else{
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'featuresettings'
                }
            ])
        }
    },
});


// Views

PJQ.views.featureSettings = {};

PJQ.views.featureSettings.FeatureSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'feature-settings')
    },
    events: {

    },
    beforeFirstRender: function() {
        if(this.model && !this.options.project && !this.model.isFetched){
            this.model.fetch({
                success: _.bind(function(){
                    this.render();
                }, this)
            })
        }
        else{
            this.render();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        }
    },
    afterRender: function() {
        new PJQ.Binder(this.$('.settings'), this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });
    },
    onChange: function() {
        if(typeof this.options.onChange === 'function'){
            this.options.onChange(this.model);
        }
    }
})

PJQ.views.featureSettings.FeatureSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Feature-Settings'),
        minWidth: 700
    },
    defaultEvents: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        new PJQ.views.featureSettings.FeatureSettings({
            el: this.$('.feature-settings'),
            project: this.options.project,
            model: this.model
        })
    },
    save: function() {
        this.model.save(null, {
            success: _.bind(function(featureSettings) {
                PJQ.app.session.project.set('featureSettings', featureSettings.toJSON());
                PJQ.app.navigator.refreshCommands();
                PJQ.app.navigator.renderHeader();
                this.removeModal();
            }, this)
        })
    },
    cancel: function() {
        this.removeModal();
    }
});

PJQ.files = {
    downloadDrawings: function (attachments, project, options) {
        let objType = PJQ.helpers.objectHelpers.refinedType(attachments, true);
        if (objType === 'backboneCollection' || objType === 'array') {
            let versions = {},
                versionIds = _.uniq(_.map(_.filter(objType === 'array' ? attachments : attachments.models, function (attachment) {
                    return attachment.get("isDrawing") && attachment.get('guid') != null;
                }), function (attachment) {
                    return attachment.get('versionId');
                }));
            _.each(versionIds, function (versionId) {
                versions[versionId] = _.map(_.filter(objType === 'array' ? attachments : attachments.models, function (attachment) {
                    return attachment.get('versionId') === versionId
                }), function (drawing) {
                    return drawing.get('guid');
                });
            });

            let params = [];
            if (options) {
                if (options.raster) {
                    params.push({
                        parameter: 'raster',
                        value: options.raster
                    });
                }
                if (options.merge) {
                    params.push({
                        parameter: 'merge',
                        value: options.merge
                    });
                }

                if (options.includeAttachments) {
                    params.push({
                        parameter: 'attachments',
                        value: options.includeAttachments
                    });
                }
            }

            let endpoint;
            if (project != null) {
                endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: project.id
                    },
                    {
                        endpoint: 'drawings'
                    },
                    {
                        endpoint: 'downloads'
                    }
                ], params)
            } else {
                endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings'
                    },
                    {
                        endpoint: 'downloads'
                    }
                ], params)
            }
            let data = {
                versions: versions,
                fileGuids: _.map(_.filter(objType === 'array' ? attachments : attachments.models, function (attachment) {
                    return !attachment.get("isDrawing");
                }), function (attachment) {
                    return attachment.get('guid');
                })
            };
            PJQ.files.queueDownload(endpoint, data);
        } else {
            new PJQ.models.drawings.Drawing({
                drawingId: -attachments.get('entryId'),
                guid: attachments.get('guid')
            }).download();
        }
    },
    queueDownload: function (endpoint, data, downloadStartCallback, isApiv2 = false) {
        PJQ.files.createDownloadFrame();
        let req = new PJQ.ajax.Request({
            endpoint: endpoint,
            data: data,
            isApi2: true,
            isAPIv2: isApiv2
        });
        if (data != null) {
            req = req.post();
        } else {
            req = req.get();
        }
        req.done(_.bind(function (download) {
            if (typeof downloadStartCallback === 'function') {
                downloadStartCallback();
            }
            this.handleDownload(download);
        }, this)).fail(function (jqXHR) {
            PJQ.files.logDownloadFailure({
                endpoint: endpoint,
                error: jqXHR.responseText
            });
        });
    },
    handleDownload: function (download) {
        let minWaitSeconds;
        let showPromo;
        let promoType = 'fora'
        // force a minimum wait for downloads on projects that they don't own or when the user is not logged in
        if (PJQ.app.session && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId && PJQ.app.options.isPanteraApp &&
            (PJQ.app.session.user == null
                || (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')))) {
            let contact = PJQ.app.session.contact,
                groupIds = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.QUIKBID_GROUP_IDS);
            // Make groupids an array
            if (groupIds != null) {
                groupIds = groupIds.split(",");
                // Fetch contact if contact isn't fetched. Rerun handleDownload after they are fetched
                if (contact != null && !contact.isFetched) {
                    contact.fetch({
                        success: _.bind(function () {
                            this.handleDownload(download);
                        }, this)
                    })
                    return;
                }
                // Check if any of the the contacts groups match the specified quikbids groups.
                if (contact != null) {
                    _.each(contact.groups.models, function (group) {
                        let quikBidGroup = _.contains(groupIds, group.get('groupId').toString());
                        if (quikBidGroup) {
                            promoType = 'quikbid';
                        }
                    }, this);
                }
            }
            minWaitSeconds = 20;
            showPromo = true;
        } else {
            minWaitSeconds = null;
            showPromo = false;
        }
        if (download.isReady && download.url && (!(download.isZip || download.isDrawing) || minWaitSeconds <= 0 || minWaitSeconds == null)) {
            PJQ.files.downloadFile(download.url, {
                isEndpoint: false
            });
        } else {
            if (download.isZip) {
                new PJQ.views.files.ZipProgressModal({
                    model: new PJQ.models.files.ZipFile(download),
                    minWaitSeconds: minWaitSeconds,
                    showPromo: showPromo,
                    promoType: promoType
                });
            } else if (download.isDrawing) {
                new PJQ.views.files.DrawingProgressModal({
                    model: new PJQ.models.drawings.DrawingDownload(download),
                    minWaitSeconds: minWaitSeconds,
                    showPromo: showPromo,
                    promoType: promoType
                });
            } else {
                new PJQ.views.files.FileProgressModal({
                    model: new PJQ.models.files.File(download)
                });
            }
        }
    },
    logDownloadFailure: function (data) {
        new PJQ.logging.Debug(PJQ.logging.LoggingActions.FILE_DOWNLOAD_FAILED, data);
    },
    downloadFile: function (url, options = {}) {
        PJQ.files.createDownloadFrame();
        if (options.isEndpoint !== false) {
            options.includeSessionId = true;
            options.includeAccessToken = true;
            if (options.isAPIv2 === true) {
                options.service = PJQ.constants.services.APIv2;
            } else if (options.isApi2 === true) {
                options.service = PJQ.constants.services.FILES;
            }
            url = PJQ.helpers.urlHelpers.buildApiUrl(url, options);
        }
        window.open(url, PJQ.constants.files.downloadFrameId);
    },
    createDownloadFrame: function () {
        let iFrame = $('#' + PJQ.constants.files.downloadFrameId);
        if (_.size(iFrame) === 0) {
            iFrame = $('<iframe/>', {
                id: PJQ.constants.files.downloadFrameId,
                name: PJQ.constants.files.downloadFrameId,
                class: 'hidden'
            });
            $('body').append(iFrame);
        }
        return iFrame;
    }
};

//Models
PJQ.models.files = {};
PJQ.models.files.File = PJQ.models.BaseModel.extend({
    idAttribute: 'entryId',
    endpointArr: function () {
        let arr;
        if (this.get('isFolder')) {
            if (_.size(this.get('guid')) > 0) {
                arr = [
                    {
                        endpoint: 'files',
                        value: this.get('guid')
                    }
                ];
            } else {
                arr = [
                    {
                        endpoint: 'folders',
                        value: this.get('folderGuid')
                    }
                ];
            }
        } else {
            if (_.size(this.get('guid')) > 0) {
                if (this.get('entryId') < 0) {
                    arr = [
                        {
                            endpoint: 'drawings',
                            value: this.get('guid')
                        }
                    ];
                } else {
                    arr = [
                        {
                            endpoint: 'files',
                            value: this.get('guid')
                        }
                    ];
                }
            } else if (_.size(this.get('key')) > 0) {
                arr = [
                    {
                        endpoint: 'files',
                        value: this.get('key')
                    }
                ];
            } else {
                arr = [
                    {
                        endpoint: 'files',
                        value: this.get('entryId')
                    }
                ];
            }
        }
        return arr;
    },
    endpoint: function (urlOptions) {
        let params;
        if (urlOptions != null && urlOptions.params != null) {
            params = urlOptions.params;
        } else {
            params = [];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(this.endpointArr(), params);
    },
    renderUrl: function (pageNumber) {
        //currently returns renderid as a fallback for old places that only have the entryid and not the guid
        return PJQ.helpers.urlHelpers.buildAPIURL(PJQ.helpers.urlHelpers.generateEndpoint(_.union(this.endpointArr(), [{
                endpoint: _.size(this.get('guid')) > 0 ? 'render' : 'renderid'
            }]),
            [
                {
                    parameter: 'pageNumber',
                    value: pageNumber > 0 ? pageNumber : 1
                }
            ]), false, false, true);
    },
    urlForKey: function (key) {
        return PJQ.helpers.urlHelpers.buildApiUrl(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files',
                value: _.size(key) > 0 ? key : this.get('key')
            }
        ]), {
            service: PJQ.constants.services.APIv2
        });
    },
    thumbnailUrl: function () {
        let thumbUrl = this.get('thumbUrl');
        if (_.size(thumbUrl) > 0) {
            return thumbUrl;
        } else {
            if (_.size(this.get('key')) > 0) {
                return this.urlForKey() + '/thumbnail';
            }
            return this.dataUrl;
        }
    },
    getSize() {
        if (this.get('isFolder')) {
            return _.reduce(this.getFolderAttachments(), function (memo, file) {
                return memo + file.getSize();
            }, 0);
        } else {
            return this.get('size');
        }
    },
    exportFileList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files',
                value: this.get('entryId')
            },
            {
                endpoint: 'export'
            }
        ]));
    },
    addNotification: function (email) {
        new PJQ.models.files.DrawingNotification({
            guid: this.get('guid'),
            email: email
        }).save();
    },
    download: function () {
        let url = this.get('url');
        if (_.size(url) === 0 && _.size(this.get('key')) > 0) {
            url = this.urlForKey() + '/download';
        }

        if (_.size(url) > 0) {
            PJQ.files.downloadFile(url, {
                isEndpoint: false,
                isApi2: true
            });
        } else if (_.size(this.get('guid')) > 0) {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint(this.endpointArr()) + '/download', {
                isApi2: true
            });
        }
    },
    move: function (files, options, callback) {
        let params = [];
        if (options.project != null) {
            params.push({
                parameter: "projectId",
                value: options.project.id
            });
        }
        // move files to this folder
        if (this.get('isFolder')) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'files',
                        value: this.get('entryId')
                    },
                    {
                        endpoint: 'moveto'
                    }
                ], params),
                data: {
                    entryList: _.map(files, function (file) {
                        return file.get('entryId')
                    })
                }
            }).put().done(_.bind(function (changedFiles) {
                _.each(changedFiles, function (changedFile) {
                    let matchFile = _.find(files, function (file) {
                        return file.get('entryId') === changedFile.entryId;
                    });
                    if (matchFile != null) {
                        matchFile.set('folderId', changedFile.folderId);
                    }
                }, this);
                callback(files);
            }, this));
        } else {
            callback(files);
        }
    },
    copy: function (files, options, callback) {
        let params = [];
        if (options.project != null) {
            params.push({
                parameter: "projectId",
                value: options.project.id
            });
        }
        // move files to this folder
        if (this.get('isFolder')) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'files',
                        value: this.get('entryId')
                    },
                    {
                        endpoint: 'copyto'
                    }
                ], params),
                data: {
                    entryList: _.map(files, function (file) {
                        return file.get('entryId')
                    })
                }
            }).put().done(_.bind(function (newFiles) {
                callback(newFiles);
            }, this));
        } else {
            callback(files);
        }
    },
    destroy: function (options) {
        if (this.get('isFolder')) {
            this.deleteFolderContents();
        }
        return Backbone.Model.prototype.destroy.call(this, options);
    },
    deleteFolderContents: function () {
        _.each(this.getFolderAttachments(), _.bind(function (file) {
            if (file.get('isFolder')) {
                file.deleteFolderContents();
            }
            if (this.collection != null) {
                this.collection.remove(file);
            }
        }, this));
    },
    detachFromProject: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'attachments',
                    value: this.get('guid')
                },
                {
                    endpoint: 'detach'
                }
            ])
        }).delete().done(callback);
    },
    parse: function (model) {
        if (model != null) {
            if (model.key != null) {
                model.url = this.urlForKey(model.key) + "/download";
                model.thumbUrl = this.urlForKey(model.key) + "/thumbnail";
            }

            if (model.createdOn != null) {
                model.createdOn = new Date(model.createdOn);
            }

            if (model.versions != null) {
                this.versions = new PJQ.collections.files.Files(model.versions);
            }
        }
        return model;
    },
    convert: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint(this.endpointArr()) + '/convert',
            isApi2: true
        }).post().done(callback).fail(_.bind(function () {
            PJQ.files.logDownloadFailure({
                file: this,
                error: "Failed to convert file"
            })
        }, this));
    },
    checkStatus: function (callback) {
        new PJQ.ajax.Request({
            url: this.get('url')
        }).get().done(callback).fail(_.bind(function () {
            PJQ.files.logDownloadFailure({
                file: this,
                error: "Failed to process file"
            })
        }, this));
    },
    canRender: function () {
        let extension = PJQ.helpers.fileHelpers.getExtension(this.get("name"));
        return extension === 'pdf' || extension === 'tiff' || extension === 'tif';
    },
    isImage: function () {
        return _.contains(PJQ.constants.files.imageExtensions, PJQ.helpers.fileHelpers.getExtension(this.get("name")));
    },
    getNameNoExtension: function () {
        return this.get('name').replace(this.getExtension(), '');
    },
    getExtension: function () {
        let ext = this.get('name').split('.').pop();
        return ext === "" ? ext : ('.' + ext);
    },
    icon: function (isColored = false) {
        let icon;
        if (this.get('isFolder')) {
            icon = 'folder';
        } else {
            icon = 'file';
            switch (PJQ.helpers.fileHelpers.getExtension(this.get("name"))) {
                case 'avi':
                case 'mp4':
                case 'flv':
                case 'mov':
                case 'qt':
                case 'wmv':
                case 'webm':
                    icon = 'file-video';
                    break;
                case 'mp3':
                case 'wav':
                case 'flac':
                case 'm4a':
                case 'm4b':
                case 'wma':
                case 'aac':
                case 'aiff':
                    icon = 'file-audio';
                    break;
                case 'png':
                case 'jpg':
                case 'jpeg':
                case 'bmp':
                case 'gif':
                case 'tif':
                case 'tiff':
                    icon = 'file-image';
                    break;
                case 'pdf':
                    icon = 'file-pdf';
                    break;
                case 'xls':
                case 'xlsx':
                    icon = 'file-excel';
                    break;
                case 'doc':
                case 'docx':
                    icon = 'file-word';
                    break;
                case 'ppt':
                case 'pptx':
                    icon = 'file-powerpoint';
                    break;
                case 'csv':
                    icon = 'file-csv';
                    break;
                case 'zip':
                case 'rar':
                case '7z':
                case 'gz':
                case 'tar':
                    icon = 'file-archive';
                    break;
                case 'eml':
                case 'mbox':
                case 'msg':
                    icon = 'envelope';
                    break;
            }
        }
        return (isColored ? 'file-type ' : '') + 'fal fa-' + icon;
    },
    getFolderAttachments: function (isRecursive = false, filter) {
        return this.collection.getFolderAttachments(this, isRecursive, filter);
    },
    fetchFolderAttachments: function (options = {recursive: false}, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files'
                }
            ], [
                {
                    parameter: 'folderId',
                    value: this.get('guid')
                },
                {
                    parameter: 'recursive',
                    value: options && options.recursive
                }
            ])
            //isApi2: true //dont do this yet
        }).get().done(_.bind(function (files) {
            if (this.collection != null) {
                this.collection.add(files, {
                    silent: true
                });
            }
            this.isFetched = true;
            callback(this.collection.get(_.map(files, function (file) {
                return file.entryId;
            })));
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(null);
        }, this));
    },
    getSiblingAttachments: function () {
        let folderId = this.get('folderId');
        if (this.collection == null || !(folderId > 0)) {
            return [this];
        }

        return this.collection.where({folderId: folderId});
    },
    getParentFolder: function (recursive = false, contextFolder = null, folders = null) {
        let folderId = this.get('folderId');
        if (recursive) {
            if (contextFolder != null) {
                folderId = contextFolder.get('folderId');
            }

            if (folders == null) {
                folders = [];
            }

            if (folderId != null) {
                let parentFolder = this.collection.findWhere({
                    entryId: folderId
                });
                if (parentFolder != null) {
                    folders.push(parentFolder);
                    return this.getParentFolder(recursive, parentFolder, folders);
                }
            }
            return folders;
        }

        if (this.collection == null) {
            return null;
        }

        return this.collection.findWhere({
            entryId: folderId
        });
    },
    getDepth: function () {
        if (this.collection == null) {
            return 0;
        }

        let folder = this.getParentFolder(),
            depth = 0;
        while (folder != null) {
            depth++;
            folder = folder.getParentFolder();
        }
        return depth;
    }
});

PJQ.models.files.ZipFile = PJQ.models.files.File.extend({
    idAttribute: "guid",
    endpoint: function () {
        if (PJQ.app.options.isV2Zips) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'zips',
                    value: this.get('guid')
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'zips',
                value: this.get('guid')
            }
        ]);
    },
    beforeInit: function (options) {
        if (PJQ.app.options.isV2Zips) {
            options.isAPIv2 = true;
        }
    },
    downloadEndpoint: function () {
        return this.endpoint() + '/download';
    },
    download: function () {
        let url = this.get('url');
        if (_.size(url) === 0 && _.size(this.get('key')) > 0) {
            url = this.urlForKey() + '/download';
        }

        if (_.size(url) > 0) {
            PJQ.files.downloadFile(url, {
                isEndpoint: false,
                isApi2: true,
                isAPIv2: PJQ.app.options.isV2Zips
            });
        } else {
            PJQ.files.queueDownload(this.endpoint(), {guids: this.get('guids')}, null, PJQ.app.options.isV2Zips)
        }
    },
    addNotification: function (email) {
        new PJQ.models.files.ZipFileNotification({
            guid: this.get('guid'),
            email: email
        }).save();
    },
    cancel: function () {
        if (!this.get('isReady')) {
            this.set('status', PJQ.constants.files.zipStatus.CANCELLED);
            new PJQ.ajax.Request({
                endpoint: this.endpoint('cancel')
            }).delete();
        }
    }
});

PJQ.models.files.ZipFileNotification = PJQ.models.BaseModel.extend({
    idAttribute: 'zipFileNotificationId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'zips',
                value: this.get('guid')
            },
            {
                endpoint: 'notifications'
            }
        ]);
    }
});

PJQ.models.files.DrawingNotification = PJQ.models.BaseModel.extend({
    idAttribute: 'notificationId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'downloads',
                value: this.get('guid')
            },
            {
                endpoint: 'notifications'
            }
        ]);
    }
});

//Collections
PJQ.collections.files = {};

PJQ.collections.files.Files = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.files.File,
    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
        {
            endpoint: 'files'
        }
    ], [
        {
            parameter: 'folderId',
            value: this.options ? this.options.folderId : null
        }
    ]),
    share: function (data, project, callback) {
        let endpoint;
        if (project != null) {
            if (this.options.isPhotos) {
                endpoint = "/projects/" + project.id.toString() + "/photos/share";
            } else {
                endpoint = "/projects/" + project.id.toString() + "/attachments/share";
            }
        } else {
            endpoint = "/files/share";
        }
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                subject: data != null ? data.subject : null,
                emails: data != null ? data.emails : null,
                guids: _.map(this.models, function (model) {
                    return model.get('guid');
                })
            }
        }).post().done(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }).fail(function () {
            callback();
        });
    },
    download: function () {
        let hasDrawings = _.find(this.models, function (attachment) {
            return attachment.get('isDrawing');
        }) != null;
        if (hasDrawings) {
            PJQ.files.downloadDrawings(this.models);
        } else {
            new PJQ.models.files.ZipFile({
                guids: _.map(this.models, function (file) {
                    return file.get('guid')
                })
            }).download();
        }
    },
    getRootAttachments: function () {
        return this.where({folderId: 0});
    },
    getSharedFolder: function () {
        let sharedFolderRoot = this.get(-1);
        if (sharedFolderRoot == null) {
            let rootFolder = new PJQ.models.files.File({
                entryId: -1,
                folderId: 0,
                name: 'Shared',
                isFolder: true
            });
            this.add(rootFolder);
            _.each(this.models, _.bind(function (model) {
                if (model.get('entryId') !== -1 && null == _.find(this.models, function (modelComp) {
                    return modelComp.get('entryId') === model.get('folderId');
                })) {
                    model.set('folderId', -1);
                }
            }, this));
        }

        return _.find(this.models, function (model) {
            return model.get('folderId') === 0 && model.get('entryId') === -1;
        });
    },
    getPrivateFolder: function () {
        return _.find(this.models, function (model) {
            return model.get('folderId') === 0 && model.get('entryId') > 0;
        });
    },
    getRootSharedAttachments: function () {
        let sharedFolders = this.where({folderId: 0});
        if (_.size(sharedFolders) > 1) {
            return sharedFolders
        }
        let result = [];
        _.each(sharedFolders, function (sharedFolder) {
            result.push(...this.getFolderAttachments(sharedFolder));
        }, this);
        return result;
    },
    fetchFoldersAttachments: function (folders, options = {recursive: false}, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files'
                }
            ], [
                {
                    parameter: 'folderIds',
                    value: _.map(_.filter(folders, function (folder) {
                        return folder.get('isFolder');
                    }), function (f) {
                        return f.get('guid');
                    })
                },
                {
                    parameter: 'recursive',
                    value: options && options.recursive
                }
            ])
            //isApi2: true //dont do this yet
        }).get().done(_.bind(function (files) {
            this.add(files, {
                silent: true
            });
            callback(this.get(_.map(files, function (file) {
                return file.guid;
            })));
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(null);
        }, this));
    },
    getFolderAttachments: function (folder, isRecursive = false, filter = {hideFiles: false, hideFolders: false}) {
        if (folder == null || !folder.get('isFolder')) {
            return [];
        }

        if (isRecursive) {
            let result = [];
            _.each(this.where({folderId: folder.get('entryId')}), function (attachment) {
                if (attachment.get('isFolder')) {
                    if (!filter.hideFolders) {
                        result.push(attachment);
                    }

                    result = _.union(result, this.getFolderAttachments(attachment, isRecursive, filter));
                } else if (!filter.hideFiles) {
                    result.push(attachment);
                }
            }, this);
            return result;
        } else {
            let where = {
                folderId: folder.get('entryId')
            };
            if (filter.hideFolders)
                where.isFolder = true;
            else if (filter.hideFiles) {
                where.isFolder = false;
            }

            return this.where(where);
        }
    },
    destroy: function (callback) {
        let privateFolder = this.getPrivateFolder(),
            privateFolderId = privateFolder ? privateFolder.get('entryId') : null,
            models = _.filter(this.models, _.bind(function (model) {
                return model.get('entryId') !== privateFolderId;
            }, this));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files'
                }
            ]),
            data: {
                entryList: _.map(models, function (model) {
                    return model.get('entryId')
                })
            },
        }).delete().done(_.bind(function () {
            callback(true);
        }, this)).fail(_.bind(function () {
            callback(false);
        }, this));
    }
});

PJQ.collections.files.FileShare = PJQ.collections.files.Files.extend({
    model: PJQ.models.files.File,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'share',
                value: this.options.accessKey
            }
        ]);
    }
});

//Views
PJQ.views.files = {};

PJQ.views.files.FileUploader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader'),
        endpoint: "/files",
        canUpload: true,
        canDelete: true,
        dictRemoveFile: "Delete",
        isRemoveOnComplete: false,
        ignoreHiddenFiles: false,
        allowedExtensions: null,
        dictDefaultMessage: "Drop files here or click to upload",
        parallelUploads: 2,
        chunking: true,
        onError: _.noop,
        onSuccess: _.noop,
        onDrop: _.noop,
        useFileAPI: true,
        useApiV2: false,
        uuid: null,
        useBlob: false
    },
    events: {
        'click .download-import-template': 'downloadImportTemplate'
    },
    downloadImportTemplate: function (e) {
        e.stopPropagation();

        if (typeof this.options.uploadTemplateCallback === 'function') {
            this.options.uploadTemplateCallback();
        }
    },
    getUrl: function (files) {
        let svc, endpoint;
        if (this.options.useApiV2) {
            svc = PJQ.constants.services.APIv2;
            endpoint = '/uploads';
        } else if (this.options.useFileAPI) {
            svc = PJQ.constants.services.FILES;
            endpoint = this.options.endpoint;
        } else {
            svc = PJQ.constants.services.API;
            endpoint = this.options.endpoint;
        }

        let result = PJQ.helpers.urlHelpers.buildApiUrl(endpoint, {
            service: svc
        });
        result += (result.indexOf('?') === -1 ? "?" : "&") + "folder=" + this.options.uuid;
        // there should only ever be one file in the files array
        if (_.size(files) === 1) {
            let file = files[0];
            if (_.size(file.fullPath) > 0 && file.fullPath !== file.name) {
                let folderPath = file.fullPath.replace('/' + file.name, '');
                if (_.size(folderPath) > 0) {
                    result += ('&fp=' + encodeURIComponent(folderPath));
                }
            }
        }
        return result;
    },
    beforeRender: function () {
        if (this.options.uuid === null)
            this.options.uuid = PJQ.helpers.guid();

        if (this.collection == null) {
            this.collection = new PJQ.collections.files.Files();
        }

        this.options.useBlob = this.options.useBlob && PJQ.app.options.useBlobStorage;
    },
    renderData: function () {
        return {
            options: this.options,
            collection: this.collection,
            uuid: "fileUpload_" + this.options.uuid
        };
    },
    afterRender: function () {
        if (!this.options.canDelete)
            this.options.dictRemoveFile = "";
        this.options.headers = PJQ.helpers.apiHelpers.getHeaders();

        let acceptedFilesFormatted = _.map(this.options.allowedExtensions, function (extension) {
            return '.' + extension.toLowerCase();
        });
        this.options.dropzoneOptions = _.defaults(this.options, {
            url: _.bind(this.getUrl, this),
            hiddenInputContainer: this.$el[0],
            maxFilesize: 15000,
            acceptedFiles: _.size(acceptedFilesFormatted) > 0 ? acceptedFilesFormatted.join(',') : null
        });

        if (PJQ.app.session && PJQ.app.options.useBlobStorage && this.options.useBlob) {
            this.options.dropzoneOptions.chunking = false;
            this.options.dropzoneOptions.method = 'PUT';
            this.options.dropzoneOptions.headers = {"x-ms-blob-type": "BlockBlob"};
            this.options.dropzoneOptions.sending = _.bind(function (file, xhr) {
                // send file without wrapping in multipart/form-data
                const _send = xhr.send;
                xhr.send = () => {
                    _send.call(xhr, file)
                };
            }, this)
        }

        this.renderDropzone();

        if (this.options.canUpload) {
            let hasUploadTemplateCallback = typeof this.options.uploadTemplateCallback === 'function';
            let $footer = $('<div class="mt-1" />');
            this.$el.append($footer);

            if (_.size(this.options.allowedExtensions) > 0) {
                $footer.append($('<span>', {
                    class: 'text-muted fs-12 ml-1'
                }).append('<strong>Allowed File Types: </strong>' + this.options.allowedExtensions.join(',') + ((this.options.maxFiles || hasUploadTemplateCallback) ? ' |' : '')));
            }

            if (this.options.maxFiles) {
                $footer.append($('<span>', {
                    class: 'text-muted fs-12 ml-1'
                }).append('<strong>Max Files: </strong>' + this.options.maxFiles + (hasUploadTemplateCallback ? ' |' : '')));
            }

            if (hasUploadTemplateCallback) {
                $footer.append($('<span>', {
                    class: 'text-muted fs-12 ml-1'
                }).append('<strong>Upload Template: </strong>' + '<a class="download-import-template" href="javascript:void(0)">Download</a>'));
            }
        }
    },
    renderDropzone() {
        if (this.$('#fileUpload_' + this.options.uuid).length > 0) {
            this.dropzone = new Dropzone('#fileUpload_' + this.options.uuid, this.options.dropzoneOptions);
            this.dropzone.on('complete', _.bind(function (file) {
                if (this.options.isRemoveOnComplete) {
                    this.removeFile(file);
                }
                if (file.status === 'success') {
                    this.onSuccess(file);
                } else if (file.status === 'error') {
                    if (_.size(this.options.dropzoneOptions.acceptedFiles) > 0 && !_.contains(this.options.dropzoneOptions.acceptedFiles, function (extension) {
                        return file.name.toLowerCase().indexOf(extension);
                    })) {
                        this.removeFile(file);
                        this.showError('The file type you uploaded is not allowed');
                    }

                    this.onError(file);
                }
            }, this));
            this.dropzone.on('drop', _.bind(function () {
                if (typeof this.options.onDrop === 'function') {
                    this.options.onDrop();
                }
            }, this));
        }
    },
    showError: function (errorText, timeout = 2000) {
        this.errorAlert = new PJQ.Alert(this.$('.file-upload'), {
            type: 'danger',
            extraClasses: ['dropzone-error-alert', 'p-absolute', 'wd-100', 'left-0', 'text-align-center'],
            style: 'bottom:-13px !important;',
            text: errorText,
            isAppend: true,
            animation: {
                in: 'fadeIn',
                out: 'fadeOut'
            },
            timeout: timeout
        });

        return this.errorAlert;
    },
    isUploading: function () {
        return this.dropzone != null && _.size(this.dropzone.getQueuedFiles()) + _.size(this.dropzone.getUploadingFiles()) > 0;
    },
    clearError: function () {
        if (this.errorAlert != null) {
            this.errorAlert.destroy();
        }
    },
    removeFile: function (file) {
        if (this.dropzone != null) {
            this.dropzone.removeFile(file);
        }

        if (this.collection != null && file.model != null) {
            this.collection.remove(file.model);
        }
    },
    onError: function (data) {
        this.options.onError(data);
    },
    onSuccess: function (data) {
        let res = null;
        if (data?.blob != null) {
            res = {
                name: data.name
            };
        } else if (data?.xhr) {
            res = JSON.parse(data.xhr.response);
            res.name = res.fileName ?? res.name;
        }
        this.options.onSuccess(res, data);
    }
});

PJQ.views.files.FileUploaderGrid = PJQ.views.files.FileUploader.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid'),
        subTemplates: {
            gridFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid-File'),
            listFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-List-File')
        },
        style: 'grid',
        sideBySide: false,
        isSmall: false, //this is used when the uploader is in a small location so the elements/text sizes need to be smaller
        endpoint: "/files",
        canUpload: true,
        canDelete: true,
        canView: true,
        dictRemoveFile: "Delete",
        isRemoveOnComplete: false,
        ignoreHiddenFiles: false,
        allowedExtensions: null,
        dictDefaultMessage: "Drop files here or click to upload",
        canDownloadAll: false,
        includeProjectAttachments: false,
        parallelUploads: 1,
        chunking: true,
        offsetTopText: false,
        onError: _.noop,
        onSuccess: _.noop,
        onFileStatusChange: _.noop,
        onDrop: _.noop,
        onDelete: null, //this must be null or correctly use the callback (2nd param)
        afterDelete: _.noop,
        previewImageDimension: 150,
        showCreatedByLink: true,
        useFileAPI: true,
        useApiV2: false,
        hasNotes: false,
        isVersioned: false,
        onNewVersion: _.noop,
        context: null,
        contextId: null,
        onAnnotationChange: null,
        canAddAnnotations: true,
        mergeAnnotations: null,
        sortDirection: 'desc',
        maxFiles: null,
        onNoteChanged: null
    },
    events: {
        'click .file-preview-image': 'viewFile',
        'click .file-view-pdf': 'viewPdfFile',
        'click .file-preview-download': 'downloadFile',
        'click .file-preview-delete': 'deleteFile',
        'click .btn-versions': 'viewFileVersions',
        'click .file-edit-note': 'editNote',
        'click .download-all': 'downloadAll',
        'click .dz-upload-project-attachments': 'uploadFromProjectAttachments',
        'click .download-import-template': 'downloadImportTemplate'
    },
    viewFileVersions: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        if (file == null && this.options.isVersioned) {
            // Find the model in the collection the versioned file belongs to
            file = _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        return true;
                    }
                }
                return false;
            });
        }

        new PJQ.views.files.FileVersionsModal({
            model: file,
            collectionDefinition: this.collection ? this.collection.constructor : null,
            onSave: _.bind(function (files) {
                let parentAttachment = files[0].get('parentAttachmentId') != null ? this.collection.get(files[0].get('parentAttachmentId')) : null;

                if (parentAttachment != null) {
                    parentAttachment.versions.add(files);
                }

                this.collection.add(files);
                if (this.options.onNewVersion) {
                    this.options.onNewVersion();
                }
            }, this)
        });
    },
    beforeFirstRender: function () {
        this.options.uuid = PJQ.helpers.guid();

        let prefs = null;
        if (PJQ.app.session.project != null) {
            prefs = PJQ.app.session.project.preferences;
        } else {
            prefs = PJQ.app.session.preferences;
        }
        if (prefs != null) {
            this.options.sideBySide = prefs.hasPref(PJQ.constants.preferenceTypes.FILE_UPLOADER_SIDE_BY_SIDE);
        }
    },
    renderDropzone() {
        if (this.options.isSmall) {
            this.$('.file-upload').addClass('file-upload-small');
        }

        if (this.options.style.toLowerCase() === 'list') {
            this.$('.file-upload').addClass('file-upload-list');
        } else {
            this.$('.file-upload').addClass('file-upload-grid');
        }

        if (!this.options.canUpload) {
            this.renderFiles();
            return;
        }

        let useBlob = this.options.useBlob,
            fnRender = (blobToken) => {
                useBlob = useBlob && blobToken != null;
                this.dropzone = new Dropzone(this.$('#fileUpload_' + this.options.uuid)[0], _.extend(this.options.dropzoneOptions, {
                    maxFiles: this.options.maxFiles,
                    maxfilesexceeded: _.bind(function (file) {
                        this.removeFile(file);
                        this.showError('Maximum files exceeded');
                    }, this),
                    addedfile: _.bind(function (file) {
                        if (this.options.maxFiles && _.size(_.filter(this.collection.models, function (model) {
                            return !model.get('delete') && !model.get('isDeleted');
                        }, this)) >= this.options.maxFiles) {
                            this.removeFile(file);
                            this.showError('Maximum files exceeded');
                            return;
                        }
                        let fileModel = new this.collection.model({
                            name: file.name,
                            status: 'queued'
                        });

                        if (PJQ.app.session.contact != null) {
                            fileModel.set('createdBy', PJQ.app.session.contact.toJSON());
                        } else if (PJQ.app.session.user != null) {
                            fileModel.set('createdBy', PJQ.app.session.user.toJSON());
                        }

                        if (this.options.versionByName) {
                            let parentAttachment;
                            if (typeof this.options.getParentAttachment === 'function') {
                                parentAttachment = this.options.getParentAttachment(fileModel);
                            } else {
                                parentAttachment = _.find(this.collection.models, (file) => {
                                    return file.get('name') === fileModel.get('name') && !file.get('delete')
                                        && (file.get('parentAttachmentId') == null || file.get('parentAttachmentId') === file.id);
                                });
                            }
                            if (parentAttachment != null) {
                                fileModel.set('parentAttachmentId', parentAttachment.id);
                            }
                        }

                        fileModel.file = file;
                        file.model = fileModel;
                        this.collection.add(fileModel);
                        file.$previewElement = this.renderFile(fileModel, this.options.style.toLowerCase() === 'grid');
                        file.$previewElement.addClass('uploading queued');
                        file.previewElement = file.$previewElement[0];
                    }, this),
                    thumbnail: function (file, dataUrl) {
                        if (file.$previewElement != null) {
                            file.$previewElement.find('.file-preview-image').attr('src', dataUrl);
                        }
                    },
                    uploadprogress: function (file, progress) {
                        file.$previewElement.removeClass('queued');

                        if (file.model.get('status') !== file.status) {
                            file.model.set('status', file.status);
                            this.options.onFileStatusChange(file);
                        }

                        //This is a fix for chunking progress
                        //Dropzone triggers a progress event for the end of a chunk w/ a progress of 100%
                        //We want to ignore all progress events that are not related to the total upload progress of this file
                        if ((file.status === 'uploading' && progress < 100) || file.status === 'success') {
                            file.lastProgress = Math.ceil(progress);
                            let width = file.lastProgress.toString() + '%';
                            file.$previewElement.find(".file-preview-progress .progress-bar").css('width', width).html(width);
                        }
                    },
                    drop: _.bind(function () {
                        if (typeof this.options.onDrop === 'function') {
                            this.options.onDrop();
                        }
                    }, this),
                    complete: _.bind(function (file) {
                        file.model.set('status', file.status);
                        this.options.onFileStatusChange(file);
                        if (file.status === 'success') {
                            file.$previewElement.removeClass('uploading').addClass('uploaded');

                            file.model.dataUrl = file.dataURL;

                            let response;
                            if (file.blob) {
                                file.model.set('blob', file.blob);
                            } else {
                                response = JSON.parse(file.xhr.response);
                                if (this.options.useApiV2 || (this.options.endpoint !== '/files' && !this.options.useApiV2)) {
                                    file.model.set({
                                        uploadId: response.uploadId,
                                        name: response.name ?? response.fileName ?? response.fileData?.fileName
                                    }, {
                                        silent: true
                                    });
                                } else {
                                    file.model.set({
                                        folder: response.folder,
                                        name: response.name ?? response.fileName ?? response.fileData?.fileName
                                    }, {
                                        silent: true
                                    });
                                }
                            }

                            if (!this.options.useApiV2 && this.options.endpoint !== '/files') {
                                let fileResponse;
                                if (PJQ.helpers.objectHelpers.refinedType(response) === 'array') {
                                    _.each(response, function (responseFile) {
                                        if (responseFile.isFolder) {
                                            this.collection.add(responseFile);
                                        } else {
                                            fileResponse = responseFile;
                                        }
                                    }, this);
                                } else {
                                    fileResponse = response;
                                }
                                file.model.set(fileResponse, {
                                    silent: true
                                });
                            }

                            if (file.model.id > 0) {
                                file.$previewElement.find('.file-preview-download').removeClass('hidden');
                            }

                            this.onSuccess(file);
                        } else if (file.status === 'error') {
                            if (_.size(this.options.dropzoneOptions.acceptedFiles) > 0 && !_.contains(this.options.dropzoneOptions.acceptedFiles, function (extension) {
                                return file.name.toLowerCase().indexOf(extension);
                            })) {
                                this.removeFile(file);
                                this.showError('The file type you uploaded is not allowed');
                            } else {
                                let retries = file.model.get('retries');
                                retries = retries != null ? retries : 0;
                                if (retries > -1) {
                                    file.$previewElement.removeClass('uploading').addClass('failed');
                                } else {
                                    file.model.set('retries', 1);
                                    new File([file], file.name, {type: file.type});
                                    this.dropzone.uploadFile(file);
                                }
                            }

                            this.onError(file);
                        }
                    }, this)
                }));

                if (useBlob) {
                    let dz = this.dropzone;
                    dz.on("processing", (file) => {
                        let blobName = PJQ.helpers.guid() + ".file"
                        file.blob = blobToken.id + "/" + blobName;
                        file.uploadId = 'blob:' + file.blob;
                        dz.options.headers["Content-Type"] = file.type;
                        dz.options.headers["x-ms-blob-content-disposition"] = "attachment; filename=" + file.name;
                        dz.options.url = `${blobToken.url}/${blobName}?${blobToken.token}`;
                    })
                }
            }

        if (PJQ.app.session && useBlob) {
            this.options.chunking = false;
            PJQ.app.TokenManager.getBlobToken('upload', _.bind(function (blobToken) {
                fnRender(blobToken);
            }, this))
        } else {
            fnRender();
        }

        this.renderFiles();
    },
    renderFiles() {
        if (this.options.canUpload) {
            this.renderUploadMessage();
        }

        _.each(_.sortBy(_.filter(this.collection.models, function (model) {
            return !model.get('isDeleted');
        }), _.bind(function (model) {
            if (this.options.sortBy)
                return model.get(this.options.sortBy);

            if (this.options.sortDirection && this.options.sortDirection.toLowerCase() === 'asc') {
                return model.id;
            }
            return -model.id;
        }, this)), _.bind(function (model) {
            let fileToRender = model;

            // If the model is versioned, we want to render the newest version.
            if (this.options.isVersioned) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    fileToRender = _.max(model.versions.models, (v) => v.get('version'));
                } else if (model.get('version') > 1) {
                    fileToRender = null;
                }
            }

            if (fileToRender != null) {
                this.renderFile(fileToRender);
            }
        }, this));
        PJQ.app.lazyLoad().update();
    },
    renderFile(file, isPrepend = false) {
        let fileTemplate;
        if (this.options.style.toLowerCase() === 'list') {
            fileTemplate = this.options.subTemplates.listFile;
        } else {
            fileTemplate = this.options.subTemplates.gridFile;
        }
        let $fileEl = PJQ.templating.TemplateRenderer.parseTemplate(fileTemplate, {
            model: file,
            showCreatedByLink: this.options.showCreatedByLink,
            canDelete: this.options.canDelete,
            canView: this.options.canView,
            isImage: file.isImage(),
            thumbUrl: file.thumbnailUrl(),
            previewImageDimension: this.options.previewImageDimension,
            hasNotes: this.options.hasNotes,
            isVersioned: this.options.isVersioned,
            versions: this.options.versions ? this.options.versions : null
        });
        if (this.options.canUpload && !this.$('.dz-message').hasClass('dz-message-top')) {
            $fileEl.addClass('hidden');
            this.renderUploadMessage(_.bind(function () {
                $fileEl.removeClass('hidden');
            }, this));
        }
        let $outer;
        if (this.options.sideBySide && file.id > 0) {
            $outer = this.$('.files-existing-container');
        } else {
            $outer = this.$('.files-container');
        }
        if (isPrepend) {
            $outer.prepend($fileEl);
        } else {
            $outer.append($fileEl);
        }
        return $fileEl;
    },
    renderUploadMessage: function (callback = _.noop) {
        let $message = this.$('.dz-message'),
            topClass = 'dz-message-top',
            topCSS = {
                height: '40px'
            };

        if (this.options.offsetTopText)
            topCSS.right = '3rem';

        if ((!this.options.sideBySide && this.collection.length > 0) || (this.collection.findWhere(function (attachment) {
            return attachment.isNew();
        }) != null)) {
            this.$('.file-upload').removeClass('dz-clickable');
            if (!$message.hasClass('dz-message-top')) {
                $message.addClass(topClass).animate(topCSS, 500, _.bind(function () {
                    $message.css(topCSS).html('Drop files or <a href="javascript:void(0)" class="file-upload-upload ml-1 text-orange">click here to upload</a>');
                    if (this.options.offsetTopText) {
                        $message.removeAttr('left')
                        $message.css('right', '3rem');
                    }
                    if (callback != null) {
                        callback();
                    }
                }, this)).addClass(topClass);
            } else {
                callback();
            }
        } else {
            $message.html('Drop files or click to upload');
            if (callback != null) {
                callback();
            }
        }
    },
    uploadFromProjectAttachments: function (e) {
        new PJQ.views.projects.AttachmentsModal({
            onSave: _.bind(function (files) {
                _.each(files, function (file) {
                    let fileModel = new PJQ.models.files.File(file.toJSON());
                    if (!fileModel.get('isFolder')) {
                        if (fileModel.get('drawingId') > 0) {
                            fileModel.set('entryId', -fileModel.get('drawingId'));
                        }
                        fileModel.set('attachmentId', null);
                        this.collection.add(fileModel);
                        this.options.onSuccess(fileModel);
                    }
                }, this)
                this.render();
            }, this)
        });
    },
    viewFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find and set file to the newest version if the file is versioned.
        if (file == null && this.options.isVersioned) {
            _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        file = versionFile;
                        return true;
                    }
                }
                return false;
            });
        }

        PJQ.app.view.renderPhotoViewer({
            model: file,
            collection: this.collection,
            canDelete: this.options.canDelete,
            onDelete: _.bind(function () {
                this.render()
            }, this)
        });
    },
    viewPdfFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find and set file to the newest version if the file is versioned.
        if (file == null && this.options.isVersioned) {
            _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        file = versionFile;
                        return true;
                    }
                }
                return false;
            });
        }

        if (file.get('entryId') < 0) {
            let drawing = new PJQ.models.drawings.Drawing({
                drawingId: -file.get('entryId')
            });
            drawing.fetch({
                success: _.bind(function () {
                    new PJQ.views.drawings.DrawingViewer({
                        model: drawing,
                        context: this.options.context,
                        contextId: this.options.contextId,
                        isAnnotationsEnabled: true,
                        noNavigation: true,
                        canAddAnnotations: this.options.canAddAnnotations,
                        onAnnotationChange: this.options.onAnnotationChange,
                        mergeAnnotations: this.options.mergeAnnotations != null ? this.options.mergeAnnotations.models : null
                    });
                }, this)
            })
        } else {
            new PJQ.views.files.FileViewer({
                model: file
            });
        }
    },
    downloadFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find and set file to the newest version if the file is versioned.
        if (file == null && this.options.isVersioned) {
            _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        file = versionFile;
                        return true;
                    }
                }
                return false;
            });
        }

        if (file.versions != null && _.size(file.versions.models) > 0) {
            let newestVersion = file.versions.sortBy((v) => {
                return -v.id;
            })[0];
            return newestVersion.download();
        }
        file.download();
    },
    downloadAll: function () {
        this.collection.download();
    },
    downloadVersion: function (e) {
        let file = this.options.versions.get($(e.currentTarget).closest('.btn-download-version').data('cid'))
        file.download();
    },
    editNote: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find the collection model the version belongs to. Keep all notes on the collection model.
        if (file == null && this.options.isVersioned) {
            file = _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        return true;
                    }
                }
                return false;
            });
        }

        new PJQ.views.submittals.FileEditorModal({
            model: file,
            isNoteEdit: true,
            collection: this.collection,
            isNewVersion: true,
            onSave: () => {
                this.render();

                if (typeof this.options.onNoteChanged === 'function') {
                    this.options.onNoteChanged(file);
                }
            }
        });
    },
    deleteFile: function (e) {
        let previewContainer = $(e.currentTarget).closest('.file-preview'),
            file = this.collection.get(previewContainer.data('cid'));

        // Find the collection model the version file belongs to and delete that.
        if (file == null && this.options.isVersioned) {
            file = _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        return true;
                    }
                }
                return false;
            });
        }

        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(file, _.bind(function () {
                previewContainer.remove();
                this.options.afterDelete();
            }, this));
        } else {
            file.destroy();
            previewContainer.remove();
            this.options.afterDelete();
        }
    }
});

PJQ.views.files.ZipProgressModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Zip-Progress'),
        subTemplates: {
            content: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Zip-Progress-Content')
        },
        checkProgressInterval: 2000,
        minWaitSeconds: null
    },
    events: {
        'click .zip-download-button': 'downloadZip',
        'click .zip-email-button': 'emailZip',
        'keyup .zip-email': 'emailChanged',
        'click .zip-cancel-button': 'cancelZip'
    },
    beforeModalCreated: function () {
        if (this.options.minWaitSeconds > 0) {
            this.isWaiting = true;
            this.waitTimeout = setTimeout(_.bind(function () {
                this.isWaiting = false;
                let status = this.model.get('status');
                if (this.model.get('isReady') && (status === PJQ.constants.files.zipStatus.COMPLETE || status === PJQ.constants.files.zipStatus.COMPLETE_ASYNC)) {
                    this.downloadZip();
                    this.stopChecking();
                }
            }, this), this.options.minWaitSeconds * 1000);
        }
    },
    renderData: function () {
        return {
            model: this.model,
            showPromo: this.options.showPromo,
            promoType: this.options.promoType
        };
    },
    afterRender: function () {
        this.renderContent();
        this.checkZipStatus();
    },
    checkZipStatus: function () {
        let status = this.model.get('status');
        if (this.model.get('isReady') && (status === PJQ.constants.files.zipStatus.COMPLETE || status === PJQ.constants.files.zipStatus.COMPLETE_ASYNC)) {
            if (this.isWaiting) {
                this.renderContent();
            } else {
                this.downloadZip();
            }
        } else if (status === PJQ.constants.files.zipStatus.NEW || status === PJQ.constants.files.zipStatus.QUEUED || status === PJQ.constants.files.zipStatus.IN_PROGRESS) {
            this.checkStatusTimeout = setTimeout(_.bind(function () {
                this.model.fetch({
                    success: _.bind(function () {
                        this.checkZipStatus();
                    }, this),
                    fail: _.bind(function (model, result) {
                        this.model.set('status', PJQ.constants.files.zipStatus.FAILED);
                        this.renderContent();
                        PJQ.files.logDownloadFailure({
                            model: model,
                            result: result
                        });
                    }, this)
                });
            }, this), this.options.checkProgressInterval);
        } else if (status === PJQ.constants.files.zipStatus.CANCELLED || status === PJQ.constants.files.zipStatus.FAILED) {
            this.renderContent();
        }
    },
    renderContent: function () {
        let defaultEmail = "";
        if (PJQ.app.session.user != null) {
            defaultEmail = PJQ.app.session.user.get('email');
        } else if (PJQ.app.session.contact != null) {
            defaultEmail = PJQ.app.session.contact.get('email');
        }
        this.renderSubTemplate(false, this.options.subTemplates.content, this.$('.download-content'), {
            model: this.model,
            defaultEmail: defaultEmail,
            isWaiting: this.isWaiting
        }, _.bind(function () {
            if (this.model.get('status') === PJQ.constants.files.zipStatus.CANCELLED || this.model.get('status') === PJQ.constants.files.zipStatus.FAILED) {
                this.$('.zip-cancel-button').text('Close');
            } else {
                new PJQ.Loader(this.$('.zip-loader'), {
                    type: 'block'
                });
            }
        }, this));
    },
    downloadZip: function () {
        if (!this.cancel && !this.downloaded) {
            this.downloaded = true;

            this.model.download();

            if (this.options.showPromo) {
                this.renderContent();
            } else {
                this.removeModal();
            }
        }
    },
    emailChanged: function () {
        this.$('.zip-email-button').prop('disabled', this.$('.zip-email').val().indexOf('@') <= 0);
    },
    emailZip: function () {
        this.stopChecking();
        this.model.addNotification(this.$('.zip-email').val());
    },
    cancelZip: function () {
        //Clear the timeout for checking the status since we are cancelling it
        //Do this first because once its cancelled the /download endpoint will return 404
        this.stopChecking();
        if (this.model.get('status') === PJQ.constants.files.zipStatus.IN_PROGRESS) {
            //Only send the cancel request to the server if its in progress
            this.model.cancel();
        }
    },
    stopChecking: function () {
        this.cancel = true;
        if (this.checkStatusTimeout != null) {
            clearTimeout(this.checkStatusTimeout);
        }
        if (this.waitTimeout != null) {
            clearTimeout(this.waitTimeout);
        }
    }
});

PJQ.views.files.FileProgressModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-File-Progress'),
        subTemplates: {
            content: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-File-Progress-Content')
        }
    },
    events: {
        'click .file-cancel-button': 'cancelDownload'
    },
    afterRender: function () {
        this.renderContent();
    },
    renderContent: function () {
        this.renderSubTemplate(false, this.options.subTemplates.content, this.$('.modal-body'), {
            model: this.model
        }, _.bind(function () {
            new PJQ.Loader(this.$('.file-loader'), {
                type: 'block'
            });
            if (this.model.get('isReady')) {
                this.downloadFile();
            } else if (this.model.get('isProcess') && _.size(this.model.get('url')) > 0) {
                this.checkStatus();
            } else {
                this.model.convert(_.bind(function () {
                    this.downloadFile();
                }, this));
            }
        }, this));
    },
    downloadFile: function () {
        if (!this.isCancel) {
            this.model.download();
            this.removeModal();
        }
    },
    checkStatus: function () {
        setTimeout(_.bind(function () {
            this.model.checkStatus(_.bind(function (data) {
                this.model.set(data);
                if (!data.isReady) {
                    this.checkStatus();
                } else {
                    this.downloadFile();
                }
            }, this));
        }, this), 2000);
    },
    cancelDownload: function () {
        this.isCancel = true;
    }
});

PJQ.views.files.DrawingProgressModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Drawing-Progress'),
        subTemplates: {
            content: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Drawing-Progress-Content')
        },
        checkProgressInterval: 2000,
        minWaitSeconds: null
    },
    events: {
        'click .drawing-download-button': 'downloadZip',
        'click .drawing-email-button': 'emailZip',
        'keyup .drawing-email': 'emailChanged',
        'click .drawing-cancel-button': 'cancelZip'
    },
    beforeModalCreated: function () {
        if (this.options.minWaitSeconds > 0) {
            this.isWaiting = true;
            this.waitTimeout = setTimeout(_.bind(function () {
                this.isWaiting = false;
                let status = this.model.get('status');
                if (this.model.get('isReady') && (status === PJQ.constants.drawings.downloadStatus.COMPLETE)) {
                    this.downloadDrawings();
                    this.stopChecking();
                }
            }, this), this.options.minWaitSeconds * 1000);
        }
    },
    renderData: function () {
        return {
            model: this.model,
            showPromo: this.options.showPromo,
            promoType: this.options.promoType
        };
    },
    afterRender: function () {
        this.renderContent();
        this.checkDownloadStatus();
    },
    checkDownloadStatus: function () {
        let status = this.model.get('status');
        if (this.model.get('isReady') && status === PJQ.constants.drawings.downloadStatus.COMPLETE) {
            if (this.isWaiting) {
                this.renderContent();
            } else {
                this.downloadDrawings();
            }
        } else if (status === PJQ.constants.drawings.downloadStatus.QUEUED || status === PJQ.constants.drawings.downloadStatus.IN_PROGRESS) {
            this.checkStatusTimeout = setTimeout(_.bind(function () {
                this.model.fetch({
                    success: _.bind(function () {
                        this.checkDownloadStatus();
                    }, this),
                    fail: _.bind(function (model, result) {
                        this.model.set('status', PJQ.constants.drawings.downloadStatus.FAILED);
                        this.renderContent();
                        PJQ.files.logDownloadFailure({
                            model: model,
                            result: result
                        });
                    }, this)
                });
            }, this), this.options.checkProgressInterval);
        } else if (status === PJQ.constants.drawings.downloadStatus.FAILED) {
            this.renderContent();
        }
    },
    renderContent: function () {
        let defaultEmail = "";
        if (PJQ.app.session.user != null) {
            defaultEmail = PJQ.app.session.user.get('email');
        } else if (PJQ.app.session.contact != null) {
            defaultEmail = PJQ.app.session.contact.get('email');
        }
        this.renderSubTemplate(false, this.options.subTemplates.content, this.$('.modal-body'), {
            model: this.model,
            defaultEmail: defaultEmail,
            isWaiting: this.isWaiting
        }, _.bind(function () {
            if (this.model.get('status') === PJQ.constants.drawings.downloadStatus.FAILED) {
                this.$('.drawing-cancel-button').text('Close');
            }
        }, this));
    },
    downloadDrawings: function () {
        if (!this.cancel && !this.downloaded) {
            this.downloaded = true;

            this.model.download();
            if (this.options.showPromo) {
                this.renderContent();
            } else {
                this.removeModal();
            }
        }
    },
    emailChanged: function () {
        this.$('.drawing-email-button').prop('disabled', this.$('.drawing-email').val().indexOf('@') <= 0);
    },
    emailZip: function () {
        this.stopChecking();
        this.model.addNotification(this.$('.drawing-email').val());
    },
    cancelZip: function () {
        //Clear the timeout for checking the status since we are cancelling it
        //Do this first because once its cancelled the /download endpoint will return 404
        this.stopChecking();
        if (this.model.get('status') === PJQ.constants.files.zipStatus.IN_PROGRESS) {
            //Only send the cancel request to the server if its in progress
            this.model.cancel();
        }
    },
    stopChecking: function () {
        this.cancel = true;
        if (this.checkStatusTimeout != null) {
            clearTimeout(this.checkStatusTimeout);
        }
    }
});

PJQ.views.files.FileUploaderModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-Upload'),
        fileUploaderOptions: {},
        onDone: _.noop,
        maxFiles: null
    },
    events: {
        'click .btn-done': 'done'
    },
    beforeModalCreated: function () {
        this.files = new PJQ.collections.files.Files();
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    afterRender: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid(_.defaults({
            el: this.$('.file-uploader-container'),
            collection: this.files,
            endpoint: this.options.project != null ? PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'attachments',
                    value: this.options.folder != null ? this.options.folder.get('entryId') : null
                }
            ]) : PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files',
                    value: this.options.folder != null ? this.options.folder.get('entryId') : null
                }
            ]),
            allowedExtensions: this.options.allowedExtensions,
            maxFiles: this.options.maxFiles,
            style: 'list',
            onSuccess: _.bind(this.dataChanged, this),
            onFileStatusChange: _.bind(this.dataChanged, this),
            onDrop: _.bind(this.dataChanged, this),
            afterDelete: _.bind(this.dataChanged, this)
        }, this.options.fileUploaderOptions));
    },
    dataChanged: function () {
        let queued = 0,
            uploading = 0,
            success = 0,
            failed = 0;
        _.each(this.files.models, function (file) {
            switch (file.get('status')) {
                case 'queued':
                    queued++;
                    break;
                case 'uploading':
                    uploading++;
                    break;
                case 'success':
                    success++;
                    break;
                case 'error':
                    failed++;
                    break;
            }

            let $queued = $('<span class="text-primary mr-2">Queued: ' + queued.toString() + '</span>');
            if (queued === 0) {
                $queued.addClass('op-6 font-weight-light');
            }

            let $uploaded = $('<span class="text-orange mr-2">Uploading: ' + uploading.toString() + '</span>');
            if (uploading === 0) {
                $uploaded.addClass('op-6 font-weight-light');
            }

            let $success = $('<span class="text-success mr-2">Uploaded: ' + success.toString() + '</span>');
            if (success === 0) {
                $success.addClass('op-6 font-weight-light');
            }

            let data;
            if (failed === 0) {
                data = [$queued, $uploaded, $success];
            } else {
                data = [$queued, $uploaded, $success, $('<span class="text-danger">Failed: ' + failed.toString() + '</span>')];
            }

            this.$('.upload-files-status').empty().append(data);
        }, this);
    },
    done: function () {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You cannot finish while files are still uploading.  Would you like to stop uploading?",
                isShowOkButton: false,
                isShowCancelButton: true,
                isShowSecondaryButton: true,
                secondaryButtonText: "Stop Upload",
                secondaryButtonColorClass: "danger",
                onSecondary: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
            if (typeof this.options.onDone === 'function') {
                this.options.onDone(this.files.models);
            }
        }
    },
    cancel: function () {
        this.removeModal();
    }
});

PJQ.views.files.RawFileUploaderModal = PJQ.views.files.FileUploaderModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-File-Uploader-Raw'),
        maxWidth: '530px'
    },
    events: {
        'keyup .input-revision-name': 'dataChanged',
        'click .btn-submit': 'submit'
    },
    beforeModalCreated: function () {
        if (this.options.project == null) {
            this.options.project = PJQ.app.session.project;
        }

        this.files = new PJQ.collections.files.Files();
    },
    beforeRender: function () {
        this.renderData = {
            uploadId: this.uploadId,
            options: this.options
        }
    },
    afterRender: function () {
        if (this.uploadId == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.raw-file-upload'),
                collection: this.files,
                useFileAPI: false,
                style: 'list',
                onSuccess: _.bind(this.dataChanged, this),
                onFileStatusChange: _.bind(this.dataChanged, this),
                onDrop: _.bind(this.dataChanged, this),
                afterDelete: _.bind(this.dataChanged, this)
            });
        }
    },
    dataChanged: function () {
        let hasName = _.size(this.$('.input-revision-name').val()) > 0,
            attachmentsCount = _.size(this.files.models),
            hasAttachments = attachmentsCount > 0;

        let queued = 0,
            uploading = 0,
            success = 0;
        _.each(this.files.models, function (attachment) {
            switch (attachment.get('status')) {
                case 'queued':
                    queued++;
                    break;
                case 'uploading':
                    uploading++;
                    break;
                case 'success':
                    success++;
                    break;
            }

            let $queued = $('<span class="text-primary mr-2">Queued: ' + queued.toString() + '</span>');
            if (queued === 0) {
                $queued.addClass('op-6 font-weight-light');
            }

            let $uploaded = $('<span class="text-orange mr-2">Uploading: ' + uploading.toString() + '</span>');
            if (uploading === 0) {
                $uploaded.addClass('op-6 font-weight-light');
            }


            let $success = $('<span class="text-success">Uploaded: ' + success.toString() + '</span>');
            if (success === 0) {
                $success.addClass('op-6 font-weight-light');
            }

            this.$('.upload-files-status').empty().append([$queued, $uploaded, $success]);
        }, this);
        this.$('.btn-submit').prop('disabled', !hasName || !hasAttachments || this.fileUploader.isUploading());
    },
    submit: function () {
        let postData = {
            name: this.$('.input-revision-name').val(),
            notes: this.$('.input-revision-notes').val(),
            attachments: this.files.toJSON()
        };
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'revisions'
                },
            ]),
            data: postData,
            //isApi2: true //dont do this yet
        }).post().done(_.bind(function (data) {
            this.uploadId = data.uploadId;
            if (this.options.project != null) {
                this.options.project.set('status', 'BUSY');
            }
            this.render();
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.uploadId = 0;
            this.render();
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.UPLOAD_RAW_FILES, {
                data: postData,
                error: err,
                result: result
            });
        }, this));
    }
});

PJQ.views.files.FileUploaderBackground = PJQ.views.files.FileUploader.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid'),
        subTemplates: {
            gridFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid-File'),
            listFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-List-File')
        },
        style: 'grid',
        isSmall: false, //this is used when the uploader is in a small location so the elements/text sizes need to be smaller
        endpoint: "/files",
        canUpload: true,
        canDelete: true,
        canView: true,
        dictRemoveFile: "Delete",
        isRemoveOnComplete: false,
        allowedExtensions: null,
        dictDefaultMessage: "Drop files here or click to upload",
        parallelUploads: 1,
        chunking: true,
        onError: _.noop,
        onSuccess: _.noop,
        onFileStatusChange: _.noop,
        onDrop: _.noop,
        onDelete: null, //this must be null or correctly use the callback (2nd param)
        afterDelete: _.noop,
        previewImageDimension: 160,
        showCreatedByLink: true,
        useFileAPI: true,
        hasNotes: false,
        isVersioned: false
    },
    events: {
        'click .file-preview-image': 'viewFile',
        'click .file-preview-download': 'downloadFile',
        'click .file-preview-delete': 'deleteFile',
        'click .file-preview': 'renderHistoryFiles'
    },
    beforeFirstRender: function () {
        if (this.collection == null) {
            this.collection = new PJQ.collections.files.Files();
        }
    },
    renderDropzone() {
        if (this.options.isSmall) {
            this.$('.file-upload').addClass('file-upload-small');
        }

        if (this.options.style.toLowerCase() === 'list') {
            this.$('.file-upload').addClass('file-upload-list');
        } else {
            this.$('.file-upload').addClass('file-upload-grid');
        }

        this.dropzone = new Dropzone('#fileUpload_' + this.options.uuid, _.extend(this.options.dropzoneOptions, {
            addedfile: _.bind(function (file) {
                let fileModel = new this.collection.model({
                    name: file.name,
                    status: 'queued'
                });

                if (PJQ.app.session.contact != null) {
                    fileModel.set('createdBy', PJQ.app.session.contact.toJSON());
                } else if (PJQ.app.session.user != null) {
                    fileModel.set('createdBy', PJQ.app.session.user.toJSON());
                }

                fileModel.file = file;
                file.model = fileModel;
                this.collection.add(fileModel);
                file.$previewElement = this.renderFile(fileModel, this.options.style.toLowerCase() === 'grid');
                file.$previewElement.addClass('uploading queued');
                file.previewElement = file.$previewElement[0];
            }, this),
            thumbnail: function (file, dataUrl) {
                if (file.$previewElement != null) {
                    file.$previewElement.find('.file-preview-image').attr('src', dataUrl);
                }
            },
            uploadprogress: function (file, progress) {
                file.$previewElement.removeClass('queued');

                if (file.model.get('status') !== file.status) {
                    file.model.set('status', file.status);
                    this.options.onFileStatusChange(file);
                }

                //This is a fix for chunking progress
                //Dropzone triggers a progress event for the end of a chunk w/ a progress of 100%
                //We want to ignore all progress events that are not related to the total upload progress of this file
                if ((file.status === 'uploading' && progress < 100) || file.status === 'success') {
                    file.lastProgress = Math.ceil(progress);
                    let width = file.lastProgress.toString() + '%';
                    file.$previewElement.find(".file-preview-progress .progress-bar").css('width', width).html(width);
                }
            },
            drop: _.bind(function () {
                if (typeof this.options.onDrop === 'function') {
                    this.options.onDrop();
                }
            }, this),
            complete: _.bind(function (file) {
                if (file.status === 'success') {
                    file.$previewElement.removeClass('uploading').addClass('uploaded');

                    file.model.dataUrl = file.dataURL;
                    let response = JSON.parse(file.xhr.response);
                    if (this.options.useApiV2) {
                        file.model.set({
                            uploadId: response.uploadId,
                            name: response.fileName
                        }, {
                            silent: true
                        });
                    } else {
                        file.model.set({
                            folder: response.folder,
                            name: response.fileData.fileName
                        }, {
                            silent: true
                        });
                    }

                    if (!this.options.useApiV2 && this.options.endpoint !== '/files') {
                        let fileResponse;
                        if (PJQ.helpers.objectHelpers.refinedType(response) === 'array') {
                            _.each(response, function (responseFile) {
                                if (responseFile.isFolder) {
                                    this.collection.add(responseFile);
                                } else {
                                    fileResponse = responseFile;
                                }
                            }, this);
                        } else {
                            fileResponse = response;
                        }
                        file.model.set(fileResponse, {
                            silent: true
                        });
                    }

                    if (file.model.id > 0) {
                        file.$previewElement.find('.file-preview-download').removeClass('hidden');
                    }

                    this.onSuccess(file);
                } else if (file.status === 'error') {
                    if (_.size(this.options.dropzoneOptions.acceptedFiles) > 0 && !_.contains(this.options.dropzoneOptions.acceptedFiles, function (extension) {
                        return file.name.toLowerCase().indexOf(extension);
                    })) {
                        this.removeFile(file);
                        this.showError('The file type you uploaded is not allowed');
                    } else {
                        let retries = file.model.get('retries');
                        retries = retries != null ? retries : 0;
                        if (retries > -1) {
                            file.$previewElement.removeClass('uploading').addClass('failed');
                        } else {
                            file.model.set('retries', 1);
                            new File([file], file.name, {type: file.type});
                            this.dropzone.uploadFile(file);
                        }
                    }
                }
            }, this)
        }));

        if (!this.options.canUpload) {
            this.$(".dz-hidden-input").remove();
        }

        this.renderFiles();
    },
    renderFiles() {
        if (this.options.canUpload) {
            this.renderUploadMessage();
        }

        _.each(_.sortBy(_.filter(this.collection.models, function (model) {
            return !model.get('isDeleted');
        }), function (model) {
            return -model.get('entryId');
        }), _.bind(function (model) {
            this.renderFile(model);
        }, this));
        PJQ.app.lazyLoad().update();
    },
    renderFile(file, isPrepend = false) {
        let fileTemplate;
        if (this.options.style.toLowerCase() === 'list') {
            fileTemplate = this.options.subTemplates.listFile;
        } else {
            fileTemplate = this.options.subTemplates.gridFile;
        }
        let $fileEl = PJQ.templating.TemplateRenderer.parseTemplate(fileTemplate, {
            model: file,
            showCreatedByLink: this.options.showCreatedByLink,
            canDelete: this.options.canDelete,
            canView: this.options.canView,
            isImage: file.isImage(),
            thumbUrl: file.thumbnailUrl(),
            previewImageDimension: this.options.previewImageDimension,
            hasNotes: this.options.hasNotes,
            isVersioned: this.options.isVersioned,
            versions: file.fileHistory ? file.fileHistory : null
        });
        if (this.options.canUpload && !this.$('.dz-message').hasClass('dz-message-top')) {
            $fileEl.addClass('hidden');
            this.renderUploadMessage(_.bind(function () {
                $fileEl.removeClass('hidden');
            }, this));
        }

        let $outer;
        if (this.options.sideBySide && file.id > 0) {
            $outer = this.$('.files-existing-container');
        } else {
            $outer = this.$('.files-container');
        }
        if (isPrepend) {
            $outer.prepend($fileEl);
        } else {
            $outer.append($fileEl);
        }
        return $fileEl;
    },
    renderUploadMessage: function (callback = _.noop) {
        let $message = this.$('.dz-message'),
            topClass = 'dz-message-top',
            topCSS = {
                height: '40px'
            };

        let hasNewAttachment = this.collection.findWhere(function (attachment) {
            return attachment.isNew();
        }) != null;
        if (hasNewAttachment) {
            this.$('.file-upload').removeClass('dz-clickable');
            if (!$message.hasClass('dz-message-top')) {
                $message.addClass(topClass).animate(topCSS, 500, _.bind(function () {
                    $message.css(topCSS).html('Drop files or <a href="javascript:void(0)" class="file-upload-upload ml-1 text-orange">click here to upload</a>');
                    if (callback != null) {
                        callback();
                    }
                }, this)).addClass(topClass);
            } else {
                callback();
            }
        } else {
            $message.html('Drop files or click to upload');
            if (callback != null) {
                callback();
            }
        }
    },
    viewFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));
        PJQ.app.view.renderPhotoViewer({
            model: file,
            collection: this.collection
        });
    },
    downloadFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));
        file.download();
    },
    deleteFile: function (e) {
        let previewContainer = $(e.currentTarget).closest('.file-preview'),
            file = this.collection.get(previewContainer.data('cid'));
        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(file, _.bind(function () {
                previewContainer.remove();
                this.options.afterDelete();
            }, this));
        } else {
            file.destroy();
            previewContainer.remove();
            this.options.afterDelete();
        }
    }
});

PJQ.views.files.FileSelectInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Select-Input'),
        subTemplates: {
            changeButton: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Select-Input-Change-Button')
        },
        isShowChangeButton: false,
        emptyNotice: "No Files Selected"
    },
    events: {
        "click .file-select-input-edit": "edit"
    },
    beforeFirstRender() {
        if (this.options.isShowChangeButton) {
            this.options.template = this.options.subTemplates.changeButton;
        }

        let addButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm file-select-input-edit ml-1"><i class="fal fa-pencil"></i></button>');
        this.$el.closest('.form-group').find('label').append(addButton);
        addButton.on('click', _.bind(this.edit, this));

        this.selectedFiles = this.options.selectedFiles ? this.options.selectedFiles : [];
    },
    renderData: function () {
        return {
            selectedFiles: this.selectedFiles
        };
    },
    edit: function () {
        new PJQ.views.files.FileSelector(_.defaults(this.options.selectorOptions, {
            project: this.options.project,
            selectedAttachmentIds: _.map(this.selectedFiles, function (file) {
                return file.cid;
            }),
            collection: this.options.collection,
            onSave: _.bind(function (files) {
                this.selectedFiles = this.options.ignoreFolders ? _.filter(files, function (file) {
                    return !file.get('isFolder')
                }) : files;

                this.render();

                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(this.selectedFiles);
                }
            }, this)
        }));
    },
    validate: function () {
        if (_.size(this.selectedFiles) > 0) {
            return true;
        } else {
            this.$('.file-select-value').html('<div class="text-danger mt-1">This field is required.</div>');
            return false;
        }
    }
});

PJQ.views.files.FileVersionsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-file-versions'),
        width: '40%',
        maxWidth: 800,
    },
    events: {
        'click .btn-download-version': 'downloadVersion',
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.versions = _.union(this.model.versions ? this.model.versions.models : [], [this.model]);

        if (this.collectionDefinition == null) {
            this.collectionDefinition = PJQ.collections.files.Files;
        }

        this.newVersions = new this.collectionDefinition();

        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".file-versions"),
            data: this.versions,
            isHideSearch: true,
            rowId: "cid",
            paging: false,
            order: [0, 'desc'],
            language: {
                zeroRecords: 'No other versions'
            },
            columns: [
                {
                    "title": "Version",
                    "data": "attributes.version",
                    "render": function (data, type, row) {
                        return data ?? 1;
                    }
                },
                {
                    "title": "Name",
                    "data": "attributes.name"
                },
                {
                    "title": "Uploaded",
                    "data": "attributes.createdOn",
                    "render": function (data, type, row) {
                        if (row.get('createdOn') == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(row.get('createdOn'), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '80px',
                    "render": _.bind(function (data, type, row) {
                        return '<div class="show-on-row-hover"><button type="button" data-cid="' + row.cid + '" class="btn btn-primary btn-download-version"><i class="fal fa-download"></i></button></div>';
                    }, this)
                }
            ]
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.file-versions-uploader'),
            collection: this.newVersions,
            style: 'list',
            canUpload: this.newVersions.length === 0,
            canDelete: true,
            canDownload: true,
            isRemoveOnComplete: true,
            previewImageDimension: 150,
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    downloadVersion: function (e) {
        let file = _.findWhere(this.versions, {cid: $(e.currentTarget).data('cid')});
        file.download();
    },
    save: function () {
        _.each(this.newVersions.models, (newFile) => {
            newFile.set({
                parentAttachmentId: this.model.get('attachmentId'),
                version: this.versions.length + 1,
                createdOn: new Date()
            });
            this.model.versions.add(newFile);
        });

        this.options.onSave(this.newVersions.models);
        this.removeModal();
    }
});

PJQ.helpers.fileHelpers = {
    getExtension: function (filename) {
        return filename ? filename.split('.').pop().toLowerCase() : null;
    },
    getDisplayFileSize(bytes, si = true) {
        let thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        let units = si
                ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'],
            u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }
};

PJQ.modules.files = {
    routes: [
        {
            route: 'files/share/:accessKey',
            name: 'shareFiles',
            callback: function (accessKey) {
                let files = new PJQ.collections.files.FileShare(null, {
                    accessKey: accessKey
                });
                files.fetch({
                    success: function () {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'orders'
                                },
                                {
                                    endpoint: 'settings'
                                }
                            ], [
                                {
                                    parameter: 'entryId',
                                    value: files.models[0].get('entryId')
                                }
                            ])
                        }).get().done(_.bind(function (settings) {
                            let $container = $('<div>', {
                                class: 'p-3'
                            });
                            PJQ.app.$el.html($container);
                            _.each(files.models, function (attachment) {
                                if (attachment.get('isFolder'))
                                    attachment.isFetched = true;
                            });

                            PJQ.app.view.renderView(PJQ.views.projects.Attachments, {
                                el: $container,
                                collection: files,
                                isAdmin: false,
                                orderSettings: settings
                            });
                        }, this));

                    },
                    error: function (data, response) {
                        let $container = $('<div>', {
                            class: 'p-3'
                        });
                        PJQ.app.$el.html($container);
                        if (response.responseJSON.message == 'BUSY') {
                            $container.html(`
                                <div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
                                    <div>
                                        <div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
                                        <div class="fs-36">File Share Unavailable</div>
                                        <div class="fs-24">Files for this project are currently being processed.<br />Please try again later.</div>
                                    </div>
                                </div>
						    `);
                        } else if (response.responseJSON.message == 'OFFLINE') {
                            $container.html(`
                                <div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
                                    <div>
                                        <div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
                                        <div class="fs-36">File Share Unavailable</div>
                                        <div class="fs-24">This project is currently unavailable for download.<br />Please try again later, or check with the sender if the issue persists.</div>
                                    </div>
                                </div>
						    `);
                        } else {
                            $container.html(`
                                <div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
                                    <div>
                                        <div><i class="fal fa-clock fa-9x text-orange mb-2"></i></div>
                                        <div class="fs-36">File Share Invalid</div>
                                        <div class="fs-24">This file share has expired or is invalid.</div>
                                    </div>
                                </div>
						    `);
                        }
                    }
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.files.routes);
//Models
PJQ.models.groups = {};

PJQ.models.groups.Group = PJQ.models.BaseModel.extend({
	idAttribute: "groupId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'groups',
				value: this.id
			}
		])
	}
});

//Collections
PJQ.collections.groups = {};

PJQ.collections.groups.Groups = PJQ.collections.BaseCollection.extend({
	defaults: {
		groupLevels: 1
	},
	model: PJQ.models.groups.Group,
	endpoint: function () {
		let endpoint = [
			{
				endpoint: 'groups'
			}
		];
		if (this.options.userId > 0) {
			endpoint = [
				{
					endpoint: 'users',
					value: this.options.userId
				},
				{
					endpoint: 'groups'
				}
			];
		}
		else if (this.options.project != null) {
			endpoint = [
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'groups'
				}
			];
		}
		return PJQ.helpers.urlHelpers.generateEndpoint(endpoint);
	},
	afterInit: function () {
		this.on('sync', this.setSelectedGroups, this);
	},
	setSelectedGroups: function (selectedGroupIds) {
		if (_.size(this.models) > 0) {
			_.each(this.models, _.bind(function (model) {
				if (selectedGroupIds != null && Array.isArray(selectedGroupIds)) {
					if (selectedGroupIds.indexOf(model.id) !== -1) {
						model.set('isSelected', true);
					}
					else {
						model.set('isSelected', false);
					}
				}
				else {
					model.set('isSelected', false);
				}

			}, this));
		}
	},
	addSelectedGroups: function (selectedGroupIds) {
		_.each(typeof selectedGroupIds === "number" ? [selectedGroupIds] : selectedGroupIds, function (groupId) {
			let group = this.get(groupId);
			if (group != null) {
				group.set('isSelected', true);
			}
		}, this);
	},
	deleteSelectedGroups: function (selectedGroupIds) {
		_.each(typeof selectedGroupIds === "number" ? [selectedGroupIds] : selectedGroupIds, function (groupId) {
			let group = this.get(groupId);
			if (group != null) {
				group.set('isSelected', false);
			}
		}, this);
	},
	setDisabledGroups: function (disabledGroupIds) {
		if (_.size(this.models) > 0) {
			_.each(this.models, _.bind(function (model) {
				if (disabledGroupIds.indexOf(model.id) !== -1)
					model.set('isDisabled', true);
				else
					model.set('isDisabled', false);
			}, this));
		}
	},
	setPublicDisabledGroups: function (disabledPublicGroupIds = []) {
		if (_.size(this.models) > 0) {
			_.each(this.models, _.bind(function (model) {
				if (disabledPublicGroupIds.indexOf(model.id) !== -1) {
					model.set('isDisabled', true);
					model.set('isPublic', true);
				}
				else {
					model.set('isDisabled', false);
					model.set('isPublic', false);
				}
			}, this));
		}
	},
	getGroupIds: function () {
		let groupIds = [];
		_.each(this.models, function (model) {
			groupIds.push(model.id);
		});
		return groupIds;
	},
	getSelectedGroups: function () {
		let selectedGroups = new PJQ.collections.groups.Groups([], {
			groupLevels: this.options.groupLevels ? this.options.groupLevels : PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
		});
		_.each(this.models, function (model) {
			if (model.get('isSelected'))
				selectedGroups.add(model);
		});
		return selectedGroups;
	},
	getGroupsLeveled: function (filterGroups) {
		let result = null;
		if (this.options.groupLevels === 1) {
			result = (filterGroups == null ? this.models : _.filter(this.models, function (model) {
				return _.find(filterGroups, {id: model.id}) != null;
			}));
		}
		else if (this.options.groupLevels > 1) {
			result = [];
			_.each(this.models, function (model) {
				if (filterGroups === null || _.find(filterGroups, {id: model.id}) != null) {
					let parentName1 = model.get('groupDescription'),
						parentName2 = '';
					if (_.size(parentName1) === 0) {
						parentName1 = "No Parent";
					}
					if (this.options.groupLevels === 3) {
						parentName2 = parentName1.split('|')[1];
						parentName1 = parentName1.split('|')[0];

						if (_.size(parentName2) === 0) {
							parentName2 = "No Parent";
						}
					}

					let existingParent1 = _.find(result, function (group) {
						return group.name === parentName1;
					});
					if (existingParent1 != null) {
						if (this.options.groupLevels === 3) {
							let existingParent2 = _.find(existingParent1.parents, function (parent) {
								return parent.name === parentName2;
							});
							if (existingParent2 != null) {
								existingParent2.groups.push(model);
							}
							else {
								existingParent1.parents.push({
									name: parentName2,
									groups: [model]
								});
							}
						}
						else {
							existingParent1.groups.push(model);
						}
					}
					else {
						if (this.options.groupLevels === 3) {
							result.push({
								name: parentName1,
								parents: [
									{
										name: parentName2,
										groups: [model]
									}
								]
							});
						}
						else {
							result.push({
								name: parentName1,
								groups: [model]
							});
						}
					}
				}
			}, this);
		}
		return result;
	}
});

//Views
PJQ.views.groups = {};

PJQ.views.groups.GroupSelector = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Group-Selector-Container'),
		subTemplates: {
			selector: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Group-Selector')
		},
		groups: null,
		groupLabel: null,
		groupUserId: null,
		groupLevels: null,
		detectGroupLevels: false,
		includeGroupIds: null,
		selectedGroupIds: null,
		disabledGroupIds: null,
		selectedGroups: null,
		onGroupsLoaded: null,
		onGroupSelected: null,
		isAdmin: false,
		isPublicGroups: false,
		isEnableSelectedFilter: true,
		isEnableSelectAll: true,
		isDisableSelected: false,
		isHideDisabled: false,
		isExpandSelected: true,
		isDisableParents: false,
		isDisableCollapsedParents: false,
		isShowGroupCount: false,
		canEdit: true,
		isShowNoGroup: false,
		onSelect: _.noop,
		isSingleChoice: false,
		maxGroups: null,
		headerButtons: null
	},
	events: {
		"keyup .group-search": "renderGroups",
		"click .btn-header-action": "headerAction",
		"click .group-clear-filters": "clearFilters",
		"click .group-all-select": "selectAll",
		"click .group-parent-select": "selectParent",
		"click .group-select": "groupSelected",
		"click .group-expand": "expandParentClick",
		"click .report-contact-groups": "reportContactGroups",
		"click .no-group-select": "noGroupClicked"
	},
	beforeFirstRender: function () {
		if (this.options.maxGroups > 0) {
			this.options.isEnableSelectAll = true;
			this.options.isDisableParents = true;
		}
	},
	afterRender: function () {
		this.isNoGroupSelected = false;
		this.options.groupUserId = this.options.isPublicGroups ? PJQ.constants.publicUserId : this.options.groupUserId;
		if (this.options.groups == null) {
			this.getGroups();
		}
		else {
			this.afterSync();
		}
	},
	reload: function (userId) {
		if (typeof userId === 'number') {
			this.options.groupUserId = userId;
		}
		this.getGroups();
	},
	getGroups: function () {
		PJQ.app.session.fetchUserGroups(this.options.groupUserId, _.bind(function (groups) {
			this.options.groups = groups.toJSON();
			this.afterSync();
		}, this));
	},
	afterSync: function () {
		this.options.isGroupsLoaded = true;
		this.loadGroups();
	},
	loadGroups: function () {
		if (this.removed) {
			return;
		}

		let groups = this.options.groups != null ? this.options.groups : PJQ.app.session.groups[this.options.groupUserId > 0 ? this.options.groupUserId : -1].toJSON();
		if (this.options.groupUserId === PJQ.constants.publicUserId) {
			this.options.groupLevels = 2;
		}
		else if (this.options.detectGroupLevels) {
			for (let i = 0; i < _.size(groups); i++) {
				let group = groups[i];
				if (_.size(group.groupDescription) > 0) {
					if (group.groupDescription.indexOf('|') !== -1) {
						// this group has a pipe, it is group level 3
						this.options.groupLevels = 3;
						break;
					}
					else if (this.options.groupLevels < 2) {
						// this group has a description, it is at least group level 2
						// we need to keep checking other groups to make sure its not group level 3
						this.options.groupLevels = 2;
					}
				}
			}
			_.each(groups, _.bind(function (group) {

			}, this));
		}
		else if (this.options.groupLevels == null) {
			let groupLevels = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS);
			this.options.groupLevels = groupLevels ? groupLevels : 1;
		}

		if (this.options.groupLabel == null) {
			let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL);
			this.options.groupLabel = typeof groupLabel === 'string' ? groupLabel.toLowerCase() : 'trades';
		}

		this.collection = new PJQ.collections.groups.Groups(groups, {
			groupLevels: this.options.groupLevels,
			userId: this.options.groupUserId
		});

		if (_.size(this.options.selectedGroupIds) > 0) {
			//if init with selectedGroupIds, just set those groups as selected
			this.collection.setSelectedGroups(this.options.selectedGroupIds);
		}
		else {
			//Else if init with selectedGroups, loop through them and set selected by groupId
			//Also set disabled accordingly
			// This is used to disable groups related to public contacts when admins are editing
			this.disabledPublicGroups = [];
			let selectedGroupIds = [];
			if (_.size(this.options.selectedGroups) > 0) {
				_.each(this.options.selectedGroups.models, function (group) {
					selectedGroupIds.push(group.id);

					//Custom functionality for public groups on contacts - only when admin is editing
					//This piggybacks off of disabledGroupIds for disabling checkboxes
					if (this.options.isAdmin && group.get('isPublic') && PJQ.app.session.get('masterUserId') !== 23) {
						this.disabledPublicGroups.push(group.id);
					}
				}, this);
			}
			this.collection.setSelectedGroups(selectedGroupIds);
		}

		//If editing is disabled, disable all group checkboxes
		if (!this.options.canEdit) {
			this.collection.setDisabledGroups(_.map(this.collection.models, function (model) {
				return model.id;
			}));
		}
		else if (this.options.contactId > 0 && _.size(this.disabledPublicGroups) > 0) {
			this.createDisabledPublicGroupsAlert();
			this.collection.setPublicDisabledGroups(this.disabledPublicGroups);
		}

		//If there are disabledGroupIds passed in, mirror that to this.collection
		//These will render as disabled
		if (_.size(this.options.disabledGroupIds) > 0) {
			this.collection.setDisabledGroups(this.options.disabledGroupIds);
		}
		this.originalGroups = this.collection.getSelectedGroups().models;

		this.renderFilters();
		this.renderGroups();

		if (_.size(this.options.selectedGroupIds) > 0 && this.options.isShowNoGroup && this.options.selectedGroupIds.indexOf(0) !== -1)
			this.$('.no-group-select').prop('checked', true);

		if (typeof this.options.onGroupsLoaded === 'function') {
			this.options.onGroupsLoaded();
		}
	},
	renderFilters: function () {
		if (_.size(this.disabledPublicGroups) > 0) {
			this.$('.group-status-filter').append('<option value="public">Public</option>');
		}
		if (this.options.isEnableSelectedFilter) {
			this.filterPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.group-status-filter'),
				onChange: _.bind(this.renderGroups, this),
				noneSelectedText: 'No Filters',
				hideDisabled: false
			});
		}
	},
	renderGroups: function () {
		let searchFilter = this.$('.group-search').val().toLowerCase(),
			filterVal = this.options.isEnableSelectedFilter ? this.filterPicker.getValue().toLowerCase() : '',
			selectedFilter = null,
			publicFilter = null,
			groups = [];

		if (filterVal.toLowerCase() === 'public') {
			publicFilter = true;
		}
		else if (filterVal.toLowerCase() === 'selected') {
			selectedFilter = true;
		}
		else if (filterVal.toLowerCase() === 'unselected') {
			selectedFilter = false;
		}
		if (_.size(searchFilter) > 0 || selectedFilter != null || publicFilter != null || _.size(this.options.includeGroupIds) > 0) {
			this.$('.group-clear-filters').prop('disabled', false);
			_.each(this.collection.models, _.bind(function (model) {
				if (_.size(this.options.includeGroupIds) === 0 || this.options.includeGroupIds.indexOf(model.id) !== -1) {
					if ((publicFilter == null || model.get('isPublic') === publicFilter) && (selectedFilter === null || model.get('isSelected') === selectedFilter) && ((model.get('groupName').toLowerCase().indexOf(searchFilter) > -1) || (model.get('groupDescription').toLowerCase().indexOf(searchFilter) > -1)))
						groups.push(model);
				}
			}, this));
		}
		else {
			this.$('.group-clear-filters').prop('disabled', true);
			groups = this.collection.models;
		}

		let data = {
			models: this.collection.getGroupsLeveled(groups),
			options: this.options,
			isNoGroupSelected: this.isNoGroupSelected
		};
		this.renderSubTemplate(false, this.options.subTemplates.selector, this.$('.groups-container'), data, _.bind(function () {
			this.setSelectedParents();
			if (!this.isRendered && this.options.groupLevels > 1 && this.options.isExpandSelected) {
				this.expandSelectedParents();
			}
			this.setDisabledParents();
			if (this.options.isHideDisabled) {
				this.$('.group-select:disabled').closest('.group-select-container').hide();
			}
			this.isRendered = true;

			this.checkMaxGroups();
		}, this));
	},
	setDisabledParents: function () {
		let self = this;
		this.$('.group-parent-select').each(function () {
			//Disable the parent if:
			//isDisableCollapsedParents == true and there are no visible groups within the corresponding child container (shown group parents do not qualify)
			//or
			//there are no enabled groups shown within the corresponding child container
			let childContainer = self.getParentChildContainer($(this));
			$(this).prop('disabled', (self.options.isDisableCollapsedParents && (childContainer.hasClass('hidden') || _.size(childContainer.find('.group-child-container.hidden')) > 0)) || _.size(childContainer.find('.group-select,.group-parent-select').not(':disabled')) === 0);
		});
		if (this.options.isEnableSelectAll && !this.options.isDisableCollapsedParents && !this.options.isDisableParents) {
			this.$('.group-all-select').prop('disabled', !(this.$('.group-select:not(:disabled)').length > 0));
		}
	},
	setSelectedParents: function () {
		let self = this;
		this.$('.group-parent-select').each(function () {
			$(this).prop('checked', _.size(self.getParentChildContainer($(this)).find('.group-select').not(':checked')) === 0);
		});
		this.$('.group-all-select').prop('checked', !(this.$('.group-select:not(:checked)').length > 0));
	},
	createDisabledPublicGroupsAlert: function () {
		new PJQ.Alert(this.$el, {
			text: "<div>This contact has " + this.options.groupLabel.toLowerCase() + " that are linked to a public account.  They can only be removed by this contact.</div><div class='mt-1'>Think these are incorrect?  <a href='javascript:void(0)' class='report-contact-groups font-weight-normal'>Report their groups</a></div>",
			isPrepend: true
		});
	},
	getGroupSwitch: function (groupId) {
		return this.$('input[data-group-id="' + groupId.toString() + '"]');
	},
	expandSelectedParents: function () {
		if (this.options.groupLevels > 1) {
			_.each(this.collection.getSelectedGroups().models, function (group) {
				let childContainer = this.getGroupSwitch(group.id).closest('.group-child-container');
				if (childContainer.hasClass('hidden')) {
					this.expandParent(childContainer);
				}
				if (this.options.groupLevels === 3) {
					childContainer = childContainer.parent().closest('.group-child-container');
					if (childContainer.hasClass('hidden')) {
						this.expandParent(childContainer);
					}
				}
			}, this);
		}
	},
	getParentChildContainer: function (parent) {
		return parent.closest('.pretty').siblings('.group-child-container');
	},
	setIncludedGroups: function (includeGroupIds) {
		this.options.includeGroupIds = includeGroupIds;
		this.renderGroups();
	},
	headerAction: function (e) {
		let actionId = $(e.currentTarget).data('id'),
			headerButton = _.findWhere(this.options.headerButtons, {id: actionId});

		if (headerButton != null && typeof headerButton.callback === 'function') {
			headerButton.callback(this);
		}
	},
	clearFilters: function () {
		this.$('.group-search').val('');
		if (this.options.isEnableSelectedFilter) {
			this.filterPicker.deselectAll();
		}
		this.renderGroups();
	},
	selectAll: function (override) {
		if (typeof override === 'boolean')
			this.$('.group-all-select').prop('checked', override);

		let groupSelects = this.$('.group-select:not(:disabled)');
		if (this.$('.group-all-select').prop('checked')) {
			this.isNoGroupSelected = true;
			this.collection.addSelectedGroups(_.map(groupSelects, function (select) {
				return $(select).data('groupId');
			}));
			groupSelects.prop('checked', true);
		}
		else {
			this.isNoGroupSelected = false;
			this.collection.deleteSelectedGroups(_.map(groupSelects, function (select) {
				return $(select).data('groupId');
			}));
			groupSelects.prop('checked', false);
		}
		this.onGroupSelected();
	},
	noGroupClicked: function (e) {
		this.isNoGroupSelected = this.$('.no-group-select').prop('checked');
	},
	selectParent: function (e) {
		if (!this.options.isDisableParents) {
			//Select all child groups/parents that aren't disabled
			let childContainer = this.getParentChildContainer($(e.currentTarget)),
				isChecked = $(e.currentTarget).is(':checked');

			//If only un-collapsed parents can be selected, ensure we only select visible groups
			//This mainly only matters for groupLevels == 3, but it doesn't hurt to do for all levels
			let groupSelects = [];
			if (this.options.isDisableCollapsedParents) {
				groupSelects = childContainer.find('.group-select:visible').not(':disabled');
				childContainer.find('.group-select:visible,.group-parent-select:visible').not(':disabled').prop('checked', isChecked);
			}
			else {
				groupSelects = childContainer.find('.group-select').not(':disabled');
				childContainer.find('.group-select,.group-parent-select').not(':disabled').prop('checked', isChecked);
			}

			if (isChecked) {
				//If its checked, expand the parents/sub-parents to show the groups that were selected
				if (childContainer.hasClass('hidden')) {
					this.expandParent(childContainer);
				}
				//Check if there is another level underneath the first one to expand
				childContainer = childContainer.find('.group-child-container');
				if (_.size(childContainer) > 0) {
					if (childContainer.hasClass('hidden')) {
						this.expandParent(childContainer);
					}
				}
				this.collection.addSelectedGroups(_.map(groupSelects, function (select) {
					return $(select).data('groupId');
				}));
			}
			else {
				this.collection.deleteSelectedGroups(_.map(groupSelects, function (select) {
					return $(select).data('groupId');
				}));
			}
			this.onGroupSelected();
		}
	},
	selectGroups: function (groupIds) {
		if (this.options.canEdit && _.size(groupIds) > 0) {
			_.each(groupIds, function (groupId) {
				this.selectGroup(groupId, true, true, true);
			}, this);
			this.options.onSelect();
			this.onGroupSelected();
		}
	},
	groupSelected: function (e) {
		if (this.options.canEdit) {
			let select = $(e.currentTarget),
				groupId = select.data('groupId'),
				isSelected = select.is(':checked');
			this.selectGroup(groupId, isSelected, false);
		}
	},
	selectGroup: function (groupId, isSelected, setSwitch = false, silent = false) {
		if (this.options.canEdit && groupId > 0) {
			if (isSelected) {
				if (this.options.isSingleChoice) {
					this.collection.setSelectedGroups();
				}
				this.collection.addSelectedGroups(groupId);
			}
			else {
				this.collection.deleteSelectedGroups(groupId);
			}

			if (setSwitch) {
				this.getGroupSwitch(groupId).prop('checked', isSelected);
			}

			if (!silent) {
				this.options.onSelect();
				this.onGroupSelected();
			}
		}
	},
	onGroupSelected: function () {
		this.checkMaxGroups();
		this.setSelectedParents();
		if (typeof this.options.onGroupSelected === 'function') {
			this.options.onGroupSelected(this.getGroupsData());
		}
	},
	checkMaxGroups: function () {
		if (this.options.maxGroups == null) {
			return true;
		}

		let result = this.options.maxGroups <= this.getGroupsData().selected.length;
		if (result) {
			_.each((this.$('.group-select:not(:disabled)') && this.$('.group-select:not(:checked)')), function (group) {
				$(group).prop('disabled', true);
			})
		}
		else if(this.options.canEdit) {
			_.each(this.$('.group-select:disabled'), function (group) {
				$(group).prop('disabled', false);
			})
		}
		return result;
	},
	expandParentClick: function (e) {
		this.expandParent($(e.currentTarget).siblings('.group-child-container'));
	},
	expandParent: function (container) {
		let icon = container.siblings('i.group-expand');
		if (container.hasClass('hidden')) {
			container.removeClass('hidden');
			icon.removeClass('fa-chevron-down text-primary');
			icon.addClass('fa-chevron-up text-muted');
		}
		else {
			//If its being collapsed, find all sub-parents and collapse those as well
			container = container.add(container.find('.group-child-container'));
			icon = icon.add(container.find('i.group-expand'));
			container.addClass('hidden');
			icon.removeClass('fa-chevron-up text-muted');
			icon.addClass('fa-chevron-down text-primary');
		}
		this.setDisabledParents();
	},
	getGroupsData: function () {
		let selectedGroups = this.collection.getSelectedGroups().models;
		if (this.options.isSingleChoice) {
			return _.size(selectedGroups) > 0 ? selectedGroups[0] : null;
		}
		else {
			if (this.options.isShowNoGroup && this.$('.no-group-select').prop('checked')) {
				selectedGroups.push(new PJQ.models.groups.Group({
					groupId: 0
				}));
			}

			let newGroups = _.filter(selectedGroups, function (group) {
					return !_.findWhere(this.originalGroups, {id: group.id});
				}, this),
				allGroups = _.union([], this.originalGroups);

			_.each(selectedGroups, function (group) {
				if (!_.findWhere(allGroups, {id: group.id}))
					allGroups.push(group);
			});
			_.each(allGroups, _.bind(function (group) {
				if (_.findWhere(this.originalGroups, {id: group.id}) && !_.findWhere(selectedGroups, {id: group.id}))
					group.set('isDeleted', true);
				else
					group.set('isDeleted', false);
			}, this));
			if (this.options.isSync) {
				this.originalGroups = selectedGroups;
			}
			return {
				selected: selectedGroups,
				new: newGroups,
				original: this.originalGroups,
				all: allGroups
			};
		}
	},
	reportContactGroups: function () {
		new PJQ.views.groups.ReportContactGroupsModal({
			contactId: this.options.contactId,
			groups: this.collection
		});
	},
	showError: function (errorText) {
		this.hideError();
		this.errorAlert = new PJQ.Alert(this.$el, {
			type: 'danger',
			extraClasses: ['mt-1, mb-1'],
			text: errorText,
			isPrepend: true
		});
	},
	hideError: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
	},
	remove: function () {
		this.removed = true;
		return PJQ.views.BaseView.prototype.remove.call(this);
	}
});

PJQ.views.groups.ReportContactGroupsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Report-Contact-Groups'),
		onSave: _.noop
	},
	events: {
		"click .btn-report-contact-groups": "report"
	},
	afterRender: function () {
		let grps = _.where(this.options.groups.getSelectedGroups().toJSON(), {isPublic: true});
		_.each(grps, function (grp) {
			grp.isDisabled = false;
		});
		this.groupSelector = new PJQ.views.groups.GroupSelector({
			el: this.$('.group-selector'),
			groups: grps,
			isEnableSelectedFilter: false,
			onGroupSelected: _.bind(this.checkGroupsSelected, this)
		});
		this.checkGroupsSelected(this.groupSelector.getGroupsData());
	},
	checkGroupsSelected: function (groupsData) {
		this.$('.btn-report-contact-groups').prop('disabled', _.size(groupsData.selected) === 0)
	},
	report: function () {
		let reportedGroups = new PJQ.collections.groups.Groups(this.groupSelector.getGroupsData().selected).toJSON();
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.options.contactId
				},
				{
					endpoint: 'groups'
				},
				{
					endpoint: 'report'
				}
			]),
			data: {
				groups: reportedGroups,
				projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null
			}
		}).post().done(_.bind(function () {
			let reportedGroupCount = _.size(reportedGroups),
				modalCreated = PJQ.notifications.createNotifyModal({
					header: 'Groups Reported',
					notification: reportedGroupCount.toString() + " groups linked to this contact's public account were successfully reported.  Customer service will determine if they are valid.",
					cookie: PJQ.constants.cookies.NOTIFY_CONTACT_GROUPS_REPORTED
				});
			if (!modalCreated) {
				PJQ.notifications.notify.successNotify({
					message: reportedGroupCount.toString() + ' groups successfully reported.'
				});
			}
		}, this)).fail(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Failed to report groups.  Contact customer service.'
			});
		});
	}
});


PJQ.views.groups.SelectGroupsModal = PJQ.views.BaseModal.extend({
	defaults: {
		isSingleChoice: false,
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Groups-Select'),
		alertText: null,
		onSave: null
	},
	events: {
		"click .groups-select-save": "onSave"
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.options.selectorOptions = _.defaults(this.options.selectorOptions, {
			el: this.$('.group-selector'),
			isEnableSelectedFilter: false,
			onGroupSelected: _.bind(this.checkGroupsSelected, this),
		});
		this.groupSelector = new PJQ.views.groups.GroupSelector(this.options.selectorOptions);
	},
	checkGroupsSelected: function (groupsData) {
		this.$('.groups-select-save').prop('disabled', _.size(groupsData.new) === 0 && _.size(_.difference(_.map(groupsData.original, function (group) {
			return group.id;
		}), _.map(groupsData.selected, function (group) {
			return group.id
		}))) === 0);
		if (this.options.selectorOptions.isSingleChoice) {
			this.onSave()
		}
	},
	onSave: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.groupSelector.getGroupsData());
		}
		this.removeModal();
	},
});

PJQ.views.groups.GroupsSelectInput = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input'),
		subTemplates: {
			groupBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input-Groups')
		},
		selectedGroups: null,
		isShowAddButton: true,
		addButton: null,
		isReadOnly: false,
		onAfterSave: _.noop,
		limitGroups: false
	},
	events: {
		"click .group-select-input-edit": "modify",
		"click .group-select-input-delete": "deleteGroup",
		"click .btn-show-groups": "showAllGroups"
	},
	renderData: function () {
		return {
			isReadOnly: this.options.isReadOnly
		};
	},
	beforeRender() {
		if (!this.options.isShowAddButton) {
			this.options.template = new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input-No-Button');

			if (_.size(this.options.addButton) > 0) {
				this.options.addButton.on('click', _.bind(this.modify, this));
			}
		}

		this.selectedGroups = this.options.selectedGroups ? this.options.selectedGroups : [];
	},
	afterRender() {
		this.renderSelectedGroups();
	},
	deleteGroup: function () {
		let id = jQuery(event.target).closest('.select-group-container').data('group-id');

		this.selectedGroups = _(this.selectedGroups).filter(function (item) {
			return item.id !== id;
		});

		this.options.onAfterSave(this.selectedGroups);

		this.renderSelectedGroups();
	},
	modify: function () {
		this.selector = new PJQ.views.groups.SelectGroupsModal({
			selectorOptions: {
				groupUserId: this.options.groupUserId,
				selectedGroupIds: _.map(this.selectedGroups, function (model) {
					return model.attributes.groupId
				}),
				groupLevels: this.options.groupLevels,
				isSingleChoice: this.options.isSingleChoice ?? false
			},
			onSave: _.bind(function (data) {
				if(this.options.isSingleChoice){
					this.selectedGroups = [data]
					this.renderSelectedGroups();
					this.options.onAfterSave(data);
				} else {
					this.selectedGroups = _.union(this.selectedGroups, data.new);
					this.renderSelectedGroups();
					this.options.onAfterSave(this.selectedGroups);
				}
			}, this)
		});
	},
	renderSelectedGroups: function () {
		let data;
		if (this.options.limitGroups && _.size(this.selectedGroups) > 5) {
			data = _.rest(this.selectedGroups.reverse(), _.size(this.selectedGroups) - 5).reverse();
		}
		else {
			data = this.selectedGroups;
		}

		if (_.size(data) === 0) {
			this.$('.group-select-list').html('<div class="text-muted font-weight-light fs-16 mb-2 mt-2">No Trades Selected</div>');
		}
		else {
			this.renderSubTemplate(false, this.options.subTemplates.groupBadge, this.$('.group-select-list'),
				{
					models: data,
					isReadOnly: this.options.isReadOnly
				});
		}

		if (this.options.limitGroups && _.size(this.selectedGroups) > 5) {
			this.$('.group-select-list').append("<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> Show " + (_.size(this.selectedGroups) - 5) + " more item(s)</a>")
		}
	},
	showAllGroups: function () {
		let data = this.selectedGroups.reverse();

		if (_.size(data) === 0) {
			this.$('.group-select-list').html('<div class="text-muted font-weight-light fs-16 mb-2">No Trades Selected</div>');
		}
		else {
			this.renderSubTemplate(false, this.options.subTemplates.groupBadge, this.$('.group-select-list'),
				{
					models: data,
					isReadOnly: this.options.isReadOnly
				});
		}
	}
});

PJQ.views.history = {};

PJQ.views.history.HistoryTimelineModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-history-timeline'),
        width: 600,
        maxWidth: '90%',
        isShowCloseButton: true
    },
    events: {
        'click .btn-notification-link': 'copyNotificationLink',
        'click .btn-notification-resend': 'resendNotification'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.options.items != null) {
            this.items = this.options.items;
        } else {
            this.items = [];
        }

        if (this.collection != null && !this.collection.isFetched) {
            await this.collection.fetch();
            _.each(this.collection.models, (item) => {
                this.items.push({
                    action: item.getActionName(),
                    description: item.getDescription(),
                    date: item.get('createdOn'),
                    person: item.get('person')
                });
            });
        }

        this.isFetched = true;
        this.render();
    },
    afterRender: function () {
        new PJQ.views.history.HistoryTimeline({
            el: this.$('.history-outer'),
            items: this.items
        });
    },
    renderData: function () {
        return {
            options: this.options,
            isFetched: this.isFetched
        };
    }
});

PJQ.views.history.HistoryTimeline = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'history-timeline'),
        subTemplates: {},
    },
    renderData: function () {
        return {
            items: this.options.items
        };
    },
    afterRender: function () {

    }
});

PJQ.inputs = {};

PJQ.inputs.EditorInput = PJQ.views.BaseView.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input'),
        value: "",
        label: "",
        title: '',
        extraLabelClasses: "",
        extraValueDisplayClasses: "",
        extraEditButtonClasses: "",
        editButtonText: "edit",
        isFormInput: false,
        canEdit: true,
        showSaveButton: true,
        showCancelButton: true,
        onEditStart: _.noop,
        onCancel: _.noop,
        onSave: _.noop
    },
    events: {
        "click .ei-edit-button": "edit",
        "click .ei-cancel-button": "cancel",
        "click .ei-save-button": "save",
        "keyup .ei-input": "onChange",
        "dp.change .ei-input": "onChange"
    },
    inputType: "",
    beforeFirstRender: function () {
        //set value initially in case setValue has custom formatting
        this.setValue(this.getValue());
    },
    beforeRender: function () {
        this.beforeInputRender();
        this.renderData = {
            value: this.getDisplayValue(),
            isEdit: this.isEdit,
            inputType: this.inputType,
            options: this.options
        };
    },
    beforeInputRender: function () {

    },
    afterRender: function () {
        if (this.isEdit) {
            this.$('.ei-input').focus().select();
        }
        this.afterInputRender();
    },
    afterInputRender: function () {

    },
    getDisplayValue: function () {
        return typeof this.options.getDisplayValue === 'function' ? this.options.getDisplayValue(this.options.value) : this.options.value;
    },
    getValue: function () {
        return this.options.value;
    },
    setValue: function (value) {
        this.options.value = value;
    },
    onChange: function (e) {
        if (e && e.which === 13) {
            this.save();
            return;
        }

        this.setValue(this.$('.ei-input').val());
    },
    onEditStart: function () {
        if (typeof this.options.onEditStart === 'function') {
            this.options.onEditStart();
        }
    },
    edit: function () {
        this.onEditStart();
        this.isEdit = true;
        this.render();
    },
    cancel: function () {
        this.options.onCancel(this.getValue());
        this.isEdit = false;
        this.render();
    },
    save: function () {
        this.options.onSave(this.getValue());
        this.isEdit = false;
        this.render();
    }
});

PJQ.inputs.CurrencyEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Currency'),
        digits: 2
    },
    inputType: 'currency',
    afterRender: function () {
        if (this.isEdit) {
            let $input = this.$('.ei-input');
            PJQ.helpers.inputHelpers.inputMaskCurrency($input, this.options.digits);
            if (this.options.value == null) {
                this.options.value = 0;
            }
            $input.val(this.options.digits === 2 ? this.options.value / 100 : this.options.value);
            $input.focus().select();
        }
    },
    onChange: function (e) {
        let inputVal = $(e.currentTarget).val().replace(/ /g, '0'),
            val = parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputVal));
        if (!isNaN(val)) {
            if (this.options.digits === 0) {
                val = val * 100;
            }
        } else {
            val = 0;
        }
        this.setValue(val);
        return val;
    }
});

PJQ.inputs.TextEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Text')
    },
    inputType: 'text'
});

PJQ.inputs.SelectPickerEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Select-Picker'),
        subTemplates: {
            formTemplate: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Select-Picker-Form'),
        }
    },
    inputType: 'select',
    beforeInputRender: function () {
        if (this.options.isFormInput) {
            this.options.template = this.options.subTemplates.formTemplate;
        }
        this.options.selectPickerOptions = this.options.selectPickerOptions != null ? this.options.selectPickerOptions : {};
    },
    afterInputRender: function () {
        new PJQ.inputs.Selectpicker(_.extend(this.options.selectPickerOptions, {
            el: this.$('select.ei-input'),
            defaultValue: this.options.value,
            onChange: _.bind(function (value) {
                this.options.value = value;
                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(...arguments);
                }
            }, this)
        }));
    },
    onEditStart: function () {
        if (typeof this.options.getChoices === 'function') {
            let fnRender = (choices) => {
                if (PJQ.helpers.objectHelpers.refinedType(choices) === 'array') {
                    this.options.selectPickerOptions.choices = choices;
                    this.render();
                }
            }, choices = this.options.getChoices((ch) => {
                fnRender(ch);
            });
            fnRender(choices);
        }

        return PJQ.inputs.EditorInput.prototype.onEditStart.apply(this, arguments);
    },
    getDisplayValue: function () {
        if (this.options.value != null && _.size(this.options.selectPickerOptions.choices) > 0) {
            let displayVal = _.find(this.options.selectPickerOptions.choices, _.bind(function (choice) {
                return choice.id === this.options.value;
            }, this));
            if (displayVal != null) {
                return displayVal.name;
            }
        } else if (_.size(this.options.defaultDisplayValue) > 0) {
            return this.options.defaultDisplayValue;
        }
        return 'N/A';
    },
});

PJQ.inputs.TextAreaEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Textarea'),
        value: "",
        label: "",
        nullText: "",
        canEdit: true,
        extraLabelClasses: "",
        extraValueDisplayClasses: "",
        extraEditButtonClasses: "",
        onEditStart: _.noop,
        onCancel: _.noop,
        onSave: _.noop
    },
    inputType: 'textarea',
    onChange: function (e) {
        this.setValue($(e.currentTarget).val());
    }
});

PJQ.inputs.DateEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Date'),
        value: "",
        label: "",
        nullText: "",
        canEdit: true,
        extraLabelClasses: "",
        extraValueDisplayClasses: "",
        extraEditButtonClasses: "",
        onEditStart: _.noop,
        onCancel: _.noop,
        onSave: _.noop,
        dateOrientation: "left bottom",
        dateFormat: PJQ.helpers.dateHelpers.dateFormats.DATE_TIME
    },
    inputType: 'date',
    afterRender: function () {
        if (_.size(this.$('.ei-date').find('.ei-input')) > 0) {
            this.datepicker = this.$('.ei-date').find('.ei-input');
            new PJQ.inputs.Datepicker({
                el: this.datepicker,
                datepickerOptions: {
                    format: this.options.dateFormat === PJQ.helpers.dateHelpers.dateFormats.DATE ? PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE : PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.getValue()
                }
            })
        }
    },
    setValue: function (value) {
        if (PJQ.helpers.objectHelpers.refinedType(value) === 'string')
            this.options.value = new Date(value);
        else
            this.options.value = value;
    },
    onChange: function (e) {
        this.setValue(e.date._d);
    },
    getDisplayValue: function () {
        let value = this.getValue();
        return value == null ? this.options.nullText : PJQ.helpers.dateHelpers.getDateString(value, this.options.dateFormat);
    }
});

PJQ.inputs.AutocompleteInput = PJQ.views.BaseView.extend({
    defaults: {
        data: null,
        dataDisplayProperty: null,
        source: [],
        value: null,
        onSelect: _.noop
    },
    events: {
        'keyup': 'onKeyup'
    },
    afterRender: function () {
        if (!this.$el.hasClass('pt-autocomplete'))
            this.$el.addClass('pt-autocomplete');

        //If there is data passed in, that means we want to be able to return a data object related to the autocomplete item selected
        this.parseSource();

        this.autocomplete = this.$el.autocomplete(_.defaults(this.options, {
            select: _.bind(this.select, this),
            change: _.bind(this.change, this)
        }));

        let self = this;
        this.autocomplete.data('ui-autocomplete')._renderMenu = function (ul, items) {
            _.each(items, _.bind(function (item) {
                this._renderItemData(ul, item);
            }, this));
            $(ul).addClass('pt-autocomplete-menu');
        };
        this.autocomplete.data('ui-autocomplete')._resizeMenu = function () {
            this.menu.element.outerWidth(self.$el.outerWidth());
        };

        if (this.options.value != null) {
            this.setValue(this.getValue());
        }
    },
    parseSource: function () {
        if (PJQ.helpers.objectHelpers.refinedType(this.options.data) === 'array' && this.options.dataDisplayProperty != null) {
            this.options.source = [];
            _.each(this.options.data, _.bind(function (dataItem) {
                this.options.source.push(this.getDataItemValue(dataItem));
            }, this));
        }
    },
    reloadSource: function (obj) {
        if (obj != null) {
            if (obj.data && this.options.dataDisplayProperty) {
                this.options.data = obj.data;
                this.parseSource();
            } else if (PJQ.helpers.objectHelpers.refinedType(obj.source) === 'array') {
                this.options.source = obj.source;
            }
        }
        if (this.autocomplete) {
            this.$el.autocomplete('option', 'source', this.options.source);
        }
    },
    getValue: function () {
        return this.$el.val();
    },
    setValue: function (value) {
        this.$el.val(value);
    },
    refresh: function (e) {
        $(e.currentTarget).autocomplete('search');
    },
    onKeyup: function (e) {
        //Force a refresh after the first character is entered in case there is any page altering markup changes made
        //The autocomplete menu is absolutely positioned, so any dom changes will result in it shifting down/up
        if (_.size(this.$el.val()) === 1) {
            setTimeout(_.bind(function () {
                this.refresh(e);
            }, this), 300);
        }
    },
    change: function (e, ui) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange($(e.currentTarget).val());
        }
    },
    select: function (e, ui) {
        let $target = $(e.target);
        $target.val(ui.item.value);
        $target.trigger('keyup');
        if (typeof this.options.onSelect === 'function') {
            this.options.onSelect({
                value: ui.item.value,
                match: PJQ.helpers.objectHelpers.refinedType(this.options.data) === 'array' ? (_.find(this.options.data, _.bind(function (dataItem) {
                    return this.getDataItemValue(dataItem).toLowerCase() === ui.item.value.toLowerCase()
                }, this))) : null,
                e
            });
        }
    },
    getDataItemValue: function (dataItem) {
        let result = PJQ.helpers.objectHelpers.refinedType(dataItem, true) === 'backboneModel' ? dataItem.get(this.options.dataDisplayProperty) : dataItem[this.options.dataDisplayProperty];
        return result ? result : '';
    }
});

PJQ.inputs.Datepicker = PJQ.views.BaseView.extend({
    defaults: {
        datepickerOptions: {
            defaultDate: null,
            allowInputToggle: true,
            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
            icons: {
                time: 'fal fa-clock',
                date: 'fal fa-calendar-alt',
                up: 'fal fa-chevron-up',
                down: 'fal fa-chevron-down',
                previous: 'fal fa-chevron-left',
                next: 'fal fa-chevron-right',
                today: 'fal fa-crosshairs',
                clear: 'fal fa-trash',
                close: 'fal fa-times'
            },
            useCurrent: false,
            minDate: false
        },
        disabledDays: [],
        disableWeekends: false,
        isTimeOnly: false,
        onChange: _.noop,
        onShow: _.noop,
        isShowTimezone: true,
        isEditTimezone: false,
        canEdit: true,
        timezone: new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2]
    },
    events: {
        "dp.show": "onShow",
        "dp.change": "onChange"
    },
    beforeInit: function (options) {
        if (options.datepickerOptions != null) {
            this.options.datepickerOptions = _.defaults(options.datepickerOptions ? options.datepickerOptions : {}, this.defaults.datepickerOptions);

            this.setMinDate(this.options.datepickerOptions.minDate);
            if (this.options.datepickerOptions.defaultDate == null && _.size(this.$el.val()) > 0) {
                this.options.datepickerOptions.defaultDate = this.$el.val();
                this.$el.val('');
            }

            if (typeof this.options.datepickerOptions.defaultDate === 'string' && _.size(this.options.datepickerOptions.defaultDate) > 0) {
                if (!this.options.isDateTime) {
                    this.options.datepickerOptions.defaultDate.replace(/[^0-9\/]/g, '');
                }

                let parsedDate = parsedDate = PJQ.helpers.dateHelpers.parseDateString(this.options.datepickerOptions.defaultDate, this.options.datepickerOptions.format !== PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE);
                if (!isNaN(parsedDate.getTime())) {
                    this.value = parsedDate;
                } else {
                    this.options.datepickerOptions.defaultDate = null;
                    this.value = null;
                }
            } else if (PJQ.helpers.objectHelpers.refinedType(this.options.datepickerOptions.defaultDate) === 'date') {
                this.value = this.options.datepickerOptions.defaultDate;
            } else {
                this.value = null;
            }
            this.options.datepickerOptions.defaultDate = this.value;
        }

        if (this.$el.hasClass('disabled') || this.$el.prop('disabled')) {
            options.canEdit = false;
        }

        if (options.isTimeOnly) {
            options.datepickerOptions.format = 'LT';
        }

        if (_.size(this.options.timezone) === 0) {
            this.options.timezone = new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2]
        }
    },
    afterRender: function () {
        this.$el.prop('disabled', !this.options.canEdit);
        if (this.options.isEditTimezone && this.options.canEdit) {
            this.$el.after('<select class="select-tz wd-75p"></select>');

            let localOffset = new Date().getTimezoneOffset();
            this.timezonePicker = new PJQ.inputs.Selectpicker({
                el: this.$el.parent().find('.select-tz'),
                defaultValue: this.options.timezone,
                isLiveSearch: true,
                choices: this.getTimezoneSelectOptions(),
                isMultiple: false,
                isIntChoices: false,
                onChange: (value) => {
                    this.options.timezone = value;
                    if (typeof this.options.onTimezoneChange === 'function') {
                        this.options.onTimezoneChange(this.options.timezone);
                    }
                }
            });
        } else if ((this.options.isShowTimezone || this.options.isEditTimezone) && (this.isDateTime() || this.options.isTimeOnly)) {
            let timezoneInputAddon = $("<div>", {
                class: 'input-group-append'
            }).append($("<span>", {
                class: 'input-group-text'
            }).text(this.options.timezone));
            this.$el.after(timezoneInputAddon);
        }

        this.datetimepicker = this.$el.datetimepicker(this.getPickerOptions());

        this.$el.on('keyup', _.bind(this.onKeyup, this));
    },
    getPickerOptions: function () {
        return _.defaults({
            daysOfWeekDisabled: this.getDaysOfWeekDisabled()
        }, this.options.datepickerOptions);
    },
    setTimezone: function (tz) {
        if (_.size(tz) === 0 || this.timezonePicker == null) {
            return;
        }

        this.options.timezone = tz;
        this.timezonePicker.setValue(tz);
    },
    getTimezoneSelectOptions: function () {
        return _.map(_.sortBy(PJQ.helpers.dateHelpers.timezones, (timezone) => {
            return timezone.offset;
        }), (timezone) => {
            return {
                id: timezone.abbr,
                title: timezone.abbr,
                name: '(GMT' + PJQ.helpers.dateHelpers.getFormattedTimezoneOffset(timezone.offset) + ') ' + timezone.name
            }
        });
    },
    setDisabledDays: function (value) {
        this.options.disabledDays = value;

        let picker = this.getPicker();
        if (picker != null) {
            picker.options(this.getPickerOptions());
        }
    },
    getDaysOfWeekDisabled: function () {
        let disableDays = [];
        if (this.options.disableWeekends) {
            disableDays.push(...[0, 6]);
        }
        if (_.size(this.options.disabledDays) > 0) {
            disableDays = _.union(disableDays, this.options.disabledDays);
        }
        return _.size(disableDays) > 0 ? disableDays : false;
    },
    isDateTime: function () {
        return this.options.datepickerOptions.format.indexOf('h') !== -1 || this.options.datepickerOptions.format.indexOf('m') !== -1;
    },
    onKeyup: function () {
        let inputVal = this.$el.val(),
            selectedDate = null;
        if (PJQ.helpers.dateHelpers.validateDate(inputVal)) {
            selectedDate = PJQ.helpers.dateHelpers.parseDateString(inputVal);
        }
        this.dateChanged(selectedDate);
    },
    onChange: function (e) {
        if (e.date) {
            this.dateChanged(e.date._d);
        }
    },
    onShow: function () {
        if (typeof this.options.onShow === 'function')
            this.options.onShow(this);
    },
    hide: function () {
        let picker = this.getPicker();
        if (picker != null) {
            picker.hide();
        }
    },
    show: function () {
        let picker = this.getPicker();
        if (picker != null) {
            picker.show();
        }
    },
    dateChanged: function (selectedDate) {
        let isChanged = false,
            isDateTime = this.isDateTime(),
            isTimeOnly = this.options.isTimeOnly;
        if (this.value == null) {
            isChanged = true;
        } else if ((isDateTime || isTimeOnly) && PJQ.helpers.dateHelpers.getDateDiff(selectedDate, new Date(this.value)) !== 0) {
            isChanged = true;
        } else if (!isDateTime) {
            let parsedValue = PJQ.helpers.dateHelpers.getDateString(this.value, PJQ.helpers.dateHelpers.dateFormats.DATE);
            if (typeof parsedValue !== 'undefined' && parsedValue !== PJQ.helpers.dateHelpers.getDateString(selectedDate, PJQ.helpers.dateHelpers.dateFormats.DATE)) {
                isChanged = true;
            }
        }

        if (isChanged) {
            if (!isDateTime && !isTimeOnly && selectedDate != null) {
                selectedDate.setHours(0, 0, 0, 0);
            }
            this.value = selectedDate;

            if (typeof this.options.onChange === 'function') {
                this.options.onChange(typeof selectedDate === 'undefined' ? null : selectedDate);
            }
        }
    },
    disable: function () {
        this.$el.prop('disabled', true);
    },
    setValue: function (newValue) {
        this.value = newValue;
        if (newValue === null) {
            this.$el.val('');
        }

        let picker = this.getPicker();
        if (picker != null) {
            newValue ? picker.setValue(newValue) : picker.clear();
        }
    },
    setValueSilently: function (newValue) {
        // This will set the value without triggering the onChange. Useful for initially setting the value.
        this.value = newValue;
        if (newValue === null) {
            this.$el.val('');
        } else {
            this.datetimepicker.off('dp.change');

            let picker = this.getPicker();
            if (picker != null) {
                picker.setValue(newValue);
            }

            this.datetimepicker.on('dp.change', this.onChange.bind(this));
        }
    },
    getValue: function () {
        return this.value;
    },
    setMinDate: function (value) {
        let minDate = value;
        if (minDate) {
            if (typeof minDate === 'string') {
                minDate = new Date(minDate);
            }

            minDate = PJQ.helpers.dateHelpers.getDateString(minDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
        }

        this.options.datepickerOptions.minDate = (minDate ?? false);

        let picker = this.getPicker();
        if (picker != null) {
            picker.minDate(this.options.datepickerOptions.minDate);
        }
    },
    setPickerOption: function (option, value) {
        this.options.datepickerOptions[option] = value;
        let picker = this.getPicker();
        if (picker != null) {
            picker.options(this.options.datepickerOptions);
        }
    },
    getPicker: function () {
        return this.datetimepicker != null ? this.datetimepicker.data('DateTimePicker') : null;
    },
    showError: function (errorText) {
        PJQ.helpers.inputHelpers.setInputError(this.$el, false, {
            errorText: errorText
        });
    },
    hideError: function () {
        PJQ.helpers.inputHelpers.setInputError(this.$el, true);
    }
});

PJQ.inputs.SelectPickerCollection = class {
    constructor($el, models, options = {}) {
        this.options = _.defaults(options, {
            selectPickerOptions: {},
            pickerSelector: null,
            idAttribute: 'cid'
        });

        if (_.size(this.options.pickerSelector) === 0) {
            return;
        }

        this.$el = $el;
        this.models = models;

        this.pickers = {};
        this.initPickers();
    }

    initPickers() {
        this.cleanPickers();
        this.pickers = {};

        let self = this;
        this.$el.find(this.options.pickerSelector).each(function () {
            let model = null,
                id = $(this).closest('tr').attr('id');
            if (_.size(id) > 0) {
                model = _.find(self.models, function (model) {
                    return model[self.options.idAttribute]?.toString() === id;
                }, this);
            }

            if (model != null) {
                let defaultValue = self.options.selectPickerOptions.defaultValue && typeof self.options.selectPickerOptions.defaultValue === 'function' ? self.options.selectPickerOptions.defaultValue(model) : null;
                let opts = _.defaults({
                    el: $(this),
                    defaultValue: defaultValue || (() => {
                        if (_.size(self.options.valueAttribute) > 0) {
                            return PJQ.helpers.objectHelpers.refinedType(model, true) === 'backboneModel'
                                ? model.get(self.options.valueAttribute)
                                : model[self.options.valueAttribute];
                        }
                        return null;
                    }),
                    choices: function () {
                        let choices = self.options.selectPickerOptions.choices;
                        if (typeof choices === 'function') {
                            return choices(model);
                        }
                        return choices;
                    },
                    isDisabled: function () {
                        let disabled = self.options.selectPickerOptions.isDisabled;
                        if (typeof disabled === 'function') {
                            return disabled(model);
                        }
                        return disabled;
                    },
                    onChange: function (value) {
                        if (typeof self.options.onChange === 'function') {
                            self.options.onChange(model, value);
                        }
                    }
                }, self.options.selectPickerOptions);
                self.pickers[model.cid] = new PJQ.inputs.Selectpicker(opts);
            }
        })
    }

    getPickerForId(id) {
        return this.pickers[id];
    }

    cleanPickers() {
        _.each(this.pickers, function (picker) {
            picker.remove();
        });
        this.pickers = {};
    }

    remove() {
        this.cleanPickers();
    }
};

PJQ.inputs.DatePickerCollection = class {
    constructor($el, models, options = {}) {
        this.options = _.defaults(options, {
            datePickerOptions: {},
            pickerSelector: null,
            idAttribute: 'cid'
        });

        if (_.size(this.options.pickerSelector) === 0) {
            return;
        }

        this.$el = $el;
        this.models = models;

        this.pickers = {};
        this.initPickers();
    }

    initPickers() {
        this.cleanPickers();
        this.pickers = {};

        let self = this;
        this.$el.find(this.options.pickerSelector).each(function () {
            let model = null,
                id = $(this).closest('tr').attr('id');
            if (_.size(id) > 0) {
                model = _.find(self.models, function (model) {
                    return model[self.options.idAttribute]?.toString() === id;
                }, this);
            }

            if (model != null) {
                let defaultVal = PJQ.helpers.objectHelpers.refinedType(model, true) === 'backboneModel' ? model.get(self.options.valueAttribute) : model[self.options.valueAttribute],
                    defaultValDate = new Date(defaultVal);
                let opts = _.defaults({
                    el: $(this),
                    onChange: function (value) {
                        if (typeof self.options.onChange === 'function') {
                            self.options.onChange(model, value);
                        }
                    },
                    datepickerOptions: _.defaults({
                        defaultDate: defaultValDate instanceof Date && !isNaN(defaultValDate.getTime()) ? defaultValDate : null
                    }, self.options.datePickerOptions.datepickerOptions)
                }, self.options.datePickerOptions);
                self.pickers[model.cid] = new PJQ.inputs.Datepicker(opts);
            }
        })
    }

    getPickerForId(id) {
        return this.pickers[id];
    }

    cleanPickers() {
        _.each(this.pickers, function (picker) {
            picker.remove();
        });
        this.pickers = {};
    }

    remove() {
        this.cleanPickers();
    }
};

PJQ.inputs.Selectpicker = PJQ.views.BaseView.extend({
    defaults: {
        onChange: _.noop,
        onHide: _.noop,
        onShow: _.noop,
        style: 'btn-default',
        noneSelectedText: 'Select Value',
        selectAllText: 'All Selected',
        defaultValue: null,
        selectOnTab: true,
        isMultiple: false,
        isDisabled: false,
        isGrouped: false,
        allGroupsIsMultiple: false,
        hideDisabled: true,
        isIntChoices: false,
        isLiveSearch: false,
        isBlockSubtext: false,
        mobile: false,
        header: false,
        isMirrorOptionColors: false,
        exclusiveChoices: null,
        mustSelectValue: false,
        mustSelectValuePerOptGroup: false,
        countBeforeTextFormat: 0,
        canEdit: true
    },
    events: {
        "changed.bs.select": "onChange",
        "hidden.bs.select": "onHidden",
        "show.bs.select": "onShow"
    },
    beforeFirstRender: function () {
        if (this.options.isLiveSearch) {
            this.$el.attr('data-live-search', 'true');
        }
        // This will format the text shown in the select picker to be "x items selected" instead of the choices once the choices exceed the number passed to this option.
        if (this.options.countBeforeTextFormat > 0) {
            this.$el.attr('data-selected-text-format', 'count > ' + (this.options.countBeforeTextFormat));
        }
        if (this.options.isBlockSubtext) {
            this.$el.addClass('block-subtext');
        }

        if (this.$el.hasClass('disabled') || this.$el.prop('disabled')) {
            this.options.canEdit = false;
        }

        if (this.$el.length > 0) {
            this.$el.data('selectpickerview', this);
        }

        this.$el.prop('disabled', !this.options.canEdit);
    },
    beforeRender: function () {
        // set the multiple flag on the select element, this is required by the selectpicker library
        // we have to determine if any groups are marked as multiple
        // if isMultiple is passed in and none of the optgroups have the multiple data attribute, that means every optgroup is multiple
        // if even 1 optgroup has the multiple data attribute then we refer to those attributes to determine if each group is multiple
        let isMultipleGroupCount = _.size(this.$('optgroup').filter(function () {
                return $(this).data('multiple') !== undefined
            })),
            hasIsMultipleGroup = isMultipleGroupCount > 0;
        this.options.allGroupsIsMultiple = this.options.isGrouped && this.options.isMultiple && isMultipleGroupCount === 0;

        this.options.isMultiple = this.options.isMultiple || this.$el.hasClass('multiple') || this.$el.prop('multiple') || hasIsMultipleGroup || this.options.allGroupsIsMultiple;
        this.$el.prop('multiple', this.options.isMultiple);


        this.options.isDisabled = this.options.isDisabled || this.$el.hasClass('disabled') || this.$el.prop('disabled');
        this.$el.prop('disabled', this.options.isDisabled);

        if (this.options.choices) {
            this.updateChoices(this.options.choices);
        }

        // if no default value was passed in, try to determine which items are selected by going through the select element
        if (this.options.defaultValue == null) {
            let self = this;
            this.$el.find('option').each(function () {
                if ($(this).attr("selected") && $(this).attr("selected").toLowerCase() === 'selected') {
                    // only set the default value as non null once we have a matched item
                    if (self.options.defaultValue == null) {
                        self.options.defaultValue = self.options.isMultiple ? [] : "";
                    }

                    let val = $(this).attr('value');
                    if (self.options.isMultiple) {
                        self.options.defaultValue.push(val);
                    } else {
                        self.options.defaultValue = val;
                        return false;
                    }
                }
            });
        }

        this.$el.selectpicker(_.defaults({
            choices: typeof this.options.choices === 'function' ? this.options.choices() : this.options.choices
        }, this.options));

        const self = this;

        this.$outer = this.$el.closest('.bootstrap-select');
        if ((!this.options.isDisabled || (typeof this.options.isDisabled === 'function' && !this.options.isDisabled()))) {
            this.$outer.find('.dropdown-toggle').removeClass('btn-light');
        }
        //If there are any headers that are empty, hide them
        this.$outer.find('.dropdown-header').each(function () {
            let $header = $(this);
            if (_.size($header.find('.text').html()) === 0) {
                $header.addClass('hidden');
            }
        });

        this.isClicking = false;
        let $clickItems = this.$outer.add(this.$outer.find('button.dropdown-toggle'));
        $clickItems.off('mousedown.isClicking click.isClicking').on('mousedown.isClicking click.isClicking', (e) => {
            this.isClicking = true;
        });

        this.$outer.find('button.dropdown-toggle').off('focus').on('focus', (e) => {
            if (!this.isClicking && this.isCollapsed()) {
                this.toggle();
            }

            this.isClicking = false;
        });

        this.setValue(typeof this.options.defaultValue === 'function' ? this.options.defaultValue() : this.options.defaultValue, false);

        // This works for multiple choice, but the checkmarks do not.
        if (this.options.appendContainer) {
            let self = this;

            this.$el.selectpicker().on('shown.bs.select', function (e) {
                let $select = $(e.target);
                let $dropdown = $select.data('selectpicker').$menu;
                let $wrapper = $select.closest('.bootstrap-select');
                let $button = $wrapper.find('.dropdown-toggle');

                if ($button.length === 0) {
                    return;
                }

                if ($dropdown.length) {
                    let $innerMenu = $dropdown.find('.dropdown-menu.inner');

                    if ($innerMenu.length === 0) {
                        return;
                    }

                    self.options.appendContainer.append($dropdown.detach());

                    let rect = $button[0].getBoundingClientRect();

                    if (!rect) {
                        return;
                    }

                    $dropdown.append($innerMenu.detach());

                    $dropdown.css({
                        position: 'absolute',
                        top: rect.bottom + 'px',
                        left: rect.left + 'px',
                        minWidth: rect.width + 'px',
                        zIndex: 1050,
                        display: 'block',
                        visibility: 'visible',
                        opacity: 1,
                        transform: 'none'
                    });

                    $innerMenu.css({
                        position: 'relative',
                        top: '0px',
                        left: '0px',
                        width: '100%',
                        display: 'block',
                        visibility: 'visible',
                        opacity: 1
                    });

                    $dropdown.find('.check-mark').remove();

                    $select.data('selectpicker').$menu = $dropdown;
                    $select.selectpicker('render');
                }
            });

            this.$el.selectpicker().on('hide.bs.select', function (e) {
                let $dropdown = $(e.target).data('selectpicker').$menu;
                let $wrapper = $(e.target).closest('.bootstrap-select');

                if ($dropdown.length) {
                    $wrapper.append($dropdown.detach());
                    $dropdown.hide();
                }
            });

            this.$el.selectpicker().on('changed.bs.select', function (e) {
                if (!self.options.isMultiple) {
                    let $dropdown = $(e.target).data('selectpicker').$menu;
                    let $wrapper = $(e.target).closest('.bootstrap-select');

                    if ($dropdown.length) {
                        $wrapper.append($dropdown.detach());
                        $dropdown.hide();
                    }
                }
            });
        }


        this.afterRender();
        return false;
    },
    checkGroupIsMultiple: function (group) {
        if (this.options.allGroupsIsMultiple) {
            return true;
        }

        if (_.size(group) > 0) {
            let optGroup = this.$('optgroup[data-attr="' + group + '"]');
            if (_.size(optGroup) > 0) {
                return optGroup.data('multiple') === true;
            }
        }
        return false;
    },
    getValue: function () {
        let value = null,
            self = this;
        //If the options call for grouped results, we have to manually get them rather than using built in selectpicker function
        //This is because if there are 2 options in different groups with the same value, we need to check them separately
        if (this.options.isGrouped) {
            value = {};
            this.$('option:selected').each(function () {
                let selectedOptionVal = $(this).val();
                if (selectedOptionVal !== undefined) {
                    if (self.options.isIntChoices) {
                        selectedOptionVal = parseInt(selectedOptionVal);
                        if (isNaN(selectedOptionVal))
                            return;
                    }

                    let selectedGroupAttr = self.getOptionGroupAttribute($(this)),
                        groupIsMultiple = self.checkGroupIsMultiple(selectedGroupAttr);
                    if (value[selectedGroupAttr] == null) {
                        value[selectedGroupAttr] = groupIsMultiple ? [selectedOptionVal] : selectedOptionVal;
                    } else if (groupIsMultiple) {
                        value[selectedGroupAttr].push(selectedOptionVal);
                    }
                }
            });
        } else {
            value = this.$el.selectpicker('val');
            if (this.options.isIntChoices) {
                let valueType = PJQ.helpers.objectHelpers.refinedType(value);
                if (valueType === 'array') {
                    let newValue = [];
                    _.each(value, function (valueItem) {
                        let intValueItem = parseInt(valueItem);
                        if (!isNaN(intValueItem))
                            newValue.push(intValueItem);
                        else
                            newValue.push(valueItem);
                    });
                    value = newValue;
                } else if (valueType === 'string') {
                    let intValue = parseInt(value);
                    if (!isNaN(intValue))
                        value = intValue;
                    else
                        value = null;
                }
            }
        }

        if (value != null && typeof value == 'object' && value.length === 0) {
            return null;
        }

        return value == null && this.options.isMultiple ? [] : value;
    },
    getOptionGroupAttribute: function (option) {
        let groupAttr = option.closest('optgroup').data('attr');
        return _.size(groupAttr) <= 0 ? 'noGroup' : groupAttr;
    },
    setValue: function (value, isKeepExisting, isAllowSelectDisabled) {
        this.lastValue = value;
        if (this.options.isGrouped) {
            if (typeof value === 'object') {
                let valArr = [];
                _.each(value, function (group) {
                    if (typeof group == 'string') {
                        valArr.push(group);
                    } else if (typeof group == 'object') {
                        _.each(group, function (groupValue) {
                            valArr.push(groupValue);
                        });
                    }
                });
                this.$el.selectpicker('val', valArr);
            }
        } else {
            if (this.options.isMultiple) {
                let valArr = [],
                    valueType = PJQ.helpers.objectHelpers.refinedType(value);
                if (valueType === 'string') {
                    valArr.push(value);
                } else if (valueType === 'array') {
                    valArr = value;
                }

                if (isKeepExisting) {
                    valArr = _.union(valArr, this.getValue());
                }

                this.$el.selectpicker('val', valArr);
            } else {
                if (!this.$el.find('option[value="' + (value == null ? '' : value.toString()) + '"]').prop('disabled') || isAllowSelectDisabled) {
                    this.$el.selectpicker('val', value == null ? null : value.toString());
                } else {
                    this.$el.selectpicker('val', null);
                }
            }
        }
        this.$el.selectpicker('render');

        if (this.options.isMirrorOptionColors && !this.options.isMultiple) {
            this.setInputColors();
        }
    },
    selectAll: function () {
        if (this.options.isMultiple)
            this.$el.selectpicker('selectAll');
    },
    deselectAll: function () {
        if (this.options.isMultiple)
            this.$el.selectpicker('deselectAll');
        else
            this.setValue('', false);
    },
    toggle: function () {
        this.$el.selectpicker('toggle');
    },
    isCollapsed: function () {
        return !this.$outer.hasClass('show');
    },
    hide: function () {
        this.$el.selectpicker('hide');
    },
    show: function () {
        this.$el.selectpicker('show');
    },
    enable: function () {
        this.options.isDisabled = false;
        this.$el.prop('disabled', false).removeClass('disabled');
        this.$el.closest('.bootstrap-select').find('.dropdown-toggle').removeClass('btn-light');
        this.refresh();
    },
    disable: function () {
        this.options.isDisabled = true;
        this.$el.prop('disabled', true);
        this.refresh();
    },
    updateChoices: function (choices) {
        this.options.choices = choices;
        this.$el.empty();

        if (this.options.unsetChoice) {
            this.options.choices.unshift({
                id: null,
                unset: true,
                name: this.options.unsetChoice.name ?? 'None',
            });
        }

        let allIntChoices = true,
            fnMakeOption = (choice) => {
                let style = choice.style ?? '';
                if (this.options.pickerWidth != null) {
                    style += ';overflow:hidden;width: ' + this.options.pickerWidth;
                }

                if (typeof choice === 'string') {
                    allIntChoices = false;
                    return $('<option>', {
                        value: choice,
                        text: choice,
                        style: style
                    });
                } else if (typeof choice === 'object') {
                    allIntChoices = allIntChoices && typeof choice.id === 'number';

                    let opts = {
                        value: choice.id,
                        'data-content': choice.name,
                        style: style,
                        "data-subtext": choice.subtext,
                        disabled: choice.disabled === true
                    }
                    if (_.size(choice.title) > 0) {
                        opts.title = choice.title;
                    }
                    if (choice.unset) {
                        opts.class = 'unset';
                        opts["data-unset"] = true;
                    }
                    return $('<option>', opts).html(choice.name);
                }
                return '';
            }

        _.each(typeof choices === 'function' ? choices() : choices, function (choice) {
            if (choice == null) {
                this.$el.append($('<option>', {
                    text: this.options.noneSelectedText,
                    disabled: true
                }));
            } else if (choice.choices != null) {
                // this is an optgroup
                let optGroup = $('<optgroup data-attr="' + (choice.id ?? '') + '" label="' + choice.name + '"></optgroup>');
                _.each(choice.choices, function (optChoice) {
                    optGroup.append(fnMakeOption(optChoice));
                }, this);
                this.$el.append(optGroup);
            } else {
                this.$el.append(fnMakeOption(choice));
            }
        }, this);
        this.refresh();

        if (!this.options.isIntChoices && allIntChoices) {
            this.options.isIntChoices = true;
        }
    },
    updateNoneSelectedText: function (newText) {
        this.options.noneSelectedText = newText;
        this.$el.closest('.bootstrap-select').find('.filter-option').html(this.options.noneSelectedText);
    },
    refresh: function () {
        this.$el.selectpicker('refresh');
        this.setValue(this.lastValue);
    },
    onChange: function (event, clickedIndex) {
        if (_.size(this.$el) > 1 && !this.options.isMultiple) {
            let changeEl = $(event.currentTarget);
            this.$el.selectpicker('val', changeEl.selectpicker('val'));
            this.$el.selectpicker('render');
        }

        this.lastValue = this.getValue();

        let optGroup = $(this.$el.find('option')[clickedIndex]).closest('optgroup'),
            choice = $(this.$el.find('option')[clickedIndex]).attr('value'),
            unset = $(this.$el.find('option')[clickedIndex]).data('unset') === true;

        if (unset && !this.options.isMultiple) {
            this.lastValue = null;
            this.setValue(this.lastValue);
        } else if (this.options.isIntChoices) {
            choice = parseInt(choice);
            if (isNaN(choice)) {
                choice = null;
            }
        }

        if (this.options.isMultiple) {
            if (_.size(this.options.exclusiveChoices) > 0) {
                let exclusiveChoices = [];
                if (PJQ.helpers.objectHelpers.refinedType(this.options.exclusiveChoices) === 'array')
                    exclusiveChoices = this.options.exclusiveChoices;
                else
                    exclusiveChoices.push(this.options.exclusiveChoices);

                if (this.options.isGrouped) {
                    if (_.indexOf(exclusiveChoices, choice) !== -1) {
                        _.each(optGroup.find('option'), _.bind(function (option) {
                            let optionValue = parseInt($(option).attr('value'));
                            if (optionValue !== choice) {
                                this.lastValue[optGroup.data('attr')] = _.filter(this.lastValue[optGroup.data('attr')], function (item) {
                                    return item !== optionValue;
                                });
                            }
                        }, this));
                    }
                } else {
                    this.lastValue = (_.indexOf(exclusiveChoices, choice) !== -1) ? [choice] : _.filter(this.lastValue, function (item) {
                        return _.indexOf(exclusiveChoices, item) === -1;
                    });
                }

                this.setValue(this.lastValue);
            }

            // if a value must be selected, one cannot unselect the last selected value.
            if (this.options.mustSelectValue) {
                if (_.size(this.lastValue) === 0) {
                    this.lastValue = [choice];
                    this.setValue(this.lastValue);
                }
            }

            if (this.options.mustSelectValuePerOptGroup && optGroup.data('options') !== 'nullable') {
                let optGroupValueSelected = false;
                if (this.options.isGrouped) {
                    if (_.size(this.lastValue[optGroup.data('attr')]) === 0) {
                        this.lastValue[optGroup.data('attr')] = [choice];
                        this.setValue(this.lastValue);
                    }
                } else {
                    _.each(optGroup.find('option'), _.bind(function (option) {
                        if (this.lastValue.indexOf(parseInt($(option).attr('value'))) !== -1)
                            optGroupValueSelected = true;
                    }, this));

                    if (!optGroupValueSelected) {
                        this.lastValue.push(choice);
                        this.setValue(this.lastValue);
                    }
                }
            }
        }

        if (this.options.isMirrorOptionColors && !this.options.isMultiple) {
            this.setInputColors();
        }

        if (this.options.isGrouped && !this.options.allGroupsIsMultiple) {
            let group = optGroup.data('attr');
            if (_.size(group) > 0) {
                let isGroupMultiple = this.checkGroupIsMultiple(group);
                if (!isGroupMultiple) {
                    this.lastValue[group] = choice;
                    this.setValue(this.lastValue);
                }
            }
        }

        this.options.onChange(this.lastValue);
    },
    onHidden: function () {
        this.options.onHide();
    },
    onShow: function () {
        this.options.onShow();
    },
    setInputColors: function () {
        let selectedOption = this.$('option:selected').first(),
            color = 'inherit';
        if (_.size(selectedOption) > 0) {
            color = selectedOption.css('color');
        }
        this.$('.filter-option').css('color', color);
    },
    showError: function (errorText) {
        PJQ.helpers.inputHelpers.setInputError(this.$el, false, {
            errorText: errorText
        });
    },
    hideError: function () {
        PJQ.helpers.inputHelpers.setInputError(this.$el, true);
    }
});

PJQ.inputs.StatePicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.hideDisabled = false;
    },
    afterRender: function () {
        this.renderStates(this.options.country);
    },
    setValue: function (value, isKeepExisting, isAllowSelectDisabled) {
        PJQ.inputs.Selectpicker.prototype.setValue.call(this, value, isKeepExisting, isAllowSelectDisabled);
    },
    renderStates: function (country) {
        this.$el.find('option').remove();

        let choices = [];
        if (country) {
            if (country.toLowerCase() === 'ca') {
                choices = _.map(PJQ.constants.states.ca, (st) => {
                    return {
                        id: st.abbreviation.toUpperCase(),
                        name: st.name,
                    }
                });
            } else if (country.toLowerCase() === 'us') {
                choices = _.map(PJQ.constants.states.us, (st) => {
                    return {
                        id: st.abbreviation.toUpperCase(),
                        name: st.name,
                    }
                });
            } else {
                let countryDef = _.find(PJQ.constants.internationalCountries, function (c) {
                    return c.name === country;
                });
                if (countryDef) {
                    choices = _.map(countryDef.states, (st) => {
                        return {
                            id: st,
                            name: st,
                            title: st
                        };
                    });
                }
            }
        }

        this.updateChoices(choices);
    }
});

PJQ.inputs.GroupPicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.noneSelectedText = 'Select Group';
        this.options.isIntChoices = true;
        this.options.isLiveSearch = true;
        this.options.size = 20;
        this.options.unsetChoice = true;
        return PJQ.inputs.Selectpicker.prototype.beforeFirstRender.call(this);
    },
    afterRender: function () {
        if (this.options.project != null) {
            this.options.project.fetchGroups((groups) => {
                let gGroups = _.groupBy(groups.models, (group) => {
                    return group.get('groupDescription');
                });
                this.options.choices = _.map(gGroups, (gGroup, groupDescription) => {
                    return {
                        name: groupDescription,
                        choices: _.map(gGroup, (group) => {
                            return {
                                id: group.id,
                                name: group.get('groupName')
                            }
                        })
                    }
                });
                this.updateChoices(this.options.choices);
            }, true)
            return false;
        } else {
            PJQ.app.session.fetchUserGroups(null, (groups) => {
                let gGroups = _.groupBy(groups.models, (group) => {
                    return group.get('groupDescription');
                });
                this.options.choices = _.map(gGroups, (gGroup, groupDescription) => {
                    return {
                        name: groupDescription,
                        choices: _.map(gGroup, (group) => {
                            return {
                                id: group.id,
                                name: group.get('groupName')
                            }
                        })
                    }
                });
                this.updateChoices(this.options.choices);
            });
        }
    }
});

PJQ.inputs.ProjectLocationPicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.noneSelectedText = 'Select Location';
        this.options.isIntChoices = true;
        this.options.isLiveSearch = true;
        this.options.hideDisabled = false;
        this.options.unsetChoice = true;
        return PJQ.inputs.Selectpicker.prototype.beforeFirstRender.call(this);
    },
    afterRender: function () {
        if (this.options.project != null) {
            this.options.project.fetchLocations((locations) => {
                this.options.choices = locations.getPickerArray();
                this.updateChoices(this.options.choices);
            })
            return false;
        }
    }
});

PJQ.inputs.CountryPicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.hideDisabled = false;
    },
    afterRender: function () {
        let firstOptGroup = {
                name: '',
                choices: []
            },
            secondOptGroup = {
                name: '',
                choices: []
            };
        if (this.options.enableInternational) {
            firstOptGroup.choices.push({
                id: "US",
                name: "United States",
                title: "US"
            });

            firstOptGroup.choices.push({
                id: "CA",
                name: "Canada",
                title: "CA"
            });

            _.each(PJQ.constants.internationalCountries, function (country) {
                secondOptGroup.choices.push({
                    id: country.name,
                    name: country.name,
                    title: country.name
                });
            }, this);
        } else {
            _.each(PJQ.constants.countries, function (country) {
                firstOptGroup.choices.push({
                    id: country.toUpperCase(),
                    name: country.toUpperCase(),
                    title: country.toUpperCase(),
                });
            }, this);
        }

        this.updateChoices(_.size(secondOptGroup) > 0 ? [firstOptGroup, secondOptGroup] : firstOptGroup.choices);

        this.refresh();

        if (this.options.statePicker || this.options.zipInput) {
            this.attachStateZipInputs(this.options.statePicker, this.options.zipInput);
        }
    },
    setValue: function (value, isKeepExisting, isAllowSelectDisabled) {
        PJQ.inputs.Selectpicker.prototype.setValue.call(this, value, isKeepExisting, isAllowSelectDisabled);
        if (this.options.statePicker) {
            this.options.statePicker.renderStates(value);
        }
    },
    attachStateZipInputs: function (statePicker, zipInput) {
        let optionOnChange = this.options.onChange;
        this.options.onChange = function (country) {
            if (statePicker instanceof PJQ.inputs.StatePicker) {
                statePicker.renderStates(country);
            }
            if (zipInput.is('input')) {
                zipInput.val('');
                PJQ.helpers.inputHelpers.inputMaskZip(zipInput, country);
            }
            if (typeof optionOnChange === 'function')
                optionOnChange(country);
        };

        if (zipInput.is('input')) {
            PJQ.helpers.inputHelpers.inputMaskZip(zipInput, this.getValue());
        }
    }
});

PJQ.inputs.HTMLEditor = PJQ.views.BaseView.extend({
    defaults: {
        onChange: _.noop,
        defaultValue: null,
        isDisabled: false,
        isHideTokens: false,
        onInit: _.noop,
        editorHeight: 200
    },
    events: {},
    beforeRender: function () {
    },
    afterRender: function () {
        let tokenButton = _.bind(function (context) {
            let ui = $.summernote.ui;

            // create button
            let button = ui.button({
                contents: 'Tokens',
                tooltip: 'View the available Message Tokens',
                click: _.bind(function () {
                    context.invoke('editor.saveRange');
                    new PJQ.inputs.HTMLEditor.HTMLEditorTokensModal({
                        editor: this.$el.summernote,
                        context: context
                    });
                }, this)
            });

            return button.render();   // return button as jquery object
        }, this);

        let summerNoteOptions = {
            tabsize: 2,
            height: this.options.editorHeight,
            shortcuts: false,
            callbacks: {
                onChange: _.bind(function (contents, $editable) {
                    if (typeof this.options.onChange === 'function') {
                        //this checks if the actual content of the text is blank without spaces
                        try {
                            let $c = $(contents);
                            if (_.size($c) > 0 && _.size($c.text().replace(/\s/gm, "")) === 0) {
                                contents = "";
                            }
                        } catch (err) {
                        }
                        this.options.onChange(contents);
                    }
                }, this)
            },
            toolbar: [
                ['style', ['style']],
                ['font-style', ['bold', 'italic', 'underline', 'clear']],
                ['font', ['fontname']],
                ['font-size', ['fontsize']],
                ['font-color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['hr']],
                ['misc', ['codeview']],
                ['custom', ['token']]
            ],
            oninit: this.options.onInit
        };

        if (!this.options.isHideTokens) {
            summerNoteOptions.buttons = {
                token: tokenButton
            };
        }

        this.$el.summernote(summerNoteOptions);

        if (this.options.defaultValue)
            this.setValue(this.options.defaultValue);
    },
    getValue: function () {
        return this.$el.summernote('code');
    },
    setValue: function (value) {
        this.$el.summernote('code', value);
    },
    pasteValue: function (value) {
        this.$el.summernote('pasteHTML', value);
    },
    enable: function () {
        this.$el.summernote('enable');
    },
    disable: function () {
        this.$el.summernote('disable');
    }
});

PJQ.inputs.HTMLEditor.HTMLEditorTokensModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Tokens'),
        minWidth: '60%',
        context: null
    },
    events: {
        'click .tokens-close': 'onClose',
        'click table.tokens tr td label': 'insertToken'
    },
    insertToken: function (e) {
        //this.options.editor.pasteValue( $(e.currentTarget).text());
        this.removeModal();
        this.options.context.invoke('editor.restoreRange');
        this.options.context.invoke('editor.focus');
        this.options.context.invoke('editor.insertText', $(e.currentTarget).text());
    },
    onClose: function () {
        this.removeModal();
    }
});

PJQ.inputs.ButtonGroup = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Input-Button-Group'),
        colorInactiveButtons: false,
        buttons: [],
        defaultValue: null,
        onChange: _.noop,
        buttonClasses: null,
        fitHeight: false,
        fitWidth: false,
        separateButtons: false,
        canEdit: true
    },
    events: {
        'click .input-btn-group button': 'onChange'
    },
    beforeFirstRender: function () {
        this.value = typeof this.options.defaultValue != 'undefined' ? this.options.defaultValue : null;
    },
    beforeRender: function () {
        this.renderData = {
            options: this.options
        };
    },
    afterRender: function () {
        this.renderButton();
    },
    renderButton: function () {
        let self = this;
        this.$('.input-btn-group button').each(function () {
            if ($(this).data('value') === self.value || ($(this).data('value') === "null" && self.value == null)) {
                if (self.options.colorInactiveButtons) {
                    $(this).removeClass($(this).data('inactiveClass')).addClass($(this).data('activeClass')).addClass('active');
                } else {
                    $(this).removeClass('inactive').addClass('font-weight-normal').addClass('active');
                }
            } else {
                if (self.options.colorInactiveButtons) {
                    $(this).addClass($(this).data('inactiveClass')).removeClass($(this).data('activeClass')).removeClass('active');
                } else {
                    $(this).addClass('inactive').removeClass('font-weight-normal').addClass('active');
                }
            }
        });
    },
    onChange: function (e) {
        this.value = $(e.currentTarget).data('value');
        this.renderButton();
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.value);
        }
    },
    getValue: function () {
        return this.value;
    },
    setValue: function (value, triggerChange) {
        this.value = value;
        this.renderButton();
        if (triggerChange && typeof this.options.onChange === 'function') {
            this.options.onChange(this.value);
        }
    }
});

PJQ.inputs.StarRating = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Star-Rating'),
        isReadOnly: false
    },
    events: {
        'click .btn-rate': 'ratingChanged'
    },
    beforeFirstRender: function () {
        this.rating = this.options.rating;
        if (this.rating == null) {
            this.rating = 0;
        }
    },
    renderData: function () {
        return {
            rating: this.rating,
            isReadOnly: this.options.isReadOnly
        };
    },
    ratingChanged: function (e) {
        this.setRating(parseInt(this.$(e.currentTarget).data('stars')));
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.rating);
        }
    },
    setRating: function (rating) {
        if (rating == null) {
            this.rating = 0;
        } else {
            this.rating = rating;
        }
        this.render();
    }
});

PJQ.inputs.DayPicker = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'day-picker'),
        isReadOnly: false
    },
    events: {
        'click .btn-work-day': 'dayClicked'
    },
    beforeFirstRender: function () {
        this.days = this.options.defaultValue;
        if (this.days == null) {
            this.days = 0;
        }
    },
    renderData: function () {
        return {
            days: this.days
        };
    },
    reportDayClicked: function (e) {
        this.notificationPerDayRefresh();
    },
    dayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('selected');
        } else {
            dayBtn.addClass('selected');
        }

        let val = 0;
        this.$('.btn-work-day.selected').each(function () {
            val += parseInt($(this).data('value'));
        });
        this.days = val;

        this.render();

        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.days);
        }
    },
    getValue: function () {
        return this.days;
    }
});

if (typeof LazyLoad === 'undefined') {
	(function (w, d) {
		var b = d.getElementsByTagName('head')[0];
		var s = d.createElement("script");
		var v = !("IntersectionObserver" in w) ? "8.17.0" : "10.19.0";
		s.setAttribute('defer', '');
		s.src = (typeof window.lazyLoadPath === 'string' ? window.lazyLoadPath : "/DesktopModules/PanteraModuleGlobal/lazyload/js") + ("/lazyload-" + v + ".min.js");
		b.appendChild(s);
	}(window, document));
}
var dateFormat = function () {
	var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
		timezoneClip = /[^-+\dA-Z]/g,
		pad = function (val, len) {
			val = String(val);
			len = len || 2;
			while (val.length < len) val = "0" + val;
			return val;
		};

	// Regexes and supporting functions are cached through closure
	return function (date, mask, utc) {
		var dF = dateFormat;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date;
		if (isNaN(date)) throw SyntaxError("invalid date");

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var _ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d: d,
				dd: pad(d),
				ddd: dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m: m + 1,
				mm: pad(m + 1),
				mmm: dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy: String(y).slice(2),
				yyyy: y,
				h: H % 12 || 12,
				hh: pad(H % 12 || 12),
				H: H,
				HH: pad(H),
				M: M,
				MM: pad(M),
				s: s,
				ss: pad(s),
				l: pad(L, 3),
				L: pad(L > 99 ? Math.round(L / 10) : L),
				t: H < 12 ? "a" : "p",
				tt: H < 12 ? "am" : "pm",
				T: H < 12 ? "A" : "P",
				TT: H < 12 ? "AM" : "PM",
				Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
				o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
				S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace(token, function ($0) {
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};
}();

// Some common format strings
dateFormat.masks = {
	"default": "ddd mmm dd yyyy HH:MM:ss",
	shortDate: "m/d/yy",
	mediumDate: "mmm d, yyyy",
	longDate: "mmmm d, yyyy",
	fullDate: "dddd, mmmm d, yyyy",
	shortTime: "h:MM TT",
	mediumTime: "h:MM:ss TT",
	longTime: "h:MM:ss TT Z",
	isoDate: "yyyy-mm-dd",
	isoTime: "HH:MM:ss",
	isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
	dayNames: [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
	]
};

// For convenience...
Date.prototype.format = function (mask, utc) {
	return dateFormat(this, mask, utc);
};

function ValidateEmail2(email) {
	email = email.replace(/[ ]/g, '');

	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		isValid = true;
	if (email.indexOf(';') != -1) {
		var emailList = email.split(';');
		for (var i = 0; i < emailList.length; i++) {
			if (!re.test(emailList[i])) {
				isValid = false;
				break;
			}
		}
	}
	else {
		isValid = re.test(email);
	}
	return isValid;
}

function ValidateEmail3(email) {
	email = email.replace(/[ ]/g, '');

	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		isValid = true;
	if (email.indexOf(';') != -1) {
		var emailList = email.split(';');
		for (var i = 0; i < emailList.length; i++) {
			if (!re.test(emailList[i])) {
				isValid = false;
				break;
			}
		}
	}
	else {
		isValid = re.test(email);
	}
	return isValid;
}
PJQ.Loader = class {
    constructor($el, options = {}) {
        this.$el = $el;
        this.options = _.defaults(options, {
            loadingText: 'Loading...',
            type: this.$el.is(':button') ? 'button' : null,
        });
        this.init();
    }

    init() {
        switch (this.getType().toLowerCase()) {
            case 'button':
                this.$processing = $('<span>', {
                    style: 'position:absolute;color:#fff;',
                    text: this.options.loadingText
                });
                this.$el.addClass('loader loader-button').prop('disabled', true);

                if(_.size(this.options.loadingText) === 0){
                    this.$el.addClass('loader-center')
                } else{
                    this.$el.removeClass('loader-center')
                }

                this.$el.prepend(this.$processing);
                break;
            case 'iconbutton':
                this.$el.find('i').addClass('hidden');
                this.$el.addClass('loader loader-button').prop('disabled', true);

                if(_.size(this.options.loadingText) === 0){
                    this.$el.addClass('loader-center')
                } else{
                    this.$el.removeClass('loader-center')
                }

                this.$processing = $('<span>', {
                    style: 'position:absolute;color:#fff;',
                    text: this.options.loadingText
                });
                this.$el.prepend(this.$processing);
                break;
            case 'block':
                this.$el.addClass('loader');
                break;
            case 'small':
                this.$el.addClass('loader loader-overlay loader-small');
                break;
            default:
                this.$el.addClass('loader loader-overlay');
                break;
        }
    }

    getType() {
        return this.options.type ? this.options.type : '';
    }

    remove() {
        if (this.getType().toLowerCase() === 'button') {
            this.$processing.remove();
            this.$el.css('color', '').removeClass('loader loader-overlay').prop('disabled', false);
        } else if (this.getType().toLowerCase() === 'iconbutton') {
            this.$processing.remove();
            this.$el.removeClass('loader loader-overlay').prop('disabled', false);
            this.$el.find('i').removeClass('hidden');
        } else {
            this.$el.removeClass('loader').removeClass('loader-overlay');
        }
    }
};
PJQ.logging = {
	LoggingActions: {
		GLOBAL_GET_SESSION: 'GLOBAL_GET_SESSION',
		AUTH_SIGN_IN: 'AUTH_SIGN_IN',
		AUTH_SIGN_UP: 'AUTH_SIGN_UP',
		AUTH_RESET_PASSWORD: 'AUTH_RESET_PASSWORD',
		PJQPROFILE_GET_SCREENINGS: 'PJQPROFILE_GET_SCREENINGS',
		PJQPROFILE_GET_PREQUAL: 'PJQPROFILE_GET_PREQUAL',
		SEND_PREQUAL_UPDATE: 'SEND_PREQUAL_UPDATE',
		PJQPROQUALADMIN_GET_INVITE: 'PJQPROQUALADMIN_GET_INVITE',
		PJQPROQUALADMIN_GET_ITEM: 'PJQPROQUALADMIN_GET_ITEM',
		PJQPROQUALADMIN_GET_REQUEST: 'PJQPROQUALADMIN_GET_REQUEST',
		PJQPROQUALADMIN_GET_ITEM_COMMENTS: 'PJQPROQUALADMIN_GET_ITEM_COMMENTS',
		PREQUAL_EXPORT: 'PREQUAL_EXPORT',
		FILE_DOWNLOAD_FAILED: 'FILE_DOWNLOAD_FAILED',
		SCREENING_PAYMENT: 'SCREENING_PAYMENT',
		GET_NEW_CONTACT_AB: 'GET_NEW_CONTACT_AB',
		PAYMENT_ERROR: 'PAYMENT_ERROR',
		DELETE_PROJECT_CONTACTS_OR_GROUPS: 'DELETE_PROJECT_CONTACTS_OR_GROUPS',
		UPLOAD_RAW_FILES: 'UPLOAD_RAW_FILES',
		REPORT_CONTACT: 'REPORT_CONTACT'
	}
};

PJQ.logging.Debug = class {
	constructor(action, data, options = {}) {
		this.action = action;
		this.data = data;
		this.options = _.defaults(options, {
			isIncludeUrl: true,
			isSave: true,
			onSave: _.noop
		});
		if (this.options.isSave)
			this.save();
	}

	save() {
		if (PJQ.helpers.objectHelpers.refinedType(this.data) !== 'object') {
			this.data = {
				data: this.data
			}
		}
		if (this.options.isIncludeUrl) {
			this.data = _.defaults(this.data, {
				SESSION_URL: window.location.href
			});
		}
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'logging'
				},
				{
					endpoint: 'debug'
				}
			]),
			data: {
				auditAction: this.action,
				data: this.data
			}
		}).post().done(_.bind(function () {
			if (typeof this.options.onSave === 'function')
				this.options.onSave(this);
		}, this));
	}
};
PJQ.maps = {};

PJQ.maps.GoogleMap = class {
	constructor($el, options = {}) {
		this.options = _.defaults(options, {
			mapId: 'map_' + _.uniqueId(),
			zoom: 4,
			center: new google.maps.LatLng(38.6159, -100.7456),
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});
		this.$el = $el;
		this.$el.attr('id', this.options.mapId);
		this.initMap();
	}

	initMap() {
		this.mapObjects = {};
		this.map = new google.maps.Map(this.$el[0], {
			zoom: this.options.zoom,
			center: this.options.center,
			mapTypeId: this.options.mapTypeId,
			gestureHandling: 'cooperative'
		});
	}

	addMarker(latitude, longitude, options = {}) {
		let id = _.uniqueId(),
			marker = new google.maps.Marker({
				position: new google.maps.LatLng(latitude, longitude),
				map: this.map,
				title: options.title,
				animation: google.maps.Animation.DROP
			});
		this.mapObjects[id] = marker;
		if (_.size(options.infoWindowContent) > 0) {
			let infoWindow = new google.maps.InfoWindow({
				content: options.infoWindowContent
			});
			marker.addListener('click', function () {
				infoWindow.open(this.map, marker);
			});
		}
	}

	addKMLStatesLayer(states) {
		let id = _.uniqueId(),
			src = PJQ.helpers.urlHelpers.buildAPIURL('/workareas/kml?states=' + states.join(','), false, false, true);
		this.mapObjects[id] = new google.maps.KmlLayer(src, {
			suppressInfoWindows: true,
			preserveViewport: true,
			map: this.map
		});
		return id;
	}

	addKMLCountiesLayer(countyIds) {
		let id = _.uniqueId(),
			countyEncode = PJQ.compression.encode.runLength(PJQ.compression.encode.delta(countyIds)),
			src = PJQ.helpers.urlHelpers.buildAPIURL('/workareas/kml?countyIds=' + countyEncode.join(','), false, false, true);
		this.mapObjects[id] = new google.maps.KmlLayer(src, {
			suppressInfoWindows: true,
			preserveViewport: true,
			map: this.map
		});
		return id;
	}

	removeMapObject(id) {
		let object = this.mapObjects[id];
		if (object != null) {
			object.setMap(null);
		}
	}

	resize() {
		google.maps.event.trigger(this.map, 'resize');
	}

	setCenter(center) {
		this.map.setCenter(center);
	}

	setZoom(zoom) {
		this.map.setZoom(zoom);
	}
};

PJQ.views.SuperMap = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Super-Map'),
		mapZoom: 4,
		isDetail: false,
		isActive: true
	},
	events: {
		'click .btn-edit-super': 'editSuper',
		'click .btn-go-to-super': 'goToSuper',
		'click .user-edit-text-map': 'infoWindowEditSuper',
		'keyup .datatable-search': 'search',
		'click .clear-filters': 'clearFilters'
	},
	beforeFirstRender() {
		if (this.collection == null) {
			this.collection = new PJQ.collections.users.Users(null, {
				isDetail: this.options.isDetail
			});
		}

		this.customFields = null;
		if (!this.options.isFetched) {
			this.collection.fetch({
				success: _.bind(function () {
					PJQ.app.session.fetchUserCustomFields(PJQ.app.session.user.get('masterUserId'), _.bind(function(customFields) {
						this.customFields = customFields;
						this.options.isFetched = true;
						this.render();

						if (typeof this.options.onFetch === 'function') {
							this.options.onFetch();
						}
					}, this));
				}, this)
			});
		}
		else {
			this.render();
		}
	},
	beforeRender: function () {
		this.renderData = {
			isDetail: this.options.isDetail,
			options: this.options,
			collection: this.collection
		};
		this.filtered = [];
		_.each(this.collection.models, function (model) {
			if (model.attributes.userTypeId === 396 || model.attributes.userTypeId === 3738) {
				if (!this.options.isActive || model.attributes.isActive)
					this.filtered.push(model)
			}
		}, this);
	},
	afterRender: function () {
		let columns = [];

		if (this.options.isDetail) {
			this.statusSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('select.status-filter'),
				defaultValue: [10,12,16,15,13,14,11,17,18],
				isMultiple: true,
				isIntChoices: true,
				onChange: _.bind(function () {
					this.statusFilterChanged();
				}, this)
			});

			columns = [
				{
					"data": "attributes.contactName",
					"title": "Name"
				},
				{
					"data": "attributes.phone",
					"title": "Phone",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
					}
				},
				{
					"data": "attributes.cell",
					"title": "Cell",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
					}
				},
				{
					"data": "attributes.email",
					"title": "Email",
					"render": function (data) {
						return '<a href="mailto:' + data + '">' + data + '</a>';
					}
				},
				{
					"data": "attributes",
					"title": "Address",
					"render": function (data, type, row) {
						let addr = row.get('address1');
						if (_.size(row.get('address2')) > 0) {
							addr += (' ' + row.get('address2'));
						}
						return addr;
					}
				},
				{
					"data": "attributes.city",
					"title": "City"
				},
				{
					"data": "attributes.state",
					"title": "State"
				},
				{
					"data": "attributes.zip",
					"title": "Zip",
					"render": _.bind(function (data) {
						if (data.length < 5) {
							return ""
						}
						else {
							return data
						}
					})
				},
				{
					"data": "attributes.fieldValue1",
					"title": "Last Safety",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 1);
						return value ? PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : '';
					}, this)
				},
				{
					"data": "attributes.fieldValue2",
					"title": "Last Proc.",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 2);
						return value ? PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : '';
					}, this)
				},
				{
					"data": "attributes.fieldValue6",
					"title": "OSHA",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 6);
						return this.getUserCustomFieldChoice(value, 6);

					}, this)
				},
				{
					"data": "attributes.fieldValue12",
					"title": "Status",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 12);
						return this.getUserCustomFieldChoice(value, 12);
					}, this)
				},
				{
					"data": "attributes.fieldValue16",
					"title": "Pref. PM",
					"render": _.bind(function (data, type, row) {
						return this.getUserCustomFieldValue(row, 16);
					}, this)
				},
				{
					"data": "attributes.fieldValue17",
					"title": "Insurance",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 17);
						return this.getUserCustomFieldChoice(value, 17);
					}, this)
				},
				{
					"data": "attributes.zip",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "80px",
					"render": _.bind(function (data) {
						let editButtonHtml = PJQ.app.session.hasPermission('settings.canManageUsers') ? '<button type="button" class="btn btn-info btn-edit-super ht-30p wd-35p mr-1"><span class="fas fa-pencil"></span></button>' : '';
						if (data.length === 5) {
							return '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'<button type="button" class="btn btn-orange btn-go-to-super ht-30p wd-35p"><span class="fas fa-map-marked-alt"></span></button></div>';
						}
						else {
							return _.size(editButtonHtml)>0 ? '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'</div>' : '';
						}
					}, this)
				}
			];
		} else {
			columns = [
				{
					"data": "attributes.contactName",
					"title": "Name"
				},
				{
					"data": "attributes.phone",
					"title": "Phone",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
					}
				},
				{
					"data": "attributes.email",
					"title": "Email",
					"render": function (data) {
						return '<a href="mailto:' + data + '">' + data + '</a>';
					}
				},
				{
					"data": "attributes",
					"title": "Address",
					"render": function (data, type, row) {
						let addr = row.get('address1');
						if (_.size(row.get('address2')) > 0) {
							addr += (' ' + row.get('address2'));
						}
						return addr;
					}
				},
				{
					"data": "attributes.city",
					"title": "City"
				},
				{
					"data": "attributes.zip",
					"title": "Zip",
					"render": _.bind(function (data) {
						if (data.length < 5) {
							return ""
						}
						else {
							return data
						}
					})
				},
				{
					"data": "attributes.state",
					"title": "State"
				},
				{
					"data": "attributes.zip",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "80px",
					"render": _.bind(function (data) {
						let editButtonHtml = PJQ.app.session.hasPermission('settings.canManageUsers') ? '<button type="button" class="btn btn-info btn-edit-super ht-30p wd-35p mr-1"><span class="fas fa-pencil"></span></button>' : '';
						if (data.length === 5) {
							return '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'<button type="button" class="btn btn-orange btn-go-to-super ht-30p wd-35p"><span class="fas fa-map-marked-alt"></span></button></div>';
						}
						else {
							return _.size(editButtonHtml)>0 ? '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'</div>' : '';
						}
					}, this)
				}
			];
		}

		this.superMapDataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.super-map-data-table'),
			data: this.filtered,
			language: {
				emptyTable: "No Superintendents exist",
				zeroRecords: "No Superintendents match this criteria"

			},
			paging: false,
			info: false,
			rowId: "cid",
			deferRender: true,
			columns: columns,
			isHideSearch: true,
			dom: "t"
		});
		if (this.collection.isFetched) {
			this.renderMap();
			this.renderCounts(this.filtered);
		}
	},
	clearFilters: function() {
		this.$('.datatable-search').val('');
		if (this.options.isDetail) {
			this.statusSelectPicker.setValue([10, 12, 16, 15, 13, 14, 11, 17, 18]);
			this.statusFilterChanged();
		}
		else {
			this.search();
		}
	},
	statusFilterChanged: function() {
		let values = this.statusSelectPicker.getValue();
		this.filtered = [];
		_.each(this.collection.models, function (model) {
			if (model.attributes.userTypeId === 396 || model.attributes.userTypeId === 3738) {
				if ((!this.options.isActive || model.attributes.isActive) && (values.indexOf(parseInt(this.getUserCustomFieldValue(model, 12))) !== -1 || (values.length === 9 && _.size(this.getUserCustomFieldValue(model, 12))===0)))
					this.filtered.push(model)
			}
		}, this);

		this.superMapDataTable.dataTable.clear();
		this.superMapDataTable.dataTable.rows.add(this.filtered);

		this.search();
	},
	search: function() {
		this.superMapDataTable.dataTable.search(this.$('.datatable-search').val()).draw();
	},
	getUserCustomFieldValue: function (row, id) {
		let match = _.find(row.get('userCustomFieldValues'), function (cf) {
			return (cf.fieldNumber === id);
		});
		return match ? match.value : null;
	},
	getUserCustomFieldChoice: function (value, id) {
		let match = _.find(this.customFields.models, function (cf) {
			return (cf.get('fieldNumber') === id);
		});
		let result = '';
		if (match) {
			_.each(match.choices.models, function(choice) {
				if (choice.id === value)
					result = choice.get('choiceName');
			});
		}

		return result;
	},
	renderCounts: function(models) {
		let retired = 0,
			active = 0,
			activeNew = 0,
			retiredToOffice = 0,
			activeSub = 0,
			neverUse = 0,
			retiredSub = 0,
			inactiveSub = 0,
			inactiveSuper = 0;

		_.each(models, function(model) {
			_.each(model.get('userCustomFieldValues'), function(customFieldValue) {
				if (customFieldValue.fieldNumber === 12) { // status
					switch(customFieldValue.value) {
						case 10:
							retired++;
							break;
						case 12:
							active++;
							break;
						case 16:
							activeNew++;
							break;
						case 15:
							retiredToOffice++;
							break;
						case 13:
							activeSub++;
							break;
						case 14:
							neverUse++;
							break;
						case 11:
							retiredSub++;
							break;
						case 17:
							inactiveSub++;
							break;
						case 18:
							inactiveSuper++;
							break;
					}
				}
			});
		});

		this.$('.total-retired').text(retired);
		this.$('.total-active').text(active);
		this.$('.total-active-new').text(activeNew);
		this.$('.total-retired-office').text(retiredToOffice);
		this.$('.total-active-sub').text(activeSub);
		this.$('.total-never-use').text(neverUse);
		this.$('.total-retired-sub').text(retiredSub);
		this.$('.total-inactive-sub').text(inactiveSub);
		this.$('.total-inactive-super').text(inactiveSuper);
	},
	renderMap: function () {
		this.map = new PJQ.maps.GoogleMap(this.$('.super-map'), {
			zoom: this.options.mapZoom
		});
		this.renderMarkers(this.filtered);
		this.watchSearch();
	},
	makeInfoWindow: function (user) {
		return "<div class=\"fs-18 user-edit-text-map text-primary font-weight-light mb-n3 mt-n1\" id='" + user.get('userId') + "'>" + user.get('contactName') + "</div><p><br />" +
			"<b>Phone:</b> " + PJQ.helpers.formatHelpers.formatPhoneNumber(user.get('phone')) + "<br />" +
			"<b>Email:</b> " + user.get('email') + "<br />" +
			"<b>Address:</b> " + user.get('address1') + "<br/>" +
			"<b>City:</b> " + user.get('city') + "<br />" +
			"<b>State:</b> " + user.get('state') + "<br />" +
			"<b>Zip:</b> " + user.get('zip') + "</p>";
	},
	renderMarkers: function (source) {
		_.each(source, function (user) {
			let latitude = user.get('latitude'),
				longitude = user.get('longitude');
			if (latitude !== 0 && longitude !== 0) {
				this.map.addMarker(latitude, longitude, {
					infoWindowContent: this.makeInfoWindow(user),
					title: user.get('contactName')
				});
			}
		}, this);
	},
	removeMarkers() {
		_.each(this.map.mapObjects, function (marker) {
			marker.setMap(null)
		});
	},
	infoWindowEditSuper: function (e) {
		if (!PJQ.app.session.hasPermission('settings.canManageUsers'))
			return;
		
		let target = $(e.currentTarget);
		let id = parseInt(target.context.id);
		_.each(this.filtered, function (user) {
			if (user.get('userId') === id) {
				new PJQ.views.contacts.BaseEditContactModal({
					model: user,
					onSave: _.bind(function () {
						this.superMapDataTable.refresh();
						this.removeMarkers();
						this.renderMarkers(this.filtered)
					}, this)
				});
			}
		}, this);
	},
	editSuper: function (e) {
		let target = $(e.currentTarget),
			row = this.superMapDataTable.getRow(target.closest('tr')),
			user = row.data();
		new PJQ.views.contacts.BaseEditContactModal({
			model: user,
			onSave: _.bind(function () {
				this.superMapDataTable.refresh();
				this.removeMarkers();
				this.renderMarkers(this.filtered)
			}, this)
		});
	},
	goToSuper: function (e) {
		let target = $(e.currentTarget),
			row = this.superMapDataTable.getRow(target.closest('tr')),
			user = row.data();
		this.map.setCenter({lat: user.get('latitude'), lng: user.get('longitude')});
		this.map.setZoom(8);
		_.each(this.map.mapObjects, function (marker) {
			if (user.get('longitude') === 0 || user.get('latitude') === 0) {
				return;
			}

			if (marker.getPosition().lng().toFixed(5) === user.get('longitude').toFixed(5) && marker.getPosition().lat().toFixed(5) === user.get('latitude').toFixed(5)) {
				if (this.infoWindow) {
					this.infoWindow.close();
				}
				this.infoWindow = new google.maps.InfoWindow({
					content: this.makeInfoWindow(user)
				});
				this.infoWindow.open(this.map, marker)
			}
		}, this)
	},
	watchSearch: function () {
		this.superMapDataTable.dataTable.on('search.dt', _.bind(function () {
			this.filterArray = [];

			let self = this;
			this.superMapDataTable.dataTable.rows({filter: 'applied'}).every(function () {
				self.filterArray.push(this.data());
			});

			this.removeMarkers();
			this.renderMarkers(this.filterArray);
			this.renderCounts(this.filterArray);
		}, this))
	},
});

PJQ.app.addRoutes([
	{
		route: 'supermap',
		name: 'supermap',
		callback: function () {
			new PJQ.views.SuperMap({
				el: $('#pjq-main')
			});
		}
	},
	{
		route: 'supermapall',
		name: 'supermapall',
		callback: function () {
			new PJQ.views.SuperMap({
				el: $('#pjq-main'),
				isDetail: true,
				isActive: false
			});
		}
	}
]);


PJQ.menus = {
	activeMenus: [],
	closeActiveMenus: function () {
		_.each(PJQ.menus.activeMenus, function (contextMenu) {
			contextMenu.close();
		});
	}
};

PJQ.menus.ContextMenu = PJQ.views.BaseView.extend({
	defaults: {

		/* user-defined function to obtain specific data about the currently
		 * opened element, to pass it to the rest of user-defined functions
		 * of an action. */
		fetchElementData: _.noop,

		/* what the source of the context menu should be when opened.
		 * Valid values are 'mouse' and 'element'. */
		menuSource: 'mouse',

		/* how to calculate the position of the context menu based on its source.
		 * Valid values are 'aboveLeft', 'aboveRight', 'belowLeft', and 'belowRight'. */
		menuPosition: 'belowLeft',

		/* the event to listen to open the menu.
		 * Valid values are 'click', 'right-click', 'hover' */
		menuEvent: 'right-click',

		/* group actions to render them next to each other, with a separator
		 * between each group. */
		actionsGroups: [],

		/* message to show when there are no actions to show in a menu
		 * (isShown() returned false on all actions) */
		noActionsMessage: 'No available actions',

		/* Hide the menu entirely if there are no available actions instead of displaying the message. */
		isHideNoActions: false,

		/* In some weird cases, another plugin may be installing 'click' listeners
		 * in the anchors used for each action of the context menu, and stopping
		 * the event bubbling before it reaches this plugin's listener.
		 *
		 * For those cases, _actionSelectEvent can be used to change the event we
		 * listen to, for example to 'mousedown'.
		 *
		 * Unless the context menu is not working due to this and a workaround is
		 * needed, this option can be safely ignored.
		 */
		_actionSelectEvent: 'click',

		/* In some situations such as datagrids that contain subgrids, the context menu needs to be wrapped in a fixed div to avoid display issues
		 *
		 */
		isWrapInFixedContainer: false,

		onOpen: _.noop,
		onClose: _.noop
	},
	events: {},
	beforeFirstRender: function () {
		// namespaces to use when registering event listeners
		this.namespace = _.uniqueId('.ContextMenu_');
		this.closeNamespace = _.uniqueId('.ContextMenuClose_');

		// jQuery object of the rendered context menu. Not part of the DOM yet.
		this.$menu = this.renderMenu(this);
		this.$menuList = this.$menu.children();

		/* append the context menu to <body> to be able to use "position: absolute"
		 * absolute to the whole window. */
		this.$menu.hide().appendTo(this.$el);

		/* the element in which the context menu was opened. Updated every time
		 * the menu is opened. */
		this.$openTarget = null;

		/* event that triggered the context menu to open. Updated every time
		 * the menu is opened. */
		this.openEvent = null;

		this.setupOpenEventListeners();

		this.setupActionsEventListeners();

		// keep track of all the existing context menu instances in the page
		PJQ.menus.activeMenus.push(this);

		return false;
	},
	updatePosition: function () {
		let menuLocation = null, // my
			relativeToElem = null, // of
			relativeToLocation = null; // at

		switch (this.options.menuSource) {
			case 'element':
				relativeToElem = this.$openTarget;
				break;
			case 'mouse':
				relativeToElem = this.openEvent;
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuSource' option");
		}

		switch (this.options.menuPosition) {
			case 'belowRight':
				menuLocation = 'right top';
				relativeToLocation = 'right bottom';
				break;
			case 'belowLeft':
				menuLocation = 'left top';
				relativeToLocation = 'left bottom';
				break;
			case 'aboveRight':
				menuLocation = 'right bottom';
				relativeToLocation = 'right top';
				break;
			case 'aboveLeft':
				menuLocation = 'left bottom';
				relativeToLocation = 'left top';
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuPosition' option");
		}

		// update the menu's height and width manually
		this.$menu.css({display: 'block'});

		// once the menu is not hidden anymore, we can obtain its content's height and width,
		// to manually update it in the menu
		this.$menu.css({
			height: this.$menuList.height(),
			width: this.$menuList.width()
		});

		this.$menu.position({my: menuLocation, at: relativeToLocation, of: relativeToElem});
	},
	open: function ($openTarget) {
		let self = this;

		// first close all open instances of opened context menus in the page
		PJQ.menus.closeActiveMenus();

		self.$openTarget = $openTarget;

		self.openEvent = event;

		let targetData = self.options.fetchElementData(self.$openTarget),
			$actions = self.$menu.find('[data-action]'),
			$noActionsMsg = self.$menu.find('.noActionsMessage');

		// clear previously hidden actions, and hide by default the 'No actions' message
		$actions.show();
		$noActionsMsg.hide();

		/* go through all actions to update the text to show, which ones to show
		 * enabled/disabled and which ones to hide. */
		let numShown = 0;
		$actions.each(function () {
			let $action = $(this),
				$actionName = $action.find('.actionName'),
				actionId = $action.data('action'),
				action = self.options.actions[actionId];

			let itemClasses = $action.attr('class');
			if (_.size(action.itemClasses) > 0) {
				itemClasses += (' ' + action.itemClasses);
			}

			if (action.isDanger) {
				itemClasses += (' ' + 'danger-item');
			}
			$action.attr('class', itemClasses);

			let textClasses = $actionName.attr('class');
			if (_.size(action.textClasses) > 0) {
				textClasses = textClasses + ' ' + action.textClasses;
			}
			$actionName.attr('class', textClasses);

			if (typeof action.isShown === 'function' && action.isShown(targetData) !== true) {
				$action.hide();
				return;
			}
			else {
				numShown++;
			}

			// the name provided for an action may be dynamic, provided as a function
			$actionName.html(
				_.isFunction(action.name) && action.name(targetData) || action.name
			);

			if (action.isEnabled && action.isEnabled(targetData) === false) {
				$action.addClass('disabled');
			}
		});

		if (numShown === 0) {
			$noActionsMsg.show();
		}

		// once it is known which actions are or arent being shown
		// (so we know the final height of the context menu),
		// calculate its position
		this.updatePosition();

		if (numShown === 0 && this.options.isHideNoActions)
			this.$menu.hide();
		else {
			this.$menu.show();

			this.setupCloseEventListeners();

			this.options.onOpen(targetData);
		}
	},
	close: function () {
		// hide the menu
		this.$menu.hide();

		this.clearCloseEventListeners();

		this.options.onClose();
	},
	destroy: function () {
		this.close();
		this.clearOpenEventListeners();
		this.clearActionsEventListeners();
	},
	renderMenu: function (_this) {
		let $menu = $('<div class="dropdown context-menu"/>'),
			$ul = $('<ul class="dropdown-menu"/>');

		// group all actions following the actionsGroups option, to
		// add a separator between each of them.
		let groups = [];

		// default group where all ungrouped actions will go
		groups[0] = [];

		// add the rest of groups
		_.each(_this.options.actionsGroups, function (groupArr, ind) {
			groups[ind + 1] = [];
		});

		// find out if any of the actions has an icon
		let actionsHaveIcon = false;

		// add each action to the group it belongs to, or the default group
		_.each(_this.options.actions, function (action, actionId) {
			let addedToGroup = false;

			_.each(_this.options.actionsGroups, function (groupArr, ind) {
				if (_.contains(groupArr, actionId)) {
					groups[ind + 1].push(actionId);
					addedToGroup = true;
				}
			});

			if (addedToGroup === false) {
				groups[0].push(actionId);
			}

			if (typeof action.iconClass !== 'undefined') {
				actionsHaveIcon = true;
			}
		});

		let isFirstNonEmptyGroup = true;
		_.each(groups, function (actionsIds) {
			if (actionsIds.length == 0)
				return;

			if (isFirstNonEmptyGroup === false) {
				$ul.append('<li class="divider"></li>');
			}
			isFirstNonEmptyGroup = false;

			_.each(actionsIds, function (actionId) {
				let action = _this.options.actions[actionId];
				if (typeof action.isHidden === 'function' && action.isHidden()) {
					return;
				}

				/* At least an action has an icon. Add the icon of the current action,
				 * or room to align it with the actions which do have one. */
				if (actionsHaveIcon === true) {
					$ul.append(
						'<li role="presentation" class="menu-item" data-action="' + actionId + '">' +
						'<a href="javascript:void(0)" role="menuitem" class="menu-item-link">' +
						'<i class="' + (action.iconClass || '') + '"></i> ' +
						'<span class="actionName"></span>' +
						'</a>' +
						'</li>'
					);
				}
				// neither of the actions have an icon.
				else {
					$ul.append(
						'<li role="presentation" class="menu-item" data-action="' + actionId + '">' +
						'<a href="javascript:void(0)" role="menuitem" class="menu-item-link"><span class="actionName"></span></a>' +
						'</li>'
					);
				}
			});

			$ul.append(
				'<li role="presentation" class="noActionsMessage disabled">' +
				'<a href="javascript:void(0)" role="menuitem">' +
				'<span>' + _this.options.noActionsMessage + '</span>' +
				'</a>' +
				'</li>'
			);
		});

		let result = $menu.append($ul);

		if (this.options.isWrapInFixedContainer) {
			let $wrapper = $('<div style="position:fixed;overflow:visible;width:100%;z-index:10;"/>')
			result = $wrapper.append($menu);
		}

		return result;
	},
	setupOpenEventListeners: function () {
		let self = this,
			openEventName = null;

		switch (self.options.menuEvent) {
			case 'click':
				openEventName = 'click';
				break;
			case 'right-click':
				openEventName = 'contextmenu';
				break;
			case 'hover':
				openEventName = 'mouseenter';
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuEvent' option");
		}

		// install the handler for every future elements where
		// the context menu will open
		self.$el.on(openEventName + self.namespace, self.options.selector, function (evt) {
			self.open($(this), evt);

			// cancel event propagation, to avoid it bubbling up to this.$el
			// and closing the context menu as if the user clicked outside the menu.
			return false;
		});
	},
	clearOpenEventListeners: function () {
		this.$el.off(this.namespace);
	},
	setupActionsEventListeners: function () {
		let self = this,
			actionSelectEvent = self.options._actionSelectEvent + self.namespace;

		// handler to run when an option is selected
		this.$menu.on(actionSelectEvent, function (evt) {
			evt.preventDefault();
			evt.stopPropagation();

			let $target = $(evt.target),
				$action = $target.closest('[data-action]');

			// check if the clicked element is an action, and its enabled.
			// if not don't do anything
			if (!$action || !$action.length || $action.is('.disabled')) {
				return;
			}

			let actionId = $action.data('action'),
				targetData = self.options.fetchElementData(self.$openTarget);

			/* call the user click handler. It receives the optional user-defined data,
			 * or undefined. */
			self.options.actions[actionId].onClick(targetData);

			// close the menu
			self.close();
		});
	},
	clearActionsEventListeners: function () {
		this.$menu.off(this.namespace);
	},
	setupCloseEventListeners: function () {
		let self = this;
		switch (self.options.menuEvent) {
			case 'click':
				break;
			case 'right-click':
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuEvent' option");
		}

		// If the user clicks outside the context menu, close it.
		// Attach this event to the body to ensure it closes no matter where they click
		$('html').on('click' + self.closeNamespace, function () {
			self.close();
		});
	},
	clearCloseEventListeners: function () {
		this.$el.off(this.closeNamespace);
	}
});
PJQ.helpers.mobile = {
	getDevice: function () {
		let userAgent = window.navigator.userAgent,
			device = null;
		if (userAgent.match(/android/i) != null) {
			device = "android";
		}
		else if (userAgent.match(/iPhone/i) != null
			|| userAgent.match(/iPod/i) != null
			|| userAgent.match(/iPad/i) != null) {
			device = "ios";
		}
		return device;
	}
};

PJQ.views.mobile = {};

PJQ.views.mobile.AppDownloadModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-App-Download'),
		cookie: 'JP_APP_DOWNLOAD',
		isVerticalCenter: true
	},
	events: {
		'click .open-in-app': 'openInApp',
		'click .no-thanks': 'setCookie'
	},
	beforeModalCreated: function () {
		if (PJQ.helpers.cookieHelpers.getCookie(this.options.cookie) != null) {
			return false;
		}
	},
	openInApp: function () {
		this.setCookie();
		PJQ.app.session.project.openInApp();
	},
	setCookie: function () {
		PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true, 3);
	}
});
PJQ.views.modals = {};

PJQ.views.modals.YesNo = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			okButtonText: "Yes",
			onOk: _.bind(function () {
				if (_.size(this.options.cookie) > 0) {
					PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true);
				}

				if (typeof this.options.onYes === 'function') {
					this.options.onYes();
				}
			}, this),
			isShowSecondaryButton: true,
			secondaryButtonText: "No",
			onSecondary: _.bind(function () {
				if (typeof this.options.onNo === 'function') {
					this.options.onNo();
				}
			}, this)
		}, this.options);
	}
});

PJQ.views.modals.SaveDontSave = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			okButtonText: "Save",
			onOk: _.bind(function () {
				if (typeof this.options.onSave === 'function') {
					this.options.onSave();
				}
			}, this),
			isShowSecondaryButton: !(this.options.isShowDontSaveButton === false),
			secondaryButtonText: "Don't Save",
			onSecondary: _.bind(function () {
				if (typeof this.options.onDontSave === 'function') {
					this.options.onDontSave();
				}
			}, this),
			isShowCancelButton: true,
			cancelButtonColorClass: this.options.declineButtonColorClass ? this.options.declineButtonColorClass : "secondary",
			cancelButtonText: "Cancel",
			onClose: _.bind(function () {
				if (typeof this.options.onCancel === 'function') {
					this.options.onCancel();
				}
			}, this)
		}, this.options);
	}
});

PJQ.views.modals.DeleteCancel = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			okButtonText: this.options.deleteButtonText ? this.options.deleteButtonText : "Delete",
			okButtonColorClass: this.options.deleteButtonColorClass ? this.options.deleteButtonColorClass : 'danger',
			onOk: _.bind(function () {
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete();
				}
			}, this),
			isShowCancelButton: true,
			cancelButtonColorClass: this.options.declineButtonColorClass ? this.options.declineButtonColorClass : "secondary",
			cancelButtonText: this.options.declineButtonText ? this.options.declineButtonText : "Cancel",
			onClose: _.bind(function () {
				if (typeof this.options.onCancel === 'function') {
					this.options.onCancel();
				}
			}, this)
		}, this.options);
	}
});

PJQ.views.modals.CopyDelete = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			secondaryButtonColorClass: 'danger',
			okButtonText: "Copy All User Types",
			onOk: _.bind(function () {
				if (typeof this.options.onYes === 'function') {
					this.options.onYes();
				}
			}, this),
			isShowSecondaryButton: true,
			secondaryButtonText: "Delete All User Types",
			onSecondary: _.bind(function () {
				if (typeof this.options.onNo === 'function') {
					this.options.onNo();
				}
			}, this)
		}, this.options);
	}
});

//This modal is used for pages where there should be no other action behind the modal (at least without further action)
//The template provides no way for the user to close the dialog
PJQ.views.modals.ErrorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Error')
	}
});

PJQ.nav = {
    getDataForOldProjectModules: function (callback) {
        window.pjqWallContext = 'project';
        new PJQ.ajax.Request({
            endpoint: "/session/project/" + PJQ.app.session.project.id.toString()
        }).put().done(_.bind(function () {
            if (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
                let sessionId = window.pjqSessionId ? window.pjqSessionId : PJQ.app.session.id;
                PanteraScript.PanteraScriptService.GetProjectWallAdminSettings(sessionId, window.projectContactTemp != null ? window.projectContactTemp : '', function (settings) {
                    window.settings = $.parseJSON(settings);
                    window.settings.projectId = PJQ.app.session.project.id;
                    if (window.settings.LayoutCompany != null) {
                        window.pjqITBLayoutDefault = window.settings.LayoutCompany;
                    }
                    if (window.settings.LayoutGroupCompany != null) {
                        window.pjqITBLayoutGroupCompany = window.settings.LayoutGroupCompany;
                    }

                    if (window.settings.FieldMappingContact != null) {
                        window.pjqFMContact = window.settings.FieldMappingContact;
                    }

                    let xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetProjectMessageTemplates.aspx?sessionid=' + PJQ.app.session.id + '&x=' + new Date().getTime();
                    jQuery.ajax({
                        type: "GET",
                        url: xmlFile,
                        dataType: "json",
                        success: _.bind(function (result) {
                            window.settings.ProjectMessageTemplates = result;
                            PanteraScript.PanteraScriptService.GetProjectInfo(PJQ.app.session.id, function (project) {
                                window.project = $.parseJSON(project);
                                callback();
                            }, onScriptError);
                        }, this)
                    });
                }, onScriptError);
            } else {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'settings'
                        },
                        {
                            endpoint: 'getsubwallsettings'
                        }
                    ]),
                    isPascal: true
                }).get().done(_.bind(function (settings) {
                    window.settings = settings;
                    PanteraScript.PanteraScriptService.GetProjectInfo(PJQ.app.session.id, function (project) {
                        window.project = $.parseJSON(project);
                        callback();
                    }, onScriptError);
                }, this)).fail(onScriptError);
            }
        }, this));
    }
};
PJQ.nav.NavItem = class {
    constructor(options = {}) {
        this.id = options.id;
        this.title = options.title;
        this.isBeta = options.isBeta === true;
        this.isLegacy = options.isLegacy;
        this.requiresDirectory = options.requiresDirectory === true;
        this.isPrimaryProjectManagerCheckExempt = options.isPrimaryProjectManagerCheckExempt === true;
        this.sortOrder = options.sortOrder;
        this.icon = options.icon;
        this.iconImage = options.iconImage;
        this.iconImageActive = options.iconImageActive;
        this.feature = options.feature;
        this.systemFeature = options.systemFeature === true;
        this.isActive = options.isActive;
        this.hasRoute = options.hasRoute;
        this.hasPrecedingSeparator = options.hasPrecedingSeparator;
        this.extraMarkup = options.extraMarkup;
        this.includeMarkup = options.includeMarkup;
        this.outsideRoute = options.outsideRoute;
        this.category = options.category ? options.category : null;
        this.isAdmin = options.isAdmin;
        if (options.route != null) {
            this.route = options.route;
        }
        if (options.count != null) {
            this.count = options.count;
        }
        if (options.render != null) {
            this.render = options.render;
        }
        if (options.hasPermission != null) {
            this.hasPermission = options.hasPermission;
        }
        if (options.path != null) {
            this.path = typeof options.path === 'function' ? options.path : _.noop;
        }
        if (options.isDisabled != null) {
            this.isDisabled = options.isDisabled;
        }

        if (options.isHidden != null) {
            this.isHidden = options.isHidden;
        }

        if (options.requireSignUp != null) {
            this.requireSignUp = options.requireSignUp;
        }

        if (options.leaveView != null) {
            this.leaveView = options.leaveView;
        }
    }

    path() {
        return this.id;
    }

    routeToRoot() {
        if (PJQ.app.session.project != null) {
            PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id.toString(), {
                trigger: true
            });
            return;
        }
        PJQ.app.router.signInCache = '#' + PJQ.app.router.getCurrentRoute();
        PJQ.app.router.routeToRoot();
    }

    route(options, triggerRoute = true, $navBody = null) {
        let hasPermission = this.hasPermission();
        if (!hasPermission && PJQ.app.session && PJQ.app.session.get('contactGuid')) {
            PJQ.app.router.signInNavigate({
                cacheRoute: true
            });
            return false;
        } else if (!hasPermission || !this.hasFeature() || this.getIsDisabled()) {
            this.routeToRoot();
            return false;
        }

        if (options && options.noRoute)
            return;

        if (_.size($navBody) > 0 && this.requiresDirectory && PJQ.app.session.isPanteraPortal() && PJQ.app.session.contact == null && PJQ.app.options.isPanteraApp) {
            if (PJQ.app.session.user != null && PJQ.app.session.user.get('companyType') === 'SUB') {
                new PJQ.views.nav.RegisterDirectory({
                    el: $navBody,
                    onRegister: _.bind(function () {
                        this.render($navBody, options);
                    }, this),
                    onClose: _.bind(function () {
                        this.routeToRoot();
                    }, this)
                });
            } else {
                this.routeToRoot();
            }
            return false;
        } else {
            PJQ.app.router.navigate(typeof this.path === 'function' ? this.path(options) : this.path, {
                trigger: triggerRoute
            });
        }
    }

    getNavPref() {
        if (this.navPref == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let appNavPref = prefs.getPref(PJQ.constants.preferenceTypes.APP_NAV_ITEMS),
                portalNavPref = prefs.getPref(PJQ.constants.preferenceTypes.PORTAL_APP_NAV_ITEMS);
            this.navPref = _.findWhere(_.union(portalNavPref != null ? portalNavPref : [], appNavPref != null ? appNavPref : []), {id: this.id});
        }
        return this.navPref;
    }

    getDocumentTitle() {
        let result = '',
            itemPref = this.getNavPref();
        if (itemPref != null && itemPref.title != null) {
            result = itemPref.title;
        } else {
            result = typeof this.title === 'function' ? this.title() : this.title;
        }

        if (PJQ.app.session.project != null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_NAME_PAGE_TITLE)) {
            let pName = PJQ.app.session.project.get('projectName'),
                pCity = PJQ.app.session.project.get('city'),
                pState = PJQ.app.session.project.get('state'),
                pLoc = '';
            if (_.size(pCity) > 0) {
                pLoc += pCity;
            }
            if (_.size(pState) > 0) {
                pLoc += pState;
            }
            result = pLoc + ' - ' + pName;
        }

        return result;
    }

    getTitle(html = true) {
        let result = '',
            itemPref = this.getNavPref();
        if (itemPref != null && itemPref.title != null) {
            result = itemPref.title;
        } else {
            result = typeof this.title === 'function' ? this.title() : this.title;
        }

        if (this.isBeta) {
            if (html) {
                result += "<span class='ml-1 fs-12 font-weight-medium'>beta</span>"
            } else {
                result += ' - beta';
            }
        } else if ((typeof this.isLegacy === 'function' && this.isLegacy()) || this.isLegacy === true) {
            if (html) {
                result += "<span class='ml-1 fs-12 font-weight-medium'>legacy</span>"
            } else {
                result += ' - legacy';
            }
        }

        return result;
    }

    getSortOrder() {
        let itemPref = this.getNavPref();
        if (itemPref != null && itemPref.sortOrder != null) {
            return itemPref.sortOrder;
        }
        return this.sortOrder;
    }

    getIsAdmin() {
        let itemPref = this.getNavPref();
        if (itemPref != null && itemPref.isAdmin != null) {
            return itemPref.isAdmin;
        }
        return this.isAdmin;
    }

    getIsHidden() {
        //only return item pref if its forced to true
        let itemPref = this.getNavPref();
        if (itemPref != null && itemPref.isHidden) {
            return itemPref.isHidden;
        }
        return typeof this.isHidden === 'function' ? this.isHidden() : this.isHidden;
    }

    getIsDisabled() {
        //only return item pref if its forced to true
        let itemPref = this.getNavPref();
        if (itemPref != null && itemPref.isDisabled) {
            return itemPref.isDisabled;
        }
        return typeof this.isDisabled === 'function' ? this.isDisabled() : this.isDisabled;
    }

    hasPermission() {
        return true;
    }

    hasFeature() {
        if (_.size(this.feature) > 0) {
            if (!this.systemFeature && PJQ.app.session.project != null && PJQ.app.session.project.subscription != null) {
                return PJQ.app.session.project.subscription.hasFeature(this.feature);
            }
            return PJQ.app.session.hasFeature(this.feature);
        }
        return true;
    }

    isDisabled() {
        return false;
    }

    count() {
        return 0;
    }
};

PJQ.nav.NavItemGroup = class {
    constructor(items, options) {
        this.items = items;
        this.options = options ? options : {};
    }
};

PJQ.nav.itemGroups = {
    main: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "myprojects",
            title: "My Projects",
            sortOrder: 10,
            icon: "fa-hammer",
            feature: "projects",
            hasRoute: true,
            systemFeature: true,
            render: function ($el) {
                new PJQ.views.projects.MyProjectList({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "biddingprojects",
            title: function () {
                return PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.BIDDING_PROJECTS_TAB_NAME) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.BIDDING_PROJECTS_TAB_NAME) : "Bidding Projects";
            },
            sortOrder: 20,
            icon: "fa-hammer",
            hasRoute: true,
            systemFeature: true,
            render: function ($el) {
                new PJQ.views.projects.BiddingProjectsList({
                    el: $el
                });
            },
            isDisabled: function () {
                return PJQ.app.session.get('ownsPortal') || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_BIDDING_PROJECTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectinvites",
            title: "Project Invites",
            sortOrder: 30,
            icon: "fa-envelope",
            hasRoute: true,
            systemFeature: true,
            render: function ($el) {
                new PJQ.views.projects.ProjectInvitesList({
                    el: $el
                });
            },
            isDisabled: function () {
                return PJQ.app.session.get('ownsPortal') && !PJQ.app.session.isPanteraPortal();
            }
        }),
        new PJQ.nav.NavItem({
            id: "contacts",
            title: "Contacts",
            sortOrder: 40,
            icon: "fa-users",
            feature: "contacts",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('contacts.canView');
            },
            render: function ($el, options) {
                new PJQ.views.addressbook.AddressBook(_.defaults({
                    el: $el
                }, options));
            },
            count: function () {
                if (PJQ.app.session.hasPermission('contacts.canApprove')) {
                    return PJQ.app.session.get('unApprovedContactsCount');
                } else {
                    return 0;
                }
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "documents",
            title: "Documents",
            sortOrder: 50,
            icon: "fa-folder",
            feature: "documents",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('documents.canView');
            },
            route: function () {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_DOCUMENTS)) {
                    PJQ.app.router.navigate(this.path(), {
                        trigger: true
                    });
                } else {
                    if (window.location.hash.toLowerCase() !== ('#' + this.path())) {
                        window.location.href = '#' + this.path();
                        window.location.reload();
                        return false;
                    }
                }
            },
            render: function ($el) {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_DOCUMENTS)) {
                    new PJQ.views.files.FileNavigator({
                        el: $el
                    });
                } else {
                    $el.append($('<iframe/>', {
                        src: '/Default.aspx?tabid=' + PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.DOCUMENTS_TAB_ID).toString(),
                        style: 'border:0;width:100%;height:' + $el.height() + 'px;'
                    }));
                }
            },
            isDisabled: function () {
                return (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DOCUMENTS_TAB_ID)
                    && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_DOCUMENTS)) || PJQ.app.session.user == null || !PJQ.app.session.get('ownsPortal') || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SYSTEM_DOCUMENTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "bidfiler",
            title: "Bid Filer",
            sortOrder: 60,
            icon: "fa-file-import",
            feature: "bidFiler",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('bidFiler.isAdmin');
            },
            render: function ($el) {
                new PJQ.views.BidFiler({
                    el: $el
                });
            },
            isDisabled: function () {
                if (PJQ.app.session.isPanteraPortal() && PJQ.app.options.isPanteraApp) {
                    return false;
                }

                return !PJQ.app.session.get('ownsPortal')
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FILER)
                    || !PJQ.app.options.isPanteraApp;
            }
        }),
        new PJQ.nav.NavItem({
            id: "printondemand",
            title: "Order Prints",
            sortOrder: 70,
            icon: "fa-print",
            hasRoute: true,
            systemFeature: true,
            render: function ($el) {
                initPrintOnDemand($el);
            },
            isDisabled: function () {
                return !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PRINT_ON_DEMAND);
            }
        }),
        new PJQ.nav.NavItem({
            id: "profile",
            title: "Profile",
            sortOrder: 80,
            icon: "fa-user",
            hasRoute: true,
            requiresDirectory: true,
            systemFeature: true,
            render: function ($el, options) {
                new PJQ.views.profile.CompanyProfile({
                    el: $el,
                    key: options ? options.key : null,
                    activateTab: options ? options.tab : null
                });
            },
            isDisabled: function () {
                let companyType = null;
                if (PJQ.app.session.user != null) {
                    companyType = PJQ.app.session.user.get('companyType');
                }
                return (PJQ.app.session.get('ownsPortal') && !PJQ.app.session.isPanteraPortal()) || companyType !== "SUB" || !PJQ.app.options.isPanteraApp;
            }
        }),
        new PJQ.nav.NavItem({
            id: "prequal",
            title: "Prequalification",
            sortOrder: 80,
            icon: "fa-align-justify",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.isPanteraPortal() || PJQ.app.session.hasPermission('prequal.canView');
            },
            requiresDirectory: true,
            render: function ($el, options) {
                let terms = new PJQ.collections.screenings.ScreeningTerms(),
                    renderDashboard = function () {
                        let clients = new PJQ.collections.screenings.ScreeningClients(null, {
                            contact: PJQ.app.session.contact,
                            prequalKey: options?.prequalKey,
                            masterUserId: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : (options?.masterUserId ?? PJQ.constants.publicUserId)
                        });
                        clients.fetch({
                            success: function () {
                                new PJQ.views.screenings.ScreeningDashboard({
                                    el: $el,
                                    collection: clients
                                });
                            },
                            error: function (model, result) {
                                new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
                                    model: model,
                                    result: result
                                });
                            }
                        });
                    };
                terms.fetch({
                    success: function () {
                        if (_.find(terms.models, function (term) {
                            return term.get('isActive') && !term.get('isAccepted')
                        }) != null) {
                            new PJQ.views.screenings.ScreeningTermsModal({
                                collection: terms,
                                onComplete: function () {
                                    renderDashboard();
                                }
                            });
                        } else {
                            renderDashboard();
                        }
                    }
                });
            },
            isHidden: function(){
                return true;
            },
            isDisabled: function () {
                return !PJQ.app.session.isLoggedIn() || !PJQ.app.session.isPanteraPortal() || PJQ.app.session.contact == null;
            }
        }),
        new PJQ.nav.NavItem({
            id: "screenings",
            title: "Screenings",
            sortOrder: 90,
            icon: "fa-user",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.isPanteraPortal() || PJQ.app.session.hasPermission('prequal.canView');
            },
            render: function ($el, options) {
                let terms = new PJQ.collections.screenings.ScreeningTerms(),
                    renderDashboard = function () {
                        let clients = new PJQ.collections.screenings.ScreeningClients(null, {
                            contact: PJQ.app.session.contact,
                            masterUserId: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.constants.publicUserId
                        });
                        clients.fetch({
                            success: function () {
                                new PJQ.views.screenings.ScreeningDashboard({
                                    el: $el,
                                    collection: clients
                                });
                            },
                            error: function (model, result) {
                                new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
                                    model: model,
                                    result: result
                                });
                            }
                        });
                    };
                terms.fetch({
                    success: function () {
                        if (_.find(terms.models, function (term) {
                            return term.get('isActive') && !term.get('isAccepted')
                        }) != null) {
                            new PJQ.views.screenings.ScreeningTermsModal({
                                collection: terms,
                                onComplete: function () {
                                    renderDashboard();
                                }
                            });
                        } else {
                            renderDashboard();
                        }
                    }
                });
            },
            isDisabled: function () {
                return true;
            }
        }),
        new PJQ.nav.NavItem({
            id: "calendar",
            title: "Calendar",
            sortOrder: 100,
            icon: "fa-calendar-alt",
            feature: "calendar",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('calendar.canView');
            },
            render: function ($el) {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_OLD_CALENDAR)) {
                    initScheduler($el);
                } else {
                    new PJQ.views.calendars.SystemCalendar({
                        el: $el
                    });
                }
            },
            isDisabled: function () {
                return PJQ.app.session.user == null;
            }
        }),
        new PJQ.nav.NavItem({
            id: "resources",
            title: "Resources",
            sortOrder: 105,
            icon: "fa-person-carry",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('resources.isAdmin');
            },
            render: function ($el) {
                new PJQ.views.resources.ResourceAllocation({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal') || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_RESOURCE_ALLOCATION);
            }
        }),
        new PJQ.nav.NavItem({
            id: "timecards",
            title: "Time Cards",
            sortOrder: 106,
            icon: "fa-user-clock",
            hasRoute: true,
            feature: "timecards",
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('timeCards.canView') || PJQ.app.session.hasPermission('timeCards.isAdmin');
            },
            render: function ($el) {
                new PJQ.views.timecards.TimeCardMain({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "invoices",
            title: "Invoices",
            sortOrder: 107,
            icon: "fa-file-invoice-dollar",
            hasRoute: true,
            feature: 'invoices',
            systemFeature: true,
            hasPermission: function () {
                // either already on, or in demo mode
                return PJQ.app.session.hasPermission('invoices.canView') || PJQ.app.session.hasPermission('invoices.isAdmin') || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INVOICES);
            },
            render: function ($el, options) {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INVOICES)) {
                    new PJQ.views.invoices.InvoicePreview({
                        el: $el
                    });
                } else {
                    new PJQ.views.invoices.Invoices(_.defaults({
                        el: $el
                    }, options));
                }
            },
            isDisabled: function () {
                return PJQ.app.session.get('onAccount');
            }
        }),
        new PJQ.nav.NavItem({
            id: "erpadmin",
            sortOrder: 108,
            title: "ERP Admin",
            icon: "fa-check-to-slot",
            feature: "erpAdmin",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('settings.canManageERPAdmin');
            },
            path: function (options) {
                if (options) {
                    return 'erpadmin/' + options.feature;
                } else {
                    return 'erpadmin';
                }
            },
            render: function ($el, options) {
                new PJQ.views.erpAdmin.ERPAdminManagement({
                    el: $el,
                    feature: options.feature
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal') || PJQ.app.session.erpIntegration == null;
            }
        }),
        new PJQ.nav.NavItem({
            id: "reports",
            sortOrder: 110,
            title: "Reports",
            icon: "fa-chart-line",
            feature: "reports",
            hasRoute: true,
            systemFeature: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('reports.canView');
            },
            render: function ($el) {
                PJQ.app.ReportView = new PJQ.views.reporting.NewReportView({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "settings",
            title: "Settings",
            sortOrder: 120,
            icon: "fa-cog",
            hasRoute: true,
            render: function ($el, options) {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_SETTINGS)) {
                    initSystemSettings($el);
                } else {
                    PJQ.helpers.urlHelpers.cleanRouteParams();
                    if (this.planroomSettings != null) {
                        this.planroomSettings.remove();
                    }

                    this.planroomSettings = new PJQ.views.settings.SettingsNav({
                        el: $el,
                        procoreCode: options.procoreCode,
                        subscriptionId: options.subscriptionId,
                        initView: options.initView,
                        initOptions: options
                    });
                }
            }
        }),
        new PJQ.nav.NavItem({
            id: "signout",
            title: "Sign Out",
            sortOrder: 130,
            icon: "fa-sign-out",
            hasPrecedingSeparator: true,
            route: function () {
                if (PJQ.app.options.isK8) {
                    window.location.href = "/signout";
                } else {
                    window.location.href = "/Signout.aspx";
                }
            }
        }),
        new PJQ.nav.NavItem({
            id: "resourcecenter",
            title: "Resource Center",
            sortOrder: 125,
            isAdmin: true,
            marginTop: '50px',
            iconImage: '/assets/modules2/global/images/wrench_icon.png',
            hasPermission: function () {
                return true
            },
            outsideRoute: 'https://www.panteratools.com/support/resource-center/',
            isDisabled: function () {
                return PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_RESOURCE_CENTER) || !PJQ.app.options.isPanteraApp;
            },
            includeMarkup: '<div class="d-flex justify-content-end"><div style="margin-top:-12px !important;font-weight: 400;font-size: 12px;" class="p-0 m-0 ht-20p lh-20 wd-85p">Click here for Tutorials ></div></div>'
        })
    ]),
    project: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "dashboard",
            title: "Dashboard",
            sortOrder: 10,
            icon: "fa-tachometer-alt-fast",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/dashboard';
            },
            render: function ($el, options) {
                new PJQ.views.projects.ProjectDashboard(_.defaults({
                    el: $el,
                    model: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                if (PJQ.app.session.project) {
                    return PJQ.app.session.project.get('status') === 'ARCHIVE'
                        || PJQ.app.session.project.get('status') === 'NEW';
                }
            }
        }),
        new PJQ.nav.NavItem({
            id: "details",
            title: "Project Details",
            sortOrder: 20,
            icon: "fad fa-asterisk",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/details';
            },
            render: function ($el, options) {
                this.projectDetails = new PJQ.views.projects.ProjectDetails(_.defaults({
                    el: $el,
                    model: PJQ.app.session.project
                }, options));
            },
            leaveView: function () {
                if (this.projectDetails != null) {
                    this.projectDetails.cancelEdit();
                }
            },
            hasPermission: function () {
                let proj = PJQ.app.session.project;
                return !proj.get('isDetailsAdminOnly') || (proj.get('masterUserId') === PJQ.app.session.get('masterUserId'));
            }
        }),
        new PJQ.nav.NavItem({
            id: "locations",
            title: "Locations",
            sortOrder: 25,
            icon: "fa-map-pin",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/locations';
            },
            render: function ($el, options) {
                new PJQ.views.projects.LocationManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('base.canEdit');
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "mall",
            title: "Mall",
            sortOrder: 20,
            isAdmin: true,
            icon: "fa-building",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/mall';
            },
            render: function ($el, options) {
                let loader = new PJQ.Loader($el);
                PJQ.nav.getDataForOldProjectModules(function () {
                    window.pjqIsNewProjContainer = true;
                    if (loader != null) {
                        loader.remove();
                    }
                    $el.html('<div><button type="button" id="project-save" onclick="SaveProjContainer()" class="btn btn-primary mb-2">Save Changes</button><div id="project-container-home"></div></div>');
                    PanteraScript.PanteraScriptService.GetProjectContainerInfo(PJQ.app.session.id, ProjContainerInfoC, onScriptError);
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_CONTAINERS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "messaging",
            title: function () {
                return PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME) : "Messaging";
            },
            sortOrder: 30,
            icon: "fa-poll-people",
            category: PJQ.constants.navigation.categories.BIDDING,
            feature: "projectMessaging",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('messaging.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/messaging';
            },
            render: function ($el, options) {
                let muid = PJQ.app.session.get("masterUserId");
                PJQ.app.session.fetchCompanyCustomFields(muid, _.bind(function () {
                    PJQ.app.session.fetchContactCustomFields(muid, _.bind(function () {
                        PJQ.app.session.fetchProjectMessageEmailTemplates(_.bind(function () {
                            new PJQ.views.projects.ProjectMessaging(_.defaults({
                                el: $el,
                                project: PJQ.app.session.project,
                                copyProjectMessageId: options.copyProjectMessageId
                            }, options));
                        }, this));
                    }, this));
                }, this));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "privatemessaging",
            title: "Private Messages",
            sortOrder: 40,
            icon: "fa-comments-alt",
            feature: "privateMessaging",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('privateMessaging.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/privatemessaging';
            },
            render: function ($el, options) {
                new PJQ.views.projects.UserMessages({
                    el: $el,
                    project: PJQ.app.session.project,
                    userMessageId: options.viewUserMessageId,
                    view: options.view ? options.view : 'inbox'
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || (PJQ.app.session.user === null && PJQ.app.session.contact === null)
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PRIVATE_MESSAGES);
            }
        }),
        new PJQ.nav.NavItem({
            id: "bidforms",
            title: "Bid Forms",
            sortOrder: 50,
            category: PJQ.constants.navigation.categories.BIDDING,
            icon: "fa-file-invoice-dollar",
            feature: "bidForms",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && PJQ.app.session.project.hasPermission('bidForms.canView');
            },
            path: function (options) {
                if (options && options.groupId > 0) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/bidforms/' + options.groupId.toString();
                }
                return 'projects/' + PJQ.app.session.project.id.toString() + '/bidforms';
            },
            render: function ($el, options) {
                PJQ.app.BidFormEditor = new PJQ.views.bidForms.BidFormEditorSelector(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project,
                    collection: new PJQ.collections.bidForms.GroupBidForms([]),
                    initProposalId: options.proposalId,
                    initGroupId: options.groupId
                }, options));
            },
            isDisabled: function () {
                let hasPref = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS)
                    || PJQ.app.session.isPanteraPortal();
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW' || !hasPref || !PJQ.app.session.project.get('featureSettings').isBidFormsEnabled;
            }
        }),
        new PJQ.nav.NavItem({
            id: "proposals",
            title: "Proposals",
            sortOrder: 60,
            category: PJQ.constants.navigation.categories.BIDDING,
            icon: "fa-file-invoice-dollar",
            isAdmin: false,
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/proposals';
            },
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('bidForms.canView');
            },
            render: function ($el, options) {
                new PJQ.views.bidForms.ProposalSelector({
                    el: $el,
                    model: new PJQ.models.bidForms.Bidder({
                        contactId: PJQ.app.session.contact.id
                    })
                });
            },
            isDisabled: function () {
                if (PJQ.app.session.contact == null)
                    return true;

                let itemPref = this.getNavPref();
                if (itemPref != null && itemPref.isDisabled != null) {
                    return itemPref.isDisabled;
                }

                let hasPref = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS)
                    || (PJQ.app.session.isPanteraPortal() && PJQ.app.session.project.get('portalId') === 4);
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !hasPref
                    || !PJQ.app.session.project.get('featureSettings').isBidFormsEnabled
                    || PJQ.app.session.contact == null;
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectcontacts",
            title: "Project Contacts",
            sortOrder: 70,
            icon: "fa-users-class",
            isAdmin: true,
            hasRoute: true,
            isPrimaryProjectManagerCheckExempt: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('projectContacts.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/contacts';
            },
            render: function ($el, options) {
                PJQ.app.projectContactsManagement = new PJQ.views.projectContacts.ProjectContactsManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_CONTACTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "drawings",
            title: "Drawings",
            sortOrder: 90,
            icon: "fa-ruler",
            feature: "drawings",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('drawings.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/drawings';
            },
            render: function ($el, options) {
                new PJQ.views.drawings.Dashboard({
                    el: $el,
                    project: PJQ.app.session.project,
                    isReadOnly: PJQ.app.session.project.get('status') === 'ARCHIVE',
                    initOptions: options
                });
            },
            isDisabled: function () {
                let proj = PJQ.app.session.project;
                return proj.get('status') === 'NEW'
                    || proj.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS)
                    || (!proj.get('hasDrawings') && (PJQ.app.session.user == null || proj.get('masterUserId') !== PJQ.app.session.user.get('masterUserId')));
            }
        }),
        new PJQ.nav.NavItem({
            id: "crews",
            title: "Crews & Equipment",
            sortOrder: 95,
            icon: "fa-person-digging",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                // return true;
                return PJQ.app.session.project.hasPermission('timeCards.canManageEquipment') || PJQ.app.session.project.hasPermission('timeCards.canManageCrews');
            },
            path: function (options) {
                if(options?.view === 'equipment' || !PJQ.app.session.project.hasPermission('timeCards.canManageCrews')){
                    if(options == null){
                        options = {};
                    }

                    options.view = 'equipment';
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/equipment';
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/crews';
                }
            },
            render: function ($el, options) {
                new PJQ.views.timecards.CrewsAndEquipmentDashboard({
                    el: $el,
                    project: PJQ.app.session.project,
                    view: options?.view
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
            }
        }),
        new PJQ.nav.NavItem({
            id: "attachments",
            title: "Attachments",
            sortOrder: 100,
            icon: "fa-paperclip",
            feature: "projectAttachments",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('attachments.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/attachments';
            },
            render: function ($el) {
                new PJQ.views.projects.Attachments({
                    el: $el,
                    expandSharedFolders: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ROOT_SHARED_FOLDERS),
                    project: PJQ.app.session.project,
                    isReadOnly: PJQ.app.session.project.get('status') === 'ARCHIVE'
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'NEW' ||
                    PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_ATTACHMENTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectphotos",
            title: "Photo Gallery",
            sortOrder: 110,
            icon: "fa-images",
            feature: "projectPhotos",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('photoGallery.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/photos';
            },
            render: function ($el, options) {
                PJQ.app.ProjectPhotoGallery = new PJQ.views.photos.PhotoGallery(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PHOTOS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "meetings",
            title: "Meetings",
            sortOrder: 108,
            icon: "fa-people-group",
            feature: "meetings",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('meetings.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/meetings';
            },
            render: function ($el, options) {
                new PJQ.views.meetings.MeetingsList({
                    el: $el,
                    project: PJQ.app.session.project,
                    meetingId: options.meetingId
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectschedule",
            title: "Schedule",
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            sortOrder: 105,
            icon: "fad fa-tasks-alt",
            feature: "schedule",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('schedule.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/schedule';
            },
            render: function ($el, options) {
                new PJQ.views.schedule.ScheduleDashboard({
                    el: $el,
                    project: PJQ.app.session.project,
                    model: options.model,
                    initTaskId: options.taskId,
                    initLookAheadId: options.lookAheadId,
                    shareKey: options.shareKey
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW' ||
                    PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SCHEDULING);
            }
        }),
        new PJQ.nav.NavItem({
            id: "rfi",
            title: "RFI",
            sortOrder: 120,
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            icon: "fa-question",
            feature: "rfi",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('rfi.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/rfi';
            },
            render: function ($el, options) {
                PJQ.app.session.project.fetchRFISettings(_.bind(function (settings) {
                    PJQ.app.RFIManagement = new PJQ.views.rfi.RFIManagement(_.defaults({
                        el: $el,
                        settings: settings,
                        project: PJQ.app.session.project
                    }, options));
                }, this));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_RFI)
                    || (PJQ.app.session.user === null && PJQ.app.session.contact === null);
            }
        }),
        new PJQ.nav.NavItem({
            id: "submittals",
            title: "Submittals",
            sortOrder: 130,
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            icon: "fa-conveyor-belt-alt",
            feature: "submittals",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('submittals.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/submittals';
            },
            render: function ($el, options) {
                new PJQ.views.submittals.SubmittalsView({
                    el: $el,
                    project: PJQ.app.session.project,
                    initSubmittalId: options.submittalId
                });
            },
            isDisabled: function () {
                let hasPref = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SUBMITTALS) || PJQ.app.session.isPanteraPortal();
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW' || !hasPref;
            }
        }),
        new PJQ.nav.NavItem({
            id: "dailyreports",
            title: "Daily Reports",
            sortOrder: 140,
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            icon: "fa-calendar-day",
            feature: "dailyReports",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('dailyReports.canView');
            },
            path: function (options) {
                let url = 'projects/' + PJQ.app.session.project.id + '/dailyreports';
                if (options != null && options.date != null && options.tab != null) {
                    url += '/' + PJQ.helpers.dateHelpers.getDateString(options.date, PJQ.helpers.dateHelpers.dateFormats.URL_DATE) + '/' + options.tab;
                } else if (options != null && options.date != null) {
                    url += '/' + PJQ.helpers.dateHelpers.getDateString(options.date, PJQ.helpers.dateHelpers.dateFormats.URL_DATE);
                }
                return url;
            },
            render: function ($el, options) {
                PJQ.app.DailyReportsManagement = new PJQ.views.dailyReports.DailyReportsNavigator(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DAILY_REPORTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "timecardsProject",
            title: "Time Cards",
            sortOrder: 144,
            icon: "fa-user-clock",
            feature: "timecards",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('timeCards.canView') || PJQ.app.session.project.hasPermission('timeCards.canViewAll');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/timecards';
            },
            render: function ($el) {
                let contact = null;
                if ((PJQ.app.session.contact === null && PJQ.app.session.hasPermission('timeCards.canView')) || PJQ.app.session.project.hasPermission('timeCards.canViewAll'))
                    contact = null;
                else if (PJQ.app.session.project.hasPermission('timeCards.canView'))
                    contact = PJQ.app.session.user;
                else
                    contact = PJQ.app.session.contact;

                new PJQ.views.timecards.TimeCardMain({
                    el: $el,
                    project: PJQ.app.session.project,
                    contact: contact
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "punchlists",
            title: "Punch List",
            sortOrder: 150,
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            icon: "fa-clipboard-check",
            feature: "punchList",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('punchList.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/punchlists';
            },
            render: function ($el, options) {
                PJQ.app.PunchlistView = new PJQ.views.punchlists.PunchlistView(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                let hasPref = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PUNCH_LISTS)
                    || PJQ.app.session.isPanteraPortal();
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW' || !hasPref;
            }
        }),
        new PJQ.nav.NavItem({
            id: "actionitems",
            title: "Action Items",
            sortOrder: 150,
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            icon: "fa-circle-exclamation-check",
            feature: "actionItems",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('actionItems.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/actionitems';
            },
            render: function ($el, options) {
                PJQ.app.ActionItemsView = new PJQ.views.actionItems.ActionItemView(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                let hasPref = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ACTION_ITEMS) || PJQ.app.session.isPanteraPortal();
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW' || !hasPref;
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectreports",
            title: "Reports",
            sortOrder: 160,
            icon: "fa-chart-pie",
            feature: "projectReports",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('reports.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/reports';
            },
            render: function ($el, options) {
                PJQ.app.ReportView = new PJQ.views.reporting.NewReportView({
                    el: $el,
                    project: PJQ.app.session.project
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
            }
        }),
        new PJQ.nav.NavItem({
            id: "rsvpautoreport",
            title: function () {
                let result = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_RSVP_AUTO_REPORT);
                if (result.indexOf('|') !== -1)
                    result = result.substring(0, result.indexOf('|'));
                return result;
            },
            sortOrder: 165,
            icon: "fa-info",
            isAdmin: false,
            route: function () {
                let options = {};
                new PJQ.views.projects.AutoReport(_.defaults({
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_RSVP_AUTO_REPORT);
            }
        }),
        new PJQ.nav.NavItem({
            id: "costcodes",
            title: "Cost Codes",
            sortOrder: 175,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-money-check-dollar",
            feature: "budget",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('budget.isAdmin') && PJQ.app.session.user != null;
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/costcodes';
            },
            render: function ($el, options) {
                this.costCodeSettings = new PJQ.views.budget.ProjectCostCodeSettings({
                    el: $el,
                    project: PJQ.app.session.project
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "budget",
            title: "Budget",
            sortOrder: 180,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-clipboard-check",
            feature: "budget",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('budget.canView') && PJQ.app.session.user != null;
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/budget';
            },
            render: function ($el, options) {
                PJQ.app.BudgetView = new PJQ.views.budget.ProjectBudget(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "primecontracts",
            title: "Contracts",
            sortOrder: 182,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-signature",
            feature: "primecontracts",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('primeContracts.canView') && PJQ.app.session.user != null;
            },
            path: function (options) {
                if (options) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/contracts/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/contracts';
                }
            },
            render: function ($el, options) {
                new PJQ.views.primeContracts.PrimeContractManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "commitments",
            title: "Commitments",
            sortOrder: 190,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-money-bill",
            feature: "commitments",
            hasRoute: true,
            requireSignUp: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('commitments.canView') && PJQ.app.session.user != null;
            },
            path: function (options) {
                if (options) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/commitments/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/commitments';
                }
            },
            render: function ($el, options) {
                new PJQ.views.commitments.CommitmentManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "changerequests",
            title: "Change Requests",
            sortOrder: 192,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-money-bill-transfer",
            feature: "changerequests",
            hasRoute: true,
            requireSignUp: true,
            hasPermission: function () {
                return PJQ.app.session.user != null
                    && (PJQ.app.session.project.hasPermission('changeRequests.canView') || PJQ.app.session.project.hasPermission('changeRequests.canViewRFQs'));
            },
            path: function (options) {
                if (options && options.view) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/changerequests/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/changerequests';
                }
            },
            render: function ($el, options) {
                new PJQ.views.changeRequests.ChangeRequestManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "directcosts",
            title: "Direct Costs",
            sortOrder: 195,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-envelope-open-dollar",
            feature: "directcosts",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('directCosts.canView') && PJQ.app.session.user != null;
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/directcosts';
            },
            render: function ($el, options) {
                new PJQ.views.directcosts.ProjectDirectCosts(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "invoicing",
            title: "Invoicing",
            sortOrder: 200,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-file-invoice-dollar",
            feature: "invoicing",
            hasRoute: true,
            hasPermission: function () {
                return (PJQ.app.session.project.hasPermission('payableInvoices.isAdmin') || PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin')) && PJQ.app.session.user != null;
            },
            path: function (options) {
                if (options) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/invoicing/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/invoicing';
                }
            },
            render: function ($el, options) {
                new PJQ.views.invoicing.InvoicingManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "productionquantities",
            title: "Production Quantities",
            sortOrder: 205,
            category: PJQ.constants.navigation.categories.JOB_COSTING,
            icon: "fa-boxes-stacked",
            feature: "productionquantities",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('productionQuantities.canView') && PJQ.app.session.user != null;
            },
            path: function (options) {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/productionquantities';
            },
            render: function ($el, options) {
                new PJQ.views.productionQuantities.ProductionQuantitiesList(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "inspections",
            title: "Inspections",
            sortOrder: 205,
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            icon: "fa-list-check",
            feature: "inspections",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('inspections.canView') && PJQ.app.session.user != null;
            },
            path: function (options) {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/inspections';
            },
            render: function ($el, options) {
                new PJQ.views.inspections.InspectionsList(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        })
    ], {
        hasHeader: true
    }),
    nonAdminExtras: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "cloneproject",
            title: "Clone Project",
            sortOrder: 300,
            icon: "fa-clone",
            isAdmin: false,
            hasPrecedingSeparator: true,
            route: function () {
                let cloneModal = new PJQ.views.modals.YesNo({
                    header: "Clone Project",
                    body: "Are you sure you want to clone this into your projects?",
                    onYes: function () {
                        new PJQ.Loader(cloneModal.$('.modal-content'));
                        PJQ.app.session.project.clone(function (newProject) {
                            cloneModal.remove();
                            PJQ.modules.projectWall.initProjectNavigator(newProject.id, "dashboard");
                            PJQ.notifications.notify.successNotify({
                                message: 'Project cloned successfully'
                            });
                        });
                    }
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.isLoggedIn() || !PJQ.app.session.get('ownsPortal') || PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');
            }
        }),
        new PJQ.nav.NavItem({
            id: "followproject",
            title: "Follow Project",
            sortOrder: 310,
            icon: "fa-bell",
            isAdmin: false,
            hasPrecedingSeparator: true,
            route: function () {
                new PJQ.views.contacts.BaseEditContactModal({
                    model: new PJQ.models.projectContacts.ProjectContact({
                        id: PJQ.app.session.contact.id,
                        projectId: PJQ.app.session.project.id
                    }),
                    alert: "Please review and update your contact details before registering your account",
                    onSave: function () {
                        new PJQ.views.auth.AuthModal({
                            contactId: PJQ.app.session.contact.id,
                            mode: PJQ.app.session.contact.get('userId') > 0 ? 'SIGN_IN' : 'SIGN_UP',
                            isShowCloseButton: true
                        });
                    }
                });
            },
            isDisabled: function () {
                return PJQ.app.session.isLoggedIn() || PJQ.app.session.contact == null;
            }
        })
    ]),
    adminExtras: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "copyproject",
            title: "Copy Project",
            sortOrder: 320,
            icon: "fa-clone",
            isAdmin: true,
            hasPrecedingSeparator: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('base.canCopy');
            },
            route: function () {
                let copyModal = new PJQ.views.modals.YesNo({
                    header: "Copy Project",
                    body: "Are you sure you want to copy this project?",
                    onYes: function () {
                        new PJQ.Loader(copyModal.$('.modal-content'));
                        PJQ.app.session.project.copy(function (newProject) {
                            copyModal.remove();
                            PJQ.modules.projectWall.initProjectNavigator(newProject.id, "dashboard");
                            PJQ.notifications.notify.successNotify({
                                message: 'Project copied successfully'
                            });
                        });
                    }
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_COPY_PROJECT);
            }
        }),
        new PJQ.nav.NavItem({
            id: "orderprints",
            title: "Order Prints",
            sortOrder: 325,
            icon: 'fa-shopping-cart',
            isAdmin: true,
            hasPermission: function () {
                return true;
            },
            route: function () {
                new PJQ.views.files.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.ALT_PRINT,
                    project: PJQ.app.session.project
                })
            },
            isDisabled: function () {
                return !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PLAN_EXPRESS_PORTAL);
            }
        }),
        new PJQ.nav.NavItem({
            id: "bluebookpublish",
            title: "Message The Blue Book",
            sortOrder: 325,
            isAdmin: true,
            iconImage: PJQ.app.options.isK8 ? '/assets/images/global/thebluebook.png' : '/assets/modules2/global/images/thebluebook.png',
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('messaging.canManage');
            },
            route: function () {
                new PJQ.views.projects.BlueBookPublishModal({
                    project: PJQ.app.session.project
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BLUE_BOOK_PUBLISH) &&
                        (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_BLUE_BOOK_PUBLISH)
                            || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_BLUE_BOOK_PUBLISH_PORTAL)));
            },
            extraMarkup: '<li class="nav-item"><div class="d-flex justify-content-end"><a style="margin-top:-8px !important;font-weight: 400;font-size: 14px;" class="nav-button-label nav-link p-0 m-0 mr-4 ht-20p lh-20 wd-85p" target="_blank" href="https://www.panteratools.com/the-blue-book-network/">See Details ></a></div></li>'
        }),
        new PJQ.nav.NavItem({
            id: "procorepublish",
            title: "Publish to Procore",
            sortOrder: 330,
            isAdmin: true,
            iconImage: '/assets/modules2/global/images/procore.png',
            route: function () {
                let loader = new PJQ.Loader($('div.nav-body'));
                new PJQ.ajax.Request({
                    endpoint: '/procore/settings/-1'
                }).get().done(_.bind(function (response) {
                    if (loader != null) {
                        loader.remove();
                    }
                    new PJQ.views.projects.ProcorePublishModal({
                        settings: response
                    });
                }, this)).fail(_.bind(function (xhr, err, result) {

                }, this));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_CLIENT_ID)
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN)
                    || _.size(PJQ.app.session.project.get('externalProjectId')) > 0
                    || !PJQ.app.options.isPanteraApp;
            }
        }),
        new PJQ.nav.NavItem({
            id: "procoreview",
            title: "View in Procore",
            sortOrder: 340,
            isAdmin: true,
            iconImage: '/assets/modules2/global/images/procore.png',
            route: function () {
                let data = PJQ.app.session.project.get('externalProjectId').substring(8);
                new PJQ.views.BaseModal({
                    header: "Procore Project",
                    body: '<a href="https://api.procore.com/' + data + '/project/home" target="_blank">Click here</a> to open your Procore project in a new window.'
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_CLIENT_ID)
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN)
                    || (_.size(PJQ.app.session.project.get('externalProjectId')) === 0 || !PJQ.app.session.project.get('externalProjectId').startsWith('PROCORE:'))
                    || !PJQ.app.options.isPanteraApp;
            }
        })
    ])
};

PJQ.views.nav = {};
PJQ.views.nav.AppNavigator = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Navigator'),
        subTemplates: {
            commands: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Navigator-Commands'),
            projectCommands: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'app-navigator-project-commands'),
            signUpMessage: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'app-navigator-sign-up-message')
        },
        itemGroups: [],
        isAdmin: true
    },
    events: {
        'click .nav-link': 'navigate',
        'click .project-nav-link': 'navigate',
        'click .btn-to-top': 'backToTop',
        'click .btn-start-tour': 'startTour',
        'click .active-feature': 'expandProjectNav'
    },
    beforeInit: function () {
        if (PJQ.app.options.isNavExpanded == null) {
            PJQ.app.options.isNavExpanded = window.innerWidth > 768;
        }
        this.$el.off();
    },
    expandNav: function (e) {
        let $nav = this.$('.app-navigator');
        $nav.toggleClass('expanded');
        PJQ.app.options.isNavExpanded = $nav.hasClass('expanded');
    },
    beforeFirstRender: function () {
        this.renderHeaderNavExpandButton();
        this.renderHeaderSubscription();
    },
    expandProjectNav: function () {
        let $projectNav = this.$('.nav-project-container'),
            windowWidth = $(window).width(),
            windowHeight = $(window).height();
        if ($projectNav.height() > 50) {
            // if you set the height to 50, it sets it to 51. I don't know why
            $projectNav.height(49);
            this.$('.expand-display').attr('hidden', true);
        } else {
            this.$('.expand-display').attr('hidden', false);
            if (windowWidth >= 992) {
                $projectNav.height(550);
            } else {
                $projectNav.height(windowHeight);
            }
        }

        $(document).on('click', _.bind(function (event) {
            if (!$(event.target).closest('.nav-project-container').length) {
                this.$('.expand-display').attr('hidden', true);
                $projectNav.height(49); // set height of #projectNav to 50 pixels
            }
        }, this));
    },
    renderHeaderNavExpandButton: function () {
        let $header = $('.skin-header');
        if (_.size($header) > 0 && _.size($('.btn-expand-nav')) === 0) {
            let bgColor = $header.css('background-color'),
                btnColor = _.size(bgColor) > 0 ? PJQ.helpers.colorHelpers.idealLinkColorForBackground(PJQ.helpers.colorHelpers.getHexFromRGB(bgColor)) : '#fff',
                $expand = $('<i style="color:' + btnColor + ';" class="fad fa-bars btn-expand-nav fa-2x ml-3"></i>');
            $header.prepend($expand);
            $expand.on('click', _.bind(this.expandNav, this));
        }
    },
    renderHeaderSubscription: function () {
        if (PJQ.app.session.user != null && !PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            $('.subscription-name').remove();
            $('.start-tour').remove();

            let $header = $('.skin-header'),
                showTrial = PJQ.app.session.subscription.get('isFreeTrial') && (PJQ.app.session.subscription.newSubscription != null && PJQ.app.session.subscription.newSubscription.id === PJQ.constants.subscriptions.types.FREE),
                $subscription = $('<span class="fs-14 subscription-name"> ' + PJQ.helpers.formatHelpers.upperCaseFirstLetterEachWord(PJQ.app.session.subscription.get('name').toLowerCase()) + (showTrial ? ' Trial' : '') + '</span>');
            $header.append($subscription);
            if (showTrial) {
                let days = PJQ.helpers.dateHelpers.getDateDiff(new Date(PJQ.app.session.subscription.get('trialExpiresOn')), new Date(), 'days') + 1;
                let $daysRemaining = $('<span class="fs-12"> (' + days.toString() + 'd remaining)</span>')
                $subscription.append($daysRemaining)
            }
            if (PJQ.app.session.user.get('tourDone') && !PJQ.app.session.get('onAccount') && PJQ.app.session.subscription.get('subscriptionId') > 1) {
                let $startTourButton = $('<div class="start-tour" style="position: absolute; right: 0; margin-right: 20px;"><button type="button" class="btn btn-link text-light btn-start-tour">Start Tour</button></div>');
                $header.append($startTourButton);
                $('.btn-start-tour').on('click', _.bind(function () {
                    this.startTour();
                }, this))
            }
        }
    },
    beforeRender: function () {
        if (this.options.activeItem != null) {
            let mainItem = PJQ.nav.itemGroups.main == null ? null : _.findWhere(PJQ.nav.itemGroups.main.items, {id: this.options.activeItem});
            if (mainItem != null) {
                // if they are navigating to a main nav item, they will never have a project
                // so we make sure its null
                PJQ.app.session.project = null;
            }
        } else {
            // there isn't an active item provided, default to the first enabled main item
            let defActiveItem = _.find(PJQ.nav.itemGroups.main.items, function (item) {
                return !item.getIsDisabled() && item.hasPermission() && item.hasFeature();
            });
            if (defActiveItem != null) {
                this.options.activeItem = defActiveItem.id;
            }
        }

        this.user = PJQ.app.session.user;
        this.project = PJQ.app.session.project;
    },
    renderData: function () {
        return {
            project: this.project,
            context: this.options.context,
            isExpanded: PJQ.app.options.isNavExpanded
        };
    },
    afterRender: function () {
        //remove dhtml tooltips for calendar (temporary until old calendar is phased out)
        $('.dhtmlXTooltip').remove();

        this.determineCommands();
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_TOP_OF_PAGE_BUTTON)) {
            $('.scroll-to-top').append('<a id="btntotop" class="btn-to-top" style="display: none;">\n' +
                '<span class="fas fa-chevron-up"></span>\n' +
                '</a>');
            this.$('div.nav-content').on('scroll', _.bind(function () {
                if (this.$('div.nav-content')[0].scrollTop > 100) {
                    $('.btn-to-top').fadeIn(300);

                } else {
                    $('.btn-to-top').fadeOut(300);
                }
            }, this));
        }

        this.setActiveItem(this.options.activeItem);
        this.options.activeItem = null;

        this.renderCommands();
        this.renderHeader();
        this.renderActiveItem(false);

        if (PJQ.app.session.user != null && !PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            let trialCookie = PJQ.constants.cookies.SUBSCRIPTION_FREE_TRIAL + "-" + PJQ.app.session.user.id.toString();
            if (PJQ.app.session.subscription.get('trialExpiresOn') == null && !PJQ.helpers.cookieHelpers.getCookie(trialCookie)) {
                new PJQ.views.subscriptions.EditSubscriptionModal({
                    onSave: _.bind(function (type) {
                        PJQ.helpers.tours.initTour();
                    }, this),
                    onDecline: function () {
                        PJQ.helpers.cookieHelpers.setCookie(trialCookie, true, 14);
                    }
                });
            } else if (!this.options.preventTour && !PJQ.app.navInit && !PJQ.app.session.user.get('tourDone') && PJQ.app.session.subscription.get('subscriptionId') > 1) {
                PJQ.app.navInit = true;
                PJQ.helpers.tours.initTour();
            }

            let expireCookie = PJQ.constants.cookies.SUBSCRIPTION_EXPIRES_ALERT + "-" + PJQ.app.session.user.id.toString();
            if (PJQ.app.session.subscription.newSubscription != null && !PJQ.helpers.cookieHelpers.getCookie(expireCookie)) {
                let expiresOnDays = PJQ.helpers.dateHelpers.getDateDiff(new Date(PJQ.app.session.subscription.get('expiresOn')), new Date(), 'days') + 1;
                if (expiresOnDays <= 15 && expiresOnDays > 0) {
                    let expirationText,
                        isDowngrade = PJQ.app.session.subscription.newSubscription.id !== PJQ.constants.subscriptions.types.FREE;
                    if (isDowngrade) {
                        // its a paid downgrade
                        expirationText = "Your current plan will be downgraded in " + expiresOnDays.toString() + (expiresOnDays === 1 ? " day" : " days") + ".  Upgrade your account to keep your current features!  <a class='btn-change-sub no-trial' href='#settings'>Upgrade Now</a>";
                    } else {
                        // its a downgrade to a free account
                        let isFreeTrial = PJQ.app.session.subscription.get('isFreeTrial');
                        expirationText = "Your " + (isFreeTrial ? "free trial" : "current plan") + " will expire in " + expiresOnDays.toString() + (expiresOnDays === 1 ? " day" : " days") + ".  Upgrade your account to keep your project progress!  <a class='btn-change-sub no-trial' href='#settings'>Upgrade Now</a>";
                    }
                    new PJQ.Alert(this.$('.nav-content'), {
                        type: "sub-expiration",
                        text: expirationText,
                        isPrepend: true,
                        cookie: expireCookie,
                        cookieExpirationDays: expiresOnDays === 1 ? 1 : expiresOnDays / (isDowngrade ? 1.5 : 2) //show this alert every half time (shows more as it gets closer to expiration)
                    });
                }
            }
        }
    },
    startTour: function () {
        new PJQ.views.tours.SubscriptionTourIntro();
    },
    determineCommands: function () {
        if (this.project != null) {
            this.projectMenuItems = [];
            this.projectMenuItems.push(...PJQ.nav.itemGroups.project.items);

            if (this.project.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
                this.projectMenuItems.push(...PJQ.nav.itemGroups.adminExtras.items);
            } else {
                if (this.project.userMessageTypes != null) {
                    let userTypeId = PJQ.app.session.contact ? PJQ.app.session.contact.get('userTypeId') : (PJQ.app.session.user ? PJQ.app.session.user.get('userTypeId') : null),
                        actionItems = _.filter(this.project.userMessageTypes.models, function (item) {
                            return _.size(item.get('actionButtonText')) > 0 && item.get('userMessageType').toLowerCase() !== 'bid submittal' && (!item.get('userTypeId') || item.get('userTypeId') === userTypeId);
                        });

                    let sortOrder = 300;
                    _.each(actionItems, function (item, index) {
                        let menuItem = new PJQ.nav.NavItem({
                            id: 'msg_' + item.id.toString(),
                            title: item.get('actionButtonText'),
                            sortOrder: sortOrder,
                            icon: "fa-clone",
                            isAdmin: false,
                            hasPrecedingSeparator: index === 0,
                            route: _.bind(function () {
                                new PJQ.views.projects.UserMessageModal({
                                    project: this.project,
                                    userMessageTypeId: item.id
                                });
                            }, this)
                        });
                        this.projectMenuItems.push(menuItem);

                        sortOrder = sortOrder + 10;
                    }, this);
                }
                this.projectMenuItems.push(...PJQ.nav.itemGroups.nonAdminExtras.items);
            }
        }
    },
    refreshCommands: function () {
        this.determineCommands();
        this.renderCommands();
    },
    renderCommands: function () {
        this.renderSubTemplate(false, this.options.subTemplates.commands, this.$('.nav-commands-container'), {
            project: this.project,
            projectMenuItems: this.projectMenuItems,
            activeItem: this.activeItem,
            context: this.options.context ? this.options.context : ""
        });

        if (PJQ.app.options.isV2UI) {
            this.renderSubTemplate(false, this.options.subTemplates.projectCommands, this.$('.nav-project-commands-container'), {
                project: this.project,
                projectMenuItems: this.projectMenuItems,
                activeItem: this.activeItem,
                context: this.options.context ? this.options.context : ""
            });
        }
    },
    setActiveItem: function (id) {
        let result = PJQ.nav.itemGroups.main == null ? null : _.findWhere(PJQ.nav.itemGroups.main.items, {id: id});
        if (result != null) {
            PJQ.app.session.project = null;
            this.project = null;
            if (result.hasRoute) {
                this.activeItem = result;
            }
        } else if (this.project != null) {
            result = _.findWhere(this.projectMenuItems, {id: id});
            if (result != null) {
                if (result.hasRoute) {
                    this.activeItem = result;
                }
            }
        } else {
            this.activeItem = null;
        }

        // they tried to navigate to a disabled active item
        if (PJQ.app.session.project) {
            if (this.activeItem == null || this.activeItem.getIsDisabled()) {
                if (this.project != null) {
                    let isProjectAdmin = PJQ.app.session.get('masterUserId') === this.project.get('masterUserId');
                    this.activeItem = _.find(PJQ.nav.itemGroups.project.items, function (item) {
                        return item.hasFeature() && item.hasPermission() && !item.getIsDisabled() && (item.getIsAdmin() == null || isProjectAdmin === item.getIsAdmin());
                    });
                } else {
                    this.activeItem = _.find(PJQ.nav.itemGroups.main.items, function (item) {
                        return item.hasFeature() && item.hasPermission() && !item.getIsDisabled();
                    });
                }
            }
        }

        return result;
    },
    renderHeader: function () {
        if (this.user != null) {
            this.userHeader = new PJQ.views.nav.UserHeader({
                el: this.$('.app-nav-user-header'),
                model: this.user
            });
        } else if (this.userHeader != null) {
            this.userHeader.remove();
        }

        if (this.project != null) {
            this.projectHeader = new PJQ.views.nav.ProjectHeader({
                el: this.$('.app-nav-project-header'),
                model: this.project
            });
        } else if (this.projectHeader != null) {
            this.projectHeader.remove();
        }
    },
    renderActiveItem: function (triggerRoute) {
        let $navBody = this.$('.nav-body');
        if (this.activeItem != null) {
            if (this.activeItem.route(this.options.viewOptions, triggerRoute, $navBody) === false) {
                return;
            }

            if (this.activeItem.id === 'dashboard') {
                $navBody.addClass('module-content-gray');
            } else {
                $navBody.removeClass('module-content-gray');
            }

            // if (this.activeItem.requireSignUp) {
            //     this.renderSignUpMessage($navBody);
            // } else {
            //     this.activeItem.render($navBody, this.options.viewOptions != null ? this.options.viewOptions : {});
            // }

            this.activeItem.render($navBody, this.options.viewOptions != null ? this.options.viewOptions : {});

            if (this.project != null && PJQ.app.session.get('masterUserId') === this.project.get('masterUserId') && this.activeItem.isPrimaryProjectManagerCheckExempt !== true && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_PRIMARY_PROJECT_MANAGER_REQUIRED) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
                let fnPMR = _.bind(function () {
                    // fetch project contacts
                    PJQ.app.session.project.fetchProjectContacts(_.bind(function () {
                        let primaryPM = null;
                        _.each(PJQ.app.session.project.projectContacts.models, _.bind(function (projectContact) {
                            if (projectContact.get('isPrimary')) {
                                _.each(PJQ.app.session.userTypes.models, _.bind(function (userType) {
                                    // see if userType is a PM
                                    if (userType.get('userTypeId') === projectContact.get('userTypeId') && userType.get('isProjectManager'))
                                        primaryPM = projectContact;
                                }, this));
                            }
                        }, this));

                        if (!primaryPM) {
                            new PJQ.views.BaseModal({
                                header: "Primary Project Manager Required",
                                body: 'Please add or select a Primary Project Manager in the Project Contacts list.',
                                isShowCancelButton: false,
                                onOk: _.bind(function () {
                                    PJQ.app.router.navigate('projects/' + PJQ.app.session.project.get('projectId') + '/contacts', {
                                        trigger: true
                                    });
                                }, this)
                            });
                        }
                    }, this));
                }, this);

                let value = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_PRIMARY_PROJECT_MANAGER_REQUIRED);
                if (value == 'true') {
                    fnPMR();
                } else {
                    let cfid = value.split('|')[0], targetValues = value.split('|')[1].split(',');
                    _.each(PJQ.app.session.project.get('customFields'), _.bind(function (fieldValue) {
                        if (parseInt(cfid) === fieldValue.id) {
                            if (targetValues.indexOf(fieldValue.value.toString()) !== -1)
                                fnPMR();
                        }
                    }, this));
                }
            }

            document.title = this.activeItem.getDocumentTitle();

            // this is here to allow for initial nav routing within it's content
            // for example, on RFI if we want to allow for /rfis/{rfiId}
            //  we don't want the initial load of the tab to route the to /rfis
            if (this.options.viewOptions != null && this.options.viewOptions.shouldDoFirstRoute === false) {
                this.options.viewOptions.shouldDoFirstRoute = null;
                return;
            }

            this.options.viewOptions = null;
        }
    },
    renderSignUpMessage: function ($el) {
        this.renderSubTemplate(false, this.options.subTemplates.signUpMessage, $el);
    },
    backToTop: function () {
        this.$('div.nav-content').animate({
            scrollTop: 0
        }, 500);
    },
    navigate: function (e) {
        if (this.activeItem.leaveView != null && typeof this.activeItem.leaveView === "function") {
            this.activeItem.leaveView();
        }
        if (this.$(e.currentTarget).hasClass('disabled'))
            return;
        let selectedItemId = this.$(e.currentTarget).data('action');
        if (_.size(selectedItemId) > 0 && (this.activeItem == null || selectedItemId !== this.activeItem.id)) {
            let activeItem = this.setActiveItem(selectedItemId);
            if (activeItem != null) {
                // only re-render the nav if this menu item actually has a render function
                // it could be an item that does some logic on route()
                if (!activeItem.hasRoute) {
                    if (typeof activeItem.route === 'function') {
                        activeItem.route();
                    } else if (typeof activeItem.render === 'function') {
                        this.render();
                    }
                }
            }
        }
    }
});

PJQ.views.nav.UserHeader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Nav-User-Header')
    },
    beforeFirstRender: function () {
        //this.listenTo(this.model, 'sync change:projectName change:address1 change:address2 change:city change:state change:zip change:isFavorite change:bidsDue', this.render);
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        }
    }
});

PJQ.views.nav.ProjectHeader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Nav-Project-Header')
    },
    events: {
        'click .btn-favorite-project': 'favoriteProject',
        'change .input-project-online': 'projectOnlineChanged',
        'click .btn-project-map': 'projectMap'
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, 'sync change:projectName change:address1 change:address2 change:city change:state change:zip change:isFavorite change:bidsDue change:isOnline', this.render);
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        }
    },
    projectMap: function () {
        new PJQ.views.projects.ProjectMapModal();
    },
    favoriteProject: function () {
        this.model.set('isFavorite', this.model.get('isFavorite') === false, {
            silent: true
        });
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.id
                },
                {
                    endpoint: 'favorite'
                }
            ], [
                {
                    parameter: 'isFavorite',
                    value: this.model.get('isFavorite')
                }
            ])
        }).put().done(_.bind(function () {
            this.render();
        }, this));
    },
    projectOnlineChanged: function () {
        let isOnline = this.$('.input-project-online').prop('checked');
        this.model.set('isOnline', isOnline);
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.id
                }
            ], [
                {
                    parameter: 'isOnline',
                    value: isOnline
                }
            ])
        }).patch().done(_.bind(function () {
            let alertMessage;
            if (isOnline) {
                alertMessage = "Project set to online";
            } else {
                alertMessage = "Project set to offline";
            }
            PJQ.notifications.notify.successNotify({
                message: alertMessage
            });
        }, this));
    }
});

PJQ.views.nav.RegisterDirectory = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'register-directory'),
    },
    events: {
        'click .btn-join-directory': 'joinDirectory'
    },
    joinDirectory: function () {
        PJQ.app.session.joinDirectory(_.bind(function () {
            if (typeof this.options.onRegister === 'function') {
                this.options.onRegister();
            }
        }, this));
    }
});

PJQ.views.modals.RegisterDirectoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-register-directory'),
    },
    beforeModalCreated: function () {
        this.options = _.defaults({
            onOk: _.bind(function () {
                PJQ.app.session.joinDirectory(_.bind(function () {
                    if (typeof this.options.onRegister === 'function') {
                        this.options.onRegister();
                    }
                    this.removeModal();
                }, this));
            }, this)
        }, this.options);
    }
});

PJQ.views.notifications = {};
PJQ.views.notifications.NotificationHistory = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Notification-History'),
        width: 1000,
        maxWidth: '90%'
    },
    events: {
        'click .btn-notification-link': 'copyNotificationLink',
        'click .btn-notification-resend': 'resendNotification'
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: '.notifications-data-table',
            data: this.collection.models,
            isHideSearch: true,
            rowId: "cid",
            order: [0, 'desc'],
            language: {
                zeroRecords: 'No notifications have been sent yet'
            },
            // RFI Notifications have extra columns for times sent and last sent, so check if the collection is RFI Notifications
            columns: this.getColumns()
        });
    },
    getColumns: function () {
        if (this.collection instanceof PJQ.collections.rfi.Notifications) {
            return [
                {
                    "data": {
                        "_": 'attributes.lastSent',
                        "display": function (row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.lastSent), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false)
                        },
                        "filter": function (row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.lastSent), "MM/dd/yyyy hh:mm:ss TT", false)
                        }
                    },
                    "title": "Last Sent",
                    "width": "150px"
                },
                {
                    "data": "",
                    "title": "Type",
                    "width": "20%",
                    "render": function (data, type, row) {
                        return row.getTypeName();
                    }
                },
                {
                    "data": "recipient",
                    "title": "Recipient",
                    "render": function (data) {
                        if (data != null) {
                            return PJQ.helpers.contacts.getContactAnchor({contact: data});
                        }
                        return "";
                    }
                },
                {
                    "data": "attributes.status",
                    "title": "Status",
                    "width": "80px"
                },
                {
                    "data": "attributes.sentCount",
                    "title": "Times Sent",
                    "width": "40px"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "100px",
                    "render": function (data, type, row) {
                        let wasResent = row.get('wasResent');

                        if (wasResent) {
                            return '<div class="text-align-right"><button type="button" title="Copy Link" data-id="' + row.id.toString() + '" class="btn btn-primary btn-notification-link wd-35p ht-30p"><i class="fal fa-link"></i></button><button type="button" title="Resend" data-id="' + row.id.toString() + '" class="btn btn-success btn-notification-resend ml-1 wd-35p ht-30p" disabled><i class="fal fa-check"></i></button></div>';
                        } else {
                            return '<div class="text-align-right"><button type="button" title="Copy Link" data-id="' + row.id.toString() + '" class="btn btn-primary btn-notification-link wd-35p ht-30p"><i class="fal fa-link"></i></button><button type="button" title="Resend" data-id="' + row.id.toString() + '" class="btn btn-share btn-notification-resend ml-1 wd-35p ht-30p"><i class="fal fa-share"></i></button></div>';
                        }
                    }
                }
            ];
        }

        let cols = [
            {
                "data": {
                    "_": 'attributes.createdOn',
                    "display": function (row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.createdOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false)
                    },
                    "filter": function (row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.createdOn), "MM/dd/yyyy hh:mm:ss TT", false)
                    }
                },
                "title": "Sent",
                "width": "150px",
                // "render": function (data) {
                // 	return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                // }
            },
            {
                "data": "",
                "title": "Type",
                "width": "20%",
                "render": function (data, type, row) {
                    return row.getTypeName();
                }
            },
            {
                "data": "recipient",
                "title": "Recipient",
                "render": function (data) {
                    if (data != null) {
                        return PJQ.helpers.contacts.getContactAnchor({contact: data});
                    }
                    return "";
                }
            },
            {
                "data": "attributes.status",
                "title": "Status",
                "width": "80px"
            }
        ];

        if (_.size(this.options.extraColumns) > 0) {
            _.each(this.options.extraColumns, (column) => {
                if (column.index == null || column.index >= cols.length - 1) {
                    cols.push(column);
                    return;
                }

                cols = [
                    ...cols.slice(0, column.index),
                    column,
                    ...cols.slice(column.index)
                ];
            });
        }

        cols.push({
            "data": "",
            "title": "",
            "orderable": false,
            "searchable": false,
            "width": "100px",
            "render": function (data, type, row) {
                return '<div class="text-align-right"><button type="button" title="Copy Link" data-id="' + row.id.toString() + '" class="btn btn-primary btn-notification-link wd-35p ht-30p"><i class="fal fa-link"></i></button><button type="button" title="Resend" data-id="' + row.id.toString() + '" class="btn btn-share btn-notification-resend ml-1 wd-35p ht-30p"><i class="fal fa-share"></i></button></div>';
            }
        });

        return cols;
    },
    copyNotificationLink: function (e) {
        let notificationId = $(e.currentTarget).data('id'),
            notification = this.collection.get(notificationId),
            url = notification.get('endpoint');
        if (_.size(url) > 0) {
            url = window.location.origin + url;
        } else {
            url = notification.get('url');
        }

        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: url,
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();

        PJQ.notifications.notify.successNotify({
            message: 'URL copied to clipboard.'
        });
    },
    resendNotification: function (e) {
        let resendButton = $(e.currentTarget),
            notificationId = $(e.currentTarget).data('id'),
            notification = this.collection.get(notificationId),
            row = this.dataTable.getRow(notification.cid);
        notification.resend();

        // If the collection is RFI notifications, we want to update the sentCount and the lastSent. Add an attribute "wasResent" to disable the resend button on table redraw.
        if (this.collection instanceof PJQ.collections.rfi.Notifications) {
            notification.set({
                sentCount: notification.get('sentCount') + 1,
                lastSent: new Date(),
                wasResent: true
            });
            row.data(notification).draw();
        } else {
            resendButton.find('i').removeClass('fa-share').addClass('fa-check');
            resendButton.removeClass('btn-share').addClass('btn-success').prop('disabled', true);
        }
    }
});

PJQ.models.notifications = {};
PJQ.models.notifications.Notification = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (!model)
            return model;

        this.recipient = new PJQ.models.projectContacts.ProjectContact(model.recipient);

        return model;
    },
    getTypeName: function () {
        let name = this.notificationTypeNames[this.get('type')];
        return name || "";
    },
    resend: function () {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/resend'
        }).post().success(_.bind(function (data) {
            PJQ.notifications.notify.successNotify({
                message: 'Notification Resent'
            });
        }, this)).fail(_.bind(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Encountered an error resending notification.'
            });
        }, this));
    }
});

PJQ.collections.notifications = {};
PJQ.collections.notifications.Notifications = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.notifications.Notification
});

// Models
PJQ.models.notificationSettings = {};

PJQ.models.notificationSettings.NotificationSetting = PJQ.models.BaseModel.extend();

PJQ.models.notificationSettings.ContactNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ProjectsNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();

PJQ.models.notificationSettings.MessagingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.PrivateMessagingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.BidFormNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.AttachmentNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ProjectContactNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.RFINotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.DailyReportNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.DrawingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.PunchListNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ActionItemNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.SubmittalNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ScheduleNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.MeetingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.PayableInvoiceNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.CommitmentNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.RFQNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.InspectionNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();

PJQ.models.notificationSettings.NotificationSettings = PJQ.models.BaseModel.extend({
    idAttribute: "notificationSettingsId",
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings',
                    value: this.id
                }
            ]);
        } else if (this.get('id') != null && this.get('projectId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('id') < 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'users',
                    value: this.get('id')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('id') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('userTypeId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'usertypes',
                    value: this.get('userTypeId')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId') > 0 ? this.get('projectId') : null
            },
            {
                endpoint: 'notificationsettings'
            }
        ]);
    },
    hasNotificationSetting: function (notificationSetting, options = {}) {
        let result = null;
        let splitNS = _.bind(function (setting) {
            let parts = setting.split('.'),
                size = _.size(parts),
                stack = this,
                settingsResult = false;
            _.each(parts, function (part, index) {
                if (stack == null) {
                    return;
                }

                if (index + 1 === size) {
                    settingsResult = stack.get(part) === true;
                } else {
                    stack = stack[part];
                }
            }, this);
            return settingsResult;
        }, this);
        if (PJQ.helpers.objectHelpers.refinedType(notificationSetting) === 'array') {
            _.each(notificationSetting, function (ns) {
                if (options.or) {
                    result = splitNS(ns) || (result == null ? false : result);
                } else {
                    result = splitNS(ns) && (result == null ? true : result);
                }
            });
        } else {
            result = splitNS(notificationSetting);
        }
        return result == null ? false : result;
    },
    parse: function (model) {
        if (model != null) {
            if (PJQ.app.session != null && model.userTypeId != null) {
                this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
            } else if (model.userType != null) {
                model.userTypeId = model.userType.id;
                this.userType = model.userType;
            }

            _.each(this.subItems, function (nsMap, key) {
                let modelNotificationSettings = model[key];
                if (modelNotificationSettings != null) {
                    this[key] = new nsMap(modelNotificationSettings);
                }
            }, this);
        }

        return model;
    },
    beforeSave: function () {
        _.each(this.subItems, function (permMap, key) {
            let notificationSettings = this[key];
            if (notificationSettings != null && notificationSettings instanceof PJQ.models.notificationSettings.NotificationSetting) {
                this.set(key, notificationSettings.toJSON());
            }
        }, this);
    }
});

PJQ.models.notificationSettings.SystemNotificationSettings = PJQ.models.notificationSettings.NotificationSettings.extend({
    subItems: {
        projects: PJQ.models.notificationSettings.ProjectsNotifications,
        contacts: PJQ.models.notificationSettings.ContactNotifications
    },
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'notificationsettings',
                    value: this.id
                }
            ]);
        } else if (this.get('id') < 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'users',
                    value: this.get('id')
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('id') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('userTypeId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'usertypes',
                    value: this.get('userTypeId')
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'notificationsettings'
            }
        ]);
    }
});

PJQ.models.notificationSettings.ProjectNotificationSettings = PJQ.models.notificationSettings.NotificationSettings.extend({
    subItems: {
        messaging: PJQ.models.notificationSettings.MessagingNotifications,
        privateMessaging: PJQ.models.notificationSettings.PrivateMessagingNotifications,
        bidForms: PJQ.models.notificationSettings.BidFormNotifications,
        drawings: PJQ.models.notificationSettings.DrawingNotifications,
        attachments: PJQ.models.notificationSettings.AttachmentNotifications,
        projectContacts: PJQ.models.notificationSettings.ProjectContactNotifications,
        rfi: PJQ.models.notificationSettings.RFINotifications,
        dailyReports: PJQ.models.notificationSettings.DailyReportNotifications,
        punchList: PJQ.models.notificationSettings.PunchListNotifications,
        submittals: PJQ.models.notificationSettings.SubmittalNotifications,
        schedule: PJQ.models.notificationSettings.ScheduleNotifications,
        actionItems: PJQ.models.notificationSettings.ActionItemNotifications,
        meetings: PJQ.models.notificationSettings.MeetingNotifications,
        payableInvoices: PJQ.models.notificationSettings.PayableInvoiceNotifications,
        commitments: PJQ.models.notificationSettings.CommitmentNotifications,
        rfq: PJQ.models.notificationSettings.RFQNotifications,
        inspections: PJQ.models.notificationSettings.InspectionNotifications
    },
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings',
                    value: this.id
                }
            ]);
        } else if (this.get('id') != null && this.get('projectId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('id') < 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'users',
                    value: this.get('id')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('id') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        } else if (this.get('userTypeId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'usertypes',
                    value: this.get('userTypeId')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'notificationsettings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId') > 0 ? this.get('projectId') : null
            },
            {
                endpoint: 'notificationsettings'
            }
        ]);
    }
});

// Views
PJQ.views.notificationSettings = {};

PJQ.views.notificationSettings.NotificationSettingsEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Notification-Settings-Editor'),
        minWidth: 700
    },
    defaultEvents: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        this.notificationSettingsEditor = new PJQ.views.notificationSettings.NotificationSettingsEditor({
            el: this.$('.notification-settings'),
            model: this.model,
            project: this.options.project
        });
    },
    save: function () {
        new PJQ.Loader(this.$('.modal-content'));
        this.notificationSettingsEditor.save(_.bind(function () {
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Notification settings saved'
            });
        }, this));
    },
    cancel: function () {
        this.removeModal();
    }
});

PJQ.views.notificationSettings.NotificationSettingsEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Notification-Settings-Editor'),
        hasTooltips: true
    },
    events: {
        'click .btn-system-notification-settings-override': 'overrideSystem',
        'click .btn-system-notification-settings-revert': 'revertSystem',
        'click .btn-project-notification-settings-override': 'overrideProject',
        'click .btn-project-notification-settings-revert': 'revertProject'
    },
    beforeFirstRender: function () {
        this.fetchNotificationSettings();
    },
    fetchNotificationSettings: function () {
        if (this.options.project != null) {
            this.fetchProjectNotificationSettings(_.bind(function () {
                this.render();
            }, this));
        } else {
            this.fetchSystemNotificationSettings(_.bind(function () {
                this.fetchProjectNotificationSettings(_.bind(function () {
                    this.render();
                }, this));
            }, this));
        }
    },
    fetchSystemNotificationSettings: function (callback) {
        this.model.fetchSystemNotificationSettings(_.bind(function (settings) {
            this.systemNotificationSettings = settings;
            if (typeof callback === 'function') {
                callback(settings);
            }
        }, this));
    },
    fetchProjectNotificationSettings: function (callback) {
        if (this.model instanceof PJQ.models.userTypes.UserType) {
            this.model.fetchProjectNotificationSettings(_.bind(function (settings) {
                this.projectNotificationSettings = settings;
                if (typeof callback === 'function') {
                    callback(settings);
                }
            }, this));
        } else {
            this.model.fetchProjectNotificationSettings(this.options.project ? this.options.project.id : null, _.bind(function (settings) {
                this.projectNotificationSettings = settings;
                if (typeof callback === 'function') {
                    callback(settings);
                }
            }, this));
        }
    },
    renderData: function () {
        return {
            model: this.options.model,
            project: this.options.project,
            systemNotificationSettings: this.systemNotificationSettings,
            projectNotificationSettings: this.projectNotificationSettings
        };
    },
    afterRender: function () {
        let fnInit = _.bind(function (nsEl, nsModel) {
            let $nsEl = $(nsEl),
                nsKey = $nsEl.data('notificationSetting'),
                notificationSetting = nsModel[nsKey];
            if (notificationSetting != null) {
                new PJQ.Binder($nsEl, notificationSetting, {
                    setDefaultValues: true,
                    watchElements: [
                        'input'
                    ],
                    afterChange: _.bind(function ($ns, attr, val) {
                        this.notificationSettingChanged($ns, attr, val);
                        nsModel.isDirty = true;
                    }, this)
                });
            }
        }, this);
        if (this.systemNotificationSettings != null) {
            _.each(this.$('.system-notification-setting-container'), function (nsEl) {
                fnInit(nsEl, this.systemNotificationSettings);
            }, this);
        }
        if (this.projectNotificationSettings != null) {
            _.each(this.$('.project-notification-setting-container'), function (nsEl) {
                fnInit(nsEl, this.projectNotificationSettings);
            }, this);
        }
    },
    notificationSettingChanged: function ($notificationSetting, attr, val) {
        let level = $notificationSetting.data('level');
        if (level != null) {
            let inputs = $notificationSetting.closest('.notification-setting-container').find('input');
            if (val && level > 1) {
                _.each(inputs, function (otherNS) {
                    let $otherNS = $(otherNS),
                        otherLevel = $otherNS.data('level');
                    if (otherLevel != null && otherLevel < level) {
                        $otherNS.prop('checked', val);
                        $otherNS.trigger('change');
                    }
                });
            } else if (!val) {
                //don't cascade notifications up if there is another permission at this level still enabled
                if (_.find(inputs, function (otherNS) {
                    let otherAttr = $(otherNS).data('pBind'),
                        otherLevel = $(otherNS).data('level');
                    return otherLevel === level && attr !== otherAttr && $(otherNS).prop('checked');
                }) != null) {
                    return;
                }
                _.each(inputs, function (otherNS) {
                    let $otherNS = $(otherNS),
                        otherLevel = $otherNS.data('level');
                    if (otherLevel != null && otherLevel > level) {
                        $otherNS.prop('checked', val);
                        $otherNS.trigger('change');
                    }
                });
            }
        }
    },
    overrideSystem: function () {
        //To override we have to set the correct values for an overridden notification setting
        //This will not have an id so it is temporary until saved to the server
        //When it is saved next, it POST to the correct endpoint to create the overridden notification settings
        this.systemNotificationSettings.set({
            notificationSettingsId: null,
            userTypeId: null,
            id: this.model.get('id'),
            override: true
        });
        this.render();
    },
    revertSystem: function () {
        //To revert we have to delete the overridden notification setting if it has been saved to the server already
        //We then have to fetch the inherited notification settings
        let fp = _.bind(function () {
            this.fetchSystemNotificationSettings(_.bind(function () {
                this.render();
            }, this));
        }, this);
        if (!this.systemNotificationSettings.isNew()) {
            this.systemNotificationSettings.destroy({
                success: _.bind(function () {
                    this.systemNotificationSettings = null;
                    fp();
                }, this)
            });
        } else {
            fp();
        }
    },
    overrideProject: function () {
        //To override we have to set the correct values for an overridden notification setting
        //This will not have an id so it is temporary until saved to the server
        //When it is saved next, it POST to the correct endpoint to create the overridden notification settings
        this.projectNotificationSettings.set({
            notificationSettingsId: null,
            userTypeId: null,
            id: this.model.get('id'),
            projectId: this.options.project ? this.options.project.id : null,
            override: true
        });
        this.render();
    },
    revertProject: function () {
        //To revert we have to delete the overridden notification setting if it has been saved to the server already
        //We then have to fetch the inherited notification settings
        let fp = _.bind(function () {
            this.fetchProjectNotificationSettings(_.bind(function () {
                this.render();
            }, this));
        }, this);
        if (!this.projectNotificationSettings.isNew()) {
            this.projectNotificationSettings.destroy({
                success: _.bind(function () {
                    this.projectNotificationSettings = null;
                    fp();
                }, this)
            });
        } else {
            fp();
        }
    },
    save: function (callback) {
        let fp = _.bind(function () {
                this.fetchProjectNotificationSettings(_.bind(function () {
                    this.render();
                }, this));
            }, this),
            saveP = _.bind(function () {
                if (this.projectNotificationSettings != null && this.projectNotificationSettings.hasChanged()) {
                    this.projectNotificationSettings.save(null, {
                        success: _.bind(function () {
                            if (typeof callback === 'function') {
                                callback();
                            }
                        }, this)
                    });
                } else {
                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            }, this);
        if (this.systemNotificationSettings != null && this.systemNotificationSettings.hasChanged()) {
            this.systemNotificationSettings.save(null, {
                success: function () {
                    saveP();
                    fp();
                }
            });
        } else {
            saveP();
        }
    }
});

PJQ.notifications = {
	createNotifyModal: function (options) {
		if (options.cookie == null || !PJQ.helpers.cookieHelpers.getCookie(options.cookie)) {
			new PJQ.notifications.NotifyModal(options);
			return true;
		}
		return false;
	}
};

PJQ.notifications.NotifyModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Notify')
	},
	events: {
		"click .btn-dont-show": "setDontShowCookie"
	},
	setDontShowCookie: function () {
		if (_.size(this.options.cookie) > 0) {
			PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true);
		}
	}
});

PJQ.notifications.notify = {
	defaultNotifySettings: {
		placement: {
			from: 'bottom',
			align: 'right'
		},
		animate: {
			enter: 'animated fadeInDown',
			exit: 'animated fadeOutRight'
		},
		allow_dismiss: true,
		delay: 5000,
		z_index: 10000000
	},
	getTemplate: function (options, callback) {
		PJQ.templating.TemplateRenderer.parseTemplate(new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Notify'), options, function (template) {
			callback(template.outerHTML());
		});
	},
	notify: function (options, settings) {
		let notifyOptions = {},
			notifySettings = {};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = options;
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object') {
			notifySettings = _.defaults(settings, this.defaultNotifySettings);
		}

		this.getTemplate({ options: notifyOptions, settings: notifySettings }, function ($template) {
			notifySettings.template = $template;
			$.notify(notifyOptions, notifySettings);
		});
	},
	successNotify: function (options, settings) {
		let notifyOptions = {
				icon: 'fal fa-check'
			},
			notifySettings = {
				type: 'notify-success'
			};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = _.defaults(options, notifyOptions);
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object') {
			notifySettings = _.defaults(settings, notifySettings);
		}

		this.notify(notifyOptions, notifySettings);
	},
	warningNotify: function (options, settings) {
		let notifyOptions = {
				icon: 'fal fa-lightbulb'
			},
			notifySettings = {
				type: 'notify-warning'
			};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = _.defaults(options, notifyOptions);
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object') {
			notifySettings = _.defaults(settings, notifySettings);
		}

		this.notify(notifyOptions, notifySettings);
	},
	errorNotify: function (options, settings) {
		let notifyOptions = {
				icon: 'fal fa-exclamation-triangle',
				title: 'Something went wrong!'
			},
			notifySettings = {
				type: 'notify-error'
			};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = _.defaults(options, notifyOptions);
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object')
			notifySettings = _.defaults(settings, notifySettings);

		this.notify(notifyOptions, notifySettings);
	}
};
PJQ.Pagination = class {
	constructor($el, options = {}) {
		this.$el = $el;
		this.options = _.defaults(options, {
			callback: _.bind(function (items) {
				this.$paginationData.empty();
				_.each(items, function (item) {
					this.renderPageItem(item);
				}, this);
			}, this)
		});
		this.createElement();
		this.render(options.dataSource);
	}

	createElement() {
		//Create inner elements for pagination and data
		if(_.size(this.$el.find('.pagination-controller')) === 0){
			this.$el.append($('<div>', {
				class: 'pagination-controller'
			}));
		}
		if(_.size(this.$el.find('.pagination-data')) === 0){
			this.$el.append($('<div>', {
				class: 'pagination-data mt-2'
			}));
		}

		this.$paginationController = this.$el.find('.pagination-controller');
		this.$paginationData = this.$el.find('.pagination-data');
	}

	render(data) {
		if(data != null){
			this.options.dataSource = data;
		}

		//Instantiate pagination on the pagination controller element
		this.$paginationController.pagination(this.options);
	}

	reload(data){
		this.render(data);
	}

	renderPageItem(item) {
		//If there is an override for rendering each page item, do the callback
		if (typeof this.options.renderPageItem === 'function') {
			this.options.renderPageItem(item);
		}
		//Else if there was a passed in page template, render that, otherwise do nothing
		else if (typeof this.options.pageItemTemplate != null) {
			PJQ.templating.TemplateRenderer.renderTemplate(true, this.options.pageItemTemplate, this.$paginationData, _.extend({
				model: item
			}, this.options.renderData));
		}
	}
};
//Views
PJQ.views.payment = {};

PJQ.views.payment.PaymentModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Payment'),
		onSave: _.noop,
		minWidth: 700,
		maxWidth: 800
	},
	events: {
		'click .payment-complete': 'paymentCompleteClicked',
		'click .payment-cancel': 'paymentCancelClicked'
	},
	errors: {
		FORM_NOT_COMPLETE: 'All required fields (*) must be filled out',
		INVALID_ACCOUNT: "The card number you entered is invalid",
		DECLINED: "The card you entered was declined.  This can be due to an incorrect address, expiration date, security code, or insufficient funds.",
		ERROR: "Unable to process payment right now.  Please try again later or contact customer service."
	},
	beforeModalCreated: function () {
		if (this.options.product instanceof PJQ.models.payment.Product) {
			if (!(this.options.products instanceof PJQ.collections.payment.Products)) {
				this.options.products = new PJQ.collections.payment.Products();
			}
			this.options.products.add(this.options.product);
		}

		if (!(this.options.contact instanceof PJQ.models.contacts.Contact)) {
			this.options.contact = new PJQ.models.contacts.Contact();
		}

		if (_.size(this.options.products.models) === 0) {
			//todo: error here
		}

		this.model = new PJQ.models.payment.Transaction({
			cardholderName: this.options.contact.get('contactName'),
			address1: this.options.contact.get('address1'),
			address2: this.options.contact.get('address2'),
			city: this.options.contact.get('city'),
			state: this.options.contact.get('state'),
			zip: this.options.contact.get('zip'),
			country: _.size(this.options.contact.get('country')) > 0 ? this.options.contact.get('country') : 'US',
			cardNumber: null,
			expirationMonth: null,
			expirationYear: null,
			securityCode: null,
			products: this.options.products
		});

		if (this.options.endpoint != null) {
			this.model.endpoint = this.options.endpoint;
		}
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		new PJQ.Binder(this.$('.payment-container'), this.model, {
			watchElements: [
				'input'
			],
			afterChange: _.bind(function ($field) {
				this.validateField($field, true);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('select.payment-expiration-month'),
			hideDisabled: false,
			onChange: _.bind(function (value) {
				this.model.set('expirationMonth', value);
				this.validateField(this.$('select.payment-expiration-month'), true);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('select.payment-expiration-year'),
			hideDisabled: false,
			onChange: _.bind(function (value) {
				this.model.set('expirationYear', value);
				this.validateField(this.$('select.payment-expiration-year'), true);
			}, this)
		});

		let statePicker = new PJQ.inputs.StatePicker({
			el: this.$('select.payment-state'),
			country: this.model.get('country') ? this.model.get('country').toUpperCase() : null,
			defaultValue: this.model.get('state') ? this.model.get('state').toUpperCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('state', value);
				this.validateField(this.$('select.payment-state'), true);
			}, this)
		});

		new PJQ.inputs.CountryPicker({
			el: this.$('.payment-country'),
			defaultValue: this.model.get('country') ? this.model.get('country').toUpperCase() : null,
			statePicker: statePicker,
			zipInput: this.$('.payment-zip'),
			onChange: _.bind(function (value) {
				this.model.set('country', value);
				this.validateField(this.$('select.payment-country'), true);
			}, this)
		});
	},
	paymentCompleteClicked: function () {
		if (this.validateForm()) {
			if (this.model.endpoint != null) {
				this.$('.payment-cancel').prop('disabled', true);
				this.$('.payment-complete').prop('disabled', true).text('Processing...');
				this.model.save(null, {
					success: _.bind(function (model, response) {
						if (response.result) {
							this.removeModal();
							if (typeof this.options.onComplete === 'function') {
								this.options.onComplete(this.model);
							}
						}
						else {
							let error = response.error;
							if (_.size(error) === 0 || error === 'ERROR') {
								error = 'ERROR';
								new PJQ.logging.Debug(PJQ.logging.LoggingActions.PAYMENT_ERROR, {
									result: response,
									endpoint: (typeof this.model.endpoint === 'function') ? this.model.endpoint() : this.model.endpoint
								});
							}
							this.renderFormError(this.errors[error]);
							this.$('.payment-cancel').prop('disabled', false);
							this.$('.payment-complete').prop('disabled', false).text('Complete Order');
						}
					}, this)
				});
			}
			else {
				if (typeof this.options.onComplete === 'function') {
					this.options.onComplete(this.model);
				}
			}
		}
	},
	validateForm: function () {
		let self = this,
			isFormValid = true,
			errorFields = [];
		this.$('.payment-container').find(':required').each(function () {
			if (!self.validateField($(this))) {
				isFormValid = false;
				errorFields.push($(this).data('pBind'));
			}
		});

		if (_.size(this.$formError) > 0) {
			this.$formError.remove();
		}
		if (!isFormValid) {
			let errorText = this.errors.FORM_NOT_COMPLETE;
			if (_.size(errorFields) === 1 && errorFields.indexOf('cardNumber') !== -1) {
				errorText = this.errors.INVALID_ACCOUNT
			}
			this.renderFormError(errorText);
		}
		return isFormValid;
	},
	renderFormError: function (errorText) {
		if (_.size(this.$formError) > 0) {
			this.$formError.remove();
		}
		this.$formError = $('<div>', {
			class: 'text-danger fs-14 p-absolute left-1d25rem wd-70'
		}).text(errorText);
		this.$('.modal-footer').append(this.$formError);
	},
	validateField: function ($field, isKeyupValidation = false) {
		let attribute = $field.data('pBind'),
			value = this.model.get(attribute),
			isFieldValid = true;
		if (attribute === 'zip') {
			let zipLength = 5;
			if (this.model.get("country") === 'ca') {
				zipLength = 6;
			}
			isFieldValid = (_.size(value) === zipLength);
		}
		else if (attribute === 'cardNumber') {
			isFieldValid = PJQ.helpers.paymentHelpers.validateCreditCard(value);
		}
		else if (!value || _.size(value.toString()) === 0) {
			isFieldValid = false;
		}

		if (isFieldValid || !isKeyupValidation)
			PJQ.helpers.inputHelpers.setInputError($field, isFieldValid);

		return isFieldValid;
	},
	paymentCancelClicked: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	}
});

PJQ.views.payment.PaySimplePaymentModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-paysimple-payment-settings'),
		minWidth: 500,
		onSave: null,
		onError: null,
		isVerticalCenter: true
	},
	events: {
		'click .btn-save': 'save',
		'keyup .input-cardholder-name': 'cardholderNameChanged',
		'keyup .input-card-number': 'setCardIssuer'
	},
	beforeModalCreated: function () {
		PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
			this.model = billingInfo;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model == null) {
			new PJQ.Loader(this.$('.modal-content'));
			return;
		}

		new PJQ.Binder(this.$el, this.model);

		PJQ.helpers.inputHelpers.inputMaskCreditCard(this.$('.input-card-number'));

		this.monthPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-card-expiration-month'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('cardExpirationMonth', value);
			}, this)
		});

		this.yearPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-card-expiration-year'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('cardExpirationYear', value);
			}, this)
		});
	},
	cardholderNameChanged: function (e) {
		let name = $(e.currentTarget).val().trim(),
			firstName,
			lastName,
			spaceIndex = name.indexOf(' ');
		if (spaceIndex !== -1) {
			firstName = name.substr(0, spaceIndex);
			lastName = name.substr(spaceIndex + 1, _.size(name) - spaceIndex);
		}
		else {
			firstName = name;
			lastName = '';
		}
		this.model.set({
			firstName: firstName,
			lastName: lastName
		})
	},
	setCardIssuer: function () {
		let cardBrand = PJQ.helpers.paymentHelpers.getCardIssuer(this.model.get('cardNumber')),
			icon = PJQ.helpers.paymentHelpers.getCardIssuerIconFAClass(cardBrand);
		this.$('.card-issuer').addClass('fs-30 ' + icon);
	},
	validate: function () {
		let isValid = true;

		let isNameValid = _.size(this.model.get('firstName')) > 0 && _.size(this.model.get('lastName')) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-cardholder-name'), isNameValid);
		isValid = isNameValid && isValid;

		let isZipValid = _.size(this.model.get('zip').trim()) > 4;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-cardholder-zip'), isZipValid);
		isValid = isZipValid && isValid;

		let isCardValid = PJQ.helpers.paymentHelpers.validateCreditCard(this.model.get('cardNumber'));
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-card-number'), isCardValid);
		isValid = isCardValid && isValid;

		let isYearValid = (this.yearPicker.getValue() != null);
		isValid = isYearValid && isValid;
		this.$('.select-expiration-year').removeClass('p-field-error');
		if (!isYearValid) {
			this.$('.select-expiration-year').addClass('p-field-error');
		}

		let isMonthValid = (this.monthPicker.getValue() != null);
		isValid = isMonthValid && isValid;
		this.$('.select-expiration-month').removeClass('p-field-error');
		if (!isMonthValid) {
			this.$('.select-expiration-month').addClass('p-field-error');
		}

		return isValid;
	},
	saveBillingInfo: function (onSuccess, onError) {
		this.model.save(null, {
			success: _.bind(function (data) {
				if (typeof onSuccess === 'function') {
					onSuccess(this.model);
				}
			}, this),
			error: _.bind(function () {
				if (typeof onError === 'function') {
					onError(this.model);
				}
			}, this)
		});
	},
	save: function () {
		new PJQ.Loader(this.$('.modal-content'));
		if (this.validate()) {
			this.saveBillingInfo(_.bind(function () {
				if (typeof this.options.onSave === 'function') {
					this.options.onSave(this.model);
				}
				this.removeModal();
			}, this), _.bind(function () {
				if (typeof this.options.onError === 'function') {
					this.options.onError(this.model);
				}
				this.removeModal();
			}, this));
		}
	}
});

PJQ.views.payment.SubscriptionPaymentModal = PJQ.views.payment.PaySimplePaymentModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-subscription-payment'),
		subTemplates: {
			selectSubscription: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'subscription-payment-select-subcription')
		},
		minWidth: 500,
		onSave: null,
		onError: null,
		isVerticalCenter: true,
		isShowCloseButton: true,
		selectedSubscriptionId: null
	},
	events: {
		'click .btn-save': 'save',
		'keyup .input-cardholder-name': 'cardholderNameChanged',
		'keyup .input-card-number': 'setCardIssuer',
		'click .sub-option': 'subscriptionSelected'
	},
	beforeModalCreated: function () {
		this.selectedSubscriptionId = this.options.selectedSubscriptionId > 0 ? this.options.selectedSubscriptionId : PJQ.app.session.subscription.id;
		PJQ.app.session.subscription.getCostsPerUser(_.bind(function (costs) {
			this.changeCosts = costs;
			let curCost = PJQ.app.session.subscription.get('cost');
			this.changeCosts.basic = this.changeCosts.basic - curCost;
			if(this.changeCosts.basic < 0){
				this.changeCosts.basic = 0;
			}
			this.changeCosts.pro = this.changeCosts.pro - curCost;
			if(this.changeCosts.pro < 0){
				this.changeCosts.pro = 0;
			}
			this.changeCosts.enterprise = this.changeCosts.enterprise - curCost;
			if(this.changeCosts.enterprise < 0){
				this.changeCosts.enterprise = 0;
			}

			PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
				this.model = billingInfo;
				this.hasCardOnFile = this.model.get('cardNumber') != null;
				this.render();
			}, this));
		}, this));
	},
	renderData: function () {
		return {
			model: this.model,
			hasCardOnFile: this.hasCardOnFile,
			selectedSubscriptionId: this.selectedSubscriptionId,
			error: this.error
		};
	},
	afterRender: function () {
		if (this.model == null) {
			new PJQ.Loader(this.$('.modal-content'));
			return;
		}

		if (!this.hasCardOnFile) {
			new PJQ.Binder(this.$el, this.model);

			PJQ.helpers.inputHelpers.inputMaskCreditCard(this.$('.input-card-number'));

			this.monthPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-card-expiration-month'),
				noneSelectedText: '',
				defaultValue: this.model.get('cardExpirationMonth'),
				onChange: _.bind(function (value) {
					this.model.set('cardExpirationMonth', value);
				}, this)
			});

			this.yearPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-card-expiration-year'),
				noneSelectedText: '',
				defaultValue: this.model.get('cardExpirationYear'),
				onChange: _.bind(function (value) {
					this.model.set('cardExpirationYear', value);
				}, this)
			});
		}

		this.renderSelectedSubscription();
	},
	subscriptionSelected: function (e) {
		this.selectedSubscriptionId = parseInt($(e.currentTarget).data('subId'));
		this.renderSelectedSubscription();
	},
	renderSelectedSubscription: function () {
		this.renderSubTemplate(false, this.options.subTemplates.selectSubscription, this.$('.subscription-select'), {
			selectedSubscriptionId: this.selectedSubscriptionId
		});
		this.renderTotal();
	},
	renderTotal: function () {
		let cost;
		switch (this.selectedSubscriptionId) {
			case PJQ.constants.subscriptions.types.BASIC:
				cost = this.changeCosts.basic;
				break;
			case PJQ.constants.subscriptions.types.PRO:
				cost = this.changeCosts.pro;
				break;
			case PJQ.constants.subscriptions.types.ENTERPRISE:
				cost = this.changeCosts.enterprise;
				break;
			default:
				cost = 0;
				break;
		}
		this.$('.payment-total').html(PJQ.helpers.formatHelpers.formatCurrency(cost * PJQ.app.session.subscription.get('userSeats'), 2, true));
	},
	save: function () {
		let $err = this.$('.payment-error'),
			loader = new PJQ.Loader(this.$('.modal-content')),
			err = function () {
				loader.remove();
				PJQ.notifications.notify.errorNotify({
					message: 'Encountered an error upgrading your subscription.  Please contact customer service.'
				});
			};
		$err.empty();

		let cNumber = this.model.get('cardNumber');
		let fnChangeSubscription = _.bind(function () {
			PJQ.app.session.changeSubscription(this.selectedSubscriptionId, _.bind(function (data) {
				if (data == null || data.subscription == null) {
					err();
				}
				else {
					PJQ.notifications.notify.successNotify({
						message: 'Subscription successfully updated'
					});
					this.removeModal();
				}
			}, this), _.bind(function (response) {
				if (response.responseJSON != null && _.size(response.responseJSON.message) > 0) {
					this.error = response.responseJSON.message;
					if (this.hasCardOnFile) {
						this.model = new PJQ.models.billing.BillingInfo();
						this.hasCardOnFile = false;
					}
					else {
						this.model.set('cardNumber', cNumber);
					}
					this.render();
				}
				else {
					$err.html("An error occurred processing the payment.  Please contact customer service.");
					loader.remove();
					this.$('.btn-save').prop('disabled', true);
				}
			}, this));
		}, this);

		if (this.hasCardOnFile) {
			fnChangeSubscription();
		}
		else if (this.validate()) {
			this.saveBillingInfo(_.bind(function () {
				fnChangeSubscription();
			}, this), _.bind(function () {
				if (typeof this.options.onError === 'function') {
					this.options.onError(this.model);
				}
			}, this));
		}
	}
});

//Models
PJQ.models.payment = {};

PJQ.models.payment.Transaction = PJQ.models.BaseModel.extend();

PJQ.models.payment.Product = PJQ.models.BaseModel.extend();


//Collections
PJQ.collections.payment = {};

PJQ.collections.payment.Products = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.payment.Product
});

PJQ.views.paysimple = {};

PJQ.views.paysimple.SignUpOpenedModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-paysimple-sign-up-opened'),
		maxWidth: 500,
		isShowCloseButton: true,
		isVerticalCenter: true
	}
});
//Models
PJQ.models.permissions = {};

PJQ.models.permissions.Permission = PJQ.models.BaseModel.extend();

PJQ.models.permissions.ProjectsPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ContactPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DocumentPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.BidFilerPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.CalendarPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ReportPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.SettingsPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrequalPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ResourcePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.TimeCardPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.InvoicePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.UserPermissions = PJQ.models.permissions.Permission.extend();

PJQ.models.permissions.ProjectBasePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.MessagingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrivateMessagingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.BidFormPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DrawingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.AttachmentPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ProjectContactPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PhotoGalleryPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.RFIPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DailyReportPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PunchListPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ActionItemPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.SubmittalPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ReportPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.SchedulePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.BudgetPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.CommitmentPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.CommitmentChangeOrderPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrimeContractPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrimeContractChangeOrderPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DirectCostPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PayableInvoicePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ReceivableInvoicePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.MeetingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ChangeRequestPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ProductionQuantityPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.InspectionPermissions = PJQ.models.permissions.Permission.extend();

PJQ.models.permissions.Permissions = PJQ.models.BaseModel.extend({
    idAttribute: "permissionId",
    afterInit: function () {
        this.on('change:userTypeId', function () {
            let userTypeId = this.get('userTypeId');
            if (PJQ.app.session != null && userTypeId != null) {
                this.userType = PJQ.app.session.userTypes.get(userTypeId);
                if (this.userType != null) {
                    this.userType.permissions = this;
                }
            } else {
                this.userType = null;
            }
        });
    },
    hasPermission: function (permission, options = {}) {
        let result = null;
        let splitPerm = _.bind(function (perm) {
            let parts = perm.split('.'),
                size = _.size(parts),
                stack = this,
                permResult = false;
            _.each(parts, function (part, index) {
                if (stack == null) {
                    return;
                }

                if (index + 1 === size) {
                    permResult = stack.get(part) === true;
                } else {
                    stack = stack[part];
                }
            }, this);
            return permResult;
        }, this);
        if (PJQ.helpers.objectHelpers.refinedType(permission) === 'array') {
            _.each(permission, function (perm) {
                if (options.or) {
                    result = splitPerm(perm) || (result == null ? false : result);
                } else {
                    result = splitPerm(perm) && (result == null ? true : result);
                }
            });
        } else {
            result = splitPerm(permission);
        }
        return result == null ? false : result;
    },
    parse: function (model) {
        if (model != null) {
            if (PJQ.app.session != null && model.userTypeId != null) {
                this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
            } else if (model.userType != null) {
                model.userTypeId = model.userType.id;
                this.userType = model.userType;
            }

            _.each(this.subItems, function (permMap, key) {
                let modelPermissions = model[key];
                if (modelPermissions != null) {
                    this[key] = new permMap(modelPermissions);
                }
            }, this);
        }

        return model;
    },
    beforeSave: function () {
        _.each(this.subItems, function (permMap, key) {
            let permissions = this[key];
            if (permissions != null && permissions instanceof PJQ.models.permissions.Permission) {
                this.set(key, permissions.toJSON());
            }
        }, this);
    }
});

PJQ.models.permissions.SystemPermissions = PJQ.models.permissions.Permissions.extend({
    subItems: {
        projects: PJQ.models.permissions.ProjectsPermissions,
        contacts: PJQ.models.permissions.ContactPermissions,
        documents: PJQ.models.permissions.DocumentPermissions,
        bidFiler: PJQ.models.permissions.BidFilerPermissions,
        calendar: PJQ.models.permissions.CalendarPermissions,
        reports: PJQ.models.permissions.ReportPermissions,
        settings: PJQ.models.permissions.SettingsPermissions,
        prequal: PJQ.models.permissions.PrequalPermissions,
        resources: PJQ.models.permissions.ResourcePermissions,
        timeCards: PJQ.models.permissions.TimeCardPermissions,
        invoices: PJQ.models.permissions.InvoicePermissions,
        users: PJQ.models.permissions.UserPermissions
    },
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'permissions',
                    value: this.id
                }
            ]);
        } else if (this.options.isAPIv2) {
            let params = [],
                pId = this.get('id'),
                utId = this.get('userTypeId');
            if (pId < 0) {
                params.push({
                    parameter: 'userId',
                    value: pId
                });
            } else if (pId > 0) {
                params.push({
                    parameter: 'contactId',
                    value: pId
                });
            } else if (utId > 0) {
                params.push({
                    parameter: utId,
                    value: pId
                });
            }

            let projectId = this.get('projectId');
            if (projectId > 0) {
                params.push({
                    parameter: utId,
                    value: projectId
                });
            }

            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'permissions'
                }
            ], params);
        } else if (this.get('id') < 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'users',
                    value: this.get('id')
                },
                {
                    endpoint: 'permissions'
                }
            ]);
        } else if (this.get('id') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'permissions'
                }
            ]);
        } else if (this.get('userTypeId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'usertypes',
                    value: this.get('userTypeId')
                },
                {
                    endpoint: 'permissions'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'permissions'
            }
        ]);
    }
});

PJQ.models.permissions.ProjectPermissions = PJQ.models.permissions.Permissions.extend({
    subItems: {
        base: PJQ.models.permissions.ProjectBasePermissions,
        messaging: PJQ.models.permissions.MessagingPermissions,
        privateMessaging: PJQ.models.permissions.PrivateMessagingPermissions,
        bidForms: PJQ.models.permissions.BidFormPermissions,
        drawings: PJQ.models.permissions.DrawingPermissions,
        attachments: PJQ.models.permissions.AttachmentPermissions,
        projectContacts: PJQ.models.permissions.ProjectContactPermissions,
        photoGallery: PJQ.models.permissions.PhotoGalleryPermissions,
        rfi: PJQ.models.permissions.RFIPermissions,
        dailyReports: PJQ.models.permissions.DailyReportPermissions,
        punchList: PJQ.models.permissions.PunchListPermissions,
        actionItems: PJQ.models.permissions.ActionItemPermissions,
        submittals: PJQ.models.permissions.SubmittalPermissions,
        reports: PJQ.models.permissions.ReportPermissions,
        schedule: PJQ.models.permissions.SchedulePermissions,
        timeCards: PJQ.models.permissions.TimeCardPermissions,
        budget: PJQ.models.permissions.BudgetPermissions,
        commitments: PJQ.models.permissions.CommitmentPermissions,
        commitmentChangeOrders: PJQ.models.permissions.CommitmentChangeOrderPermissions,
        primeContracts: PJQ.models.permissions.PrimeContractPermissions,
        primeContractChangeOrders: PJQ.models.permissions.PrimeContractChangeOrderPermissions,
        directCosts: PJQ.models.permissions.DirectCostPermissions,
        payableInvoices: PJQ.models.permissions.PayableInvoicePermissions,
        receivableInvoices: PJQ.models.permissions.ReceivableInvoicePermissions,
        meetings: PJQ.models.permissions.MeetingPermissions,
        changeRequests: PJQ.models.permissions.ChangeRequestPermissions,
        productionQuantities: PJQ.models.permissions.ProductionQuantityPermissions,
        inspections: PJQ.models.permissions.InspectionPermissions
    },
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'permissions',
                    value: this.id
                }
            ]);
        } else if (this.options.isAPIv2) {
            let params = [],
                pId = this.get('id'),
                utId = this.get('userTypeId');
            if (pId < 0) {
                params.push({
                    parameter: 'userId',
                    value: pId
                });
            } else if (pId > 0) {
                params.push({
                    parameter: 'contactId',
                    value: pId
                });
            } else if (utId > 0) {
                params.push({
                    parameter: utId,
                    value: pId
                });
            }

            let projectId = this.get('projectId');
            if (projectId > 0) {
                params.push({
                    parameter: utId,
                    value: projectId
                });
            }

            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'permissions'
                }
            ], params);
        } else if (this.get('id') != null && this.get('projectId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'permissions'
                }
            ]);
        } else if (this.get('id') < 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'users',
                    value: this.get('id')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'permissions'
                }
            ]);
        } else if (this.get('id') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('id')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'permissions'
                }
            ]);
        } else if (this.get('userTypeId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'usertypes',
                    value: this.get('userTypeId')
                },
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'permissions'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId') > 0 ? this.get('projectId') : null
            },
            {
                endpoint: 'permissions'
            }
        ]);
    }
});

//Views
PJQ.views.permissions = {};

PJQ.views.permissions.PermissionsEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Permissions-Editor'),
        minWidth: 800
    },
    defaultEvents: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        this.permissionEditor = new PJQ.views.permissions.PermissionsEditor({
            el: this.$('.permissions'),
            model: this.model,
            project: this.options.project
        });
    },
    save: function () {
        new PJQ.Loader(this.$('.modal-content'));
        this.permissionEditor.save(_.bind(function () {
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Permissions saved'
            });

            if (PJQ.app.session.user != null) {
                let permFn = function () {
                    PJQ.app.session.fetchSystemPermissions(function () {
                        PJQ.app.navigator.refreshCommands();
                    });
                };
                if (this.model.get('id') === PJQ.app.session.user.get('id')) {
                    permFn();
                } else if (this.model.get('id') == null && this.model.get('userTypeId') === PJQ.app.session.user.get('userTypeId')) {
                    permFn();
                }
            }
        }, this));
    },
    cancel: function () {
        this.removeModal();
    }
});

PJQ.views.permissions.PermissionsEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Permissions-Editor'),
        hasTooltips: true
    },
    events: {
        'click .btn-system-permissions-override': 'overrideSystem',
        'click .btn-system-permissions-revert': 'revertSystem',
        'click .btn-project-permissions-override': 'overrideProject',
        'click .btn-project-permissions-revert': 'revertProject'
    },
    beforeFirstRender: function () {
        this.fetchPermissions();
    },
    fetchPermissions: function () {
        if (this.options.project != null) {
            this.fetchProjectPermissions(_.bind(function () {
                this.render();
            }, this));
        } else {
            this.fetchSystemPermissions(_.bind(function () {
                this.fetchProjectPermissions(_.bind(function () {
                    this.render();
                }, this));
            }, this));
        }
    },
    fetchSystemPermissions: function (callback) {
        this.model.fetchSystemPermissions(_.bind(function (perm) {
            this.systemPermissions = perm;
            if (typeof callback === 'function') {
                callback(perm);
            }
        }, this));
    },
    fetchProjectPermissions: function (callback) {
        if (this.model instanceof PJQ.models.userTypes.UserType) {
            this.model.fetchProjectPermissions(_.bind(function (perm) {
                this.projectPermissions = perm;
                if (typeof callback === 'function') {
                    callback(perm);
                }
            }, this));
        } else {
            this.model.fetchProjectPermissions(this.options.project ? this.options.project.id : null, _.bind(function (perm) {
                this.projectPermissions = perm;
                if (typeof callback === 'function') {
                    callback(perm);
                }
            }, this));
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            systemPermissions: this.systemPermissions,
            projectPermissions: this.projectPermissions,
            hasFeature: this.hasFeature,
            hasApproval: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_APPROVAL_REQUIRED) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_APPROVAL_REQUIRED) : false,
            newAddressBook: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)
        };
    },
    afterRender: function () {
        let fnInit = _.bind(function (permissionEl, permissionModel) {
            let $permissionEl = $(permissionEl),
                permissionKey = $permissionEl.data('permission'),
                permission = permissionModel[permissionKey];
            if (permission != null) {
                new PJQ.Binder($permissionEl, permission, {
                    setDefaultValues: true,
                    watchElements: [
                        'input'
                    ],
                    afterChange: _.bind(function ($perm, attr, val) {
                        this.permissionChanged($perm, attr, val);
                        permissionModel.isDirty = true;
                    }, this)
                });
            }
        }, this);

        if (this.systemPermissions != null) {
            _.each(this.$('.system-permission-container'), function (permissionEl) {
                fnInit(permissionEl, this.systemPermissions);
            }, this);
        }

        if (this.projectPermissions != null) {
            _.each(this.$('.project-permission-container'), function (permissionEl) {
                fnInit(permissionEl, this.projectPermissions);
            }, this);
        }
    },
    hasFeature: function (feature) {
        return PJQ.app.session.hasFeature(feature);
    },
    permissionChanged: function ($permission, attr, val) {
        // cascading permissions logic
        let level = $permission.data('level');
        if (level != null) {
            let inputs = $permission.closest('.perm-container').find('input');
            if (val && level > 1) {
                _.each(inputs, function (otherPerm) {
                    let $otherPerm = $(otherPerm),
                        otherLevel = $otherPerm.data('level');
                    if (otherLevel != null && otherLevel < level) {
                        $otherPerm.prop('checked', val);
                        $otherPerm.trigger('change');
                    }
                });
            } else if (!val) {
                //don't cascade permissions up if there is another permission at this level still enabled
                if (_.find(inputs, function (otherPerm) {
                    let otherAttr = $(otherPerm).data('pBind'),
                        otherLevel = $(otherPerm).data('level');
                    return otherLevel === level && attr !== otherAttr && $(otherPerm).prop('checked');
                }) != null) {
                    return;
                }
                _.each(inputs, function (otherPerm) {
                    let $otherPerm = $(otherPerm),
                        otherLevel = $otherPerm.data('level');
                    if (otherLevel != null && otherLevel > level) {
                        $otherPerm.prop('checked', val);
                        $otherPerm.trigger('change');
                    }
                });
            }
        }
    },
    overrideSystem: function () {
        //To override we have to set the correct values for an overridden permission
        //This will not have an id so it is temporary until saved to the server
        //When it is saved next, it POST to the correct endpoint to create the overridden permissions
        this.systemPermissions.set({
            permissionId: null,
            userTypeId: null,
            id: this.model.get('id'),
            override: true
        });
        this.render();
    },
    revertSystem: function () {
        //To revert we have to delete the overridden permissions if it has been saved to the server already
        //We then have to fetch the inherited permissions
        let fp = _.bind(function () {
            this.fetchSystemPermissions(_.bind(function () {
                this.render();
            }, this));
        }, this);
        if (!this.systemPermissions.isNew()) {
            this.systemPermissions.destroy({
                success: _.bind(function () {
                    this.systemPermissions = null;
                    fp();
                }, this)
            });
        } else {
            fp();
        }
    },
    overrideProject: function () {
        //To override we have to set the correct values for an overridden permission
        //This will not have an id so it is temporary until saved to the server
        //When it is saved next, it POST to the correct endpoint to create the overridden permissions
        this.projectPermissions.set({
            permissionId: null,
            userTypeId: null,
            id: this.model.get('id'),
            projectId: this.options.project ? this.options.project.id : null,
            override: true
        });
        this.render();
    },
    revertProject: function () {
        //To revert we have to delete the overridden permissions if it has been saved to the server already
        //We then have to fetch the inherited permissions
        let fp = _.bind(function () {
            this.fetchProjectPermissions(_.bind(function () {
                this.render();
            }, this));
        }, this);
        if (!this.projectPermissions.isNew()) {
            this.projectPermissions.destroy({
                success: _.bind(function () {
                    this.projectPermissions = null;
                    fp();
                }, this)
            });
        } else {
            fp();
        }
    },
    save: function (callback) {
        let fp = _.bind(function () {
                this.fetchProjectPermissions(_.bind(function () {
                    this.render();
                }, this));
            }, this),
            saveP = _.bind(function () {
                if (this.projectPermissions != null && this.projectPermissions.hasChanged()) {
                    this.projectPermissions.save(null, {
                        success: _.bind(function () {
                            if (typeof callback === 'function') {
                                callback();
                            }
                        }, this)
                    });
                } else {
                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            }, this);
        if (this.systemPermissions != null && this.systemPermissions.hasChanged()) {
            this.systemPermissions.save(null, {
                success: function () {
                    saveP();
                    fp();
                }
            });
        } else {
            saveP();
        }
    }
});

PJQ.views.photos = {};
PJQ.views.photos.PhotoGallery = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Gallery'),
		subTemplates: {
			dateGroup: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Gallery-Date-Group'),
			photo: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Gallery-Photo')
		},
		canExport: true,
		previewImageDimension: 160,
		showCreatedByLink: true
	},
	events: {
		'click .gallery-photo-image': 'viewPhoto',
		'click .gallery-photo-download': 'downloadPhoto',
		'keyup .gallery-search': 'filter',
		'click .select-photo': 'selectPhoto',
		'click .select-date-group': 'selectDateGroup',
		'click .group-by': 'selectGroupBy'
	},
	beforeFirstRender: function () {
		if (this.collection == null && this.options.project != null) {
			this.options.canExport = this.options.project.hasPermission('photoGallery.canExport');
			this.options.project.fetchGalleryPhotos(_.bind(function (photos) {
				this.collection = photos;
				this.render();
			}, this));
			return false;
		}
	},
	beforeRender: function () {
		this.groupBy = "day";
		this.renderData = {
			collection: this.collection,
			groupByDefault: this.groupBy,
			groupByOptions: ["Year", "Month", "Week", "Day"]
		}
	},
	afterRender: function () {
		if (this.collection == null) {
			new PJQ.Loader(this.$('.photo-gallery'));
		}
		else {
			this.renderPhotos();
		}

		this.filesToolbar = new PJQ.views.toolbars.FilesToolbar({
			el: this.$el,
			isPhotos: true,
			onClose: _.bind(function () {
				this.deselectAll();
			}, this)
		});

		this.startDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.gallery-filter-start-date'),
			isShowTimezone: false,
			datepickerOptions: {
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function () {
				this.filter();
			}, this)
		});

		this.endDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.gallery-filter-end-date'),
			isShowTimezone: false,
			datepickerOptions: {
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function () {
				this.filter();
			}, this)
		});
	},
	renderPhotos() {
		if (_.size(this.collection.models) === 0) {
			this.$('.photos-container .list-empty').removeClass('hidden');
		}
		else {
			let groupedPhotos;
			switch (this.groupBy) {
				case 'year':
				case 'month':
				case 'day':
					let dateFormat;
					if (this.groupBy === 'year') {
						dateFormat = 'yyyy';
					}
					else if (this.groupBy === 'month') {
						dateFormat = 'MMMM';
					}
					else if (this.groupBy === 'day') {
						dateFormat = 'ddd, MMM dd, yyyy';
					}
					groupedPhotos = _.groupBy(this.collection.models, function (model) {
						return PJQ.helpers.dateHelpers.getDateString(model.get('createdOn'), dateFormat);
					});
					break;
				case 'week':
					let startDateFormat = 'MMM dd',
						endDateFormat = 'MMM dd, yyyy';
					groupedPhotos = _.groupBy(this.collection.models, function (model) {
						let weekBounds = PJQ.helpers.dateHelpers.getWeekBounds(model.get('createdOn'));
						return PJQ.helpers.dateHelpers.getDateString(weekBounds.start, startDateFormat) + ' - ' + PJQ.helpers.dateHelpers.getDateString(weekBounds.end, endDateFormat);
					});
					break;
			}

			this.$('.photos-container').empty();
			_.each(groupedPhotos, _.bind(function (photos, date) {
				let $groupEl = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.dateGroup, {
						date: date,
						canExport: this.options.canExport
					}),
					$datePhotos = $groupEl.find('.date-group-photos');
				_.each(photos, _.bind(function (photo) {
					this.renderPhoto($datePhotos, photo);
				}, this));
				this.$('.photos-container').append($groupEl);
			}, this));
			PJQ.app.lazyLoad().update();
		}
	},
	filter: function () {
		let self = this,
			search = this.$('.gallery-search').val().toLowerCase(),
			startDateFilter = this.startDatePicker.getValue(),
			endDateFilter = this.endDatePicker.getValue();
		//Go through each of the date containers
		this.$('.gallery-date-group').each(function () {
			let $date = $(this),
				visiblePhotoCount = 0;
			//Now go through each of the photos in the date containers, keeping count of how many photos are made visible
			$date.find('.gallery-photo-container').each(function () {
				let $photo = $(this),
					cid = $(this).data('cid'),
					photo = self.collection.get(cid);
				if (_.size(search) > 0 && photo.get('name').toLowerCase().indexOf(search) === -1) {
					$photo.addClass('hidden');
				}
				else if (startDateFilter != null || endDateFilter != null) {
					let createdOn = photo.get('createdOn');
					if (startDateFilter != null && createdOn < startDateFilter) {
						$photo.addClass('hidden');
					}
					else if (endDateFilter != null && createdOn > endDateFilter) {
						$photo.addClass('hidden');
					}
					else {
						$photo.removeClass('hidden');
						visiblePhotoCount++;
					}
				}
				else {
					$photo.removeClass('hidden');
					visiblePhotoCount++;
				}
			});

			//If there weren't any photos in this date container made visible, hide the whole date container
			if (visiblePhotoCount === 0) {
				$date.addClass('hidden');
			}
			else {
				$date.removeClass('hidden');
			}
		});
	},
	selectGroupBy: function (e) {
		let $groupBy = $(e.currentTarget);
		this.$('.group-by').not($groupBy).removeClass('selected');
		$groupBy.addClass('selected');

		this.groupBy = $groupBy.data('groupBy');
		this.filesToolbar.close();
		this.renderPhotos();
	},
	renderPhoto($container, file) {
		let $fileEl = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.photo, {
			model: file,
			canExport: this.options.canExport,
			previewImageDimension: this.options.previewImageDimension,
			showCreatedByLink: this.options.showCreatedByLink
		});
		$container.append($fileEl);
		return $fileEl;
	},
	viewPhoto: function (e) {
		let file = this.collection.get($(e.currentTarget).closest('.gallery-photo-container').data('cid'));
		PJQ.app.view.renderPhotoViewer({
			model: file,
			canDownload: this.options.canExport
		});
	},
	downloadPhoto: function (e) {
		let file = this.collection.get($(e.currentTarget).closest('.gallery-photo-container').data('cid'));
		file.download();
	},
	selectPhoto: function (e) {
		let $photo = $(e.currentTarget).closest('.gallery-photo-container'),
			cid = $photo.data('cid'),
			photoModel = this.collection.get(cid),
			isSelected = this.filesToolbar.collection.get(cid) != null;

		if (isSelected) {
			this.filesToolbar.removeFiles(photoModel);
			$photo.removeClass('selected');
			$photo.find('.select-photo').removeClass('fa-check-square').addClass('fa-square');
		}
		else {
			this.filesToolbar.addFiles(photoModel);
			$photo.addClass('selected');
			$photo.find('.select-photo').removeClass('fa-square').addClass('fa-check-square');
		}

		let $dateGroup = $photo.closest('.gallery-date-group');
		if (_.size($dateGroup.find('.gallery-photo-container:not(.selected)')) > 0) {
			$dateGroup.find('.select-date-group').removeClass('fa-check-square').addClass('fa-square');
			$dateGroup.removeClass('selected');
		}
		else {
			$dateGroup.find('.select-date-group').removeClass('fa-square').addClass('fa-check-square');
			$dateGroup.addClass('selected');
		}
	},
	selectDateGroup: function (e) {
		let self = this,
			$dateGroup = $(e.currentTarget).closest('.gallery-date-group'),
			isSelected = $dateGroup.hasClass('selected'),
			dateGroupPhotos = [];
		$dateGroup.find('.gallery-photo-container').each(function () {
			let $photo = $(this),
				cid = $photo.data('cid');
			dateGroupPhotos.push(self.collection.get(cid));
			if (isSelected) {
				$dateGroup.find('.select-date-group, .select-photo').removeClass('fa-check-square').addClass('fa-square');
				$photo.removeClass('selected');
			}
			else {
				$dateGroup.find('.select-date-group, .select-photo').removeClass('fa-square').addClass('fa-check-square');
				$photo.addClass('selected');
			}
		});

		if (isSelected) {
			this.filesToolbar.removeFiles(dateGroupPhotos);
			$dateGroup.removeClass('selected');
		}
		else {
			this.filesToolbar.addFiles(dateGroupPhotos);
			$dateGroup.addClass('selected');
		}
	},
	deselectAll: function () {
		this.$('.gallery-photo-container.selected,.gallery-date-group.selected').removeClass('selected');
		this.$('.select-date-group, .select-photo').removeClass('fa-check-square').addClass('fa-square');
	}
});

PJQ.collections.photos = {};
PJQ.collections.photos.PhotoShare = PJQ.collections.files.FileShare.extend({
	model: PJQ.models.files.File,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'photos'
			},
			{
				endpoint: 'share',
				value: this.options.shareGuid
			}
		]);
	}
});

PJQ.modules.photos = {
	routes: [
		{
			route: 'photos/share/:id',
			name: 'sharePhotos',
			callback: function (id) {
				let photos = new PJQ.collections.photos.PhotoShare(null, {
					shareGuid: id
				});
				photos.fetch({
					success: function () {
						PJQ.app.view.renderView(PJQ.views.photos.PhotoGallery, {
							collection: photos
						});
					}
				});
			}
		},
		{
			route: 'projects/:projectId/photos',
			name: 'projectPhotos',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectphotos");
			}
		},
		{
			route: 'projects/:projectId/photos/:photoId',
			name: 'projectPhotos',
			callback: function (projectId, photoId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectphotos");
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.photos.routes);
$(function () {
	let lastTime = 0,
		vendors = ['ms', 'moz', 'webkit', 'o'];
	for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	}

	if (!window.requestAnimationFrame)
		window.requestAnimationFrame = function (callback) {
			let currTime = new Date().getTime(),
				timeToCall = Math.max(0, 16 - (currTime - lastTime)),
				id = window.setTimeout(function () {
						callback(currTime + timeToCall);
					},
					timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};

	if (!window.cancelAnimationFrame)
		window.cancelAnimationFrame = function (id) {
			clearTimeout(id);
		};
});

PJQ.helpers.photoHelpers = {
	easeOutQuart: function (currentTime, initialVal, changedVal, duration) {
		currentTime /= duration;
		currentTime--;
		return -changedVal * (currentTime * currentTime * currentTime * currentTime - 1) + initialVal;
	}
};

PJQ.views.photos.PhotoViewer = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Viewer'),
		elementId: 'iv-outer',
		zoomValue: 100,
		snapView: true,
		maxZoom: 500,
		refreshOnResize: true,
		canDownload: true,
		zoomOnMouseWheel: true,
		triggerRoute: false,
		onDelete: _.noop,
		shouldCreateCanvas: false,
		keyListeners: [
			{
				which: 27,
				keys: ['Escape', 'Esc'],
				callback: function () {
					this.destroy();
				}
			},
			{
				which: 37,
				callback: function () {
					this.previous();
				}
			},
			{
				which: 39,
				callback: function () {
					this.next();
				}
			},
			{
				which: 68,
				shiftKey: true,
				callback: function () {
					this.downloadFile();
					$(window).focus();
				}
			},
			{
				which: 82,
				shiftKey: true,
				callback: function () {
					this.destroy();
				}
			}
		]
	},
	events: {
		'click .iv-prev': 'previous',
		'click .iv-next': 'next',
		'click .iv-rotate-neg-90': 'rotateNeg90',
		'click .iv-rotate-90': 'rotate90'
	},
	beforeFirstRender: function () {
		let viewport = document.querySelector('meta[name="viewport"]');
		if (viewport) {
			viewport.content = "width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0";
		}

		let $body = $('body');

		//First set the element to the outer container so the photo gallery view renders inside of it
		this.setElement($('#' + this.options.elementId));

		if (_.size(this.$el) === 0) {
			let $outer = $('<div>', {
				id: this.options.elementId
			});
			$body.append($outer);
			this.setElement($outer);
		}

		$body.css('overflow', 'hidden');

		this.ZOOM_CONSTANT = 40;
		this.MOUSE_WHEEL_COUNT = 5;
		this.zoomValue = 100;

		this.options.previousRoute = PJQ.app.router.getCurrentRoute();
		if (this.options.route) {
			PJQ.app.router.navigate(this.options.route);
		}
	},
	renderData: function () {
		return {
			model: this.model,
			options: this.options
		};
	},
	setContainerDimensions: function () {
		let $window = $(window);
		this.$el.css({
			"max-width": $window.width(),
			"max-height": $window.height()
		});
	},
	afterRender: function () {
		let $contain = this.$('.iv-container');
		this.setElement($contain);
		this.setContainerDimensions();

		if (this.options.canDownload) {
			this.$('.iv-download').removeClass('hidden');
		}

		if (this.options.canDelete) {
			this.$('.iv-delete').removeClass('hidden');
		}

		if (this.$el.css('position') === 'static') {
			this.$el.css('position', 'relative');
		}

		this.snapView = this.$('.iv-snap-view');
		this.snapImageWrap = this.$('.iv-snap-image-wrap');
		this.imageView = this.$('.iv-image-view');
		this.imageWrap = this.$('.iv-image-wrap');
		this.snapHandle = this.$('.iv-snap-handle');
		this.zoomHandle = this.$('.iv-zoom-handle');
		this.createdOnDate = this.$('.photo-created-date');
		this._viewerId = 'iv_' + _.uniqueId();

		this.keydownListener = _.bind(function (e) {
			if ($(e.target).is(':input')) {
				return;
			}

			e = e || window.event;
			let listener = _.find(this.options.keyListeners, function (listener) {
				return (_.indexOf(listener.keys, e.key) !== -1 || listener.which === e.which) && (!listener.shiftKey || e.shiftKey);
			});
			if (listener != null && typeof listener.callback === 'function') {
				_.bind(listener.callback, this)();
			}
		}, this);

		let eventSuffix = '.' + this._viewerId;
		$(document).on('keydown' + eventSuffix, this.keydownListener);

		this.prevButton = this.$('.iv-prev');
		this.nextButton = this.$('.iv-next');

		this.init();

		this.initViewer();
	},
	downloadFile: function () {
		this.model.download();
	},
	initViewer: function () {
		if (this.model != null) {
			this.initPaging();
			this.renderPage();
		}
		else if (this.options.image) {
			this.show(this.options.image);
		}
	},
	initPaging: function () {
		this.pagingModels = _.sortBy(_.filter(this.model.collection.models, function (model) {
			return typeof model.isImage === 'function' && model.isImage();
		}), function (model) {
			return model.id ? -model.id : 0;
		});

		this.pageIndex = null;
		_.each(this.pagingModels, function (model, index) {
			if (model.cid === this.model.cid) {
				this.pageIndex = index;
			}
		}, this);

		if (this.pageIndex != null) {
			this.$('.iv-paging').removeClass('hidden');
			this.pagingDisplay = this.$('.iv-paging-display');
			this.renderPaging();
		}
	},
	renderPaging: function () {
		let modelCount = _.size(this.pagingModels);
		this.pagingDisplay.html((this.pageIndex + 1).toString() + ' of ' + modelCount.toString());
		if (this.pageIndex === 0) {
			this.prevButton.addClass('disabled');
		}
		else {
			this.prevButton.removeClass('disabled');
		}

		if ((this.pageIndex + 1) === modelCount) {
			this.nextButton.addClass('disabled');
		}
		else {
			this.nextButton.removeClass('disabled');
		}
	},
	renderPage: function () {
		this.model = this.pagingModels[this.pageIndex];
		let url = this.model.get('url');
		if (_.size(url) > 0) {
			this.show(this.model.get('url'));
		}
		else if (this.model.file != null && this.model.file.dataURL != null) {
			this.show(this.model.file.dataURL);
		}
	},
	previous: function () {
		if (this.pageIndex > 0) {
			--this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	next: function () {
		if ((this.pageIndex + 1) < _.size(this.pagingModels)) {
			++this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	rotate: function (degrees) {
		//this code is only needed if we want to implement saved rotation and not just temporary viewing rotation
		// new PJQ.ajax.Request({
		// 	endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
		// 		{
		// 			endpoint: 'files',
		// 			value: this.model.get('guid')
		// 		},
		// 		{
		// 			endpoint: 'rotate'
		// 		}
		// 	], [
		// 		{
		// 			parameter: 'degrees',
		// 			value: degrees
		// 		}
		// 	])
		// }).put().done(_.bind(function () {
		// 	this.renderPage();
		// }, this));
		let rotation = this.model.get('rotation') != null ? this.model.get('rotation') : 0;
		if (rotation === 0 && degrees < 0) {
			rotation = 360;
		}
		else if (rotation === 360 && degrees > 0) {
			rotation = 0;
		}
		this.model.set('rotation', (rotation + degrees) % 360);
		this.renderPage();
	},
	rotate90: function () {
		this.rotate(90);
	},
	rotateNeg90: function () {
		this.rotate(-90)
	},
	canDrag: function () {
		return true;
	},
	canZoom: function () {
		return true;
	},
	shouldCreateCanvas: function () {
		return this.options.shouldCreateCanvas === true;
	},
	init: function () {
		let viewer = this,
			options = this.options,
			eventSuffix = '.' + viewer._viewerId,
			snapHandle = this.snapHandle,
			snapImgWrap = this.snapImageWrap,
			imageWrap = this.imageWrap,
			snapSlider = new PJQ.views.photos.Slider(snapImgWrap, {
				sliderId: viewer._viewerId,
				onStart: function () {
					if (!viewer.loaded) {
						return false;
					}

					this.curHandleTop = parseFloat(snapHandle.css('top'));
					this.curHandleLeft = parseFloat(snapHandle.css('left'));
					this.handleWidth = parseFloat(snapHandle.width());
					this.handleHeight = parseFloat(snapHandle.height());

					this.width = snapImgWrap.width();
					this.height = snapImgWrap.height();

					//stop momentum on image
					clearInterval(imageSlider.slideMomentumCheck);
					cancelAnimationFrame(imageSlider.sliderMomentumFrame);
				},
				onMove: function (e, position) {
					let maxLeft = Math.max(this.width - this.handleWidth, this.curHandleLeft),
						maxTop = Math.max(this.height - this.handleHeight, this.curHandleTop),
						minLeft = Math.min(0, this.curHandleLeft),
						minTop = Math.min(0, this.curHandleTop),
						left = PJQ.helpers.mathHelpers.clamp(this.curHandleLeft + position.dx, minLeft, maxLeft),
						top = PJQ.helpers.mathHelpers.clamp(this.curHandleTop + position.dy, minTop, maxTop),
						imgLeft = viewer.imgWidth < viewer.containerDim.w ? (viewer.containerDim.w - viewer.imgWidth) / 2 : -left * viewer.imgWidth / this.width,
						imgTop = viewer.imgHeight < viewer.containerDim.h ? (viewer.containerDim.h - viewer.imgHeight) / 2 : -top * viewer.imgHeight / this.height;

					snapHandle.css({
						top: top + 'px',
						left: left + 'px'
					});

					viewer.currentImg.css({
						left: imgLeft,
						top: imgTop
					});
					if (viewer.shouldCreateCanvas()) {
						viewer.$canvas.css({
							left: imgLeft,
							top: imgTop
						});

						viewer.$activeCanvas.css({
							left: imgLeft,
							top: imgTop
						});

						viewer.$tooltips.css({
							left: imgLeft,
							top: imgTop
						});

						let cOff = viewer.$canvas.offset();
						viewer.canvas.x = cOff.left;
						viewer.canvas.y = cOff.top;
					}
				}
			}).init();

		/*Add slide interaction to image*/
		let imageSlider = viewer._imageSlider = new PJQ.views.photos.Slider(imageWrap, {
			viewer: viewer,
			sliderId: viewer._viewerId,
			onStart: function (e, position) {
				if (!viewer.loaded) {
					return false;
				}
				if (viewer.zooming) {
					return;
				}
				let self = this;
				snapSlider.onStart();

				self.positions = [position, position];

				self.startPosition = position;

				//clear all animation frame and interval
				viewer._clearFrames();

				self.slideMomentumCheck = setInterval(function () {
					if (!self.currentPos) {
						return;
					}

					self.positions.shift();
					self.positions.push({
						x: self.currentPos.mx,
						y: self.currentPos.my
					})
				}, 30);
			},
			onMove: function (e, position) {
				if (viewer.zooming) {
					return;
				}
				this.currentPos = position;

				snapSlider.onMove(e, {
					dx: -position.dx * snapSlider.width / viewer.imgWidth,
					dy: -position.dy * snapSlider.height / viewer.imgHeight
				});
			},
			onEnd: function () {
				if (viewer.zooming) {
					return;
				}
				let self = this,
					xDiff = this.positions[1].x - this.positions[0].x,
					yDiff = this.positions[1].y - this.positions[0].y,
					positionX = 0,
					positionY = 0,
					step = 1;

				if (Math.abs(xDiff) > 30 || Math.abs(yDiff) > 30) {
					positionX = self.currentPos.dx;
					positionY = self.currentPos.dy;

					function momentum() {
						if (step <= 60) {
							self.sliderMomentumFrame = requestAnimationFrame(momentum);
						}

						positionX = positionX + PJQ.helpers.photoHelpers.easeOutQuart(step, xDiff / 3, -xDiff / 3, 60);
						positionY = positionY + PJQ.helpers.photoHelpers.easeOutQuart(step, yDiff / 3, -yDiff / 3, 60);

						snapSlider.onMove(null, {
							dx: -((positionX) * snapSlider.width / viewer.imgWidth),
							dy: -((positionY) * snapSlider.height / viewer.imgHeight)
						});
						step++;
					}

					momentum();
				}
			}
		}).init();

		/*Add zoom iteration in mouse wheel*/
		let changedDelta = 0,
			self = this;
		imageWrap.on("mousewheel" + eventSuffix + " DOMMouseScroll" + eventSuffix, function (e) {
			if (!viewer.loaded || !options.zoomOnMouseWheel || !self.canZoom()) {
				return;
			}

			//clear all animation frame and interval
			viewer._clearFrames();

			// cross-browser wheel delta
			let delta = Math.max(-1, Math.min(1, (e.originalEvent.wheelDelta || -e.originalEvent.detail))),
				zoomValue = viewer.zoomValue * (100 + delta * viewer.ZOOM_CONSTANT) / 100;
			if (!(zoomValue >= 100 && zoomValue <= options.maxZoom)) {
				changedDelta += Math.abs(delta);
			}
			else {
				changedDelta = 0;
			}

			if (changedDelta > viewer.MOUSE_WHEEL_COUNT) {
				return;
			}

			e.preventDefault();

			let contOffset = self.$el.offset(),
				x = (e.pageX || e.originalEvent.pageX) - contOffset.left,
				y = (e.pageY || e.originalEvent.pageY) - contOffset.top;


			viewer.zoom(zoomValue, {
				x: x,
				y: y
			});

			//show the snap viewer
			showSnapView();
		});


		//apply pinch and zoom feature
		imageWrap.on('touchstart' + eventSuffix, function (eStart) {
			if (!self.canDrag() || !viewer.loaded) {
				return;
			}

			let touch0 = eStart.originalEvent.touches[0],
				touch1 = eStart.originalEvent.touches[1];
			if (!(touch0 && touch1)) {
				return;
			}

			viewer.zooming = true;

			let contOffset = self.$el.offset(),
				startDist = Math.sqrt(Math.pow(touch1.pageX - touch0.pageX, 2) + Math.pow(touch1.pageY - touch0.pageY, 2)),
				startZoom = viewer.zoomValue,
				center = {
					x: ((touch1.pageX + touch0.pageX) / 2) - contOffset.left,
					y: ((touch1.pageY + touch0.pageY) / 2) - contOffset.top
				},
				$document = $(document),
				moveListener = function (eMove) {
					eMove.preventDefault();

					let touch0 = eMove.originalEvent.touches[0],
						touch1 = eMove.originalEvent.touches[1],
						newDist = Math.sqrt(Math.pow(touch1.pageX - touch0.pageX, 2) + Math.pow(touch1.pageY - touch0.pageY, 2)),
						zoomValue = startZoom + (newDist - startDist) / 2;

					viewer.zoom(zoomValue, center);
				},
				endListener = function () {
					$document.off('touchmove', moveListener);
					$document.off('touchend', endListener);
					viewer.zooming = false;
				};

			$document.on('touchmove', moveListener);
			$document.on('touchend', endListener);
		});


		//handle double tap for zoom in and zoom out
		let touchtime = 0,
			point;
		imageWrap.on('click' + eventSuffix, function (e) {
			if (!self.canDrag()) {
				return;
			}

			if (touchtime === 0) {
				touchtime = Date.now();
				point = {
					x: e.pageX,
					y: e.pageY
				};
			}
			else {
				if ((Date.now() - touchtime) < 500 && Math.abs(e.pageX - point.x) < 50 && Math.abs(e.pageY - point.y) < 50) {
					if (viewer.zoomValue === options.zoomValue) {
						viewer.zoom(200)
					}
					else {
						viewer.resetZoom()
					}
					touchtime = 0;
				}
				else {
					touchtime = 0;
				}
			}
		});

		//zoom in zoom out using zoom handle
		let slider = viewer.snapView.find('.iv-zoom-slider');
		new PJQ.views.photos.Slider(slider, {
			viewer: viewer,
			sliderId: viewer._viewerId,
			onStart: function (eStart) {
				if (!viewer.loaded) {
					return false;
				}

				this.leftOffset = slider.offset().left;
				this.handleWidth = viewer.zoomHandle.width();
				this.onMove(eStart);
			},
			onMove: function (e) {
				let newLeft = (e.pageX || e.originalEvent.touches[0].pageX) - this.leftOffset - this.handleWidth / 2;

				newLeft = Math.max(0, newLeft);
				newLeft = Math.min(viewer._zoomSliderLength, newLeft);

				let zoomValue = 100 + (options.maxZoom - 100) * newLeft / viewer._zoomSliderLength;
				viewer.zoom(zoomValue);
			}
		}).init();

		//display snapView on interaction
		let snapViewTimeout,
			snapViewVisible;

		function showSnapView(noTimeout) {
			if (!options.snapView) {
				return;
			}

			if (snapViewVisible || viewer.zoomValue <= 100 || !viewer.loaded) {
				return;
			}
			clearTimeout(snapViewTimeout);
			snapViewVisible = true;
			viewer.snapView.css('opacity', 1);
			if (!noTimeout) {
				snapViewTimeout = setTimeout(function () {
					viewer.snapView.css('opacity', 0);
					snapViewVisible = false;
				}, 4000);
			}
		}

		imageWrap.on('touchmove' + eventSuffix + ' mousemove' + eventSuffix, function () {
			showSnapView();
		});

		let snapEventsCallback = {};
		snapEventsCallback['mouseenter' + eventSuffix + ' touchstart' + eventSuffix] = function () {
			snapViewVisible = false;
			showSnapView(true);
		};

		snapEventsCallback['mouseleave' + eventSuffix + ' touchend' + eventSuffix] = function () {
			snapViewVisible = false;
			showSnapView();
		};

		viewer.snapView.on(snapEventsCallback);

		//calculate elements size on window resize
		if (options.refreshOnResize) {
			$(window).on('resize' + eventSuffix, function () {
				viewer.refresh()
			});
		}

		//prevent scrolling the backside if container if fixed positioned
		this.imageView.on('touchmove' + eventSuffix + ' mousewheel' + eventSuffix + ' DOMMouseScroll' + eventSuffix, function (e) {
			e.preventDefault();
		});

		//assign event on close button
		this.$el.find('.iv-close').on('click' + eventSuffix, function () {
			viewer.destroy();
		});

		//assign event on delete button
		this.$el.find('.iv-delete').on('click' + eventSuffix, function () {
			viewer.delete();
		});

		//assign event on delete button
		this.$el.find('.iv-download').on('click' + eventSuffix, function (e) {
			viewer.download(e);
		});
	},
	zoom: function (perc, point) {
		perc = Math.round(Math.max(100, perc));
		perc = Math.min(this.options.maxZoom, perc);

		point = point || {
			x: this.containerDim.w / 2,
			y: this.containerDim.h / 2
		};

		this.lastZoomPoint = point;

		let maxZoom = this.options.maxZoom,
			curPerc = this.zoomValue,
			curImg = this.currentImg,
			curLeft = parseFloat(curImg.css('left')),
			curTop = parseFloat(curImg.css('top')),
			step = 0;

		this._clearFrames();

		//calculate base top,left,bottom,right
		let containerDim = this.containerDim,
			imageDim = this.imageDim,
			baseLeft = (containerDim.w - imageDim.w) / 2,
			baseTop = (containerDim.h - imageDim.h) / 2,
			baseRight = containerDim.w - baseLeft,
			baseBottom = containerDim.h - baseTop;
		let zoom = _.bind(function () {
			step++;

			if (step < 5) {
				this._zoomFrame = requestAnimationFrame(zoom);
			}

			let tickZoom = PJQ.helpers.photoHelpers.easeOutQuart(step, curPerc, perc - curPerc, 5),
				ratio = tickZoom / curPerc,
				imgWidth = this.imageDim.w * tickZoom / 100,
				imgHeight = this.imageDim.h * tickZoom / 100,
				newLeft = -((point.x - curLeft) * ratio - point.x),
				newTop = -((point.y - curTop) * ratio - point.y);

			//fix for left and top
			if(this.prevItemInfo && step === 5){
				let wIncrease = (this.prevItemInfo.canvas.width / this.canvas.width) * 100,
					hIncrease = (this.prevItemInfo.canvas.height / this.canvas.height) * 100

				if(wIncrease !== 100){
					newLeft = (this.prevItemInfo.position.left / wIncrease) * 100
				}
				else{
					newLeft = this.prevItemInfo.position.left
				}
				if(hIncrease !== 100){
					newTop = (this.prevItemInfo.position.top / hIncrease) * 100
				}
				else{
					newTop = this.prevItemInfo.position.top
				}
				this.prevItemInfo = null;
			}
			else {
				newLeft = Math.min(newLeft, baseLeft);
				newTop = Math.min(newTop, baseTop);
			}

			//fix for right and bottom
			if ((newLeft + imgWidth) < baseRight) {
				newLeft = baseRight - imgWidth; //newLeft - (newLeft + imgWidth - baseRight)
			}

			if ((newTop + imgHeight) < baseBottom) {
				newTop = baseBottom - imgHeight; //newTop + (newTop + imgHeight - baseBottom)
			}


			let css = {
				height: imgHeight + 'px',
				width: imgWidth + 'px',
				left: newLeft + 'px',
				top: newTop + 'px'
			};
			curImg.css(css);
			if (this.shouldCreateCanvas()) {
				this.$canvas[0].height = imgHeight;
				this.$canvas[0].width = imgWidth;
				this.$canvas.css(css);
				this.$activeCanvas.css(css);
				this.$activeCanvas[0].height = imgHeight;
				this.$activeCanvas[0].width = imgWidth;
				this.$tooltips.css(css);

				let cOff = this.$canvas.offset();
				this.canvas = {
					width: imgWidth,
					height: imgHeight,
					x: cOff.left,
					y: cOff.top
				};
			}

			this.zoomValue = tickZoom;

			this._resizeHandle(imgWidth, imgHeight, newLeft, newTop);

			//update zoom handle position
			this.zoomHandle.css('left', ((tickZoom - 100) * this._zoomSliderLength) / (maxZoom - 100) + 'px');
		}, this);

		zoom();
	},
	_clearFrames: function () {
		clearInterval(this._imageSlider.slideMomentumCheck);
		cancelAnimationFrame(this._imageSlider.sliderMomentumFrame);
		cancelAnimationFrame(this._zoomFrame)
	},
	resetZoom: function () {
		this.lastZoomPoint = null;
		this.zoom(this.options.zoomValue);
	},
	//calculate dimensions of image, container and reset the image
	_calculateDimensions: function () {
		this.setContainerDimensions();

		//calculate content width of image and snap image
		let imageWidth = this.currentImg.width(),
			imageHeight = this.currentImg.height(),
			$iv = this.$('.iv-image-view'),
			contWidth = $iv.width(),
			contHeight = $iv.height(),
			snapViewWidth = this.snapView.innerWidth(),
			snapViewHeight = this.snapView.innerHeight();

		this.containerDim = {
			w: contWidth,
			h: contHeight
		};

		//set the image dimension
		let isFlipped = this.currentImg.hasClass('transform-rotate-90') || this.currentImg.hasClass('transform-rotate-270');
		if (isFlipped) {
			let ratio = imageHeight / imageWidth,
				imgHeight = (imageWidth > imageHeight && contHeight >= contWidth) || ratio * contHeight > contWidth ? contWidth : ratio * contHeight,
				imgWidth = imgHeight / ratio;

			this.imageDim = {
				w: imgWidth - 120,
				h: imgHeight - (120 * ratio)
			};

			//set the snap Image dimension
			this.snapImg.css({
				width: this.imageDim.w > this.imageDim.h ? snapViewHeight : this.imageDim.w * snapViewHeight / this.imageDim.h,
				height: this.imageDim.h > this.imageDim.w ? snapViewWidth : this.imageDim.h * snapViewWidth / this.imageDim.w
			});
		}
		else {
			let ratio = imageWidth / imageHeight,
				imgWidth = (imageWidth > imageHeight && contHeight >= contWidth) || ratio * contHeight > contWidth ? contWidth : ratio * contHeight,
				imgHeight = imgWidth / ratio;

			this.imageDim = {
				h: imgHeight - 120,
				w: imgWidth - (120 * ratio)
			};

			//set the snap Image dimension
			this.snapImg.css({
				width: this.imageDim.w > this.imageDim.h ? snapViewWidth : this.imageDim.w * snapViewHeight / this.imageDim.h,
				height: this.imageDim.h > this.imageDim.w ? snapViewHeight : this.imageDim.h * snapViewWidth / this.imageDim.w
			});
		}

		this.imgWidth = this.imageDim.w * this.zoomValue / 100;
		this.imgHeight = this.imageDim.h * this.zoomValue / 100;

		//reset image position and zoom
		let newLeft = (contWidth - this.imageDim.w) / 2,
			newTop = (contHeight - this.imageDim.h) / 2,
			css = {
				width: this.imageDim.w + 'px',
				height: this.imageDim.h + 'px',
				left: newLeft + 'px',
				top: newTop + 'px',
				'max-width': 'none',
				'max-height': 'none'
			};
		this.currentImg.css(css);

		if (this.shouldCreateCanvas()) {
			this.$canvas.css(css);
			this.$activeCanvas.css(css);
			this.$tooltips.css(css);

			let cOff = this.$canvas.offset();
			this.canvas = {
				width: this.imageDim.w,
				height: this.imageDim.h,
				x: cOff.left,
				y: cOff.top
			};
		}

		//calculate zoom slider area
		this._zoomSliderLength = snapViewWidth - this.zoomHandle.outerWidth();
	},
	refresh: function (refreshOpts) {
		if (!this.loaded) {
			return;
		}
		this._calculateDimensions();
		this.resetZoom();
	},
	_resizeHandle: function (imgWidth, imgHeight, imgLeft, imgTop) {
		this.imgWidth = imgWidth || this.imageDim.w * this.zoomValue / 100;
		this.imgHeight = imgHeight || this.imageDim.h * this.zoomValue / 100;

		let left = Math.max(-(imgLeft || parseFloat(this.currentImg.css('left'))) * 100 / this.imgWidth, 0),
			top = Math.max(-(imgTop || parseFloat(this.currentImg.css('top'))) * 100 / this.imgHeight, 0),
			handleWidth = Math.min(this.containerDim.w * 100 / this.imgWidth, 100),
			handleHeight = Math.min(this.containerDim.h * 100 / this.imgWidth, 100);

		this.snapHandle.css({
			top: top + '%',
			left: left + '%',
			width: handleWidth + '%',
			height: handleHeight + '%'
		});

		if (this.loaded) {
			this.afterDimensionChange();
		}
	},
	afterDimensionChange: function () {

	},
	show: function (image, showOpts) {
		this.$el.show();
		if (image) {
			this.load(image, showOpts);
		}
	},
	options: function (key, value) {
		if (!value) {
			return this.options[key];
		}
		this.options[key] = value;
	},
	destroy: function () {
		if (this.options.route) {
			PJQ.app.router.navigate(this.options.previousRoute, {
				trigger: this.options.triggerRoute
			});
			this.options.triggerRoute = false;
			this.options.route = null;
		}

		$(window).off('.' + this._viewerId);
		$(document).off('.' + this._viewerId);
		this.$el.off();
		this.$el.remove();
		this.onClose();

		$('body').css('overflow', 'auto');
	},
	onClose: function(){
		if (typeof this.options.onClose === 'function') {
			this.options.onClose();
		}
	},
	delete: function () {
		this.model.destroy();
		this.collection.remove(this.model);
		this.options.onDelete(this.model);
		this.destroy()
	},
	download: function () {
		this.model.download();
	},
	load: function (image, loadOpts = {persistZoom: false}) {
		//Clear any images that are already in the view/snap
		this.$('.iv-snap-image,.iv-large-image').remove();

		this.loader = new PJQ.Loader(this.imageView);

		//Add the snap image
		this.snapImg = $('<img>', {
			class: 'iv-snap-image',
			src: image,
			style: 'display:none;'
		});
		this.$('.iv-snap-image-wrap').prepend(this.snapImg);

		this.imageWrap.empty();

		//Add the full image
		this.imageWrap.prepend($('<img>', {
			class: 'iv-large-image noselect',
			src: image,
			style: 'display:none;'
		}));

		if (this.shouldCreateCanvas()) {
			this.imageWrap.prepend($('<div>', {
				class: 'iv-tooltips-outer noselect'
			}));

			this.imageWrap.prepend($('<canvas>', {
				class: 'iv-canvas noselect'
			}));

			this.imageWrap.append($('<canvas>', {
				class: 'iv-active-canvas noselect'
			}));

			this.$canvas = this.$('.iv-canvas');
			this.ctx = this.$canvas[0].getContext('2d');

			this.$activeCanvas = this.$('.iv-active-canvas');
			this.activeCtx = this.$activeCanvas[0].getContext('2d');

			this.$tooltips = this.$('.iv-tooltips-outer');
		}

		this.currentImg = this.$('.iv-large-image');

		this.loaded = false;

		if(this.model && this.model.get('createdOn')) {
			this.createdOnDate.attr('hidden', false);
			this.createdOnDate.html(PJQ.helpers.dateHelpers.getDateString(this.model.get('createdOn'), PJQ.helpers.dateHelpers.dateFormats.DATE));
		}
		else{
			this.createdOnDate.attr('hidden', true);
		}

		//refresh the view
		let refreshView = _.bind(function () {
			this.afterImageDownload();

			let fnRender = _.bind(function () {
				this.loader.remove();
				this.loaded = true;

				let newZoom = this.zoomValue,
					newZoomPoint = this.lastZoomPoint;
				this.zoomValue = 100;
				this.refresh(loadOpts);
				if (loadOpts.persistZoom && this.prevItemInfo) {
					this.zoom(newZoom, newZoomPoint);
				}
				else {
					this.resetZoom();
				}

				this.afterLoad();

				this.currentImg.show();
				this.snapImg.show();
			}, this);
			let chromeVer = PJQ.helpers.browserHelpers.getChromeVersion();
			if (this.model.get('rotation') != null && !(this.model instanceof PJQ.models.drawings.Drawing)) {
				PJQ.helpers.imageHelpers.rotateElement(this.currentImg.add(this.snapImg), this.model.get('rotation'));
				fnRender();
			}
			else if (chromeVer == null || chromeVer >= 81) {
				fnRender();
			}
			else {
				PJQ.helpers.imageHelpers.rotateByExif(this.currentImg.add(this.snapImg), _.bind(function () {
					fnRender();
				}, this));
			}
		}, this);

		let currentImage = this.currentImg[0];
		if (currentImage.complete && (typeof currentImage.naturalWidth === 'undefined' || currentImage.naturalWidth !== 0)) {
			refreshView();
		}
		else {
			$(currentImage).on('load', refreshView);
		}
	},
	afterImageDownload: function () {

	},
	afterLoad: function(){}
});

PJQ.views.files.FileViewer = PJQ.views.photos.PhotoViewer.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Viewer'),
		zoomValue: 100,
		snapView: true,
		maxZoom: 500,
		refreshOnResize: true,
		zoomOnMouseWheel: true,
		triggerRoute: false,
		isDisableDownload: true
	},
	events: {
		'click .iv-prev': 'previous',
		'click .iv-next': 'next',
		'contextmenu .iv-image-view': 'preventRightClick'
	},
	initPaging: function () {
		this.pageCount = this.model.get('pages');
		if (!(this.pageCount > 0)) {
			this.pageCount = 1;
		}
		this.pageIndex = 0;

		this.renderPaging();
	},
	renderPaging: function () {
		if (this.pageCount > 1) {
			this.$('.iv-paging').removeClass('hidden');
			this.pagingDisplay = this.$('.iv-paging-display');

			this.pagingDisplay.html((this.pageIndex + 1).toString() + ' of ' + this.pageCount.toString());
			if (this.pageIndex === 0) {
				this.prevButton.addClass('disabled');
			}
			else {
				this.prevButton.removeClass('disabled');
			}

			if ((this.pageIndex + 1) === this.pageCount) {
				this.nextButton.addClass('disabled');
			}
			else {
				this.nextButton.removeClass('disabled');
			}
		}
		else {
			this.$('.iv-paging').addClass('hidden');
		}
	},
	renderPage: function () {
		if (this.$('.iv-image-view').length > 0) {
			this.show(this.model.renderUrl(this.pageIndex + 1));
		}
	},
	previous: function () {
		if (this.pageIndex > 0) {
			--this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	next: function () {
		if ((this.pageIndex + 1) < this.pageCount) {
			++this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	afterImageDownload: function () {
		if (!(this.model.get('pages') > 0)) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'files',
						value: this.model.get('entryId')
					},
					{
						endpoint: 'pages'
					}])
			}).get().done(_.bind(function (response) {
				this.model.set('pages', response.pages);
				this.initPaging();
			}, this));
		}
		else {
			this.renderPaging();
		}
	},
	preventRightClick: function () {
		return false;
	}
});

PJQ.views.photos.Slider = class {
	constructor($el, options) {
		this.container = $el;
		this.onStart = options.onStart || _.noop;
		this.onMove = options.onMove || _.noop;
		this.onEnd = options.onEnd || _.noop;
		this.sliderId = options.sliderId || 'slider' + Math.ceil(Math.random() * 1000000);
		this.viewer = options.viewer ? options.viewer : null;
	}

	init() {
		let self = this,
			eventSuffix = '.' + this.sliderId,
			$document = $(document);

		//assign event on snap image wrap
		this.container.on('touchstart' + eventSuffix + ' mousedown' + eventSuffix, function (eStart) {
			let def = function (eStart) {
				eStart.preventDefault();
				let touchMove = (eStart.type === "touchstart" ? "touchmove" : "mousemove") + eventSuffix,
					touchEnd = (eStart.type === "touchstart" ? "touchend" : "mouseup") + eventSuffix,
					eOriginal = eStart.originalEvent,
					sx = eOriginal.clientX || eOriginal.touches[0].clientX,
					sy = eOriginal.clientY || eOriginal.touches[0].clientY,
					start = self.onStart(eStart, {
						x: sx,
						y: sy
					});
				if (start === false)
					return;

				let moveListener = function (eMove) {
						eMove.preventDefault();

						eOriginal = eMove.originalEvent;

						//get the coordinates
						let mx = eOriginal.clientX || eOriginal.touches[0].clientX,
							my = eOriginal.clientY || eOriginal.touches[0].clientY;

						self.onMove(eMove, {
							dx: mx - sx,
							dy: my - sy,
							mx: mx,
							my: my
						});

					},
					endListener = function () {
						$document.off(touchMove, moveListener);
						$document.off(touchEnd, endListener);
						self.onEnd();
					};

				$document.on(touchMove, moveListener);
				$document.on(touchEnd, endListener);
			}
			if (self.viewer && typeof self.viewer.onMouseDown === 'function' && (false === self.viewer.canDrag() || false === self.viewer.onMouseDown(eStart, def))) {
				return;
			}
			def(eStart);
		});

		return this;
	}
};
//Models
PJQ.models.preferences = {};

PJQ.models.preferences.Preferences = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'preferences'
			}
		])
	},
	afterInit: function () {
		if (this.get('preferences') == null)
			this.set('preferences', {});
	},
	getPref: function (key) {
		return this.get('preferences')[key];
	},
	hasPref: function (key) {
		return typeof this.get('preferences')[key] !== 'undefined';
	},
	setPref: function (key, value) {
		this.get('preferences')[key] = value;
	},
	deletePref: function (key) {
		delete this.get('preferences')[key];
	}
});

PJQ.constants.preferenceTypes = {
	ACTION_ITEM_WORK_COMPLETED_STATUS_OVERRIDE: "actionItemWorkCompletedStatusOverride",
	ADD_PARTICIPANTS_BID_PACKAGE_RADIUS: "projectScopeRadius",
	ADDRESS_BOOK_DEFAULT_DISPLAY_DIRECTORY: "addressBookDefaultDisplayDirectory",
	ADDRESS_BOOK_COLOR_COLUMNS: "addressBookColorColumns",
	ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL: "addressBookContactCompanyIdLabel",
	ADDRESS_BOOK_CONTACT_ID_LABEL: "addressBookContactIdLabel",
	ADDRESS_BOOK_SHOW_PREQUAL_URL: "addressBookShowPrequalURL",
	ADDRESS_BOOK_SHOW_PREQUAL_EDITOR: "addressBookShowPrequalEditor",
	ADDRESS_BOOK_HIDE_DEFAULT_SEARCH: "addressBookHideDefaultSearch",
	ADDRESS_BOOK_HIDE_MINORITY_STATUS: "addressBookHideMinorityStatus",
	ADDRESS_BOOK_HIDE_SECTOR: "addressBookHideSector",
	ADDRESS_BOOK_APPROVAL_REQUIRED: "addressBookSelfAddApprovalRequired",
	ADDRESS_BOOK_CONTACT_UPDATER_ENABLED: "addressBookContactUpdaterEnabled",
	ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP: "addressBookEnableAdminRequiredFields",
	ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE: "addressBookEnableAdminRequiredFieldsCore",
	ADDRESS_BOOK_HIDE_INACTIVE_CONTACTS: "addressBookHideInactiveContacts",
	ADDRESS_BOOK_DEFAULT_COUNTRY: "addressBookDefaultCountry",
	ADDRESS_BOOK_DEFAULT_FILTERS: "addressBookDefaultFilters",
	ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS: "addressBookDefaultLocationFilters",
	ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE: "addressBookPreventDefaultUserType",
	ALLOW_SUB_GROUP_EDIT: "addressBookAllowSubGroupEdit",
	PJQ_REGISTRATION_WORKAREAS_OPTIONAL: "pjqRegistrationWorkAreasOptional",
	ALLOW_SUB_GROUP_EDIT_REQUIRED: "addressBookAllowSubGroupEditRequired",
	APP_NAV_ITEMS: "appNavItems",
	ASAP_SCHEDULE_CONTRAINT_ENABLED: "asapScheduleConstraintEnabled",
	BIDDING_PROJECTS_REQUIRE_APPROVAL: "biddingProjectsRequireApproval",
	BIDDING_PROJECTS_TAB_NAME: "biddingProjectsTabName",
	DISABLE_BIDDING_PROJECTS: "disableBiddingProjects",
	BIDDING_PROJECTS_INCLUDE_COLUMNS: "biddingProjectsIncludeColumns",
	BID_FORM_NOT_SUBMITTED_STATUS_NAME_OVERRIDE: "bidFormNotSubmittedStatusNameOverride",
	PORTAL_APP_NAV_ITEMS: "portalAppNavItems",
	CAN_EDIT_MINORITY_CLASS_SUB: "rsvpEditMinorityClassification",
	CAN_EDIT_UNION_STATUS_SUB: "rsvpEditUnionStatus",
	CAN_ORDER_ON_ACCOUNT: "canOrderOnAccount",
	COPY_SCOPES_GRID_LAYOUT: "copyProjectScopesGridLayout",
	DAILY_REPORT_ATTACHMENTS_NAME: "dailyReportAttachmentsName",
	DAILY_REPORT_SURVEY_NAME: "dailyReportSurveyName",
	DAILY_REPORT_NAV_ORDER: "dailyReportNavOrder",
	DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT: "isLockReportAfterSubmit",
	DRAWING_SHARE_PREVENT_EXPIRATION: "drawingSharePreventExpiration",
	DRAWING_HIDE_TITLE: "drawingsHideTitle",
	DRAWING_HIDE_TAG: "drawingsHideTag",
	DEFAULT_AUTO_SELECT_DISABLED: "defaultAutoSelectDisabled",
	ENABLE_BLUE_BOOK_PUBLISH: "isBlueBookPublishEnabled",
	DISABLE_BLUE_BOOK_PUBLISH: "isBlueBookPublishDisabled",
	DISABLE_BLUE_BOOK_PUBLISH_PORTAL: "isBlueBookPublishDisabledPortal",
	DISABLE_DAILY_REPORTS: "isDailyReportsDisabled",
	DISABLE_DAILY_REPORT_EXPENSES: "isDisableDailyReportExpenses",
	DISABLE_ORDER_PRINT: "disableOrderPrint",
	DISABLE_PREQUAL: "disablePrequal",
	DISABLE_PROJECT_PRIVATE_ATTACHMENTS: "disableProjectPrivateAttachments",
	DISABLE_PROJECT_PRIVATE_MESSAGES: "projectWallHidePrivateMessages",
	DISABLE_PROJECT_CONTACTS: "disableProjectContacts",
	DISABLE_PROJECT_DOCUMENTS: "disableProjectDocuments",
	DISABLE_PROJECT_PHOTOS: "disableProjectPhotos",
	DISABLE_RFI: "isRFIDisabled",
	DISABLE_SIMPLE_SEARCH: "disableSimpleSearch",
	DOCUMENTS_TAB_ID: "appDocumentsTabId",
	DRAWINGS_CURRENT_SET_DEFAULT_OFF: "drawingsCurrentSetDefaultOff",
	DOWNLOAD_CONTACT_UPDATE_REQ: "rsvpContactInfoRequired",
	DOWNLOAD_RESPONSE_REQ: "preventDownloadUntilResponse",
	DOWNLOAD_TERMS_PROJECT_CF: "rsvpDownloadTermsProjectCustomField",
	DOWNLOAD_TERMS_PROJECT: "rsvpDownloadTermsProject",
	DOWNLOAD_TERMS_SIGNATURE_REQ: "rsvpDownloadTermsSignatureRequired",
	DOWNLOAD_TERMS: "rsvpDownloadTerms",
	EMAIL_LOGO_URL: "emailLogoURL",
	ENABLE_AB_PREQUAL_EDIT: "enableAbPrequalEdit",
	ENABLE_ADMIN_PAID_DOWNLOADS: "enableAdminPaidDownloads",
	ENABLE_BID_FILER: "isBidFilerEnabled",
	ENABLE_BID_FORMS: "isBidFormsEnabled",
	ENABLE_BID_FORM_SEALING: "enableBidFormSealing",
	ENABLE_BID_PACKAGES: "enableBidPackages",
	ENABLE_BID_PACKAGES_COUNT: "enableBidPackagesCount",
	ENABLE_CONTACT_FIELD_SETTINGS: "enableContactFieldSettings",
	ENABLE_USER_FIELD_SETTINGS: "enableUserFieldSettings",
	ENABLE_COPY_PROJECT: "enableCopyProject",
	ENABLE_DAILY_REPORT_DELAYS: "enableDailyReportDelays",
	ENABLE_DATA_TABLE_FIXED_HEADER: "enableDataTableFixedHeader",
	ENABLE_DELIVER_BY_LOCAL: "enableDeliverByLocal",
	ENABLE_DELIVER_BY_PICKUP: "enableDeliverByPickup",
	ENABLE_DIRECTORY: "isDirectoryEnabled",
	ENABLE_DIRECTORY_EDIT: "isAllowDirectoryEdit",
	DISABLE_DRAWINGS: "isDrawingsDisabled",
	ENABLE_DRAWING_ANNOTATIONS: "isDrawingAnnotationsEnabled",
	ENABLE_DRAWING_ANNOTATION_REFS: "enableDrawingAnnotationRefs",
	ENABLE_FAX: "enableFax",
	ENABLE_FIELD_REPORTS: "fieldReportEnabled",
	ENABLE_GANTT_COLUMN_SORTING: "enableGanttColumnSorting",
	ENABLE_INTERNATIONAL_COUNTRIES: "enableInternationalCountries",
	ENABLE_INVOICES: "enableInvoices",
	ENABLE_MEETINGS: "enableMeetings",
	ENABLE_MEETING_TRANSCRIPTIONS: 'enableMeetingTranscriptions',
	DISABLE_OLD_SUBMITTALS: "disableOldSubmittals",
	DISABLE_OLD_ADDRESSBOOK: "disableOldAddressBook",
	ENABLE_NEW_ADDRESSBOOK: "enableNewAddressBook",
	ENABLE_OLD_ADDRESSBOOK: "enableOldAddressBook",
	ENABLE_FINANCES: "enableFinances",
	ENABLE_NEW_FILES: "isNewFilesEnabled",
	ENABLE_NEW_FILE_VIEWER: "enableNewFileViewer",
	ENABLE_NEW_GANTT: "enableNewGantt",
	ENABLE_PERMISSIONS: "enablePermissions",
	ENABLE_PERMISSIONS_PORTAL: "enablePermissionsPortal",
	ENABLE_PREQUAL_AUDITLOG: "enablePrequalAuditLog",
	ENABLE_PREQUAL_COMMENTS: "enablePrequalComments",
	ENABLE_PRODUCTION_QUANTITIES: "enableProductionQuantities",
	ENABLE_PROJECT_CONTAINERS: "projectContainerEnabled",
	ENABLE_PROJECT_LOCATIONS: "enableProjectLocations",
	ENABLE_PROJECT_NDA_DECLINE: "enableProjectNDADecline",
	ENABLE_NEW_PROJECT_CONTACTS_MANAGEMENT: "enableNewProjectContactsManagement",
	ENABLE_NEW_PROJECT_HISTORY: "enableNewProjectHistory",
	ENABLE_NEW_PROJECT_WALL: "enableNewProjectWall",
	ENABLE_NEW_SUBMITTALS: "enableNewSubmittals",
	ENABLE_NEW_UPLOAD_BID_DOCS: "enableNewUploadBidDocs",
	ENABLE_RAW_FILE_UPLOAD_BILLING: "enableRawFileUploadBilling",
	ENABLE_RESOURCE_ALLOCATION: "enableResourceAllocation",
	ENABLE_SCHEDULE_MSPROJECT_EXPORT: "enableScheduleMSProjectExport",
	ENABLE_SCREENINGS: "screeningEnabled",
	ENABLE_TIME_CARDS: "enableTimeCards",
	ENABLE_TIMECARDS_SIGNATURE: "enableTimeCardsSignature",
	ENABLE_USER_GROUPS: "enableUserGroups",
	ENABLE_WORK_LOG_OVERTIME: "enableWorkLogOvertime",
	FILE_UPLOADER_SIDE_BY_SIDE: "fileUploaderSideBySide",
	EXPAND_PROJECT_ROOT_SHARED_FOLDERS: "expandProjectRootSharedFolders",
	DISABLE_PREQUAL_ATTACHMENT_DELETE: "disablePrequalAttachmentDelete",
	DISABLE_PREQUAL_CONTACT_ATTACHMENT_LINK: "disablePrequalContactAttachmentLink",
	DISABLE_PROJECT_ATTACHMENTS: "isProjAttDisabled",
	DISABLE_PROJECT_WALL_MESSAGING_OLD: "disableOldProjectWallProjectMessaging",
	ENABLE_NEW_CONTACT_IMPORT: "enableNewContactImport",
	DISABLE_NEW_ADDRESSBOOK: "isNewAddressBookDisabled",
	DISABLE_NEW_DOCUMENTS: "isNewDocumentsDisabled",
	ENABLE_NEW_RAW_FILE_UPLOAD: "enableNewRawFileUpload",
	DISABLE_NEW_SETTINGS: "isNewSettingsDisabled",
	DISABLE_SHARE_PEI: "disableSharePEI",
	DISABLE_WORK_AREAS: "disableWorkAreas",
	ENABLE_ACTION_ITEMS: "enableActionItems",
	ENABLE_ERP_ADMIN: "enableERPAdmin",
	ENABLE_PREQUAL_PRIVATE_GROUPS: "enablePrequalPrivateGroups",
	ENABLE_SUB_RESPONSE: "projectMessagingAllowIndecisiveSubs",
	ENABLE_PROJECT_NAME_PAGE_TITLE: "enableProjectNamePageTitle",
	ENABLE_PRINT_ON_DEMAND: "enablePrintOnDemand",
	ENABLE_PUNCH_LISTS: "isPunchListsEnabled",
	ENABLE_REGIONS_MAP: "enableRegionsMap",
	ENABLE_RFI_NEW: "isRFINewEnabled",
	ENABLE_RFI: "isRFIEnabled",
	DISABLE_SCHEDULING: "isSchedulingDisabled",
	ENABLE_SCHEDULING: "isSchedulingEnabled",
	ENABLE_SCHEDULE_TASK_NOTIFICATION_SETTINGS: "enableScheduleTaskNotificationSettings",
	ENABLE_SYSTEM_DOCUMENTS: "enableSystemDocuments",
	ENABLE_REPORTS_NEW: "enableNewReports",
	ENABLE_OLD_CALENDAR: "enableOldCalendar",
	ENABLE_PROJECT_STATUS_ID: "enableNewProjectStatusId",
	DISABLE_PROJECT_STATUS_ID: "disableNewProjectStatusId",
	ENABLE_SCOPES: "enableProjectScope",
	ENABLE_SUBMITTALS: "submittalEnabled",
	ENABLE_SUBMITTAL_WORKFLOW: "enableSubmittalWorkflow",
	ENABLE_TOP_OF_PAGE_BUTTON: "isEnableTopOfPageButton",
	ENABLE_WORK_AREAS_ZIP_RADIUS_COUNTY_PICKER: "enableWorkAreasZipRadiusCountyPicker",
	ENABLE_WORK_AREAS: "enableWorkAreas",
	EXPAND_PROJECT_ATTACHMENTS: "expandProjectAttachments",
	FILE_NAVIGATOR_VIEW_ON_CLICK: "fileNavigatorViewOnClick",
	FLATTEN_DL_ALL_PROJECT_ATTACHMENTS: "flattenDLAllProjAtt",
	GROUP_LABEL: "addressBookGroupLabel",
	GROUP_LEVELS: "addressBookGroupLevels",
	HAS_GROUPS_LINKED: "hasGroupsLinked",
	HIDE_DAILY_REPORT_UNSUBMIT: "hideDailyReportUnsubmit",
	HIDE_VERSION_SELECTOR_ISSUED_ON: "hideDrawingVersionSelectorIssuedOn",
	HIDE_SUBMITTAL_ITEM_TYPE: "hideSubmittalItemType",
	IS_DISABLE_PARENT_GROUPS: "isDisableParentGroups",
	IS_DOCUMENT_CLERK: "isDocumentClerk",
	IS_DOCUMENT_CLERK_COMPANY: "isDocumentClerkCompany",
	IS_DODGE_CRM: "dodgeCRMPortal",
	IS_DODGE_WG: "dodgeWhiteGlovePortal",
	IS_ENABLE_NEW_DOWNLOADS: "isEnableNewDownloads",
	IS_HIDE_UNION_STATUS: "addressBookHideUnionStatus",
	IS_PROJECT_HOME_READONLY: "isProjectHomeReadonly",
	IS_PROJECT_WALL_MESSAGING_NEW: "enableNewProjectWallProjectMessaging",
	IS_PROJECT_WALL_MESSAGING_NEW_PORTAL: "portalEnableNewProjectWallProjectMessaging",
	IS_PROQUAL_CUSTOMER: "isProqualCustomer",
	IS_PROQUAL_PORTAL: "proQualPortal",
	IS_REQUIRE_BIDFORM_ATTACHMENT: "isRequireBidformAttachment",
	ITB_RESUME_LABEL: "itbResumeLabel",
	ITB_SEND_NEW_LABEL: "itbSendNewLabel",
	IS_SSO_ENABLED: "isSSOEnabled",
	ITB_TAB_LABEL: "itbTabLabel",
	MESSAGE_RESPONSE_DUE_LABEL: "messageResponseDueLabel",
	MESSAGE_STATUS_LIST: "messageStatusList",
	NEW_APP_PORTAL: 'portalNewApp',
	NO_REQUIRE_UNION_SUB: 'addressBookUnionStatusNotRequired',
	ORDER_DELIVER_BY: 'orderDeliverBy',
	ORDER_LARGE_FORMAT_BINDING_TYPE: 'orderLargeFormatBindingType',
	ORDER_LARGE_FORMAT_PAPER_TYPE: 'orderLargeFormatPaperType',
	ORDER_LARGE_FORMAT_PRINT_SIZE: 'orderLargeFormatPrintSize',
	ORDER_LARGE_FORMAT_QUANTITY: 'orderLargeFormatQuantity',
	ORDER_PO_REQUIRED: 'orderPORequired',
	ORDER_SMALL_FORMAT_BINDING_TYPE: 'orderSmallFormatBindingType',
	ORDER_SMALL_FORMAT_PAPER_TYPE: 'orderSmallFormatPaperType',
	ORDER_SMALL_FORMAT_QUANTITY: 'orderSmallFormatQuantity',
	PLAN_EXPRESS_PORTAL: "planExpressPortal",
	PREQUAL_HEADER: "prequalHeader",
	PREQUAL_ALLOW_SIGNATURE_ALWAYS: "prequalAllowSignatureAlways",
	PREQUAL_HELP_CONTACT_DETAILS: "prequalHelpContactDetails",
	PREQUAL_PROJECT_REFERENCE_COUNT: "prequalProjectReferenceCount",
	PREQUAL_PROJECT_REFS_GC_COL_NAME: "prequalProjectRefsGcColName",
	PREQUAL_SIGNATURE_ALERT: "prequalSignatureAlert",
	PREQUAL_TERMS: "prequalTerms",
	PREVAILING_WAGE_LABEL: "prevailingWageLabel",
	PREVENT_NATIONWIDE_WORK_AREAS: "preventNationwideWorkAreas",
	PREVENT_NATIONWIDE_WORK_AREAS_PORTAL: "portalPreventNationwideWorkAreas",
	PREVENT_NATIONWIDE_WORK_AREAS_SUB: "portalPreventNationwideWorkAreas_Sub",
	PRIVATE_MESSAGING_USER_ID_DEFAULT: "internalMessageUserIdDefault",
	PROCORE_ACCESS_REFRESH_TOKEN: "proCoreAccessRefreshToken",
	PROCORE_CLIENT_ID: "proCoreClientId",
	PROCORE_CLIENT_REDIRECT: "proCoreClientRedirect",
	PROCORE_URL_API: "proCoreURL",
	PROCORE_URL_AUTH: "proCoreAuthURL",
	PROJ_DASHBOARD_SELECT_ALL_ATTACHMENTS: "rsvpSelectAllDocuments",
	PROJECT_ACTIVITY_RANK_STATUS_LIST: "projectActivityRankStatusList",
	PROJECT_DEFAULT_BID_DUE_TIME: "projectDefaultBidDueTime",
	PROJECT_DEFAULT_BID_DUE_TIME_AMPM: "projectDefaultBidDueTimeAMPM",
	PROJECT_DETAILS_EXPORT: "projectDetailsExport",
	PROJECT_MANAGEMENT_CONTACTS_ENABLE_PRIMARY: 'projectManagementContactsEnablePrimary',
	PROJECT_MESSAGING_DEFAULT_TEMPLATE: "projectMessagingDefaultTemplateKey",
	PROJECT_MESSAGING_DISABLE_QUICKADD: "projectMessagingDisableQuickAdd",
	PROJECT_MESSAGING_DISABLE_RESPONSE_DUE: "projectMessagingDisableResponseDue",
	PROJECT_MESSAGING_DISTANCE_ICON_THRESHOLD: "projectMessagingDistanceIconThreshold",
	PROJECT_MESSAGING_ENABLE_REPLYTO_OVERRIDE: "projectMessagingEnableReplyToOverride",
	PROJECT_MESSAGING_MAX_GROUP_DISPLAY: "projectMessagingMaxGroupDisplay",
	PROJECT_MESSAGING_SEND_OPTIONS_EMAIL_ALWAYS: "sendEmail",
	PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS: "sendFax",
	PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED: "sendFaxIfEmailFailed",
	PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL: "sendFaxOnlyIfNoEmail",
	PROJECT_MESSAGING_RESTRICT_TO_EXISTING_GROUPS: "projectMessagingRestrictToExistingGroups",
	PROJECT_NAV_HEADER_CUSTOM_MARKUP: "projectNavHeaderCustomMarkup",
	PROJECT_NDA_CHECKED_DEFAULT: "projectNDACheckedDefault",
	PROJECT_NDA_MODAL_TITLE: "projectNDAModalTitle",
	PROJECT_NOTES_LABEL: "projectNotesLabel",
	PROJECT_SHARED_FOLDER_NAME_OVERRIDE: "projectSharedFolderNameOverride",
	PROJECT_STATUS_LIST: "projectStatusList",
	PROJECT_STATUS_NON_DEFAULT_REQUIRED: "projectStatusNonDefaultRequired",
	PROJECT_USER_1_LABEL: "projectUser1Label",
	PROJECT_USER_2_HIDE: "projectUser2Hide",
	PROJECT_USER_2_LABEL: "projectUser2Label",
	PROJECT_WALL_ADMIN_BID_DUE_DATE_REQUIRED: "projectWallAdminBidDueDateRequired",
	PROJECT_WALL_ADMIN_NOTES_HIDDEN: "projectWallAdminNotesHidden",
	PROJECT_WALL_ADMIN_NOTES_REQUIRED: "projectWallAdminNotesRequired",
	PROJECT_WALL_ADMIN_USER_2_REQUIRED: "projectWallAdminUser2Required",
	PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES: "enableProjectWallViewBidPackages",
	PROJECT_WALL_ADMIN_VIEW_COMPANY: "enableProjectWallViewCompany",
	PROJECT_WALL_ADMIN_VIEW_CONTACT: "enableProjectWallViewContact",
	PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY: "enableProjectWallViewGroupCompany",
	PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT: "enableProjectWallViewGroupContact",
	PROJECT_WALL_ADMIN_ZIP_REQUIRED: "projectWallAdminPostalCodeRequired",
	PROJECT_WALL_MESSAGING_SHOW_TEMPLATES: "projectWallMessagingShowTemplates",
	PROJECT_WALL_RSVP_AUTO_REPORT: "rsvpAutoReportTab",
	PROJECT_WALL_DEFAULT_MODULE: "projectWallDefaultModule",
	PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS: "projectDefaultPrivateRootFolderTemplate",
	PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS: "projectDefaultPublicRootFolderTemplate",
	PROJECT_WALL_MESSAGING_TAB_NAME: "projectWallMessagingTabName",
	PROJECT_WALL_PRIMARY_PROJECT_MANAGER_REQUIRED: "projectWallPrimaryProjectManagerRequired",
	PROJECT_WALL_SORT_GROUPS_BY_RESPONSE: "projectWallAdminSortGroupsByResponse",
	PROJECT_WALL_HIDE_BIDS_DUE: "projectWallHideBidsDue",
	PROJECT_WALL_TAB_ID: "projectWallTabId",
	PROJECT_SCHEDULE_FILTER_USER_ID: "projectScheduleFilterUserId",
	PUBLIC_PROJECTS_REQ_REG: "publicProjectsRequireRegistration",
	PUBLIC_PROJECTS_EMPTY_MESSAGE: "publicProjectsEmptyMessage",
	PUNCH_LIST_WORK_COMPLETED_STATUS_OVERRIDE: "punchListWorkCompletedStatusOverride",
	QUIKBID_GROUP_IDS: "quikBidGroupIds",
	QUIKBID_ZIP_CODES: "quikBidZipCodes",
	REGISTRATION_REDIRECT: "registrationRedirect",
	REGISTRATION_TAB_ID: "registrationTabId",
	RESOURCE_ALLOCATION_PRIMARY_ONLY: "resourceAllocationPrimaryOnly",
	RESPONSE_DUE_LABEL: "responseDueLabel",
	PROJECT_START_LABEL: "projectStartLabel",
	PROJECT_FINISH_LABEL: "projectFinishLabel",
	REQUIRE_PROJECT_START_FINISH: "requireProjectStartFinish",
	RESTRICT_GROUP_COUNT: "addressBookGroupsRestrictChoiceCount",
	RESOURCE_ALLOCATION_PROJECT_CUSTOM_FIELD_COLOR_BAR: "resourceAllocationProjectCustomFieldColorBar",
	RFI_DEFAULT_PUBLIC: "rfiDefaultPublic",
	RFI_DEFAULT_NOTIFY_PROJECT_CONTACTS: "rfiDefaultNotifyProjectContacts",
	RFI_DEFAULT_NOTIFY_PARTICIPANTS: "rfiDefaultNotifyParticipants",
	RFI_LOCATION_LABEL: "rfiLocationLabel",
	RFI_NAME_OVERRIDE: "rfiNameOverride",
	RFI_RESPONSE_NAME_OVERRIDE: "rfiResponseNameOverride",
	RSVP_DISABLE_PER_GROUP: "rsvpDisablePerGroup",
	RSVP_FOLDER_CHECKBOXES_ONLY: "rsvpFolderCheckboxesOnly",
	SETTINGS_LOCK: "settingsLock",
	PROJECT_DETAILS_PROJECT_ID: "projectDetailsProjectId",
	PROJECT_GANTT_HEADER_CUSTOM_MARKUP: "projectGanttHeaderCustomMarkup",
	HIDE_RESOURCE_CENTER: "hideResourceCenter",
	SIMPLE_SEARCH_DEFAULT_ADDRESS_BOOK: "simpleSearchDefaultAddressBook",
	SIMPLE_SEARCH_DEFAULT_RADIUS: "simpleSearchDefaultRadius",
	SQUARE_TAKEOFF_ENABLED: "enableSquareTakeoff",
	STACK_TAKEOFF_ENABLED: "enableStackTakeoff",
	START_END_HIDE: "startEndHide",
	SUB_ADDRESS_REQUIRED: "rsvpAddressRequired",
	SUB_RESTRICT_SINGLE_EMAIL: "addressBookForceSingleEmail",
	SUB_ZIP_REQUIRED: "rsvpPostalCodeRequired",
	TIMECARD_WEEKLY_EXPORT_TEMPLATE: "timeCardWeeklyExportTemplate",
	HIDE_CURRENT_SET_WHEN_POSSIBLE: "hideCurrentSetWhenPossible",
	ENABLE_WORK_LOG_WORK_ITEMS: 'enableWorkLogWorkItems',
	ENABLE_WORK_LOG_PROGRESS: 'enableWorkLogProgress',
	WORK_LOG_WORK_ITEM_LABEL: 'workLogWorkItemLabel',
	WORK_LOG_WORK_ITEM_SUB_TEXT: 'workLogWorkItemSubText',
};

PJQ.progress = {};

PJQ.progress.ProgressBar = class {
    constructor($el, options = {}) {
        this.$outer = $el;
        this.options = _.defaults(options, {
            isStriped: false,
            height: 20,
            width: 'auto',
            isShowPercentage: false,
            progress: 0,
            borderRadius: null
        });

        if (this.$el != null && this.$el.length > 0) {
            this.renderProgressBar();
        }
    }

    makeProgressBar() {
        let colorClass = this.options.colorClass ?? this.getCompletionColorClass();
        let $res = $('<div>', {
            class: 'progress',
            style: `height: ${this.options.height}px; width: ${typeof this.options.width === 'number' ? `${this.options.width}px` : this.options.width}; border-radius: ${this.options.borderRadius ?? '.25rem'};`
        });
        $res.append($('<div>', {
            class: 'progress-bar font-weight-light fs-14 bg-' + colorClass + ' text-' + (colorClass === 'warning' ? 'dark' : 'light'),
            role: 'progressbar',
            style: 'width:' + this.options.progress + '%;'
        }).text(this.options.isShowPercentage ? this.options.progress + '%' : ''));
        return $res;
    }

    getCompletionColorClass () {
        let textClass = 'danger';
        if (this.options.progress === 100)
            textClass = 'success';
        else if (this.options.progress > 60)
            textClass = 'warning';

        return textClass;
    }

    renderProgressBar() {
        if (_.size(this.$el) > 0) {
            this.$el.remove();
        }
        this.$el = this.makeProgressBar();

        this.$outer.append(this.$el);
    }

    updateProgress(progress = 0, colorClass = PJQ.views.prequal.PrequalEditor.prototype.getCompletionColorClass(progress)) {
        this.options = _.defaults({
            progress: progress,
            colorClass: colorClass
        }, this.options);
        this.renderProgressBar();
    }
};
//Models
PJQ.models.projectContacts = {};

PJQ.models.projectContacts.ProjectContact = PJQ.models.contacts.Contact.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'contacts',
                value: this.get('id')
            }
        ])
    },
    parse: function (model) {
        PJQ.models.contacts.Contact.prototype.parseContactData.call(this, model);
        PJQ.models.contacts.Contact.prototype.parseAttachmentData.call(this, model);

        return model;
    },
    fetchProjectNotificationSettings: function (projectId, callback) {
        let notificationSettings = null;
        if (!this.isNew()) {
            notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
                id: this.get('id'),
                projectId: this.get('projectId')
            });
        } else {
            notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
                userTypeId: this.get('userTypeId')
            });
        }

        notificationSettings.fetch({
            success: _.bind(function () {
                callback(notificationSettings);
            }, this)
        });
    },
    updateIsPrimary: function (isPrimary, callback) {
        this.set('isPrimary', isPrimary);
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '?isPrimary=' + isPrimary.toString()
        }).patch().success(_.bind(function () {
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    beforeSave: function () {
        PJQ.models.contacts.Contact.prototype.beforeSave.call(this);
        this.set({
            attachments: this.attachments.getChangedModels()
        })
    }
});

//Collections
PJQ.collections.projectContacts = {};

PJQ.collections.projectContacts.ProjectContacts = PJQ.collections.BaseCollection.extend({
    idAttribute: 'id',
    model: PJQ.models.projectContacts.ProjectContact,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'contacts'
            }
        ])
    },
    addContactsToProject: function (ids, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/ids',
            data: {
                ids: ids
            }
        }).post().success(_.bind(function (data) {
            this.reset(data);
            callback();
        }, this)).fail(_.bind(function (xhr) {
            //todo: toast error
            callback();
        }, this));
    }
});

//Views
PJQ.views.projectContacts = {};

PJQ.views.projectContacts.ProjectContactsManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Contacts-Management')
    },
    events: {
        'click .btn-edit-pc-perms': 'editPermissionsClicked',
        'click .btn-edit-pc-notification-settings': 'notificationSettingsClicked',
        'click .edit-project-contact': 'editClicked',
        'click .remove-project-contact': 'removeClicked',
        'click .project-contacts-new-contact': 'newContactClicked',
        'click .project-contacts-add-from-bid-participants': 'addFromBidParticipants',
        'click .project-contacts-add-from-address-book': 'addFromAddressBook',
        'click .project-contacts-quick-search': 'quickSearch',
        'click .project-contacts-add-from-project': 'addFromProject',
        'click .project-contacts-new-user': 'newUserClicked',
        'click .project-contacts-add-from-company': 'addFromCompany',
        'change .cb-primary': 'changeIsPrimary',
        'click .export-pdf': 'exportPDF',
        'click .export-excel': 'exportExcel',
        'click .btn-copy-email': 'copyEmail'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = this.options.project.hasPermission('projectContacts.isAdmin');
        this.options.canEdit = PJQ.app.session.hasPermission('settings.canManageUsers');
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;

        if (this.options.project.projectContacts != null) {
            this.collection = this.options.project.projectContacts;
        } else {
            this.collection = this.options.project.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
                project: this.options.project
            });
        }

        PJQ.app.session.fetchUserGroups(this.options.project.get('masterUserId'), _.bind(function (grResult) {
            this.groups = grResult;

            this.listenTo(this.collection, 'reset update', _.bind(function () {
                this.renderDataTable();
            }, this));

            this.listenTo(this.collection, 'sync', _.bind(function () {
                this.dataTable.refresh('page');
            }, this));
            this.collection.fetchReset();
        }, this));
    },
    renderData: function () {
        return {
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin
        };
    },
    afterRender: function () {
        this.renderDataTable();
    },
    renderDataTable: function () {
        let columns = [
            {
                "columnData": "userType",
                "title": "Type",
                "width": "120px",
                "orderable": true,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    if (row.userType != null) {
                        if (type === 'sort') {
                            return row.userType.get('sortOrder');
                        }
                        return '<span style="color:' + row.userType.get('color') + ';">' + row.userType.get('name') + '</span>';
                    }
                    return '';
                }, this)
            },
            {"columnData": "companyName", "data": "attributes.companyName", "title": "Company Name"},
            {"columnData": "contactName", "data": "attributes.contactName", "title": "Contact Name"},
            {
                "columnData": "email",
                "data": "attributes.email",
                "title": "Email",
                "orderable": true,
                "searchable": true,
                "render": function (data) {
                    if (_.size(data) === 0) {
                        return '';
                    }

                    return '<div class="no-wrap tof-ellipsis of-hidden d-flex align-items-center"><span></span><button type="button" class="btn btn btn-transparent-dark btn-copy-email" title="Copy Email"><i class="far fa-envelope text-dark"></i></button>' + data + '</div>';
                }
            },
            {
                "columnData": "phone",
                "data": "attributes.phone",
                "title": "Phone",
                "orderable": true,
                "searchable": true,
                "render": function (data) {
                    return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
                }
            },
            {
                "columnData": "cell",
                "data": "attributes.cell",
                "title": "Cell",
                "orderable": true,
                "searchable": true,
                "render": function (data) {
                    return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
                }
            },
            {
                "columnData": "projectGroups",
                "data": "attributes.projectGroups",
                "title": this.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ?? "Trades",
                "orderable": true,
                "searchable": true,
                "render": _.bind(function (data, type, row) {
                    if (row.id > 0) {
                        let arr = [];
                        _.each(data, function (groupId) {
                            let group = this.groups ? this.groups.get(groupId) : null;
                            if (group != null) {
                                arr.push(group);
                            }
                        }, this);
                        return _.map(_.sortBy(arr, function (group) {
                            return group.get('sortOrder');
                        }), function (group) {
                            return group.get('groupName');
                        }).join(', ');
                    }
                    return '';
                }, this)
            }];

        if (PJQ.app.session.get('portalId') === 0 || this.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MANAGEMENT_CONTACTS_ENABLE_PRIMARY)) {
            columns.push({
                "columnData": "isPrimary",
                "data": "attributes.isPrimary",
                "title": "Primary",
                "width": "80px",
                "orderable": true,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    if (row.get('id') > 0) {
                        return '';
                    }

                    if (type === 'sort') {
                        return data;
                    }
                    return '<div class="pretty p-switch ml-3"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-primary" /><div class="state p-success"><label>&nbsp;</label></div></div>';
                }, this)
            });
        }
        columns.push(...[{
            "columnData": "actions",
            "data": "",
            "title": "",
            "orderable": false,
            "searchable": false,
            "width": 120 + (this.options.isAdmin ? 40 : 0) + 'px',
            "render": _.bind(function (data, type, row) {
                let buttons = '',
                    notificationButton = '<button type="button" title="Notifications" class="btn btn-purple btn-edit-pc-notification-settings mr-1"><span class="fal fa-bell"></span></button>';
                buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-pc-perms mr-1"><span class="fal fa-key"></span></button>';

                if (this.options.isAdmin) {
                    buttons += (row.get('userId') === PJQ.app.session.user.get('userId') || PJQ.app.session.hasPermission('users.canModifyNotifications')) ? notificationButton : ``
                } else if (this.options.isAdmin) {
                    buttons += notificationButton;
                }

                if (this.options.canEdit) {
                    buttons += '<button type="button" title="Edit" class="btn btn-info edit-project-contact mr-1"><span class="fal fa-pencil"></span></button>';
                } else {
                    buttons += '<button type="button" title="View" class="btn btn-info edit-project-contact mr-1"><span class="fal fa-search"></span></button>';
                }
                if (this.options.isAdmin) {
                    buttons += '<button type="button" title="Remove" class="btn btn-danger remove-project-contact"><span class="fal fa-trash"></span></button>';
                }
                return '<div class="text-align-center show-on-row-hover" style="min-width: 140px">' + buttons + '</div>';
            }, this)
        }]);

        let self = this,
            tableOpts = {
                el: this.$('.project-contacts-data-table-container'),
                data: this.collection.models,
                orderCookie: PJQ.constants.cookies.PROJECT_CONTACT_LIST_ORDER,
                columnDefinitions: columns,
                // columns: columns,
                colReorder: {
                    fixedColumnsLeft: 0,
                    fixedColumnsRight: 1,
                    realtime: false
                },
                pageLengthCookie: PJQ.constants.cookies.PROJECT_CONTACT_LIST_PAGE_LENGTH,
                identifier: 'project_contacts_data_table',
                language: {
                    emptyTable: "No project contacts have been added to this project",
                    zeroRecords: "No project contacts match the search criteria"
                },
                subTemplates: {
                    header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Contacts')
                },
                headerData: function () {
                    return {
                        userTypes: PJQ.app.session.userTypes.models,
                        isAdmin: self.options.isAdmin
                    };
                },
                afterHeaderRender: function (view, $header) {
                    new PJQ.inputs.Selectpicker({
                        el: $header.find('.user-type-filter'),
                        onChange: function (value) {
                            view.setFilter('userType', value);
                        },
                        isMultiple: true,
                        isIntChoices: true,
                        noneSelectedText: 'No Filters',
                        defaultValue: self.userTypeFilter
                    });
                },
                getFilterData: function (view, data) {
                    let userTypeFilter = view.getFilter('userType');
                    if (_.size(userTypeFilter) === 0) {
                        return data;
                    }

                    return _.filter(data, function (row) {
                        return _.contains(userTypeFilter, row.userType.id);
                    });
                },
                onRowDoubleClick: _.bind(function (row) {
                    if (row.data()) {
                        this.editContact(row.data());
                    }
                }, this),
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'Edit',
                            iconClass: 'fal fa-pencil',
                            isShown: _.bind(function (row) {
                                return this.options.canEdit;
                            }, this),
                            onClick: _.bind(function (row) {
                                this.editContact(row.data());
                            }, this)
                        },
                        {
                            name: 'View',
                            iconClass: 'fal fa-search',
                            isShown: _.bind(function (row) {
                                return !this.options.canEdit;
                            }, this),
                            onClick: _.bind(function (row) {
                                this.editContact(row.data());
                            }, this)
                        },
                        {
                            name: 'Manage Trades',
                            iconClass: 'fal fa-hard-hat',
                            onClick: _.bind(function (row) {
                                new PJQ.views.projects.ManageProjectParticipantTradesModal({
                                    contactId: row.data().get('contactId'),
                                    onSave: _.bind(function (data) {
                                        row.data().set('projectGroups', _.map(_.filter(data.models, function (model) {
                                            return model.get('isSelected');
                                        }), function (model) {
                                            return {
                                                groupId: model.get('groupId')
                                            };
                                        }));
                                        row.invalidate().draw();
                                    }, this)
                                });
                            }, this),
                            isShown: _.bind(function (row) {
                                return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view !== PJQ.constants.projectMessaging.views.MSGCONT_CONT && row.data().id > 0;
                            }, this)

                        },
                        {
                            name: 'Permissions',
                            iconClass: 'fal fa-key',
                            isShown: _.bind(function (row) {
                                return this.options.isAdmin;
                            }, this),
                            onClick: _.bind(function (row) {
                                this.editPermissions(row.data());
                            }, this)
                        },
                        {
                            name: 'Notifications',
                            iconClass: 'fal fa-bell',
                            isShown: _.bind(function (row) {
                                return this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
                            }, this),
                            onClick: _.bind(function (row) {
                                this.editNotificationsSettings(row.data());
                            }, this)
                        },
                        {
                            name: 'Remove',
                            iconClass: 'fal fa-trash',
                            isDanger: true,
                            isShown: _.bind(function (row) {
                                return this.options.isAdmin;
                            }, this),
                            onClick: _.bind(function (row) {
                                this.removeContact(row);
                            }, this)
                        }
                    ]
                }
            };
        this.dataTable = new PJQ.views.dataTables.DataTable(tableOpts);
    },
    copyEmail: function (e) {
        let target = $(e.currentTarget),
            projectContact = this.dataTable.getRow(target.closest('tr')).data();
        if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(projectContact.get('email'));
            PJQ.notifications.notify.successNotify({
                message: 'Email copied to clipboard'
            });
        }
    },
    changeIsPrimary: function (e) {
        let target = $(e.currentTarget),
            isPrimary = target.prop('checked'),
            projectContact = this.dataTable.getRow(target.closest('tr')).data();
        if (projectContact != null) {
            projectContact.updateIsPrimary(isPrimary);
        }
    },
    editPermissionsClicked: function (e) {
        let target = $(e.currentTarget),
            projectContact = this.dataTable.getRow(target.closest('tr')).data();
        this.editPermissions(projectContact);
    },
    editPermissions: function (projectContact) {
        new PJQ.views.permissions.PermissionsEditorModal({
            model: projectContact,
            project: this.options.project
        });
    },
    notificationSettingsClicked: function (e) {
        let target = $(e.currentTarget),
            projectContact = this.dataTable.getRow(target.closest('tr')).data();
        this.editNotificationsSettings(projectContact);
    },
    editNotificationsSettings: function (projectContact) {
        new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
            model: projectContact,
            project: this.options.project
        });
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            projectContact = this.dataTable.getRow(target.closest('tr')).data();
        this.editContact(projectContact);
    },
    editContact: function (projectContact) {
        new PJQ.views.contacts.BaseEditContactModal({
            model: projectContact
        });
    },
    removeClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.removeContact(row);
    },
    removeContact: function (row) {
        let projectContact = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Remove",
            deleteButtonText: "Remove",
            body: "Are you sure you want to remove this contact from the project?",
            onDelete: _.bind(function () {
                this.collection.remove(projectContact);
                projectContact.destroy();
            }, this)
        });
    },
    addFromBidParticipants: function () {
        this.options.project.fetchParticipants(_.bind(function (participants) {
            new PJQ.views.contacts.SelectContactsModal({
                contacts: participants,
                hideContacts: this.collection.models,
                context: PJQ.constants.contacts.contexts.PARTICIPANTS,
                isSingleChoice: false,
                subtitle: "Add Project Contacts from Bid Participants",
                onSave: _.bind(function (selectedContacts) {
                    this.collection.addContactsToProject(_.map(selectedContacts, function (contact) {
                        return contact.id;
                    }), _.bind(function () {
                        this.renderDataTable();
                    }, this));
                }, this)
            });
        }, this));
    },
    addFromAddressBook: function () {
        $('form[name="modal-add-participants"]').remove();
        let options = {
            onSave: _.bind(function (selectedContactsAll, data) {
                this.collection.addContactsToProject(selectedContactsAll, _.bind(function () {
                    this.renderDataTable();
                }, this));
            }, this),
            disableContacts: _.map(this.collection.models, function (contact) {
                return contact.id;
            })
        };

        if (!this.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
            options.isWrapForm = false;
            options.wrapFormName = null;
            options.isUseNewAddressBook = true;
            options.isMultipleProjects = true;
        }

        new PJQ.views.projects.AddParticipantsDetailedModal(options);
    },
    quickSearch: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.CONTACTS,
            isSingleChoice: false,
            project: this.options.project,
            subtitle: "Add Project Contacts From Address Book",
            onSave: _.bind(function (selectedContacts) {
                this.collection.addContactsToProject(_.map(selectedContacts, function (contact) {
                    return contact.id;
                }), _.bind(function () {
                    this.renderDataTable();
                }, this));
            }, this)
        });
    },
    addFromProject: function () {

    },
    addFromCompany: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.USERS,
            isSingleChoice: false,
            hideContacts: this.collection.models,
            subtitle: "Add Project Contacts from My Company Users",
            onSave: _.bind(function (selectedContacts) {
                this.collection.addContactsToProject(_.map(selectedContacts, function (contact) {
                    return -contact.id;
                }), _.bind(function () {
                    this.renderDataTable();
                }, this));
            }, this)
        });
    },
    newContactClicked: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                projectId: PJQ.app.session.project.id,
                country: this.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ?? 'US'
            })
        });
    },
    newUserClicked: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                projectId: PJQ.app.session.project.id
            })
        });
    },
    exportProjectContacts: function () {
        new PJQ.ajax.Request({
            endpoint: this.options.project.endpoint(false) + '/contacts/export',
            data: {
                isApi2: true
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
        }, this));
    },
    exportExcel: function () {
        if (this.options.project == null) {
            return;
        }

        let filters = {},
            userTypeFilter = this.dataTable.getFilter('userType');

        if (_.size(userTypeFilter) > 0) {
            filters.userTypes = userTypeFilter;
        }

        let order = this.dataTable.dataTable.order()[0],
            report = new PJQ.models.reports.NewReport({
                type: "projectContacts",
                projectId: this.options.project.id,
                options: {
                    filters: filters,
                    columns: ["userType", "companyName", "contactName", "email", "phone", "cell", "trades"],
                    columnOrder: order
                }
            });
        report.export({format: 'excel'}).then(() => {

        });
    },
    exportPDF: function () {
        if (this.options.project == null) {
            return;
        }

        let filters = {},
            userTypeFilter = this.dataTable.getFilter('userType');

        if (_.size(userTypeFilter) > 0) {
            filters.userTypes = userTypeFilter;
        }

        let order = this.dataTable.dataTable.order()[0],
            report = new PJQ.models.reports.NewReport({
                type: "projectContacts",
                projectId: this.options.project.id,
                options: {
                    filters: filters,
                    columns: ["userType", "companyName", "contactName", "email", "phone", "cell", "trades"],
                    columnOrder: order
                }
            });
        report.export({format: 'pdf'}).then(() => {

        });
    }
});

//Routes
PJQ.modules.projectContacts = {
    routes: [
        {
            route: 'projects/:projectId/contacts',
            name: 'projectContacts',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectcontacts");
            }
        },
        {
            route: 'projects/:projectId/contacts/:id',
            name: 'projectContact',
            callback: function (projectId, id) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectcontacts", {
                    id: id
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.projectContacts.routes);

PJQ.views.projectInvites = {};

PJQ.views.projectInvites.ProjectInvite = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Invite'),
		project: null,
		emailTemplates: [],
		onChange: _.noop,
		isShowQuickAdd: false,
		isShowAttachments: false,
		defaultTemplateKey: null
	},
	beforeRender: function () {
		if (!this.options.project.inviteSettings) {
			this.options.project.inviteSettings = {
				sendEmail: true,
				sendFaxIfNoEmail: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL),
				sendFaxIfEmailFails: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED),
				sendFaxAlways: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS),
				responseDue: this.options.project.get('responseDueDate') === 'ASAP' ? 'ASAP' : this.options.project.get('bidsDue') ? PJQ.helpers.dateHelpers.getDateString(new Date(this.options.project.get('bidsDue')), PJQ.helpers.dateHelpers.dateFormats.DATE, false) : null,
				responseDueLabel: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) : "Response Due",
				quickAdd: '',
				attachments: new PJQ.collections.files.Files(),
				uploaderGuid: PJQ.helpers.guid(),
				privateFolders: new PJQ.collections.files.Files(),
				templateKey: this.options.defaultTemplateKey,
				replyTo: null
			};
		}

		if (!this.options.project.inviteSettings.emailTemplate) {
			this.options.project.inviteSettings.emailTemplate = this.options.emailTemplates[0];
			if (this.options.project.inviteSettings.templateKey) {
				_.each(this.options.emailTemplates, _.bind(function (item) {
					if (item.get('templateKey') === this.options.project.inviteSettings.templateKey)
						this.options.project.inviteSettings.emailTemplate = item;
				}, this));
			}

		}

		this.renderData = {
			emailTemplates: this.options.emailTemplates,
			replyToContacts: this.options.replyToContacts,
			isShowQuickAdd: this.options.isShowQuickAdd,
			isShowAttachments: this.options.isShowAttachments,
			responseDueLabel: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) : "Response Due",
			activeView: ''
		};
	},
	afterRender: function () {

		if (this.options.isShowQuickAdd) {
			this.$('input.quick-add-list').val(this.options.project.inviteSettings.quickAdd);

			this.$('input.quick-add-list').on('change keyup', _.bind(function () {
				this.options.project.inviteSettings.quickAdd = this.$('input.quick-add-list').val();
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();
			}, this));

		}

		if (_.size(this.options.replyToContacts) > 0) {
			this.replyToSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.reply-to'),
				isIntChoices: true,
				defaultValue: this.options.project.inviteSettings.replyTo ? this.options.project.inviteSettings.replyTo : 0,
				onChange: _.bind(function(value) {
					this.options.project.inviteSettings.replyTo = value ? value : null;
				}, this)
			});

		}

		this.$('input.message-subject').val(this.options.project.inviteSettings.messageSubject);
		this.$('input.message-subject').on('change keyup', _.bind(function () {
			this.options.project.inviteSettings.messageSubject = this.$('input.message-subject').val();
			if (typeof this.options.onChange === 'function')
				typeof this.options.onChange();

			this.queuePreview();
		}, this));

		if (this.options.project.inviteSettings.responseDue === 'ASAP')
			this.$('input.response-due').val('').prop('disabled', true);
		else {
			if (this.options.project.inviteSettings && this.options.project.inviteSettings.responseDue === '1970-01-01')
				this.$('input.response-due').val('');
			else {
				let rDueDate = new Date(this.options.project.inviteSettings.responseDue);
				this.$('input.response-due').val(PJQ.helpers.dateHelpers.getDateString(rDueDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD, true));
			}
		}

		this.$('input.response-due').on('change keyup', _.bind(function () {
			let dText = this.$('input.response-due').val();
			if(_.size(dText) > 0){
				let dVal = new Date(dText);
				dText = PJQ.helpers.dateHelpers.getDateString(dVal, PJQ.helpers.dateHelpers.dateFormats.DATE, true);
			}

			this.options.project.inviteSettings.responseDue = dText;
			if (typeof this.options.onChange === 'function')
				typeof this.options.onChange();

			this.queuePreview();
		}, this));

		this.$('input.response-due-asap').prop('checked', (this.options.project.inviteSettings.responseDue === 'ASAP'));

		this.$('input.response-due-asap').on('click', _.bind(function () {
			this.options.project.inviteSettings.responseDue = this.$('input.response-due-asap').prop('checked') ? 'ASAP' : this.$('input.response-due').val();
			this.$('input.response-due').val('').prop('disabled', this.$('input.response-due-asap').prop('checked'));
			if (typeof this.options.onChange === 'function')
				typeof this.options.onChange();

			this.renderPreview();
		}, this));

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISABLE_RESPONSE_DUE)) {
			this.$('input.response-due, input.response-due-asap').prop('disabled', true);
		}

		this.messageType = new PJQ.inputs.Selectpicker({
			el: this.$('select.message-type'),
			defaultValue: this.options.project.inviteSettings.emailTemplate ? this.options.project.inviteSettings.emailTemplate.get('templateKey') : this.options.emailTemplates[0].get('templateKey'),
			dropupAuto: false,
			onChange: _.bind(function () {
				this.messageTypeSelected(this.messageType.getValue());
			}, this)
		});

		this.responseType = new PJQ.inputs.Selectpicker({
			el: this.$('select.response-type'),
			defaultValue: this.options.project.inviteSettings.responseType ? this.options.project.inviteSettings.responseType : 'NONE',
			onChange: _.bind(function (value) {
				if (value === 'NONE')
					value = '';
				this.options.project.inviteSettings.responseType = value;
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();

				this.renderPreview();
			}, this),
		});

		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_FAX)) {
			this.$('select.send-options option[value="2"]').prop('hidden', true);
			this.$('select.send-options option[value="3"]').prop('hidden', true);
			this.$('select.send-options option[value="4"]').prop('hidden', true);
		}
		else {
			this.$('select.send-options option[value="2"]').prop('selected', PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL));
			this.$('select.send-options option[value="3"]').prop('selected', PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED));
			this.$('select.send-options option[value="4"]').prop('selected', PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS));
		}

		let sendOptions = ["1"];

		if (this.options.project.inviteSettings.sendFaxIfNoEmail)
			sendOptions.push("2");

		if (this.options.project.inviteSettings.sendFaxIfEmailFails)
			sendOptions.push("3");

		if (this.options.project.inviteSettings.sendFaxAlways)
			sendOptions.push("4");

		new PJQ.inputs.SelectpickerProjectMessageSendOptions({
			el: this.$('select.send-options'),
			onChange: _.bind(function (value) {
				this.options.project.inviteSettings.sendFaxIfNoEmail = value.indexOf("2") !== -1;
				this.options.project.inviteSettings.sendFaxIfEmailFails = value.indexOf("3") !== -1;
				this.options.project.inviteSettings.sendFaxAlways = value.indexOf("4") !== -1;
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();
			}, this),
			isMultiple: true,
			isIntChoices: false,
			hideDisabled: false,
			noneSelectedText: 'No Options Selected',
			defaultValue: sendOptions,
			exclusiveChoices: ["4"]
		});

		this.messageBodyEditor = new PJQ.inputs.HTMLEditor({
			el: this.$('div.invite-message'),
			defaultValue: this.options.project.inviteSettings.messageBody,
			onInit: _.bind(function () {
				let tokenBtn = '<button type="button" class="btn btn-default btn-sm btn-small tokenBtn" title="Token List" data-event="something" tabindex="-1">Tokens</button>',
					tokenGroup = '<div class="note-file btn-group">' + tokenBtn + '</div>';

				$(tokenGroup).prependTo(this.$('.note-toolbar'));
				this.$('.tokenBtn').tooltip({container: 'body', placement: 'bottom'});
				this.$('.tokenBtn').click(function (event) {
					// load token dialog
				});

			}, this),
			onChange: _.bind(function (contents) {
				this.options.project.inviteSettings.messageBody = contents;
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();

				this.queuePreview();
			}, this)
		});

		if (this.options.isShowAttachments) {
			this.uploader = new PJQ.views.files.FileUploaderGrid({
				el: this.$('.uploader'),
				collection: this.options.project.inviteSettings.attachments,
				uuid: this.options.project.inviteSettings.uploaderGuid
			});

			this.options.project.fetchAttachments({
				isShared: false,
				includeDrawings: false
			}, _.bind(function (attachments) {
				this.privateFolders = attachments;
				if (_.size(attachments.models) > 1)
					this.$('.private-folders').closest('div.form-group').show();

				new PJQ.views.projects.ProjectAttachments({
					el: this.$('.private-folders'),
					collection: attachments,
					project: this.options.project,
					isHideDownload: true,
					isHideDrawings: true,
					preventSelectAll: true,
					selectedAttachments: this.options.project.inviteSettings.privateFolders,
					onChange: _.bind(function (attachments) {
						this.options.project.inviteSettings.privateFolders = attachments;
					}, this)
				});
			}, this));
		}

		if (!this.options.project.inviteSettings.messageType)
			this.messageTypeSelected(this.options.project.inviteSettings.templateKey ? this.options.project.inviteSettings.templateKey : this.options.emailTemplates[0].get('templateKey'));
		else
			this.renderPreview();

	},
	messageTypeSelected: function (templateKey) {
		let emailTemplate = _.filter(this.options.emailTemplates, function (template) {
			return template.get('templateKey') === templateKey
		})[0];
		this.options.project.inviteSettings.emailTemplate = emailTemplate;
		this.options.project.inviteSettings.messageType = emailTemplate.get('templateKey');
		this.options.project.inviteSettings.messageSubject = emailTemplate.get('subjectTemplate');
		this.options.project.inviteSettings.messageBody = emailTemplate.get('defaultTextTemplate');
		this.options.project.inviteSettings.responseType = emailTemplate.get('projectMessageType');

		this.$('.message-subject').val(this.options.project.inviteSettings.messageSubject);
		this.responseType.setValue(emailTemplate.get('projectMessageType') ? emailTemplate.get('projectMessageType') : "NONE");
		this.messageBodyEditor.setValue(emailTemplate.get('defaultTextTemplate'));

		if (typeof this.options.onChange === 'function')
			typeof this.options.onChange();

		this.renderPreview();
	},
	queuePreview: function() {
		clearTimeout(this.saveTimeout);
		this.saveTimeout = setTimeout(_.bind(function () {
			this.renderPreview();
		}, this), 500);
	},
	renderPreview: function() {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.get('projectId')
			},
			{
				endpoint: 'projectmessagepreview'
			}
		], [
			{
				parameter: "templateKey",
				value: this.options.project.inviteSettings.emailTemplate.get('templateKey')
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function (data) {
			this.options.tokens = data;

			let subject = this.options.project.inviteSettings.messageSubject,
				body = this.options.project.inviteSettings.emailTemplate.get('bodyTemplate');

			this.options.tokens.projectMessage.responseType = 'N/A';
			if (this.options.project.inviteSettings.responseType === 'PROJECT')
				this.options.tokens.projectMessage.responseType = 'ACCEPT/DECLINE';
			else if (this.options.project.inviteSettings.responseType === 'MESSAGE')
				this.options.tokens.projectMessage.responseType = 'YES/NO';

			this.options.tokens.projectMessage.bidDueDate = this.options.project.inviteSettings.responseDue;
			this.options.tokens.projectMessage.responseDueDate = this.options.project.inviteSettings.responseDue;

			this.options.tokens.projectMessage.responseDueDateWithBy = '&nbsp;by&nbsp;' + (this.options.project.inviteSettings.responseDue ? this.options.project.inviteSettings.responseDue : 'N/A');

			this.options.tokens.projectMessage.messageBody = this.translateTokens(this.options.project.inviteSettings.messageBody);
			this.$('.message-preview-subject').html(this.translateTokens(subject));
			this.$('.message-preview-body').html(this.translateTokens(body)).scrollTop(0);

		}, this)).fail(function () {
		});

	},
	translateTokens: function (input) {
		input = input.replace(/\[Sender.Username\]/g, this.options.tokens.sender.username);
		input = input.replace(/\[Sender.Company\]/g, this.options.tokens.sender.company);
		input = input.replace(/\[Sender.Contact\]/g, this.options.tokens.sender.contact);
		input = input.replace(/\[Sender.Address1\]/g, this.options.tokens.sender.address1);
		input = input.replace(/\[Sender.Address2\]/g, this.options.tokens.sender.address2);
		input = input.replace(/\[Sender.City\]/g, this.options.tokens.sender.city);
		input = input.replace(/\[Sender.State\]/g, this.options.tokens.sender.state);
		input = input.replace(/\[Sender.Zip\]/g, this.options.tokens.sender.zip);
		input = input.replace(/\[Sender.Country\]/g, this.options.tokens.sender.country);
		input = input.replace(/\[Sender.Phone\]/g, this.options.tokens.sender.phone);
		input = input.replace(/\[Sender.PhoneExtension\]/g, this.options.tokens.sender.phoneExtension);
		input = input.replace(/\[Sender.Fax\]/g, this.options.tokens.sender.fax);
		input = input.replace(/\[Sender.Cell\]/g, this.options.tokens.sender.cell);
		input = input.replace(/\[Sender.Email\]/g, this.options.tokens.sender.email);
		input = input.replace(/\[Sender.EmailLogoURL\]/g, this.options.tokens.sender.emailLogoURL);
		input = input.replace(/\[Sender.FullAddress\]/g, this.options.tokens.sender.fullAddress);
		input = input.replace(/\[Sender.Email2\]/g, this.options.tokens.sender.email2);
		input = input.replace(/\[Sender.Signature\]/g, this.options.tokens.sender.signature);
		input = input.replace(/\[Sender.UserType\]/g, this.options.tokens.sender.userType);

		input = input.replace(/\[SenderPM.Username\]/g, this.options.tokens.senderPM.username);
		input = input.replace(/\[SenderPM.Company\]/g, this.options.tokens.senderPM.company);
		input = input.replace(/\[SenderPM.Contact\]/g, this.options.tokens.senderPM.contact);
		input = input.replace(/\[SenderPM.Address1\]/g, this.options.tokens.senderPM.address1);
		input = input.replace(/\[SenderPM.Address2\]/g, this.options.tokens.senderPM.address2);
		input = input.replace(/\[SenderPM.City\]/g, this.options.tokens.senderPM.city);
		input = input.replace(/\[SenderPM.State\]/g, this.options.tokens.senderPM.state);
		input = input.replace(/\[SenderPM.Zip\]/g, this.options.tokens.senderPM.zip);
		input = input.replace(/\[SenderPM.Country\]/g, this.options.tokens.senderPM.country);
		input = input.replace(/\[SenderPM.Phone\]/g, this.options.tokens.senderPM.phone);
		input = input.replace(/\[SenderPM.PhoneExtension\]/g, this.options.tokens.senderPM.phoneExtension);
		input = input.replace(/\[SenderPM.Fax\]/g, this.options.tokens.senderPM.fax);
		input = input.replace(/\[SenderPM.Cell\]/g, this.options.tokens.senderPM.cell);
		input = input.replace(/\[SenderPM.Email\]/g, this.options.tokens.senderPM.email);
		input = input.replace(/\[SenderPM.EmailLogoURL\]/g, this.options.tokens.senderPM.emailLogoURL);
		input = input.replace(/\[SenderPM.FullAddress\]/g, this.options.tokens.senderPM.fullAddress);
		input = input.replace(/\[SenderPM.Email2\]/g, this.options.tokens.senderPM.email2);
		input = input.replace(/\[SenderPM.UserType\]/g, this.options.tokens.senderPM.userType);


		input = input.replace(/\[ProjectContact2.Username\]/g, this.options.tokens.projectContact2.username);
		input = input.replace(/\[ProjectContact2.Company\]/g, this.options.tokens.projectContact2.company);
		input = input.replace(/\[ProjectContact2.Contact\]/g, this.options.tokens.projectContact2.contact);
		input = input.replace(/\[ProjectContact2.Address1\]/g, this.options.tokens.projectContact2.address1);
		input = input.replace(/\[ProjectContact2.Address2\]/g, this.options.tokens.projectContact2.address2);
		input = input.replace(/\[ProjectContact2.City\]/g, this.options.tokens.projectContact2.city);
		input = input.replace(/\[ProjectContact2.State\]/g, this.options.tokens.projectContact2.state);
		input = input.replace(/\[ProjectContact2.Zip\]/g, this.options.tokens.projectContact2.zip);
		input = input.replace(/\[ProjectContact2.Country\]/g, this.options.tokens.projectContact2.country);
		input = input.replace(/\[ProjectContact2.Phone\]/g, this.options.tokens.projectContact2.phone);
		input = input.replace(/\[ProjectContact2.PhoneExtension\]/g, this.options.tokens.projectContact2.phoneExtension);
		input = input.replace(/\[ProjectContact2.Fax\]/g, this.options.tokens.projectContact2.fax);
		input = input.replace(/\[ProjectContact2.Cell\]/g, this.options.tokens.projectContact2.cell);
		input = input.replace(/\[ProjectContact2.Email\]/g, this.options.tokens.projectContact2.email);
		input = input.replace(/\[ProjectContact2.EmailLogoURL\]/g, this.options.tokens.projectContact2.emailLogoURL);
		input = input.replace(/\[ProjectContact2.FullAddress\]/g, this.options.tokens.projectContact2.fullAddress);
		input = input.replace(/\[ProjectContact2.Email2\]/g, this.options.tokens.projectContact2.email2);
		input = input.replace(/\[ProjectContact2.Signature\]/g, this.options.tokens.projectContact2.signature);
		input = input.replace(/\[ProjectContact2.UserType\]/g, this.options.tokens.projectContact2.userType);

		input = input.replace(/\[Recipient.Company\]/g, this.options.tokens.recipient.company);
		input = input.replace(/\[Recipient.Contact\]/g, this.options.tokens.recipient.contact);
		input = input.replace(/\[Recipient.FirstName\]/g, this.options.tokens.recipient.firstName);
		input = input.replace(/\[Recipient.Title\]/g, this.options.tokens.recipient.title);
		input = input.replace(/\[Recipient.Address1\]/g, this.options.tokens.recipient.address1);
		input = input.replace(/\[Recipient.Address2\]/g, this.options.tokens.recipient.address2);
		input = input.replace(/\[Recipient.City\]/g, this.options.tokens.recipient.city);
		input = input.replace(/\[Recipient.State\]/g, this.options.tokens.recipient.state);
		input = input.replace(/\[Recipient.Zip\]/g, this.options.tokens.recipient.zip);
		input = input.replace(/\[Recipient.Country\]/g, this.options.tokens.recipient.country);
		input = input.replace(/\[Recipient.Phone\]/g, this.options.tokens.recipient.phone);
		input = input.replace(/\[Recipient.PhoneExtension\]/g, this.options.tokens.recipient.phoneExtension);
		input = input.replace(/\[Recipient.Fax\]/g, this.options.tokens.recipient.fax);
		input = input.replace(/\[Recipient.Email\]/g, this.options.tokens.recipient.email);
		input = input.replace(/\[Recipient.EmailLogoURL\]/g, this.options.tokens.recipient.emailLogoURL);
		input = input.replace(/\[Recipient.FullAddress\]/g, this.options.tokens.recipient.fullAddress);

		input = input.replace(/\[Portal.URL\]/g, this.options.tokens.portal.url);
		input = input.replace(/\[Portal.Domain\]/g, this.options.tokens.portal.domain);
		input = input.replace(/\[DateTime.Today\]/g, this.options.tokens.dateTime.today);

		input = input.replace(/\[ProjectMessage.AccessKey\]/g, this.options.tokens.projectMessage.accessKey);
		input = input.replace(/\[ProjectMessage.RSVPURL\]/g, this.options.tokens.projectMessage.rsvpurl);
		input = input.replace(/\[ProjectMessage.RecipientGroupList\]/g, this.options.tokens.projectMessage.recipientGroupList);
		input = input.replace(/\[ProjectMessage.RecipientGroupListComma\]/g, this.options.tokens.projectMessage.recipientGroupListComma);
		input = input.replace(/\[ProjectMessage.ResponseDueLabel\]/g, this.options.tokens.projectMessage.responseDueLabel);
		input = input.replace(/\[ProjectMessage.MessageResponseDueLabel\]/g, this.options.tokens.projectMessage.messageResponseDueLabel);
		input = input.replace(/\[ProjectMessage.ResponseDueDate\]/g, this.options.tokens.projectMessage.responseDueDate);
		input = input.replace(/\[ProjectMessage.ResponseDueDateWithBy\]/g, this.options.tokens.projectMessage.responseDueDateWithBy ? this.options.tokens.projectMessage.responseDueDateWithBy : '');
		input = input.replace(/\[ProjectMessage.ResponseDueTime\]/g, this.options.tokens.projectMessage.responseDueTime);
		input = input.replace(/\[ProjectMessage.MessageSubject\]/g, this.options.tokens.projectMessage.messageSubject);
		input = input.replace(/\[ProjectMessage.MessageBody\]/g, this.options.tokens.projectMessage.messageBody);
		input = input.replace(/\[ProjectMessage.SentOnDate\]/g, this.options.tokens.projectMessage.sentOnDate);
		input = input.replace(/\[ProjectMessage.EstCompleteDate\]/g, this.options.tokens.projectMessage.estCompleteDate);
		input = input.replace(/\[ProjectMessage.EstStartDate\]/g, this.options.tokens.projectMessage.estStartDate);
		input = input.replace(/\[ProjectMessage.MessageType\]/g, this.options.tokens.projectMessage.messageType);
		input = input.replace(/\[ProjectMessage.ResponseType\]/g, this.options.tokens.projectMessage.responseType);
		input = input.replace(/\[ProjectMessage.MessageName\]/g, this.options.tokens.projectMessage.messageName);

		input = input.replace(/\[Project.ProjectId\]/g, this.options.tokens.project.projectId);
		input = input.replace(/\[Project.Name\]/g, this.options.tokens.project.name);
		input = input.replace(/\[Project.Address1\]/g, this.options.tokens.project.address1);
		input = input.replace(/\[Project.Address2\]/g, this.options.tokens.project.address2);
		input = input.replace(/\[Project.City\]/g, this.options.tokens.project.city);
		input = input.replace(/\[Project.State\]/g, this.options.tokens.project.state);
		input = input.replace(/\[Project.Zip\]/g, this.options.tokens.project.zip);
		input = input.replace(/\[Project.Country\]/g, this.options.tokens.project.country);
		input = input.replace(/\[Project.Notes\]/g, this.options.tokens.project.notes);
		input = input.replace(/\[Project.ResponseDueLabel\]/g, this.options.tokens.project.responseDueLabel);
		input = input.replace(/\[Project.MessageResponseDueLabel\]/g, this.options.tokens.project.messageResponseDueLabel);
		input = input.replace(/\[Project.ResponseDueDate\]/g, this.options.tokens.project.responseDueDate);
		input = input.replace(/\[Project.ResponseDueTime\]/g, this.options.tokens.project.responseDueTime);
		input = input.replace(/\[Project.ResponseDueShortTime\]/g, this.options.tokens.project.responseDueShortTime);
		input = input.replace(/\[Project.ResponseDueTimeZone\]/g, this.options.tokens.project.responseDueTimeZone);
		input = input.replace(/\[Project.ResponseDueDateWithBy\]/g, this.options.tokens.project.responseDueDateWithBy);
		input = input.replace(/\[Project.StartDate\]/g, this.options.tokens.project.startDate);
		input = input.replace(/\[Project.EndDate\]/g, this.options.tokens.project.endDate);
		input = input.replace(/\[Project.ProjectStatus\]/g, this.options.tokens.project.projectStatus);
		input = input.replace(/\[Project.CustomFieldLabel1\]/g, this.options.tokens.project.customFieldLabel1);
		input = input.replace(/\[Project.CustomFieldValue1\]/g, this.options.tokens.project.customFieldValue1);
		input = input.replace(/\[Project.CustomFieldLabel2\]/g, this.options.tokens.project.customFieldLabel2);
		input = input.replace(/\[Project.CustomFieldValue2\]/g, this.options.tokens.project.customFieldValue2);
		input = input.replace(/\[Project.CustomFieldLabel3\]/g, this.options.tokens.project.customFieldLabel3);
		input = input.replace(/\[Project.CustomFieldValue3\]/g, this.options.tokens.project.customFieldValue3);
		input = input.replace(/\[Project.CustomFieldLabel4\]/g, this.options.tokens.project.customFieldLabel4);
		input = input.replace(/\[Project.CustomFieldValue4\]/g, this.options.tokens.project.customFieldValue4);
		input = input.replace(/\[Project.CustomFieldLabel5\]/g, this.options.tokens.project.customFieldLabel5);
		input = input.replace(/\[Project.CustomFieldValue5\]/g, this.options.tokens.project.customFieldValue5);
		input = input.replace(/\[Project.CustomFieldLabel6\]/g, this.options.tokens.project.customFieldLabel6);
		input = input.replace(/\[Project.CustomFieldValue6\]/g, this.options.tokens.project.customFieldValue6);
		input = input.replace(/\[Project.CustomFieldLabel7\]/g, this.options.tokens.project.customFieldLabel7);
		input = input.replace(/\[Project.CustomFieldValue7\]/g, this.options.tokens.project.customFieldValue7);
		input = input.replace(/\[Project.CustomFieldLabel8\]/g, this.options.tokens.project.customFieldLabel8);
		input = input.replace(/\[Project.CustomFieldValue8\]/g, this.options.tokens.project.customFieldValue8);
		input = input.replace(/\[Project.CustomFieldLabel9\]/g, this.options.tokens.project.customFieldLabel9);
		input = input.replace(/\[Project.CustomFieldValue9\]/g, this.options.tokens.project.customFieldValue9);
		input = input.replace(/\[Project.CustomFieldLabel10\]/g, this.options.tokens.project.customFieldLabel10);
		input = input.replace(/\[Project.CustomFieldValue10\]/g, this.options.tokens.project.customFieldValue10);
		input = input.replace(/\[Project.CustomFieldLabel11\]/g, this.options.tokens.project.customFieldLabel11);
		input = input.replace(/\[Project.CustomFieldValue11\]/g, this.options.tokens.project.customFieldValue11);
		input = input.replace(/\[Project.CustomFieldLabel12\]/g, this.options.tokens.project.customFieldLabel12);
		input = input.replace(/\[Project.CustomFieldValue12\]/g, this.options.tokens.project.customFieldValue12);
		input = input.replace(/\[Project.CustomFieldLabel13\]/g, this.options.tokens.project.customFieldLabel13);
		input = input.replace(/\[Project.CustomFieldValue13\]/g, this.options.tokens.project.customFieldValue13);
		input = input.replace(/\[Project.CustomFieldLabel14\]/g, this.options.tokens.project.customFieldLabel14);
		input = input.replace(/\[Project.CustomFieldValue14\]/g, this.options.tokens.project.customFieldValue14);
		input = input.replace(/\[Project.CustomFieldLabel15\]/g, this.options.tokens.project.customFieldLabel15);
		input = input.replace(/\[Project.CustomFieldValue15\]/g, this.options.tokens.project.customFieldValue15);
		input = input.replace(/\[Project.CustomFieldLabel16\]/g, this.options.tokens.project.customFieldLabel16);
		input = input.replace(/\[Project.CustomFieldValue16\]/g, this.options.tokens.project.customFieldValue16);
		input = input.replace(/\[Project.CustomFieldLabel17\]/g, this.options.tokens.project.customFieldLabel17);
		input = input.replace(/\[Project.CustomFieldValue17\]/g, this.options.tokens.project.customFieldValue17);
		input = input.replace(/\[Project.CustomFieldLabel18\]/g, this.options.tokens.project.customFieldLabel18);
		input = input.replace(/\[Project.CustomFieldValue18\]/g, this.options.tokens.project.customFieldValue18);
		input = input.replace(/\[Project.CustomFieldLabel19\]/g, this.options.tokens.project.customFieldLabel19);
		input = input.replace(/\[Project.CustomFieldValue19\]/g, this.options.tokens.project.customFieldValue19);
		input = input.replace(/\[Project.CustomFieldLabel20\]/g, this.options.tokens.project.customFieldLabel20);
		input = input.replace(/\[Project.CustomFieldValue20\]/g, this.options.tokens.project.customFieldValue20);
		input = input.replace(/\[Project.CustomFieldLabel21\]/g, this.options.tokens.project.customFieldLabel21);
		input = input.replace(/\[Project.CustomFieldValue21\]/g, this.options.tokens.project.customFieldValue21);
		input = input.replace(/\[Project.CustomFieldLabel22\]/g, this.options.tokens.project.customFieldLabel22);
		input = input.replace(/\[Project.CustomFieldValue22\]/g, this.options.tokens.project.customFieldValue22);
		input = input.replace(/\[Project.CustomFieldLabel23\]/g, this.options.tokens.project.customFieldLabel23);
		input = input.replace(/\[Project.CustomFieldValue23\]/g, this.options.tokens.project.customFieldValue23);
		input = input.replace(/\[Project.CustomFieldLabel24\]/g, this.options.tokens.project.customFieldLabel24);
		input = input.replace(/\[Project.CustomFieldValue24\]/g, this.options.tokens.project.customFieldValue24);
		input = input.replace(/\[Project.CustomFieldLabel25\]/g, this.options.tokens.project.customFieldLabel25);
		input = input.replace(/\[Project.CustomFieldValue25\]/g, this.options.tokens.project.customFieldValue25);
		input = input.replace(/\[Project.CustomFieldLabel26\]/g, this.options.tokens.project.customFieldLabel26);
		input = input.replace(/\[Project.CustomFieldValue26\]/g, this.options.tokens.project.customFieldValue26);
		input = input.replace(/\[Project.CustomFieldLabel27\]/g, this.options.tokens.project.customFieldLabel27);
		input = input.replace(/\[Project.CustomFieldValue27\]/g, this.options.tokens.project.customFieldValue27);
		input = input.replace(/\[Project.CustomFieldLabel28\]/g, this.options.tokens.project.customFieldLabel28);
		input = input.replace(/\[Project.CustomFieldValue28\]/g, this.options.tokens.project.customFieldValue28);
		input = input.replace(/\[Project.CustomFieldLabel29\]/g, this.options.tokens.project.customFieldLabel29);
		input = input.replace(/\[Project.CustomFieldValue29\]/g, this.options.tokens.project.customFieldValue29);
		input = input.replace(/\[Project.CustomFieldLabel30\]/g, this.options.tokens.project.customFieldLabel30);
		input = input.replace(/\[Project.CustomFieldValue30\]/g, this.options.tokens.project.customFieldValue30);
		input = input.replace(/\[Project.CustomFieldLabel31\]/g, this.options.tokens.project.customFieldLabel31);
		input = input.replace(/\[Project.CustomFieldValue31\]/g, this.options.tokens.project.customFieldValue31);
		input = input.replace(/\[Project.CustomFieldLabel32\]/g, this.options.tokens.project.customFieldLabel32);
		input = input.replace(/\[Project.CustomFieldValue32\]/g, this.options.tokens.project.customFieldValue32);
		input = input.replace(/\[Project.CustomFieldLabel33\]/g, this.options.tokens.project.customFieldLabel33);
		input = input.replace(/\[Project.CustomFieldValue33\]/g, this.options.tokens.project.customFieldValue33);
		input = input.replace(/\[Project.CustomFieldLabel34\]/g, this.options.tokens.project.customFieldLabel34);
		input = input.replace(/\[Project.CustomFieldValue34\]/g, this.options.tokens.project.customFieldValue34);
		input = input.replace(/\[Project.CustomFieldLabel35\]/g, this.options.tokens.project.customFieldLabel35);
		input = input.replace(/\[Project.CustomFieldValue35\]/g, this.options.tokens.project.customFieldValue35);
		input = input.replace(/\[Project.CustomFieldLabel36\]/g, this.options.tokens.project.customFieldLabel36);
		input = input.replace(/\[Project.CustomFieldValue36\]/g, this.options.tokens.project.customFieldValue36);
		input = input.replace(/\[Project.CustomFieldLabel37\]/g, this.options.tokens.project.customFieldLabel37);
		input = input.replace(/\[Project.CustomFieldValue37\]/g, this.options.tokens.project.customFieldValue37);
		input = input.replace(/\[Project.CustomFieldLabel38\]/g, this.options.tokens.project.customFieldLabel38);
		input = input.replace(/\[Project.CustomFieldValue38\]/g, this.options.tokens.project.customFieldValue38);
		input = input.replace(/\[Project.CustomFieldLabel39\]/g, this.options.tokens.project.customFieldLabel39);
		input = input.replace(/\[Project.CustomFieldValue39\]/g, this.options.tokens.project.customFieldValue39);

		input = input.replace(/\[Project.CustomFieldValue26_CompanyName\]/g, this.options.tokens.project.customFieldValue26_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactName\]/g, this.options.tokens.project.customFieldValue26_ContactName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactTitle\]/g, this.options.tokens.project.customFieldValue26_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue26_Address26\]/g, this.options.tokens.project.customFieldValue26_Address26);
		input = input.replace(/\[Project.CustomFieldValue26_Address2\]/g, this.options.tokens.project.customFieldValue26_Address2);
		input = input.replace(/\[Project.CustomFieldValue26_City\]/g, this.options.tokens.project.customFieldValue26_City);
		input = input.replace(/\[Project.CustomFieldValue26_StateProvince\]/g, this.options.tokens.project.customFieldValue26_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue26_PostalCode\]/g, this.options.tokens.project.customFieldValue26_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue26_Country\]/g, this.options.tokens.project.customFieldValue26_Country);
		input = input.replace(/\[Project.CustomFieldValue26_Phone\]/g, this.options.tokens.project.customFieldValue26_Phone);
		input = input.replace(/\[Project.CustomFieldValue26_Fax\]/g, this.options.tokens.project.customFieldValue26_Fax);
		input = input.replace(/\[Project.CustomFieldValue26_Cell\]/g, this.options.tokens.project.customFieldValue26_Cell);
		input = input.replace(/\[Project.CustomFieldValue26_Email\]/g, this.options.tokens.project.customFieldValue26_Email);

		input = input.replace(/\[Project.CustomFieldValue27_CompanyName\]/g, this.options.tokens.project.customFieldValue27_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactName\]/g, this.options.tokens.project.customFieldValue27_ContactName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactTitle\]/g, this.options.tokens.project.customFieldValue27_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue27_Address27\]/g, this.options.tokens.project.customFieldValue27_Address27);
		input = input.replace(/\[Project.CustomFieldValue27_Address2\]/g, this.options.tokens.project.customFieldValue27_Address2);
		input = input.replace(/\[Project.CustomFieldValue27_City\]/g, this.options.tokens.project.customFieldValue27_City);
		input = input.replace(/\[Project.CustomFieldValue27_StateProvince\]/g, this.options.tokens.project.customFieldValue27_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue27_PostalCode\]/g, this.options.tokens.project.customFieldValue27_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue27_Country\]/g, this.options.tokens.project.customFieldValue27_Country);
		input = input.replace(/\[Project.CustomFieldValue27_Phone\]/g, this.options.tokens.project.customFieldValue27_Phone);
		input = input.replace(/\[Project.CustomFieldValue27_Fax\]/g, this.options.tokens.project.customFieldValue27_Fax);
		input = input.replace(/\[Project.CustomFieldValue27_Cell\]/g, this.options.tokens.project.customFieldValue27_Cell);
		input = input.replace(/\[Project.CustomFieldValue27_Email\]/g, this.options.tokens.project.customFieldValue27_Email);

		input = input.replace(/\[Project.CustomFieldValue1_CLBR\]/g, this.options.tokens.project.customFieldValue1_CLBR);
		input = input.replace(/\[Project.CustomFieldValue2_CLBR\]/g, this.options.tokens.project.customFieldValue2_CLBR);
		input = input.replace(/\[Project.CustomFieldValue3_CLBR\]/g, this.options.tokens.project.customFieldValue3_CLBR);
		input = input.replace(/\[Project.CustomFieldValue4_CLBR\]/g, this.options.tokens.project.customFieldValue4_CLBR);
		input = input.replace(/\[Project.CustomFieldValue5_CLBR\]/g, this.options.tokens.project.customFieldValue5_CLBR);
		input = input.replace(/\[Project.CustomFieldValue6_CLBR\]/g, this.options.tokens.project.customFieldValue6_CLBR);
		input = input.replace(/\[Project.CustomFieldValue7_CLBR\]/g, this.options.tokens.project.customFieldValue7_CLBR);
		input = input.replace(/\[Project.CustomFieldValue8_CLBR\]/g, this.options.tokens.project.customFieldValue8_CLBR);
		input = input.replace(/\[Project.CustomFieldValue9_CLBR\]/g, this.options.tokens.project.customFieldValue9_CLBR);
		input = input.replace(/\[Project.CustomFieldValue10_CLBR\]/g, this.options.tokens.project.customFieldValue10_CLBR);
		input = input.replace(/\[Project.CustomFieldValue11_CLBR\]/g, this.options.tokens.project.customFieldValue11_CLBR);
		input = input.replace(/\[Project.CustomFieldValue12_CLBR\]/g, this.options.tokens.project.customFieldValue12_CLBR);
		input = input.replace(/\[Project.CustomFieldValue13_CLBR\]/g, this.options.tokens.project.customFieldValue13_CLBR);
		input = input.replace(/\[Project.CustomFieldValue14_CLBR\]/g, this.options.tokens.project.customFieldValue14_CLBR);
		input = input.replace(/\[Project.CustomFieldValue15_CLBR\]/g, this.options.tokens.project.customFieldValue15_CLBR);
		input = input.replace(/\[Project.CustomFieldValue16_CLBR\]/g, this.options.tokens.project.customFieldValue16_CLBR);
		input = input.replace(/\[Project.CustomFieldValue17_CLBR\]/g, this.options.tokens.project.customFieldValue17_CLBR);
		input = input.replace(/\[Project.CustomFieldValue18_CLBR\]/g, this.options.tokens.project.customFieldValue18_CLBR);
		input = input.replace(/\[Project.CustomFieldValue19_CLBR\]/g, this.options.tokens.project.customFieldValue19_CLBR);
		input = input.replace(/\[Project.CustomFieldValue20_CLBR\]/g, this.options.tokens.project.customFieldValue20_CLBR);
		input = input.replace(/\[Project.CustomFieldValue21_CLBR\]/g, this.options.tokens.project.customFieldValue21_CLBR);
		input = input.replace(/\[Project.CustomFieldValue22_CLBR\]/g, this.options.tokens.project.customFieldValue22_CLBR);
		input = input.replace(/\[Project.CustomFieldValue23_CLBR\]/g, this.options.tokens.project.customFieldValue23_CLBR);
		input = input.replace(/\[Project.CustomFieldValue24_CLBR\]/g, this.options.tokens.project.customFieldValue24_CLBR);
		input = input.replace(/\[Project.CustomFieldValue25_CLBR\]/g, this.options.tokens.project.customFieldValue25_CLBR);
		input = input.replace(/\[Project.CustomFieldValue26_CLBR\]/g, this.options.tokens.project.customFieldValue26_CLBR);
		input = input.replace(/\[Project.CustomFieldValue27_CLBR\]/g, this.options.tokens.project.customFieldValue27_CLBR);
		input = input.replace(/\[Project.CustomFieldValue28_CLBR\]/g, this.options.tokens.project.customFieldValue28_CLBR);
		input = input.replace(/\[Project.CustomFieldValue29_CLBR\]/g, this.options.tokens.project.customFieldValue29_CLBR);
		input = input.replace(/\[Project.CustomFieldValue30_CLBR\]/g, this.options.tokens.project.customFieldValue30_CLBR);
		input = input.replace(/\[Project.CustomFieldValue31_CLBR\]/g, this.options.tokens.project.customFieldValue31_CLBR);
		input = input.replace(/\[Project.CustomFieldValue32_CLBR\]/g, this.options.tokens.project.customFieldValue32_CLBR);
		input = input.replace(/\[Project.CustomFieldValue33_CLBR\]/g, this.options.tokens.project.customFieldValue33_CLBR);
		input = input.replace(/\[Project.CustomFieldValue34_CLBR\]/g, this.options.tokens.project.customFieldValue34_CLBR);
		input = input.replace(/\[Project.CustomFieldValue35_CLBR\]/g, this.options.tokens.project.customFieldValue35_CLBR);
		input = input.replace(/\[Project.CustomFieldValue36_CLBR\]/g, this.options.tokens.project.customFieldValue36_CLBR);
		input = input.replace(/\[Project.CustomFieldValue37_CLBR\]/g, this.options.tokens.project.customFieldValue37_CLBR);
		input = input.replace(/\[Project.CustomFieldValue38_CLBR\]/g, this.options.tokens.project.customFieldValue38_CLBR);
		input = input.replace(/\[Project.CustomFieldValue39_CLBR\]/g, this.options.tokens.project.customFieldValue39_CLBR);

		input = input.replace(/\[BidForms.GroupDueDates\]/g, this.options.tokens.bidForms.groupDueDates);

		input = input.replace(/\[ProjectContacts.UserType395_CompanyName\]/g, this.options.tokens.projectContacts.userType395_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactName\]/g, this.options.tokens.projectContacts.userType395_ContactName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactTitle\]/g, this.options.tokens.projectContacts.userType395_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType395_Address26\]/g, this.options.tokens.projectContacts.userType395_Address);
		input = input.replace(/\[ProjectContacts.UserType395_Address2\]/g, this.options.tokens.projectContacts.userType395_Address2);
		input = input.replace(/\[ProjectContacts.UserType395_City\]/g, this.options.tokens.projectContacts.userType395_City);
		input = input.replace(/\[ProjectContacts.UserType395_StateProvince\]/g, this.options.tokens.projectContacts.userType395_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType395_PostalCode\]/g, this.options.tokens.projectContacts.userType395_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType395_Country\]/g, this.options.tokens.projectContacts.userType395_Country);
		input = input.replace(/\[ProjectContacts.UserType395_Phone\]/g, this.options.tokens.projectContacts.userType395_Phone);
		input = input.replace(/\[ProjectContacts.UserType395_Fax\]/g, this.options.tokens.projectContacts.userType395_Fax);
		input = input.replace(/\[ProjectContacts.UserType395_Cell\]/g, this.options.tokens.projectContacts.userType395_Cell);
		input = input.replace(/\[ProjectContacts.UserType395_Email\]/g, this.options.tokens.projectContacts.userType395_Email);

		input = input.replace(/\[ProjectContacts.UserType396_CompanyName\]/g, this.options.tokens.projectContacts.userType396_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactName\]/g, this.options.tokens.projectContacts.userType396_ContactName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactTitle\]/g, this.options.tokens.projectContacts.userType396_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType396_Address26\]/g, this.options.tokens.projectContacts.userType396_Address);
		input = input.replace(/\[ProjectContacts.UserType396_Address2\]/g, this.options.tokens.projectContacts.userType396_Address2);
		input = input.replace(/\[ProjectContacts.UserType396_City\]/g, this.options.tokens.projectContacts.userType396_City);
		input = input.replace(/\[ProjectContacts.UserType396_StateProvince\]/g, this.options.tokens.projectContacts.userType396_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType396_PostalCode\]/g, this.options.tokens.projectContacts.userType396_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType396_Country\]/g, this.options.tokens.projectContacts.userType396_Country);
		input = input.replace(/\[ProjectContacts.UserType396_Phone\]/g, this.options.tokens.projectContacts.userType396_Phone);
		input = input.replace(/\[ProjectContacts.UserType396_Fax\]/g, this.options.tokens.projectContacts.userType396_Fax);
		input = input.replace(/\[ProjectContacts.UserType396_Cell\]/g, this.options.tokens.projectContacts.userType396_Cell);
		input = input.replace(/\[ProjectContacts.UserType396_Email\]/g, this.options.tokens.projectContacts.userType396_Email);

		return input;
	}
});

PJQ.views.projectInvites.ProjectInviteModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Invite'),
		minWidth: '90%',
		onSend: _.noop,
		onCancel: _.noop,
		onAddFromThisProject: _.noop,
		onViewSelected: _.noop,
		projectMessagingView: null,
		project: null,
		emailTemplates: [],
		isShowQuickAdd: false,
		isShowAttachments: false,
		isShowAddParticipants: false
	},
	events: {
		'click .preview-invite': 'previewInvite',
		'click .invite-send': 'sendInvite',
		'click .invite-preview': 'previewInvite',
		'click .invite-close': 'closeInvite',
		'click .btn-add-participants-from-project': 'addParticipantsFromProject',
		'click .btn-add-participants-from-this-project': 'addParticipantsFromThisProject',
		'click .btn-detailed-search': 'detailedSearch',
		'click .btn-detailed-search-new': 'detailedSearch',
		'click .btn-simple-search': 'simpleSearch',
		'click .btn-quick-search': 'quickSearch',
		'click .view-selected-contacts': 'viewSelected',
		'click .preview-export': 'export'
	},
	beforeRender: function () {
		this.renderData = {};
	},
	afterRender: function () {
		this.$('.count-selected-contacts').html(_.size(this.options.projectMessagingView.options.selectedContacts));
		this.projectInvite = new PJQ.views.projectInvites.ProjectInvite({
			el: this.$('.project-invite'),
			project: this.options.project,
			emailTemplates: this.options.emailTemplates,
			replyToContacts: this.options.replyToContacts,
			defaultTemplateKey: this.options.defaultTemplateKey,
			onChange: _.bind(function () {
				this.$('.invite-send').prop('disabled', (_.size(this.options.project.inviteSettings.messageSubject) === 0 ||
					_.size(this.options.project.inviteSettings.messageBody) === 0 ||
					(_.size(this.options.projectMessagingView.options.selectedContacts) === 0 &&
						!PJQ.helpers.validators.validateEmail(this.options.project.inviteSettings.quickAdd, true).success)
				));

			}, this),
			isShowQuickAdd: this.options.isShowQuickAdd,
			isShowAttachments: this.options.isShowAttachments
		});
	},
	previewInvite: function () {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.get('projectId')
			},
			{
				endpoint: 'projectmessagepreview'
			}
		], [
			{
				parameter: "templateKey",
				value: this.options.project.inviteSettings.emailTemplate.get('templateKey')
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function (data) {
			new PJQ.views.projectInvites.ProjectInvitePreviewModal({
				tokens: data,
				inviteSettings: this.options.project.inviteSettings,
				project: this.options.project
			});
		}, this)).fail(function () {
		});

	},
	export: function () {
		let responseType = 'N/A';
		if (this.options.project.inviteSettings.responseType === 'PROJECT')
			responseType = 'ACCEPT/DECLINE';
		else if (this.options.project.inviteSettings.responseType === 'MESSAGE')
			responseType = 'YES/NO';

		this.$('.preview-export').prop('disabled', true);

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.get('projectId')
				},
				{
					endpoint: 'projectmessagepreview'
				},
				{
					endpoint: 'export'
				}
			]),
			data: {
				templateKey: this.options.project.inviteSettings.emailTemplate.get('templateKey'),
				responseType: encodeURIComponent(responseType),
				bidDueDate: this.options.project.inviteSettings.responseDue,
				responseDueDate: this.options.project.inviteSettings.responseDue,
				messageSubject: encodeURIComponent(this.projectInvite.translateTokens(this.options.project.inviteSettings.messageSubject)),
				messageBody: encodeURIComponent(this.projectInvite.translateTokens(this.options.project.inviteSettings.messageBody))
			}
		}).post().success(_.bind(function (data) {
			this.$('.preview-export').prop('disabled', false);
			PJQ.files.downloadFile(data.url, {isEndpoint: false});
		}, this));
	},
	closeInvite: function () {
		if (typeof this.options.onCancel === 'function')
			this.options.onCancel();

		this.removeModal();
	},
	sendInvite: function () {
		let button = this.$('.invite-send');
		button.attr('disabled', true);
		if (this.options.project.inviteSettings.attachments && _.size(this.options.project.inviteSettings.attachments.models) > 0) {
			// enforce max file size of 15728640
			let totalSize = 0;
			_.each(this.options.project.inviteSettings.attachments.models, _.bind(function (fileModel) {
				totalSize += fileModel.file ? fileModel.file.size : fileModel.get('size');
			}, this));

			if (totalSize > 15728640) {
				PJQ.notifications.notify.warningNotify({
					message: 'The total size of uploaded attachments exceeds the 15mb limit.'
				});
				button.attr('disabled', false);
				return;
			}
		}
		// Remove no-space replacement characters
		this.options.project.inviteSettings.messageBody = this.options.project.inviteSettings.messageBody.replace(/[\u200B-\u200D\uFEFF]/g, '');

		let sendOptions = [{
			projectId: this.options.project.get('projectId'),
			messageSubject: this.options.project.inviteSettings.messageSubject,
			messageBody: this.options.project.inviteSettings.messageBody,
			responseType: this.options.project.inviteSettings.responseType,
			templateKey: this.options.project.inviteSettings.messageType,
			responseDue: this.options.project.inviteSettings.responseDue,
			sendEmail: true,
			sendFax: this.options.project.inviteSettings.sendFaxAlways,
			sendFaxIfNoEmail: this.options.project.inviteSettings.sendFaxIfNoEmail,
			sendFaxIfEmailFails: this.options.project.inviteSettings.sendFaxIfEmailFails,
			quickAdd: this.options.project.inviteSettings.quickAdd,
			attachments: this.options.project.inviteSettings.attachments.models,
			privateFolders: this.options.project.inviteSettings.privateFolders.models,
			replyTo: this.options.project.inviteSettings.replyTo
		}];

		let endpointCheck = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'sendprojectmessages'
			},
			{
				endpoint: 'checkrecipients'
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpointCheck,
			data: {
				isAddAllGroups: false,
				contacts: this.options.projectMessagingView.options.selectedContacts,
				projectMessageSendOptions: sendOptions
			},
			isApi2: true
		}).post().done(_.bind(function (data) {

			let sendCallback = _.bind(function () {
				let endpointSend = PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects'
					},
					{
						endpoint: 'sendprojectmessages'
					}
				]);
				new PJQ.ajax.Request({
					endpoint: endpointSend,
					data: {
						isAddAllGroups: false,
						contacts: this.options.projectMessagingView.options.selectedContacts,
						projectMessageSendOptions: sendOptions
					},
					isApi2: true
				}).post().done(_.bind(function (data) {
					if (typeof this.options.onSend === 'function')
						this.options.onSend();

					this.options.project.inviteSettings = null;

					PJQ.notifications.notify.successNotify({
						message: 'Message queued for sending'
					});

					this.removeModal();

				}, this)).fail(function () {
					PJQ.notifications.notify.errorNotify({
						message: 'Something went wrong.'
					});
					button.attr('disabled', false);
				});
			}, this);

			if (data.nonPendingCount > 0) {
				new PJQ.views.modals.YesNo({
					header: "Project Status Warning",
					body: "Participants in your selection have a non-PENDING status.  If you send this message, it will reset their status back to PENDING.  Do you want to continue?",
					onYes: _.bind(function () {
						sendCallback();
					}, this)
				});
			}
			else
				sendCallback();


		}, this)).fail(function () {
			button.attr('disabled', false);
			PJQ.notifications.notify.errorNotify({
				message: 'Something went wrong.'
			});
		});


	},
	addSelectedContacts: function (selectedContacts) {
		this.options.projectMessagingView.addSelectedContacts(selectedContacts);
		this.$('.count-selected-contacts').html(this.options.projectMessagingView.options.selectedContacts.length);
		this.options.projectMessagingView.stats.unsentCount += _.size(selectedContacts);
		this.options.projectMessagingView.renderContactStats();
		this.options.projectMessagingView.renderView();
		this.$('.invite-send').prop('disabled', this.options.projectMessagingView.options.selectedContacts.length === 0);
	},
	addParticipantsFromThisProject: function () {
		this.options.onAddFromThisProject(this.options.project.inviteSettings);
		this.removeModal();
	},
	addParticipantsFromProject: function () {
		let statuses = this.options.project.getProjectStatusList();
		new PJQ.views.projectParticipants.AddParticipantsFromProjectModal({
			model: this.options.project,
			isBidFormsEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS),
			projectResponses: statuses,
			isReturnContactIds: true,
			onSave: _.bind(function (selectedContacts) {
				this.addSelectedContacts(selectedContacts);
			}, this)
		});
	},
	simpleSearch: function () {
		let showUnionStatus = true;
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS)) {
			showUnionStatus = !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS);
		}
		new PJQ.views.projectParticipants.AddParticipantsModal({
			model: this.options.project,
			isDirectoryEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY),
			isUnionStatusEnabled: showUnionStatus,
			isReturnContactIds: true,
			onSave: _.bind(function (selectedContacts) {
				this.addSelectedContacts(selectedContacts);
			}, this)
		});
	},
	quickSearch: function () {
		new PJQ.views.contacts.SelectContactsModal({
			isSingleChoice: false,
			onSave: _.bind(function (selectedContacts) {
				this.options.project.addParticipantsById(selectedContacts, _.bind(function () {
					this.addSelectedContacts(_.map(selectedContacts, function (selectedContact) {
						return selectedContact.get('contactId');
					}));
				}, this));
			}, this)
		});
	},
	detailedSearch: function (e) {
		$('form[name="modal-add-participants"]').remove();
		let options = {
			onSave: _.bind(function (selectedContacts) {
				this.addSelectedContacts(selectedContacts);
			}, this)
		};

		if ($(e.currentTarget).hasClass('btn-detailed-search-new') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
			options.isWrapForm = false;
			options.wrapFormName = null;
			options.isUseNewAddressBook = true;
		}

		new PJQ.views.projects.AddParticipantsDetailedModal(options);
	},
	viewSelected: function () {
		if (_.size(this.options.projectMessagingView.options.selectedContacts) > 0) {
			this.options.onViewSelected();
			this.removeModal();
		}
	}
});

PJQ.views.projectInvites.ProjectInvitesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Invites'),
		minWidth: '60%',
		onSend: _.noop,
		onClose: _.noop,
		projects: [],
		emailTemplates: []
	},
	events: {
		'click .project-invites-add-contacts': 'addContacts',
		'click .btn-remove-contact': 'removeContact',
		'click .project-invites-jump-step': 'jumpStep',
		'click .preview-invite': 'previewInvite',
		'click .remove-invite': 'removeInvite',
		'click .invites-close': 'onClose',
		'click .invites-send': 'onSend',
		'click .btn-detailed-search-new': 'detailedSearch',
	},
	beforeModalCreated: function () {
		this.contacts = [];
		this.selectedContacts = [];
		this.selectedCompanies = [];
		this.selectedGroups = [];
	},
	beforeRender: function () {
		this.renderData = {
			projects: this.options.projects,
			emailTemplates: this.options.emailTemplates,
			responseDueLabel: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) : "Response Due"
		};
	},
	afterRender: function () {
		this.contactTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.contact-list'),
			data: [],
			isHideSearch: true,
			order: [],
			columns: [
				{"data": "attributes.companyName", "title": "Company Name", "orderable": false},
				{"data": "attributes.contactName", "title": "Contact Name", "orderable": false},
				{"data": "attributes.phone", "title": "Phone", "orderable": false},
				{"data": "attributes.email", "title": "Email", "orderable": false},
				{
					"title": '',
					"render": function () {
						return '<button type="button" class="btn btn-danger btn-remove-contact ml-2" title="Remove Contact"><i class="fal fa-trash"></i></button>';
					},
					"width": "120px",
					"orderable": false,
					"searchable": false,
					"className": "text-center",
					"visible": true
				}
			],
			dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
			language: {
				"emptyTable": "No contacts have been selected"
			}
		});
		$('#project-invite-step-2').on('shown.bs.collapse', _.bind(function () {
			this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
			if (this.step === 2 && this.$('#projectInvitesAccordion div.collapse.show').length === 0) {
				this.$('#project-accordion-' + this.options.projects[0].get('projectId')).collapse('show');
			}
		}, this));

		$('div.collapse.project-accordion-step').on('shown.bs.collapse', _.bind(function (e) {
			let projectId = parseInt($(e.currentTarget).data('projectId')),
				project = _.filter(this.options.projects, _.bind(function (project, index) {
					return projectId === project.get('projectId');
				}, this))[0];

			if (!project.inviteSettings.isShown) {
				project.inviteSettings.isShown = true;

				// todo: initialize all other controls here since they don't seem to be working from the other place.

				if (project.get('rDueText') === 'ASAP') {
					project.inviteSettings.responseDueAsapCheckbox.prop('checked', true);
					project.inviteSettings.responseDueInput.val('').prop('disabled', true);
				}
				else if (_.size(project.get('rDueText')) > 0) {
					project.inviteSettings.responseDueInput.val(PJQ.helpers.dateHelpers.getDateString(PJQ.helpers.dateHelpers.parseDateString(project.get('rDueText'), false), PJQ.helpers.dateHelpers.dateFormats.DATE));
				}

				this.messageTypeSelected(project.get('projectId'), this.options.emailTemplates[0].get('templateKey'));
			}
		}, this));

		_.each(this.options.projects, _.bind(function (project) {
			project.inviteSettings = {};
			project.inviteSettings.isShown = false;
			project.inviteSettings.messageSubject = this.options.emailTemplates[0].get('subjectTemplate');
			project.inviteSettings.messageType = this.options.emailTemplates[0].get('templateKey');
			project.inviteSettings.responseType = this.options.emailTemplates[0].get('projectMessageType');
			project.inviteSettings.sendOptions = {};
			project.inviteSettings.sendOptions.sendEmail = true;
			project.inviteSettings.sendOptions.sendFaxIfNoEmail = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL);
			project.inviteSettings.sendOptions.sendFaxIfEmailFails = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED);
			project.inviteSettings.sendOptions.sendFaxAlways = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS);
			project.inviteSettings.messageBody = this.options.emailTemplates[0].get('defaultTextTemplate');
			project.inviteSettings.responseDue = (project.get('rDueText') === 'ASAP') ? 'ASAP' : project.get('rDueText');

			project.inviteSettings.messageSubjectInput = this.$('#project-accordion-' + project.get('projectId') + ' input.message-subject');
			project.inviteSettings.messageSubjectInput.on('change', _.bind(function () {
				project.inviteSettings.messageSubject = project.inviteSettings.messageSubjectInput.val();
			}, this));
			project.inviteSettings.responseDueInput = this.$('#project-accordion-' + project.get('projectId') + ' input.response-due');
			project.inviteSettings.responseDueInput.on('change', _.bind(function () {
				project.inviteSettings.responseDue = project.inviteSettings.responseDueAsapCheckbox.prop('checked') ? 'ASAP' : project.inviteSettings.responseDueInput.val();
			}, this));
			project.inviteSettings.responseDueAsapCheckbox = this.$('#project-accordion-' + project.get('projectId') + ' input.response-due-asap');
			project.inviteSettings.responseDueAsapCheckbox.on('click', _.bind(function () {
				project.inviteSettings.responseDue = project.inviteSettings.responseDueAsapCheckbox.prop('checked') ? 'ASAP' : project.inviteSettings.responseDueInput.val();
				project.inviteSettings.responseDueInput.val('').prop('disabled', project.inviteSettings.responseDueAsapCheckbox.prop('checked'));
			}, this));

			project.inviteSettings.messageTypeSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('#project-accordion-' + project.get('projectId') + ' select.message-type'),
				dropupAuto: false,
				onChange: _.bind(function () {
					this.messageTypeSelected(project.get('projectId'), project.inviteSettings.messageTypeSelectPicker.getValue());
				}, this)
			});

			project.inviteSettings.responseTypeSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('#project-accordion-' + project.get('projectId') + ' select.response-type'),
				onChange: _.bind(function (value) {
					project.inviteSettings.responseType = value;
				}, this),
			});

			let defaultSendOptions = ["1"];
			if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_FAX)) {
				this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="2"]').prop('hidden', true);
				this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="3"]').prop('hidden', true);
				this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="4"]').prop('hidden', true);
			}
			else {
				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL)) {
					this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="2"]').prop('selected', true);
					defaultSendOptions.push("2");
				}

				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED)) {
					this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="3"]').prop('selected', true);
					defaultSendOptions.push("3");
				}

				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS)) {
					this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="4"]').prop('selected', true);
					defaultSendOptions.push("4");
				}
			}

			project.inviteSettings.sendOptionsSelectPicker = new PJQ.inputs.SelectpickerProjectMessageSendOptions({
				el: this.$('#project-accordion-' + project.get('projectId') + ' select.send-options'),
				onChange: _.bind(function (value) {
					project.inviteSettings.sendFaxIfNoEmail = value.indexOf("2") !== -1;
					project.inviteSettings.sendFaxIfEmailFails = value.indexOf("3") !== -1;
					project.inviteSettings.sendFaxAlways = value.indexOf("4") !== -1;
				}, this),
				isMultiple: true,
				isIntChoices: false,
				hideDisabled: false,
				noneSelectedText: 'No Options Selected',
				defaultValue: ["1"],
				exclusiveChoices: ["4"]
			});

			project.inviteSettings.messageBodyHTMLEditor = new PJQ.inputs.HTMLEditor({
				el: this.$('#project-accordion-' + project.get('projectId') + ' div.invite-message'),
				onInit: _.bind(function () {
					let tokenBtn = '<button type="button" class="btn btn-default btn-sm btn-small tokenBtn" title="Token List" data-event="something" tabindex="-1">Tokens</button>',
						tokenGroup = '<div class="note-file btn-group">' + tokenBtn + '</div>';

					$(tokenGroup).prependTo(this.$('.note-toolbar'));
					this.$('.tokenBtn').tooltip({container: 'body', placement: 'bottom'});
					this.$('.tokenBtn').click(function (event) {
						// load token dialog
					});

				}, this),
				onChange: _.bind(function (contents) {
					project.inviteSettings.messageBody = contents;
				}, this),
				defaultValue: this.options.emailTemplates[0].get('defaultTextTemplate')
			});
		}, this));

		this.$('.project-invites-selected-project-count').text(_.size(this.options.projects));
		this.manageButtonStates(0);
		this.goToStep(1);
	},
	onClose: function () {
		if (typeof this.options.onClose === 'function')
			this.options.onClose();
		this.removeModal();
	},
	detailedSearch: function (e) {
		$('form[name="modal-add-participants"]').remove();
		let options = {
			onSave: _.bind(function (selectedContactsAll, data) {
				this.selectedContacts = _.union(this.selectedContacts, data.selectedContacts);
				this.selectedCompanies = _.union(this.selectedCompanies, data.selectedCompanies);
				this.selectedGroups = _.union(this.selectedGroups, data.selectedGroups);

				if (_.size(selectedContactsAll) > 0) {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'contacts'
							},
							{
								endpoint: 'list'
							},
						], [{
							parameter: 'contactIds',
							value: selectedContactsAll
						}
						])
					}).get().done(_.bind(function (data) {
						if (_.size(data) > 0) {
							_.each(data, function (model) {
								this.contacts.push(new PJQ.models.contacts.Contact(model))
							}, this)
							this.contactTable.resetData(this.contacts);
							this.contactTable.dataTable.draw();
							this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
						}
					}, this)).fail(function (xhr, err, result) {

					});
				}
			}, this),
			disableContacts: _.map(this.contactTable.dataTable.data(), function (row) {
				return row.attributes.contactId;
			})
		};

		if ($(e.currentTarget).hasClass('btn-detailed-search-new') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
			options.isWrapForm = false;
			options.wrapFormName = null;
			options.isUseNewAddressBook = true;
			options.isMultipleProjects = true;
			options.projects = this.options.projects;
		}

		new PJQ.views.projects.AddParticipantsDetailedModal(options);
	},

	onSend: function () {
		let sendOptions = [];
		_.each(this.options.projects, _.bind(function (project) {
			let sendOption = {};
			sendOption.projectId = project.get('projectId');
			sendOption.messageSubject = project.inviteSettings.messageSubject;
			sendOption.messageBody = project.inviteSettings.messageBody;
			sendOption.responseType = project.inviteSettings.responseType;
			sendOption.templateKey = project.inviteSettings.messageType;
			sendOption.responseDue = project.inviteSettings.responseDue;
			sendOption.sendEmail = true;
			sendOption.sendFax = project.inviteSettings.sendFaxAlways;
			sendOption.sendFaxIfNoEmail = project.inviteSettings.sendFaxIfNoEmail;
			sendOption.sendFaxIfEmailFails = project.inviteSettings.sendFaxIfEmailFails;
			sendOptions.push(sendOption);
		}, this));

		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'sendprojectmessages'
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint,
			data: {
				contacts: _.map(this.contactTable.dataTable.data(), function (contact) {
					return contact.get('contactId')
				}),
				projectMessageSendOptions: sendOptions
			}
		}).post().done(_.bind(function (data) {
			if (typeof this.options.onSend === 'function')
				this.options.onSend();

			new PJQ.views.BaseModal({
				header: "Project Invites Sent",
				body: "Your project invites are now being processed for broadcast.",
				isShowCancelButton: false
			});

			this.removeModal();
		}, this)).fail(function () {

		});

	},
	jumpStep: function (e) {
		let step = parseInt($(e.currentTarget).data('step').toString());
		this.goToStep(step);
	},
	goToStep: function (step) {
		this.step = step;
		let thisStep = $('.step-' + this.step.toString()),
			thisStepHeader = $('.step-header-' + this.step.toString());
		this.$('[class*=step-]').not(thisStep).collapse('hide');
		this.$('[class*=step-header-]').not(thisStepHeader).removeClass('text-primary').addClass('text-dark op-4');
		thisStepHeader.removeClass('text-dark op-4').addClass('text-primary');

		if (this.step === 1) {
			this.$('.project-invites-selected-contact-count').parent().removeClass('text-dark op-4').addClass('text-info');
			this.$('.project-invites-selected-project-count').parent().removeClass('text-info').addClass('text-dark op-4');
		}
		else if (this.step === 2) {
			this.$('.project-invites-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');
			this.$('.project-invites-selected-project-count').parent().removeClass('text-dark op-4').addClass('text-info');
		}

		thisStep.collapse('show');
	},
	addContacts: function () {
		new PJQ.views.contacts.SelectContactsModal({
			context: PJQ.constants.contacts.contexts.CONTACTS,
			isSingleChoice: false,
			subtitle: "Add Contacts to Project Invites",
			disableContacts: _.map(this.contactTable.dataTable.data(), function (row) {
				return {id: row.attributes.contactId};
			}),
			onSave: _.bind(function (selectedContacts) {
				this.contactTable.dataTable.rows.add(selectedContacts);
				this.contactTable.dataTable.draw();
				this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
			}, this)
		});
	},
	removeContact: function (e) {
		let row = this.contactTable.getRow($(e.currentTarget).closest('tr')),
			contact = row.data();

		let deleteText = 'Are you sure you want to remove ' + contact.get('companyName') + ' from the list?';
		if (this.contactTable.dataTable.data().length === 1)
			deleteText += ' This is the last contact in the invite list, and if you remove it it will cancel this process.';

		new PJQ.views.BaseModal({
			header: "Confirm Remove Contact",
			okButtonText: 'Remove',
			body: deleteText,
			isShowCancelButton: true,
			onOk: _.bind(function () {
				row.remove().draw();
				this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
				if (this.contactTable.dataTable.data().length === 0)
					this.onClose();
			}, this)
		});
	},
	manageButtonStates: function (contactCount) {
		this.$('.project-invites-selected-contact-count').text(contactCount);
		this.$('.invites-send').prop('disabled', (contactCount === 0 || this.step === 1));
		this.$('.project-invites-jump-step').prop('disabled', contactCount === 0);
	},
	messageTypeSelected: function (projectId, templateKey) {
		let emailTemplate = _.filter(this.options.emailTemplates, function (template) {
			return template.get('templateKey') === templateKey
		})[0];
		let project = _.filter(this.options.projects, function (project) {
			return project.get('projectId') === projectId
		})[0];
		project.inviteSettings.emailTemplate = emailTemplate;
		project.inviteSettings.messageType = emailTemplate.get('templateKey');
		project.inviteSettings.messageSubject = emailTemplate.get('subjectTemplate');
		project.inviteSettings.messageSubjectInput.val(emailTemplate.get('subjectTemplate'));
		project.inviteSettings.responseTypeSelectPicker.setValue(emailTemplate.get('projectMessageType') ? emailTemplate.get('projectMessageType') : "NONE");
		project.inviteSettings.messageBodyHTMLEditor.setValue(emailTemplate.get('defaultTextTemplate'));
		project.inviteSettings.messageBody = emailTemplate.get('defaultTextTemplate');
	},
	previewInvite: function (e) {
		let projectId = parseInt($(e.currentTarget).closest('div.project-accordion-step').data('projectId')),
			project = _.filter(this.options.projects, _.bind(function (project) {
				return project.get('projectId') === projectId
			}, this))[0];

		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: project.get('projectId')
			},
			{
				endpoint: 'projectmessagepreview'
			}
		], [
			{
				parameter: "templateKey",
				value: project.inviteSettings.emailTemplate.get('templateKey')
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function (data) {
			new PJQ.views.projectInvites.ProjectInvitePreviewModal({
				tokens: data,
				inviteSettings: project.inviteSettings,
				project: project
			});
		}, this)).fail(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Something went wrong.'
			});
		});

	},
	removeInvite: function (e) {
		let projectId = this.$(e.currentTarget).closest('div.project-accordion-step').data('projectId'),
			project = _.filter(this.options.projects, _.bind(function (project) {
				return project.get('projectId') === projectId
			}, this))[0];
		let deleteText = 'Are you sure you want to remove this project from the invite list?';

		if (_.size(this.options.projects) === 1)
			deleteText += ' This is the last project in the invite list, and if you remove it it will cancel this process.';

		new PJQ.views.BaseModal({
			header: "Confirm Remove",
			okButtonText: 'Remove',
			body: deleteText,
			isShowCancelButton: true,
			onOk: _.bind(function () {
				this.options.projects = _.filter(this.options.projects, _.bind(function (project) {
					return project.get('projectId') !== projectId;
				}, this));
				this.$('#project-accordion-' + project.get('projectId')).parent().remove();

				if (_.size(this.options.projects) === 0)
					this.onClose();
				else
					this.$('#project-accordion-' + this.options.projects[0].get('projectId')).collapse('show');

			}, this)
		});
	}
});

PJQ.views.projectInvites.ProjectInvitePreviewModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Invite-Preview'),
		minWidth: '60%',
		tokens: null,
		inviteSettings: null,
		project: null
	},
	events: {
		'click .preview-export': 'export'
	},
	afterRender: function () {
		let subject = this.options.inviteSettings.messageSubject,
			body = this.options.inviteSettings.emailTemplate.get('bodyTemplate');

		this.options.tokens.projectMessage.responseType = 'N/A';
		if (this.options.inviteSettings.responseType === 'PROJECT')
			this.options.tokens.projectMessage.responseType = 'ACCEPT/DECLINE';
		else if (this.options.inviteSettings.responseType === 'MESSAGE')
			this.options.tokens.projectMessage.responseType = 'YES/NO';

		this.options.tokens.projectMessage.bidDueDate = this.options.inviteSettings.responseDue;
		this.options.tokens.projectMessage.responseDueDate = this.options.inviteSettings.responseDue;

		this.options.tokens.projectMessage.messageBody = this.translateTokens(this.options.inviteSettings.messageBody);
		this.$('.message-subject').html(this.translateTokens(subject));
		this.$('.message-body').html(this.translateTokens(body));
	},
	translateTokens: function (input) {
		input = input.replace(/\[Sender.Username\]/g, this.options.tokens.sender.username);
		input = input.replace(/\[Sender.Company\]/g, this.options.tokens.sender.company);
		input = input.replace(/\[Sender.Contact\]/g, this.options.tokens.sender.contact);
		input = input.replace(/\[Sender.Address1\]/g, this.options.tokens.sender.address1);
		input = input.replace(/\[Sender.Address2\]/g, this.options.tokens.sender.address2);
		input = input.replace(/\[Sender.City\]/g, this.options.tokens.sender.city);
		input = input.replace(/\[Sender.State\]/g, this.options.tokens.sender.state);
		input = input.replace(/\[Sender.Zip\]/g, this.options.tokens.sender.zip);
		input = input.replace(/\[Sender.Country\]/g, this.options.tokens.sender.country);
		input = input.replace(/\[Sender.Phone\]/g, this.options.tokens.sender.phone);
		input = input.replace(/\[Sender.PhoneExtension\]/g, this.options.tokens.sender.phoneExtension);
		input = input.replace(/\[Sender.Fax\]/g, this.options.tokens.sender.fax);
		input = input.replace(/\[Sender.Cell\]/g, this.options.tokens.sender.cell);
		input = input.replace(/\[Sender.Email\]/g, this.options.tokens.sender.email);
		input = input.replace(/\[Sender.EmailLogoURL\]/g, this.options.tokens.sender.emailLogoURL);
		input = input.replace(/\[Sender.FullAddress\]/g, this.options.tokens.sender.fullAddress);
		input = input.replace(/\[Sender.Email2\]/g, this.options.tokens.sender.email2);
		input = input.replace(/\[Sender.Signature\]/g, this.options.tokens.sender.signature);
		input = input.replace(/\[Sender.UserType\]/g, this.options.tokens.sender.userType);

		input = input.replace(/\[SenderPM.Username\]/g, this.options.tokens.senderPM.username);
		input = input.replace(/\[SenderPM.Company\]/g, this.options.tokens.senderPM.company);
		input = input.replace(/\[SenderPM.Contact\]/g, this.options.tokens.senderPM.contact);
		input = input.replace(/\[SenderPM.Address1\]/g, this.options.tokens.senderPM.address1);
		input = input.replace(/\[SenderPM.Address2\]/g, this.options.tokens.senderPM.address2);
		input = input.replace(/\[SenderPM.City\]/g, this.options.tokens.senderPM.city);
		input = input.replace(/\[SenderPM.State\]/g, this.options.tokens.senderPM.state);
		input = input.replace(/\[SenderPM.Zip\]/g, this.options.tokens.senderPM.zip);
		input = input.replace(/\[SenderPM.Country\]/g, this.options.tokens.senderPM.country);
		input = input.replace(/\[SenderPM.Phone\]/g, this.options.tokens.senderPM.phone);
		input = input.replace(/\[SenderPM.PhoneExtension\]/g, this.options.tokens.senderPM.phoneExtension);
		input = input.replace(/\[SenderPM.Fax\]/g, this.options.tokens.senderPM.fax);
		input = input.replace(/\[SenderPM.Cell\]/g, this.options.tokens.senderPM.cell);
		input = input.replace(/\[SenderPM.Email\]/g, this.options.tokens.senderPM.email);
		input = input.replace(/\[SenderPM.EmailLogoURL\]/g, this.options.tokens.senderPM.emailLogoURL);
		input = input.replace(/\[SenderPM.FullAddress\]/g, this.options.tokens.senderPM.fullAddress);
		input = input.replace(/\[SenderPM.Email2\]/g, this.options.tokens.senderPM.email2);
		input = input.replace(/\[SenderPM.UserType\]/g, this.options.tokens.senderPM.userType);


		input = input.replace(/\[ProjectContact2.Username\]/g, this.options.tokens.projectContact2.username);
		input = input.replace(/\[ProjectContact2.Company\]/g, this.options.tokens.projectContact2.company);
		input = input.replace(/\[ProjectContact2.Contact\]/g, this.options.tokens.projectContact2.contact);
		input = input.replace(/\[ProjectContact2.Address1\]/g, this.options.tokens.projectContact2.address1);
		input = input.replace(/\[ProjectContact2.Address2\]/g, this.options.tokens.projectContact2.address2);
		input = input.replace(/\[ProjectContact2.City\]/g, this.options.tokens.projectContact2.city);
		input = input.replace(/\[ProjectContact2.State\]/g, this.options.tokens.projectContact2.state);
		input = input.replace(/\[ProjectContact2.Zip\]/g, this.options.tokens.projectContact2.zip);
		input = input.replace(/\[ProjectContact2.Country\]/g, this.options.tokens.projectContact2.country);
		input = input.replace(/\[ProjectContact2.Phone\]/g, this.options.tokens.projectContact2.phone);
		input = input.replace(/\[ProjectContact2.PhoneExtension\]/g, this.options.tokens.projectContact2.phoneExtension);
		input = input.replace(/\[ProjectContact2.Fax\]/g, this.options.tokens.projectContact2.fax);
		input = input.replace(/\[ProjectContact2.Cell\]/g, this.options.tokens.projectContact2.cell);
		input = input.replace(/\[ProjectContact2.Email\]/g, this.options.tokens.projectContact2.email);
		input = input.replace(/\[ProjectContact2.EmailLogoURL\]/g, this.options.tokens.projectContact2.emailLogoURL);
		input = input.replace(/\[ProjectContact2.FullAddress\]/g, this.options.tokens.projectContact2.fullAddress);
		input = input.replace(/\[ProjectContact2.Email2\]/g, this.options.tokens.projectContact2.email2);
		input = input.replace(/\[ProjectContact2.Signature\]/g, this.options.tokens.projectContact2.signature);
		input = input.replace(/\[ProjectContact2.UserType\]/g, this.options.tokens.projectContact2.userType);

		input = input.replace(/\[Recipient.Company\]/g, this.options.tokens.recipient.company);
		input = input.replace(/\[Recipient.Contact\]/g, this.options.tokens.recipient.contact);
		input = input.replace(/\[Recipient.FirstName\]/g, this.options.tokens.recipient.firstName);
		input = input.replace(/\[Recipient.Title\]/g, this.options.tokens.recipient.title);
		input = input.replace(/\[Recipient.Address1\]/g, this.options.tokens.recipient.address1);
		input = input.replace(/\[Recipient.Address2\]/g, this.options.tokens.recipient.address2);
		input = input.replace(/\[Recipient.City\]/g, this.options.tokens.recipient.city);
		input = input.replace(/\[Recipient.State\]/g, this.options.tokens.recipient.state);
		input = input.replace(/\[Recipient.Zip\]/g, this.options.tokens.recipient.zip);
		input = input.replace(/\[Recipient.Country\]/g, this.options.tokens.recipient.country);
		input = input.replace(/\[Recipient.Phone\]/g, this.options.tokens.recipient.phone);
		input = input.replace(/\[Recipient.PhoneExtension\]/g, this.options.tokens.recipient.phoneExtension);
		input = input.replace(/\[Recipient.Fax\]/g, this.options.tokens.recipient.fax);
		input = input.replace(/\[Recipient.Email\]/g, this.options.tokens.recipient.email);
		input = input.replace(/\[Recipient.EmailLogoURL\]/g, this.options.tokens.recipient.emailLogoURL);
		input = input.replace(/\[Recipient.FullAddress\]/g, this.options.tokens.recipient.fullAddress);

		input = input.replace(/\[Portal.URL\]/g, this.options.tokens.portal.url);
		input = input.replace(/\[Portal.Domain\]/g, this.options.tokens.portal.domain);
		input = input.replace(/\[DateTime.Today\]/g, this.options.tokens.dateTime.today);

		input = input.replace(/\[ProjectMessage.AccessKey\]/g, this.options.tokens.projectMessage.accessKey);
		input = input.replace(/\[ProjectMessage.RSVPURL\]/g, this.options.tokens.projectMessage.rsvpurl);
		input = input.replace(/\[ProjectMessage.RecipientGroupList\]/g, this.options.tokens.projectMessage.recipientGroupList);
		input = input.replace(/\[ProjectMessage.RecipientGroupListComma\]/g, this.options.tokens.projectMessage.recipientGroupListComma);
		input = input.replace(/\[ProjectMessage.ResponseDueLabel\]/g, this.options.tokens.projectMessage.responseDueLabel);
		input = input.replace(/\[ProjectMessage.MessageResponseDueLabel\]/g, this.options.tokens.projectMessage.messageResponseDueLabel);
		input = input.replace(/\[ProjectMessage.ResponseDueDate\]/g, this.options.tokens.projectMessage.responseDueDate);
		input = input.replace(/\[ProjectMessage.ResponseDueTime\]/g, this.options.tokens.projectMessage.ResponseDueTime);
		input = input.replace(/\[ProjectMessage.MessageSubject\]/g, this.options.tokens.projectMessage.messageSubject);
		input = input.replace(/\[ProjectMessage.MessageBody\]/g, this.options.tokens.projectMessage.messageBody);
		input = input.replace(/\[ProjectMessage.SentOnDate\]/g, this.options.tokens.projectMessage.sentOnDate);
		input = input.replace(/\[ProjectMessage.EstCompleteDate\]/g, this.options.tokens.projectMessage.estCompleteDate);
		input = input.replace(/\[ProjectMessage.EstStartDate\]/g, this.options.tokens.projectMessage.estStartDate);
		input = input.replace(/\[ProjectMessage.MessageType\]/g, this.options.tokens.projectMessage.messageType);
		input = input.replace(/\[ProjectMessage.ResponseType\]/g, this.options.tokens.projectMessage.responseType);
		input = input.replace(/\[ProjectMessage.MessageName\]/g, this.options.tokens.projectMessage.messageName);

		input = input.replace(/\[Project.ProjectId\]/g, this.options.tokens.project.projectId);
		input = input.replace(/\[Project.Name\]/g, this.options.tokens.project.name);
		input = input.replace(/\[Project.Address1\]/g, this.options.tokens.project.address1);
		input = input.replace(/\[Project.Address2\]/g, this.options.tokens.project.address2);
		input = input.replace(/\[Project.City\]/g, this.options.tokens.project.city);
		input = input.replace(/\[Project.State\]/g, this.options.tokens.project.state);
		input = input.replace(/\[Project.Zip\]/g, this.options.tokens.project.zip);
		input = input.replace(/\[Project.Country\]/g, this.options.tokens.project.country);
		input = input.replace(/\[Project.Notes\]/g, this.options.tokens.project.notes);
		input = input.replace(/\[Project.ResponseDueLabel\]/g, this.options.tokens.project.responseDueLabel);
		input = input.replace(/\[Project.MessageResponseDueLabel\]/g, this.options.tokens.project.messageResponseDueLabel);
		input = input.replace(/\[Project.ResponseDueDate\]/g, this.options.tokens.project.responseDueDate);
		input = input.replace(/\[Project.ResponseDueTime\]/g, this.options.tokens.project.responseDueTime);
		input = input.replace(/\[Project.ResponseDueShortTime\]/g, this.options.tokens.project.responseDueShortTime);
		input = input.replace(/\[Project.ResponseDueTimeZone\]/g, this.options.tokens.project.responseDueTimeZone);
		input = input.replace(/\[Project.ResponseDueDateWithBy\]/g, this.options.tokens.project.responseDueDateWithBy);
		input = input.replace(/\[Project.StartDate\]/g, this.options.tokens.project.startDate);
		input = input.replace(/\[Project.EndDate\]/g, this.options.tokens.project.endDate);
		input = input.replace(/\[Project.ProjectStatus\]/g, this.options.tokens.project.projectStatus);
		input = input.replace(/\[Project.CustomFieldLabel1\]/g, this.options.tokens.project.customFieldLabel1);
		input = input.replace(/\[Project.CustomFieldValue1\]/g, this.options.tokens.project.customFieldValue1);
		input = input.replace(/\[Project.CustomFieldLabel2\]/g, this.options.tokens.project.customFieldLabel2);
		input = input.replace(/\[Project.CustomFieldValue2\]/g, this.options.tokens.project.customFieldValue2);
		input = input.replace(/\[Project.CustomFieldLabel3\]/g, this.options.tokens.project.customFieldLabel3);
		input = input.replace(/\[Project.CustomFieldValue3\]/g, this.options.tokens.project.customFieldValue3);
		input = input.replace(/\[Project.CustomFieldLabel4\]/g, this.options.tokens.project.customFieldLabel4);
		input = input.replace(/\[Project.CustomFieldValue4\]/g, this.options.tokens.project.customFieldValue4);
		input = input.replace(/\[Project.CustomFieldLabel5\]/g, this.options.tokens.project.customFieldLabel5);
		input = input.replace(/\[Project.CustomFieldValue5\]/g, this.options.tokens.project.customFieldValue5);
		input = input.replace(/\[Project.CustomFieldLabel6\]/g, this.options.tokens.project.customFieldLabel6);
		input = input.replace(/\[Project.CustomFieldValue6\]/g, this.options.tokens.project.customFieldValue6);
		input = input.replace(/\[Project.CustomFieldLabel7\]/g, this.options.tokens.project.customFieldLabel7);
		input = input.replace(/\[Project.CustomFieldValue7\]/g, this.options.tokens.project.customFieldValue7);
		input = input.replace(/\[Project.CustomFieldLabel8\]/g, this.options.tokens.project.customFieldLabel8);
		input = input.replace(/\[Project.CustomFieldValue8\]/g, this.options.tokens.project.customFieldValue8);
		input = input.replace(/\[Project.CustomFieldLabel9\]/g, this.options.tokens.project.customFieldLabel9);
		input = input.replace(/\[Project.CustomFieldValue9\]/g, this.options.tokens.project.customFieldValue9);
		input = input.replace(/\[Project.CustomFieldLabel10\]/g, this.options.tokens.project.customFieldLabel10);
		input = input.replace(/\[Project.CustomFieldValue10\]/g, this.options.tokens.project.customFieldValue10);
		input = input.replace(/\[Project.CustomFieldLabel11\]/g, this.options.tokens.project.customFieldLabel11);
		input = input.replace(/\[Project.CustomFieldValue11\]/g, this.options.tokens.project.customFieldValue11);
		input = input.replace(/\[Project.CustomFieldLabel12\]/g, this.options.tokens.project.customFieldLabel12);
		input = input.replace(/\[Project.CustomFieldValue12\]/g, this.options.tokens.project.customFieldValue12);
		input = input.replace(/\[Project.CustomFieldLabel13\]/g, this.options.tokens.project.customFieldLabel13);
		input = input.replace(/\[Project.CustomFieldValue13\]/g, this.options.tokens.project.customFieldValue13);
		input = input.replace(/\[Project.CustomFieldLabel14\]/g, this.options.tokens.project.customFieldLabel14);
		input = input.replace(/\[Project.CustomFieldValue14\]/g, this.options.tokens.project.customFieldValue14);
		input = input.replace(/\[Project.CustomFieldLabel15\]/g, this.options.tokens.project.customFieldLabel15);
		input = input.replace(/\[Project.CustomFieldValue15\]/g, this.options.tokens.project.customFieldValue15);
		input = input.replace(/\[Project.CustomFieldLabel16\]/g, this.options.tokens.project.customFieldLabel16);
		input = input.replace(/\[Project.CustomFieldValue16\]/g, this.options.tokens.project.customFieldValue16);
		input = input.replace(/\[Project.CustomFieldLabel17\]/g, this.options.tokens.project.customFieldLabel17);
		input = input.replace(/\[Project.CustomFieldValue17\]/g, this.options.tokens.project.customFieldValue17);
		input = input.replace(/\[Project.CustomFieldLabel18\]/g, this.options.tokens.project.customFieldLabel18);
		input = input.replace(/\[Project.CustomFieldValue18\]/g, this.options.tokens.project.customFieldValue18);
		input = input.replace(/\[Project.CustomFieldLabel19\]/g, this.options.tokens.project.customFieldLabel19);
		input = input.replace(/\[Project.CustomFieldValue19\]/g, this.options.tokens.project.customFieldValue19);
		input = input.replace(/\[Project.CustomFieldLabel20\]/g, this.options.tokens.project.customFieldLabel20);
		input = input.replace(/\[Project.CustomFieldValue20\]/g, this.options.tokens.project.customFieldValue20);
		input = input.replace(/\[Project.CustomFieldLabel21\]/g, this.options.tokens.project.customFieldLabel21);
		input = input.replace(/\[Project.CustomFieldValue21\]/g, this.options.tokens.project.customFieldValue21);
		input = input.replace(/\[Project.CustomFieldLabel22\]/g, this.options.tokens.project.customFieldLabel22);
		input = input.replace(/\[Project.CustomFieldValue22\]/g, this.options.tokens.project.customFieldValue22);
		input = input.replace(/\[Project.CustomFieldLabel23\]/g, this.options.tokens.project.customFieldLabel23);
		input = input.replace(/\[Project.CustomFieldValue23\]/g, this.options.tokens.project.customFieldValue23);
		input = input.replace(/\[Project.CustomFieldLabel24\]/g, this.options.tokens.project.customFieldLabel24);
		input = input.replace(/\[Project.CustomFieldValue24\]/g, this.options.tokens.project.customFieldValue24);
		input = input.replace(/\[Project.CustomFieldLabel25\]/g, this.options.tokens.project.customFieldLabel25);
		input = input.replace(/\[Project.CustomFieldValue25\]/g, this.options.tokens.project.customFieldValue25);
		input = input.replace(/\[Project.CustomFieldLabel26\]/g, this.options.tokens.project.customFieldLabel26);
		input = input.replace(/\[Project.CustomFieldValue26\]/g, this.options.tokens.project.customFieldValue26);
		input = input.replace(/\[Project.CustomFieldLabel27\]/g, this.options.tokens.project.customFieldLabel27);
		input = input.replace(/\[Project.CustomFieldValue27\]/g, this.options.tokens.project.customFieldValue27);
		input = input.replace(/\[Project.CustomFieldLabel28\]/g, this.options.tokens.project.customFieldLabel28);
		input = input.replace(/\[Project.CustomFieldValue28\]/g, this.options.tokens.project.customFieldValue28);
		input = input.replace(/\[Project.CustomFieldLabel29\]/g, this.options.tokens.project.customFieldLabel29);
		input = input.replace(/\[Project.CustomFieldValue29\]/g, this.options.tokens.project.customFieldValue29);
		input = input.replace(/\[Project.CustomFieldLabel30\]/g, this.options.tokens.project.customFieldLabel30);
		input = input.replace(/\[Project.CustomFieldValue30\]/g, this.options.tokens.project.customFieldValue30);
		input = input.replace(/\[Project.CustomFieldLabel31\]/g, this.options.tokens.project.customFieldLabel31);
		input = input.replace(/\[Project.CustomFieldValue31\]/g, this.options.tokens.project.customFieldValue31);
		input = input.replace(/\[Project.CustomFieldLabel32\]/g, this.options.tokens.project.customFieldLabel32);
		input = input.replace(/\[Project.CustomFieldValue32\]/g, this.options.tokens.project.customFieldValue32);
		input = input.replace(/\[Project.CustomFieldLabel33\]/g, this.options.tokens.project.customFieldLabel33);
		input = input.replace(/\[Project.CustomFieldValue33\]/g, this.options.tokens.project.customFieldValue33);
		input = input.replace(/\[Project.CustomFieldLabel34\]/g, this.options.tokens.project.customFieldLabel34);
		input = input.replace(/\[Project.CustomFieldValue34\]/g, this.options.tokens.project.customFieldValue34);
		input = input.replace(/\[Project.CustomFieldLabel35\]/g, this.options.tokens.project.customFieldLabel35);
		input = input.replace(/\[Project.CustomFieldValue35\]/g, this.options.tokens.project.customFieldValue35);
		input = input.replace(/\[Project.CustomFieldLabel36\]/g, this.options.tokens.project.customFieldLabel36);
		input = input.replace(/\[Project.CustomFieldValue36\]/g, this.options.tokens.project.customFieldValue36);
		input = input.replace(/\[Project.CustomFieldLabel37\]/g, this.options.tokens.project.customFieldLabel37);
		input = input.replace(/\[Project.CustomFieldValue37\]/g, this.options.tokens.project.customFieldValue37);
		input = input.replace(/\[Project.CustomFieldLabel38\]/g, this.options.tokens.project.customFieldLabel38);
		input = input.replace(/\[Project.CustomFieldValue38\]/g, this.options.tokens.project.customFieldValue38);
		input = input.replace(/\[Project.CustomFieldLabel39\]/g, this.options.tokens.project.customFieldLabel39);
		input = input.replace(/\[Project.CustomFieldValue39\]/g, this.options.tokens.project.customFieldValue39);

		input = input.replace(/\[Project.CustomFieldValue26_CompanyName\]/g, this.options.tokens.project.customFieldValue26_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactName\]/g, this.options.tokens.project.customFieldValue26_ContactName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactTitle\]/g, this.options.tokens.project.customFieldValue26_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue26_Address26\]/g, this.options.tokens.project.customFieldValue26_Address26);
		input = input.replace(/\[Project.CustomFieldValue26_Address2\]/g, this.options.tokens.project.customFieldValue26_Address2);
		input = input.replace(/\[Project.CustomFieldValue26_City\]/g, this.options.tokens.project.customFieldValue26_City);
		input = input.replace(/\[Project.CustomFieldValue26_StateProvince\]/g, this.options.tokens.project.customFieldValue26_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue26_PostalCode\]/g, this.options.tokens.project.customFieldValue26_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue26_Country\]/g, this.options.tokens.project.customFieldValue26_Country);
		input = input.replace(/\[Project.CustomFieldValue26_Phone\]/g, this.options.tokens.project.customFieldValue26_Phone);
		input = input.replace(/\[Project.CustomFieldValue26_Fax\]/g, this.options.tokens.project.customFieldValue26_Fax);
		input = input.replace(/\[Project.CustomFieldValue26_Cell\]/g, this.options.tokens.project.customFieldValue26_Cell);
		input = input.replace(/\[Project.CustomFieldValue26_Email\]/g, this.options.tokens.project.customFieldValue26_Email);

		input = input.replace(/\[Project.CustomFieldValue27_CompanyName\]/g, this.options.tokens.project.customFieldValue27_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactName\]/g, this.options.tokens.project.customFieldValue27_ContactName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactTitle\]/g, this.options.tokens.project.customFieldValue27_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue27_Address27\]/g, this.options.tokens.project.customFieldValue27_Address27);
		input = input.replace(/\[Project.CustomFieldValue27_Address2\]/g, this.options.tokens.project.customFieldValue27_Address2);
		input = input.replace(/\[Project.CustomFieldValue27_City\]/g, this.options.tokens.project.customFieldValue27_City);
		input = input.replace(/\[Project.CustomFieldValue27_StateProvince\]/g, this.options.tokens.project.customFieldValue27_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue27_PostalCode\]/g, this.options.tokens.project.customFieldValue27_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue27_Country\]/g, this.options.tokens.project.customFieldValue27_Country);
		input = input.replace(/\[Project.CustomFieldValue27_Phone\]/g, this.options.tokens.project.customFieldValue27_Phone);
		input = input.replace(/\[Project.CustomFieldValue27_Fax\]/g, this.options.tokens.project.customFieldValue27_Fax);
		input = input.replace(/\[Project.CustomFieldValue27_Cell\]/g, this.options.tokens.project.customFieldValue27_Cell);
		input = input.replace(/\[Project.CustomFieldValue27_Email\]/g, this.options.tokens.project.customFieldValue27_Email);

		input = input.replace(/\[Project.CustomFieldValue1_CLBR\]/g, this.options.tokens.project.customFieldValue1_CLBR);
		input = input.replace(/\[Project.CustomFieldValue2_CLBR\]/g, this.options.tokens.project.customFieldValue2_CLBR);
		input = input.replace(/\[Project.CustomFieldValue3_CLBR\]/g, this.options.tokens.project.customFieldValue3_CLBR);
		input = input.replace(/\[Project.CustomFieldValue4_CLBR\]/g, this.options.tokens.project.customFieldValue4_CLBR);
		input = input.replace(/\[Project.CustomFieldValue5_CLBR\]/g, this.options.tokens.project.customFieldValue5_CLBR);
		input = input.replace(/\[Project.CustomFieldValue6_CLBR\]/g, this.options.tokens.project.customFieldValue6_CLBR);
		input = input.replace(/\[Project.CustomFieldValue7_CLBR\]/g, this.options.tokens.project.customFieldValue7_CLBR);
		input = input.replace(/\[Project.CustomFieldValue8_CLBR\]/g, this.options.tokens.project.customFieldValue8_CLBR);
		input = input.replace(/\[Project.CustomFieldValue9_CLBR\]/g, this.options.tokens.project.customFieldValue9_CLBR);
		input = input.replace(/\[Project.CustomFieldValue10_CLBR\]/g, this.options.tokens.project.customFieldValue10_CLBR);
		input = input.replace(/\[Project.CustomFieldValue11_CLBR\]/g, this.options.tokens.project.customFieldValue11_CLBR);
		input = input.replace(/\[Project.CustomFieldValue12_CLBR\]/g, this.options.tokens.project.customFieldValue12_CLBR);
		input = input.replace(/\[Project.CustomFieldValue13_CLBR\]/g, this.options.tokens.project.customFieldValue13_CLBR);
		input = input.replace(/\[Project.CustomFieldValue14_CLBR\]/g, this.options.tokens.project.customFieldValue14_CLBR);
		input = input.replace(/\[Project.CustomFieldValue15_CLBR\]/g, this.options.tokens.project.customFieldValue15_CLBR);
		input = input.replace(/\[Project.CustomFieldValue16_CLBR\]/g, this.options.tokens.project.customFieldValue16_CLBR);
		input = input.replace(/\[Project.CustomFieldValue17_CLBR\]/g, this.options.tokens.project.customFieldValue17_CLBR);
		input = input.replace(/\[Project.CustomFieldValue18_CLBR\]/g, this.options.tokens.project.customFieldValue18_CLBR);
		input = input.replace(/\[Project.CustomFieldValue19_CLBR\]/g, this.options.tokens.project.customFieldValue19_CLBR);
		input = input.replace(/\[Project.CustomFieldValue20_CLBR\]/g, this.options.tokens.project.customFieldValue20_CLBR);
		input = input.replace(/\[Project.CustomFieldValue21_CLBR\]/g, this.options.tokens.project.customFieldValue21_CLBR);
		input = input.replace(/\[Project.CustomFieldValue22_CLBR\]/g, this.options.tokens.project.customFieldValue22_CLBR);
		input = input.replace(/\[Project.CustomFieldValue23_CLBR\]/g, this.options.tokens.project.customFieldValue23_CLBR);
		input = input.replace(/\[Project.CustomFieldValue24_CLBR\]/g, this.options.tokens.project.customFieldValue24_CLBR);
		input = input.replace(/\[Project.CustomFieldValue25_CLBR\]/g, this.options.tokens.project.customFieldValue25_CLBR);
		input = input.replace(/\[Project.CustomFieldValue26_CLBR\]/g, this.options.tokens.project.customFieldValue26_CLBR);
		input = input.replace(/\[Project.CustomFieldValue27_CLBR\]/g, this.options.tokens.project.customFieldValue27_CLBR);
		input = input.replace(/\[Project.CustomFieldValue28_CLBR\]/g, this.options.tokens.project.customFieldValue28_CLBR);
		input = input.replace(/\[Project.CustomFieldValue29_CLBR\]/g, this.options.tokens.project.customFieldValue29_CLBR);
		input = input.replace(/\[Project.CustomFieldValue30_CLBR\]/g, this.options.tokens.project.customFieldValue30_CLBR);
		input = input.replace(/\[Project.CustomFieldValue31_CLBR\]/g, this.options.tokens.project.customFieldValue31_CLBR);
		input = input.replace(/\[Project.CustomFieldValue32_CLBR\]/g, this.options.tokens.project.customFieldValue32_CLBR);
		input = input.replace(/\[Project.CustomFieldValue33_CLBR\]/g, this.options.tokens.project.customFieldValue33_CLBR);
		input = input.replace(/\[Project.CustomFieldValue34_CLBR\]/g, this.options.tokens.project.customFieldValue34_CLBR);
		input = input.replace(/\[Project.CustomFieldValue35_CLBR\]/g, this.options.tokens.project.customFieldValue35_CLBR);
		input = input.replace(/\[Project.CustomFieldValue36_CLBR\]/g, this.options.tokens.project.customFieldValue36_CLBR);
		input = input.replace(/\[Project.CustomFieldValue37_CLBR\]/g, this.options.tokens.project.customFieldValue37_CLBR);
		input = input.replace(/\[Project.CustomFieldValue38_CLBR\]/g, this.options.tokens.project.customFieldValue38_CLBR);
		input = input.replace(/\[Project.CustomFieldValue39_CLBR\]/g, this.options.tokens.project.customFieldValue39_CLBR);

		input = input.replace(/\[BidForms.GroupDueDates\]/g, this.options.tokens.bidForms.groupDueDates);

		input = input.replace(/\[ProjectContacts.UserType395_CompanyName\]/g, this.options.tokens.projectContacts.userType395_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactName\]/g, this.options.tokens.projectContacts.userType395_ContactName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactTitle\]/g, this.options.tokens.projectContacts.userType395_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType395_Address26\]/g, this.options.tokens.projectContacts.userType395_Address);
		input = input.replace(/\[ProjectContacts.UserType395_Address2\]/g, this.options.tokens.projectContacts.userType395_Address2);
		input = input.replace(/\[ProjectContacts.UserType395_City\]/g, this.options.tokens.projectContacts.userType395_City);
		input = input.replace(/\[ProjectContacts.UserType395_StateProvince\]/g, this.options.tokens.projectContacts.userType395_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType395_PostalCode\]/g, this.options.tokens.projectContacts.userType395_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType395_Country\]/g, this.options.tokens.projectContacts.userType395_Country);
		input = input.replace(/\[ProjectContacts.UserType395_Phone\]/g, this.options.tokens.projectContacts.userType395_Phone);
		input = input.replace(/\[ProjectContacts.UserType395_Fax\]/g, this.options.tokens.projectContacts.userType395_Fax);
		input = input.replace(/\[ProjectContacts.UserType395_Cell\]/g, this.options.tokens.projectContacts.userType395_Cell);
		input = input.replace(/\[ProjectContacts.UserType395_Email\]/g, this.options.tokens.projectContacts.userType395_Email);

		input = input.replace(/\[ProjectContacts.UserType396_CompanyName\]/g, this.options.tokens.projectContacts.userType396_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactName\]/g, this.options.tokens.projectContacts.userType396_ContactName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactTitle\]/g, this.options.tokens.projectContacts.userType396_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType396_Address26\]/g, this.options.tokens.projectContacts.userType396_Address);
		input = input.replace(/\[ProjectContacts.UserType396_Address2\]/g, this.options.tokens.projectContacts.userType396_Address2);
		input = input.replace(/\[ProjectContacts.UserType396_City\]/g, this.options.tokens.projectContacts.userType396_City);
		input = input.replace(/\[ProjectContacts.UserType396_StateProvince\]/g, this.options.tokens.projectContacts.userType396_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType396_PostalCode\]/g, this.options.tokens.projectContacts.userType396_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType396_Country\]/g, this.options.tokens.projectContacts.userType396_Country);
		input = input.replace(/\[ProjectContacts.UserType396_Phone\]/g, this.options.tokens.projectContacts.userType396_Phone);
		input = input.replace(/\[ProjectContacts.UserType396_Fax\]/g, this.options.tokens.projectContacts.userType396_Fax);
		input = input.replace(/\[ProjectContacts.UserType396_Cell\]/g, this.options.tokens.projectContacts.userType396_Cell);
		input = input.replace(/\[ProjectContacts.UserType396_Email\]/g, this.options.tokens.projectContacts.userType396_Email);

		return input;
	},
	export: function () {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.get('projectId')
				},
				{
					endpoint: 'projectmessagepreview'
				},
				{
					endpoint: 'export'
				}
			]),
			data: {
				templateKey: this.options.project.inviteSettings.emailTemplate.get('templateKey'),
				responseType: encodeURIComponent(this.options.tokens.projectMessage.responseType),
				bidDueDate: this.options.tokens.projectMessage.bidDueDate,
				responseDueDate: this.options.tokens.projectMessage.responseDueDate,
				messageSubject: encodeURIComponent(this.options.inviteSettings.messageSubject),
				messageBody: encodeURIComponent(this.options.tokens.projectMessage.messageBody)
			}
		}).post().success(_.bind(function (data) {
			PJQ.files.downloadFile(data.url, {isEndpoint: false});
		}, this));
	}
});

//Models
PJQ.models.projectMessages = {};

PJQ.models.projectMessages.ProjectMessagesResponse = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId')
			},
			{
				endpoint: 'projectmessages'
			}
		])
	},
	parse: function (model) {
		this.messages = new PJQ.collections.projectMessages.ProjectMessages(model.messages);
		this.contactGroups = new PJQ.collections.projectMessages.ProjectContactGroups(model.contactGroups);
		return model;
	},
	getContextMessage: function(){
		let contextMessage = null;
		if (_.size(this.messages.models) > 0) {
			let sessionMessage = this.messages.findWhere({accessKey: PJQ.app.session.get('accessKey').toUpperCase()});
			if (sessionMessage != null && sessionMessage.canChangeStatus()) {
				contextMessage = sessionMessage;
			}

			if(contextMessage == null){
				// try to find newest Project Message not responded to yet and open its accordion
				let noResponseMessages = this.messages.getChangeableMessages();
				if (_.size(noResponseMessages) > 0) {
					contextMessage = _.max(noResponseMessages, function (item) {
						return PJQ.helpers.dateHelpers.getDateDiff(new Date(), new Date(item.get('createdOn')));
					});
				}
				else {
					contextMessage = null;
				}
			}
		}
		return contextMessage;
	}
});

PJQ.models.projectMessages.ProjectMessage = PJQ.models.BaseModel.extend({
	idAttribute: 'projectMessageId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId')
			},
			{
				endpoint: 'projectmessages',
				value: this.id
			}
		])
	},
	parse: function (model) {
		if (model.attachments)
			this.attachments = new PJQ.collections.files.Files(model.attachments);
		else
			this.attachments = new PJQ.collections.files.Files();
		return model;
	},
	canChangeStatus: function(){
		return ((this.get('type') === "PROJECT" && (this.get('canChange'))) ||
			(this.get('type') === "MESSAGE" && (this.get('canChange') || _.size(this.get('status')) === 0 || (this.get('status') === ("PENDING" || "UNSENT"))))
		)
	}
});

PJQ.models.projectMessages.ProjectContactGroup = PJQ.models.BaseModel.extend({
	idAttribute: 'groupId',
	parse: function (model) {
		return model;
	}
});

//Collections
PJQ.collections.projectMessages = {};

PJQ.collections.projectMessages.ProjectMessages = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.projectMessages.ProjectMessage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'projectmessages'
			}
		])
	},
	getChangeableMessages: function(){
		return this.models.filter(function(message){
			return message.get('type') === "PROJECT" && (message.get('canChange') || _.size(message.get('status')) === 0 || (message.get('status') === ("PENDING" || "UNSENT")))
		});
	}
});

PJQ.collections.projectMessages.ProjectContactGroups = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.projectMessages.ProjectContactGroup,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'projectmessages'
			},
			{
				endpoint: 'accesskey',
				value: this.accessKey
			},
			{
				endpoint: 'response'
			}
		])
	}
});

//Models
PJQ.models.projectParticipants = {};

PJQ.models.projectParticipants.ProjectParticipant = PJQ.models.contacts.Contact.extend({
	endpoint: function () {
		let endpointArr = [
			{
				endpoint: 'projects',
				value: this.project ? this.project.id : this.get('projectId')
			},
			{
				endpoint: 'participants',
				value: this.get('id')
			}
		];

		if (this.get('isUpdateBidAmount'))
			endpointArr.push({endpoint: 'bidamount'});

		return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
	},
	parse: function (model) {
		if (model && model.project) {
			this.project = model.project;
		}
		PJQ.models.contacts.Contact.prototype.parseContactData.call(this, model);
		PJQ.models.contacts.Contact.prototype.parseAttachmentData.call(this, model);
		return model;
	},
	getCompanyCustomField: function (customFieldId) {
		return _.find(this.get('companyCustomFieldValues'), function (cf) {
			return (cf.id === customFieldId);
		});
	},
	getContactCustomField: function (customFieldId) {
		return _.find(this.get('contactCustomFieldValues'), function (cf) {
			return (cf.id === customFieldId);
		});
	},
	beforeSave: function () {
		PJQ.models.contacts.Contact.prototype.beforeSave.call(this);
		this.set({
			attachments: this.attachments.getChangedModels()
		})
	}
});

//Collections
PJQ.collections.projectParticipants = {};

PJQ.collections.projectParticipants.ProjectParticipants = PJQ.collections.BaseCollection.extend({
	idAttribute: 'id',
	model: PJQ.models.projectContacts.ProjectContact,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants'
			}
		], [
			{
				parameter: 'includeGroups',
				value: true
			}
		])
	}
});

//Views
PJQ.views.projectParticipants = {};

PJQ.views.projectParticipants.AddParticipantsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Add-Participants'),
		addButtonText: "Add Participants",
		isDirectoryEnabled: false,
		isUnionStatusEnabled: false,
		isReturnContactIds: false,
		defaultDirectoryFilter: [1],
		defaultRadius: 50,
		defaultZip: '',
		groupSelectorOptions: {},
		onSave: _.noop,
		onCancel: _.noop
	},
	events: {
		"click .add-participants-cancel": "onCancel",
		"click .add-participants-save": "onSave",
		'keyup .add-participants-radius': 'radiusChanged',
		'keyup .add-participants-zip': 'zipChanged',
		"keydown .add-participants-radius": "numbersOnly",
		"click .send-message-save": "sendMessage"
	},
	beforeModalCreated: function () {
		this.options.isWorkAreasEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_WORK_AREAS);

		let projectZip = this.model.get('zip');
		if (_.size(projectZip) > 0) {
			this.options.defaultZip = projectZip;
		}

		this.model.fetchBidPackages(_.bind(function (bp) {
			this.bidPackages = bp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	zipChanged: function () {
		let zipInput = this.$('.add-participants-zip');
		if (PJQ.helpers.validators.validateZip(zipInput.val())) {
			PJQ.helpers.inputHelpers.setInputError(zipInput, true);
		}
	},
	afterRender: function () {
		if (this.options.isDirectoryEnabled) {
			let directoryFilter = this.options.defaultDirectoryFilter ? this.options.defaultDirectoryFilter : [];
			if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_ADDRESS_BOOK)) {
				let directoryFilterStr = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_ADDRESS_BOOK).toLowerCase();
				if (directoryFilterStr.indexOf('private') !== -1) {
					directoryFilter.push(1);
				}
				if (directoryFilterStr.indexOf('public') !== -1) {
					directoryFilter.push(2);
				}
			}
			this.directoryFilterSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.add-participants-directory-filter'),
				isIntChoices: true,
				isMultiple: true,
				defaultValue: directoryFilter,
				onChange: _.bind(function () {
					this.renderGroups();
					this.directoryFilterSelectPicker.hideError();
				}, this)
			});
		}

		this.unionFilterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.add-participants-union-filter'),
			isIntChoices: true,
			isMultiple: true,
			onChange: _.bind(function () {
				this.unionFilterSelectPicker.hideError();
			}, this)
		});

		this.renderGroups();

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES)) {
			this.renderBidPackages();
		}

		if (this.options.isWorkAreasEnabled) {
			if (this.locationFilter == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS)) {
				this.locationFilter = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS)
			}
			this.locationTypeSelector = new PJQ.inputs.Selectpicker({
				el: this.$('.add-participants-location-filter'),
				isIntChoices: true,
				isMultiple: true,
				defaultValue: this.locationFilter ? this.locationFilter.split(',') : [1, 2],
				onChange: _.bind(function (value) {
					let $radiusOuter = this.$('.radius-outer'),
						$boundariesOuter = this.$('.boundaries-outer');
					if (value.indexOf(2) === -1) {
						$radiusOuter.addClass('hidden');
						$boundariesOuter.addClass('hidden');
					}
					else {
						$radiusOuter.removeClass('hidden');
						$boundariesOuter.removeClass('hidden');
					}
				}, this)
			});
		}

		let radius = this.options.defaultRadius;
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_RADIUS)) {
			radius = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_RADIUS);
		}
		this.radiusSlider = new PJQ.Slider(this.$('.add-participants-radius-slider'), {
			ticks: [1, 50, 100, 150, 200, 250, 300],
			ticks_labels: [1, 50, 100, 150, 200, 250, 300],
			value: radius,
			onChange: _.bind(function (obj) {
				this.setRadius(obj.newValue);
			}, this)
		});
		this.setRadius(radius);
	},
	renderBidPackages: function () {
		this.bidPackageSelector = new PJQ.views.bidPackages.BidPackageSelector({
			el: this.$('.bid-package-selector'),
			project: PJQ.app.session.project,
			isIncludeGroups: true,
			onSelected: _.bind(function (groupIds, bidPackageIds) {
				this.selectedGroupIds = groupIds;
				this.selectedBidPackageIds = bidPackageIds;
			}, this)
		})
	},
	renderGroups: function () {
		let isPrivate = true,
			isPublic = false,
			hasGroupsLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED),
			hasBidPackages = this.bidPackages != null && _.size(this.bidPackages.models) > 0;
		if (this.options.isDirectoryEnabled) {
			let selectedDirectoryValues = this.directoryFilterSelectPicker.getValue();
			isPrivate = _.size(selectedDirectoryValues) === 0 || _.indexOf(selectedDirectoryValues, 1) > -1;
			isPublic = _.indexOf(selectedDirectoryValues, 2) > -1;
		}

		let $publicA = this.$('a[href="#addParticipantsGroupsPublic"]'),
			$publicLi = $publicA.closest('li'),
			$privateA = this.$('a[href="#addParticipantsGroupsPrivate"]'),
			$privateLi = $privateA.closest('li'),
			$bidPackageA = this.$('a[href="#addParticipantsBidPackages"]'),
			$bidPackageLi = $bidPackageA.closest('li');

		if (this.groupSelectorPrivate != null) {
			this.groupSelectorPrivate.remove();
			this.groupSelectorPrivate = null;
		}
		if (this.groupSelectorPublic != null) {
			this.groupSelectorPublic.remove();
			this.groupSelectorPublic = null;
		}

		if (hasBidPackages || (isPrivate && isPublic && !hasGroupsLinked)) {
			this.$('.add-participants-groups-nav-bar').removeClass('hidden');

			if (hasBidPackages) {
				$bidPackageLi.removeClass('hidden');
				$bidPackageA.tab('show');
			}
			else{
				$bidPackageLi.addClass('hidden');
			}

			if(isPublic && !hasGroupsLinked){
				$publicLi.removeClass('hidden');
				$publicA.tab('show');
			}
			else{
				$publicLi.addClass('hidden');
			}

			if(isPrivate || (isPublic && hasGroupsLinked)){
				$privateLi.removeClass('hidden');
				$privateA.tab('show');
			}
			else{
				$privateLi.addClass('hidden');
			}
		}
		else {
			this.$('.add-participants-groups-nav-bar').addClass('hidden');
			if (!hasGroupsLinked) {
				if (isPrivate) {
					$privateA.tab('show');
				}
				else {
					$publicA.tab('show');
				}
			}
			else {
				$privateA.tab('show');
			}
		}

		let headerButtons = null;
		if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS) && this.model.hasPermission('bidForms.canView')) {
			headerButtons = [
				{
					id: 'filterBFTrades',
					label: 'Select Bid Form Trades',
					callback: _.bind(function (selector) {
						let fnSelect = function (groupIds) {
							selector.selectGroups(groupIds);
							selector.expandSelectedParents();
						};
						if (this.options.bidFormGroupIds != null) {
							fnSelect(this.options.bidFormGroupIds);
						}
						else {
							let summary = new PJQ.collections.bidForms.BidFormsSummary(null, {
								projectId: this.model.id
							});
							summary.fetch({
								success: _.bind(function () {
									this.options.bidFormGroupIds = _.map(summary.models, function (summaryItem) {
										return summaryItem.get('groupId');
									});
									fnSelect(this.options.bidFormGroupIds);
								}, this)
							});

						}
					}, this)
				}
			];
		}

		if (isPrivate || (isPublic && hasGroupsLinked)) {
			this.groupSelectorPrivate = new PJQ.views.groups.GroupSelector(_.defaults({
				el: this.$('.group-selector-private'),
				headerButtons: headerButtons,
				onGroupSelected: _.bind(function () {
					this.groupSelectorPrivate.hideError();
				}, this)
			}, this.options.groupSelector));
		}

		if (isPublic && !hasGroupsLinked) {
			this.groupSelectorPublic = new PJQ.views.groups.GroupSelector(_.defaults({
				el: this.$('.group-selector-public'),
				isPublicGroups: true,
				headerButtons: headerButtons,
				onGroupSelected: _.bind(function () {
					this.groupSelectorPublic.hideError();
				}, this)
			}, this.options.groupSelector));
		}
	},
	numbersOnly: function (e) {
		return PJQ.helpers.inputHelpers.numbersOnly(e);
	},
	radiusChanged: function () {
		this.setRadius(parseInt(this.$('.add-participants-radius').val()));
	},
	setRadius: function (radius) {
		if (isNaN(radius) || radius < 1)
			radius = 1;
		else if (radius > 300)
			radius = 300;
		this.radiusSlider.setValue(radius);
		//don't set the radius input yet if the length of the value is 0 in case the user is trying to clear the input to enter a new value
		if (this.$('.add-participants-radius').val().length > 0)
			this.$('.add-participants-radius').val(radius);
	},
	onCancel: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	},
	sendMessage: function () {
		this.onSave(null, true);
	},
	onSave: function (e, isSendMessage = false) {
		let hasGroupsLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED),
			publicGroups = this.groupSelectorPublic ? this.groupSelectorPublic.getGroupsData().selected : [],
			privateGroups = this.groupSelectorPrivate ? this.groupSelectorPrivate.getGroupsData().selected : [],
			radius = this.$('.add-participants-radius').val(),
			zipInput = this.$('.add-participants-zip'),
			zip = PJQ.helpers.formatHelpers.formatZip(zipInput.val()),
			directoryFilter = null,
			isPublic = true,
			isPrivate = false,
			canCrossStateBoundaries = this.$('.cb-can-cross-state-bounds').prop('checked'),
			locationFilter = 2,
			hasBidPackages = this.bidPackages != null && _.size(this.bidPackages.models) > 0;

		this.selectedGroupIds = _.union(privateGroups, publicGroups, this.selectedGroupIds);
		if (this.options.isWorkAreasEnabled) {
			let locationType = this.locationTypeSelector.getValue(),
				isWorkAreas = _.indexOf(locationType, 1) > -1,
				isOfficeLocation = _.indexOf(locationType, 2) > -1;
			if (isWorkAreas && isOfficeLocation) {
				locationFilter = 0;
			}
			else if (isWorkAreas) {
				locationFilter = 1;
			}
			else if (isOfficeLocation) {
				locationFilter = 2;
			}
		}

		if (this.options.isDirectoryEnabled) {
			let selectedDirectoryValues = this.directoryFilterSelectPicker.getValue(),
				isPrivate = _.indexOf(selectedDirectoryValues, 1) > -1,
				isPublic = _.indexOf(selectedDirectoryValues, 2) > -1;

			if (isPrivate && isPublic) {
				directoryFilter = 0;
			}
			else if (isPrivate) {
				directoryFilter = 1;
			}
			else if (isPublic) {
				directoryFilter = 2;
			}
		}

		let selectedUnionStatusValues = this.unionFilterSelectPicker.getValue(),
			isUnion = _.indexOf(selectedUnionStatusValues, 1) > -1,
			isNonUnion = _.indexOf(selectedUnionStatusValues, 2) > -1,
			isPrevailingWage = _.indexOf(selectedUnionStatusValues, 3) > -1,
			isNoLaborStatus = _.indexOf(selectedUnionStatusValues, 4) > -1;

		let isValid = true;
		if (this.directoryFilterSelectPicker != null) {
			if (directoryFilter == null) {
				this.directoryFilterSelectPicker.showError('You must select an address book');
				isValid = false;
			}
			else {
				this.directoryFilterSelectPicker.hideError();
			}
		}

		if (_.size(privateGroups) === 0 && isPrivate && !hasBidPackages) {
			if (!hasGroupsLinked) {
				this.groupSelectorPrivate.showError('You must select at least one private trade');
			}
			else {
				this.groupSelectorPrivate.showError('You must select at least one trade');
			}
			this.$('a[href="#addParticipantsGroupsPrivate"]').tab('show');
			isValid = false;
		}
		else if (this.groupSelectorPublic != null && _.size(publicGroups) === 0 && isPublic && !hasGroupsLinked && !hasBidPackages) {
			this.groupSelectorPublic.showError('You must select at least one public trade');
			this.$('a[href="#addParticipantsGroupsPublic"]').tab('show');
			isValid = false;
		}
		else if (this.bidPackageSelector != null && _.size(this.selectedGroupIds) === 0 && hasBidPackages) {
			this.bidPackageSelector.showError('You must select at least one trade or bid package');
			this.$('a[href="#addParticipantsBidPackages"]').tab('show');
			isValid = false;
		}
		else {
			if (this.groupSelectorPrivate != null) {
				this.groupSelectorPrivate.hideError();
			}
			if (this.groupSelectorPublic != null) {
				this.groupSelectorPublic.hideError();
			}
			if (this.bidPackageSelector != null) {
				this.bidPackageSelector.hideError();
			}
		}

		if (!PJQ.helpers.validators.validateZip(zip)) {
			PJQ.helpers.inputHelpers.setInputError(zipInput, false, {
				errorText: 'Invalid zip code'
			});
			isValid = false;
		}
		else {
			PJQ.helpers.inputHelpers.setInputError(zipInput, true);
		}

		if (isValid) {
			let loader = new PJQ.Loader(this.$('.modal-content'));
			this.model.addParticipants(this.selectedGroupIds != null ? this.selectedGroupIds : _.union(privateGroups, publicGroups), zip, radius, locationFilter, canCrossStateBoundaries, directoryFilter, isUnion, isNonUnion, isPrevailingWage, isNoLaborStatus, this.options.isReturnContactIds, _.bind(function (data) {
				this.removeModal();
				let participantCount = _.size(data);
				if (participantCount > 0) {
					PJQ.notifications.notify.successNotify({
						message: 'Successfully added ' + participantCount.toString() + ' participants'
					});
				}
				else {
					PJQ.notifications.notify.warningNotify({
						message: 'No new participants were found'
					});
				}

				if (typeof this.options.onSave === 'function') {
					this.options.onSave(data, isSendMessage);
				}
			}, this), function () {
				loader.remove();
				PJQ.notifications.notify.errorNotify({
					message: 'Failed to add participants to the project.  Please contact customer service.'
				});
			});
		}
	}
});

PJQ.views.projectParticipants.AddParticipantsFromProjectModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Add-Participants-From-Project'),
		addButtonText: "Add Participants",
		maxWidth: '650px',
		isBidFormsEnabled: false,
		isReturnContactIds: false,
		projectResponses: [],
		onSave: _.noop,
		onCancel: _.noop
	},
	events: {
		"click .add-participants-cancel": "onCancel",
		"click .add-participants-save": "onSave",
		"click .add-participants-select-projects-continue": "completeProjectsStep",
		"click .add-participants-select-trades-continue": "completeTradesStep",
		"click .add-participants-jump-step": "goToStepEvent"
	},
	beforeRender: function () {
		this.renderData = {
			options: this.options
		}
	},
	afterRender: function () {
		new PJQ.views.projects.ProjectSelector({
			el: this.$('.project-selector'),
			excludeProjectIds: [this.model.id],
			onProjectSelected: _.bind(function (projects) {
				this.selectedProjects = projects;
				this.renderSelectedProjectCount();
				this.$('.add-participants-select-projects-continue').prop('disabled', _.size(this.selectedProjects) === 0);
			}, this),
			dataTableHeaderData: {
				isHideDeletedFilter: true
			}
		});
		this.renderSelectedProjectCount();
		this.goToStep(1);
	},
	renderSelectedProjectCount: function () {
		let selectedProjectCount = _.size(this.selectedProjects);
		this.$('.add-participants-projects-count').html(selectedProjectCount.toString());
		if (this.step > 1) {
			this.$('.add-participants-selected-projects').html(selectedProjectCount.toString() + " selected");
		}
		else {
			this.$('.add-participants-selected-projects').empty();
		}
	},
	completeProjectsStep: function () {
		this.goToStep(2);
	},
	completeTradesStep: function () {
		this.goToStep(3);
	},
	goToStepEvent: function (e) {
		let step = parseInt($(e.currentTarget).data('step').toString());
		this.goToStep(step);
	},
	goToStep: function (step) {
		this.step = step;
		let thisStep = $('.step-' + this.step.toString()),
			thisStepHeader = $('.step-header-' + this.step.toString());
		this.$('[class*=step-]').not(thisStep).collapse('hide');
		this.$('[class*=step-header-]').not(thisStepHeader).removeClass('text-primary').addClass('text-dark op-4');
		thisStepHeader.removeClass('text-dark op-4').addClass('text-primary');
		thisStep.collapse('show');
		this.startStep();
	},
	startStep: function () {
		switch (this.step) {
			case 1:
				this.$('.add-participants-selected-project-name').empty();
				this.$('.add-participants-selected-trades').empty();
				break;
			case 2:
				this.$('.add-participants-selected-trades').empty();
				let request = new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'projects',
							value: 0
						},
						{
							endpoint: 'groups'
						}
					], [
						{
							parameter: 'projects',
							value: _.map(this.selectedProjects, function (project) {
								return project.id;
							}).join(',')
						}
					])
				});
				request.get().done(_.bind(function (data) {
					this.createGroupSelector(new PJQ.collections.groups.Groups(data, {
						groupLevels: PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
					}));
				}, this));
				break;
			case 3:
				for (let i = 0; i < this.options.projectResponses.length; i++) {
					let res = this.options.projectResponses[i];
					if (PJQ.helpers.objectHelpers.refinedType(res) === 'array') {
						res = res[0];
					}
					let resLower = res.toLowerCase();
					if (resLower !== "yes" && resLower !== "no" && resLower !== "true" && resLower !== "false") {
						let option = "<option value='" + res + "'>" + res + "</option>";
						this.$('select.add-participants-response-filter').append(option);
					}
				}

				this.projectResponseFilterSelectPicker = new PJQ.inputs.Selectpicker({
					el: this.$('.add-participants-response-filter'),
					isMultiple: true
				});
				break;
		}
		this.renderSelectedProjectCount();
		this.renderSelectedGroupCount();
		this.$('.add-participants-save').prop('disabled', this.step !== 3);
	},
	createGroupSelector: function (groups) {
		if (_.size(groups.models) > 0) {
			this.$('.select-trades-instruction').show();

			let headerButtons = null;
			if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS) && this.model.hasPermission('bidForms.canView')) {
				headerButtons = [
					{
						id: 'filterBFTrades',
						label: 'Select Bid Form Trades',
						callback: _.bind(function (selector) {
							let fnSelect = function (groupIds) {
								selector.selectGroups(groupIds);
								selector.expandSelectedParents();
							};
							if (this.options.bidFormGroupIds != null) {
								fnSelect(this.options.bidFormGroupIds);
							}
							else {
								let summary = new PJQ.collections.bidForms.BidFormsSummary(null, {
									projectId: this.model.id
								});
								summary.fetch({
									success: _.bind(function () {
										this.options.bidFormGroupIds = _.map(summary.models, function (summaryItem) {
											return summaryItem.get('groupId');
										});
										fnSelect(this.options.bidFormGroupIds);
									}, this)
								});

							}
						}, this)
					}
				];
			}
			this.groupSelector = new PJQ.views.groups.GroupSelector({
				el: this.$('.group-selector'),
				isShowNoGroup: true,
				groups: groups.models,
				headerButtons: headerButtons,
				onGroupSelected: _.bind(function () {
					this.selectedGroups = this.groupSelector.getGroupsData().new;
					this.renderSelectedGroupCount();
					this.$('.add-participants-select-trades-continue').prop('disabled', _.size(this.selectedGroups) === 0);
				}, this)
			});
			this.renderSelectedGroupCount();
		}
		else {
			this.$('.select-trades-instruction').hide();
			new PJQ.Alert(this.$('.group-selector'), {
				type: 'warning',
				text: _.size(this.selectedProjects) > 0 ? 'These projects do not contain any trades' : 'This project does not contain any trades'
			});
		}
	},
	renderSelectedGroupCount: function () {
		let selectedGroupCount = _.size(this.selectedGroups);
		this.$('.add-participants-trades-count').html(selectedGroupCount);
		if (this.step > 2) {
			this.$('.add-participants-selected-trades').html(selectedGroupCount.toString() + " selected");
		}
		else {
			this.$('.add-participants-selected-trades').empty();
		}
	},
	onCancel: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	},
	onSave: function () {
		let isCopyBidForms = this.options.isBidFormsEnabled ? this.$('.add-participants-copy-bid-forms').prop('checked') : false,
			responseFilter = _.size(this.options.projectResponses) > 0 ? this.projectResponseFilterSelectPicker.getValue() : [],
			request = new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: this.model.id
					},
					{
						endpoint: 'participants'
					},
					{
						endpoint: 'copy'
					}
				], [
					{
						parameter: 'projects',
						value: _.map(this.selectedProjects, function (project) {
							return project.id;
						}).join(',')
					}
				]),
				data: {
					groupIds: _.map(this.selectedGroups, function (group) {
						return group.id;
					}),
					isCopyBidForms: isCopyBidForms,
					projectResponses: responseFilter ?? []
				}
			}),
			loader = new PJQ.Loader(this.$('.modal-content'));
		request.post().done(_.bind(function (response) {
			this.removeModal();
			let message = "";
			if (response.participantsCopied.length > 0 || response.bidFormsCopied > 0) {
				if (isCopyBidForms && response.bidFormsCopied > 0) {
					message = response.participantsCopied.length.toString() + (response.participantsCopied.length === 1 ? ' participant' : ' participants') + ' and ' + response.bidFormsCopied.toString() + ' bid ' + (response.bidFormsCopied === 1 ? 'form' : 'forms') + ' copied successfully.';
				}
				else {
					message = response.participantsCopied.length.toString() + (response.participantsCopied.length === 1 ? ' participant' : ' participants') + ' copied successfully.';
				}
				PJQ.notifications.notify.successNotify({
					message: message
				});
			}
			else {
				if (isCopyBidForms) {
					message = "No new participants or bid forms could be found on the selected project";
				}
				else {
					message = "No new participants could be found on the selected project";
				}
				PJQ.notifications.notify.warningNotify({
					message: message
				});
			}

			if (typeof this.options.onSave === 'function') {
				this.options.onSave(this.options.isReturnContactIds ? response.contactsCopied : response.participantsCopied);
			}
		}, this)).fail(function () {
			loader.remove();
			PJQ.notifications.notify.errorNotify({
				message: 'Failed to add bidders to the project'
			});
		});
	}
});

PJQ.models.projects = {};
PJQ.collections.projects = {};
PJQ.views.projects = {};

//Models
PJQ.models.projects.Project = PJQ.models.BaseModel.extend({
    options: {
        isDetail: false
    },
    idAttribute: "projectId",
    notifyName: 'Project',
    endpoint: function (isBase) {
        if (this.options.isDetail && !isBase) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                }
            ], [
                {
                    parameter: 'isDetail',
                    value: this.options.isDetail
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                }
            ]);
        }
    },
    beforeInit: function (options) {
        if (this.preferences == null) {
            this.preferences = new PJQ.models.preferences.Preferences();
        }
    },
    fetchPermissions: function (callback) {
        if (this.permissions != null) {
            callback(this.permissions);
            return;
        }

        this.permissions = new PJQ.models.permissions.ProjectPermissions({
            projectId: PJQ.app.session.project ? PJQ.app.session.project.id : this.id
        });
        this.permissions.fetch({
            success: _.bind(function () {
                callback(this.permissions);
            }, this)
        });
    },
    fetch: function (options) {
        PJQ.models.BaseModel.prototype.fetch.call(this, _.defaults({
            success: (model, response) => {
                this.fetchPermissions((perm) => {
                    if (perm && perm.get('contactId') > 0
                        && (PJQ.app.session.contact == null || PJQ.app.session.contact.id !== perm.get('contactId'))) {
                        PJQ.app.session.contact = new PJQ.models.contacts.Contact({
                            id: perm.get('contactId'),
                            contactId: perm.get('contactId')
                        });
                    }

                    if (options && typeof options.success === 'function') {
                        options.success(model, response);
                    }
                });
            },
            error: options && typeof options.error === 'function' ? options.error : null
        }, options));
    },
    parse: function (model) {
        if (model) {
            if (model.preferences) {
                if (this.preferences && model.preferences) {
                    this.preferences.set(model.preferences);
                    this.preferences.parse(model.preferences);
                } else if (model.preferences) {
                    if (model.preferences instanceof PJQ.models.preferences.Preferences)
                        this.preferences = model.preferences;
                    else
                        this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
                }
            }

            this.subscription = new PJQ.models.subscriptions.Subscription(model.subscription);

            if (model.nda) {
                this.nda = new PJQ.models.projects.ProjectNDA(_.extend({project: this}, model.nda));
            } else {
                this.nda = null;
            }

            if (model.user) {
                this.user = new PJQ.models.projectContacts.ProjectContact(model.user);
            } else {
                this.user = null;
            }

            if (model.user2) {
                this.user2 = new PJQ.models.projectContacts.ProjectContact(model.user2);
            } else {
                this.user2 = null;
            }

            if (model.orderSettings) {
                this.orderSettings = new PJQ.models.BaseModel(model.orderSettings)
            } else {
                this.orderSettings = null;
            }

            if (model.participants) {
                if (model.participants instanceof PJQ.collections.projectParticipants.ProjectParticipants) {
                    this.participants = model.participants;
                    this.participants.options.project = this;
                } else {
                    this.participants = new PJQ.collections.projectParticipants.ProjectParticipants(model.participants, {
                        project: this
                    });
                }
            } else {
                this.participants = new PJQ.collections.projectParticipants.ProjectParticipants(null, {
                    project: this
                });
            }

            if (model.projectContacts) {
                if (model.projectContacts instanceof PJQ.collections.projectContacts.ProjectContacts) {
                    this.projectContacts = model.projectContacts;
                    this.projectContacts.options.project = this;
                } else {
                    //Temporary, the API is currently returning a list of ids for the apps
                    if (_.size(model.projectContacts) > 0 && typeof model.projectContacts[0] === 'number') {
                        model.projectContacts = [];
                    }
                    this.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(model.projectContacts, {
                        project: this
                    });
                }
            } else {
                this.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
                    project: this
                });
            }
        }
        return model;
    },
    hasPermission: function (permission, options = {}) {
        return this.permissions == null || this.permissions.hasPermission(permission, options);
    },
    checkDownloadRequirements: function (callback) {
        callback = typeof callback === 'function' ? callback : _.noop;
        if (this.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
            if (PJQ.app.session.contact != null && this.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_CONTACT_UPDATE_REQ) === true && PJQ.app.session.contact.get('updatedOn') == null) {
                new PJQ.views.contacts.BaseEditContactModal({
                    alert: "You must update your contact information before downloading.",
                    onSave: _.bind(function () {
                        PJQ.app.session.contact.set('updatedOn', new Date());
                        this.checkDownloadRequirements(callback);
                    }, this),
                    model: new PJQ.models.projectContacts.ProjectContact({
                        id: PJQ.app.session.contact.id,
                        projectId: this.id
                    })
                });
                return;
            }

            if (PJQ.app.session.contact != null && (this.messages != null && _.size(this.messages.models) > 0) && this.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_RESPONSE_REQ) && (_.size(this.get('bidResponse')) === 0 || (this.get('bidResponse') === ("PENDING" || "UNSENT")))) {
                this.fetchProjectMessageResponses(_.bind(function (messages) {
                    let contextMessage = messages.getContextMessage();
                    if (contextMessage != null) {
                        new PJQ.views.projects.ProjectMessageResponseModal({
                            model: contextMessage,
                            alert: 'You must update your bid response before downloading.',
                            project: this,
                            onResponse: _.bind(function (response) {
                                this.set('bidResponse', response);
                                this.checkDownloadRequirements(callback);
                            }, this)
                        });
                    } else {
                        this.checkDownloadRequirements(callback);
                    }
                }, this));
                return;
            }

            if (_.size(this.get('downloadTerms')) > 0 && !this.get('downloadTermsAgreed')) {
                new PJQ.views.projects.DownloadTermsModal({
                    project: this,
                    onAccept: _.bind(function () {
                        this.checkDownloadRequirements(callback);
                    }, this)
                });
            } else {
                callback();
            }
        } else {
            callback();
        }
    },
    clone: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'clone'
                }
            ])
        }).post().done(_.bind(function (response) {
            callback(new PJQ.models.projects.Project(response));
        }, this));
    },
    copy: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (response) {
            callback(new PJQ.models.projects.Project(response));
        }, this));
    },
    addParticipantsById: function (ids, callback) {
        new PJQ.ajax.Request({
            endpoint: '/projects/' + PJQ.app.session.project.id.toString() + '/participants/ids',
            data: {
                ids: _.map(ids, function (contact) {
                    return contact.id;
                })
            }
        }).post().success(_.bind(function (data) {
            PJQ.notifications.notify.successNotify({
                message: _.size(ids) + ' participants added successfully'
            });
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(_.bind(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    addParticipants: function (groups, zip, radius, locationType, canCrossStateBoundaries, directoryFilter, isUnion, isNonUnion, isPrevailingWage, isNoLaborStatus, isReturnContactIds, success, error) {
        let groupIds = [];
        if (_.size(groups) > 0) {
            if (groups[0].id) {
                groupIds = _.map(groups, function (group) {
                    return group.id;
                });
            } else {
                groupIds = _.uniq(groups);
            }
        }

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'participants'
            },
            {
                endpoint: 'simple'
            }
        ]);
        let request = new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                projectId: this.id,
                groupIds: groupIds,
                zip: zip,
                radius: radius,
                locationType: locationType,
                canCrossStateBoundaries: canCrossStateBoundaries,
                directoryFilter: directoryFilter,
                isUnion: isUnion,
                isNonUnion: isNonUnion,
                isPrevailingWage: isPrevailingWage,
                isNoLaborStatus: isNoLaborStatus,
                isReturnContactIds: isReturnContactIds
            }
        });
        request.post().done(_.bind(function (data) {
            success(data);
        }, this)).fail(function () {
            error();
        });
    },
    getCompanyLogoUrl: function (callback) {
        if (this.get('logoUrl') != null) {
            callback(this.get('logoUrl'));
        }

        if (this.get('masterUserId') > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users',
                        value: this.get('masterUserId')
                    },
                    {
                        endpoint: 'logo'
                    }
                ])
            }).get().done(_.bind(function (response) {
                this.set('logoUrl', response.url);
                callback(response.url);
            }, this));
        } else {
            callback(null);
        }
    },
    updateResponse: function (response, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'respond',
                    value: response
                }
            ])
        }).put().done(_.bind(function () {
            callback();
        }, this));
    },
    fetchGroups: function (callback, forCompany = false) {
        return new Promise((resolve, reject) => {
            if (forCompany) {
                if (this.companyGroups != null) {
                    if (typeof callback === 'function') {
                        callback(this.companyGroups);
                    }
                    resolve(this.companyGroups);
                    return;
                }

                PJQ.app.session.fetchUserGroups(this.get('masterUserId'), (groups) => {
                    if (groups == null) {
                        if (typeof callback === 'function') {
                            callback(null);
                        }
                        reject(null);
                        return;
                    }

                    this.companyGroups = groups;
                    if (typeof callback === 'function') {
                        callback(groups);
                    }
                    resolve(groups);
                });
                return;
            }

            if (this.groups == null) {
                this.groups = new PJQ.collections.groups.Groups(null, {
                    project: this
                });
            }

            if (!this.groups.isFetched) {
                this.groups.fetch({
                    success: _.bind(function () {
                        callback(this.groups);
                    }, this)
                });
            } else {
                callback(this.groups);
            }
        });
    },
    fetchBidPackages: function (callback) {
        if (this.bidPackages == null) {
            this.bidPackages = new PJQ.collections.bidPackages.BidPackages(null, {
                projectId: this.id
            })
        }

        if (!this.bidPackages.isFetched) {
            this.bidPackages.fetch({
                success: _.bind(function () {
                    callback(this.bidPackages);
                }, this)
            });
        } else {
            callback(this.bidPackages);
        }
    },
    fetchERPObject: function (callback) {
        return new Promise((resolve, reject) => {
            let exObj = this.get('externalObject');
            if (exObj != null || this.erpObjectFetched) {
                if (typeof callback === 'function') {
                    callback(exObj);
                }
                resolve(exObj);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.id
                    },
                    {
                        endpoint: 'erpobject'
                    }
                ]),
                isAPIv2: true
            }).get().done((data) => {
                if (data != null) {
                    this.set({
                        externalObject: data
                    }, {
                        silent: true
                    });
                }
                this.erpObjectFetched = true;
                if (typeof callback === 'function') {
                    callback(data);
                }
                resolve(data);
            }).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(null);
            });
        });
    },
    linkERP: function (externalId, callback) {
        if (_.size(externalId) === 0) {
            callback(null);
            return;
        }

        new PJQ.ajax.Request({
            endpoint: this.endpoint(true) + '/linkerp?externalId=' + externalId,
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                if (res && _.size(res.externalId) > 0) {
                    this.set('externalObject', res);
                }
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    fetchVersions: function (callback) {
        if (this.versions == null) {
            this.versions = new PJQ.collections.drawings.Versions(null, {
                project: this
            });
        }
        if (!this.versions.isFetched) {
            this.versions.fetch({
                success: _.bind(function () {
                    callback(this.versions);
                }, this)
            });
        } else {
            callback(this.versions);
        }
    },
    fetchAttachments: function (options, callback) {
        let att;
        if (options && options.isPrivate === false) {
            if (this.sharedAttachments == null) {
                this.sharedAttachments = new PJQ.collections.projects.ProjectAttachments(null, {
                    project: this,
                    isPrivate: false,
                    isShared: true
                });
            }
            att = this.sharedAttachments;
        } else if (options && options.isShared === false) {
            if (this.privateAttachments == null) {
                this.privateAttachments = new PJQ.collections.projects.ProjectAttachments(null, {
                    project: this,
                    isShared: false,
                    isPrivate: true
                });
            }
            att = this.privateAttachments;
        } else {
            if (this.attachments == null) {
                this.attachments = new PJQ.collections.projects.ProjectAttachments(null, {
                    project: this
                });
            }
            att = this.attachments;
        }

        let fnResult = _.bind(function () {
            let resultAtt = [];
            _.each(att.models, function (attachment) {
                resultAtt.push(attachment.clone());
            });
            let result = new PJQ.collections.projects.ProjectAttachments(resultAtt, {
                project: this,
                isShared: att.options.isShared,
                isPrivate: att.options.isPrivate,
                isDeferred: att.options.isDeferred
            });
            result.isFetched = true;
            if ((!options || options.includeDrawings !== false) && !this.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS)) {
                if (PJQ.app.session.project.permissions == null || PJQ.app.session.project.permissions.hasPermission('drawings.canView')) {
                    this.fetchVersions(_.bind(function (versions) {
                        callback(versions.createPsuedoFolders(result));
                    }, this));
                } else {
                    callback(result);
                }
            } else {
                callback(result);
            }
        }, this);

        if (options && options.forceRecursive) {
            att.options.isDeferred = false;
            att.fetch({
                success: function () {
                    fnResult();
                }
            });
        } else {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.id
                    },
                    {
                        endpoint: 'attachmentscount'
                    }
                ])
            }).get().done(_.bind(function (data) {
                att.options.isDeferred = data.total > 1500;
                att.fetch({
                    success: function () {
                        fnResult();
                    }
                });
            }, this)).fail(function () {
                //error();
            });
        }
    },
    downloadAttachments: function (attachments, options) {
        let ids = [],
            entryIds = [],
            hasPrivate = false,
            hasNonPrivate = false,
            objType = PJQ.helpers.objectHelpers.refinedType(attachments, true),
            fnCheck = function (att) {
                if (att.get('entryId') === -1) {
                    hasNonPrivate = true;

                    ids.push(..._.map(att.getFolderAttachments(), function (folderAtt) {
                        return folderAtt.id;
                    }));

                    _.each(att.getFolderAttachments(), function (folderAtt) {
                        if (!folderAtt.get('isFolder')) {
                            entryIds.push(folderAtt.get('isDrawing') ? folderAtt.get('drawingId') * -1 : folderAtt.get('entryId'));
                        }
                    });
                } else {
                    ids.push(att.id);

                    if (!att.get('isFolder')) {
                        entryIds.push(att.get('isDrawing') ? att.get('drawingId') * -1 : att.get('entryId'));
                    }

                    if (!hasNonPrivate) {
                        let parents = att.getParentFolder(true);
                        if (parents.length === 0) {
                            if (att.get('name') !== 'Private')
                                hasNonPrivate = true;
                        } else if (parents[parents.length - 1].get('name') !== 'Private') {
                            hasNonPrivate = true;
                        }
                    }
                }
            };
        if (objType === 'backboneCollection') {
            _.each(attachments.models, function (attachment) {
                fnCheck(attachment);
            });
        } else if (objType === 'array') {
            _.each(attachments, function (attachment) {
                fnCheck(attachment);
            })
        } else {
            fnCheck(attachments);
        }

        if (this.orderSettings != null &&
            this.orderSettings.get('downloadPerFileFee') > 0 &&
            (this.get('masterUserId') !== PJQ.app.session.get('masterUserId') || (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS) && hasNonPrivate)) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {

            if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.files.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    files: attachments,
                    orderSettings: this.orderSettings,
                    project: PJQ.app.session.project != null ? PJQ.app.session.project : options.project
                });
            }
            return;
        }

        let hasDrawings = _.find(ids, function (id) {
            return id < -1;
        }) != null;
        if (hasDrawings) {
            PJQ.files.downloadDrawings(attachments, this, options);
        } else {
            PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'attachments'
                }
            ]), {entryList: ids});
        }
    },
    attachFiles: function (files, callback) {
        if (PJQ.helpers.objectHelpers.refinedType(files) === 'object') {
            files = [files];
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'attachments'
                },
                {
                    endpoint: 'attach'
                }
            ], [
                {
                    parameter: 'entryList',
                    value: _.map(files, function (file) {
                        return file.get('entryId');
                    }).join(',')
                }
            ])
        }).put().done(function () {
            callback(true);
        }).fail(function () {
            callback(false);
        });
    },
    detachFiles: function (files, callback) {
        if (PJQ.helpers.objectHelpers.refinedType(files) === 'object') {
            files = [files];
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'attachments'
                },
                {
                    endpoint: 'detach'
                }
            ], [
                {
                    parameter: 'entryList',
                    value: _.map(files, function (file) {
                        return file.get('entryId');
                    }).join(',')
                }
            ])
        }).delete().done(_.bind(function () {
            callback(true);
        }, this)).fail(_.bind(function () {
            callback(false);
        }, this));
    },
    fetchProjectMessageResponses: function (callback) {
        if (this.messageResponses == null) {
            this.messageResponses = new PJQ.models.projectMessages.ProjectMessagesResponse({
                projectId: this.id
            });
        }

        if (!this.messageResponses.isFetched) {
            this.messageResponses.fetch({
                success: _.bind(function () {
                    callback(this.messageResponses);
                }, this)
            });
        } else {
            callback(this.messageResponses);
        }
    },
    fetchParticipants: function (callback) {
        if (this.participants == null) {
            this.participants = new PJQ.collections.projectParticipants.ProjectParticipants(null, {
                project: this
            });
        }

        if (!this.participants.isFetched) {
            this.participants.fetch({
                success: _.bind(function () {
                    callback(this.participants);
                }, this)
            });
        } else {
            callback(this.participants);
        }
    },
    fetchProjectContacts: function (callback) {
        if (this.projectContacts == null) {
            this.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
                project: this
            });
        }

        if (!this.projectContacts.isFetched) {
            this.projectContacts.fetch({
                success: _.bind(function () {
                    callback(this.projectContacts);
                }, this)
            });
        } else {
            callback(this.projectContacts);
        }
    },
    fetchDailyReportSettings: function (callback) {
        this.dailyReportSettings = new PJQ.models.dailyReports.Settings({
            project: this
        });
        this.dailyReportSettings.fetch({
            success: _.bind(function () {
                callback(this.dailyReportSettings);
            }, this)
        });
    },
    fetchBidFormSettings: function (callback) {
        this.bidFormSettings = new PJQ.models.bidForms.Settings({
            projectId: this.id
        });
        this.bidFormSettings.fetch({
            success: _.bind(function () {
                callback(this.bidFormSettings);
            }, this)
        });
    },
    fetchNDA: function (callback) {
        this.nda = new PJQ.models.projects.ProjectNDA({
            project: this
        });
        this.nda.fetch({
            success: _.bind(function () {
                callback(this.nda);
            }, this)
        });
    },
    fetchPunchListItems(callback) {
        return new Promise((resolve, reject) => {
            if (this.punchListItems != null) {
                if (typeof callback === 'function') {
                    callback(this.punchListItems);
                }
                resolve(this.punchListItems);
                return;
            }

            this.punchListItems = new PJQ.collections.punchlists.PunchlistItems(null, {
                project: this
            });
            this.punchListItems.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.punchListItems);
                    }
                    resolve(this.punchListItems);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(this.actionItems);
                    }
                    reject(new Error("Failed to fetch project punchlist items"));
                }
            })
        });
    },
    fetchPunchListCustomFields(callback) {
        return new Promise((resolve, reject) => {
            if (this.punchlistCustomFields != null) {
                resolve(this.punchlistCustomFields);
                if (typeof callback === 'function') {
                    callback(this.punchlistCustomFields);
                }
            }

            this.punchlistCustomFields = new PJQ.collections.punchlists.PunchlistCustomFields(null, {
                project: this
            });
            this.punchlistCustomFields.fetch({
                success: () => {
                    resolve(this.punchlistCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.punchlistCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract field settings"));
                    if (typeof callback === 'function') {
                        callback(this.punchlistCustomFields);
                    }
                }
            })
        });
    },
    fetchRFICustomFields(callback) {
        if (this.rfiCustomFields == null) {
            this.rfiCustomFields = new PJQ.collections.rfi.CustomFields(null, {
                project: this
            });
            this.rfiCustomFields.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.rfiCustomFields);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.rfiCustomFields);
            }
        }
    },
    fetchActionItems(callback) {
        return new Promise((resolve, reject) => {
            if (this.actionItems != null) {
                if (typeof callback === 'function') {
                    callback(this.actionItems);
                }
                resolve(this.actionItems);
                return;
            }

            this.actionItems = new PJQ.collections.actionItems.ActionItems(null, {
                project: this
            });
            this.actionItems.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.actionItems);
                    }
                    resolve(this.actionItems);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(this.actionItems);
                    }
                    reject(new Error("Failed to fetch project action items"));
                }
            })
        });
    },
    fetchActionItemCustomFields(callback) {
        if (this.actionItemCustomFields == null) {
            this.actionItemCustomFields = new PJQ.collections.actionItems.ActionItemCustomFields(null, {
                project: this
            });
            this.actionItemCustomFields.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.actionItemCustomFields);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.actionItemCustomFields);
            }
        }
    },
    fetchSubmittalWorkflowTemplates: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalWorkflowTemplates != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalWorkflowTemplates);
                }
                resolve(this.submittalWorkflowTemplates);
                return;
            }

            this.submittalWorkflowTemplates = new PJQ.collections.submittals.WorkflowTemplates(null, {
                projectId: this.id
            });
            this.submittalWorkflowTemplates.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalWorkflowTemplates);
                    }

                    resolve(this.submittalWorkflowTemplates);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal workflow templates"));
                }
            });
        });
    },
    fetchSubmittalSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalSettings);
                }
                resolve(this.submittalSettings);
                return;
            }

            this.submittalSettings = new PJQ.models.submittals.Settings({
                projectId: this.id
            });
            this.submittalSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalSettings);
                    }

                    resolve(this.submittalSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal settings"));
                }
            });
        });
    },
    fetchSubmittalStatuses: function (refresh, callback) {
        return new Promise((resolve, reject) => {
            if (refresh !== true && this.submittalStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalStatuses);
                }
                resolve(this.submittalStatuses);
                return;
            }

            this.submittalStatuses = new PJQ.collections.submittals.Statuses(null, {
                projectId: this.id
            });
            this.submittalStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalStatuses);
                    }

                    resolve(this.submittalStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal statuses"));
                }
            });
        });
    },
    fetchSubmittalItemTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalItemTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalItemTypes);
                }
                resolve(this.submittalItemTypes);
                return;
            }

            this.submittalItemTypes = new PJQ.collections.submittals.ItemTypes(null, {
                projectId: this.id
            });
            this.submittalItemTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalItemTypes);
                    }

                    resolve(this.submittalItemTypes);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal item types"));
                }
            });
        });
    },
    fetchSubmittalCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalCustomFields);
                }
                resolve(this.submittalCustomFields);
                return;
            }

            this.submittalCustomFields = new PJQ.collections.submittals.SubmittalCustomField(null, {
                projectId: this.id
            });
            this.submittalCustomFields.fetch({
                success: () => {
                    resolve(this.submittalCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.submittalCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal custom fields"));
                }
            });
        });
    },
    fetchSubmittalTemplates: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalTemplates != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalTemplates);
                }
                resolve(this.submittalTemplates);
                return;
            }

            this.submittalTemplates = new PJQ.collections.submittals.Templates(null, {
                projectId: this.id
            });
            this.submittalTemplates.fetch({
                success: () => {
                    resolve(this.submittalTemplates);
                    if (typeof callback === 'function') {
                        callback(this.submittalTemplates);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal templates"));
                }
            });
        });
    },
    fetchActionItemTemplates: function (callback) {
        this.actionItemTemplates = new PJQ.collections.actionItems.Templates();
        this.actionItemTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.actionItemTemplates);
                }
            }, this)
        });
    },
    fetchPunchlistTemplates: function (callback) {
        this.punchlistTemplates = new PJQ.collections.punchlists.Templates();
        this.punchlistTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.punchlistTemplates);
                }
            }, this)
        });
    },
    fetchMeetingTemplates: function (callback) {
        this.meetingTemplates = new PJQ.collections.meetings.Templates();
        this.meetingTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.meetingTemplates);
                }
            }, this)
        });
    },
    fetchActionItemSettings: function (callback) {
        if (this.actionItemSettings == null) {
            this.actionItemSettings = new PJQ.models.actionItems.Settings({
                project: this
            });
            this.actionItemSettings.fetch({
                success: _.bind(function () {
                    callback(this.actionItemSettings);
                }, this)
            });
        } else {
            callback(this.actionItemSettings);
        }
    },
    fetchPunchListSettings: function (callback) {
        if (this.punchlistSettings == null) {
            this.punchlistSettings = new PJQ.models.punchlists.Settings({
                project: this
            });
            this.punchlistSettings.fetch({
                success: _.bind(function () {
                    callback(this.punchlistSettings);
                }, this)
            });
        } else {
            callback(this.punchlistSettings);
        }
    },
    fetchRFIs: function (callback) {
        if (this.rfis == null) {
            this.rfis = new PJQ.collections.rfi.RFIS(null, {
                project: this
            });
            this.rfis.fetch({
                success: _.bind(function () {
                    callback(this.rfis);
                }, this)
            });
        } else {
            callback(this.rfis);
        }
    },
    fetchRFISettings: function (callback) {
        if (this.rfiSettings == null) {
            this.rfiSettings = new PJQ.models.rfi.Settings({
                project: this
            });
            this.rfiSettings.fetch({
                success: _.bind(function () {
                    callback(this.rfiSettings);
                }, this)
            });
        } else {
            callback(this.rfiSettings);
        }
    },
    fetchGalleryPhotos: function (callback) {
        if (this.galleryPhotos == null) {
            this.galleryPhotos = new PJQ.collections.projects.ProjectPhotos(null, {
                project: this
            });
            this.galleryPhotos.fetch({
                success: _.bind(function () {
                    callback(this.galleryPhotos);
                }, this)
            });
        } else {
            callback(this.galleryPhotos);
        }
    },
    fetchProjectCustomFields(callback) {
        if (this.customFields == null) {
            this.customFields = new PJQ.collections.projects.ProjectCustomFields(null, {
                project: this
            });
            this.customFields.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields);
            }
        }
    },
    fetchLocations(callback) {
        return new Promise((resolve, reject) => {
            if (this.locations != null) {
                if (typeof callback === 'function') {
                    callback(this.locations);
                }
                resolve(this.locations);
                return;
            }

            this.locations = new PJQ.collections.projects.Locations(null, {
                project: this
            });
            this.locations.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.locations);
                    }
                    resolve(this.locations);
                }, this),
                error: () => {
                    reject(new Error("Failed to fetch project locations"));
                }
            })
        });
    },
    fetchUserMessageTypes(callback) {
        if (this.userMessageTypes == null) {
            this.userMessageTypes = new PJQ.collections.userMessages.UserMessageTypes(null, {
                project: this
            });

            if (PJQ.app.session.contact != null) {
                this.userMessageTypes.fetch({
                    success: _.bind(function () {
                        if (typeof callback === 'function') {
                            callback(this.userMessageTypes);
                        }
                    }, this)
                });
            } else if (typeof callback === 'function') {
                callback(this.userMessageTypes);
            }
        } else {
            if (typeof callback === 'function') {
                callback(this.userMessageTypes);
            }
        }
    },
    fetchScheduleSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleSettings);
                }
                resolve(this.scheduleSettings);
                return;
            }

            this.scheduleSettings = new PJQ.models.schedule.Settings({
                projectId: this.id
            });
            this.scheduleSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleSettings);
                    }
                    resolve(this.scheduleSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch schedule settings"));
                }
            });
        });
    },
    fetchSchedule: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.schedule != null) {
                if (typeof callback === 'function') {
                    callback(this.schedule);
                }
                resolve(this.schedule);
                return;
            }

            this.schedule = new PJQ.models.schedule.Schedule({
                projectId: this.id
            });
            this.schedule.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.schedule);
                    }
                    resolve(this.schedule);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project schedule"));
                }
            });
        });
    },
    fetchScheduleLookAheads: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleLookAheads != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleLookAheads);
                }
                resolve(this.scheduleLookAheads);
                return;
            }

            this.scheduleLookAheads = new PJQ.collections.schedule.LookAheads([], {
                projectId: this.id
            });

            this.scheduleLookAheads.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleLookAheads);
                    }
                    resolve(this.scheduleLookAheads);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch schedule look-aheads"));
                }
            });
        });

    },
    fetchScheduleNotifications: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (!force && this.scheduleNotifications != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleNotifications);
                }
                resolve(this.scheduleNotifications);
                return;
            }

            this.scheduleNotifications = new PJQ.collections.schedule.Notifications(null, {
                projectId: this.id
            });
            this.scheduleNotifications.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleNotifications);
                    }
                    resolve(this.scheduleNotifications);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project schedule notifications"));
                }
            });
        });
    },
    fetchScheduleTemplates: function (callback) {
        this.scheduleTemplates = new PJQ.collections.schedule.Templates();
        this.scheduleTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.scheduleTemplates);
                }
            }, this)
        });
    },
    fetchAnnotationLayers: function (callback) {
        if (this.annotationLayers == null) {
            this.annotationLayers = new PJQ.collections.drawings.Layers(null, {
                projectId: this.id
            });
            this.annotationLayers.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.annotationLayers);
                    }
                }, this)
            });
        } else {
            if (typeof callback === 'function') {
                callback(this.annotationLayers);
            }
        }
    },
    deleteAllPunchLists: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'punchlists'
                }
            ])
        }).delete().done(_.bind(function () {
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    deleteAllActionItems: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'actionitems'
                }
            ])
        }).delete().done(_.bind(function () {
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    deleteAllScheduleTasks: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks'
                }
            ])
        }).delete().done(_.bind(function () {
            if (typeof callback === 'function') {
                if (this.schedule != null) {
                    this.schedule.tasks.reset();
                    this.schedule.dependencies.reset();
                    this.schedule.dependencies.reset();
                    this.schedule.pendingRequestedChanges.reset();
                }
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    getProjectStatuses(callback) {
        if (this.projectStatuses != null) {
            callback(this.projectStatuses);
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'statuses'
                }
            ])
        }).get().done(_.bind(function (data) {
            this.projectStatuses = data;
            callback(this.projectStatuses);
        }, this));
    },
    getProjectStatusList() {
        let list = [],
            values = (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_STATUS_LIST)) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_STATUS_LIST) : 'ACCEPT|true,DECLINE|true,BID RECEIVED|false,AWARDED|false';
        _.each(values.split(','), _.bind(function (value) {
            let parts = value.split('|');
            if (parts[0] !== 'PENDING' && parts[0] !== 'UNSENT') {
                list.push([parts[0], parts[1].toLowerCase() === 'true']);
            }
        }, this));
        return list;
    },
    getMessageStatusList() {
        let list = [],
            values = (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_STATUS_LIST)) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_STATUS_LIST) : 'YES|true,NO|true';
        _.each(values.split(','), _.bind(function (value) {
            let parts = value.split('|');
            list.push([parts[0], parts[1].toLowerCase() === 'true']);
        }, this));
        return list;
    },
    openInApp: function () {
        let device = PJQ.helpers.mobile.getDevice(),
            storeUrl,
            appRoute;
        if (device === 'android') {
            storeUrl = 'https://play.google.com/store/apps/details?id=com.jobplanner&hl=en_US&gl=US';
        } else {
            storeUrl = 'https://apps.apple.com/us/app/jobplanner-field-tools/id6450187761';
        }
        if (PJQ.app.session.contact != null) {
            appRoute = 'jp://jobplanner/project/' + this.id + '/contact/' + PJQ.app.session.contact.id;
        } else {
            appRoute = 'jp://jobplanner/project/' + this.id;
        }
        setTimeout(_.bind(function () {
            window.location = storeUrl;
        }, this), 25);
        window.location = appRoute;
    },
    fetchSubJobs: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.subJobs != null) {
                if (typeof callback === 'function') {
                    callback(this.subJobs);
                }
                resolve(this.subJobs);
                return;
            }

            this.subJobs = new PJQ.collections.budget.SubJobs(null, {
                projectId: this.id
            });
            this.subJobs.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.subJobs);
                    }
                    resolve(this.subJobs);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project sub jobs"));
                }
            });
        });
    },
    fetchCostCodes: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (this.costCodes != null && !force) {
                if (typeof callback === 'function') {
                    callback(this.costCodes);
                }
                resolve(this.costCodes);
                return;
            }

            this.costCodes = new PJQ.collections.budget.CostCodes(null, {
                projectId: this.id
            });
            this.costCodes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.costCodes);
                    }
                    resolve(this.costCodes);

                    // if (this.get('externalObject') == null) {
                    //     if (typeof callback === 'function') {
                    //         callback(this.costCodes);
                    //     }
                    //     resolve(this.costCodes);
                    //     return;
                    // }

                    // PJQ.app.session.fetchERPIntegration((erp) => {
                    //     if (erp != null && !erp.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES)) {
                    //         let allowedCostCodes = _.filter(this.costCodes.models, (costCode) => {
                    //             return costCode.isERPSynced();
                    //         });
                    //         this.costCodes.reset(allowedCostCodes);
                    //     }
                    //     if (typeof callback === 'function') {
                    //         callback(this.costCodes);
                    //     }
                    //     resolve(this.costCodes);
                    // });
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost codes"));
                }
            });
        });
    },
    fetchCostTypes: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (this.costTypes != null && !force) {
                if (typeof callback === 'function') {
                    callback(this.costTypes);
                }
                resolve(this.costTypes);
                return;
            }

            this.costTypes = new PJQ.collections.budget.CostTypes(null, {
                projectId: this.id
            });
            this.costTypes.fetch({
                success: () => {
                    if (this.get('externalObject') == null) {
                        if (typeof callback === 'function') {
                            callback(this.costTypes);
                        }
                        resolve(this.costTypes);
                        return;
                    }

                    PJQ.app.session.fetchERPIntegration((erp) => {
                        if (erp != null && !erp.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COST_TYPES)) {
                            let allowedCostTypes = _.filter(this.costTypes.models, (costType) => {
                                return costType.isERPSynced();
                            });
                            this.costTypes.reset(allowedCostTypes);
                        }
                        if (typeof callback === 'function') {
                            callback(this.costTypes);
                        }
                        resolve(this.costTypes);
                    });
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost types"));
                }
            })
        });
    },
    fetchTaxCodes: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (this.taxCodes != null) {
                if (typeof callback === 'function') {
                    callback(this.taxCodes);
                }
                resolve(this.taxCodes);
                return;
            }

            this.taxCodes = new PJQ.collections.budget.TaxCodes(null, {
                projectId: this.id
            });
            this.taxCodes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.taxCodes);
                    }

                    resolve(this.taxCodes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch tax codes"));
                }
            })
        });
    },
    fetchUnitsOfMeasure: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.unitsOfMeasure != null) {
                if (typeof callback === 'function') {
                    callback(this.unitsOfMeasure);
                }
                resolve(this.unitsOfMeasure);
                return;
            }

            this.unitsOfMeasure = new PJQ.collections.budget.UnitsOfMeasure(null, {
                projectId: this.id
            });
            this.unitsOfMeasure.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.unitsOfMeasure);
                    }

                    resolve(this.unitsOfMeasure);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch units of measure"));
                }
            })
        });
    },
    fetchChangeRequests: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (this.changeRequests != null && !force) {
                if (typeof callback === 'function') {
                    callback(this.changeRequests);
                }
                resolve(this.changeRequests);
                return;
            }

            this.changeRequests = new PJQ.collections.changeRequests.ChangeRequests(null, {
                projectId: this.id
            });
            this.changeRequests.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.changeRequests);
                    }
                    resolve(this.changeRequests);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project change requests"));
                }
            });
        });
    },
    fetchBudgetTimeStats: function (callback, options) {
        return new Promise((resolve, reject) => {
            // if (this.budgetTimeStats != null && (options == null || options.force !== true)) {
            //     if (typeof callback === 'function') {
            //         callback(this.budget);
            //     }
            //     resolve(this.budget);
            //     return;
            // }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.id,
                    },
                    {
                        endpoint: 'timecards'
                    },
                    {
                        endpoint: 'stats'
                    }
                ]),
                isAPIv2: true
            }).get().done((data) => {
                if (typeof callback === 'function') {
                    callback(data);
                }
                resolve(data);
            }).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(null);
            });
        });
    },
    fetchBudget: function (callback, options) {
        return new Promise((resolve, reject) => {
            if (this.budget != null && (options == null || options.force !== true)) {
                if (typeof callback === 'function') {
                    callback(this.budget);
                }
                resolve(this.budget);
                return;
            }

            this.budget = new PJQ.models.budget.Budget({
                projectId: this.id
            });
            this.budget.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.budget);
                    }

                    resolve(this.budget);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project budget"));
                }
            })
        });
    },
    fetchBudgetViews: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.budgetViews != null) {
                if (typeof callback === 'function') {
                    callback(this.budgetViews);
                }
                resolve(this.budgetViews);
                return;
            }

            this.budgetViews = new PJQ.collections.budget.BudgetViews();
            this.budgetViews.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.budgetViews);
                    }

                    resolve(this.budgetViews);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project budget views"));
                }
            })
        });
    },
    fetchBudgetSnapshots: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.snapshots != null) {
                if (typeof callback === 'function') {
                    callback(this.snapshots);
                }
                resolve(this.snapshots);
                return;
            }

            this.snapshots = new PJQ.collections.budget.Snapshots(null, {
                projectId: this.id
            });
            this.snapshots.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.snapshots);
                    }

                    resolve(this.snapshots);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project budget snapshots"));
                }
            })
        });
    },
    fetchCommitmentSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentSettings);
                }
                resolve(this.commitmentSettings);
                return;
            }

            this.commitmentSettings = new PJQ.models.commitments.Settings({}, {
                projectId: this.id
            });
            this.commitmentSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentSettings);
                    }

                    resolve(this.commitmentSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment settings"));
                }
            });
        });
    },
    fetchCommitmentFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentFieldSettings);
                }
                resolve(this.commitmentFieldSettings);
                return;
            }

            this.commitmentFieldSettings = new PJQ.collections.commitments.FieldSettings(null, {
                projectId: this.id
            });
            this.commitmentFieldSettings.fetch({
                success: () => {
                    resolve(this.commitmentFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.commitmentFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment field settings"));
                }
            });
        });
    },
    fetchCommitmentTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentTerms);
                }
                resolve(this.commitmentTerms);
                return;
            }

            this.commitmentTerms = new PJQ.collections.commitments.Terms(null, {
                projectId: this.id
            });
            this.commitmentTerms.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentTerms);
                    }

                    resolve(this.commitmentTerms);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment terms"));
                }
            });
        });
    },
    fetchCommitmentCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentCustomFields);
                }
                resolve(this.commitmentCustomFields);
                return;
            }

            this.commitmentCustomFields = new PJQ.collections.commitments.CustomFields(null, {
                projectId: this.id
            });
            this.commitmentCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentCustomFields);
                    }

                    resolve(this.commitmentCustomFields);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch commitment custom fields"));
                }
            });
        });
    },
    fetchDirectCostCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostCustomFields);
                }
                resolve(this.directCostCustomFields);
                return;
            }

            this.directCostCustomFields = new PJQ.collections.directcosts.CustomFields(null, {
                projectId: this.id
            });
            this.directCostCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostCustomFields);
                    }

                    resolve(this.directCostCustomFields);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost custom fields"));
                }
            });
        });
    },
    fetchMeetingCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.meetingCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.meetingCustomFields);
                }
                resolve(this.meetingCustomFields);
                return;
            }

            this.meetingCustomFields = new PJQ.collections.meetings.CustomFields(null, {
                projectId: this.id
            });
            this.meetingCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.meetingCustomFields);
                    }

                    resolve(this.meetingCustomFields);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch meeting custom fields"));
                }
            });
        });
    },
    fetchMeetingSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.meetingSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.meetingSettings);
                }
                resolve(this.meetingSettings);
                return;
            }

            this.meetingSettings = new PJQ.models.meetings.Settings(null, {
                projectId: this.id
            });
            this.meetingSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.meetingSettings);
                    }

                    resolve(this.meetingSettings);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch meeting settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderSettings);
                }
                resolve(this.commitmentChangeOrderSettings);
                return;
            }

            this.commitmentChangeOrderSettings = new PJQ.models.commitments.ChangeOrderSettings({}, {
                projectId: this.id
            });
            this.commitmentChangeOrderSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderSettings);
                    }

                    resolve(this.commitmentChangeOrderSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderFieldSettings);
                }
                resolve(this.commitmentChangeOrderFieldSettings);
                return;
            }

            this.commitmentChangeOrderFieldSettings = new PJQ.collections.commitments.ChangeOrderFieldSettings(null, {
                projectId: this.id
            });
            this.commitmentChangeOrderFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderFieldSettings);
                    }

                    resolve(this.commitmentChangeOrderFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order field settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentCOCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentCOCustomFields);
                }
                resolve(this.commitmentCOCustomFields);
                return;
            }

            this.commitmentCOCustomFields = new PJQ.collections.commitments.ChangeOrderCustomFields(null, {
                projectId: this.id
            });
            this.commitmentCOCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentCOCustomFields);
                    }

                    resolve(this.commitmentCOCustomFields);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch commitment change order custom fields"));
                }
            });
        });
    },
    fetchPrimeContractFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractFieldSettings);
                }
                resolve(this.primeContractFieldSettings);
                return;
            }

            this.primeContractFieldSettings = new PJQ.collections.primeContracts.FieldSettings(null, {
                projectId: this.id
            });
            this.primeContractFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract field settings"));
                }
            });
        });
    },
    fetchPrimeContractTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractTerms);
                }
                resolve(this.primeContractTerms);
                return;
            }

            this.primeContractTerms = new PJQ.collections.primeContracts.Terms(null, {
                projectId: this.id
            });
            this.primeContractTerms.fetch({
                success: () => {
                    resolve(this.primeContractTerms);
                    if (typeof callback === 'function') {
                        callback(this.primeContractTerms);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract terms"));
                }
            });
        });
    },
    fetchPrimeContractSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractSettings);
                }
                resolve(this.primeContractSettings);
                return;
            }

            this.primeContractSettings = new PJQ.models.primeContracts.Settings({}, {
                projectId: this.id
            });
            this.primeContractSettings.fetch({
                success: () => {
                    resolve(this.primeContractSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract settings "));
                }
            });
        });
    },
    fetchPrimeContractCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractCustomFields);
                }
                resolve(this.primeContractCustomFields);
                return;
            }

            this.primeContractCustomFields = new PJQ.collections.primeContracts.CustomFields(null, {
                projectId: this.id
            });
            this.primeContractCustomFields.fetch({
                success: () => {
                    resolve(this.primeContractCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.primeContractCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract custom fields"));
                }
            });
        });
    },
    fetchPayableInvoiceSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceSettings);
                }
                resolve(this.payableInvoiceSettings);
                return;
            }

            this.payableInvoiceSettings = new PJQ.models.invoicing.PayableInvoiceSettings(null, {
                projectId: this.id
            });
            this.payableInvoiceSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceSettings);
                    }

                    resolve(this.payableInvoiceSettings);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch payable invoice settings"));
                }
            });
        });
    },
    fetchPayableInvoiceFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceFieldSettings);
                }
                resolve(this.payableInvoiceFieldSettings);
                return;
            }

            this.payableInvoiceFieldSettings = new PJQ.collections.invoicing.PayableInvoiceFieldSettings(null, {
                projectId: this.id
            });
            this.payableInvoiceFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceFieldSettings);
                    }

                    resolve(this.payableInvoiceFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice field settings"));
                }
            });
        });
    },
    fetchPayableInvoiceCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceCustomFields);
                }
                resolve(this.payableInvoiceCustomFields);
                return;
            }

            this.payableInvoiceCustomFields = new PJQ.collections.invoicing.PayableInvoiceCustomFields(null, {
                projectId: this.id
            });
            this.payableInvoiceCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceCustomFields);
                    }

                    resolve(this.payableInvoiceCustomFields);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice custom fields"));
                }
            });
        });
    },
    fetchReceivableInvoiceSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceSettings);
                }
                resolve(this.receivableInvoiceSettings);
                return;
            }

            this.receivableInvoiceSettings = new PJQ.models.invoicing.ReceivableInvoiceSettings();
            this.receivableInvoiceSettings.fetch({
                success: () => {
                    resolve(this.receivableInvoiceSettings);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice settings "));
                }
            });
        });
    },
    fetchReceivableInvoiceCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceCustomFields);
                }
                resolve(this.receivableInvoiceCustomFields);
                return;
            }

            this.receivableInvoiceCustomFields = new PJQ.collections.invoicing.ReceivableInvoiceCustomFields(null, {
                projectId: this.id
            });
            this.receivableInvoiceCustomFields.fetch({
                success: () => {
                    resolve(this.receivableInvoiceCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice custom fields"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderFieldSettings);
                }
                resolve(this.primeContractChangeOrderFieldSettings);
                return;
            }

            this.primeContractChangeOrderFieldSettings = new PJQ.collections.primeContracts.ChangeOrderFieldSettings(null, {
                projectId: this.id
            });
            this.primeContractChangeOrderFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order field settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderSettings);
                }
                resolve(this.primeContractChangeOrderSettings);
                return;
            }

            this.primeContractChangeOrderSettings = new PJQ.models.primeContracts.ChangeOrderSettings({}, {
                projectId: this.id
            });
            this.primeContractChangeOrderSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractCOCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractCOCustomFields);
                }
                resolve(this.primeContractCOCustomFields);
                return;
            }

            this.primeContractCOCustomFields = new PJQ.collections.primeContracts.ChangeOrderCustomFields(null, {
                projectId: this.id
            });
            this.primeContractCOCustomFields.fetch({
                success: () => {
                    resolve(this.primeContractCOCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.primeContractCOCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order custom custom fields"));
                }
            });
        });
    },
    fetchChangeRequestSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestSettings);
                }
                resolve(this.changeRequestSettings);
                return;
            }

            this.changeRequestSettings = new PJQ.models.changeRequests.Settings({}, {
                projectId: this.id
            });
            this.changeRequestSettings.fetch({
                success: () => {
                    resolve(this.changeRequestSettings);
                    if (typeof callback === 'function') {
                        callback(this.changeRequestSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch change request settings"));
                }
            });
        });
    },
    fetchChangeRequestCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestCustomFields);
                }
                resolve(this.changeRequestCustomFields);
                return;
            }

            this.changeRequestCustomFields = new PJQ.collections.changeRequests.CustomFields(null, {
                projectId: this.id
            });
            this.changeRequestCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.changeRequestCustomFields);
                    }

                    resolve(this.changeRequestCustomFields);
                },
                error: () => {
                    reject(new Error("Failed to fetch change request custom fields"));
                }
            });
        });
    },
    fetchBillingPeriodSettings: function (callback, allowAutomate = false) {
        return new Promise((resolve, reject) => {
            if (this.billingPeriodSettings != null) {
                if (allowAutomate && !this.billingPeriodSettings.get('allowAutomate')) {
                    this.billingPeriodSettings.set('allowAutomate', allowAutomate);
                    fnFetch();
                }

                if (typeof callback === 'function') {
                    callback(this.billingPeriodSettings);
                }
                resolve(this.billingPeriodSettings);
                return;
            }

            this.billingPeriodSettings = new PJQ.models.budget.BillingPeriodSettings({
                projectId: this.id,
                allowAutomate: allowAutomate
            });
            this.billingPeriodSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.billingPeriodSettings);
                    }

                    resolve(this.billingPeriodSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch billing period settings"));
                }
            });
        });
    },
    fetchInspectionTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionTypes);
                }
                resolve(this.inspectionTypes);
                return;
            }

            this.inspectionTypes = new PJQ.collections.inspections.Types(null, {
                projectId: this.id
            });
            this.inspectionTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.inspectionTypes);
                    }
                    resolve(this.inspectionTypes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project inspection types"));
                }
            })
        });
    },
    fetchInspectionTemplates: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionTemplates != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionTemplates);
                }
                resolve(this.inspectionTemplates);
                return;
            }

            this.inspectionTemplates = new PJQ.collections.inspections.Templates(null, {
                projectId: this.id
            });
            this.inspectionTemplates.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.inspectionTemplates);
                    }
                    resolve(this.inspectionTemplates);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project inspection templates"));
                }
            })
        });
    },
    fetchCrews: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.crews != null) {
                if (typeof callback === 'function') {
                    callback(this.crews);
                }
                resolve(this.crews);
                return;
            }

            this.crews = new PJQ.collections.timecards.Crews(null, {
                projectId: this.id
            });
            this.crews.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.crews);
                    }
                    resolve(this.crews);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project crews"));
                }
            })
        });
    },
    fetchEquipment: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.equipment != null) {
                if (typeof callback === 'function') {
                    callback(this.equipment);
                }
                resolve(this.equipment);
                return;
            }

            this.equipment = new PJQ.collections.timecards.Equipment(null, {
                projectId: this.id
            });
            this.equipment.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.equipment);
                    }
                    resolve(this.equipment);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project equipment"));
                }
            })
        });
    },
});

PJQ.models.projects.ProjectCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'customfields',
                value: this.id
            }
        ]);
    },
});

PJQ.models.projects.ProjectSettings = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        return model;
    },
    isColumnSelected: function (column) {
        return (_.find(this.get('columns'), function (col) {
            return col === column
        }) !== undefined);
    }
});

//right now this model is 100% cookie based
PJQ.models.projects.ProjectInvitesSettings = PJQ.models.BaseModel.extend({
    setFavoriteFilter: function (val) {
        if (val) {
            PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.PROJECT_INVITES_FAVORITE_FILTER, true);
        } else {
            PJQ.helpers.cookieHelpers.removeCookie(PJQ.constants.cookies.PROJECT_INVITES_FAVORITE_FILTER);
        }
    },
    getFavoriteFilter: function () {
        return PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.PROJECT_INVITES_FAVORITE_FILTER) === "true";
    }
});

//Collections
PJQ.collections.projects.Projects = PJQ.collections.BaseCollection.extend({
    options: {
        isSimple: true,
        isBidding: false,
        customFieldIds: [],
        isMyProjects: false,
        isProjectInvites: false
    },
    model: PJQ.models.projects.Project,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            }
        ], [
            {
                parameter: 'isSimple',
                value: this.options.isSimple
            },
            {
                parameter: 'isBidding',
                value: this.options.isBidding
            },
            {
                parameter: 'status',
                value: this.options.status
            },
            {
                parameter: 'customFieldIds',
                value: this.options.customFieldIds
            },
            {
                parameter: 'isMyProjects',
                value: this.options.isMyProjects
            },
            {
                parameter: 'isProjectInvites',
                value: this.options.isProjectInvites
            }
        ])
    }
});

PJQ.collections.projects.ProjectPhotos = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.files.File,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'photos'
            }
        ])
    }
});

PJQ.collections.projects.ProjectCustomFields = PJQ.collections.customFields.CustomFields.extend({
    model: PJQ.models.projects.ProjectCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project ? this.options.project.id : null
            },
            {
                endpoint: 'customfields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

//Views
PJQ.views.projects.ProjectParticipantHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Participant-History'),
        subTemplates: {
            singleProjectHistory: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Participant-Single-Project-History'),
            overallHistory: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Participant-Overall-History'),
        },
        isShowCloseButton: true,
        maxWidth: '1000px',
        type: 'THIS',
        onGoToProject: _.noop
    },
    events: {
        'keyup .input-history-search': 'search',
        'click .link-project': 'goToProject',
        'click .btn-copy-access-key': 'copyAccessKey',
        'click .btn-view-downloads': 'viewDownloads',
        'click .btn-export': 'export',
        'click .btn-show-message': 'showProjectMessage'
    },
    beforeModalCreated: function () {
        this.options.project = PJQ.app.session.project;
    },
    search: function () {
        this.$('.datatable-search').val(this.$('.input-history-search').val());
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Resend Message',
                iconClass: 'fal fa-paper-plane',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id
                            },
                            {
                                endpoint: 'projectmessages',
                                value: row.data().projectMessageId
                            },
                            {
                                endpoint: 'resend'
                            }
                        ], [
                            {
                                parameter: 'projectMessageContactBroadcastIds',
                                value: [row.data().projectMessageContactBroadcastId]
                            }
                        ])
                    }).post().done(_.bind(function (data) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Message is being resent.'
                        });
                    }, this));

                }, this),
                isShown: _.bind(function (row) {
                    let data = row.data();
                    return data.projectMessageContactBroadcastId > 1 && data.auditAction.toLowerCase() === 'projectmessage';
                }, this)
            }
        ];
    },
    afterRender: function () {
        if (this.options.project) {
            this.historyTypeSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.history-type'),
                onChange: _.bind(function (value) {
                    this.renderHistory(value);
                }, this)
            });
            this.options.project.getProjectStatuses(_.bind(function (statuses) {
                this.statuses = statuses;
                this.renderHistory(this.options.type);
            }, this));
        } else {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'settings'
                    },
                    {
                        endpoint: 'statuses'
                    }
                ])
            }).get().done(_.bind(function (data) {
                this.statuses = data;
                this.$('.select-project-history-type').hide();
                this.renderHistory('ALL');
            }, this)).fail(_.bind(function () {
                this.statuses = null;
                this.$('.select-project-history-type').hide();
                this.renderHistory('ALL');
            }, this));
        }
    },
    renderHistory: function (type) {
        let $history = this.$('.history-data');
        if (type === 'THIS') {
            this.renderSubTemplate(false, this.options.subTemplates.singleProjectHistory, $history, {}, _.bind(function () {
                if (this.singleProjectData == null) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: "projects",
                                value: this.options.project.id
                            },
                            {
                                endpoint: "participants",
                                value: this.options.contactId
                            },
                            {
                                endpoint: "history"
                            }
                        ])
                    }).get().done(_.bind(function (data) {
                        this.singleProjectData = data;
                        this.renderSingleProjectHistory();
                    }, this));
                } else {
                    this.renderSingleProjectHistory();
                }
            }, this));
        } else {
            let loader = new PJQ.Loader($history);
            let callback = _.bind(function (data) {
                this.overallData = data;
                this.renderSubTemplate(false, this.options.subTemplates.overallHistory, $history, {
                    statuses: _.uniq(_.map(this.overallData, function (project) {
                        return (_.size(project.projectStatus) > 0 ? project.projectStatus.toUpperCase() : "PENDING");
                    }))
                }, _.bind(function () {
                    this.renderOverallHistory();
                    loader.remove();
                }, this));
            }, this);
            if (this.overallData == null) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: "contacts",
                            value: this.options.contactId
                        },
                        {
                            endpoint: "projecthistory"
                        }
                    ])
                }).get().done(callback);
            } else {
                callback(this.overallData);
            }
        }
    },
    getStatusColor: function (name) {
        let status = _.find(this.statuses, function (status) {
            return status.name.toUpperCase() === name.toUpperCase();
        });

        return status != null ? status.backgroundColor : "#eee";
    },
    renderSingleProjectHistory: function () {
        _.each(this.singleProjectData, _.bind(function (data) {
            if (data.auditAction === 'MessageKeyDownload')
                this.$('.btn-view-downloads').removeClass('hidden');
        }, this));

        let responseDueLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due";
        new PJQ.views.dataTables.DataTable({
            el: this.$('.single-project-data-table'),
            rowId: 'projectMessageContactBroadcastId',
            pageLength: 5,
            isHideSearch: true,
            data: this.singleProjectData,
            dom: "<'row no-gutters'<'table-outer col-sm-12'tr>>" + "<'row no-gutters'<'col-sm-5 mt-1'l><'col-sm-7 mt-2'p>>",
            contextMenuOptions: {
                actions: this.getContextMenuItems(),
                isHideNoActions: true
            },
            order: [0, 'desc'],
            columns: [
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.created);
                        },
                        "filter": "created",
                        "display": function (row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                    },
                    "title": "Date",
                    "orderable": false
                },
                {
                    "data": "description",
                    "title": "Description",
                    "width": '300px',
                    "orderable": false,
                    "render": function (data, type, row) {
                        if (row.auditAction === "ProjectMessage" || row.auditAction === "PrivateMessage") {
                            if (row.subject != null) {
                                return '<a href="javascript:void(0)" data-id=" ' + row.projectMessageId + '" class="btn-show-message" title="Click to view Message">' + row.subject + '</a>'
                            } else {
                                return data;
                            }
                        } else {
                            return data;
                        }
                    }
                },
                {
                    "data": {
                        "_": function (row) {
                            let result = (row.auditAction === 'ProjectMessage' ? 'No Response Required' : 'N/A');
                            switch (row.messageType) {
                                case 'PROJECT':
                                    result = 'ACCEPT/DECLINE';
                                    break;
                                case 'MESSAGE':
                                    result = 'YES/NO';
                                    break;
                            }
                            return result;
                        }
                    },
                    "title": "Response Type",
                    "orderable": false
                },
                {
                    "data": {
                        "_": function (row) {
                            let result = 'N/A';
                            if (row.auditAction === 'ProjectMessage') {
                                result = row.bidDueDate;

                                if (!row.bidDueTime.startsWith(' ')) {
                                    result += ' ' + row.bidDueTime + ' ' + row.bidDueTimeZone;
                                }
                            }
                            return result;
                        }
                    },
                    "title": responseDueLabel,
                    "orderable": false
                },
                {
                    "data": "accessKey",
                    "title": "Access Key",
                    "orderable": false,
                    "render": function (data, type, row) {
                        let html = '<div style="min-width:100px;" class="d-flex align-items-center">';
                        html += '<div class="flex-fill ' + (row.accessKey ? '' : 'text-muted') + '">' + (row.accessKey ? row.accessKey : '') + '</div>';
                        if (_.size(row.accessKey) > 0)
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-access-key" title="Copy Access Key" data-access-key="' + row.accessKey + '"><i class="far fa-key text-dark"></i></button>';
                        html += '</div>';
                        return html;
                    }

                },
                {
                    "data": "broadcastStatus",
                    "title": 'Broadcast Status',
                    "render": function (data, type, row) {
                        let broadcastStatus = row.auditAction === 'ProjectMessage' ? (_.size(row.broadcastStatus) === 0 ? 'PENDING' : row.broadcastStatus) : '';
                        return '<span title="' + (_.size(row.broadcastErrorMessage) === 0 ? broadcastStatus : row.broadcastErrorMessage) + '" >' + broadcastStatus + '</span>';
                    },
                    "orderable": false
                },
                {
                    "data": "response",
                    "title": 'Response',
                    "render": _.bind(function (data, type, row) {
                        let response = 'N/A';
                        if (_.size(row.response) > 0) {
                            response = '<span style="color:' + this.getStatusColor(row.response) + '">' + row.response + '</span>';
                        }
                        return response;
                    }, this),
                    "orderable": false
                },
                {
                    "data": "responded",
                    "title": 'Responded',
                    "render": function (data, type, row) {
                        let response = 'N/A';
                        if (row.auditAction === 'ProjectMessage') {
                            response = '';
                            if (_.size(row.responded) > 0)
                                response = PJQ.helpers.dateHelpers.getDateString(new Date(row.responded), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                        }
                        return response;
                    },
                    "orderable": false
                }
            ]
        });
    },
    renderOverallHistory: function () {
        let statuses = {},
            statusesDatasets = [],
            responses = {
                responded: 0,
                notResponded: 0
            };
        _.each(this.overallData, function (project) {
            let status = _.size(project.projectStatus) > 0 ? project.projectStatus.toUpperCase() : "PENDING";
            if (statuses[status] == null) {
                statuses[status] = 1;
            } else {
                statuses[status] = statuses[status] + 1;
            }

            if (status === "PENDING") {
                responses.notResponded = responses.notResponded + 1;
            } else {
                responses.responded = responses.responded + 1;
            }
        });
        _.each(statuses, function (count, status) {
            let set = {
                label: status,
                backgroundColor: this.getStatusColor(status),
                data: [
                    count
                ]
            };
            statusesDatasets.push(set);
        }, this);
        new PJQ.charts.Chart(this.$('.statuses-chart'), {
            type: 'bar',
            height: 250,
            width: 250,
            data: {
                datasets: statusesDatasets
            },
            options: {
                cutoutPercentage: 70,
                scales: {
                    yAxes: [{
                        ticks: {
                            min: 0
                        }
                    }]
                }
            },
            onClick: _.bind(function (clickedSegments) {
                if (_.size(clickedSegments) > 0) {
                    let segment = clickedSegments[0],
                        stat = stats.datasets[segment._index];
                    PJQ.app.router.navigate('projects/' + this.options.project.id + '/' + stat.route, {
                        trigger: true
                    });
                }
            }, this)
        });

        let responsesLabels = ["Responded", "Not Responded"],
            responsesDataset = [responses["responded"], responses["notResponded"]],
            responsesColors = [PJQ.constants.colors.BLUE, PJQ.constants.colors.GRAY];
        new PJQ.charts.Chart(this.$('.responses-chart'), {
            type: 'doughnut',
            height: 250,
            width: 250,
            options: {
                cutoutPercentage: 70
            },
            data: {
                labels: responsesLabels,
                datasets: [
                    {
                        data: responsesDataset,
                        backgroundColor: responsesColors
                    }
                ]
            },
            onClick: _.bind(function (clickedSegments) {
                if (_.size(clickedSegments) > 0) {
                    let segment = clickedSegments[0],
                        stat = stats.datasets[segment._index];
                    PJQ.app.router.navigate('projects/' + this.options.project.id + '/' + stat.route, {
                        trigger: true
                    });
                }
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-history-filter'),
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {

            }, this)
        });
        let prefs;
        if (PJQ.app.session.project != null) {
            prefs = PJQ.app.session.project.preferences;
        } else {
            prefs = PJQ.app.session.preferences;
        }

        let responseDueLabel = prefs.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due",
            startDateLabel,
            finishDateLabel;
        if (this.options.project) {
            startDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) : 'Start Date'
            finishDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) : 'Finish Date';
        } else {
            startDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) : 'Start Date'
            finishDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) : 'Finish Date';
        }
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.overall-data-table'),
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Participant-Overall-History')
            },
            headerData: _.bind(function () {
                return {
                    statuses: this.statuses,
                    getStatusColor: this.getStatusColor
                };
            }, this),
            afterHeaderRender: function (view, $header) {
                new PJQ.inputs.Selectpicker({
                    el: $header.find('.select-history-filter'),
                    onChange: function (value) {
                        view.setFilter('status', value);
                    },
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });
            },
            getFilterData: function (view, data) {
                let statusFilter = view.getFilter('status');
                if (_.size(statusFilter) > 0) {
                    return _.filter(data, function (item) {
                        return statusFilter.indexOf(item.projectStatus.toLowerCase()) !== -1;
                    });
                }
                return data;
            },
            pageLength: 10,
            data: this.overallData,
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            order: [],
            columns: [
                {
                    "data": "projectName",
                    "title": 'Name',
                    "render": _.bind(function (data, type, row) {
                        return '<a class="link-project" href="/#projects/' + row.projectId.toString() + '">' + data + '</a>';
                    }, this)
                },
                {
                    "data": "city",
                    "title": 'City'
                },
                {
                    "data": "projectStatus",
                    "title": 'Status',
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let status = _.size(row.projectStatus) > 0 ? row.projectStatus.toUpperCase() : 'PENDING';
                        return '<span style="color:' + this.getStatusColor(status) + '">' + status + '</span>';
                    }, this)
                },
                {
                    "data": {
                        "_": function (row) {

                            let dateTemp = new Date();
                            if (row.responseDue == null || row.responseDue == 'N/A')
                                return dateTemp.addDays(-20000);
                            if (row.responseDue === 'ASAP')
                                return dateTemp.addDays(-10000);

                            return new Date(row.responseDue);
                        },
                        "filter": "responseDue",
                        "display": function (row) {
                            if (row.responseDue == null || row.responseDue == 'N/A')
                                return "N/A";
                            if (row.responseDue === 'ASAP')
                                return row.responseDue;

                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.responseDue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    "title": responseDueLabel
                },
                {
                    "data": {
                        "_": function (row) {

                            let dateTemp = new Date();
                            if (row.startDate == null)
                                return dateTemp.addDays(-20000);

                            return new Date(row.startDate);
                        },
                        "filter": "startDate",
                        "display": function (row) {
                            if (row.startDate == null)
                                return "N/A";

                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.startDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    "title": startDateLabel
                },
                {
                    "data": {
                        "_": function (row) {

                            let dateTemp = new Date();
                            if (row.endDate == null)
                                return dateTemp.addDays(-20000);

                            return new Date(row.endDate);
                        },
                        "filter": "endDate",
                        "display": function (row) {
                            if (row.endDate == null)
                                return "N/A";

                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.endDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    "title": finishDateLabel
                },
                {
                    "data": "emailSuccessCount",
                    "title": "Sent/Failed",
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        return '' + (row.emailSuccessCount + row.faxSuccessCount).toString() + ' / ' + (row.emailFailedCount + row.faxFailedCount).toString();
                    }, this)
                }
            ]
        });
    },
    goToProject: function () {
        this.removeModal();
        if (this.options.onGoToProject) {
            this.options.onGoToProject();
        }
    },
    showProjectMessage: function (e) {
        let $target = $(e.currentTarget),
            message = _.find(this.singleProjectData, function (data) {
                return data.projectMessageId === parseInt($target.data('id'));
            });
        e.target.outerHTML = message.description;
    },
    copyAccessKey: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('accessKey'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Access Key copied to clipboard.'
        });
    },
    viewDownloads: function () {
        new PJQ.views.projects.ProjectParticipantDownloadHistoryModal({
            contactId: this.options.contactId
        });
    },
    export: function () {
        if (this.historyTypeSelectPicker != null && this.historyTypeSelectPicker.getValue() === 'THIS') {
            PJQ.files.downloadFile(
                PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'participants',
                        value: this.options.contactId
                    },
                    {
                        endpoint: 'history'
                    },
                    {
                        endpoint: 'export'
                    }
                ])
            );
        } else {
            PJQ.files.downloadFile(
                PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: "contacts",
                        value: this.options.contactId
                    },
                    {
                        endpoint: "projecthistory"
                    },
                    {
                        endpoint: "export"
                    }
                ])
            );
        }
    }

});

PJQ.views.projects.ProjectParticipantDownloadHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Participant-Download-History'),
        minWidth: '900px'
    },
    events: {
        'click .btn-export': 'export'
    },
    beforeModalCreated: function () {
        this.options.project = PJQ.app.session.project;
    },
    afterRender: function () {
        // build endpoint and fetch
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'participants',
                value: this.options.contactId
            },
            {
                endpoint: 'downloadhistory'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
        }).get().done(_.bind(function (data) {
            new PJQ.views.dataTables.DataTable({
                el: this.$('.download-table'),
                pageLength: 5,
                isHideSearch: true,
                data: data,
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
                order: [],
                columns: [
                    {
                        "data": "title",
                        "title": "Filename",
                        "orderable": false
                    },
                    {
                        "data": {
                            "_": function (row) {
                                return new Date(row.downloadedOn);
                            },
                            "display": function (row) {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.downloadedOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                            }
                        },
                        "title": "Downloaded On",
                        "orderable": false
                    }
                ]
            });
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong.'
            });
        });

    },
    export: function () {
        PJQ.files.downloadFile(
            PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'participants',
                    value: this.options.contactId
                },
                {
                    endpoint: 'downloadhistory'
                },
                {
                    endpoint: 'export'
                }
            ])
        );
    }
});


PJQ.views.projects.ProjectSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Selector'),
        isDisableSelected: false,
        isSingleChoice: false,
        onProjectSelected: _.noop,
        excludeProjectIds: [],
        dataTableHeaderData: {
            isHideDeletedFilter: false
        },
        dataTableColumns: null
    },
    events: {
        "change .select-project": "selectProject"
    },
    beforeFirstRender: function () {

        if (this.options.dataTableColumns === null)
            this.options.dataTableColumns = [
                {name: 'projectName', sort: 1},
                {name: 'city', sort: 0},
                {name: 'state', sort: 0}
            ];

        if (!this.options.isSingleChoice) {
            this.selectedProjects = [];
        }

        this.collection = new PJQ.collections.projects.Projects();
        this.listenTo(this.collection, 'sync', this.render);
        this.collection.fetch();
    },
    afterRender: function () {
        let order = null;
        _.each(this.options.dataTableColumns, _.bind(function (column, index) {
            if (column.sort !== 0)
                order = [index + 1, column.sort === 1 ? 'asc' : 'desc'];
        }, this));

        this.dataTable = new PJQ.views.projects.ProjectSelectorDataTable({
            el: '.projects-data-table-container',
            data: _.filter(this.collection.models, _.bind(function (model) {
                return this.options.excludeProjectIds.indexOf(model.id) === -1
            }, this)),
            columns: this.getColumns(),
            order: order,
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Selector')
            },
            headerData: this.options.dataTableHeaderData
        });
    },
    getColumns: function () {
        let columns = [
            {
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-project"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            }
        ];

        _.each(this.options.dataTableColumns, _.bind(function (column, index) {

            switch (column.name) {
                case 'projectId':
                    columns.push({
                        "data": "attributes.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "data": "attributes.projectName",
                        "title": "Project Name"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'created':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return new Date(row.attributes.created);
                            },
                            "filter": "attributes.created",
                            "display": function (row) {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                            }
                        },
                        "title": "Created"
                    });
                    break;
                case 'bidsdue':
                    let responseDueLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due";
                    columns.push({
                        "data": {
                            "_": function (row) {

                                let dateTemp = new Date();
                                if (row.attributes.bidsDue == null)
                                    return dateTemp.addDays(-20000);
                                if (row.attributes.rDueText === 'ASAP')
                                    return dateTemp.addDays(-10000);

                                return new Date(row.attributes.bidsDue);
                            },
                            "filter": "attributes.bidsDue",
                            "display": function (row) {
                                if (row.attributes.bidsDue == null)
                                    return "N/A";
                                if (row.attributes.rDueText === 'ASAP')
                                    return row.attributes.rDueText;

                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }
                        },
                        "title": responseDueLabel
                    });
                    break;
                case 'userDisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : "Project Contact"
                    });
                    break;
                case 'user2DisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : "Project Contact 2"
                    });
                    break;
            }
        }, this));

        return columns;
    },
    selectProject: function (e) {
        let target = $(e.currentTarget),
            project = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-project').not(target).text('Select').prop('checked', false); //.removeClass('btn-primary').addClass('btn-secondary');
            if (project.get('isSelected')) {
                project.set('isSelected', false);
                this.selectedProject = null;
            } else {
                project.set('isSelected', true);
                this.selectedProject = project;
                this.collection.get(project.id);
                _.each(this.collection.models, _.bind(function (dtProject) {
                    if (project.id !== dtProject.id)
                        dtProject.set('isSelected', false);
                }, this));
            }

            this.options.onProjectSelected(this.selectedProject);
        } else {
            if (project.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                project.set('isSelected', false);
                this.selectedProjects = _.reject(this.selectedProjects, function (selProject) {
                    return selProject.id === project.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                project.set('isSelected', true);
                this.selectedProjects.push(project);
            }
            this.options.onProjectSelected(this.selectedProjects);
        }
    }
});

PJQ.views.projects.ProjectSelectorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-project-select'),
        width: '40%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: false,
        isSingleChoice: false,
        onSave: _.noop(),
        excludeProjects: null,
        excludeProjectIds: null
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
    },
    afterRender: function () {
        this.projects = null;

        new PJQ.views.projects.ProjectSelector({
            el: this.$('.project-selector'),
            excludeProjectIds: this.options.excludeProjectIds,
            isSingleChoice: this.options.isSingleChoice,
            onProjectSelected: _.bind(function (projects) {
                this.projects = projects;
            }, this),
            dataTableColumns: [
                {name: 'projectName', sort: 1},
                {name: 'city', sort: 0},
                {name: 'state', sort: 0},
                {name: 'bidsdue', sort: 0},
                {name: 'created', sort: 0}
            ],
            dataTableHeaderData: {
                isHideDeletedFilter: true
            }
        });
    },
    save: function () {
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.projects);
        }

        this.removeModal();
    },
    cancel: function () {
        this.removeModal();
    }
});

PJQ.views.projects.ProjectSelectorInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Projects-Select-Input'),
        subTemplates: {
            projectBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Projects-Select-Input-Projects')
        },
        isSingleChoice: false,
        onAdd: _.noop,
        onChange: _.noop,
        onDelete: _.noop,
        canEdit: false,
        selectedProjects: null,
        selectedProjectIds: null, // If you only have a list of ids, pass it in as selectedProjectIds,
        emptyNotice: 'No Projects Selected',
    },
    events: {
        "click .project-select-input-add": "edit",
        "click .project-select-input-delete": "deleteProject"
    },
    beforeFirstRender() {
        this.selectedProjects = this.options.selectedProjects ? this.options.selectedProjects : (this.options.isSingleChoice ? null : []);
        this.projects = this.options.projects;
        this.isFetched = false;

        if (!this.projects) {
            this.projects = new PJQ.collections.projects.Projects()
        }

        if (!this.projects.isFetched) {
            this.projects.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            })
        } else {
            this.isFetched = true;
        }
    },
    afterRender() {
        if (!this.isFetched)
            return;

        let formGroup = this.$el.closest('.form-group');
        let addButton = formGroup.find('label').find('.project-select-input-add');

        // If the button already exists, remove it
        if (_.size(addButton) > 0) {
            addButton.remove();
        }

        if (this.options.canEdit) {
            // Always create a new button and append it
            addButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm ml-1 project-select-input-add"><i class="fal fa-sm fa-pencil"></i></button>');
            formGroup.find('label').first().append(addButton);
            addButton.on('click', _.bind(this.edit, this));
        }

        if (this.options.selectedProjectIds) {
            if (this.options.isSingleChoice) {
                let projectId = PJQ.helpers.objectHelpers.refinedType(this.options.selectedProjectIds) !== 'array' ? this.options.selectedProjectIds : this.options.selectedProjectIds[0];
                this.selectedProjects = this.projects.get(projectId);
            } else {
                let selectedProjects = [];
                _.each(this.options.selectedProjectIds, function (id) {
                    let project = this.projects.get(id);
                    if (project) {
                        selectedProjects.push(project);
                    }
                }, this)
                this.selectedProjects = selectedProjects;
            }
        }

        this.renderSelectedProjects();
    },
    renderSelectedProjects: function () {
        let data = this.selectedProjects;
        if (this.selectedProjects && this.options.isSingleChoice)
            data = [this.selectedProjects];

        if (_.size(data) === 0) {
            this.$('.project-select-list').html('<div class="text-muted font-weight-light mt-1 fs-16">' + this.options.emptyNotice + '</div>');
        } else {
            this.renderSubTemplate(false, this.options.subTemplates.projectBadge, this.$('.project-select-list'), {
                models: data,
                isSingleChoice: this.options.isSingleChoice,
                canEdit: this.options.canEdit
            });
        }
    },
    edit: function () {
        let excludeProjectIds = [];
        if (this.options.isSingleChoice && this.selectedProjects) {
            excludeProjectIds.push(this.selectedProjects.id);
        } else {
            excludeProjectIds = _.map(this.selectedProjects, function (project) {
                return project.id;
            }, this)
        }
        this.selector = new PJQ.views.projects.ProjectSelectorModal({
            contacts: this.options.contacts,
            excludeProjectIds: excludeProjectIds,
            isSingleChoice: this.options.isSingleChoice,
            onSave: _.bind(function (newProjects) {
                this.selectedProjects = this.options.isSingleChoice ? newProjects : _.union(this.selectedProjects, newProjects);
                this.renderSelectedProjects();
                this.options.onAdd(newProjects, this.selectedProjects);
                this.options.onChange(this.selectedProjects);
            }, this)
        });
    },
    deleteProject: function (e) {
        let id = $(e.target).closest('.select-project-container').data('projectId');
        if (this.options.isSingleChoice) {
            this.options.onDelete(this.selectedProjects, null);
            this.options.onChange(null);
            this.selectedProjects = null;
        } else {
            let deletedProject = _.find(this.selectedProjects, function (project) {
                return project.id === id
            });
            if (deletedProject != null) {
                this.selectedProjects = _.filter(this.selectedProjects, function (project) {
                    return project.id !== id;
                });
                this.options.onDelete(deletedProject, this.selectedProjects);
                this.options.onChange(this.selectedProjects);
            }
        }
        this.renderSelectedProjects();
    },
})

PJQ.views.projects.ProjectSelectorDataTable = PJQ.views.dataTables.DataTable.extend({
    options: {
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Selector')
        }
    },
    events: {
        'keyup .datatable-search': 'search',
        'click .project-selector-clear-filters': 'clearFilters'
    },
    beforeDataTableRender: function () {
        this.projectStatusFilter = ["ready"];
        this.projectStatusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.project-selector-status-filter'),
            onChange: _.bind(function (value) {
                this.projectStatusFilter = value;
                this.filter(value);
            }, this),
            isMultiple: true,
            noneSelectedText: 'No Filters',
            defaultValue: this.projectStatusFilter
        });
    },
    getFilterData: function () {
        return _.filter(this.options.data, function (row) {
            return _.size(this.projectStatusFilter) === 0 || _.indexOf(this.projectStatusFilter, row.attributes.status.toLowerCase()) !== -1;
        }, this);
    },
    afterSearch: function () {
        this.$('.project-selector-clear-filters').prop('disabled', _.size(this.$('input.datatable-search').val()) === 0 && _.size(this.projectStatusFilter) === 0);
    },
    clearFilters: function () {
        this.projectStatusFilter = null;
        this.projectStatusFilterPicker.deselectAll();
        this.$('input.datatable-search').val('');
        this.search();
    }
});

PJQ.models.projects.ProjectAttachment = PJQ.models.files.File.extend({
    idAttribute: 'entryId'
});

PJQ.collections.projects.ProjectAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.projects.ProjectAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'attachments'
            }
        ], [
            {
                parameter: 'shared',
                value: this.options.isShared != null ? this.options.isShared : true
            },
            {
                parameter: 'priv',
                value: this.options.isPrivate != null ? this.options.isPrivate : true
            },
            {
                parameter: 'recursive',
                value: !this.options.isDeferred
            }
        ])
    }
});

PJQ.models.projects.ProjectNDA = PJQ.models.BaseModel.extend({
    idAttribute: 'ndaId',
    endpoint: function () {
        if (this.project != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.project.id
                },
                {
                    endpoint: 'nda'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'nda',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model) {
            if (model.project != null) {
                this.project = model.project;
            }
        }
        return model;
    }
});

PJQ.collections.projects.ProjectNDAs = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.projects.ProjectNDA,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'nda'
            }
        ])
    }
});

PJQ.views.projects.ProjectSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Selector'),
        isDisableSelected: false,
        isSingleChoice: false,
        onProjectSelected: _.noop,
        excludeProjectIds: [],
        dataTableHeaderData: {
            isHideDeletedFilter: false
        },
        dataTableColumns: null
    },
    events: {
        "change .select-project": "selectProject"
    },
    beforeFirstRender: function () {

        if (this.options.dataTableColumns === null)
            this.options.dataTableColumns = [
                {name: 'projectName', sort: 1},
                {name: 'city', sort: 0},
                {name: 'state', sort: 0}
            ];

        if (!this.options.isSingleChoice) {
            this.selectedProjects = [];
        }

        this.collection = new PJQ.collections.projects.Projects();
        this.listenTo(this.collection, 'sync', this.render);
        this.collection.fetch();
    },
    afterRender: function () {
        let order = null;
        _.each(this.options.dataTableColumns, _.bind(function (column, index) {
            if (column.sort !== 0)
                order = [index + 1, column.sort === 1 ? 'asc' : 'desc'];
        }, this));

        this.dataTable = new PJQ.views.projects.ProjectSelectorDataTable({
            el: '.projects-data-table-container',
            data: _.filter(this.collection.models, _.bind(function (model) {
                return this.options.excludeProjectIds.indexOf(model.id) === -1
            }, this)),
            columns: this.getColumns(),
            order: order,
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Selector')
            },
            headerData: this.options.dataTableHeaderData
        });
    },
    getColumns: function () {
        let columns = [
            {
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-project"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            }
        ];

        _.each(this.options.dataTableColumns, _.bind(function (column, index) {

            switch (column.name) {
                case 'projectId':
                    columns.push({
                        "data": "attributes.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "data": "attributes.projectName",
                        "title": "Project Name"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'created':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return new Date(row.attributes.created);
                            },
                            "filter": "attributes.created",
                            "display": function (row) {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                            }
                        },
                        "title": "Created"
                    });
                    break;
                case 'bidsdue':
                    let responseDueLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due";
                    columns.push({
                        "data": {
                            "_": function (row) {

                                let dateTemp = new Date();
                                if (row.attributes.bidsDue == null)
                                    return dateTemp.addDays(-20000);
                                if (row.attributes.rDueText === 'ASAP')
                                    return dateTemp.addDays(-10000);

                                return new Date(row.attributes.bidsDue);
                            },
                            "filter": "attributes.bidsDue",
                            "display": function (row) {
                                if (row.attributes.bidsDue == null)
                                    return "N/A";
                                if (row.attributes.rDueText === 'ASAP')
                                    return row.attributes.rDueText;

                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }
                        },
                        "title": responseDueLabel
                    });
                    break;
                case 'userDisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : "Project Contact"
                    });
                    break;
                case 'user2DisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : "Project Contact 2"
                    });
                    break;
            }
        }, this));

        return columns;
    },
    selectProject: function (e) {
        let target = $(e.currentTarget),
            project = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-project').not(target).text('Select').prop('checked', false); //.removeClass('btn-primary').addClass('btn-secondary');
            if (project.get('isSelected')) {
                project.set('isSelected', false);
                this.selectedProject = null;
            } else {
                project.set('isSelected', true);
                this.selectedProject = project;
                this.collection.get(project.id);
                _.each(this.collection.models, _.bind(function (dtProject) {
                    if (project.id !== dtProject.id)
                        dtProject.set('isSelected', false);
                }, this));
            }
            this.options.onProjectSelected(this.selectedProject);
        } else {
            if (project.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                project.set('isSelected', false);
                this.selectedProjects = _.reject(this.selectedProjects, function (selProject) {
                    return selProject.id === project.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                project.set('isSelected', true);
                this.selectedProjects.push(project);
            }
            this.options.onProjectSelected(this.selectedProjects);
        }
    }
});

PJQ.views.projects.PublicProjects = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Public-Projects-Note')
    },
    events: {
        'click .project-header': 'projectClicked'
    },
    beforeFirstRender: function () {
        //this is an app route, make sure the session is fetched
        if (!PJQ.app.session.isFetched) {
            PJQ.app.session.fetch();
        }

        this.collection = new PJQ.collections.projects.Projects([], {
            isBidding: true
        });
        this.collection.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        })
    },
    renderData: function () {

        return {
            collection: this.collection,
            emptyMessage: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PUBLIC_PROJECTS_EMPTY_MESSAGE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PUBLIC_PROJECTS_EMPTY_MESSAGE) : "There currently aren't any public projects"
        };
    },
    projectClicked: function (e) {
        let cid = $(e.currentTarget).data('cid'),
            project = this.collection.get(cid);
        this.goToProject(project);
    },
    goToProject: function (project) {
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PUBLIC_PROJECTS_REQ_REG)) {
            let regTabId = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.REGISTRATION_TAB_ID);
            window.location.href = window.location.origin + '/Default.aspx?tabid=' + regTabId.toString() + '&subselfreg=1';
        } else {
            PJQ.helpers.projectHelpers.accessKeyNavigate(project.get('accessKey'), _.bind(function (err) {
                if (err != null) {
                    this.renderError(err);
                }
            }, this));
        }
    }
});

PJQ.views.projects.BlueBookPublishModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Blue-Book-Publish'),
        subTemplates: {
            dodgeTooltip: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'dodge-details-tooltip')
        },
        maxWidth: '800px',
        onAccept: null
    },
    events: {
        'click .btn-publish': 'publish'
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    beforeRender: function () {
        if (this.model == null) {
            let user = PJQ.app.session.user;
            user.fetch({
                success: _.bind(function () {
                    this.model = new PJQ.models.projects.BlueBookProject({
                        project: this.options.project,
                        user: user
                    });
                    this.model.fetch({
                        success: _.bind(function () {
                            this.render();
                        }, this)
                    });
                }, this)
            });
        }
    },
    afterRender: function () {
        if (this.model == null) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.Tooltip(this.$('.dda-details'), {
            template: this.options.subTemplates.dodgeTooltip,
            container: this.$el,
            placement: 'right',
            trigger: 'click',
            renderData: _.bind(function () {
                return {};
            }, this)
        });

        let statePicker = new PJQ.inputs.StatePicker({
            el: this.$('.contact-state'),
            defaultValue: this.model.get('contactState') ? this.model.get('contactState').toUpperCase() : null,
            country: this.model.get('contactCountry') ? this.model.get('contactCountry').toUpperCase() : null,
            onChange: _.bind(function (value) {
                this.model.set('contactState', value);
            }, this)
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('.contact-country'),
            defaultValue: this.model.get('contactCountry') ? this.model.get('contactCountry').toUpperCase() : null,
            statePicker: statePicker,
            zipInput: this.$('.contact-zip'),
            onChange: _.bind(function (value) {
                this.model.set('contactCountry', value);
            }, this)
        });

        let projectStatePicker = new PJQ.inputs.StatePicker({
            el: this.$('.project-state'),
            country: this.model.get('projectCountry') ? this.model.get('projectCountry').toUpperCase() : null,
            defaultValue: this.model.get('projectState') ? this.model.get('projectState').toUpperCase() : null,
            onChange: _.bind(function (value) {
                this.model.set('projectState', value);
            }, this)
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('.project-country'),
            defaultValue: this.model.get('projectCountry') ? this.model.get('projectCountry').toUpperCase() : null,
            statePicker: projectStatePicker,
            zipInput: this.$('.project-zip'),
            onChange: _.bind(function (value) {
                this.model.set('projectCountry', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.project-role'),
            defaultValue: this.model.get('projectRole'),
            onChange: _.bind(function (value) {
                this.model.set('projectRole', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.project-type'),
            defaultValue: this.model.get('projectType'),
            onChange: _.bind(function (value) {
                this.model.set('projectType', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.input-labor-status'),
            isMultiple: true,
            defaultValue: this.model.get('laborStatus'),
            onChange: _.bind(function (value) {
                this.model.set('laborStatus', value);
            }, this)
        });

        this.model.project.fetchGroups(_.bind(function (projectGroups) {
            this.model.set('groups', projectGroups.models);
            this.groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.group-selector'),
                selectedGroups: projectGroups,
                onGroupSelected: _.bind(function () {
                    this.model.set('groups', this.groupSelector.getGroupsData().selected);
                }, this)
            });
        }, this));

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-contact-phone'));

        new PJQ.inputs.Datepicker({
            el: this.$('.input-bids-due'),
            datepickerOptions: {
                defaultDate: this.model.get('bidsDue'),
            },
            onChange: _.bind(function (newTime) {
                this.model.set('bidsDue', newTime);
            }, this)
        });
    },
    publish: function () {
        let $err = this.$('.error-container');
        if (_.size(this.model.get('groups')) === 0) {
            this.groupSelector.showError('You must select at least 1 trade');
            $err.removeClass('hidden');
            return;
        }

        // let dodgeEnabled = $("input[type=radio][name=dodge]:checked").val();
        // if (dodgeEnabled == null) {
        //     this.$('.dodge-div').addClass('alert-danger');
        //     $err.removeClass('hidden');
        //     return;
        // }
        // this.model.set('includeDodge', dodgeEnabled.toLowerCase() === 'true' ? true : false);
        // this.$('.dodge-div').removeClass('alert-danger');
        $err.addClass('hidden');
        this.groupSelector.hideError();

        let loader = new PJQ.Loader(this.$('.btn-publish'), {
            loadingText: "Publishing..."
        });
        this.model.save(null, {
            success: _.bind(function () {
                this.removeModal();
                PJQ.notifications.notify.successNotify({
                    message: 'Project Published to The Blue Book'
                });
            }, this),
            error: _.bind(function () {
                loader.remove();
                PJQ.notifications.notify.successNotify({
                    message: 'Failed to publish to the blue book.  Please try again in a few minutes'
                });
            }, this)
        });
    }
});

PJQ.models.projects.BlueBookProject = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.project.id
            },
            {
                endpoint: 'bluebook'
            }
        ]);
    },
    parse: function (model) {
        if (model) {
            if (model.user != null) {
                model.companyName = model.user.get('companyName');
                model.contactName = model.user.get('contactName');
                model.contactAddress = (_.size(model.user.get('address1')) > 0 ? model.user.get('address1') + " " : "") + (model.user.get('address2') != null ? model.user.get('address2') : "");
                model.contactCity = model.user.get('city');
                model.contactState = model.user.get('state');
                model.contactZip = model.user.get('zip');
                model.contactCountry = model.user.get('country');
                model.contactPhone = model.user.get('phone');
                model.contactEmail = model.user.get('email');
            }

            if (model.project != null) {
                this.project = model.project;
                model.projectRole = 'General Contractor - Bidding';
                model.projectName = model.project.get('projectName');
                model.projectAddress = (_.size(model.project.get('address1')) > 0 ? model.project.get('address1') + " " : "") + (model.project.get('address2') != null ? model.project.get('address2') : "");
                model.projectCity = model.project.get('city');
                model.projectState = model.project.get('state');
                model.projectZip = model.project.get('zip');
                model.projectCountry = model.project.get('country');
                model.bidsDue = model.project.get('bidsDue');
            }

            if (model.contactNameOverride !== null)
                model.contactName = model.contactNameOverride;

            if (model.emailOverride !== null)
                model.contactEmail = model.emailOverride;
        }
        return model;
    }
});

PJQ.views.projects.UploadParticipantBidDocumentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Upload-Participant-Bid-Docs'),
        minWidth: '500px',
        onSave: _.noop,
        contact: null
    },
    events: {
        'click .save-attachments': 'onSave'
    },
    beforeRender: function () {
        this.renderData = {
            contact: this.options.contact
        };
    },
    afterRender: function () {
        this.uploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.uploader')
        });
    },
    onSave: function () {
        if (this.uploader.collection.length === 0)
            return;

        // construct endpoint and post folder accordingly
        let postData = {
            attachments: this.uploader.collection.toJSON()
        };

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'participants',
                value: this.options.contact.get('contactId')
            },
            {
                endpoint: 'bids'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: postData,
            isApi2: true
        }).post().done(_.bind(function (response) {
            if (typeof this.options.onSave === 'function') {
                this.options.onSave(response);
            }

            PJQ.notifications.notify.successNotify({
                message: 'Bid documents uploaded successfully.'
            });
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });

        this.removeModal();
    }
});

//Collections
PJQ.collections.projects.Scopes = PJQ.collections.BaseCollection.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'scopes'
            }
        ])
    }
});

//Views
PJQ.views.projectScopes = {};
PJQ.views.projectScopes.CopyScopesFromProjectModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Copy-Scopes-From-Project'),
        maxWidth: '725px',
        onCancel: _.noop,
        onCopy: _.noop
    },
    events: {
        "click .copy-scopes-cancel": "onCancel",
        "click .copy-scopes-save": "onCopy",
    },
    beforeRender: function () {
        this.renderData = {
        }
    },
    afterRender: function () {
        new PJQ.views.projects.ProjectSelector({
            el: this.$('.project-selector'),
            excludeProjectIds: [PJQ.app.session.project.id],
            isSingleChoice: true,
            onProjectSelected: _.bind(function (projects) {
                this.selectedProject = projects;
                this.$('.copy-scopes-save').prop('disabled', _.size(this.selectedProject) === 0 || !this.selectedProject.get('isSelected'));
            }, this),
            dataTableHeaderData: {
                isHideDeletedFilter: true
            },
            dataTableColumns: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.COPY_SCOPES_GRID_LAYOUT) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.COPY_SCOPES_GRID_LAYOUT) : null
        });
    },
    onCancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
        }
        this.removeModal();
    },
    onCopy: function () {
        if (typeof this.options.onCopy === 'function') {
            this.options.onCopy(this.selectedProject);
        }
        this.removeModal();
    }
});
//Models
PJQ.models.projectStatuses = {};
PJQ.models.projectStatuses.ProjectStatus = PJQ.models.BaseModel.extend({
    idAttribute: 'projectStatusId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'statuses',
                value: this.id < 0 ? -this.id : this.id
            }
        ])
    }
});

//Collections
PJQ.collections.projectStatuses = {};
PJQ.collections.projectStatuses.ProjectStatuses = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.projectStatuses.ProjectStatus,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'statuses'
            }
        ])
    },
    getDefault: function () {
        return _.find(this.models, function (model) {
            return model.get('isDefault');
        });
    },
    copy: function(callback){
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'statuses'
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (projectStatuses) {
            this.reset(projectStatuses);
            callback();
        }, this));
    }
});

PJQ.models.rawFileUploads = {};

PJQ.models.rawFileUploads.RawFileUpload = PJQ.models.BaseModel.extend({
    idAttribute: 'rawFileUploadId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'rawfileuploads',
                value: this.id
            }
        ]);
    }
});

PJQ.views.contacts.Register = PJQ.views.contacts.BaseEditContactView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'register'),
		detectGroupLevels: true,
		canEdit: true
	},
	events: {
		"change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
		"keydown .contact-edit-phone-ext": "numbersOnly",
		"click .btn-continue": "register"
	},
	beforeFirstRender: function () {
		if (PJQ.app.session.contact != null) {
			this.model = PJQ.app.session.contact;
		}

		if (PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
			if (this.model != null) {
				this.options.masterUserId = this.model.get('masterUserId');
			}
			else {
				this.options.masterUserId = PJQ.constants.publicUserId;
			}

			if (this.model.get('masterUserId') === PJQ.constants.publicUserId) {
				this.options.fieldSettingsEnabled = true;
				PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS, true);
			}
		}
		else if (PJQ.app.session.preferences.hasPref('portalOwner')) {
			this.options.masterUserId = PJQ.app.session.preferences.getPref('portalOwner');
		}

		return PJQ.views.contacts.BaseEditContactView.prototype.beforeFirstRender.call(this);
	},
	register: function () {
		let validate = this.validateCoreFields(),
			$scrollTo = validate.$scrollTo;

		if (!validate.valid) {
			new PJQ.Alert(this.$('.validation-error'), {
				type: 'danger',
				text: 'Required fields are empty or have an incorrect value'
			});

			if (_.size($scrollTo) > 0) {
				this.scrollTo($scrollTo.offset().top);
			}
		}
		else if (validate.valid) {
			if (this.groupSelector != null) {
				this.model.groups.reset(this.groupSelector.getGroupsData().all);
			}
			this.model.set('companyCustomFieldValues', this.companyCustomFieldsForm != null ? this.companyCustomFieldsForm.getChanged() : null);
			this.model.set('contactCustomFieldValues', this.contactCustomFieldsForm != null ? this.contactCustomFieldsForm.getChanged() : null);
			this.model.set({
				groups: _.map(this.model.groups.models, function (group) {
					return {
						groupId: group.id,
						isDeleted: group.get('isDeleted')
					}
				})
			});
			this.model.set({
				workAreas: _.map(this.model.workAreas.models, function (workArea) {
					return {
						contactWorkAreaId: workArea.id,
						workAreaId: workArea.get('workAreaId'),
						isDeleted: workArea.get('isDeleted')
					}
				})
			});
			new PJQ.ajax.Request({
				endpoint: '/contacts/register',
				data: this.model
			}).post().done(_.bind(function (response) {
				if (this.model.isNew() && response.id > 0) {
					this.model.set('contactId', response.id);
					this.model.set('contactCompanyId', response.contactCompanyId);
					this.model.set('userId', response.userId);
					PJQ.app.session.contact = this.model;
				}

				if (PJQ.app.session.user != null) {
					PJQ.app.router.navigate('/', {
						trigger: true
					});
				}
				else if (this.model.get('userId') > 0) {
					new PJQ.views.contacts.RegisterAuth({
						el: PJQ.app.$el,
						mode: 'SIGN_IN'
					});
				}
				else {
					new PJQ.views.contacts.RegisterAuth({
						el: PJQ.app.$el,
						mode: 'SIGN_UP'
					});
				}
			}, this));
		}
	}
});

PJQ.views.contacts.RegisterAuth = PJQ.views.auth.Auth.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'register-auth'),
		routeToRoot: true
	},
	renderResetPassword: function () {
		new PJQ.views.auth.RequestResetPasswordModal();
	}
})

PJQ.modules.register = {
	routes: [
		{
			route: 'register',
			title: 'Register',
			name: 'register',
			callback: function () {
				if ((PJQ.app.session.user != null && PJQ.app.session.contact == null) || PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId) {
					PJQ.app.router.routeToRoot();
				}
				else {
					new PJQ.views.contacts.Register({
						el: PJQ.app.$el
					});
				}
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.register.routes);

//Views
PJQ.views.reporting = {};
//This will be remade into a right bar menu when the project wall is redesigned
//Right now (1/22/2019) a left bar doesnt work with the design of the project wall
PJQ.views.reporting.GenerateReportModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Generate-Report'),
		subTemplates: {
			reportOption: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Generate-Report-Option'),
		},
		onDownload: null
	},
	events: {
		'click .modal-report-download': 'onDownload'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		_.each(this.model.get('options'), _.bind(function (option) {
			this.renderSubTemplate(true, this.options.subTemplates.reportOption, this.$('.report-options-outer'), {
				option: option
			}, function (content) {
				switch (option.type) {
					case 'DATE_RANGE':
						new PJQ.inputs.Datepicker({
							el: content.find('.input-date-from'),
							datepickerOptions: {
								defaultDate: option.defaultValue ? option.defaultValue.from : null,
								format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
							},
							onChange: function (value) {
								if (typeof option.value !== 'object') {
									option.value = {};
								}
								option.value.from = value;
							}
						});
						new PJQ.inputs.Datepicker({
							el: content.find('.input-date-to'),
							datepickerOptions: {
								defaultDate: option.defaultValue ? option.defaultValue.to : null,
								format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
							},
							onChange: function (value) {
								if (typeof option.value !== 'object') {
									option.value = {};
								}
								option.value.to = value;
							}
						});
						break;
				}
			});
		}, this));
	},
	onDownload: function () {
		let isValid = true;
		_.each(this.model.get('options'), _.bind(function (option) {
			if (option.isRequired) {
				let isOptionValid = true;
				switch (option.type) {
					case 'DATE_RANGE':
						let to = (option.value != null ? option.value.to : null),
							from = (option.value != null ? option.value.from : null),
							isToValid = (to != null && from < to),
							isFromValid = (from != null && from < to);
						PJQ.helpers.inputHelpers.setInputError(this.$('.input-date-from[data-cid="' + option.id + '"]'), isFromValid);
						PJQ.helpers.inputHelpers.setInputError(this.$('.input-date-to[data-cid="' + option.id + '"]'), isToValid);
						isOptionValid = (isFromValid && isToValid);
						break;
				}

				if (!isOptionValid) {
					isValid = false;
				}
			}
		}, this));
		if (isValid && typeof this.options.onDownload === 'function') {
			let loader = new PJQ.Loader(this.$('.modal-content'));
			this.options.onDownload(this.model.get('options'), _.bind(function(){
				loader.remove();
				this.removeModal();
			}, this));
		}
	}
});

//Models
PJQ.models.reporting = {};
PJQ.models.reporting.Report = PJQ.models.BaseModel.extend({
	idAttribute: 'reportId',
	endpoint: function () {

	},
	parse: function (model) {
		return model;
	},
	generate: function(data, callback = null){
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'reports'
			},
			{
				endpoint: 'js'
			}
		]);
		PJQ.files.queueDownload(endpoint, {
			data: data,
			templateName: this.get('name'),
			filename: _.size(this.get('fileName')) > 0 ? this.get('fileName').replace('.', '') : 'export'
		}, function(){
			if(typeof callback === 'function'){
				callback();
			}
		}, true);
	}
});

PJQ.Resizable = class {
    constructor($el, options = {}) {
        let self = this;
        self.$el = $el;
        self.options = _.defaults(options, {
            addClasses: "selected",
            stop: function () {
                self.onStop();
            }
        });
        if (_.size(self.$el) > 0) {
            self.$el.resizable(self.options);
        }
    }

    onStop() {
        if (typeof this.options.onStop === 'function') {
            this.options.onStop();
        }
    }
};
PJQ.models.sessions = {};
PJQ.models.sessions.Session = PJQ.models.BaseModel.extend({
    idAttribute: 'sessionId',
    endpoint: '/session',
    coreFields: {
        contact: {},
        user: {}
    },
    customFields: {
        company: {},
        contact: {},
        project: {},
        actionItems: {},
        punchList: {},
        rfi: {},
        primeContracts: {},
        payableInvoices: {},
        receivableInvoices: {},
        schedule: {},
        submittals: {},
        user: {},
        meetings: {}
    },
    groups: {},
    data: {
        dailyReports: {
            templates: null
        }
    },
    fetch(opts) {
        if (1 === 2) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'token'
                    }
                ]),
                isAPIv2: true
            }).get().done(_.bind(_.bind(function (data) {
                this.set('accessToken', data.access_token);
            }, this)));
        }
        return PJQ.models.BaseModel.prototype.fetch.call(this, opts);
    },
    parse: function (model) {
        if (model && _.size(model) > 0) {
            if (this.preferences && model.preferences != null) {
                this.preferences.set(model.preferences);
                this.preferences.parse(model.preferences);
            } else if (model.preferences != null) {
                if (model.preferences instanceof PJQ.models.preferences.Preferences)
                    this.preferences = model.preferences;
                else
                    this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
            } else {
                this.preferences = new PJQ.models.preferences.Preferences();
            }

            this.subscription = new PJQ.models.subscriptions.Subscription(model.subscription);

            if (model.systemPermissions != null) {
                this.systemPermissions = new PJQ.models.permissions.SystemPermissions(model.systemPermissions);
            } else {
                this.systemPermissions = null;
            }

            if (this.userTypes != null && model.userTypes != null) {
                this.userTypes.reset(model.userTypes);
            } else if (model.userTypes != null) {
                if (model.userTypes instanceof PJQ.collections.userTypes.UserTypes)
                    this.userTypes = model.userTypes;
                else
                    this.userTypes = new PJQ.collections.users.Users(model.userTypes);
            } else {
                this.userTypes = new PJQ.collections.userTypes.UserTypes();
            }

            if (this.project != null && model.project != null) {
                this.project.set(model.project);
                this.project.parse(model.project);
            } else if (model.project != null) {
                if (model.project instanceof PJQ.models.projects.Project)
                    this.project = model.project;
                else
                    this.project = new PJQ.models.projects.Project(model.project);
            } else {
                this.project = null;
            }

            if (this.contact != null && model.contact != null) {
                this.contact.set(model.contact);
                this.contact.parse(model.contact);
            } else if (model.contact != null) {
                if (model.contact instanceof PJQ.models.contacts.Contact)
                    this.contact = model.contact;
                else
                    this.contact = new PJQ.models.contacts.Contact(model.contact);
            } else {
                this.contact = null;
            }

            if (this.user != null && model.user != null) {
                this.user.set(model.user);
                this.user.parse(model.user);
            } else if (model.user != null) {
                if (model.user instanceof PJQ.models.users.User)
                    this.user = model.user;
                else
                    this.user = new PJQ.models.users.User(model.user);
            } else {
                this.user = null;
            }

            if (this.users != null && model.users != null) {
                this.users.reset(model.users);
            } else if (model.users != null) {
                if (model.users instanceof PJQ.collections.users.Users)
                    this.users = model.users;
                else
                    this.users = new PJQ.collections.users.Users(model.users);
            } else {
                this.users = new PJQ.collections.users.Users();
            }

            this.emailTemplates = {};
            this.emailTemplates.projectMessage = null;
        } else {
            this.systemPermissions = null;
            this.preferences = new PJQ.models.preferences.Preferences();
            this.project = null;
            this.contact = null;
            this.user = null;
            this.users = new PJQ.collections.users.Users();
            this.userTypes = new PJQ.collections.userTypes.UserTypes();
            this.emailTemplates = {};
            this.emailTemplates.projectMessage = null;
        }
        return model;
    },
    joinDirectory: function (callback) {
        let hasContact = this.contact != null;
        if ((!hasContact || this.contact.get('isBlacklisted')) && this.user != null) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users'
                    },
                    {
                        endpoint: 'joindirectory'
                    }
                ])
            }).post().done(_.bind(function (contact) {
                this.contact = new PJQ.models.contacts.Contact(contact);
                if (PJQ.app.navigator != null) {
                    PJQ.app.navigator.refreshCommands();
                }
                PJQ.notifications.notify.successNotify({
                    message: 'You have ' + (hasContact ? 'activated' : 'joined') + ' the Pantera contractor directory'
                });
                if (typeof callback === 'function') {
                    callback();
                }
            }, this));
        }
    },
    leaveDirectory: function (callback) {
        if (this.contact != null && this.user != null) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users'
                    },
                    {
                        endpoint: 'leavedirectory'
                    }
                ])
            }).post().done(_.bind(function (contact) {
                this.contact.set('isBlacklisted', true);
                if (PJQ.app.navigator != null) {
                    PJQ.app.navigator.refreshCommands();
                }
                PJQ.notifications.notify.successNotify({
                    message: 'You have de-activated the Pantera contractor directory'
                });
                if (typeof callback === 'function') {
                    callback();
                }
            }, this));
        }
    },
    isPanteraPortal: function () {
        return this.get('portalId') === 4;
    },
    hasPermission: function (permission, options = {}) {
        if (this.systemPermissions == null) {
            return false;
        }
        return this.systemPermissions.hasPermission(permission, options);
    },
    fetchERPIntegration: function (callback = null) {
        return new Promise((resolve, reject) => {
            let cb = (erp) => {
                if (typeof callback === 'function') {
                    callback(erp);
                }
                resolve(erp);
            }

            if (PJQ.app.session.user == null || (PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId && !PJQ.app.session.get('ownsPortal'))) {
                cb(null);
                return;
            }

            if (this.erpIntegration != null) {
                cb(this.erpIntegration);
                return;
            }

            if (this.integrations != null) {
                this.erpIntegration = this.integrations.findWhere({erp: true});
                if (this.erpIntegration != null) {
                    cb(this.erpIntegration);
                    return;
                }
            }

            let eInt = new PJQ.integrations.models.Integration({}, {
                erp: true
            });
            eInt.fetch({
                success: () => {
                    if (eInt.id > 0) {
                        this.erpIntegration = eInt;
                    }

                    cb(this.erpIntegration);
                },
                error: () => {
                    cb(null);
                    reject(new Error("Failed to fetch erp integration"));
                }
            });
        });
    },
    fetchIntegrations: function (callback) {
        if (this.integrations == null) {
            this.integrations = new PJQ.integrations.collections.Integrations();
            this.integrations.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.integrations);
                    }
                }, this)
            });
        } else {
            callback(this.integrations);
        }
    },
    fetchUserLimits: function (callback) {
        if (this.userLimits == null) {
            this.userLimits = new PJQ.models.companies.UserLimits();
            this.userLimits.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.userLimits);
                    }
                }, this)
            });
        } else {
            callback(this.userLimits);
        }
    },
    fetchNDAs: function (callback) {
        if (this.ndas == null) {
            this.ndas = new PJQ.collections.projects.ProjectNDAs(null);
        }

        if (!this.ndas.isFetched) {
            this.ndas.fetch({
                success: _.bind(function () {
                    callback(this.ndas);
                }, this)
            });
        } else {
            callback(this.ndas);
        }
    },
    fetchSystemPermissions: function (callback) {
        this.systemPermissions = new PJQ.models.permissions.SystemPermissions();
        this.systemPermissions.fetch({
            success: _.bind(function () {
                callback(this.systemPermissions);
            }, this)
        });
    },
    fetchBidPackageTemplates: function (callback) {
        if (this.bidPackageTemplates == null) {
            this.bidPackageTemplates = new PJQ.collections.bidPackages.Templates();
            this.bidPackageTemplates.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.bidPackageTemplates);
                    }
                }, this)
            });
        } else {
            callback(this.bidPackageTemplates);
        }
    },
    fetchBidFormTemplates: function (callback) {
        this.bidFormTemplates = new PJQ.collections.bidForms.Templates();
        this.bidFormTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.bidFormTemplates);
                }
            }, this)
        });
    },
    fetchBidFormSettings: function (callback) {
        if (this.bidFormSettings == null) {
            this.bidFormSettings = new PJQ.models.bidForms.Settings();
            this.bidFormSettings.fetch({
                success: _.bind(function () {
                    callback(this.bidFormSettings);
                }, this)
            });
        } else {
            callback(this.bidFormSettings);
        }
    },
    fetchUnitsOfMeasure: function (callback) {
        if (this.unitsOfMeasure == null) {
            this.unitsOfMeasure = new PJQ.collections.budget.UnitsOfMeasure();
            this.unitsOfMeasure.fetch({
                success: _.bind(function () {
                    callback(this.unitsOfMeasure);
                }, this)
            })
        } else {
            callback(this.unitsOfMeasure);
        }
    },
    fetchCostCodes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.costCodes != null) {
                if (typeof callback === 'function') {
                    callback(this.costCodes);
                }
                resolve(this.costCodes);
                return;
            }

            this.costCodes = new PJQ.collections.budget.CostCodes();
            this.costCodes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.costCodes);
                    }
                    resolve(this.costCodes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost codes"));
                }
            });
        });
    },
    fetchCostTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.costTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.costTypes);
                }
                resolve(this.costTypes);
                return;
            }

            this.costTypes = new PJQ.collections.budget.CostTypes();
            this.costTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.costTypes);
                    }
                    resolve(this.costTypes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost types"));
                }
            })
        });
    },
    fetchTaxCodes: function (callback, force) {
        if (this.taxCodes == null || force) {
            this.taxCodes = new PJQ.collections.budget.TaxCodes();
            this.taxCodes.fetch({
                success: _.bind(function () {
                    callback(this.taxCodes);
                }, this)
            })
        } else {
            callback(this.taxCodes);
        }
    },
    fetchInspectionTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionTypes);
                }
                resolve(this.inspectionTypes);
                return;
            }

            this.inspectionTypes = new PJQ.collections.inspections.Types();
            this.inspectionTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.inspectionTypes);
                    }
                    resolve(this.inspectionTypes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch inspection types"));
                }
            })
        });
    },
    fetchInspectionResponseTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionResponseTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionResponseTypes);
                }
                resolve(this.inspectionResponseTypes);
                return;
            }

            this.inspectionResponseTypes = new PJQ.collections.inspections.ResponseTypes();
            this.inspectionResponseTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.inspectionResponseTypes);
                    }
                    resolve(this.inspectionResponseTypes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch inspection response types"));
                }
            })
        });
    },
    fetchInspectionUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionUserSettings);
                }
                resolve(this.inspectionUserSettings);
                return;
            }

            this.inspectionUserSettings = new PJQ.models.inspections.UserSettings();
            this.inspectionUserSettings.fetch({
                success: () => {
                    resolve(this.inspectionUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.inspectionUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch inspection user settings"));
                }
            });
        });
    },
    fetchRFISettings: function (callback) {
        if (this.rfiSettings == null) {
            this.rfiSettings = new PJQ.models.rfi.Settings();
            this.rfiSettings.fetch({
                success: _.bind(function () {
                    callback(this.rfiSettings);
                }, this)
            });
        } else {
            callback(this.rfiSettings);
        }
    },
    fetchPlanRoomSettings: function (callback) {
        if (this.planRoomSettings == null) {
            this.planRoomSettings = new PJQ.models.settings.PlanRoomSettings();
            this.planRoomSettings.fetch({
                success: _.bind(function () {
                    callback(this.planRoomSettings);
                }, this)
            });
        } else {
            callback(this.planRoomSettings);
        }
    },
    fetchOrderingSettings: function (callback) {
        if (this.orderingSettings == null) {
            this.orderingSettings = new PJQ.models.settings.OrderingSettings();
            this.orderingSettings.fetch({
                success: _.bind(function () {
                    callback(this.orderingSettings);
                }, this)
            });
        } else {
            callback(this.orderingSettings);
        }
    },
    fetchAddressBookSettings: function (callback) {
        if (this.addressBookSettings == null) {
            this.addressBookSettings = new PJQ.models.settings.AddressBookSettings();
            this.addressBookSettings.fetch({
                success: _.bind(function () {
                    callback(this.addressBookSettings);
                }, this)
            });
        } else {
            callback(this.addressBookSettings);
        }
    },
    fetchActionItemCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.actionItems[masterUserId] == null) {
                this.customFields.actionItems[masterUserId] = new PJQ.collections.actionItems.ActionItemCustomField(null, {
                    masterUserId: masterUserId
                });
                this.customFields.actionItems[masterUserId].fetch({
                    success: () => {
                        resolve(this.customFields.actionItems[masterUserId]);
                        if (typeof callback === 'function') {
                            callback(this.customFields.actionItems[masterUserId]);
                        }
                    },
                    error: () => {
                        reject(new Error("Failed to fetch action item field settings"));
                    }
                })
            } else {
                resolve(this.customFields.actionItems[masterUserId]);
                if (typeof callback === 'function') {
                    callback(this.customFields.actionItems[masterUserId]);
                }
            }
        });
    },
    fetchPunchListCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.punchList[masterUserId] == null) {
                this.customFields.punchList[masterUserId] = new PJQ.collections.punchlists.PunchlistCustomFields(null, {
                    masterUserId: masterUserId
                });
                this.customFields.punchList[masterUserId].fetch({
                    success: () => {
                        resolve(this.customFields.punchList[masterUserId]);
                        if (typeof callback === 'function') {
                            callback(this.customFields.punchList[masterUserId]);
                        }
                    },
                    error: () => {
                        reject(new Error("Failed to fetch contract field settings"));

                        if (typeof callback === 'function') {
                            callback(this.customFields.punchList[masterUserId]);
                        }
                    }
                })
            } else {
                resolve(this.customFields.punchList[masterUserId]);
                if (typeof callback === 'function') {
                    callback(this.customFields.punchList[masterUserId]);
                }
            }
        });
    },
    fetchMeetingCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.meetings[masterUserId] == null) {
                this.customFields.meetings[masterUserId] = new PJQ.collections.meetings.CustomFields(null, {
                    masterUserId: masterUserId
                });
                this.customFields.meetings[masterUserId].fetch({
                    success: () => {
                        resolve(this.customFields.meetings[masterUserId]);
                        if (typeof callback === 'function') {
                            callback(this.customFields.meetings[masterUserId]);
                        }
                    },
                    error: () => {
                        reject(new Error("Failed to fetch contract field settings"));
                    }
                })
            } else {
                resolve(this.customFields.meetings[masterUserId]);
                if (typeof callback === 'function') {
                    callback(this.customFields.meetings[masterUserId]);
                }
            }
        });
    },
    fetchRFICustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.rfi[masterUserId] == null) {
            this.customFields.rfi[masterUserId] = new PJQ.collections.rfi.CustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.rfi[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.rfi[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.rfi[masterUserId]);
            }
        }
    },
    fetchContactFieldSettings(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.coreFields.contact[masterUserId] == null) {
            this.coreFields.contact[masterUserId] = new PJQ.collections.contacts.ContactFieldSettings(null, {
                masterUserId: masterUserId
            });
            this.coreFields.contact[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.coreFields.contact[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.coreFields.contact[masterUserId]);
            }
        }
    },
    fetchUserFieldSettings(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.coreFields.user[masterUserId] == null) {
            this.coreFields.user[masterUserId] = new PJQ.collections.users.UserFieldSettings(null, {
                masterUserId: masterUserId
            });
            this.coreFields.user[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.coreFields.user[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.coreFields.user[masterUserId]);
            }
        }
    },
    fetchPrimeContractFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractFieldSettings);
                }
                resolve(this.primeContractFieldSettings);
                return;
            }

            this.primeContractFieldSettings = new PJQ.collections.primeContracts.FieldSettings();
            this.primeContractFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract field settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderFieldSettings);
                }
                resolve(this.primeContractChangeOrderFieldSettings);
                return;
            }

            this.primeContractChangeOrderFieldSettings = new PJQ.collections.primeContracts.ChangeOrderFieldSettings();
            this.primeContractChangeOrderFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order field settings"));
                }
            });
        });
    },
    fetchReceivableInvoiceFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceFieldSettings);
                }
                resolve(this.receivableInvoiceFieldSettings);
                return;
            }

            this.receivableInvoiceFieldSettings = new PJQ.collections.invoicing.ReceivableInvoiceFieldSettings();
            this.receivableInvoiceFieldSettings.fetch({
                success: () => {
                    resolve(this.receivableInvoiceFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice field settings"));
                }
            });
        });
    },
    fetchCommitmentFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentFieldSettings);
                }
                resolve(this.commitmentFieldSettings);
                return;
            }

            this.commitmentFieldSettings = new PJQ.collections.commitments.FieldSettings();
            this.commitmentFieldSettings.fetch({
                success: () => {
                    resolve(this.commitmentFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.commitmentFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment field settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderFieldSettings);
                }
                resolve(this.commitmentChangeOrderFieldSettings);
                return;
            }

            this.commitmentChangeOrderFieldSettings = new PJQ.collections.commitments.ChangeOrderFieldSettings();
            this.commitmentChangeOrderFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderFieldSettings);
                    }

                    resolve(this.commitmentChangeOrderFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order field settings"));
                }
            });
        });
    },
    fetchPayableInvoiceFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceFieldSettings);
                }
                resolve(this.payableInvoiceFieldSettings);
                return;
            }

            this.payableInvoiceFieldSettings = new PJQ.collections.invoicing.PayableInvoiceFieldSettings();
            this.payableInvoiceFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceFieldSettings);
                    }

                    resolve(this.payableInvoiceFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice field settings"));
                }
            });
        });
    },
    fetchDirectCostFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostFieldSettings);
                }
                resolve(this.directCostFieldSettings);
                return;
            }

            this.directCostFieldSettings = new PJQ.collections.directcosts.DirectCostFieldSettings();
            this.directCostFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostFieldSettings);
                    }

                    resolve(this.directCostFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost field settings"));
                }
            });
        });
    },
    fetchContactCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.contact[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.contact[masterUserId]);
                }
                resolve(this.customFields.contact[masterUserId]);
                return;
            }

            this.customFields.contact[masterUserId] = new PJQ.collections.contacts.ContactCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.contact[masterUserId].fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.customFields.contact[masterUserId]);
                    }
                    resolve(this.customFields.contact[masterUserId]);
                }
            })
        });
    },
    fetchPrimeContractCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.primeContracts[masterUserId] == null) {
            this.customFields.primeContracts[masterUserId] = new PJQ.collections.primeContracts.CustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.primeContracts[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.primeContracts[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.primeContracts[masterUserId]);
            }
        }
    },
    fetchPayableInvoiceCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.payableInvoices[masterUserId] == null) {
            this.customFields.payableInvoices[masterUserId] = new PJQ.collections.invoicing.PayableInvoiceCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.payableInvoices[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.payableInvoices[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.payableInvoices[masterUserId]);
            }
        }
    },
    fetchPayableInvoiceUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceUserSettings);
                }
                resolve(this.payableInvoiceUserSettings);
                return;
            }

            this.payableInvoiceUserSettings = new PJQ.models.invoicing.PayableInvoiceUserSettings();
            this.payableInvoiceUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceUserSettings);
                    }

                    resolve(this.payableInvoiceUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice user settings"));
                }
            });
        });
    },
    fetchReceivableInvoiceCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.receivableInvoices[masterUserId] == null) {
            this.customFields.receivableInvoices[masterUserId] = new PJQ.collections.invoicing.ReceivableInvoiceCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.receivableInvoices[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.receivableInvoices[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.receivableInvoices[masterUserId]);
            }
        }
    },
    fetchReceivableInvoiceUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceUserSettings);
                }
                resolve(this.receivableInvoiceUserSettings);
                return;
            }

            this.receivableInvoiceUserSettings = new PJQ.models.invoicing.ReceivableInvoiceUserSettings();
            this.receivableInvoiceUserSettings.fetch({
                success: () => {
                    resolve(this.receivableInvoiceUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice user settings"));
                }
            });
        });
    },
    fetchUserCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.user[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.user[masterUserId]);
                }
                resolve(this.customFields.user[masterUserId]);
                return;
            }

            this.customFields.user[masterUserId] = new PJQ.collections.users.UserCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.user[masterUserId].fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.customFields.user[masterUserId]);
                    }
                    resolve(this.customFields.user[masterUserId]);
                }
            })
        });
    },
    fetchScreeningSettings: function (callback) {
        if (this.screeningSettings == null) {
            this.screeningSettings = new PJQ.models.addressBook.ProqualSettings();
            this.screeningSettings.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.screeningSettings);
                    }
                }, this)
            });
        } else {
            if (typeof callback === 'function') {
                callback(this.screeningSettings);
            }
        }
    },
    fetchSubmittalSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalSettings);
                }
                resolve(this.submittalSettings);
                return;
            }

            this.submittalSettings = new PJQ.models.submittals.Settings();
            this.submittalSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalSettings);
                    }

                    resolve(this.submittalSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal settings"));
                }
            });
        });
    },
    fetchSubmittalUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalUserSettings);
                }
                resolve(this.submittalUserSettings);
                return;
            }

            this.submittalUserSettings = new PJQ.models.submittals.SubmittalUserSettings();
            this.submittalUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalUserSettings);
                    }

                    resolve(this.submittalUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal user settings"));
                }
            });
        });
    },
    fetchSubmittalStatuses: function (refresh, callback) {
        return new Promise((resolve, reject) => {
            if (refresh !== true && this.submittalStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalStatuses);
                }
                resolve(this.submittalStatuses);
                return;
            }

            this.submittalStatuses = new PJQ.collections.submittals.Statuses();
            this.submittalStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalStatuses);
                    }

                    resolve(this.submittalStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal statuses"));
                }
            });
        });
    },
    fetchSubmittalItemTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalItemTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalItemTypes);
                }
                resolve(this.submittalItemTypes);
                return;
            }

            this.submittalItemTypes = new PJQ.collections.submittals.ItemTypes();
            this.submittalItemTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalItemTypes);
                    }

                    resolve(this.submittalItemTypes);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal item types"));
                }
            });
        });
    },
    fetchSubmittalCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.submittals[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.submittals[masterUserId]);
                }
                resolve(this.customFields.submittals[masterUserId]);
                return;
            }

            this.customFields.submittals[masterUserId] = new PJQ.collections.submittals.SubmittalCustomField(null, {
                masterUserId: masterUserId
            });
            this.customFields.submittals[masterUserId].fetch({
                success: () => {
                    resolve(this.customFields.submittals[masterUserId]);
                    if (typeof callback === 'function') {
                        callback(this.customFields.submittals[masterUserId]);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal custom fields"));
                }
            });
        });
    },
    fetchCompanyCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.company[masterUserId] == null) {
            this.customFields.company[masterUserId] = new PJQ.collections.contacts.CompanyCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.company[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.company[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.company[masterUserId]);
            }
        }
    },
    fetchScheduleCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.schedule[masterUserId] == null) {
            this.customFields.schedule[masterUserId] = new PJQ.collections.schedule.ScheduleCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.schedule[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.schedule[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.schedule[masterUserId]);
            }
        }
    },
    fetchUserTypes(callback) {
        if (this.userTypes == null) {
            this.userTypes = new PJQ.collections.userTypes.UserTypes();
        }
        if (!this.userTypes.isFetched) {
            this.userTypes.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.userTypes);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.userTypes);
            }
        }
    },
    fetchProjectStatuses(callback) {
        return new Promise((resolve, reject) => {
            if (this.projectStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.projectStatuses);
                }
                resolve(this.projectStatuses);
                return;
            }

            this.projectStatuses = new PJQ.collections.projectStatuses.ProjectStatuses();
            this.projectStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.projectStatuses);
                    }

                    resolve(this.projectStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch project statuses"));
                }
            });
        });
    },
    fetchProjectCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            let muid = masterUserId > 0 ? masterUserId : PJQ.app.session.get('masterUserId');
            if (this.customFields.project[muid] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.project[muid]);
                }
                resolve(this.customFields.project[muid]);
                return;
            }

            let fields = new PJQ.collections.projects.ProjectCustomFields(null, {masterUserId: muid});
            fields.fetch({
                success: () => {
                    if (muid !== PJQ.app.session.get('masterUserId')) {
                        fields = new PJQ.collections.projects.ProjectCustomFields(_.filter(fields.models, function (customField) {
                            if (customField.get('isVisibleInRSVP'))
                                return customField;
                        }));
                    }

                    this.customFields.project[muid] = fields;
                    if (typeof callback === 'function') {
                        callback(this.customFields.project[muid]);
                    }
                    resolve(this.customFields.project[muid]);
                },
                error: () => {
                    reject(new Error("Failed to fetch project custom fields"));
                }
            })
        });
    },
    fetchScheduleStatuses: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleTaskStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleTaskStatuses);
                }
                resolve(this.scheduleTaskStatuses);
                return;
            }

            this.scheduleTaskStatuses = new PJQ.collections.schedule.TaskStatuses();
            this.scheduleTaskStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleTaskStatuses);
                    }

                    resolve(this.scheduleTaskStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch schedule task statuses"));
                }
            });
        });
    },
    fetchPrequalForm(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.prequalForms == null) {
                this.prequalForms = {};
            }

            if (this.prequalForms[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.prequalForms[masterUserId]);
                }

                resolve(this.prequalForms[masterUserId]);
                return;
            }

            this.prequalForms[masterUserId] = new PJQ.models.prequal.Form({
                masterUserId: masterUserId
            });
            this.prequalForms[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.prequalForms[masterUserId]);
                    }

                    resolve(this.prequalForms[masterUserId]);
                }, this),
                error: () => {
                    reject(new Error("Failed to fetch prequal form"));
                }
            });
        });
    },
    fetchCalendarSettings: function (callback) {
        let fnCallback = _.bind(function () {
            if (typeof callback === 'function') {
                callback(this.calendarSettings);
            }
        }, this);
        if (this.calendarSettings != null) {
            fnCallback();
        } else {
            this.calendarSettings = new PJQ.models.calendars.CalendarSettings();
            this.calendarSettings.fetch({
                success: _.bind(function () {
                    fnCallback();
                }, this)
            });
        }
    },
    fetchScheduleSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleSettings);
                }
                resolve(this.scheduleSettings);
                return;
            }

            this.scheduleSettings = new PJQ.models.schedule.Settings();
            this.scheduleSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleSettings);
                    }
                    resolve(this.scheduleSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch schedule settings"));
                }
            });
        });
    },
    fetchUserGroups(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            let smuid = PJQ.app.session.get('masterUserId');
            if (masterUserId == null || masterUserId === smuid) {
                masterUserId = -1;
            }
            if (this.groups[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.groups[masterUserId]);
                }
                resolve(this.groups[masterUserId]);
                return;
            }

            let groups = new PJQ.collections.groups.Groups(null, {
                userId: masterUserId
            });
            groups.fetch({
                success: () => {
                    this.groups[masterUserId] = groups;
                    if (typeof callback === 'function') {
                        callback(this.groups[masterUserId]);
                    }
                    resolve(this.groups[masterUserId]);
                },
                error: () => {
                    reject(new Error("Failed to fetch user groups"));
                }
            })
        });
    },
    fetchProjectMessageEmailTemplates(callback) {
        return new Promise((resolve, reject) => {
            if (this.emailTemplates.projectMessage != null) {
                if (typeof callback === 'function') {
                    callback(this.emailTemplates.projectMessage);
                }
                resolve(this.emailTemplates.projectMessage);
                return;
            }

            this.emailTemplates.projectMessage = new PJQ.collections.emailTemplates.EmailTemplates(null, {projectMessage: true});
            this.emailTemplates.projectMessage.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.emailTemplates.projectMessage);
                    }
                    resolve(this.emailTemplates.projectMessage);
                },
                error: () => {
                    reject(new Error("Failed to fetch project message templates"));
                }
            });
        });
    },
    fetchUsers(callback) {
        if (this.users == null) {
            this.users = new PJQ.collections.users.Users();
        }
        if (!this.users.isFetched) {
            this.users.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.users);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.users);
            }
        }
    },
    fetchSSOProviders(callback) {
        if (this.ssoProviders == null) {
            this.ssoProviders = new PJQ.collections.sso.Providers();
        }
        if (!this.ssoProviders.isFetched) {
            this.ssoProviders.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.ssoProviders);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.ssoProviders);
            }
        }
    },
    fetchDailyReportTemplates(callback) {
        if (this.data.dailyReports.templates == null) {
            this.data.dailyReports.templates = new PJQ.collections.dailyReports.SurveyTemplates();
            this.data.dailyReports.templates.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.data.dailyReports.templates);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.data.dailyReports.templates);
            }
        }
    },
    fetchBillingInfo: function (callback) {
        if (this.billingInfo == null) {
            this.billingInfo = new PJQ.models.billing.BillingInfo();
        }

        if (!this.billingInfo.isFetched) {
            this.billingInfo.fetch({
                success: _.bind(function () {
                    callback(this.billingInfo);
                }, this)
            });
        } else {
            callback(this.billingInfo);
        }
    },
    fetchCommitmentSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentSettings);
                }
                resolve(this.commitmentSettings);
                return;
            }

            this.commitmentSettings = new PJQ.models.commitments.Settings();
            this.commitmentSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentSettings);
                    }

                    resolve(this.commitmentSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment settings"));
                }
            });
        });
    },
    fetchCommitmentTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentTerms);
                }
                resolve(this.commitmentTerms);
                return;
            }

            this.commitmentTerms = new PJQ.collections.commitments.Terms();
            this.commitmentTerms.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentTerms);
                    }

                    resolve(this.commitmentTerms);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment terms"));
                }
            });
        });
    },
    fetchCommitmentUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentUserSettings);
                }
                resolve(this.commitmentUserSettings);
                return;
            }

            this.commitmentUserSettings = new PJQ.models.commitments.CommitmentUserSettings();
            this.commitmentUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentUserSettings);
                    }

                    resolve(this.commitmentUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment user settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderSettings);
                }
                resolve(this.commitmentChangeOrderSettings);
                return;
            }

            this.commitmentChangeOrderSettings = new PJQ.models.commitments.ChangeOrderSettings();
            this.commitmentChangeOrderSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderSettings);
                    }

                    resolve(this.commitmentChangeOrderSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderUserSettings);
                }
                resolve(this.commitmentChangeOrderUserSettings);
                return;
            }

            this.commitmentChangeOrderUserSettings = new PJQ.models.commitments.ChangeOrderUserSettings();
            this.commitmentChangeOrderUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderUserSettings);
                    }

                    resolve(this.commitmentChangeOrderUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order user settings"));
                }
            });
        });
    },
    fetchDirectCostSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostSettings);
                }
                resolve(this.directCostSettings);
                return;
            }

            this.directCostSettings = new PJQ.models.directcosts.Settings();
            this.directCostSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostSettings);
                    }

                    resolve(this.directCostSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost settings"));
                }
            });
        });
    },
    fetchMeetingSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.meetingSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.meetingSettings);
                }
                resolve(this.meetingSettings);
                return;
            }

            this.meetingSettings = new PJQ.models.meetings.Settings();
            this.meetingSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.meetingSettings);
                    }

                    resolve(this.meetingSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch meetings settings"));
                }
            });
        });
    },
    fetchDirectCostUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostUserSettings);
                }
                resolve(this.directCostUserSettings);
                return;
            }

            this.directCostUserSettings = new PJQ.models.directcosts.UserSettings();
            this.directCostUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostUserSettings);
                    }

                    resolve(this.directCostUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost user settings"));
                }
            });
        });
    },
    fetchPrimeContractTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractTerms);
                }
                resolve(this.primeContractTerms);
                return;
            }

            this.primeContractTerms = new PJQ.collections.primeContracts.Terms();
            this.primeContractTerms.fetch({
                success: () => {
                    resolve(this.primeContractTerms);
                    if (typeof callback === 'function') {
                        callback(this.primeContractTerms);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract terms"));
                }
            });
        });
    },
    fetchPrimeContractSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractSettings);
                }
                resolve(this.primeContractSettings);
                return;
            }

            this.primeContractSettings = new PJQ.models.primeContracts.Settings();
            this.primeContractSettings.fetch({
                success: () => {
                    resolve(this.primeContractSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract settings "));
                }
            });
        });
    },
    fetchPrimeContractUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractUserSettings);
                }
                resolve(this.primeContractUserSettings);
                return;
            }

            this.primeContractUserSettings = new PJQ.models.primeContracts.PrimeContractUserSettings();
            this.primeContractUserSettings.fetch({
                success: () => {
                    resolve(this.primeContractUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract user settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderSettings);
                }
                resolve(this.primeContractChangeOrderSettings);
                return;
            }

            this.primeContractChangeOrderSettings = new PJQ.models.primeContracts.ChangeOrderSettings();
            this.primeContractChangeOrderSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderUserSettings);
                }
                resolve(this.primeContractChangeOrderUserSettings);
                return;
            }

            this.primeContractChangeOrderUserSettings = new PJQ.models.primeContracts.ChangeOrderUserSettings();
            this.primeContractChangeOrderUserSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order user settings"));
                }
            });
        });
    },
    fetchChangeRequestSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestSettings);
                }
                resolve(this.changeRequestSettings);
                return;
            }

            this.changeRequestSettings = new PJQ.models.changeRequests.Settings();
            this.changeRequestSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.changeRequestSettings);
                    }

                    resolve(this.changeRequestSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch change request custom fields"));
                }
            });
        });
    },
    fetchChangeRequestUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestUserSettings);
                }
                resolve(this.changeRequestUserSettings);
                return;
            }

            this.changeRequestUserSettings = new PJQ.models.changeRequests.ChangeRequestUserSettings();
            this.changeRequestUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.changeRequestUserSettings);
                    }

                    resolve(this.changeRequestUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch change request user settings"));
                }
            });
        });

        if (this.changeRequestUserSettings == null) {
            this.changeRequestUserSettings = new PJQ.models.changeRequests.ChangeRequestUserSettings();
            this.changeRequestUserSettings.fetch({
                success: _.bind(function () {
                    callback(this.changeRequestUserSettings);
                }, this)
            });
        } else {
            callback(this.changeRequestUserSettings);
        }
    },
    fetchCrews: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.crews != null) {
                if (typeof callback === 'function') {
                    callback(this.crews);
                }
                resolve(this.crews);
                return;
            }

            this.crews = new PJQ.collections.timecards.Crews();
            this.crews.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.crews);
                    }
                    resolve(this.crews);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch crews"));
                }
            })
        });
    },
    fetchEquipment: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.equipment != null) {
                if (typeof callback === 'function') {
                    callback(this.equipment);
                }
                resolve(this.equipment);
                return;
            }

            this.equipment = new PJQ.collections.timecards.Equipment();
            this.equipment.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.equipment);
                    }
                    resolve(this.equipment);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch equipment"));
                }
            })
        });
    },
    isLoggedIn: function () {
        return this.user != null && this.user.id > 0;
    },
    hasFeature: function (feature) {
        if (this.subscription == null) {
            return false;
        }
        return this.subscription.hasFeature(feature);
    },
    updateTrial: function (subscriptionId, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'trial'
                }
            ], [
                {
                    parameter: 'id',
                    value: subscriptionId
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    },
    changeSubscription: function (subscriptionId, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'subscription'
                }
            ], [
                {
                    parameter: 'id',
                    value: subscriptionId
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    },
    subscriptionChanged: function (sub) {
        if (sub instanceof PJQ.models.subscriptions.Subscription) {
            this.subscription = sub;
        } else {
            this.subscription = new PJQ.models.subscriptions.Subscription(sub);
        }

        if (this.subscription.newSubscription == null) {
            $('.alert-sub-expiration').remove();
        }

        PJQ.app.navigator.renderHeaderSubscription();
        PJQ.app.navigator.refreshCommands();
        PJQ.app.navigator.renderActiveItem();

        if (this.subscriptionChangedListeners != null) {
            _.each(this.subscriptionChangedListeners, function (listener) {
                listener();
            });
        }
    },
    listenSubscriptionChanged: function (id, callback) {
        if (typeof callback !== 'function') {
            return;
        }

        if (this.subscriptionChangedListeners == null) {
            this.subscriptionChangedListeners = {};
        }
        this.subscriptionChangedListeners[id] = callback;
    },
    updateAutoRenew: function (enable, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'autorenew'
                }
            ], [
                {
                    parameter: 'enable',
                    value: enable
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (this.subscription.newSubscription == null) {
                $('.alert-sub-expiration').remove();
            }

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    },
    changeUserSeats: function (userSeats, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'userseats'
                }
            ], [
                {
                    parameter: 'userSeats',
                    value: userSeats
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    }
});

PJQ.views.sharing = {};

PJQ.views.sharing.SharingModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Share'),
		subTemplates: {
			contact: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Contact'),
			emailBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Email-Badge')
		},
		isEmailOnly: false,
		canEditSubject: true,
		subject: 'Files have been shared with you',
		preventExpiration: null,
		onSave: null,
		onCancel: null
	},
	events: {
		'click .input-share-link,.btn-share-link-copy': 'copyShareLink',
		'keyup .input-share-search': 'searchChanged',
		'click .share-contact': 'addEmailPressed',
		'click .share-email-delete': 'deleteEmail',
		'change .cb-prevent-expire': 'preventExpiration',
		'click .modal-share-send': 'send',
		'click .modal-share-cancel': 'cancel',
		'click .btn-add-project-contact': 'addProjectContact'
	},
	beforeModalCreated: function () {
		this.selectedEmails = [];
		this.options.preventExpiration = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_SHARE_PREVENT_EXPIRATION);
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		if (_.size(this.options.url) === 0) {
			this.urlLoader = new PJQ.Loader(this.$('.share-link-outer'), {
				type: 'small'
			});
		}

		if (this.options.project != null) {
			let contactsLoader = new PJQ.Loader(this.$('.share-contacts-outer'));
			this.options.project.fetchProjectContacts(_.bind(function () {
				this.contacts = this.options.project.projectContacts;
				contactsLoader.remove();
				this.searchChanged();
			}, this));
		}
		else {
			this.contacts = new PJQ.collections.contacts.Contacts();
			this.searchChanged();
		}

		this.renderPreventExpire();
	},
	copyShareLink: function () {
		this.$('.input-share-link')[0].select();
		document.execCommand("copy");
		let linkCopiedText = this.$('.text-link-copied');
		linkCopiedText.animateCSS('fadeIn', function () {
			setTimeout(function () {
				linkCopiedText.animateCSS('fadeOut');
			}, 1500);
		});
	},
	urlChanged: function (url) {
		if (_.size(url) > 0 && !this.options.isEmailOnly) {
			this.options.url = url;
			this.$('.input-share-link').val(url);
			this.$('.share-link-outer').removeClass('hidden');
			if (this.urlLoader != null) {
				this.urlLoader.remove();
				this.urlLoader = null;
			}
		}

		this.renderPreventExpire();
	},
	searchChanged: function () {
		let searchText = this.$('.input-share-search').val().toLowerCase(),
			filteredContacts;
		if (_.size(searchText) > 0) {
			filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
				let email = contact.get('email').toLowerCase();
				if (_.size(email) === 0 || _.indexOf(this.selectedEmails, email) !== -1) {
					return false;
				}

				return contact.get('contactName').toLowerCase().indexOf(searchText) !== -1 || email.indexOf(searchText) !== -1;
			}, this));
		}
		else {
			filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
				let email = contact.get('email').toLowerCase();
				return _.size(email) > 0 && _.indexOf(this.selectedEmails, email) === -1;
			}, this))
		}

		let $addEmail = this.$('.share-add-email'),
			isValidEmail = PJQ.helpers.validators.validateEmail(searchText).success;
		if (isValidEmail && _.size(filteredContacts) === 0) {
			this.$('.share-suggested-contacts').append($('<div>', {
				text: searchText
			}));
			this.$('.share-add-email .share-contact').data('email', searchText);
			this.$('.share-email-entry-letter').html(searchText[0].toUpperCase());
			this.$('.share-email-entry').text(searchText);
			$addEmail.removeClass('hidden');
		}
		else {
			$addEmail.addClass('hidden');
		}

		let $searchResults = this.$('.share-search-results'),
			$searchResultsOuter = this.$('.share-search-results-outer');
		$searchResults.empty();
		if (_.size(filteredContacts) > 0) {
			_.each(_.sortBy(filteredContacts, function (contact) {
				return contact.get('contactName')
			}), _.bind(function (contact) {
				this.renderSubTemplate(true, this.options.subTemplates.contact, $searchResults, {
					model: contact
				});
			}, this));

			$searchResultsOuter.removeClass('hidden');
		}
		else {
			$searchResultsOuter.addClass('hidden');
		}

		let $noResults = this.$('.share-search-no-results');
		if (isValidEmail || _.size(filteredContacts) > 0) {
			$noResults.addClass('hidden');
		}
		else {
			$noResults.removeClass('hidden');
		}
	},
	addProjectContact: function (e) {
		let $target = $(e.currentTarget),
			emailLine = $target.data('email-line');

		new PJQ.views.contacts.SelectContactsModal({
			hideEmails: this.selectedEmails,
			subtitle: `Add Project Contacts to the To line`,
			context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
			canSwitchContext: false,
			showAddress: false,
			isSingleChoice: false,
			saveButtonText: "Add",
			onSave: (newContacts) => {
				_.each(newContacts, (contact) => {
					let email = contact.get('email').toLowerCase();
					if (_.size(email) === 0) {
						return;
					}

					this.addEmail(email);
				});
			}
		});
	},
	renderRecipientCount: function () {
		let emailCount = _.size(this.selectedEmails);
		this.$('.recipient-count').html(emailCount.toString() + (emailCount === 1 ? ' recipient' : ' recipients'));
	},
	addEmailPressed: function (e) {
		let email = $(e.currentTarget).closest('.share-contact').data('email');
		this.addEmail(email);
	},
	addEmail: function(email) {
		this.renderSubTemplate(true, this.options.subTemplates.emailBadge, this.$('.share-selected-emails'), {
			email: email
		});
		this.selectedEmails.push(email.toLowerCase());
		this.$('.input-share-search').val('');
		this.searchChanged();
		this.$('.modal-share-send').prop('disabled', false);
		this.renderRecipientCount();
	},
	deleteEmail: function (e) {
		let emailContainer = $(e.currentTarget).closest('.share-email');
		this.selectedEmails = _.without(this.selectedEmails, emailContainer.data('email').toLowerCase());
		emailContainer.remove();
		this.searchChanged();
		this.$('.modal-share-send').prop('disabled', _.size(this.selectedEmails) === 0);
		this.renderRecipientCount();
	},
	send: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave({
				emails: this.selectedEmails,
				subject: this.options.canEditSubject ? this.$('.input-share-subject').val() : null
			});
		}
	},
	cancel: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	},
	preventExpiration: function () {
		this.options.preventExpiration = this.$('.cb-prevent-expire').prop('checked');

		if (this.options.preventExpiration) {
			PJQ.notifications.createNotifyModal({
				header: 'Prevent Drawing Link Expiration',
				notification: "You have selected for this share link to prevent expiration.  <b>With this selected, all drawings in the selected versions will be included in this share</b> and any individual drawing selections you made will be removed.",
				cookie: PJQ.constants.cookies.NOTIFY_DRAWING_SHARE_PREVENT_EXPIRE,
			});
		}

		if (this.collection != null) {
			this.collection.options.allDrawings = this.options.preventExpiration;
			this.collection.update();
		}

		this.renderPreventExpire();
	},
	renderPreventExpire: function () {
		if (this.collection != null && _.size(this.collection.options.versionIds) > 0) {
			this.$('.prevent-expire-outer').removeClass('hidden');
			this.$('.prevent-expire').prop('checked', this.options.preventExpiration);
		}

		if (this.options.preventExpiration) {
			this.$preventExpireAlert = new PJQ.Alert(this.$('.alert-header'), {
				text: 'You have selected for this link to prevent expiration.  With this selected, only full versions can be shared.  When drawings in the shared versions change, this link will be updated with the changes.'
			});
		}
		else {
			if (this.$preventExpireAlert != null) {
				this.$preventExpireAlert.destroy();
				this.$preventExpireAlert = null;
			}
		}
	}
});
PJQ.views.signatures = {};
PJQ.views.signatures.SignatureSubmitModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Signature-Submit'),
        headerText: 'Sign Below',
        headerSubText: '',
        fetchSignature: true
    },
    events: {
        'click .signature-erase': 'onErase',
        'click .signature-close': 'onClose',
        'click .signature-submit': 'onSubmit'
    },
    afterRender: function () {
        this.$canvas = this.$('.signature-canvas');
        this.canvas = this.$canvas[0];
        this.renderSignaturePad();

        if(this.options.fetchSignature) {
            this.fetchUserSignature();
        }
        else{
            let signature = this.options.signature;
            this.isNewSignature = true;

            if(signature){
                this.signaturePad.fromDataURL(signature);
            }
        }
    },
    renderData: function () {
        return {
            options: this.options
        }
    },
    renderSignaturePad: function () {
        if (this.signaturePad != null) {
            this.signaturePad.off();
        }

        this.signaturePad = new SignaturePad(this.canvas);
        this.signaturePad.minWidth = 1;
        this.signaturePad.maxWidth = 1;
        this.resizeCanvas();
    },
    onSubmit: function () {
        new PJQ.Loader(this.$('.modal-content'));
        if (this.options.onSubmit && !this.isSubmitted) {
            this.isSubmitted = true;
            this.options.onSubmit(this.isNewSignature ? this.signaturePad.toDataURL() : null, _.bind(function () {
                this.removeModal();
            }, this));
        }
    },
    onClose: function () {
        if (this.options.onClose) {
            this.options.onClose(this.model);
        }
    },
    onErase: function () {
        this.isNewSignature = true;
        this.renderSignaturePad();
    },
    resizeCanvas: function () {
        let ratio = Math.max(window.devicePixelRatio || 1, 1);
        this.canvas.width = this.canvas.offsetWidth * ratio;
        this.canvas.height = this.canvas.offsetHeight * ratio;
        this.canvas.getContext("2d").scale(ratio, ratio);
    },
    fetchUserSignature: function () {
        this.signaturePad.off();
        this.signaturePad.fromDataURL(PJQ.helpers.urlHelpers.buildAPIURL('/users/signature', false, true));
        new PJQ.ajax.Request({
            endpoint: "/users/signature"
        }).get().done(_.bind(function () {
            //If it gets here at all, that means the user doesnt have a signature
            //jQuery ajax will not call done on requests for files
            this.isNewSignature = true;
            this.signaturePad.on();
        }, this));
    }
});

PJQ.views.signatures.SignatureTermsModal = PJQ.views.signatures.SignatureSubmitModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Signature-Terms'),
        maxWidth: '1200px',
        fitHeight: true
    },
    beforeRender: function () {
        this.renderData = {
            terms: this.options.terms
        }
    }
});
PJQ.Slider = class {
	constructor($el, options = {}) {
		this.$el = $el;
		this.options = _.defaults(options, {
			fitHorizontal: true,
			onChange: _.noop
		});
		if (_.size(this.$el) > 0) {
			this.slider = this.$el.bootstrapSlider(this.options).on('change', _.bind(this.onChange, this));
			if (this.options.fitHorizontal) {
				this.$el.prev('.slider.slider-horizontal').addClass('wd-100');
			}
			this.refresh();
		}
	}

	refresh() {
		this.slider.bootstrapSlider('refresh');
	}

	getValue() {
		return this.slider.bootstrapSlider('getValue');
	}

	setValue(value) {
		this.slider.bootstrapSlider('setValue', value);
	}

	onChange(obj) {
		this.options.onChange(obj.value);
	}
};
PJQ.Sortable = class {
	constructor($el, options = {}) {
		let self = this;
		self.$el = $el;
		self.options = _.defaults(options, {
			selectedClass: "selected",
			start: function () {
				self.onStart();
			},
			stop: function (e, ui) {
				self.onStop(e, ui);
			}
		});
		if (_.size(self.$el) > 0 && _.size(self.options.items) > 0) {
			self.$el.find(self.options.items).addClass('sortable-item');
			if (self.options.multiple) {
				self.$el.multisortable(self.options);
			}
			else {
				self.$el.sortable(self.options);
			}
		}
	}

	refreshPositions() {
		if (this.options.multiple) {
			this.$el.multisortable("refreshPositions");
		}
		else {
			this.$el.sortable("refreshPositions");
		}
	}

	getSelected() {
		return this.$el.find(this.options.items).filter("." + this.options.selectedClass);
	}

	moveSelectedTop() {
		this.getSelected().prependTo(this.$el);
		this.$el.scrollTop(0);
		this.onStop();
	}

	moveSelectedBottom() {
		this.getSelected().appendTo(this.$el);
		this.$el.scrollTop(this.$el.height() + 100);
		this.onStop();
	}

	onStop(e, ui) {
		if (typeof this.options.onStop === 'function') {
			this.options.onStop(e, ui);
		}
	}

	onStart() {
		if (typeof this.options.onStart === 'function') {
			this.options.onStart();
		}
	}
};
PJQ.StepIndicator = class {
    constructor($el, options = {}) {
        this.$el = $el;
        this.options = _.defaults(options, {});
        this.steps = this.options.steps ?? [];
        this.activeStep = this.options.activeStep ?? 0;
        if (_.size(this.$el) > 0) {
            this.refresh();
        }
    }

    refresh() {
        let html = '<div class="stepper-wrapper">';
        _.each(this.steps, (step, index) => {
            let statusClass = '';
            if (this.activeStep === index) {
                statusClass = 'active';
            } else if (this.activeStep > index) {
                statusClass = 'completed';
            }
            html += '<div class="stepper-item ' + statusClass + '"><div class="step-counter">' + (index + 1).toString() + '</div><div class="step-name">' + step.name + '</div></div>';
        });

        html += '</div>';
        this.$el.html(html);
    }

    setStep(step) {

    }
};
PJQ.constants.subscriptions = {
    types: {
        FREE: 1,
        BASIC: 2,
        ADVANCED: 3,
        PRO: 3,
        ENTERPRISE: 4
    },
    colors: {
        1: "#7e7e7e",
        2: "#4cc2e2",
        3: "#2780bd",
        4: "#1d52a0"
    },
    names: {
        1: "FREE",
        2: "BASIC",
        3: "ADVANCED",
        4: "ENTERPRISE"
    },
    names: {
        1: "FREE",
        2: "BASIC",
        3: "ADVANCED",
        4: "ENTERPRISE"
    },
    costs: {
        1: 0,
        2: 2500,
        3: 3500,
        4: 5000
    }
};

PJQ.models.subscriptions = {};

PJQ.models.subscriptions.Subscription = PJQ.models.BaseModel.extend({
    idAttribute: 'subscriptionId',
    parse: function (model) {
        if (model != null) {
            if (model.newSubscription != null) {
                this.newSubscription = new PJQ.models.subscriptions.Subscription(model.newSubscription);
            } else {
                this.newSubscription = null;
            }
        }
        return model;
    },
    hasFeature: function (feature) {
        if (PJQ.app.session.get('onAccount') || (PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId)) {
            return true;
        }

        switch (feature.toLowerCase()) {
            case 'projects':
                return this.get('hasProjects');
            case 'contacts':
                return this.get('hasContacts');
            case 'documents':
                return this.get('hasDocuments');
            case 'invoices':
                return this.get('hasInvoices');
            case 'calendar':
                return this.get('hasCalendar');
            case 'reports':
                return this.get('hasReports');
            case 'projectmessaging':
                return this.get('hasProjectMessaging');
            case 'privatemessaging':
                return this.get('hasPrivateMessaging');
            case 'bidforms':
                return this.get('hasBidForms');
            case 'drawings':
                return this.get('hasDrawings');
            case 'projectattachments':
                return this.get('hasProjectAttachments');
            case 'rfi':
                return this.get('hasRFI');
            case 'submittals':
                return this.get('hasSubmittals');
            case 'dailyreports':
                return this.get('hasDailyReports');
            case 'schedule':
                return this.get('hasSchedule');
            case 'meetings':
                return this.get('hasSchedule');
            case 'punchlist':
                return this.get('hasPunchList');
            case 'actionitems':
                return this.get('hasActionItems');
            case 'projectreports':
                return this.get('hasProjectReports');
            case 'bidfiler':
                return this.get('hasBidFiler');
            case 'timecards':
                return this.get('hasTimeCards');
            case 'jobcosting':
            case 'budget':
            case 'primecontracts':
            case 'commitments':
            case 'directcosts':
            case 'invoicing':
                return this.get('hasJobCosting');
            case 'sso':
                return this.get('hasSSO');
            default:
                return true;
        }
    },
    getCostsPerUser: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'subscription'
                },
                {
                    endpoint: 'cost'
                }
            ])
        }).get().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(_.bind(function () {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this));
    }
});

PJQ.views.subscriptions = {};

PJQ.views.subscriptions.EditSubscriptionModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-edit-subscription'),
        maxWidth: 1200,
        isVerticalCenter: true,
        preventTrial: false,
        onSave: null,
        onDecline: null
    },
    events: {
        'click .sub-option': 'subscriptionSelected',
        'click .btn-submit': 'submit',
        'click .btn-submit-trial': 'submitTrial',
        'click .btn-decline': 'decline'
    },
    beforeModalCreated: function () {
        if (PJQ.app.session.subscription.id !== PJQ.constants.subscriptions.types.FREE) {
            this.selectedSubscriptionId = PJQ.app.session.subscription.id;
        } else {
            this.selectedSubscriptionId = PJQ.constants.subscriptions.types.ENTERPRISE;
        }

        this.options.forTrialOffer = !this.options.preventTrial && (PJQ.app.session.subscription.get('trialExpiresOn') == null || (PJQ.helpers.dateHelpers.getDateDiff(new Date(PJQ.app.session.subscription.get('trialExpiresOn')), new Date(), 'days') + 1) > 0);
    },
    renderData: function () {
        return {
            forTrialOffer: this.options.forTrialOffer,
            activeSubscription: PJQ.app.session.subscription,
            selectedSubscriptionId: this.selectedSubscriptionId
        }
    },
    subscriptionSelected: function (e) {
        this.selectedSubscriptionId = parseInt($(e.currentTarget).data('subId'));
        this.render();
    },
    submitTrial: function () {
        let $err = this.$('.error-outer');
        if (this.selectedSubscriptionId === PJQ.constants.subscriptions.types.FREE) {
            $err.html('Please select a plan');
            return;
        } else {
            $err.empty();
        }

        PJQ.app.session.updateTrial(this.selectedSubscriptionId, _.bind(function (data) {
            if (data == null || data.subscription == null) {
                PJQ.notifications.notify.errorNotify({
                    message: 'Encountered an error starting your free trial.  Please contact customer service.'
                });
            } else {
                PJQ.notifications.notify.successNotify({
                    message: 'Free trial started'
                });
                this.removeModal();
            }
        }, this), _.bind(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Encountered an error starting your free trial.  Please contact customer service.'
            });
            this.removeModal();
        }, this));
    },
    submit: function () {
        let $err = this.$('.error-outer'),
            newSubscription = PJQ.app.session.subscription.get('newSubscription');
        if (this.selectedSubscriptionId === PJQ.constants.subscriptions.types.FREE) {
            $err.html('Please select a plan');
            return;
        } else if (this.selectedSubscriptionId === PJQ.app.session.subscription.id && newSubscription == null) {
            $err.html('This plan is already active on your account');
            return;
        } else {
            $err.empty();
        }

        if (PJQ.app.session.subscription.get('isFreeTrial') || this.selectedSubscriptionId > PJQ.app.session.subscription.id) {
            // this is an upgrade that will trigger a payment, show the payment modal
            this.removeModal();
            new PJQ.views.payment.SubscriptionPaymentModal({
                selectedSubscriptionId: this.selectedSubscriptionId
            });
        } else {
            // this is a change that wont trigger a payment, upgrade the subscription
            let loader = new PJQ.Loader(this.$('.modal-content')),
                err = function () {
                    loader.remove();
                    PJQ.notifications.notify.errorNotify({
                        message: 'Encountered an error upgrading your subscription.  Please contact customer service.'
                    });
                };
            PJQ.app.session.changeSubscription(this.selectedSubscriptionId, _.bind(function (data) {
                if (data == null || data.subscription == null) {
                    err();
                } else {
                    PJQ.notifications.notify.successNotify({
                        message: 'Subscription successfully updated'
                    });
                    this.removeModal();

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave();
                    }
                }
            }, this), _.bind(function () {
                err();
            }, this));
        }
    },
    decline: function(){
        if(typeof this.options.onDecline === 'function'){
            this.options.onDecline();
        }
        this.removeModal();
    }
});

PJQ.views.subscriptions.DisableAutoRenewModal = PJQ.views.BaseModal.extend({
    beforeModalCreated: function () {
        this.options = _.defaults({
            header: "Disable Auto Renew",
            body: "Are you sure you want to disable auto-renew?<br />Your users will continue to have access to your current subscription's features until it expires on <strong>" + PJQ.helpers.dateHelpers.getDateString(new Date(this.options.subscription.get('expiresOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) + "</strong>.",
            isShowOkButton: true,
            okButtonColorClass: 'danger',
            okButtonText: "Disable Auto-Renew",
            onOk: _.bind(function () {
                if (typeof this.options.onYes === 'function') {
                    this.options.onYes();
                }
            }, this),
            isShowSecondaryButton: true,
            secondaryButtonText: "Keep Auto-Renew Enabled",
            onSecondary: _.bind(function () {
                if (typeof this.options.onNo === 'function') {
                    this.options.onNo();
                }
            }, this)
        }, this.options);
    }
});
PJQ.TokenManager = class {
    UPDATE_EVENT = 'TOKENS_UPDATED';

    constructor(options = {}) {
        this.Key_Access_Token = 'access_token';
        this.Key_Refresh_Token = 'refresh_token';

        this.enabled = options && options.enabled === true;
        this.setAccessToken(options.accessToken);
        this.setRefreshToken(options.refreshToken);

        if (this.enabled) {
            this.addBroadcastChannelListener();
        }
    }

    addBroadcastChannelListener() {
        this.bc = new BroadcastChannel('TOKEN_CHANNEL');
        this.bc.addEventListener("message", _.bind(function (event) {
            if (event.data != null) {
                this.setAccessToken(event.data.accessToken);
                this.setRefreshToken(event.data.refreshToken);
            }
        }, this));
    }

    setAccessToken(accessToken) {
        window.sessionStorage.removeItem(this.Key_Access_Token);
        if (_.size(accessToken) > 0) {
            window.sessionStorage.setItem(this.Key_Access_Token, accessToken);
        }
    }

    setRefreshToken(refreshToken) {
        window.sessionStorage.removeItem(this.Key_Refresh_Token);
        if (_.size(refreshToken)) {
            window.sessionStorage.setItem(this.Key_Refresh_Token, refreshToken);
        }
    }

    updateTokens(accessToken, refreshToken, opts = {}) {
        this.setAccessToken(accessToken);
        this.setRefreshToken(refreshToken);

        if (opts.expiresOn != null) {
            this.updateCookies(opts.expiresOn, opts.onCookiesUpdated, opts.cookieParams);
        }

        if (opts.broadcast !== false) {
            new BroadcastChannel('TOKEN_CHANNEL').postMessage({
                accessToken: this.getAccessToken(),
                refreshToken: this.getRefreshToken()
            });
        }
    }

    updateCookies(expiresOn, callback, params = []) {
        let accessToken = this.getAccessToken(),
            refreshToken = this.getRefreshToken();
        if (_.size(refreshToken) > 0 && _.size(accessToken) > 0 && expiresOn != null) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: PJQ.app.options.isK8 ? 'token' : 'Token.ashx'
                    }
                ], _.union(params, [
                    {
                        parameter: 'r',
                        value: refreshToken
                    },
                    {
                        parameter: 'a',
                        value: accessToken
                    },
                    {
                        parameter: 'exp',
                        value: expiresOn
                    }
                ])),
                isOrigin: true
            }).get().done(_.bind(function () {
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)).fail(_.bind(function () {
                if (typeof callback === 'function') {
                    callback(false);
                }
            }, this));
        }
    }

    getRefreshToken() {
        return window.sessionStorage.getItem(this.Key_Refresh_Token);
    }

    getAccessToken() {
        return window.sessionStorage.getItem(this.Key_Access_Token);
    }

    getTokensForAccessKey(accessKey, callback) {
        return this.getTokensForUser(null, null, callback, {accessKey: accessKey});
    }

    getTokensForUser(username, password, callback, options = {}) {
        let cb = function (success, error) {
            if (typeof callback === 'function') {
                callback(success != null ? success : false, error != null ? error : null);
            }
        }

        let params;
        if (_.size(options.accessKey) > 0) {
            if (_.size(this.getAccessToken()) > 0 && this.accessKey === options.accessKey) {
                cb(true);
                return;
            }

            this.accessKey = options.accessKey;
            params = [
                {
                    parameter: 'accessKey',
                    value: options.accessKey
                }
            ];
        } else {
            params = [
                {
                    parameter: 'username',
                    value: username
                },
                {
                    parameter: 'password',
                    value: password
                }
            ];
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'token'
                }
            ], params),
            isAPIv2: true
        }).post().done(_.bind(function (data) {
            this.updateTokens(data.access_token, data.refresh_token);
            if (_.size(data.access_token) > 0) {
                let headers = {
                    Authorization: "Bearer " + data.access_token
                };
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'token'
                        },
                        {
                            endpoint: 'signin'
                        }
                    ]),
                    headers: headers
                }).get().done(_.bind(function (sessionData) {
                    if (sessionData.success) {
                        this.updateTokens(data.access_token, data.refresh_token, {
                            expiresOn: PJQ.helpers.dateHelpers.getNewDateAddSeconds(new Date(), 300),
                            cookieParams: [
                                {
                                    parameter: 'dnn',
                                    value: sessionData.cookie
                                },
                                {
                                    parameter: 's',
                                    value: sessionData.sessionId
                                }
                            ],
                            onCookiesUpdated: _.bind(function () {
                                cb(true);
                            }, this)
                        });
                    } else {
                        cb(true, 'CUSTOMER_SERVICE');
                    }
                }, this));
            } else {
                cb(false, _.size(data.error) > 0 ? data.error : 'CUSTOMER_SERVICE');
            }
        }, this)).fail(_.bind(function (data) {
            cb(false, _.size(data.error) > 0 ? data.error : 'CUSTOMER_SERVICE');
        }, this));
    }

    refreshAccessToken(callback) {
        let refreshToken = this.getRefreshToken();
        if (_.size(refreshToken) > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'token'
                    }
                ], [
                    {
                        parameter: 'refresh_token',
                        value: refreshToken
                    }
                ]),
                isAPIv2: true,
                canAuthRetry: false
            }).post().done(_.bind(function (data) {
                if (_.size(data.access_token) > 0) {
                    this.updateTokens(data.access_token, data.refresh_token, {
                        expiresOn: PJQ.helpers.dateHelpers.getNewDateAddSeconds(new Date(), data.expires_in),
                        onCookiesUpdated: _.bind(function () {
                            if (typeof callback === 'function') {
                                callback(this.getAccessToken());
                            }
                        }, this)
                    });
                } else if (typeof callback === 'function') {
                    callback(this.getAccessToken());
                }
            }, this)).fail(_.bind(function () {
                this.handleUnauthorized();
            }, this));
        } else {
            this.handleUnauthorized();
        }
    }

	handleUnauthorized() {
		if(PJQ.app.options.isK8){
			window.location.href = "/signout";
		}
		else{
			window.location.href = "/Signout.aspx?r=" + encodeURIComponent(window.location.origin + '/#signin');
		}
	}

	getBlobToken(context, callback) {
		let cb = _.bind(function (bt) {
			this.blobToken = bt;
			callback(this.blobToken);
		}, this)
		if (this.blobToken != null) {
			cb(this.blobToken);
		} else {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'blobs'
					},
					{
						endpoint: 'token'
					}
				]),
				isAPIv2: true
			}).get().done(_.bind(function (data) {
				if (data != null && _.size(data.token) > 0) {
					cb(data);
				} else {
					cb(null);
				}
			}, this)).fail(_.bind(function () {
				cb(null);
			}, this));
		}
	}
};
PJQ.views.toolbars = {};

PJQ.views.toolbars.BaseToolbar = PJQ.views.BaseView.extend({
	beforeFirstRender: function () {
		let $outer = _.size(this.$el) > 0 ? this.$el : $('body');
		let $toolbarsContainer = $outer.find('#toolbarsContainer');
		if (_.size($toolbarsContainer) === 0) {
			$toolbarsContainer = $('<div>', {
				id: 'toolbarsContainer'
			});
			$outer.append($toolbarsContainer);
		}
		this.setElement($toolbarsContainer);
	},
	hide: function () {
		let $animate = this.$('.toolbar');
		$animate.animate({
			height: '0px'
		}, 300, _.bind(function () {
			$animate.addClass('hidden');
		}, this));
	},
	show: function () {
		this.$('.toolbar').removeClass('hidden').animate({
			height: '50px'
		});
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave();
		}
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose();
		}

		let $animate = this.$('.toolbar');
		$animate.animate({
			height: '0px'
		}, 300, _.bind(function () {
			$animate.addClass('hidden');
		}, this));
	}
});

PJQ.views.toolbars.ProfileSaveToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Profile-Save'),
		hideWhenZero: true,
		onClose: null,
		onSave: null
	},
	events: {
		'click .btn-profile-save': 'save',
		'click .btn-profile-cancel-save': 'close'
	},
	afterRender: function () {
		this.workAreaCount = 0;
		setTimeout(_.bind(function () {
			this.listenTo(this.options.model, 'change', _.bind(this.renderChangedCount, this));
			this.listenTo(this.options.workAreaMap, 'update', _.bind(this.renderChangedCount, this));
			_.each(this.options.workAreaMap.models, function (model) {
				if (model) {
					this.workAreaCount += 1
				}
			}, this);
			this.groupsCount = this.options.groupSelector.getGroupsData().selected.length;
			this.renderChangedCount();
		}, this), 500)
	},
	autoShowToolbar: function () {
		this.$('.btn-profile-save, .btn-profile-cancel-save').prop('disabled', false);
		let $animate = this.$('.toolbar');
		$animate.removeClass('hidden').animate({
			height: '50px'
		});
	},
	renderChangedCount: function () {
		let profileChanged = this.options.model.hasChanged(),
			groupsChanged = this.options.groupSelector.getGroupsData().selected.length,
			newWorkCount = this.options.workAreaMap.length,
			$animate = this.$('.toolbar'),
			isHidden = $animate.hasClass('hidden');
		if (this.options.hideWhenZero && !profileChanged && !isHidden && newWorkCount === this.workAreaCount && groupsChanged === this.groupsCount || !this.options.isEdit) {
			this.$('.btn-profile-save, .btn-profile-cancel-save').prop('disabled', true);
			this.close();
		}
		else if ((isHidden && profileChanged) || (isHidden && newWorkCount !== this.workAreaCount) || (isHidden && groupsChanged !== this.groupsCount)) {
			this.$('.btn-profile-save, .btn-profile-cancel-save').prop('disabled', false);
			$animate.removeClass('hidden').animate({
				height: '50px'
			});
		}
	}
});

PJQ.views.toolbars.SettingsSaveToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Toolbar-Save'),
		validate: _.noop
	},
	events: {
		'click .btn-settings-save': 'save',
		'click .btn-settings-cancel-save': 'clearSaveModels'
	},
	beforeFirstRender: function () {
		this.saveArray = [];
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.renderToolbar();
	},
	addSaveModel: function (saveModel) {
		this.saveArray = _.reject(this.saveArray, function (md) {
			return md.cid === saveModel.cid
		});
		if (_.find(this.saveArray, function (md) {
			return md.cid === saveModel.cid;
		}) == null) {
			this.saveArray.push(saveModel);
		}
		this.renderToolbar();
	},
	clearSaveModels: function () {
		_.each(this.saveArray, function (saveModel) {
			saveModel.fetch();
		});
		this.saveArray = [];
		this.renderToolbar();
	},
	renderToolbar: function () {
		let settingsCount = _.size(this.saveArray),
			$animate = this.$('.toolbar'),
			isHidden = $animate.hasClass('hidden');
		if (settingsCount === 0 && !isHidden) {
			this.hide();
		}
		else if (isHidden && settingsCount > 0) {
			this.show();
		}
	},
	save: function () {
		let callbackCounter = 0,
			fnCallback = _.bind(function () {
				callbackCounter++;
				if (callbackCounter === _.size(this.saveArray)) {
					PJQ.notifications.notify.successNotify({
						message: 'Settings saved'
					});
					PJQ.app.session.fetch();
					this.clearSaveModels();
				}
			}, this);

		if (typeof this.options.validate !== 'function' || this.options.validate()) {
			_.each(this.saveArray, function (saveModel) {
				if (saveModel instanceof PJQ.models.users.User || saveModel instanceof PJQ.models.schedule.Settings || saveModel instanceof PJQ.models.bidForms.Settings || saveModel instanceof PJQ.models.submittals.Settings) {
					saveModel.save(null, {
						success: _.bind(function () {
							PJQ.app.navigator.refreshCommands();
							fnCallback();
						}, this)
					});
				}
				else if (saveModel instanceof PJQ.models.rfi.Settings) {
					saveModel.put(null, {
						success: _.bind(function () {
							fnCallback();
						}, this)
					});
				}
				else {
					saveModel.patch(null, {
						success: _.bind(function () {
							fnCallback();
						}, this)
					});
				}
			}, this);
		}
	}
});

PJQ.views.toolbars.FilesToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Toolbar-Files'),
		previewImageDimension: 160,
		hideWhenZero: true,
		isPhotos: false,
		onClose: _.noop
	},
	events: {
		'click .btn-files-download': 'download',
		'click .btn-files-share': 'share',
		'click .toolbar-close': 'close'
	},
	beforeRender: function () {
		if (this.collection == null) {
			this.collection = new PJQ.collections.files.Files(null, {
				isPhotos: this.options.isPhotos
			});
		}
		this.listenTo(this.collection, 'update', _.bind(this.renderSelectedCount, this));
	},
	renderData: function () {
		return {
			collection: this.collection,
			options: this.options
		};
	},
	afterRender: function () {
		this.renderSelectedCount();
	},
	addFiles: function (files) {
		this.collection.add(files);
	},
	removeFiles: function (files) {
		this.collection.remove(files);
	},
	renderSelectedCount: function () {
		let fileCount = _.size(this.collection.models),
			$animate = this.$('.toolbar'),
			isHidden = $animate.hasClass('hidden');
		if (this.options.hideWhenZero && fileCount === 0 && !isHidden) {
			this.close();
		}
		else if (isHidden && fileCount > 0) {
			$animate.css('display', 'inherit !important').removeClass('hidden').animate({
				height: '50px'
			});
		}
		this.$('.selected-files-label').html(fileCount.toString() + ' file' + (fileCount > 0 ? 's' : '') + ' selected');
		this.$('.download-files, .btn-share').prop('disabled', fileCount === 0);
	},
	download: function () {
		let fileCount = _.size(this.collection.models);
		if (fileCount > 1) {
			this.collection.download();
		}
		else if (fileCount === 1) {
			this.collection.models[0].download();
		}
		else {
			//todo: alert error
			//it should never get here anyway because we disable the download button when no files are selected
		}
	},
	share: function () {
		let project = PJQ.app.session.project;
		let sharingModal = new PJQ.views.sharing.SharingModal({
			project: project,
			onSave: _.bind(function (data) {
				this.collection.share(data, project, _.bind(function (share) {
					//todo: show success somehow
				}, this));
			}, this)
		});
		this.collection.share(null, project, function (share) {
			let callback = _.bind(sharingModal.urlChanged, sharingModal);
			callback(share.url);
		});
	},
	close: function () {
		this.collection.reset();
		this.options.onClose();
		let $animate = this.$('.toolbar');
		$animate.animate({
			height: '0px'
		}, 300, () => {
			$animate.addClass('hidden');
			this.$('.selected-file-count').html('0');
		});
	}
});

PJQ.views.toolbars.ExportSelectedToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Toolbar-Export-Selected'),
		previewImageDimension: 160,
		selectedCount: 0,
		onExport: null,
		onClose: null
	},
	events: {
		'click .btn-export': 'export',
		'click .toolbar-close': 'destroy'
	},
	afterRender: function () {
		this.renderSelectedCount();
		this.show();
	},
	updateSelectedCount: function (newCount) {
		this.options.selectedCount = newCount;
		this.renderSelectedCount();
	},
	renderSelectedCount: function () {
		this.$('.selected-label').html(this.options.selectedCount.toString() + ' selected');
		this.$('.btn-export').prop('disabled', this.options.selectedCount === 0);
	},
	export: function () {
		if (typeof this.options.onExport === 'function') {
			this.options.onExport();
		}
	},
	destroy: function () {
		this.hide();
		setTimeout(_.bind(function () {
			this.remove();
		}, this), 500)
	}
});

PJQ.Tooltip = class {
	constructor(el, options = {}) {
		if (el == null && _.size(options.container) > 0) {
			this.$el = $('<div>', {
				class: 'position-absolute wd-100 ht-100 left-0 top-0'
			});
			options.container.append(this.$el);
		}
		else {
			this.$el = el instanceof $ ? el : $(el);
		}

		if (!options.show) {
			this.$el.addClass('popup-trigger');
		}

		this.options = _.defaults(options, {
			placement: 'auto',
			trigger: options.show ? 'focus' : 'hover',
			html: true,
			sanitize: false,
			allowMultiple: false,
			template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Tooltip-Default')
		});
		this.init();
	}

	init() {
		this.getTemplate(_.bind(function ($tmpl) {
			this.$el.popover(_.defaults({
				content: _.bind(function () {
					return $tmpl.outerHTML();
				}, this)
			}, _.omit(this.options, 'template')));

			if (this.options.show) {
				this.$el.popover('show');
			}
			else if (_.size(this.options.container) > 0) {
				let self = this;
				this.options.container.off('click.tooltip');
				this.options.container.on('click.tooltip', function (e) {
					if ($(e.target).closest('.popup-trigger').length === 0) {
						self.options.container.children('.popover').popover('hide');
					}
				});

				if (!this.options.allowMultiple) {
					this.$el.off('show.bs.popover');
					this.$el.on('show.bs.popover', function () {
						self.options.container.children('.popover').not(this).popover('hide');
					});

					if (typeof this.options.onShow === 'function') {
						this.options.onShow(this);
					}
				}
			}

			if (typeof this.options.afterRender === 'function') {
				this.options.afterRender(this);
			}
		}, this))
	}

	getTemplate(callback) {
		this.options.template.render(this.renderData(), callback);
	}

	renderData() {
		if (this.options.renderData != null) {
			if (typeof this.options.renderData === 'function') {
				return this.options.renderData();
			}
			return this.options.renderData;
		}
		return {
			title: this.options.title
		};
	}

	show() {
		this.$el.popover('show');
	}

	hide() {
		this.$el.popover('hide');
	}

	remove() {
		this.$el.popover('dispose');
		if (_.size(this.options.container) > 0) {
			this.options.container.find('.popover').remove();
		}
		this.$el.off('show.bs.popover').off('shown.bs.popover');
		this.options.container.off('click.tooltip');
	}
};
PJQ.tours = {};
PJQ.views.tours = {};
PJQ.helpers.tours = {
    initTour: function () {
        if (1 === 0 && !PJQ.app.session.get('onAccount') && !PJQ.app.session.user.get('tourDone') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            new PJQ.views.tours.SubscriptionTourIntro();
        }
    }
};

PJQ.tours.BaseTour = class {
    constructor(options = {}) {
        this.options = _.defaults(options, {
            onEnd: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'tour'
                        }
                    ])
                }).put().done(function () {
                }).fail(function () {
                });
            }, this),
            framework: 'bootstrap4',
            showIfUnintendedOrphan: true,
            showProgressText: false,
            showProgressBar: false,
            steps: [
                {
                    element: ".nav-myprojects",
                    content: "The Projects tab is where you can view, create, and manage all of your projects.  Let's take a look at a sample project to get you familiar with some of the tools.",
                    container: '#Body',
                    placement: 'auto',
                    onShow: _.bind(function () {
                        PJQ.app.router.navigate('myprojects', {
                            trigger: true
                        });
                    }, this),
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (0 > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dashboard', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".project-dashboard",
                    orphan: true,
                    content: "This is your project dashboard.  It's the first thing you will see when you enter your project. Here you can get an overview for your project, see shared documents, and check the project news feed.",
                    placement: 'auto',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('myprojects', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-project",
                    content: "Here you can navigate through all of your project tools.  Next we'll take a look at Project Details.",
                    placement: 'right',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dashboard', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/details', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-details",
                    content: "Project Details is where you can add, view, or modify information relating to the Project.  You can also add custom fields in the settings if there is other information you would like to be shown.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/messaging', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-messaging",
                    content: "Messaging is where you will manage all of your Invitations to Bid.  It's extremely easy to invite people from your address book, or quickly send to a single email.  Once you have an existing project you can also invite from those projects.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projectMessaging')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/details', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('privateMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/privatemessaging', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-privatemessaging",
                    content: "Anyone who has access to this project can easily message you which can also include attachments they wish for you to see.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('privateMessaging')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.tour.prev();
                            } else {
                                this.tour.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/messaging', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('bidForms')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/bidforms', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-bidforms",
                    content: "Send bid forms to project participants, or add a bid form to a specific trade.  You can also manage, and view any existing bid forms.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('bidForms')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('privateMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/privatemessaging', {
                                trigger: true
                            })
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/contacts', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-projectcontacts",
                    content: "Here is where you will manage any of your Project Contacts.  Project contacts will be anyone you will want to assign to handle tasks such as Daily Reports.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('bidForms')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/bidforms', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('drawings')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/drawings', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-drawings",
                    content: "View and manage all of your drawings!  It's easy to upload, revise, and share all of your drawings.  When your drawings are uploaded, our system will automatically attempt to find the page number and name it accordingly for quick organization.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('drawings')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/contacts', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectAttachments')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/attachments', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-attachments",
                    content: "Easily upload, organize, store, and share all of your documents.  All attachments uploaded through the project can be accessed here.  By default there will be a shared and private folder, but you can also add more folders as needed.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projectAttachments')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('drawings')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/drawings', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('schedule')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/schedule', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-projectschedule",
                    content: "Scheduling is your most important tool for staying on top of your project. Add tasks with dependencies and successors and create a critical path.",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectAttachments')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/attachments', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('photoGallery')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/photos', {
                                trigger: true
                            });
                        }
                    }, this),
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('schedule')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                },
                {
                    element: ".nav-projectphotos",
                    content: "Your Photo Gallery contains any photos uploaded throughout your project.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('photoGallery')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('schedule')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/schedule', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('rfi')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/rfi', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-rfi",
                    content: "Send, receive, and collaborate on RFIs with other project contacts",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('rfi')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('photoGallery')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/photos', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('submittals')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/submittals', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-submittals",
                    content: "Create, collect, and manage your submittals for the project",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('submittals')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('rfi')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/rfi', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('dailyReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dailyreports', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-dailyreports",
                    content: "Track daily, weekly, and monthly project tasks and details with your Daily Reports.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('dailyReports')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('submittals')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/submittals', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('punchList')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/punchlists', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-punchlists",
                    content: "Assign a punch list item to one of your project contacts. They’ll receive an immediate notification!",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('punchList')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('dailyReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dailyreports', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/reports', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-projectreports",
                    content: "View and export reports related to the project.  Reports include a detailed participant list, project stats, and more!",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projectReports')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('punchList')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/punchlists', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('projectinvites', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".nav-projectinvites",
                    content: "The Project Invites tab is where you can view all of your Invitations to Bid from other contractors.",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/reports', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('contacts')) {
                            PJQ.app.router.navigate('contacts', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-contacts",
                    content: "Using the address book makes it easy to manage your contacts and add them to your projects.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('contacts')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('projectinvites', {
                            trigger: true
                        });
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('documents')) {
                            PJQ.app.router.navigate('documents', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-documents",
                    content: "Quickly view documents from all of your projects.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('documents')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('contacts')) {
                            PJQ.app.router.navigate('contacts', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('profile', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".nav-profile",
                    content: "Here’s where you can make sure all of your profile settings are correct. \n" +
                        "<br> <br> PRO TIP: Always check and make sure your Work Areas is up to date so you can receive the best leads!\n",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (!PJQ.app.session.subscription.hasFeature('documents')) {
                            PJQ.app.router.navigate('documents', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('prequal', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".nav-prequal",
                    content: "Save even more time by filling out your PreQualification details here, so you can easily share them with a General Contractor.",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('profile', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".screening-dashboard-body",
                    content: "Congratulations! You've made it to the end our your Pantera Tools tour. When you're ready, click the \"End Tour\" button below to start getting more leads!",
                    placement: 'left'
                }
            ]

        });
        this.start();
    }

    start() {
        this.tour = new Tour(this.options);
        this.tour.start(true);
    }

    next() {
        this.tour.next();
    }

    prev() {
        this.tour.prev();
    }

    setStep() {
        this.previousStep = this.tour.getCurrentStepIndex();
    }
}

PJQ.views.tours.SubscriptionTourIntro = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-tour-intro'),
        maxWidth: 800,
        isVerticalCenter: true
    },
    events: {
        'click .btn-start-tour': 'startTour',
        'click .btn-skip-tour': 'skipTour'
    },
    startTour: function () {
        if (PJQ.app.session.user.get('tourDone')) {
            window.localStorage.clear();
        }
        let projectId = null,
            projects = new PJQ.collections.projects.Projects(null, {
                isSimple: false,
                status: 'ready',
                isMyProjects: true
            });
        projects.fetch({
            success: _.bind(function (data) {
                _.each(_.filter(data.models, function (model) {
                    return model.get('projectName') === 'Sample Project'
                }), function (model) {
                    projectId = model.get('projectId');
                })
                if (projectId != null) {
                    PJQ.app.tour = new PJQ.tours.BaseTour({
                        projectId: projectId
                    });
                } else if (data.models.length > 0) {
                    projectId = data.models[0].get('projectId');
                    if (projectId != null) {
                        PJQ.app.tour = new PJQ.tours.BaseTour({
                            projectId: projectId
                        });
                    }
                }
            }, this)
        })
        this.removeModal();
    },
    skipTour: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'tour'
                }
            ])
        }).put().done(function () {
        }).fail(function () {
        });
    }
})

//Models
PJQ.models.userMessages = {};

PJQ.models.userMessages.UserMessage = PJQ.models.BaseModel.extend({
	idAttribute: 'userMessageId',
	endpoint: function () {
		if (this.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usermessages',
					value: this.id
				}
			]);
		}
		else if (this.get('replyToMessageId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usermessages',
					value: this.get('replyToMessageId')
				}
			]);
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.project.id
			},
			{
				endpoint: 'usermessages'
			}
		]);
	},
	parse: function (model) {
		if (model !== null && model !== undefined) {
			this.project = model.project;

			if (model.from != null) {
				this.from = new PJQ.models.contacts.Contact(model.from);
			}

			if (model.to != null) {
				this.to = new PJQ.models.contacts.Contact(model.to);
			}

			this.attachments = new PJQ.collections.files.Files(model.attachments);
			this.attachments.on('update', _.bind(function () {
				this.isDirty = true;
			}, this));
		}
		else {
			this.attachments = new PJQ.collections.files.Files();
		}
		return model;
	},
	beforeSave: function () {
		this.set('attachments', this.attachments.getChangedModels());

		if (this.userMessageType != null) {
			this.set('userMessageTypeId', this.userMessageType.id);
		}
	},
	updateViewed: function(){
		this.set('viewedOn', new Date());
		if(this.id > 0){
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'usermessages',
						value: this.id
					},
					{
						endpoint: 'viewed'
					}
				])
			}).put();
		}
	}
});

PJQ.models.userMessages.UserMessageType = PJQ.models.BaseModel.extend({
	idAttribute: 'internalMessageTypeId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'usermessages'
			},
			{
				endpoint: 'types',
				value: this.id
			}
		])
	}
});

//Collections
PJQ.collections.userMessages = {};

PJQ.collections.userMessages.UserMessages = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userMessages.UserMessage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'usermessages',
				value: this.options.userId
			},
			{
				endpoint: _.size(this.options.view) > 0 ? this.options.view : 'inbox'
			}
		]);
	}
});

PJQ.collections.userMessages.UserMessageThread = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userMessages.UserMessage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'usermessages',
				value: this.options.message.id
			},
			{
				endpoint: 'thread'
			}
		]);
	}
});

PJQ.collections.userMessages.UserMessageTypes = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userMessages.UserMessageType,
	endpoint: function () {
		if (this.options.project != null && this.options.project.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'usermessages'
				},
				{
					endpoint: 'types'
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usermessages'
				},
				{
					endpoint: 'types'
				}
			]);
		}
	}
});
//Models
PJQ.helpers.users = {
	sendPasswordReset: function (username, callback) {
		let result = {
			success: false,
			error: null
		};
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users'
				},
				{
					endpoint: 'requestpasswordreset'
				}
			], [
				{
					parameter: 'masterUserId',
					value: PJQ.app.session.get('masterUserId')
				},
				{
					parameter:'username',
					value: username
				}
			])
		}).post().done(_.bind(function (data) {
			result.success = data.success;
			if (!result.success) {
				result.error = PJQ.Errors.auth[data.error];
			}

			if (typeof callback === 'function') {
				callback(result);
			}
		}, this)).fail(_.bind(function (xhr, err, result) {
			result.error = PJQ.Errors.auth.CUSTOMER_SERVICE;
			if (typeof callback === 'function') {
				callback(result);
			}

			new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_RESET_PASSWORD, {
				error: err,
				result: result
			});
		}, this));
	}
};

PJQ.models.users = {};

PJQ.models.users.User = PJQ.models.contacts.Contact.extend({
	idAttribute: 'userId',
	defaults: {
		type: 'user'
	},
	endpoint: function () {
		let params = [];
		if (this.isNew()) {
			params.push(...[{
				parameter: 'username',
				value: this.get('username')
			}, {
				parameter: 'password',
				value: this.get('password')
			}]);
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users',
				value: this.id < 0 ? -this.id : this.id
			}
		], params)
	},
	parse: function (model) {
		if (model != null) {
			if (PJQ.app.session != null) {
				if (model.userTypeId != null) {
					this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
				}

				if (this.userType === null) {
					this.userType = PJQ.app.session.userTypes.getDefault(true);
				}
			}

			if (this.groups == null) {
				this.groups = new PJQ.collections.groups.Groups(model.groups, {
					groupLevels: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
				});
			} else {
				//Override for groups being returned in a nested object
				//This is some old api stuff that will soon be deprecated
				//We will remove this when that happens
				if (model.groups != null) {
					model.groups = model.groups;
				}
				this.groups.reset(_.size(model.groups) > 0 ? model.groups : null);
				this.groups.options.groupLevels = PJQ.app.session ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS) : 1;
			}

			if(model.companyId == null){
				model.companyId = 0;
			}
		}
		else {
			this.userType = PJQ.app.session != null ? PJQ.app.session.userTypes.getDefault(true) : null;
		}
		return model;
	},
	getUserProjects: function () {
		return new Promise((resolve, reject) => {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'user',
						value: this.id
					},
					{
						endpoint: 'projects'
					}
				]),
				isAPIv2: true
			}).get().done((res) => {
				resolve(res);
			}).fail((err) => {
				reject(new Error("Failed to fetch user projects"));
			});
		});
	},
	addToProjects: function (projectIds) {
		return new Promise((resolve, reject) => {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'user',
						value: -this.id
					},
					{
						endpoint: 'projects'
					}
				]),
				data: projectIds,
				isAPIv2: true
			}).post().done((res) => {
				resolve(res);
			}).fail((err) => {
				reject(new Error("Failed to add user to projects"));
			});
		});
	},
	fetchRFISettings: function (callback) {
		if (this.rfiSettings == null) {
			this.rfiSettings = new PJQ.models.rfi.Settings();
			this.rfiSettings.fetch({
				success: _.bind(function () {
					callback(this.rfiSettings);
				}, this)
			});
		}
		else {
			callback(this.rfiSettings);
		}
	},
	sendPasswordReset: function (callback) {
		PJQ.helpers.users.sendPasswordReset(this.get('username'), function (result) {
			if (typeof callback === 'function') {
				callback(result);
			}
		});
	},
	unlock: function (callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users',
					value: this.id
				},
				{
					endpoint: 'unlock'
				}
			])
		}).put().done(_.bind(function () {
			this.set('lockedOn', null);
			callback(true);
		}, this)).fail(function () {
			callback(false);
		});
	},
	beforeSave: function () {
		if (this.groups) {
			this.set({
				groups: _.map(this.groups.models, function (group) {
					return {
						groupId: group.id,
						isDeleted: group.get('isDeleted')
					}
				})
			});
		}
	}
});

PJQ.models.users.UserFieldSetting = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'user'
			},
			{
				endpoint: 'fields'
			}
		]);
	}
});

//Collections
PJQ.collections.users = {};

PJQ.collections.users.Users = PJQ.collections.contacts.Contacts.extend({
	model: PJQ.models.users.User,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users'
			}
		], [
			{
				parameter: 'isDetail',
				value: this.options.isDetail
			}
		])
	},
	getByUserType: function (userTypeId) {
		if (userTypeId == null) {
			return this.models;
		}

		return _.filter(this.models, function (user) {
			return userTypeId === user.get('userTypeId');
		})
	}
});

//Views
PJQ.views.users = {};

//Routes
PJQ.app.addRoutes({
	route: 'resetpassword/:guid',
	name: 'resetPassword',
	callback: function (guid) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users'
				},
				{
					endpoint: 'resetpassword',
					value: guid
				},
			])
		}).get().done(function (request) {
			if (request.error) {
				PJQ.app.router.signInNavigate();
				return;
			}

			if (PJQ.app.module === PJQ.constants.modules.APP) {
				new PJQ.views.auth.AppResetPassword({
					el: PJQ.app.$el,
					request: request,
					onReset: function () {
						new PJQ.views.BaseModal({
							header: "Password Reset Successfully",
							body: "Your password has been successfully reset.",
							isShowSecondaryButton: false,
							okButtonText: 'Go To Sign In',
							onOk: _.bind(function () {
								PJQ.app.router.signInNavigate();
							}, this)
						});
					}
				});
			}
			else {
				new PJQ.views.auth.ResetPasswordModal({
					request: request
				});
			}
		}).fail(function () {
			//todo: show error - this is an invalid request id
		});
	}
});

PJQ.models.users.UserCustomField = PJQ.models.customFields.CustomField.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users'
			},
			{
				endpoint: 'customfields',
				value: this.id
			}
		]);
	},
});

PJQ.collections.users.UserCustomFields = PJQ.collections.customFields.CustomFields.extend({
	model: PJQ.models.users.UserCustomField,
	options: {
		masterUserId: null
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users',
			},
			{
				endpoint: 'customfields'
			}
		], [
			{
				parameter: 'masterUserId',
				value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
			}
		]);
	}
});

PJQ.collections.users.UserFieldSettings = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.users.UserFieldSetting,
	endpoint: function () {
		let params;
		if (this.options.masterUserId > 0) {
			params = [
				{
					parameter: 'masterUserId',
					value: this.options.masterUserId
				}
			];
		} else {
			params = null;
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users'
			},
			{
				endpoint: 'fields'
			}
		], params)
	}
});
//Models
PJQ.models.userTypes = {};
PJQ.models.userTypes.UserType = PJQ.models.BaseModel.extend({
	idAttribute: 'userTypeId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'userTypes',
				value: this.id < 0 ? -this.id : this.id
			}
		])
	},
	fetchSystemPermissions: function (callback) {
		let perm = new PJQ.models.permissions.SystemPermissions({
			userTypeId: this.id
		});
		if (this.id > 0) {
			perm.fetch({
				success: _.bind(function () {
					callback(perm);
				}, this)
			});
		}
		else {
			callback(perm);
		}
	},
	fetchProjectPermissions: function (callback) {
		let perm = new PJQ.models.permissions.ProjectPermissions({
			userTypeId: this.id
		});
		if (this.id > 0) {
			perm.fetch({
				success: _.bind(function () {
					callback(perm);
				}, this)
			});
		}
		else {
			callback(perm);
		}
	},
	fetchSystemNotificationSettings: function (callback) {
		let notificationSettings = new PJQ.models.notificationSettings.SystemNotificationSettings({
			userTypeId: this.id
		});
		if (this.id > 0) {
			notificationSettings.fetch({
				success: _.bind(function () {
					callback(notificationSettings);
				}, this)
			});
		}
		else {
			callback(notificationSettings);
		}
	},
	fetchProjectNotificationSettings: function (callback) {
		let notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
			userTypeId: this.get('userTypeId')
		});
		if (this.id > 0) {
			notificationSettings.fetch({
				success: _.bind(function () {
					callback(notificationSettings);
				}, this)
			});
		}
		else {
			callback(notificationSettings);
		}
	},
});


//Collections
PJQ.collections.userTypes = {};
PJQ.collections.userTypes.UserTypes = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userTypes.UserType,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'userTypes'
			}
		])
	},
	getDefault: function (isCompanyUser = false) {
		return _.find(this.models, function (model) {
			return isCompanyUser === model.get('isCompanyUser') && model.get('isDefault');
		});
	},
	getByIsCompany: function (isCompany) {
		if (isCompany == null) {
			return this.models;
		}

		return _.filter(this.models, function (userType) {
			return isCompany === userType.get('isCompanyUser');
		})
	},
	copy: function (callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usertypes'
				},
				{
					endpoint: 'copy'
				}
			])
		}).post().done(_.bind(function (userTypes) {
			this.reset(userTypes);
			callback();
		}, this));
	}
});

$.fn.outerHTML = function (s) {
	return s ? this.before(s).remove() : jQuery("<p>").append(this.eq(0).clone()).html();
};

if (typeof Object.assign != 'function') {
	Object.assign = function (target) {
		'use strict';
		if (target == null) {
			throw new TypeError('Cannot convert undefined or null to object');
		}

		target = Object(target);
		for (var index = 1; index < arguments.length; index++) {
			var source = arguments[index];
			if (source != null) {
				for (var key in source) {
					if (Object.prototype.hasOwnProperty.call(source, key)) {
						target[key] = source[key];
					}
				}
			}
		}
		return target;
	};
}

window.onScriptError = function () {
	//do nothing for now
};

window.ValidateEmail = function (email) {
	return PJQ.helpers.validators.validateEmail(email);
};
PJQ.models.weather = {};
PJQ.models.weather.WeatherDay = PJQ.models.BaseModel.extend({
	idAttribute: 'weatherId',
	parse: function(model){
		model = model ? model : {};

		if(model.hours != null){
			this.hours = new PJQ.collection.weather.WeatherHours(model.hours);
		}

		return model;
	},
	conditionIconUrl: function(){
		let iconId = this.get('conditionIconId');
		if(iconId > 0){
			return '/assets/modules2/global/images/weather/' + iconId.toString() + '.png';
		}
	},
	minTempDisplay: function(){
		let minTemperature = this.get('minTemperature');
		if(minTemperature != null){
			return parseInt(minTemperature).toString() + '&#176;F';
		}
	},
	maxTempDisplay: function(){
		let maxTemperature = this.get('maxTemperature');
		if(maxTemperature != null){
			return parseInt(maxTemperature).toString() + '&#176;F';
		}
	}
});

PJQ.models.weather.WeatherHour = PJQ.models.BaseModel.extend({
	idAttribute: 'weatherHourId'
});

PJQ.collections.weather = {};
PJQ.collections.weather.WeatherHours = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.weather.WeatherHour
});

PJQ.constants.weather = {
	MAX_FORECAST_DAYS: 13
};
PJQ.models.workAreas = {};
PJQ.models.workAreas.WorkArea = PJQ.models.BaseModel.extend({
	idAttribute: 'workAreaId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.get('contactId')
			},
			{
				endpoint: 'workareas',
				value: this.id
			}
		]);
	},
	isStateWorkArea: function () {
		return _.size(this.get('state')) > 0 && !this.isCountyWorkArea();
	},
	isCountyWorkArea: function () {
		return _.size(this.get('county')) > 0;
	}
});

PJQ.models.workAreas.ContactWorkArea = PJQ.models.workAreas.WorkArea.extend({
	idAttribute: 'contactWorkAreaId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.get('contactId')
			},
			{
				endpoint: 'workareas',
				value: this.id > 0 ? this.get('workAreaId') : null
			}
		]);
	}
});

PJQ.collections.workAreas = {};
PJQ.collections.workAreas.WorkAreas = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.workAreas.WorkArea,
	endpoint: function () {
		let queryParams = [];
		if (_.size(this.options.country) > 0) {
			queryParams.push({
				parameter: 'country',
				value: this.options.country
			});
		}
		if (_.size(this.options.state) > 0) {
			queryParams.push({
				parameter: 'state',
				value: this.options.state
			});
		}
		if (_.size(this.options.zip) > 0) {
			queryParams.push({
				parameter: 'zip',
				value: this.options.zip
			});

		}
		if (this.options.radius > 0) {
			queryParams.push({
				parameter: 'radius',
				value: this.options.radius
			});
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'workAreas'
			}
		], queryParams);
	},
	getExistingWorkArea: function (workArea) {
		return _.find(this.models, function (existingWorkArea) {
			//If the county region is already added, or the full state for the county is added, filter the work area out
			return !existingWorkArea.get('isDeleted') && (existingWorkArea.get('workAreaId') === workArea.get('workAreaId') || (existingWorkArea.get('state') === workArea.get('state') && existingWorkArea.isStateWorkArea()));
		})
	}
});

PJQ.collections.workAreas.ContactWorkAreas = PJQ.collections.workAreas.WorkAreas.extend({
	model: PJQ.models.workAreas.ContactWorkArea,
	endpoint: function () {
		let queryParams = [];
		if (_.size(this.options.zip) > 0) {
			queryParams.push({
				parameter: 'zip',
				value: this.options.zip
			});

		}
		if (this.options.radius > 0) {
			queryParams.push({
				parameter: 'radius',
				value: this.options.radius
			});
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.options.contactId
			},
			{
				endpoint: 'workAreas'
			}
		], queryParams);
	}
});

PJQ.views.workAreas = {};
PJQ.views.workAreas.WorkAreaMap = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Work-Area-Map-Inline'),
		isInline: true,
		isStacked: false,
		isEdit: false,
		isMapOnly: false,
		isSync: true,
		defaultRadius: 50,
		mapZoom: 4,
		mapCenter: null,
		onChange: _.noop,
		onDelete: _.noop,
		onFetch: _.noop
	},
	events: {
		'keyup .work-area-zip': 'workAreaZipInputChanged',
		'keyup .work-area-radius': 'workAreaRadiusInputChanged',
		'click .add-work-area-state-county': 'addWorkAreaByStateCounty',
		'click .add-work-area-zip': 'addWorkAreasByZipRadius',
		'click .delete-work-area': 'deleteWorkAreaEvent',
		'click .delete-all-work-areas': 'deleteAllWorkAreas',
	},
	beforeFirstRender: function () {
		this.options.mapCenter = typeof google === 'object' ? new google.maps.LatLng(38.6159, -100.7456) : null;

		if (!this.options.isInline)
			this.options.template = new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Work-Area-Map');

		if (!(this.options.contactId > 0) && PJQ.app.session.contact != null) {
			this.options.contactId = PJQ.app.session.contact.id;
		}

		if (this.collection == null) {
			this.collection = new PJQ.collections.workAreas.ContactWorkAreas([], {
				contactId: this.options.contactId
			});
		}

		this.listenTo(this.collection, 'update fetch', _.bind(function () {
			this.renderDeleteAllButtons();
		}, this));

		if (!this.options.isFetched && this.collection.options.contactId > 0) {
			this.collection.fetch({
				success: _.bind(function () {
					this.options.isFetched = true;
					this.render();

					if (typeof this.options.onFetch === 'function') {
						this.options.onFetch();
					}
				}, this)
			});
		}
		else {
			this.render();
		}
		return false;
	},
	beforeRender: function () {
		this.renderData = {
			options: this.options
		};
	},
	afterRender: function () {
		this.renderUI();
	},
	renderUI: function () {
		if (this.options.isEdit) {
			this.renderInputs();
		}
		this.renderDataTables();
		this.renderDeleteAllButtons();
		this.renderMap();
	},
	renderInputs: function () {
		this.radiusSlider = new PJQ.Slider(this.$('.work-area-radius-slider'), {
			ticks: [1, 50, 100, 150, 200, 250, 300],
			ticks_labels: [1, 50, 100, 150, 200, 250, 300],
			value: this.options.defaultRadius,
			onChange: _.bind(function (obj) {
				this.setWorkAreaRadius(obj.newValue);
			}, this)
		});

		this.countryPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.work-area-country'),
			defaultValue: PJQ.constants.countries[0].toUpperCase(),
			onChange: _.bind(function (value) {
				this.populateStateSelect();
				if (value.toLowerCase() === 'ca') {
					this.$('.work-area-county').closest('div.input-group').addClass('invisible');
				}
				else {
					this.$('.work-area-county').closest('div.input-group').removeClass('invisible');
				}
				this.workAreaStateCountyInputChanged();
			}, this)
		});

		this.statePicker = new PJQ.inputs.Selectpicker({
			el: this.$('.work-area-state'),
			noneSelectedText: 'State',
			hideDisabled: false,
			isMultiple: true,
			onChange: _.bind(function () {
				this.populateCountySelect();
				this.workAreaStateCountyInputChanged();
			}, this)
		});

		this.countyPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.work-area-county'),
			noneSelectedText: 'County',
			isIntChoices: true,
			isMultiple: true,
			hideDisabled: false,
			onChange: _.bind(function () {
				this.workAreaStateCountyInputChanged();
			}, this)
		});

		this.populateStateSelect();
	},
	getStates: function (country, callback) {
		if (this.states == null) {
			this.states = [];
		}

		if (_.size(country) > 0 && this.states[country] == null) {
			let workAreas = new PJQ.collections.workAreas.WorkAreas([], {
				country: country
			});
			workAreas.fetch({
				success: _.bind(function () {
					this.states[country] = workAreas;
					callback(this.states[country]);
				}, this)
			});
		}
		else {
			callback(this.states[country]);
		}
	},
	populateStateSelect: function () {
		let country = this.countryPicker.getValue();
		this.$('select.work-area-state').empty();
		this.$('select.work-area-state').append('<option value="" disabled>State</option>');
		if (_.size(country) > 0) {
			this.getStates(country, _.bind(function (states) {
				_.each(states.models, function (workArea) {
					this.$('select.work-area-state').append('<option value="' + workArea.get('workAreaId').toString() + '" ' + (_.find(this.collection.models, function (existingWorkArea) {
						return existingWorkArea.get('isDeleted') !== true && existingWorkArea.get('workAreaId') === workArea.get('workAreaId');
					}) != null ? 'disabled' : '') + '>' + workArea.get('state') + '</option>');
				}, this);
				this.statePicker.refresh();
			}, this));
		}
		else {
			this.statePicker.refresh();
		}
		this.workAreaStateCountyInputChanged();
	},
	getCounties: function (country, state, callback) {
		if (this.counties == null) {
			this.counties = [];
		}

		if (_.size(country) > 0 && _.size(state) > 0 && this.counties[state] == null) {
			let workAreas = new PJQ.collections.workAreas.WorkAreas([], {
				country: country,
				state: state
			});
			workAreas.fetch({
				success: _.bind(function () {
					this.counties[state] = workAreas;
					callback(this.counties[state]);
				}, this)
			});
		}
		else {
			callback(this.counties[state]);
		}
	},
	populateCountySelect: function () {
		let country = this.countryPicker.getValue(),
			stateVal = this.statePicker.getValue(),
			stateWorkArea = _.size(country) > 0 && _.size(stateVal) === 1 ? this.states[country].get(stateVal[0]) : null;
		this.getCounties(country, stateWorkArea != null ? stateWorkArea.get('state') : null, _.bind(function (counties) {
			this.$('select.work-area-county').empty();
			this.$('select.work-area-county').append('<option value="" disabled>County</option>');
			if (counties != null) {
				_.each(counties.models, function (workArea) {
					this.$('select.work-area-county').append('<option value="' + workArea.get('workAreaId').toString() + '" ' + (_.find(this.collection.models, function (existingWorkArea) {
						return existingWorkArea.get('isDeleted') !== true && existingWorkArea.get('workAreaId') === workArea.get('workAreaId');
					}) != null ? 'disabled' : '') + '>' + workArea.get('county') + '</option>');
				}, this);
			}
			this.countyPicker.refresh();
		}, this));
		this.workAreaStateCountyInputChanged();
	},
	renderMap: function () {
		this.map = new PJQ.maps.GoogleMap(this.$('.work-area-map'), {
			zoom: this.options.mapZoom,
			center: this.options.mapCenter
		});
		this.renderMapLayers();
		this.refresh();
	},
	renderDataTables: function () {
		if (this.workAreaDataTable)
			this.workAreaDataTable.removeAllRows();

		//Go through each work area and make sure there aren't any county regions showing up where there is already a full state region
		//We don't want to delete the county regions, because they may be related to a public contact
		this.collection.models = _.filter(this.collection.models, function (model) {
			return !model.get('isDeleted') && (_.size(model.get('county')) === 0 || (_.find(this.collection.models, function (subModel) {
				return model.id !== subModel.id && model.get('state').toLowerCase() === subModel.get('state').toLowerCase() && _.size(subModel.get('county')) === 0;
			}) == null));
		}, this);

		let columns;
		if (this.options.isEdit) {
			columns = [
				{"data": "attributes.country", "title": "Country"},
				{"data": "attributes.state", "title": "State"},
				{"data": "attributes.county", "title": "County"},
				{
					"title": '<button type="button" class="btn btn-danger delete-all-work-areas m-0a"><i class="fal fa-trash"></i></button>',
					"defaultContent": '<button type="button" class="btn btn-danger delete-work-area m-0a"><i class="fal fa-trash"></i></button>',
					"orderable": false
				}
			];
		}
		else {
			columns = [
				{"data": "attributes.country", "title": "Country"},
				{"data": "attributes.state", "title": "State"},
				{"data": "attributes.county", "title": "County"}
			];
		}
		this.workAreaDataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.work-area-data-table'),
			data: _.sortBy(_.filter(this.collection.models, _.bind(function (model) {
				return model.get('state') && model.get('state').length > 0;
			}, this)), function (model) {
				return model.get('state');
			}),
			language: {
				emptyTable: "No work areas added",
				zeroRecords: "No work areas match the search criteria"

			},
			rowId: "cid",
			deferRender: true,
			columns: columns,
			dom: '<"top"<"clear">p>rt<"bottom"p<"clear">>'
		});
	},
	renderMapLayers: function () {
		this.renderStateLayers();
		this.renderCountyLayers();
	},
	renderStateLayers: function () {
		let states = _.map(_.filter(this.collection.models, function (workArea) {
			return !workArea.get('isDeleted') && workArea.isStateWorkArea()
		}), function (workArea) {
			return workArea.get('state');
		});
		if (this.stateLayerGuid) {
			this.map.removeMapObject(this.stateLayerGuid);
			this.stateLayerGuid = null;
		}
		if (_.size(states) > 0) {
			this.stateLayerGuid = this.map.addKMLStatesLayer(states);
		}
	},
	renderCountyLayers: function () {
		let countyIds = _.map(_.filter(this.collection.models, function (workArea) {
			return !workArea.get('isDeleted') && workArea.isCountyWorkArea()
		}), function (workArea) {
			return workArea.get('workAreaId');
		});
		if (this.countyLayerGuid) {
			this.map.removeMapObject(this.countyLayerGuid);
			this.countyLayerGuid = null;
		}
		if (_.size(countyIds) > 0) {
			this.countyLayerGuid = this.map.addKMLCountiesLayer(countyIds);
		}
	},
	reCenter: function () {
		if (this.map) {
			this.map.setCenter(this.options.mapCenter);
		}
	},
	refresh: function () {
		if (this.map) {
			this.map.resize();
		}
		if (this.radiusSlider) {
			this.radiusSlider.refresh();
		}
	},
	workAreaRadiusInputChanged: function () {
		this.setWorkAreaRadius(parseInt(this.$('.work-area-radius').val()));
	},
	setWorkAreaRadius: function (radius) {
		if (isNaN(radius) || radius < 1)
			radius = 1;
		else if (radius > 300)
			radius = 300;
		this.radiusSlider.setValue(radius);
		//don't set the radius input yet if the length of the value is 0 in case the user is trying to clear the input to enter a new value
		if (this.$('.work-area-radius').val().length > 0)
			this.$('.work-area-radius').val(radius);
	},
	workAreaZipInputChanged: function () {
		this.$('.add-work-area-zip').prop('disabled', !PJQ.helpers.validators.validateZip(this.$('.work-area-zip').val()))
	},
	workAreaStateCountyInputChanged: function () {
		let country = this.countryPicker.getValue(),
			stateWorkAreaId = this.statePicker.getValue(),
			countyWorkAreaId = this.countyPicker.getValue();

		if (_.size(country) > 0) {
			this.statePicker.enable();
		}
		else {
			this.statePicker.disable();
		}
		if (stateWorkAreaId > 0) {
			this.countyPicker.enable();
		}
		else {
			this.countyPicker.disable();
		}

		let sessionContactId = PJQ.app.session.contact ? PJQ.app.session.contact.id : null;
		if ((sessionContactId === this.options.contactId && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS_SUB)) || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS_PORTAL) || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS)) {
			this.$('.add-work-area-state-county').prop('disabled', !(stateWorkAreaId > 0));
		}
		else {
			this.$('.add-work-area-state-county').prop('disabled', !(_.size(country) > 0 || stateWorkAreaId > 0 || countyWorkAreaId > 0))
		}
	},
	addWorkAreaByStateCounty: function () {
		let country = this.countryPicker.getValue();
		if (_.size(country) === 0) {
			return;
		}

		let stateWorkAreaId = this.statePicker.getValue(),
			countyWorkAreaId = this.countyPicker.getValue(),
			self = this;
		if (stateWorkAreaId == null || _.size(stateWorkAreaId) === 0) {
			self.addNewWorkAreas(_.filter(self.states[country].models, function (workArea) {
				return _.indexOf((['hi', 'ak']), workArea.get('state').toLowerCase()) === -1;
			}));
		}
		else {
			let workArea = null,
				workAreaArray = [];
			if (_.size(stateWorkAreaId) === 1) {
				let stateWorkArea = this.states[country].get(stateWorkAreaId[0]);
				if (_.size(countyWorkAreaId) > 0) {
					_.each(countyWorkAreaId, function(id){
						if(id) {
							let countyWorkArea = this.counties[stateWorkArea.get('state')].get(id);
							workAreaArray.push(countyWorkArea);
						}
					}, this)
				}
				else {
					workArea = stateWorkArea;
				}
			}
			else if (_.size(stateWorkAreaId) > 1){
				_.each(stateWorkAreaId, function(id){
					if(id) {
						let stateWorkArea = this.states[country].get(id);
						workAreaArray.push(stateWorkArea);
					}
				}, this)
			}
			if(_.size(workAreaArray) > 0){
				this.addNewWorkAreas(workAreaArray)
			}
			else {
				this.addNewWorkAreas([workArea]);
			}
		}
	},
	addWorkAreasByZipRadius: function () {
		if (this.zipRadiusError != null) {
			this.zipRadiusError.destroy();
			this.zipRadiusError = null;
		}

		//Get all the work areas (counties) for the selected zip/radius
		let radius = this.$('.work-area-radius').val(),
			zip = PJQ.helpers.formatHelpers.formatZip(this.$('.work-area-zip').val()),
			newWorkAreas = new PJQ.collections.workAreas.WorkAreas([], {
				zip: zip,
				radius: radius
			});
		newWorkAreas.fetch({
			success: _.bind(function () {
				let newWorkAreaStateCount = _.size(_.uniq(_.map(newWorkAreas.models, function (newWorkArea) {
					return newWorkArea.get('state');
				})));
				newWorkAreas = new PJQ.collections.workAreas.WorkAreas(_.filter(newWorkAreas.models, _.bind(function (newWorkArea) {
					return this.collection.getExistingWorkArea(newWorkArea) == null;
				}, this)));
				if (_.size(newWorkAreas.models) > 0) {
					//If there are counties for more than 1 state in the result
					//Or the preference to always show the work area picker is enabled
					//Then show the work area picker
					if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_WORK_AREAS_ZIP_RADIUS_COUNTY_PICKER) || newWorkAreaStateCount > 1) {
						new PJQ.views.workAreas.SelectWorkAreasModal({
							collection: newWorkAreas,
							onSave: _.bind(function (selectedWorkAreas) {
								this.addNewWorkAreas(selectedWorkAreas, true);
							}, this)
						});
					}
					else {
						this.addNewWorkAreas(newWorkAreas.models, true);
					}
				}
				else {
					this.showZipRadiusError();
				}
			}, this)
		});
	},
	addNewWorkAreas: function (newWorkAreas, wasZipAdd = false) {
		let countiesChanged = false,
			statesChanged = false,
			newWorkAreasArray = [];
		_.each(newWorkAreas, function (newWorkArea) {
			let isStateWorkArea = newWorkArea.isStateWorkArea();
			if (isStateWorkArea) {
				let existingStateCountyWorkAreas = _.filter(this.collection.models, function (existingWorkArea) {
					return existingWorkArea.get('state') === newWorkArea.get('state') && !existingWorkArea.get('isDeleted');
				});
				_.each(existingStateCountyWorkAreas, _.bind(function (existingWorkArea) {
					this.deleteWorkArea(this.workAreaDataTable.getRow(existingWorkArea.cid));
					countiesChanged = true;
				}, this));
			}

			let existingWorkArea = this.collection.getExistingWorkArea(newWorkArea);
			if (existingWorkArea == null) {
				countiesChanged = newWorkArea.isCountyWorkArea() || countiesChanged;
				statesChanged = isStateWorkArea || statesChanged;

				let newContactWorkArea = new PJQ.models.workAreas.ContactWorkArea(_.defaults({contactId: this.options.contactId}, newWorkArea.toJSON()));
				this.collection.add(newContactWorkArea);
				this.onChange('add', newContactWorkArea);
				this.workAreaDataTable.addRow(newContactWorkArea);
				if (this.options.isSync) {
					newWorkAreasArray.push(newContactWorkArea);
				}
			}
			else if (existingWorkArea.get('isDeleted')) {
				existingWorkArea.set('isDeleted', false);
				this.onChange('add', existingWorkArea);
				this.workAreaDataTable.addRow(existingWorkArea);
			}
		}, this);
		if(this.options.isSync && _.size(newWorkAreasArray) > 0){
			let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.collection.options.contactId
				},
				{
					endpoint: 'workareas'
				},
				{
					endpoint: 'bulk'
				}
			]);
			new PJQ.ajax.Request({
				endpoint: endpoint,
				data: {
					workAreaIds: _.map(newWorkAreasArray, function (workArea) {
						return workArea.get('workAreaId')
					})
				}
			}).post().done(_.bind(function () {

			}, this)).fail(function () {
				PJQ.notifications.notify.errorNotify({
					message: 'Something went wrong!'
				});
			});
		}
		if (countiesChanged) {
			this.renderCountyLayers();
		}
		if (statesChanged) {
			this.renderStateLayers();
		}

		this.populateStateSelect();
		this.populateCountySelect();

		if (wasZipAdd) {
			this.resetZipEntry();
		}
	},
	showZipRadiusError: function () {
		this.zipRadiusError = new PJQ.Alert(this.$('.add-work-area-zip-button-container'), {
			type: 'danger',
			text: 'Unable to find new counties to add within the entered zip/radius',
			isPrepend: true,
			animation: {
				in: 'fadeIn'
			}
		});
	},
	deleteWorkAreaEvent: function (e) {
		let row = this.workAreaDataTable.getRow($(e.currentTarget).parents('tr')),
			workArea = row.data();
		this.deleteWorkArea(row);
		this.populateStateSelect();
		this.populateCountySelect();
		if (workArea.isStateWorkArea()) {
			this.renderStateLayers();
		}
		else if (workArea.isCountyWorkArea()) {
			this.renderCountyLayers();
		}
	},
	deleteAllWorkAreas: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: 'Are you sure you want to delete all work areas?',
			onDelete: _.bind(function () {
				_.each(_.clone(_.filter(this.collection.models, function (workArea) {
					return !workArea.get('isDeleted');
				})), _.bind(function (workArea) {
					this.deleteWorkArea(this.workAreaDataTable.getRow(workArea.cid));
				}, this));
				this.populateStateSelect();
				this.renderStateLayers();
				this.populateCountySelect();
				this.renderCountyLayers();
			}, this)
		});
	},
	deleteWorkArea: function (row) {
		let workArea = row.data();
		this.workAreaDataTable.removeRow(row);
		if (this.options.isSync || workArea.isNew()) {
			workArea.destroy();
		}
		else if (workArea.id > 0) {
			workArea.set('isDeleted', true);
		}
		this.onChange('delete', workArea);
		this.options.onDelete()
	},
	renderDeleteAllButtons: function () {
		this.$('.delete-all-work-areas').prop('disabled', _.size(this.collection.models) === 0);
	},
	resetZipEntry: function () {
		this.$('.work-area-zip').val('');
		this.setWorkAreaRadius(this.options.defaultRadius);
		this.workAreaZipInputChanged();
	},
	save: function (callback) {
		//This function is used when options.isSync == false
		//This is used by the code that constructs this view to save the work area data on some event outside the map (i.e. save contact in address book)
		//First delete the workareas that were deleted in the UI
		let newWorkAreas = _.filter(this.collection.models, function (model) {
				return model.isNew();
			}),
			deletedWorkAreas = this.collection.where({isDeleted: true});

		let addNewWorkAreas = _.bind(function() {
			if (_.size(newWorkAreas) > 0) {
				let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'contacts',
						value: this.collection.options.contactId
					},
					{
						endpoint: 'workareas'
					},
					{
						endpoint: 'bulk'
					}
				]);
				new PJQ.ajax.Request({
					endpoint: endpoint,
					data: {
						workAreaIds: _.map(newWorkAreas, function (workArea) {
							return workArea.get('workAreaId')
						})
					}
				}).post().done(_.bind(function () {
					if (typeof callback === 'function') {
						callback();
					}
				}, this)).fail(function () {
					PJQ.notifications.notify.errorNotify({
						message: 'Something went wrong!'
					});
				});
			}
			else if (typeof callback === 'function') {
				callback();
			}
		}, this);

		if (_.size(deletedWorkAreas) > 0) {
			let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.collection.options.contactId
				},
				{
					endpoint: 'workareas'
				},
				{
					endpoint: 'bulk'
				}
			]);
			new PJQ.ajax.Request({
				endpoint: endpoint,
				data: {
					workAreaIds: _.map(deletedWorkAreas, function (workArea) {
						return workArea.get('workAreaId')
					})
				}
			}).delete().done(_.bind(function () {
				if (_.size(newWorkAreas) > 0) {
					addNewWorkAreas();
				}
				else if (typeof callback === 'function') {
					callback();
				}
			}, this)).fail(function () {
				PJQ.notifications.notify.errorNotify({
					message: 'Something went wrong!'
				});
			});
		}
		else
		{
			addNewWorkAreas();
		}



	},
	onChange: function (e, data) {
		this.options.onChange({
			event: e,
			data: data,
			workAreas: this.collection
		});
	},
	showError: function (errorText) {
		this.hideError();
		this.errorAlert = new PJQ.Alert(this.$el, {
			type: 'danger',
			extraClasses: ['mt-1, mb-1'],
			text: errorText,
			isPrepend: true
		});
	},
	hideError: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
	}
});

PJQ.views.workAreas.WorkAreaMapModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Work-Area-Map'),
		minWidth: 800,
		isSync: false,
		isEdit: true,
		onSave: null
	},
	events: {
		"click .btn-save": "save"
	},
	afterRender: function () {
		this.workAreaMap = new PJQ.views.workAreas.WorkAreaMap({
			el: this.$('.map-outer'),
			collection: this.collection,
			isSync: this.options.isSync,
			isEdit: this.options.isEdit
		});
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.workAreaMap.collection);
		}
		this.removeModal();
	}
});

PJQ.views.workAreas.SelectWorkAreasModal = PJQ.views.BaseModal.extend({
	defaults: {
		isSingleChoice: false,
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Work-Area-Select'),
		minWidth: 500,
		onSave: null
	},
	events: {
		"click .select-all-work-areas": "selectAllWorkAreas",
		"click .select-work-area": "selectWorkArea",
		"click .select-work-areas-save": "save"
	},
	beforeModalCreated: function () {
		this.selectedWorkAreas = [];
	},
	afterRender: function () {
		this.workAreasDataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.work-area-data-table'),
			data: this.collection.models,
			language: {
				emptyTable: "No work areas added",
				zeroRecords: "No work areas match the search criteria"
			},
			order: [[0, "asc"], [1, "asc"]],
			rowId: "cid",
			deferRender: true,
			columns: [
				{"data": "attributes.state", "title": "State"},
				{"data": "attributes.county", "title": "County"},
				{
					data: "attributes.isSelected",
					title: '<button type="button" class="btn btn-orange select-all-work-areas m-0a">Select All</button>',
					orderable: false,
					render: function (data) {
						return data ? '<button type="button" class="btn btn-secondary select-work-area wd-80p m-0a">Deselect</button>' : '<button type="button" class="btn btn-primary select-work-area wd-80p m-0a">Select</button>';
					}
				}
			],
			dom: '<"top"<"clear">p>rt<"bottom"p<"clear">>'
		});
	},
	selectAllWorkAreas: function () {
		this.selectedWorkAreas = this.collection.models;
		_.each(this.collection.models, function (model) {
			model.set('isSelected', true);
		});
		this.$('.select-work-area').text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
		this.selectWorkAreasChanged();
	},
	selectWorkArea: function (e) {
		let target = $(e.currentTarget),
			data = this.workAreasDataTable.getRow(target.parents('tr')).data();
		if (target.hasClass('btn-primary')) {
			target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
			this.selectedWorkAreas.push(data);
			data.set('isSelected', true);
		}
		else {
			target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
			this.selectedWorkAreas = _(this.selectedWorkAreas).filter(function (workArea) {
				return workArea.get('workAreaId') !== data.get('workAreaId');
			});
			data.set('isSelected', true);
		}
		this.selectWorkAreasChanged();
	},
	selectWorkAreasChanged: function () {
		this.$('.select-all-work-areas').prop('disabled', _.size(this.selectedWorkAreas) === _.size(this.collection.models));
		this.$('.select-work-areas-save').prop('disabled', _.size(this.selectedWorkAreas) === 0);
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.selectedWorkAreas);
		}
	}
});
